{
  "action-buttons.content.star.error.title": "我們在為此項目標上星號時遇到問題",
  "action-buttons.content.star.success.title": "已將「{contentTitle}」標上星號",
  "action-buttons.content.starContent.label": "為此內容標上星號",
  "action-buttons.content.unstar.error.title": "我們在移除此項目的星號時遇到問題",
  "action-buttons.content.unstar.success.title": "已移除「{contentTitle}」的星號",
  "action-buttons.content.unstarContent.label": "移除此內容的星號",
  "action-buttons.error.description": "請重新整理，然後再試一次。",
  "action-buttons.page.star.menu.item": "標上星號",
  "action-buttons.page.unstar.menu-item": "移除星號",
  "action-buttons.space.star.error.title": "我們在為此空間標上星號時遇到問題",
  "action-buttons.space.star.label": "為此空間標上星號",
  "action-buttons.space.star.menu.item": "為空間標上星號",
  "action-buttons.space.star.success.title": "已將「{spaceName}」標上星號",
  "action-buttons.space.unstar.error.title": "我們在移除此空間的星號時遇到問題",
  "action-buttons.space.unstar.label": "移除此空間的星號",
  "action-buttons.space.unstar.menu.item": "移除空間的星號",
  "action-buttons.space.unstar.success.title": "已移除「{spaceName}」的星號",
  "action-buttons.space.unwatch": "取消追蹤空間",
  "action-buttons.space.watch": "追蹤空間",
  "activity-filter.config.error": "我們無法載入摘要組態",
  "activity-filter.dialog.buttons.follow": "追蹤",
  "activity-filter.dialog.buttons.unfollow": "取消追蹤",
  "activity-filter.dialog.close": "關閉",
  "activity-filter.dialog.done": "儲存",
  "activity-filter.dialog.error": "錯誤",
  "activity-filter.dialog.feed.header": "追蹤項目",
  "activity-filter.dialog.flag.description": "無法儲存您的變更。請稍後再試。",
  "activity-filter.dialog.tab.people.description": "空間中的活動和您追蹤的人員都會顯示在您的摘要中。由於以下原因，您將不會收到通知。",
  "activity-filter.dialog.tab.people.following.text": "(已經追蹤)",
  "activity-filter.dialog.tab.people.placeholder": "搜尋要追蹤的人員...",
  "activity-filter.dialog.tab.spaces.description": "空間中的活動和您追蹤的人員都會顯示在您的摘要中。由於以下原因，您將不會收到通知。",
  "activity-filter.dialog.tab.spaces.following.text": "(已經追蹤)",
  "activity-filter.dialog.tab.spaces.personalSpace.text": "個人空間",
  "activity-filter.dialog.tab.spaces.placeholder": "搜尋要追蹤的空間...",
  "activity-filter.dialog.tab.spaces.selector.label": "空間",
  "activity-filter.dialog.tab.spaces.selector.my.spaces": "已標上星號的空間",
  "activity-filter.dialog.tab.spaces.selector.recent.spaces": "最近存取的空間",
  "activity-filter.dialog.tab.spaces.selector.search.spaces": "所有空間",
  "activity-filter.dialog.tab.spaces.unwatch": "取消追蹤此空間",
  "activity-filter.dialog.tab.spaces.watch": "追蹤此空間",
  "activity-filter.dialog.tab.title.people": "人員 {count}",
  "activity-filter.dialog.tab.title.spaces": "空間{count}",
  "activity-filter.edit": "編輯",
  "activity-filter.viewing.updates": "檢視來自您追蹤之空間和人員的更新。",
  "activity-filter.viewing.updates.none": "追蹤空間或人員以調整您的摘要。",
  "activity-filter.viewing.updates.people": "檢視來自您追蹤之人員的更新。",
  "activity-filter.viewing.updates.spaces": "檢視來自您追蹤之空間的更新。",
  "add-personal-space-dialog.close.text": "關閉",
  "add-personal-space-dialog.create.text": "建立",
  "add-personal-space-dialog.creating.text": "建立",
  "add-personal-space-dialog.error.empty.space.name": "您必須輸入空間名稱。",
  "add-personal-space-dialog.introduce.description": "自訂您的個人首頁，並向團隊介紹自己。",
  "add-personal-space-dialog.introduce.title": "介紹您自己",
  "add-personal-space-dialog.organized.description": "讓您的筆記、任務清單、檔案和其他個人內容保持井然有序。",
  "add-personal-space-dialog.organized.title": "保持井然有序",
  "add-personal-space-dialog.share.description": "使用您的部落格發表公告、擷取想法並分享學習事務。",
  "add-personal-space-dialog.share.title": "分享最新消息",
  "add-personal-space-dialog.space.name": "空間名稱",
  "add-personal-space-dialog.tagline": "有了個人空間，您就可以...",
  "add-personal-space-dialog.title": "建立個人空間",
  "admin-announcement-banner.announcement.breadcrumb": "公告",
  "admin-announcement-banner.announcement.icon": "公告",
  "admin-announcement-banner.archive.success.title": "已封存「{announcementTitle}」",
  "admin-announcement-banner.archiving.error.flag.title": "我們在封存 {announcementTitle} 時遇到問題",
  "admin-announcement-banner.archiving.generic.error.flag.title": "我們在封存此公告時遇到問題",
  "admin-announcement-banner.dismiss.button": "關閉管理員公告橫幅",
  "admin-announcement-banner.dismiss.button.text": "關閉",
  "admin-announcement-banner.edit.title": "編輯公告",
  "admin-announcement-banner.editor.aria.label": "{maxCharCount, plural, other {訊息，開始打字即可輸入文字，最多可輸入 {maxCharCount} 個字元}}",
  "admin-announcement-banner.editor.toolbar.emoji.icon.label": "插入表情符號",
  "admin-announcement-banner.editor.toolbar.emoji.tooltip.content": "表情符號：",
  "admin-announcement-banner.editor.toolbar.link.icon.label": "插入連結",
  "admin-announcement-banner.editor.toolbar.link.tooltip.content": "連結 ⌘K",
  "admin-announcement-banner.editor.validation.character.overflow.error": "您已超過字元數上限。",
  "admin-announcement-banner.editor.validation.empty.error": "請先將文字新增至訊息再更新。",
  "admin-announcement-banner.editor.validation.unallowed.elements.error": "移除任何項目符號清單、編號清單、其他行或程式碼區塊。",
  "admin-announcement-banner.editor.visual.label": "訊息 <span>(必填)</span>",
  "admin-announcement-banner.error.flag.description": "請重新整理頁面，然後再試一次。",
  "admin-announcement-banner.flag.error.description": "請重新整理頁面，然後再試一次。",
  "admin-announcement-banner.flag.error.title": "我們在發布此公告時發生問題",
  "admin-announcement-banner.footer.publish-button": "發佈",
  "admin-announcement-banner.footer.update-button": "更新",
  "admin-announcement-banner.form.description": "建立您的橫幅訊息並選取顏色。",
  "admin-announcement-banner.form.title": "顯示設定",
  "admin-announcement-banner.generic.archive.success.title": "公告已封存",
  "admin-announcement-banner.header.create-button": "建立公告",
  "admin-announcement-banner.home-page.description": "請使用公告橫幅，向使用者傳達重要訊息。<a>深入了解</a>",
  "admin-announcement-banner.home-page.restriction": "一次只能啟用一個公告。",
  "admin-announcement-banner.home-page.title": "公告",
  "admin-announcement-banner.migrator-prompt.content": "管理員您好，您可以使用這類公告橫幅，一次向所有使用者傳達重要消息。",
  "admin-announcement-banner.migrator-prompt.link": "建立公告橫幅",
  "admin-announcement-banner.publish.error.flag.title.m2": "我們在發佈 {announcementTitle} 時遇到問題",
  "admin-announcement-banner.publish.refresh-page-action": "重新整理頁面",
  "admin-announcement-banner.publish.success.flag.description.private-audience.m2.v2": "所有私密使用者現在都可以看到您的 {announcementTitle} 訊息。",
  "admin-announcement-banner.publish.success.flag.description.public-audience.m2.v2": "所有公開使用者現在都可以看到您的 {announcementTitle} 訊息。",
  "admin-announcement-banner.publish.success.flag.title.m2.v2": "已發布公告橫幅",
  "admin-announcement-banner.publish.title": "建立公告",
  "admin-announcement-banner.radio.button.aria.label.blue": "背景顏色 - 藍色",
  "admin-announcement-banner.radio.button.aria.label.gray": "背景顏色 - 灰色",
  "admin-announcement-banner.radio.button.aria.label.green": "背景顏色 - 綠色",
  "admin-announcement-banner.radio.button.aria.label.purple": "背景顏色 - 紫色",
  "admin-announcement-banner.radio.button.aria.label.red": "背景顏色 - 紅色",
  "admin-announcement-banner.radio.button.aria.label.yellow": "背景顏色 - 黃色",
  "admin-announcement-banner.radio.button.icon.selected.lable": "已選取核取方塊",
  "admin-announcement-banner.radio.group.aria.label": "橫幅外觀",
  "admin-announcement-banner.radio.group.audience-selector.all": "<b>公開：</b>Confluence 中的任何人，包括訪客以及來自其他組織的使用者",
  "admin-announcement-banner.radio.group.audience-selector.aria.label": "橫幅存取層級選取器",
  "admin-announcement-banner.radio.group.audience-selector.authorized": "<b>私密：</b>僅限組織內的授權使用者",
  "admin-announcement-banner.restricted.publish.flag.description": "<a>{announcementTitle}</a> 目前處於作用中狀態。",
  "admin-announcement-banner.restricted.publish.flag.title": "無法發佈 {announcementTitle}",
  "admin-announcement-banner.schedule-conflict.default-title": "無標題橫幅",
  "admin-announcement-banner.schedule-update.success.flag.title.m2.v2": "已更新公告橫幅",
  "admin-announcement-banner.schedule.end-date.label": "結束日期",
  "admin-announcement-banner.schedule.end-time.label": "結束時間",
  "admin-announcement-banner.schedule.error.flag.description": "我們在排程 {announcementTitle} 時遇到問題",
  "admin-announcement-banner.schedule.start-date.label": "開始日期",
  "admin-announcement-banner.schedule.start-time.label": "開始時間",
  "admin-announcement-banner.schedule.success.flag.title.m2.v2": "已排程公告橫幅",
  "admin-announcement-banner.schedule.timezone.label": "時區",
  "admin-announcement-banner.schedule.validation.active.banner.error.conflict-details": "<a>{conflictingBannerTitle}</a> 目前處於作用中狀態",
  "admin-announcement-banner.schedule.validation.error.conflict-details": "• <a>{conflictingBannerTitle}</a> 已排程為從 {startDateTime} 到 {endDateTime}",
  "admin-announcement-banner.schedule.validation.error.message": "{conflictsCount, plural, other {下列橫幅與您的排程衝突：}}",
  "admin-announcement-banner.schedule.validation.error.title": "{conflictsCount, plural, other {排程衝突}}",
  "admin-announcement-banner.schedule.validation.invalid-end-date": "無效的結束日期",
  "admin-announcement-banner.schedule.validation.invalid-end-time": "無效的結束時間",
  "admin-announcement-banner.schedule.validation.invalid-schedule": "無效的排程",
  "admin-announcement-banner.schedule.validation.invalid-start-date": "無效的開始日期",
  "admin-announcement-banner.schedule.validation.invalid-start-time": "無效的開始時間",
  "admin-announcement-banner.schedule.validation.missing-end-date": "缺少結束日期",
  "admin-announcement-banner.schedule.validation.missing-end-time": "缺少結束時間",
  "admin-announcement-banner.schedule.validation.missing-start-date": "缺少開始日期",
  "admin-announcement-banner.schedule.validation.missing-start-time": "缺少開始時間",
  "admin-announcement-banner.schedule.validation.missing-timezone": "缺少時區",
  "admin-announcement-banner.scheduled.success.flag.description.private-audience.m2": "所有私密使用者都將能看到您的 {announcementTitle} 訊息。",
  "admin-announcement-banner.scheduled.success.flag.description.public-audience.m2": "所有公開使用者都將能看到您的 {announcementTitle} 訊息。",
  "admin-announcement-banner.section-message.archive": "封存公告橫幅",
  "admin-announcement-banner.section-message.description": "您可以編輯此橫幅以進行即時更新。",
  "admin-announcement-banner.section-message.title.private": "目前所有私密使用者都可以看到此公告橫幅",
  "admin-announcement-banner.section-message.title.private.is-scheduled": "此公告橫幅已排定從 {startDate} 到 {endDate} {timezone} 向所有私密使用者發布",
  "admin-announcement-banner.section-message.title.public": "目前所有公開使用者都可以看到此公告橫幅",
  "admin-announcement-banner.section-message.title.public.is-scheduled": "此公告橫幅已排定從 {startDate} 到 {endDate} {timezone} 向所有公開使用者發布",
  "admin-announcement-banner.section.announcement-title.description": "為您的公告提供一個簡短標題，以便在公告表上輕鬆參照。",
  "admin-announcement-banner.section.announcement-title.heading": "標題",
  "admin-announcement-banner.section.announcement-title.label": "公告標題 <span>(必填)</span>",
  "admin-announcement-banner.section.color-picker.label": "外觀和風格",
  "admin-announcement-banner.section.dismiss-toggle.label": "使用者可以關閉橫幅",
  "admin-announcement-banner.section.schedule.description": "橫幅的設計是立即發布，並且執行到封存為止。若要自動封存此公告橫幅，請新增結束日期。若要在將來排程，請同時新增開始日期和結束日期。",
  "admin-announcement-banner.section.schedule.heading": "排程 (選用)",
  "admin-announcement-banner.section.target-audience.description": "選取誰可以看到公告橫幅。",
  "admin-announcement-banner.section.target-audience.title": "目標受眾",
  "admin-announcement-banner.table.column.actions": "動作",
  "admin-announcement-banner.table.column.audience": "受眾",
  "admin-announcement-banner.table.column.end-date": "結束日期",
  "admin-announcement-banner.table.column.start-date": "開始日期",
  "admin-announcement-banner.table.column.status": "狀態",
  "admin-announcement-banner.table.column.title": "標題",
  "admin-announcement-banner.table.empty": "目前沒有公告",
  "admin-announcement-banner.table.error": "有一些公告無法載入",
  "admin-announcement-banner.table.quick-actions.archive": "封存",
  "admin-announcement-banner.table.quick-actions.copy": "複製",
  "admin-announcement-banner.table.quick-actions.edit": "編輯",
  "admin-announcement-banner.table.value.audience.private": "私密",
  "admin-announcement-banner.table.value.audience.public": "公開",
  "admin-announcement-banner.table.value.status.active": "作用中",
  "admin-announcement-banner.table.value.status.archived": "已封存",
  "admin-announcement-banner.table.value.status.scheduled": "已排定",
  "admin-announcement-banner.table.value.title.untitled": "無標題橫幅",
  "admin-announcement-banner.title.prefix-copy-of": "「{title}」的副本",
  "admin-announcement-banner.title.validation.empty.error": "請先將文字新增至標題再更新。",
  "admin-announcement-banner.turn-off.error.flag.title": "我們在關閉此公告時遇到問題",
  "admin-announcement-banner.update.error.flag.title": "我們在更新此公告時遇到問題",
  "admin-announcement-banner.update.error.flag.title.m2": "我們在更新 {announcementTitle} 時遇到問題",
  "admin-center..search-terms-by-zero-ctr-leaderboard-row.label": "{count, plural, other {{count,number} 個搜尋內容中沒有點擊}}",
  "admin-center.activity-section.title": "活動",
  "admin-center.admin-center-page.title": "任務控制",
  "admin-center.admin-center-space.activity-section.title": "活動",
  "admin-center.admin-center-space.admin-center-page.title": "任務控制",
  "admin-center.admin-center-space.content-count-chart.blogs-label": "部落格",
  "admin-center.admin-center-space.content-count-chart.cta": "檢視分析",
  "admin-center.admin-center-space.content-count-chart.databases-label": "資料庫",
  "admin-center.admin-center-space.content-count-chart.livedocs-label": "即時文件",
  "admin-center.admin-center-space.content-count-chart.main-statistic": "{count, plural, other {{value} 個項目}}",
  "admin-center.admin-center-space.content-count-chart.pages-label": "頁面",
  "admin-center.admin-center-space.content-count-chart.title": "總內容",
  "admin-center.admin-center-space.content-count-chart.tooltip.content": "內容總計包含頁面、部落格和白板。不包含已封存的內容。",
  "admin-center.admin-center-space.content-count-chart.tooltip.content.livedocs": "內容總計包含頁面、即時文件、部落格、資料庫和白板。不包含已封存的內容。",
  "admin-center.admin-center-space.content-count-chart.tooltip.label": "內容總計工具提示",
  "admin-center.admin-center-space.content-count-chart.whiteboards-label": "白板",
  "admin-center.admin-center-space.content-created-chart.blogs-label": "部落格",
  "admin-center.admin-center-space.content-created-chart.cta": "檢視詳細資料",
  "admin-center.admin-center-space.content-created-chart.databases-label": "資料庫",
  "admin-center.admin-center-space.content-created-chart.live-docs-label": "即時文件",
  "admin-center.admin-center-space.content-created-chart.main-statistic": "{value} 個{lastGranularityDescription}",
  "admin-center.admin-center-space.content-created-chart.pages-label": "頁面",
  "admin-center.admin-center-space.content-created-chart.title": "建立的內容",
  "admin-center.admin-center-space.content-created-chart.whiteboards-label": "白板",
  "admin-center.admin-center-space.content-management-section.title": "內容管理",
  "admin-center.admin-center-space.content-updated-chart.blogs-label": "部落格",
  "admin-center.admin-center-space.content-updated-chart.cta": "檢視詳細資料",
  "admin-center.admin-center-space.content-updated-chart.livedocs-label": "即時文件",
  "admin-center.admin-center-space.content-updated-chart.main-statistic": "{value} 個{lastGranularityDescription}",
  "admin-center.admin-center-space.content-updated-chart.pages-label": "頁面",
  "admin-center.admin-center-space.content-updated-chart.title": "內容已更新",
  "admin-center.admin-center-space.content-viewed-chart.blogs-label": "部落格",
  "admin-center.admin-center-space.content-viewed-chart.databases-label": "資料庫",
  "admin-center.admin-center-space.content-viewed-chart.live-docs-label": "即時文件",
  "admin-center.admin-center-space.content-viewed-chart.main-statistic": "{value} 個{lastGranularityDescription}",
  "admin-center.admin-center-space.content-viewed-chart.pages-label": "頁面",
  "admin-center.admin-center-space.content-viewed-chart.title": "內容檢視",
  "admin-center.admin-center-space.content-viewed-chart.whiteboards-label": "白板",
  "admin-center.admin-center-space.content-viewed-leaderboard-row.arialabel": "內容圖示",
  "admin-center.admin-center-space.content-viewed-leaderboard-row.label": "{count, plural, other {{count,number} 次檢視}}",
  "admin-center.admin-center-space.content-viewed-leaderboard.button": "全部檢視",
  "admin-center.admin-center-space.content-viewed-leaderboard.empty.description": "此空間中沒有任何已檢視的頁面",
  "admin-center.admin-center-space.content-viewed-leaderboard.title": "瀏覽次數最多的頁面",
  "admin-center.admin-center-space.content-viewed-leaderboard.title.all-content": "檢視次數最多的內容",
  "admin-center.admin-center-space.deactivated-owner-chart.label": "沒有作用中負責人的頁面",
  "admin-center.admin-center-space.deactivated-owner-chart.label.livedocs": "沒有作用中負責人的頁面和即時文件",
  "admin-center.admin-center-space.deactivated-owner-chart.main-statistic.percent": "所有頁面的 {value}",
  "admin-center.admin-center-space.deactivated-owner-chart.title": "沒有作用中負責人的頁面",
  "admin-center.admin-center-space.deactivated-owner-chart.title.livedocs": "沒有作用中負責人的頁面和即時文件",
  "admin-center.admin-center-space.deactivated-owner-pages-leaderboard-row.label": "{count, plural, other {在此空間中負責 {count,number} 個頁面}}",
  "admin-center.admin-center-space.deactivated-owner-pages-leaderboard.button": "全部檢視",
  "admin-center.admin-center-space.deactivated-owner-pages-leaderboard.empty.description": "空間中的所有頁面都有作用中的負責人",
  "admin-center.admin-center-space.deactivated-owner-pages-leaderboard.title": "檢閱這些負責人的頁面",
  "admin-center.admin-center-space.early-experience-alert.section-message": "新增內容後，圖表和指標也會隨之填入。",
  "admin-center.admin-center-space.external-access.anonymous-access-feature": "匿名存取",
  "admin-center.admin-center-space.external-access.anonymous-access-feature.description.disabled": "此空間未啟用",
  "admin-center.admin-center-space.external-access.anonymous-access-feature.description.enabled": "此空間已啟用",
  "admin-center.admin-center-space.external-access.cta-text": "管理空間權限",
  "admin-center.admin-center-space.external-access.guest-access-feature": "訪客",
  "admin-center.admin-center-space.external-access.guest-access-feature.description.disabled": "尚未新增訪客",
  "admin-center.admin-center-space.external-access.guest-access-feature.description.enabled": "已新增至少一位訪客",
  "admin-center.admin-center-space.external-access.public-links-feature": "公開連結",
  "admin-center.admin-center-space.external-access.public-links-feature.description.disabled": "此空間不允許",
  "admin-center.admin-center-space.external-access.public-links-feature.description.enabled": "此空間已允許",
  "admin-center.admin-center-space.external-access.title": "外部存取功能",
  "admin-center.admin-center-space.group-summary-section.content-count-summary.title": "總內容",
  "admin-center.admin-center-space.group-summary-section.content-count-summary.tooltip.content": "內容總計包含頁面、部落格和白板。不包含已封存的內容。",
  "admin-center.admin-center-space.group-summary-section.content-count-summary.tooltip.content.livedocs": "內容總計包含頁面、即時文件、部落格、資料庫和白板。不包含已封存的內容。",
  "admin-center.admin-center-space.group-summary-section.content-count-summary.tooltip.label": "內容總計工具提示",
  "admin-center.admin-center-space.group-summary-section.content-created-count-summary.main-statistic": "昨天 {value} 個",
  "admin-center.admin-center-space.group-summary-section.content-created-count-summary.title": "建立的內容",
  "admin-center.admin-center-space.group-summary-section.content-views-count-summary.main-statistic": "昨天 {value} 個",
  "admin-center.admin-center-space.group-summary-section.content-views-count-summary.title": "內容檢視",
  "admin-center.admin-center-space.inactive-pages-chart.inactive-pages-count-label": "非作用中的頁面",
  "admin-center.admin-center-space.inactive-pages-chart.inactive-pages-count-label.livedocs": "非作用中的頁面和即時文件",
  "admin-center.admin-center-space.inactive-pages-chart.main-statistic.percent": "所有頁面的 {value}",
  "admin-center.admin-center-space.inactive-pages-chart.main-statistic.percent.livedocs": "所有頁面的 {value}",
  "admin-center.admin-center-space.inactive-pages-chart.title": "非作用中的頁面 (6 個月)",
  "admin-center.admin-center-space.inactive-pages-chart.title.livedocs": "非作用中的頁面和即時文件 (6 個月)",
  "admin-center.admin-center-space.inactive-pages-chart.tooltip.content": "尚未檢視、更新或留言的非作用中頁面。",
  "admin-center.admin-center-space.inactive-pages-chart.tooltip.content.livedocs": "尚未檢視、更新或留言的非作用中頁面和即時文件。",
  "admin-center.admin-center-space.inactive-pages-chart.tooltip.label": "非作用中的頁面工具提示",
  "admin-center.admin-center-space.inactive-pages-chart.tooltip.label.livedocs": "非作用中的頁面和即時文件工具提示",
  "admin-center.admin-center-space.inactive-pages-leaderboard-row.arialabel": "內容圖示",
  "admin-center.admin-center-space.inactive-pages-leaderboard-row.label.month": "{count, plural, other {上次處於作用中狀態是 {count} 個月前}}",
  "admin-center.admin-center-space.inactive-pages-leaderboard-row.label.year": "{count, plural, other {上次處於作用中狀態已超過 {count} 年前}}",
  "admin-center.admin-center-space.inactive-pages-leaderboard.button": "全部檢視",
  "admin-center.admin-center-space.inactive-pages-leaderboard.button.livedocs": "全部檢視",
  "admin-center.admin-center-space.inactive-pages-leaderboard.empty.description": "空間中的所有頁面都處於作用中狀態",
  "admin-center.admin-center-space.inactive-pages-leaderboard.title": "檢閱這些頁面",
  "admin-center.admin-center-space.inactive-pages-leaderboard.title.livedocs": "檢閱這些頁面和即時文件",
  "admin-center.admin-center-space.insufficient-analytics-permission.link": "前往分析權限",
  "admin-center.admin-center-space.insufficient-analytics-permission.section-message": "若要顯示 Confluence 資料，您需要開啟分析功能。",
  "admin-center.admin-center-space.public-link-count-chart.cta": "檢視詳細資料",
  "admin-center.admin-center-space.public-link-count-chart.title": "作用中的公開連結",
  "admin-center.admin-center-space.public-link-count-chart.total-public-links-label": "公開連結",
  "admin-center.admin-center-space.public-link-views-chart.cta": "檢視詳細資料",
  "admin-center.admin-center-space.public-link-views-chart.main-statistic": "{value} 個{lastGranularityDescription}",
  "admin-center.admin-center-space.public-link-views-chart.title": "公開連結檢視",
  "admin-center.admin-center-space.public-link-views-chart.viewed-public-links-label": "公開連結檢視",
  "admin-center.admin-center-space.security-section.title": "安全性",
  "admin-center.admin-center-space.space-admins.modal.title": "空間管理員",
  "admin-center.admin-center-space.space-admins.title": "空間管理員",
  "admin-center.admins-base-modal.close-button-text": "關閉",
  "admin-center.admins-base-modal.manage-cta-text": "管理管理員",
  "admin-center.admins-base.cta-text": "檢視所有管理員",
  "admin-center.beta-features.content-wrapper-feature.description.disabled": "並未為此執行個體啟用",
  "admin-center.beta-features.content-wrapper-feature.description.enabled": "已為此執行個體啟用",
  "admin-center.beta-features.cta-text": "管理新功能",
  "admin-center.beta-features.live-docs-feature.description.disabled": "並未為此執行個體啟用",
  "admin-center.beta-features.live-docs-feature.description.enabled": "已為此執行個體啟用",
  "admin-center.beta-features.loom-feature": "Loom",
  "admin-center.beta-features.loom-feature.description.disabled": "並未為此執行個體啟用",
  "admin-center.beta-features.loom-feature.description.enabled": "已為此執行個體啟用",
  "admin-center.beta-features.title": "新功能",
  "admin-center.chart-base-subcomponents.area-path-aria-label": "{lineDescription} 區域路徑",
  "admin-center.chart-base-subcomponents.data-point-aria-label": "{lineDescription}：{yValue}，日期：{xValue}",
  "admin-center.chart-base-subcomponents.line-path-aria-label": "{lineDescription}線路徑",
  "admin-center.chart-tooltip.description.date-weekly": "{date} 開始的那一週",
  "admin-center.confluence-admins.modal.title": "Confluence 管理員",
  "admin-center.content-count-chart.blogs-label": "部落格",
  "admin-center.content-count-chart.cta": "檢視分析",
  "admin-center.content-count-chart.databases-label": "資料庫",
  "admin-center.content-count-chart.livedocs-label": "即時文件",
  "admin-center.content-count-chart.main-statistic": "{count, plural, other {{value} 個項目}}",
  "admin-center.content-count-chart.pages-label": "頁面",
  "admin-center.content-count-chart.title": "總內容",
  "admin-center.content-count-chart.tooltip.content": "內容總計包含頁面、部落格和白板。不包含已封存的內容。",
  "admin-center.content-count-chart.tooltip.content.livedocs": "內容總計包含頁面、即時文件、部落格、資料庫和白板。不包含已封存的內容。",
  "admin-center.content-count-chart.tooltip.label": "內容總計工具提示",
  "admin-center.content-count-chart.whiteboards-label": "白板",
  "admin-center.content-created-chart.blogs-label": "部落格",
  "admin-center.content-created-chart.cta": "檢視詳細資料",
  "admin-center.content-created-chart.databases-label": "資料庫",
  "admin-center.content-created-chart.live-docs-label": "即時文件",
  "admin-center.content-created-chart.main-statistic": "{value} 個{lastGranularityDescription}",
  "admin-center.content-created-chart.pages-label": "頁面",
  "admin-center.content-created-chart.title": "建立的內容",
  "admin-center.content-created-chart.whiteboards-label": "白板",
  "admin-center.content-management-section.title": "內容管理",
  "admin-center.content-updated-chart.blogs-label": "部落格",
  "admin-center.content-updated-chart.cta": "檢視詳細資料",
  "admin-center.content-updated-chart.livedocs-label": "即時文件",
  "admin-center.content-updated-chart.main-statistic": "{value} 個{lastGranularityDescription}",
  "admin-center.content-updated-chart.pages-label": "頁面",
  "admin-center.content-updated-chart.title": "內容已更新",
  "admin-center.content-views-chart.blogs-label": "部落格",
  "admin-center.content-views-chart.database-label": "資料庫",
  "admin-center.content-views-chart.live-docs-label": "即時文件",
  "admin-center.content-views-chart.main-statistic": "{value} 個{lastGranularityDescription}",
  "admin-center.content-views-chart.pages-label": "頁面",
  "admin-center.content-views-chart.title": "內容檢視",
  "admin-center.content-views-chart.whiteboards-label": "白板",
  "admin-center.content-views-leaderboard-row.arialabel": "空間圖示",
  "admin-center.content-views-leaderboard-row.label": "{count, plural, other {{count,number} 次檢視}}",
  "admin-center.content-views-leaderboard-row.secondary-button-tooltip": "檢視空間分析",
  "admin-center.content-views-leaderboard.button": "全部檢視",
  "admin-center.content-views-leaderboard.empty.description": "您尚未有已檢視的空間",
  "admin-center.content-views-leaderboard.title": "最常檢視的空間",
  "admin-center.deactivated-owner-chart.label": "沒有作用中負責人的頁面",
  "admin-center.deactivated-owner-chart.label.livedocs": "沒有作用中負責人的頁面和即時文件",
  "admin-center.deactivated-owner-chart.main-statistic.percent": "所有頁面的 {value}",
  "admin-center.deactivated-owner-chart.main-statistic.percent.livedocs": "所有頁面和即時文件的 {value}",
  "admin-center.deactivated-owner-chart.title": "沒有作用中負責人的頁面",
  "admin-center.deactivated-owner-chart.title.livedocs": "沒有作用中負責人的頁面和即時文件",
  "admin-center.deactivated-owner-pages-leaderboard-row.arialabel": "空間圖示",
  "admin-center.deactivated-owner-pages-leaderboard-row.label": "{count, plural, other {有 {count,number} 個頁面沒有作用中的負責人}}",
  "admin-center.deactivated-owner-pages-leaderboard-row.label.livedocs": "{count, plural, other {{count,number} 個頁面和即時文件沒有作用中負責人}}",
  "admin-center.deactivated-owner-pages-leaderboard-row.secondary-button-tooltip": "內容管理員",
  "admin-center.deactivated-owner-pages-leaderboard.empty.description": "空間中的所有頁面都有作用中的負責人",
  "admin-center.deactivated-owner-pages-leaderboard.title": "檢閱這些空間中的頁面",
  "admin-center.disabled-state-base-card.enabled-icon-label": "已停用的圖示",
  "admin-center.dismiss.menu-item.title": "關閉",
  "admin-center.early-experience-alert.section-message": "新增空間和內容後，圖表和指標也會隨之填入。",
  "admin-center.enabled-state-base-card.enabled-icon-label": "已啟用的圖示",
  "admin-center.error.description": "請重新整理頁面。如果持續發生問題，請<a>連絡支援人員</a>。",
  "admin-center.error.title": "載入錯誤",
  "admin-center.error.title.icon-label": "錯誤圖示",
  "admin-center.external-access.anonymous-access-feature": "匿名存取",
  "admin-center.external-access.anonymous-access-feature.description.disabled": "並未為此執行個體啟用",
  "admin-center.external-access.anonymous-access-feature.description.enabled": "已為此執行個體啟用",
  "admin-center.external-access.cta-text": "管理全域權限",
  "admin-center.external-access.guest-access-feature": "訪客",
  "admin-center.external-access.guest-access-feature.description.disabled": "尚未新增訪客",
  "admin-center.external-access.guest-access-feature.description.enabled": "已新增至少一位訪客",
  "admin-center.external-access.jsm-access-feature": "JSM 存取權",
  "admin-center.external-access.jsm-access-feature.description.disabled": "並未為此執行個體啟用",
  "admin-center.external-access.jsm-access-feature.description.enabled": "已為此執行個體啟用",
  "admin-center.external-access.public-links-feature": "公開連結",
  "admin-center.external-access.public-links-feature.description.disabled": "不允許此執行個體",
  "admin-center.external-access.public-links-feature.description.enabled": "已允許此執行個體",
  "admin-center.external-access.title": "外部存取功能",
  "admin-center.feature-usage-section.title": "功能使用情況",
  "admin-center.footer.feedback.button": "提供意見反應",
  "admin-center.footer.feedback.text": "讓我們知道您對任務控管的看法。",
  "admin-center.group-summary-block.data-refreshes-daily": "每天重新整理",
  "admin-center.group-summary-section.v2.button.cancel": "取消",
  "admin-center.group-summary-section.v2.button.edit": "編輯",
  "admin-center.group-summary-section.v2.button.save": "儲存",
  "admin-center.group-summary-section.v2.content-count-summary.title": "總內容",
  "admin-center.group-summary-section.v2.content-count-summary.tooltip.content": "內容總計包含頁面、部落格和白板。不包含已封存的內容。",
  "admin-center.group-summary-section.v2.content-count-summary.tooltip.content.livedocs": "內容總計包含頁面、即時文件、部落格、資料庫和白板。不包含已封存的內容。",
  "admin-center.group-summary-section.v2.content-count-summary.tooltip.label": "內容總計工具提示",
  "admin-center.group-summary-section.v2.content-created-summary.main-statistic": "昨天 {value} 個",
  "admin-center.group-summary-section.v2.content-created-summary.title": "建立的內容",
  "admin-center.group-summary-section.v2.content-updated-summary.main-statistic": "昨天 {value} 個",
  "admin-center.group-summary-section.v2.content-updated-summary.title": "內容已更新",
  "admin-center.group-summary-section.v2.content-views-summary.main-statistic": "昨天 {value} 個",
  "admin-center.group-summary-section.v2.content-views-summary.title": "內容檢視",
  "admin-center.group-summary-section.v2.deactivated-owner-pages-summary.percent-main-stat": "所有頁面的 {value}",
  "admin-center.group-summary-section.v2.deactivated-owner-pages-summary.title.number": "沒有作用中負責人的頁面 (數目)",
  "admin-center.group-summary-section.v2.deactivated-owner-pages-summary.title.number.livedocs": "沒有作用中負責人的頁面和即時文件 (數量)",
  "admin-center.group-summary-section.v2.deactivated-owner-pages-summary.title.percentage": "沒有作用中負責人的頁面 (百分比)",
  "admin-center.group-summary-section.v2.deactivated-owner-pages-summary.title.percentage.livedocs": "沒有作用中負責人的頁面和即時文件 (百分比)",
  "admin-center.group-summary-section.v2.flag.error.description": "請稍候數分鐘，然後再試一次。",
  "admin-center.group-summary-section.v2.flag.error.description-retry-button": "再試一次",
  "admin-center.group-summary-section.v2.inactive-pages-summary.percent-main-stat": "所有頁面的 {value}",
  "admin-center.group-summary-section.v2.inactive-pages-summary.percent-main-stat.livedocs": "所有頁面和即時文件的 {value}",
  "admin-center.group-summary-section.v2.inactive-pages-summary.title.number": "非作用中的頁面 (數目)",
  "admin-center.group-summary-section.v2.inactive-pages-summary.title.number.livedocs": "非作用中的頁面和即時文件 (數量)",
  "admin-center.group-summary-section.v2.inactive-pages-summary.title.percentage": "非作用中的頁面 (百分比)",
  "admin-center.group-summary-section.v2.inactive-pages-summary.title.percentage.livedocs": "非作用中的頁面和即時文件 (百分比)",
  "admin-center.group-summary-section.v2.public-link-count-summary.title": "作用中的公開連結",
  "admin-center.group-summary-section.v2.public-link-views-summary.main-statistic": "昨天 {value} 個",
  "admin-center.group-summary-section.v2.public-link-views-summary.title": "公開連結檢視",
  "admin-center.group-summary-section.v2.search-count-summary.main-statistic": "昨天 {value} 個",
  "admin-center.group-summary-section.v2.search-count-summary.title": "Confluence 搜尋",
  "admin-center.group-summary-section.v2.search-ctr-summary.main-statistic": "昨天 {value} 個",
  "admin-center.group-summary-section.v2.search-ctr-summary.title": "搜尋點擊率",
  "admin-center.group-summary-section.v2.search-ctr-summary.tooltip.content": "點擊率是指讓已登入的使用者檢視頁面的搜尋百分比。",
  "admin-center.group-summary-section.v2.search-ctr-summary.tooltip.content.livedocs": "點擊率是指搜尋中登入的使用者會檢視搜尋內容所佔的百分比。",
  "admin-center.group-summary-section.v2.search-ctr-summary.tooltip.label": "搜尋 CTR (點擊率) 工具提示",
  "admin-center.group-summary-section.v2.spaces-count-summary.title": "空間總數",
  "admin-center.group-summary-section.v2.spaces-count-summary.tooltip.content": "此指標中只包含作用中的空間。已刪除和封存的空間不包含在內。",
  "admin-center.group-summary-section.v2.spaces-count-summary.tooltip.label": "空間總數工具提示",
  "admin-center.group-summary-section.v2.title": "概觀",
  "admin-center.group-summary-section.v2.update.error.flag.title": "我們無法更新您的概觀",
  "admin-center.group-summary-section.v2.update.success.flag.title": "已更新概觀",
  "admin-center.inactive-pages-chart.inactive-pages-count-label": "非作用中的頁面",
  "admin-center.inactive-pages-chart.inactive-pages-count-label.livedocs": "非作用中的頁面和即時文件",
  "admin-center.inactive-pages-chart.main-statistic.percent": "所有頁面的 {value}",
  "admin-center.inactive-pages-chart.main-statistic.percent.livedocs": "所有頁面的 {value}",
  "admin-center.inactive-pages-chart.title": "非作用中的頁面 (6 個月)",
  "admin-center.inactive-pages-chart.title.livedocs": "非作用中的頁面和即時文件 (6 個月)",
  "admin-center.inactive-pages-chart.tooltip.content": "尚未檢視、更新或留言的非作用中頁面。",
  "admin-center.inactive-pages-chart.tooltip.content.livedocs": "尚未檢視、更新或留言的非作用中頁面和即時文件。",
  "admin-center.inactive-pages-chart.tooltip.label": "非作用中的頁面工具提示",
  "admin-center.inactive-pages-chart.tooltip.label.livedocs": "非作用中的頁面和即時文件工具提示",
  "admin-center.inactive-pages-leaderboard-row.arialabel": "空間圖示",
  "admin-center.inactive-pages-leaderboard-row.label": "{count, plural, other {{count,number} 個非作用中的頁面}}",
  "admin-center.inactive-pages-leaderboard-row.label.livedocs": "{count, plural, other {{count,number} 個非作用中的頁面和即時文件}}",
  "admin-center.inactive-pages-leaderboard-row.secondary-button-tooltip": "內容管理員",
  "admin-center.inactive-pages-leaderboard.empty.description": "空間中的所有頁面都處於作用中狀態",
  "admin-center.inactive-pages-leaderboard.title": "檢閱這些空間中的頁面",
  "admin-center.inactive-pages-leaderboard.title.livedocs": "檢閱這些空間中的頁面和即時文件",
  "admin-center.insufficient-analytics-permission.link": "前往分析權限",
  "admin-center.insufficient-analytics-permission.section-message": "若要顯示 Confluence 資料，您需要開啟分析功能。",
  "admin-center.live-pages-admin-info-banner.beta.body": "無需發布即可建立和編輯。<link>了解更多有關即時文件的資訊</link>",
  "admin-center.live-pages-admin-info-banner.beta.enable-live-pages": "立即試用即時文件",
  "admin-center.live-pages-admin-info-banner.beta.heading": "即時文件已可供使用",
  "admin-center.main-stat.description.last-month": "上個月",
  "admin-center.main-stat.description.last-week": "上週",
  "admin-center.main-stat.description.yesterday": "昨天",
  "admin-center.metric-dropdown.aria-label": "選取要在「概觀」區段中顯示的指標",
  "admin-center.metric-dropdown.group-name.activity": "活動",
  "admin-center.metric-dropdown.group-name.content-mgmt": "內容管理",
  "admin-center.metric-dropdown.group-name.feature-usage": "功能使用情況",
  "admin-center.metric-dropdown.group-name.security": "安全性",
  "admin-center.metric-dropdown.option.content-created": "建立的內容",
  "admin-center.metric-dropdown.option.content-updated": "內容已更新",
  "admin-center.metric-dropdown.option.content-views": "內容檢視",
  "admin-center.metric-dropdown.option.deactivated-owner-pages.number": "沒有作用中負責人的頁面 (數目)",
  "admin-center.metric-dropdown.option.deactivated-owner-pages.number.livedocs": "沒有作用中負責人的頁面和即時文件 (數量)",
  "admin-center.metric-dropdown.option.deactivated-owner-pages.percentage": "沒有作用中負責人的頁面 (百分比)",
  "admin-center.metric-dropdown.option.deactivated-owner-pages.percentage.livedocs": "沒有作用中負責人的頁面和即時文件 (百分比)",
  "admin-center.metric-dropdown.option.inactive-pages.number": "非作用中的頁面 (數目)",
  "admin-center.metric-dropdown.option.inactive-pages.number.livedocs": "非作用中的頁面和即時文件 (數量)",
  "admin-center.metric-dropdown.option.inactive-pages.percentage": "非作用中的頁面 (百分比)",
  "admin-center.metric-dropdown.option.inactive-pages.percentage.livedocs": "非作用中的頁面和即時文件 (百分比)",
  "admin-center.metric-dropdown.option.public-link-views": "公開連結檢視",
  "admin-center.metric-dropdown.option.public-links": "作用中的公開連結",
  "admin-center.metric-dropdown.option.search-ctr": "搜尋點擊率",
  "admin-center.metric-dropdown.option.searches": "Confluence 搜尋",
  "admin-center.metric-dropdown.option.total-content": "總內容",
  "admin-center.metric-dropdown.option.total-spaces": "空間總數",
  "admin-center.metric-settings-controller.granularity-day-value": "每日",
  "admin-center.metric-settings-controller.granularity-label": "精細程度為何？",
  "admin-center.metric-settings-controller.granularity-month-value": "每月",
  "admin-center.metric-settings-controller.granularity-week-value": "每週",
  "admin-center.metric-settings-controller.last-x-days-value": "{count, plural, other {過去 {count} 天}}",
  "admin-center.metric-settings-controller.last-x-granularity-label": "什麼時段？",
  "admin-center.metric-settings-controller.last-x-months-value": "{count, plural, other {過去 {count} 個月}}",
  "admin-center.metric-settings-controller.last-x-weeks-value": "{count, plural, other {過去 {count} 週}}",
  "admin-center.pagination.next-page": "下一頁",
  "admin-center.pagination.page-range": "第 {start}-{end} 項結果",
  "admin-center.pagination.page-range-limited": "所有結果的第 {start}-{end} 項 (最多 {limit} 項)",
  "admin-center.pagination.previous-page": "上一頁",
  "admin-center.public-link-count-chart.cta": "檢視詳細資料",
  "admin-center.public-link-count-chart.title": "作用中的公開連結",
  "admin-center.public-link-count-chart.total-public-links-label": "公開連結",
  "admin-center.public-link-views-chart.cta": "檢視詳細資料",
  "admin-center.public-link-views-chart.main-statistic": "{value} 個{lastGranularityDescription}",
  "admin-center.public-link-views-chart.title": "公開連結檢視",
  "admin-center.public-link-views-chart.viewed-public-links-label": "公開連結檢視",
  "admin-center.satisfaction-survey.cancel": "取消",
  "admin-center.satisfaction-survey.checkbox.can-contact": "是的，Atlassian 團隊可以與我聯繫，詢問我的使用體驗，以便改善 Atlassian 產品和服務。我同意 <a>Atlassian 隱私政策</a>。",
  "admin-center.satisfaction-survey.confirmation": "已提交意見反應",
  "admin-center.satisfaction-survey.confirmation.description": "感謝您協助我們改善 Confluence！",
  "admin-center.satisfaction-survey.description": "您對使用任務控管有什麼看法？",
  "admin-center.satisfaction-survey.question.bad": "我們很遺憾得知這個消息。您不滿意的地方是什麼？有任何讓您喜歡的地方嗎？(選擇性)",
  "admin-center.satisfaction-survey.question.great": "太棒了！您喜歡其中哪一個部分？有什麼可以改進的嗎？(選擇性)",
  "admin-center.satisfaction-survey.question.okay": "您是否能再提供多一點資訊？您喜歡其中哪一個部分？有什麼可以改進的嗎？(選擇性)",
  "admin-center.satisfaction-survey.rating.amazing": "了不起",
  "admin-center.satisfaction-survey.rating.bad": "不佳",
  "admin-center.satisfaction-survey.rating.great": "很好",
  "admin-center.satisfaction-survey.rating.okay": "普通",
  "admin-center.satisfaction-survey.rating.terrible": "很糟糕",
  "admin-center.satisfaction-survey.submit": "提交",
  "admin-center.satisfaction-survey.title": "告訴我們您的想法",
  "admin-center.search-count-chart.cta": "檢視分析",
  "admin-center.search-count-chart.main-statistic": "{value} 個{lastGranularityDescription}",
  "admin-center.search-count-chart.search-count-label": "搜尋",
  "admin-center.search-count-chart.title": "搜尋",
  "admin-center.search-count-chart.tooltip.content": "一個搜尋內容可以包含多個字詞。",
  "admin-center.search-count-chart.tooltip.label": "搜尋計數工具提示",
  "admin-center.search-ctr-chart.main-statistic": "{value} 個{lastGranularityDescription}",
  "admin-center.search-ctr-chart.search-ctr-label": "點擊率",
  "admin-center.search-ctr-chart.title": "搜尋點擊率",
  "admin-center.search-ctr-chart.tooltip.content": "點擊率是指搜尋中登入的使用者會檢視搜尋內容所佔的百分比。",
  "admin-center.search-ctr-chart.tooltip.label": "搜尋 CTR (點擊率) 工具提示",
  "admin-center.search-leaderboard-row.tooltip": "在搜尋分析中尋找此字詞",
  "admin-center.search-leaderboard.empty.button": "檢視分析",
  "admin-center.search-terms-by-search-count-leaderboard.empty.description": "此期間內沒有搜尋",
  "admin-center.search-terms-by-search-count-leaderboard.title": "最常搜尋的字詞",
  "admin-center.search-terms-by-search-leaderboard-row.button.label": "按搜尋次數來搜尋詞彙的列按鈕標籤",
  "admin-center.search-terms-by-search-leaderboard-row.label": "{count, plural, other {已顯示在 {count,number} 個搜尋內容中}}",
  "admin-center.search-terms-by-search-leaderboard.button": "全部檢視",
  "admin-center.search-terms-by-zero-ctr-leaderboard-row.button.label": "按零點擊率來搜尋詞彙的列按鈕標籤",
  "admin-center.search-terms-by-zero-ctr-leaderboard.button": "全部檢視",
  "admin-center.search-terms-by-zero-ctr-leaderboard.empty.description": "在此期間中，所有產生檢視的搜尋字詞",
  "admin-center.search-terms-by-zero-ctr-leaderboard.title": "檢閱這些字詞",
  "admin-center.security-section.title": "安全性",
  "admin-center.space-activity-section.title": "使用者活動",
  "admin-center.space-count-chart.communal-spaces-label": "團隊和專案空間",
  "admin-center.space-count-chart.cta": "檢視分析",
  "admin-center.space-count-chart.personal-spaces-label": "個人空間",
  "admin-center.space-count-chart.title": "空間總數",
  "admin-center.space-count-chart.tooltip.content": "此指標中只包含作用中的空間。已刪除和封存的空間不包含在內。",
  "admin-center.space-count-chart.tooltip.label": "空間總數工具提示",
  "admin-center.suggestion-base.dismiss.trigger.label": "建議更多動作選單",
  "admin-center.suggestion.button.review.label": "檢閱",
  "admin-center.suggestion.modal.leaderboard.item.non-admin": "您不是此空間的管理員",
  "admin-center.suggestions-base-modal.close-button-text": "關閉",
  "admin-center.suggestions-section.empty.message": "您已看完所有項目",
  "admin-center.suggestions-section.title": "建議",
  "admin-center.suggestions.deactivated-owner-pages-leaderboard-row.label": "{count, plural, other {有 {count} 個項目待審閱}}",
  "admin-center.suggestions.deactivated-owner-pages.badge.text": ">{threshold}%",
  "admin-center.suggestions.deactivated-owner-pages.description": "{value} 的內容沒有作用中負責人。請指派將維護此內容的新負責人。",
  "admin-center.suggestions.deactivated-owner-pages.modal.description": "這些空間有最多的內容沒有作用中負責人。請先檢閱這些空間中的項目。",
  "admin-center.suggestions.deactivated-owner-pages.title": "檢閱沒有作用中負責人的內容",
  "admin-center.suggestions.dismissal.flags.error.description": "請重新整理頁面或稍後再試一次。",
  "admin-center.suggestions.dismissal.flags.error.title": "我們無法關閉這項建議",
  "admin-center.suggestions.dismissal.flags.success.description": "如果需要更多動作，某些建議可能會重新出現。",
  "admin-center.suggestions.dismissal.flags.success.title": "已關閉建議",
  "admin-center.suggestions.feature-discovery.cta-text": "立即試用",
  "admin-center.suggestions.inactive-pages.badge.text": ">{threshold}%",
  "admin-center.suggestions.inactive-pages.description": "{value} 的內容已停用 6 個月以上。請檢閱內容，讓團隊的工作保持在最新狀態。",
  "admin-center.suggestions.inactive-pages.message.count": "{count, plural, other {有 {count} 個項目待審閱}}",
  "admin-center.suggestions.inactive-pages.modal.description": "這些空間具有最多非作用中的內容。請先檢閱這些空間中的項目。",
  "admin-center.suggestions.inactive-pages.title": "檢閱非作用中的內容",
  "admin-center.suggestions.lozenge.new": "全新",
  "admin-center.suggestions.space-manager.description": "使用<b>空間</b>作為單一位置，以管理員身份管理 Confluence 中的空間。",
  "admin-center.suggestions.space-manager.title": "管理作用中、已封存和已丟棄的空間",
  "admin-center.suggestions.unassigned-guests.cta-button.text": "指派",
  "admin-center.suggestions.unassigned-guests.description-with-count-only": "{count, plural, other {有 <b>{count}</b> 位訪客需要空間存取權才能使用 Confluence。}}",
  "admin-center.suggestions.unassigned-guests.description-with-name": "{count, plural, other {<b>{firstPerson}</b> 和其他 <b>{count}</b> 位訪客需要空間存取權才能使用 Confluence。}}",
  "admin-center.suggestions.unassigned-guests.title": "將訪客指派至空間",
  "admin-center.suggestions.user-access.description": "<b>使用者存取權</b>可協助您查看使用者可以存取哪些內容，以及存取權來源。",
  "admin-center.suggestions.user-access.title": "檢查使用者或群組的高層級權限",
  "admin-center.summary-card.icon-label.down-arrow": "向下箭頭圖示",
  "admin-center.summary-card.icon-label.up-arrow": "向上箭頭圖示",
  "admin-center.summary-card.less-than-one-percent-sub-stat": "自 {granularity, select, DAY {{interval, plural, =7 {上週} =30 {1 個月前} other {2 個月前}}} WEEK {{interval} 週前} MONTH {{interval} 個月前} other {}} 以來 <1%",
  "admin-center.summary-card.main-stat-not-available-text": "不適用",
  "admin-center.summary-card.no-change-sub-stat": "自 {granularity, select, DAY {{interval, plural, =7 {上週} =30 {1 個月前} other {2 個月前}}} WEEK {{interval} 週前} MONTH {{interval} 個月前} other {}} 以來沒有變化",
  "admin-center.summary-card.sub-stat": "{percentChange, plural, one {1%，自 {granularity, select, DAY {{interval, plural, =7 {上週} =30 {1 個月前} other {2 個月前}}} WEEK {{interval} 週前} MONTH {{interval} 個月前} 以來 other {}}} other {{percentChange}%，自 {granularity, select, DAY {{interval, plural, =7 {上週} =30 {1 個月前} other {2 個月前}}} WEEK {{interval} 週前} MONTH {{interval} 個月前} 以來 other {}}}}",
  "admin-center.summary-card.zero-count-both-dates": "自 {granularity, select, DAY {{interval, plural, =7 {上週} =30 {1 個月前} other {2 個月前}}} WEEK {{interval} 週前} MONTH {{interval} 個月前} other {}} 以來沒有變化",
  "admin-center.summary-card.zero-count-end-date": "{startCount, plural, one {從 1 下降，自從 {granularity, select, DAY {{interval, plural, =7 {上週} =30 {1 個月前} other {2 個月前}}} WEEK {{interval} 週前} MONTH {{interval} 個月前} 以來 other {}}} other {從 {startCount} 下降，自從 {granularity, select, DAY {{interval, plural, =7 {上週} =30 {1 個月前} other {2 個月前}}} WEEK {{interval} 週前} MONTH {{interval} 個月前} 以來 other {}}}}",
  "admin-center.summary-card.zero-count-start-date": "自 {granularity, select, DAY {{interval, plural, =7 {上週} =30 {1 個月前} other {2 個月前}}} WEEK {{interval} 週前} MONTH {{interval} 個月前} other {}} 以來已增加",
  "admin-center.user-count-chart.communal-spaces-label": "作用中的使用者總數",
  "admin-center.user-count-chart.cta": "檢視分析",
  "admin-center.user-count-chart.personal-spaces-label": "作用中的訪客使用者",
  "admin-center.user-count-chart.title": "作用中的使用者",
  "admin-center.y-axis-chart.value.aria-label": "選取圖表的 y 軸值",
  "admin-center.y-axis-chart.value.number": "# 數字",
  "admin-center.y-axis-chart.value.number.abbrevation": "＃ 數量",
  "admin-center.y-axis-chart.value.percent": "% 百分比",
  "admin-center.y-axis-chart.value.percent.abbreviation": "% 百分比",
  "admin-side-navigation.back-button.tooltip": "返回",
  "admin-side-navigation.search-input.clear-icon-label": "清除搜尋",
  "admin-side-navigation.search-input.description": "在表單欄位中輸入文字將觸發選項列表",
  "admin-side-navigation.search-input.label": "設定搜尋",
  "admin-side-navigation.search-input.placeholder": "跳到設定...",
  "admin-side-navigation.search-result.number": "{count, plural, =0 {找不到符合您搜尋內容的設定} other {找到 {count} 項設定}}",
  "advanced-search.clear.filter.button.text": "清除所有篩選條件",
  "advanced-search.date.filter.any.time": "隨時",
  "advanced-search.date.filter.custom": "自訂",
  "advanced-search.date.filter.custom.invalid.after.end": "開始日期必須在結束日期之前",
  "advanced-search.date.filter.custom.invalid.after.today": "起始日期不能是未來。",
  "advanced-search.date.filter.from.title": "從",
  "advanced-search.date.filter.last.month": "過去 30 天",
  "advanced-search.date.filter.last.week": "過去 7 天",
  "advanced-search.date.filter.last.year": "過去一年",
  "advanced-search.date.filter.title": "上次更新",
  "advanced-search.date.filter.to.title": "到",
  "advanced-search.date.filter.today": "今天",
  "advanced-search.date.filter.yesterday": "昨天",
  "advanced-search.filter.ancestor.placeholder": "選取內容",
  "advanced-search.filter.ancestor.recentpages": "最近使用的頁面",
  "advanced-search.filter.ancestor.recentpages.livedocs": "最近的頁面和即時文件",
  "advanced-search.filter.contributor.label": "參與者",
  "advanced-search.filter.generic.error-message": "發生錯誤。",
  "advanced-search.filter.labels.label": "標籤",
  "advanced-search.filter.space.label": "空間",
  "advanced-search.filter.title.label": "僅搜尋標題",
  "advanced-search.filter.type.label": "類型",
  "advanced-search.filter.verified.label": "已驗證",
  "advanced-search.header": "搜尋",
  "advanced-search.label.filter.placeholder": "依標籤篩選",
  "advanced-search.labels.filter.no.text": "開始輸入以搜尋標籤",
  "advanced-search.load.more.text": "載入更多",
  "advanced-search.number.results": "顯示 {numberOfResults,number} 筆結果 (共 {totalCount,number} 筆)",
  "advanced-search.opt.out.flag.fps.title": "我們已將您的版本變更為原始搜尋。",
  "advanced-search.opt.out.flag.undo.action": "復原",
  "advanced-search.result.space.icon.label": "{spaceName} 的空間標誌",
  "advanced-search.search.result.attachment.lastmodified": "已上傳",
  "advanced-search.search.result.content.lastmodified": "已更新",
  "advanced-search.search.result.no.result.header": "我們找不到任何符合您搜尋條件的項目。",
  "advanced-search.search.result.no.result.suggestion": "嘗試不同的關鍵字、使用較少的關鍵字，或更普遍的關鍵字。",
  "advanced-search.search.result.xps.error.header": "我們無法取得您的結果",
  "advanced-search.search.result.xps.error.suggestion": "{link}，然後再試一次。",
  "advanced-search.search.result.xps.error.suggestion.link": "請重新整理頁面",
  "advanced-search.search.skip.text.link": "跳至搜尋欄位",
  "advanced-search.space.filter.placeholder": "依空間篩選",
  "advanced-search.textfield.cross.icon.label": "清除搜尋列",
  "advanced-search.textfield.label": "在 Confluence 中搜尋",
  "advanced-search.textfield.placeholder": "輸入關鍵字以尋找頁面、附件等等",
  "advanced-search.textfield.search.icon.label": "搜尋圖示",
  "advanced-search.type.attachment": "附件",
  "advanced-search.type.blogpost": "部落格貼文",
  "advanced-search.type.comments": "留言",
  "advanced-search.type.embed": "智慧連結",
  "advanced-search.type.folders": "資料夾",
  "advanced-search.type.page": "頁面",
  "advanced-search.type.page.livedocs": "頁面和即時文件",
  "advanced-search.type.placeholder": "依類型篩選",
  "advanced-search.type.space": "空間",
  "advanced-search.type.whiteboard": "白板",
  "advanced-search.user.filter.placeholder": "依使用者篩選",
  "advanced-search.verified.filter.placeholder": "尋找經過驗證的內容",
  "advanced-workflows.panel.header.label": "工作流程",
  "ai-comments-summary.combined-comments-summary.inline-comments-header": "內嵌留言",
  "ai-comments-summary.combined-comments-summary.page-comments-header": "頁面留言",
  "ai-comments-summary.combined-comments-summary.page-comments-header.livedocs": "一般留言",
  "ai-comments-summary.comments-summaries-error.combined-error-aup-violation": "Atlassian Intelligence (AI) 無法提供本內容上的留言摘要，因為某些留言可能不符合我們的<a>可接受使用政策</a>。",
  "ai-comments-summary.comments-summaries-error.combined-error-general": "Atlassian Intelligence 目前無法提供摘要。您可以稍後再試一次，或在<a>我們的支援說明文件中</a>深入了解。",
  "ai-comments-summary.comments-summaries-error.combined-error-rate-limit": "我們近期收到過多 Atlassian Intelligence (AI) 要求。請在幾分鐘後再試一次，或<a>參閱 AI 使用過量</a>。",
  "ai-comments-summary.comments-summaries-error.combined-error-too-little-content": "沒有足夠的留言可讓 Atlassian Intelligence (AI) 摘要。請在新增了更多留言時再試一次。",
  "ai-comments-summary.comments-summaries-error.combined-error-too-much-content": "有過多留言需要 Atlassian Intelligence (AI) 摘要。請在留言較少的內容上再試一次。",
  "ai-comments-summary.comments-summaries-error.footer-comments-error-aup-violation": "此摘要僅包含內嵌留言，因為某些頁面留言可能不符合 Atlassian 的<a>可接受使用政策</a>。",
  "ai-comments-summary.comments-summaries-error.footer-comments-error-aup-violation.livedocs": "此摘要僅包含內嵌留言，因為某些一般留言可能不符合 Atlassian 的<a>可接受使用政策</a>。",
  "ai-comments-summary.comments-summaries-error.footer-comments-error-general": "目前沒有頁面留言摘要。您可以稍後再試一次，或在<a>我們的支援說明文件中</a>深入了解。",
  "ai-comments-summary.comments-summaries-error.footer-comments-error-general.livedocs": "目前沒有一般留言的摘要。您可以稍後再試一次，或在<a>我們的支援說明文件中</a>深入了解。",
  "ai-comments-summary.comments-summaries-error.footer-comments-error-rate-limit": "此摘要只包含內嵌留言，因為我們收到了過多 Atlassian Intelligence (AI) 的頁面留言摘要要求。請在幾分鐘後再試一次，或<a>參閱 AI 使用過量</a>。",
  "ai-comments-summary.comments-summaries-error.footer-comments-error-rate-limit.livedocs": "此摘要只包含內嵌留言，因為我們收到了過多 Atlassian Intelligence (AI) 的一般留言摘要要求。請在幾分鐘後再試一次，或<a>參閱 AI 使用過量</a>。",
  "ai-comments-summary.comments-summaries-error.footer-comments-error-too-little-content": "此摘要只包含內嵌留言，因為沒有足夠的頁面留言可讓 Atlassian Intelligence (AI) 摘要。",
  "ai-comments-summary.comments-summaries-error.footer-comments-error-too-little-content.livedocs": "此摘要只包含內嵌留言，因為沒有足夠的一般留言可讓 Atlassian Intelligence (AI) 摘要。",
  "ai-comments-summary.comments-summaries-error.footer-comments-error-too-much-content": "此摘要只包含內嵌留言，因為有過多的頁面留言需要 Atlassian Intelligence (AI) 摘要。",
  "ai-comments-summary.comments-summaries-error.footer-comments-error-too-much-content.livedocs": "此摘要只包含內嵌留言，因為有過多的一般留言需要 Atlassian Intelligence (AI) 摘要。",
  "ai-comments-summary.comments-summaries-error.inline-comments-error-aup-violation": "此摘要僅包含頁面留言，因為某些內嵌留言可能不符合 Atlassian 的<a>可接受使用政策</a>。",
  "ai-comments-summary.comments-summaries-error.inline-comments-error-aup-violation.livedocs": "此摘要僅包含一般留言，因為某些內嵌留言可能不符合 Atlassian 的<a>可接受使用政策</a>。",
  "ai-comments-summary.comments-summaries-error.inline-comments-error-general": "目前沒有內嵌留言摘要。您可以稍後再試一次，或在<a>我們的支援說明文件中</a>深入了解。",
  "ai-comments-summary.comments-summaries-error.inline-comments-error-rate-limit": "此摘要只包含頁面留言，因為我們收到了過多 Atlassian Intelligence (AI) 的內嵌留言摘要要求。請在幾分鐘後再試一次，或<a>參閱 AI 使用過量</a>。",
  "ai-comments-summary.comments-summaries-error.inline-comments-error-rate-limit.livedocs": "此摘要只包含一般留言，因為我們收到了過多 Atlassian Intelligence (AI) 的內嵌留言摘要要求。請在幾分鐘後再試一次，或<a>參閱 AI 使用過量</a>。",
  "ai-comments-summary.comments-summaries-error.inline-comments-error-too-much-content": "此摘要只包含頁面留言，因為有過多的內嵌留言需要 Atlassian Intelligence (AI) 摘要。",
  "ai-comments-summary.comments-summaries-error.inline-comments-error-too-much-content.livedocs": "此摘要只包含一般留言，因為有過多的內嵌留言需要 Atlassian Intelligence (AI) 摘要。",
  "ai-comments-summary.comments-summaries-error.inline-error-too-little-content": "此摘要只包含頁面留言，因為沒有足夠的內嵌留言可讓 Atlassian Intelligence (AI) 摘要。",
  "ai-comments-summary.comments-summaries-error.inline-error-too-little-content.livedocs": "此摘要只包含一般留言，因為沒有足夠的內嵌留言可讓 Atlassian Intelligence (AI) 摘要。",
  "ai-comments-summary.footer-comments-summary-button-inline-experiment.label.text": "摘要留言",
  "ai-comments-summary.footer-comments-summary-button-placeholder.label.text": "摘要頁面留言",
  "ai-comments-summary.footer-comments-summary-button-placeholder.label.text.livedocs": "摘要一般留言",
  "ai-comments-summary.footer-comments-summary-button.label.text.livedocs": "摘要一般留言",
  "ai-common.common-error.general-error": "Atlassian Intelligence 目前無法提供回應。請參閱<a>我們的支援說明文件</a>。",
  "ai-common.common-error.not-enough-content": "這裡沒有足夠的內容可以提供摘要。請新增更多內容並再試一次。",
  "ai-common.common-error.rate-limit": "我們發現 Atlassian Intelligence 使用過量。請稍後再試一次。請參閱<a>我們的支援說明文件</a>。",
  "ai-common.page-error.aup-violation": "您的內容可能不符合我們的《可接受使用政策》。如有需要，請查看並參閱我們的<a>《可接受使用政策》</a>。",
  "ai-common.page-error.too-much-content": "Atlassian Intelligence 目前無法為您產生摘要，因為需要摘要的內容太多。",
  "ai-content-actions.menu.item.label.ai-presentation-generation": "以簡報重新撰寫",
  "ai-content-actions.menu.item.label.bulk-issue-create": "建立 Jira 議題",
  "ai-content-actions.menu.item.label.bulk-issue-create-issue-term-refresh": "建立 Jira 工作項目",
  "ai-content-actions.menu.item.label.inline-comments": "摘要留言",
  "ai-content-actions.menu.item.label.page-catchup": "摘要變更",
  "ai-content-actions.menu.item.label.quick-summary": "摘要",
  "ai-content-actions.menu.item.lozenge.beta": "測試版",
  "ai-content-actions.popup-trigger.aria-text": "AI 動作選單",
  "ai-floating-context-menu.admin.opt-in.dialog.body.text": "<a>透過 Atlassian Intelligence</a> 閱讀 AL 產生的摘要，而非整個頁面，藉此為團隊節省時間。<br></br><br></br>為 Atlassian 管理的使用者啟動 Atlassian Intelligence 功能。",
  "ai-floating-context-menu.ai-button-changeboarding.body.text": "探索頁面和留言摘要等 AI 功能，協助您提升工作方式。",
  "ai-floating-context-menu.ai-button-changeboarding.dismiss.button": "知道了",
  "ai-floating-context-menu.ai-button-changeboarding.got-it.button": "知道了",
  "ai-floating-context-menu.ai-button-changeboarding.heading": "利用 Atlassian Intelligence 提升您的工作效率",
  "ai-floating-context-menu.ai-button-changeboarding.x-button-label": "關閉",
  "ai-floating-context-menu.create.section.label": "建立",
  "ai-floating-context-menu.floating-context-menu-button.logo-alt-text": "Atlassian Intelligence",
  "ai-floating-context-menu.menu.item.label.ai-presentation-generation": "以簡報重新撰寫",
  "ai-floating-context-menu.menu.item.label.audio-summary": "聆聽頁面摘要",
  "ai-floating-context-menu.menu.item.label.bulk-issue-create": "建立 Jira 議題",
  "ai-floating-context-menu.menu.item.label.bulk-work-items-create": "建立 Jira 工作項目",
  "ai-floating-context-menu.menu.item.label.inline-comments": "總結留言",
  "ai-floating-context-menu.menu.item.label.page-catchup": "總結變更",
  "ai-floating-context-menu.menu.item.lozenge.beta": "測試版",
  "ai-floating-context-menu.opt-in.dialog.header.text": "事半功倍",
  "ai-floating-context-menu.summarize.section.label": "總結",
  "ai-presentation-generation.configuration.add-emojis.label": "將表情符號新增至區段標題",
  "ai-presentation-generation.configuration.generate-button": "產生演講者筆記",
  "ai-presentation-generation.configuration.goal.example.experiment": "與工程團隊分享詳細的實驗結果",
  "ai-presentation-generation.configuration.goal.example.label": "範例：",
  "ai-presentation-generation.configuration.goal.example.overview": "為新的團隊成員建立整體概觀",
  "ai-presentation-generation.configuration.goal.example.pitch": "向客戶提議新功能",
  "ai-presentation-generation.configuration.goal.example.update": "為領導團隊撰寫簡短的狀態更新",
  "ai-presentation-generation.configuration.goal.title": "您的目標是什麼？",
  "ai-presentation-generation.configuration.level-of-detail.high.label": "高",
  "ai-presentation-generation.configuration.level-of-detail.label": "詳細等級",
  "ai-presentation-generation.configuration.level-of-detail.low.label": "低",
  "ai-presentation-generation.configuration.level-of-detail.medium.label": "中",
  "ai-presentation-generation.configuration.options.label": "更多選項",
  "ai-presentation-generation.configuration.original-headings.label": "將原始文件標題保留為區段標題",
  "ai-presentation-generation.configuration.slides.helper": "總共會建立 {slideCount} 張投影片",
  "ai-presentation-generation.configuration.slides.helper.default": "選取介於 2 和 20 之間的數字",
  "ai-presentation-generation.configuration.slides.label": "投影片數量",
  "ai-presentation-generation.configuration.title": "自訂演講者筆記",
  "ai-presentation-generation.creation.error.description": "我們目前無法從這份簡報建立頁面，請稍後再試一次。",
  "ai-presentation-generation.creation.error.title": "尚未建立簡報頁面",
  "ai-presentation-generation.error.aup-violation-error": "政策合規性",
  "ai-presentation-generation.error.general-error": "沒有回應",
  "ai-presentation-generation.error.rate-limit-error": "過度使用",
  "ai-presentation-generation.footer.footer-actions.back-button": "返回",
  "ai-presentation-generation.footer.footer-actions.cancel-button": "取消",
  "ai-presentation-generation.footer.footer-actions.create-button": "建立簡報",
  "ai-presentation-generation.footer.footer-actions.go-back-button": "返回",
  "ai-presentation-generation.modal.header.subtext": "選取<b>建立簡報</b>，將此預覽儲存為目前頁面的子項，您可以像其他 Confluence 頁面一樣加以編輯。",
  "ai-presentation-generation.modal.header.title": "「{presentationTitle}」預覽",
  "ai-presentation-generation.slide.drag-handle-button-label": "拖曳以重新排序 {slideTitle}",
  "ai-presentation-generation.stream-loading.alt-text": "正在產生簡報",
  "ai-presentation-generation.stream-loading.title": "Atlassian Intelligence 運作中...",
  "ai-suggested-image-header.suggestingAHeaderImage": "尋找相符的標頭圖片",
  "annotation-provider-inline-comments.close.icon.tooltip": "關閉側邊欄",
  "annotation-provider-inline-comments.closeCommentBox": "關閉內嵌留言",
  "annotation-provider-inline-comments.comment.sidebar.announcement": "已顯示留言側邊欄，使用 Shift + Tab 鍵即可觸及留言側邊欄",
  "annotation-provider-inline-comments.comment.sidebar.label": "留言側邊欄",
  "annotation-provider-inline-comments.could.not.delete.title": "無法刪除留言",
  "annotation-provider-inline-comments.create.error.unable.to.apply.description": "我們無法顯示您的留言。若要檢視，請立即重新整理。",
  "annotation-provider-inline-comments.create.error.unable.to.apply.title": "發生錯誤",
  "annotation-provider-inline-comments.error.comment.load.message": "載入此留言時發生問題。請重新整理以檢視最新更新。",
  "annotation-provider-inline-comments.error.comment.load.title": "無法載入留言",
  "annotation-provider-inline-comments.refresh.content.link": "重新整理內容",
  "annotation-provider-inline-comments.view-all.button.text": "全部檢視",
  "anonymous-access.anonymous-access-side-nav-message.close": "關閉",
  "anonymous-access.anonymous-access-side-nav-message.text": "您正在以匿名存取權檢視，因此某些內容可能會被封鎖。",
  "app-navigation.app-switcher-nudge-tooltip.heading": "已新增產品",
  "app-navigation.app-switcher-nudge-tooltip.jpd-content": "您團隊中的某人剛剛開始使用 Jira Product Discovery。已免費新增到您的網站。",
  "app-navigation.app-switcher-nudge-tooltip.jpd-primary-button-text": "顯示詳細資料",
  "app-navigation.app-switcher-nudge-tooltip.jsm-content": "您團隊中的某人剛剛開始使用 Jira Service Management。已免費新增到您的網站。",
  "app-navigation.app-switcher-nudge-tooltip.jsm-primary-button-text": "進行導覽",
  "app-navigation.app-switcher-nudge-tooltip.secondary-action": "關閉",
  "app-navigation.app-switcher.label": "切換至其他 Atlassian 服務",
  "app-navigation.app-switcher.tooltip": "切換至...",
  "app-navigation.apps.app-audit-logs": "應用程式稽核記錄",
  "app-navigation.apps.app-promotions": "推廣",
  "app-navigation.apps.app-requests": "檢視應用程式要求",
  "app-navigation.apps.discover.title": "熱門應用程式",
  "app-navigation.apps.empty": "當您或您的管理員安裝應用程式後，應用程式就會顯示在此處。",
  "app-navigation.apps.find-new-apps": "尋找新的應用程式",
  "app-navigation.apps.installed-apps": "您的應用程式",
  "app-navigation.apps.learn-more": "深入瞭解",
  "app-navigation.apps.link": "應用程式",
  "app-navigation.apps.manage": "管理應用程式",
  "app-navigation.company-hub.link": "公司中心",
  "app-navigation.create.button": "建立",
  "app-navigation.cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-close-button-text": "關閉",
  "app-navigation.cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-notification-text": "當團隊中的某人要求新產品時，現在這裡會向您顯示通知。",
  "app-navigation.cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-view-requests-button-text": "檢視要求",
  "app-navigation.custom.home.link": "自訂首頁",
  "app-navigation.editor-onboarding.nudge.tooltip": "需要回到草稿嗎？可以在「<b>最近</b>」索引標籤中找到。",
  "app-navigation.editor-onboarding.nudge.tooltip.live-pages": "需要返回頁面嗎？可以在<b>最近</b>分頁中找到。",
  "app-navigation.editor-onboarding.nudge.tooltip.live-pages.livedocs": "需要返回頁面或即時文件嗎？可以在<b>最近</b>分頁中找到。",
  "app-navigation.help.tooltip": "說明",
  "app-navigation.home.link": "首頁",
  "app-navigation.more.dropdown.label": "更多",
  "app-navigation.nav4-opt-out-spotlight.content": "按一下您的頭像，然後選取「開啟新導覽」以再試一次。",
  "app-navigation.nav4-opt-out-spotlight.heading": "重新啟用新版導覽",
  "app-navigation.nav4-opt-out-spotlight.ok": "確定",
  "app-navigation.navigation.region.aria.label": "全域",
  "app-navigation.notes.close.tooltip": "關閉",
  "app-navigation.notes.icon.label": "私人筆記",
  "app-navigation.notes.tooltip": "私人筆記",
  "app-navigation.notifications.error.message": "我們目前無法顯示您的通知。請重新整理或稍後再試一次。",
  "app-navigation.notifications.error.title": "發生錯誤",
  "app-navigation.notifications.link": "通知 {unreadCount}",
  "app-navigation.notifications.saveReplySuccessFlagActionBlogpost": "在部落格上檢視",
  "app-navigation.notifications.saveReplySuccessFlagActionDatabase": "在資料庫中檢視",
  "app-navigation.notifications.saveReplySuccessFlagActionLiveDoc": "在即時文件上檢視",
  "app-navigation.notifications.saveReplySuccessFlagActionPage": "在頁面上檢視",
  "app-navigation.notifications.saveReplySuccessFlagActionWhiteboard": "在白板上檢視",
  "app-navigation.notifications.saveReplySuccessFlagTitle": "留言已儲存成功",
  "app-navigation.onboarding.nudge.body": "透過選取 {helpEmoji} 圖示來尋找其他協助。",
  "app-navigation.people-nav-item-nudge-tooltip.v2": "從「<b>人員</b>」選單邀請團隊成員，立即與他們一起完成重大事項。",
  "app-navigation.people.nudge.heading.v2": "在此新增人員",
  "app-navigation.product-link.label": "Confluence 首頁",
  "app-navigation.profile.guest-lozenge": "訪客",
  "app-navigation.profile.label": "您的個人檔案和喜好設定",
  "app-navigation.recent.link": "最近存取過的項目",
  "app-navigation.settings.name": "Confluence 管理",
  "app-navigation.shortcuts.flags.liveDocsNotEnabled.action": "深入了解",
  "app-navigation.shortcuts.flags.liveDocsNotEnabled.description": "若要使用這個快速鍵，您的空間管理員需要啟用即時文件。",
  "app-navigation.shortcuts.flags.liveDocsNotEnabled.title": "在此空間中並未啟用即時文件",
  "app-navigation.sign.in.tooltip": "登入",
  "app-navigation.spaces.link": "空間",
  "app-navigation.templates.link": "範本",
  "app-navigation.top-navigation.account.label": "帳號",
  "app-navigation.top-navigation.app-switcher": "切換網站或應用程式",
  "app-navigation.top-navigation.create": "建立",
  "app-navigation.top-navigation.help": "說明",
  "app-navigation.top-navigation.login": "登入",
  "app-navigation.top-navigation.notifications": "{count, plural, =0 {通知} other {{count,number} 項通知}}",
  "app-navigation.top-navigation.notifications.over-nine-notifications": "超過 9 項通知",
  "app-navigation.top-navigation.profile.guest-label": "帳戶 (訪客)",
  "app-navigation.top-navigation.settings": "Confluence 管理",
  "app-navigation.top-navigation.side-nav-toggle-button-collapse-label": "摺疊側邊欄",
  "app-navigation.top-navigation.side-nav-toggle-button-expand-label": "展開側邊欄",
  "app-navigation.your-work.link": "您的工作",
  "app-referentiality.connections-panel.action-menu.disconnect.title": "中斷連結",
  "app-referentiality.connections-panel.action-menu.go-to-source.title": "前往來源",
  "app-referentiality.connections-panel.action-menu.go-to-target.title": "前往目標",
  "app-referentiality.connections-panel.action-menu.label": "更多動作",
  "app-referentiality.connections-panel.disconnect.confirmation-dialog.action-button-title": "中斷連結",
  "app-referentiality.connections-panel.disconnect.confirmation-dialog.cancel-button-title": "取消",
  "app-referentiality.connections-panel.disconnect.confirmation-dialog.title": "中斷與元素的連結",
  "app-referentiality.connections-panel.disconnect.confirmation-flag.description": "其他連結的巨集可能會中斷。",
  "app-referentiality.connections-panel.disconnect.source.confirmation-dialog.description": "如果中斷與此元素的連結，可能會清除以下元素中已連結的資料：",
  "app-referentiality.connections-panel.disconnect.source.confirmation-flag.title": "作為來源的 {nodeTitle} 已中斷連結",
  "app-referentiality.connections-panel.disconnect.target.confirmation-flag.title": "作為目標的 {nodeTitle} 已中斷連結",
  "app-referentiality.connections-panel.error.body": "請重新整理，然後再試一次。",
  "app-referentiality.connections-panel.error.title": "我們無法載入內容",
  "app-referentiality.connections-panel.errorFlag.body": "請再試一次，或立即重新整理。",
  "app-referentiality.connections-panel.errorFlag.title": "我們無法完成您的動作",
  "app-referentiality.connections-panel.header.closeLabel": "關閉連結面板",
  "app-referentiality.connections-panel.heading": "已連結的資料",
  "app-referentiality.connections-panel.nested.elements.message": "{number, plural, other {{number,number} 個巢狀元素}}",
  "app-referentiality.connections-panel.replace.confirmation-dialog.action-button-title": "取代",
  "app-referentiality.connections-panel.replace.confirmation-dialog.message": "如果取代此元素，其連結將會中斷並清除以下元素中連結的資料：",
  "app-referentiality.connections-panel.replace.confirmation-dialog.title": "取代已連結的元素",
  "app-referentiality.connections-panel.replace.element.flag.message": "{newNodeName} 現在已連結到 {activeNodeName}",
  "app-referentiality.connections-panel.targets-component.add-button": "新增目標",
  "app-referentiality.connections-panel.targets-component.add-label": "新增目標",
  "app-referentiality.connections-panel.targets-component.max-targets-inline-header": "已達到上限",
  "app-referentiality.connections-panel.targets-component.max-targets-inline-message": "每個元素最多可以連結 4 個其他元素。",
  "app-referentiality.connections-panel.targets-component.targets-title": "將資料傳送至",
  "app-referentiality.connections-panel.undoActionTitle": "復原",
  "app-referentiality.provider.toolbar.item.label": "管理已連結的資料",
  "app-referentiality.source.add-source": "新增來源",
  "app-referentiality.source.insertMenu.active-node-component-title": "此選取項目",
  "app-referentiality.source.insertMenu.existing-macro-no-options-warning": "沒有相容的來源",
  "app-referentiality.source.insertMenu.existing-macro-section-doc-title": "在此文件上",
  "app-referentiality.source.insertMenu.existing-macro-section-title": "此頁面內容",
  "app-referentiality.source.insertMenu.new-macro.native-table": "表格",
  "app-referentiality.source.insertMenu.new-macro.native-table-description": "新增表格",
  "app-referentiality.source.insertMenu.new-macro.section-title": "全新",
  "app-referentiality.source.insertMenu.source-component-title": "取得資料來源：",
  "app-referentiality.source.insertMenu.source-placeholder-text": "選取來源",
  "app-referentiality.source.no-compatible-source.footer": "深入了解。",
  "app-referentiality.source.no-compatible-source.text": "新增來源或將資料新增至來源。",
  "app-referentiality.source.no-compatible-source.title": "沒有相容的來源。",
  "app-referentiality.target.dependents-collapse-button-label": "摺疊目標節點列表",
  "app-referentiality.target.dependents-expand-button-label": "展開目標節點列表",
  "app-referentiality.target.dependents-tree-title": "使用者：",
  "app-referentiality.target.insertMenu.existing-macro-no-options-warning": "沒有相容的目標",
  "app-referentiality.target.insertMenu.new-macro.native-chart": "圖表",
  "app-referentiality.target.insertMenu.new-macro.native-chart-description": "新增圖表",
  "app-referentiality.target.insertMenu.target-placeholder-text": "選取目標",
  "app-referentiality.targets-component.limit-reached.text": "您最多可以將 6 個元素連結在一起。",
  "app-referentiality.targets-component.limit-reached.title": "已達到上限。",
  "app-referentiality.targets-component.no-available-target.footer": "深入了解。",
  "app-referentiality.targets-component.no-available-target.text": "將目標新增至此內容",
  "app-referentiality.targets-component.no-available-target.title": "沒有可用的目標。",
  "app-suggestions.appcard.learnmore.link": "深入瞭解",
  "app-suggestions.container.no-match-found": "沒有任何項目符合您的搜尋內容",
  "app-suggestions.marketplace-banner.body-text": "您的管理員可以安裝新的應用程式以供您的團隊使用。",
  "app-suggestions.marketplace-banner.discover-header": "探索適用於 Confluence 的新應用程式",
  "app-suggestions.marketplace-banner.explore-link": "探索 Atlassian Marketplace",
  "archive-pages.add-note.dialog.title": "新增備註",
  "archive-pages.allow-page-nested.archive.dialog.checkbox.description.generic": "{count, plural, other {「{title}」有 {count} 個巢狀項目。如果您想要一併將其封存，請勾選此方塊。}}",
  "archive-pages.allow-page-nested.archive.no-permission.dialog.description.M2": "{count, plural, other {「{title}」有 {count} 個巢狀項目。}}",
  "archive-pages.allow-page-nested.archive.selection-limit-reached.dialog.description.v2": "{count, plural, other {「{title}」有 {count} 個巢狀項目。}}",
  "archive-pages.allow-page-nested.unarchive.dialog.radio.description.message": "{count, plural, other {「{title}」有 {count} 個巢狀項目。您要復原整個分支嗎？}}",
  "archive-pages.allow-page-nested.unarchive.no-permission.dialog.description": "{count, plural, other {「{title}」有 {count} 個巢狀項目。}}",
  "archive-pages.allow-page-nested.unarchive.selection-limit-reached.dialog.description": "{count, plural, other {「{title}」有 {count} 個巢狀項目。無法復原 - 一次只能移動 500 個項目。}}",
  "archive-pages.archive-nested-message.M2": "包含巢狀項目",
  "archive-pages.archive-nested-pages.dialog.button.archive": "封存",
  "archive-pages.archive-nested-pages.dialog.selection-limit-reached.button.archive": "封存父系頁面",
  "archive-pages.archive-nested-pages.dialog.selection-limit-reached.button.unarchive": "還原父系",
  "archive-pages.archive-upsell-dialog.admin-message": "內容樹狀結構太混亂嗎？解鎖封存以保持整齊並維持在最新狀態",
  "archive-pages.archive-upsell-dialog.closeButton": "關閉",
  "archive-pages.archive-upsell-dialog.decline": "返回",
  "archive-pages.archive-upsell-dialog.footer": "Confluence Free 方案上無法使用封存功能。",
  "archive-pages.archive-upsell-dialog.from-delete-dialog.message": "您可以透過封存此內容來整理空間，無須將內容永久刪除。",
  "archive-pages.archive-upsell-dialog.title.generic": "封存內容",
  "archive-pages.archive-upsell-dialog.user-message.generic": "解鎖封存功能，以使空間保持整齊和最新狀態。",
  "archive-pages.archive.dialog.button.archive": "仍要封存",
  "archive-pages.archive.dialog.button.cancel": "取消",
  "archive-pages.archive.dialog.note.apply-note-to-nested-message": "將附註一併新增至巢狀項目",
  "archive-pages.archive.dialog.note.character-limit-error-message": "您已超過字元數上限。",
  "archive-pages.archive.dialog.note.placeholder": "讓其他人知道為什麼要封存這個頁面。",
  "archive-pages.archive.dialog.note.title": "附註 (選擇性)",
  "archive-pages.archive.error.bulk-queue-busy": "您的團隊正在處理大量項目。佇列有時間清除後，請<b>稍後再試一次</b>。{lineBreak} {lineBreak} 如果這種情況繼續發生，請嘗試連絡 {supportLink}。",
  "archive-pages.archive.error.invalid-content-ids": "您的封存要求包含疑似不存在的項目。請檢查您的選項並再次嘗試封存。{lineBreak} {lineBreak} 如果這種情況繼續發生，請嘗試連絡 {supportLink}。",
  "archive-pages.archive.error.invalid-content-status": "您選取的一個或多個項目無法封存，因為是草稿、已封存或已刪除。",
  "archive-pages.archive.error.invalid-perimissions.body": "您的封存要求包含您沒有權限封存的項目。請檢查您的選項並再次嘗試封存。",
  "archive-pages.archive.error.long-task-timeout": "處理您的要求花費了比平常更久的時間。請稍後返回查看是否處理完成。",
  "archive-pages.archive.single.dialog.button.archive": "封存",
  "archive-pages.archive.single.dialog.button.next": "下一步",
  "archive-pages.bulk-archive.dialog.body.1-generic": "這會從內容樹狀結構將其移回封存。您仍然可以檢視封存中的內容。",
  "archive-pages.bulk-archive.dialog.body.2-generic": "任何父系-子系階層都會保留下來。",
  "archive-pages.bulk-archive.dialog.button.archive": "封存",
  "archive-pages.bulk-archive.dialog.button.cancel": "取消",
  "archive-pages.bulk-archive.dialog.checkbox-label": "不再顯示此內容",
  "archive-pages.bulk-archive.dialog.inherited-restrictions-warning.message": "請檢閱您的選取範圍，以查看哪些項目正在繼承限制。封存後，此空間中的任何人都將可以檢視。<a>進一步了解繼承限制</a>",
  "archive-pages.bulk-archive.dialog.inherited-restrictions-warning.title": "某些封存項目的存取權將會變更",
  "archive-pages.bulk-archive.dialog.own-restrictions-warning.message": "這些項目受到您要封存的項目限制。封存之後，其存取權將以內容樹狀結構中的新位置為根據。<a>進一步了解繼承限制</a>",
  "archive-pages.bulk-archive.dialog.own-restrictions-warning.title": "對剩餘巢狀項目的存取權將會變更",
  "archive-pages.bulk-archive.dialog.title-generic": "{count, plural, other {封存 {count} 個項目}}",
  "archive-pages.bulk-archive.flag.refresh.link-text": "重新整理",
  "archive-pages.content-banner.message-restorable": "此內容已封存。請還原以進行變更。",
  "archive-pages.content-banner.message-unrestorable": "此內容已封存。",
  "archive-pages.content-nested.archive.cannot-archive-nested-items.message": "您沒有封存所有巢狀項目的權限。這些項目會在內容樹狀結構中向上移動。<a>為什麼我無法封存巢狀項目？</a>",
  "archive-pages.content-nested.archive.cannot-archive-nested-items.title": "巢狀項目不會封存",
  "archive-pages.content-nested.archive.limited-permission.message.V2": "您沒有封存某些巢狀項目的權限。這些項目會在內容樹狀結構中向上移動。<a>為什麼我無法封存巢狀項目？</a>",
  "archive-pages.content-nested.archive.limited-permission.title.V2": "{countNonArchivableNestedPages, plural, other {有 {countNonArchivableNestedPages} 個巢狀項目不會封存}}",
  "archive-pages.content-nested.archive.selection-limit-reached.message.v2": "一次只能移動 500 個項目。請選取較小的分支，將父系和巢狀項目封存在一起。",
  "archive-pages.content-nested.unarchive.cannot-restore-nested-items.message": "您沒有復原所有巢狀項目的權限。這些項目會在封存中向上移動。<a>為什麼我無法復原巢狀項目？</a>",
  "archive-pages.content-nested.unarchive.cannot-restore-nested-items.title": "巢狀項目不會復原",
  "archive-pages.content-nested.unarchive.limited-permission.message.V2": "您沒有復原某些巢狀項目的權限。這些項目會在封存中向上移動。<a>為什麼我無法復原巢狀項目？</a>",
  "archive-pages.content-nested.unarchive.limited-permission.message.link.aria-description": "復原封存的項目 - 在新分頁中開啟連結",
  "archive-pages.content-nested.unarchive.limited-permission.title.V2": "{count, plural, other {有 {count} 個巢狀項目無法復原}}",
  "archive-pages.content-nested.unarchive.selection-limit-reached.message.V2": "一次只能移動 500 個項目。請選取較小的分支，將父系和巢狀項目一起復原。",
  "archive-pages.content-nested.unarchive.selection-limit-reached.title.V2": "巢狀項目不會復原",
  "archive-pages.dialog.archive.inherited-restrictions.info.link.aria-description": "繼承的檢視限制 - 在新分頁中開啟連結",
  "archive-pages.dialog.button.add-note": "新增",
  "archive-pages.dialog.button.cancel": "取消",
  "archive-pages.dialog.button.update-note": "更新",
  "archive-pages.dialog.delete.inherited-restrictions.info.link.aria-description": "繼承的檢視限制 - 在新分頁中開啟連結",
  "archive-pages.drafts-archive-message": "*草稿無法封存",
  "archive-pages.nested-content-tree.archive.limited-permissions": "您沒有封存一或多個巢狀項目的權限。",
  "archive-pages.nested-content-tree.error.title": "我們無法載入整個內容的樹狀結構",
  "archive-pages.nested-content-tree.nested-content-column": "內容",
  "archive-pages.nested-content-tree.restore.limited-permissions": "您沒有復原一個或多個巢狀項目的權限。",
  "archive-pages.nested-page-tree.archive-permissions-column": "封存的權限",
  "archive-pages.nested-page-tree.can-archive": "您具有封存的權限",
  "archive-pages.nested-page-tree.no-permission": "您沒有封存的權限",
  "archive-pages.nested-pages.archive.dialog.title.generic.M2": "封存父系項目",
  "archive-pages.page-banner.link.learn-more": "深入了解",
  "archive-pages.page-banner.link.unarchive": "還原",
  "archive-pages.page-banner.note.actions.add-note": "新增備註",
  "archive-pages.page-banner.note.actions.cancel-note": "取消",
  "archive-pages.page-banner.note.actions.edit-note": "編輯備註",
  "archive-pages.page-banner.note.actions.save-note": "新增",
  "archive-pages.page-banner.note.actions.show-less": "顯示較少",
  "archive-pages.page-banner.note.actions.show-more": "顯示更多",
  "archive-pages.page-banner.note.actions.update-note": "更新",
  "archive-pages.page-banner.note.creation.error.description": "請再試一次。如果此問題持續發生，請連絡{supportLink}或您的空間管理員。",
  "archive-pages.page-banner.note.creation.error.title": "我們無法新增您的附註",
  "archive-pages.page-banner.note.creation.success.title": "已新增附註",
  "archive-pages.page-banner.note.update.error.title": "我們無法編輯您的附註",
  "archive-pages.page-banner.note.update.success.title": "已編輯附註",
  "archive-pages.page-nested.allow.unarchive.dialog.title.v2": "{count, plural, other {復原父系內容}}",
  "archive-pages.page-nested.archive.dialog.description": "封存「{title}」可能會變更誰可以查看底下的巢狀項目。",
  "archive-pages.page-nested.archive.dialog.restrictions-warnings-enabled.description": "「{title}」將會封存，但其巢狀項目將保留在內容樹狀結構中。",
  "archive-pages.page-nested.parent-selector.archive.dialog.description": "{count, plural, =0 {「{title}」} other {「{title}」(包括 {count,number} 個巢狀項目)}}",
  "archive-pages.page-nested.unarchive.dialog.body": "還原「{title}」可能會變更誰可以查看底下的巢狀項目。",
  "archive-pages.page-nested.unarchive.dialog.button.cancel": "取消",
  "archive-pages.page-nested.unarchive.dialog.button.continue": "繼續",
  "archive-pages.page-nested.unarchive.dialog.title": "這是其他內容項目的父系項目",
  "archive-pages.restore-nested-message": "{count, plural, other {復原 {count} 個巢狀項目}}",
  "archive-pages.restrictions-warning.children-only.own-restrictions.message": "這些項目受到您要封存的父系限制。封存之後，其存取權將以在內容樹狀結構中的新位置為根據。<a>進一步了解繼承限制</a>",
  "archive-pages.restrictions-warning.children-only.own-restrictions.title": "對剩餘巢狀項目的存取權將會變更",
  "archive-pages.restrictions-warning.page-and-children.inherited-restrictions.message": "這些項目受到父系限制。封存後，則不會套用這些限制。<a>進一步了解繼承限制</a>",
  "archive-pages.restrictions-warning.page-and-children.inherited-restrictions.title": "封存項目的存取權將會變更",
  "archive-pages.restrictions-warning.page-only.inherited-restrictions.message": "此項目受父系限制。封存後，則不會套用這些限制。<a>進一步了解繼承限制</a>",
  "archive-pages.restrictions-warning.page-only.inherited-restrictions.title": "封存項目的存取權將會變更",
  "archive-pages.single-content.archive.flag.failure.body": "您的團隊正在處理大量項目。請在佇列有時間清除之後{tryLater}。{lineBreak}{lineBreak}如果這種情況持續發生，請嘗試連絡{supportLink}。",
  "archive-pages.single-content.archive.flag.failure.title": "您的封存要求發生問題",
  "archive-pages.single-content.archive.flag.progress.title": "正在封存...",
  "archive-pages.single-content.archive.flag.success.link-text": "在封存中檢視",
  "archive-pages.single-content.archive.flag.success.title": "已成功封存",
  "archive-pages.single-content.unarchive.flag.failure.body": "您的團隊正在處理大量項目。請在佇列有時間清除之後{tryLater}。{lineBreak}{lineBreak}如果這種情況持續發生，請嘗試連絡{supportLink}。",
  "archive-pages.single-content.unarchive.flag.failure.title": "您的復原要求發生問題",
  "archive-pages.single-content.unarchive.flag.progress.title": "正在還原...",
  "archive-pages.single-content.unarchive.flag.success.link-text": "檢視",
  "archive-pages.single-content.unarchive.flag.success.title": "已成功還原",
  "archive-pages.single-page.flag.failure.try-later": "於稍後再試一次",
  "archive-pages.single-page.unarchive.dialog.button.unarchive": "還原",
  "archive-pages.single-page.unarchive.dialog.title": "選擇目的地",
  "archive-pages.single-page.unarchive.last-parent-page": "最近使用的父系",
  "archive-pages.single.archive.dialog.title.v2": "封存項目",
  "archive-pages.unarchive.error.invalid-content-ids": "您的復原要求包含疑似不存在的項目。請檢查您的選項並再次嘗試復原。{lineBreak} {lineBreak} 如果這種情況繼續發生，請嘗試連絡 {supportLink}。",
  "archive-pages.unarchive.error.invalid-perimissions.body": "您的復原要求包含您沒有權限復原的項目。請檢查您的選項，然後再次嘗試復原。",
  "archive-pages.unarchive.restrictions.inherited.no-children.message": "此項目受父系限制。復原之後，其存取權將以在內容樹狀結構中的新位置為根據。<a>進一步了解繼承限制</a>",
  "archive-pages.unarchive.restrictions.inherited.no-children.title": "對此項目的存取權將會變更",
  "archive-pages.unarchive.restrictions.inherited.with-children.message": "這些項目受到父系限制。復原之後，其存取權將以在內容樹狀結構中的新位置為根據。<a>進一步了解繼承限制</a>",
  "archive-pages.unarchive.restrictions.inherited.with-children.title": "復原項目的存取權將會變更",
  "archive-pages.unarchive.restrictions.own.no-children.message": "這些項目受到您要復原的父系限制。復原之後，其存取權將以封存中的新位置為根據。<a>進一步了解繼承限制</a>",
  "archive-pages.unarchive.restrictions.own.no-children.title": "對剩餘巢狀項目的存取權將會變更",
  "archive-pages.update-note.dialog.title": "編輯備註",
  "archive-pages.without-nested-pages.archive.dialog.title": "這是其他內容項目的父系項目",
  "archive-space.archive.error": "封存空間時發生錯誤。請再試一次。",
  "archive-space.archive.space.dialog.button": "封存空間",
  "archive-space.archive.space.learn.more.link": "深入瞭解",
  "archive-space.archive.status.first.description": "此空間已封存。您目前無法在基本網站導覽和搜尋中看到此空間與其內容。",
  "archive-space.archive.status.second.description": "還原此空間以返回作用中狀態。",
  "archive-space.archive.success": "已封存空間",
  "archive-space.current.status.description": "封存空間會將其從基本網站導覽中隱藏，進而降低畫面的雜亂感，讓使用者能更輕鬆找到最新和相關的內容。如果之後有需要，您隨時都能夠尋找已封存的空間，而且可以隨時還原該空間。",
  "archive-space.modal.archive.button": "封存",
  "archive-space.modal.body.description": "若要再次尋找，您只需查看空間目錄的 [已封存空間] 區段即可。",
  "archive-space.modal.cancel.button": "取消",
  "archive-space.modal.header": "封存",
  "archive-space.restore.error": "還原空間時發生錯誤。請再試一次。",
  "archive-space.restore.space.button": "還原空間",
  "archive-space.restore.success": "已還原空間",
  "archived-pages-list..upgrade-banner.button-text": "升級",
  "archived-pages-list..upgrade-banner.message": "若要復原任何封存的項目或封存更多內容，請升級至付費方案。",
  "archived-pages-list.bulk-note.dialog.add-button": "新增",
  "archived-pages-list.bulk-note.dialog.cancel-button": "取消",
  "archived-pages-list.bulk-note.dialog.description1": "此附註將新增到所有選取的項目，包括任何子項目。",
  "archived-pages-list.bulk-note.dialog.description2": "如果已經有附註，將會透過這個新的附註更新。附註一旦更新，就無法復原。",
  "archived-pages-list.bulk-note.dialog.error.message": "我們目前無法更新您的附註。請稍後再試一次。",
  "archived-pages-list.bulk-note.dialog.error.title": "發生錯誤",
  "archived-pages-list.bulk-note.dialog.loading.title": "正在編輯附註...",
  "archived-pages-list.bulk-note.dialog.success.title": "已編輯附註",
  "archived-pages-list.bulk-note.dialog.title": "{count, plural, other {在 {count} 個項目上新增或編輯備註}}",
  "archived-pages-list.cta.note.selection-limit-reached.text": "{count, plural, other {您一次只能將一個附註新增至 {count,number} 個項目。取消選取項目即可新增附註。}}",
  "archived-pages-list.cta.note.text": "附註",
  "archived-pages-list.page-list-container.checkbox.hidden.info": "如果啟用表格中的「核取方塊」，即會更新上方的內容。",
  "archived-pages-list.page-list-container.title.content": "已封存",
  "archived-pages-list.page-list-container.title.page": "封存的內容",
  "archived-pages-list.page-list.column-header.archived-by": "封存者",
  "archived-pages-list.page-list.column-header.date-archived": "封存日期",
  "archived-pages-list.page-list.column-header.note": "附註",
  "archived-pages-list.quick-action.add-note": "新增附註",
  "archived-pages-list.quick-action.delete": "刪除",
  "archived-pages-list.quick-action.edit-note": "編輯附註",
  "archived-pages-list.quick-action.restore": "還原",
  "attachments.view-attachments-button": "檢視附件",
  "audio.audio-briefing-popup.briefing-byline-casual-description": "休閒",
  "audio.audio-briefing-popup.briefing-byline-detail-description": "整體概觀",
  "audio.audio-briefing-popup.briefing-title": "簡述：{contentTitle}",
  "audio.audio-briefing-popup.close-label": "關閉",
  "audio.audio-briefing-popup.customize-tab": "自訂",
  "audio.audio-briefing-popup.customize-tab.apply": "套用自訂",
  "audio.audio-briefing-popup.customize-tab.duration-label": "音訊長度多長？",
  "audio.audio-briefing-popup.customize-tab.duration.long": "<b>10-12</b> \n分鐘",
  "audio.audio-briefing-popup.customize-tab.duration.medium": "<b>5-7</b> \n分鐘",
  "audio.audio-briefing-popup.customize-tab.duration.short": "<b>2-3</b> \n分鐘",
  "audio.audio-briefing-popup.customize-tab.tone-label": "音訊聽起來如何？",
  "audio.audio-briefing-popup.customize-tab.tone.conversational": "對話式",
  "audio.audio-briefing-popup.customize-tab.tone.conversational.description": "親切且資訊豐富",
  "audio.audio-briefing-popup.customize-tab.tone.playful": "淘氣",
  "audio.audio-briefing-popup.customize-tab.tone.playful.description": "活潑、時而幽默",
  "audio.audio-briefing-popup.customize-tab.tone.professional": "專業",
  "audio.audio-briefing-popup.customize-tab.tone.professional.description": "清楚直接",
  "audio.audio-briefing-popup.customize-tab.tone.surprise": "讓我感到驚艷",
  "audio.audio-briefing-popup.customize-tab.tone.surprise.description": "擁有獨特的個性",
  "audio.audio-briefing-popup.error.try-again": "再試一次",
  "audio.audio-briefing-popup.feedback-footer.quality-disclaimer": "使用人工智慧。品質可能會有所不同。",
  "audio.audio-briefing-popup.listen-tab": "聆聽",
  "audio.audio-briefing-popup.sources-tab": "來源",
  "audio.audio-panel.title": "摘要音訊",
  "audio.audio-time-indicator.generating-alt": "正在產生工作項目",
  "audio.briefing-popup.changeboarding-body": "簡述就像簡短的 Podcast，可幫助您了解與此頁面有關的所有內容。",
  "audio.briefing-popup.changeboarding-header": "向您介紹音訊簡述",
  "audio.briefing-popup.changeboarding.button.listen": "立即收聽",
  "audio.floating-miniplayer.error-description": "我們的音訊播放器遇到了暫時性的問題。請稍候，然後再試一次",
  "audio.floating-miniplayer.error-title": "我們無法播放摘要",
  "audio.miniplayer-controls.more-label": "更多",
  "audio.miniplayer-controls.play-from-beginning-label": "從頭開始播放",
  "audio.miniplayer-controls.skip-back-label": "倒退",
  "audio.miniplayer-controls.skip-forward-label": "快進",
  "audio.miniplayer-playback-speed-control.playback-speed-label": "播放速度",
  "audio.miniplayer-playback-speed-control.speed-label-08x": "0.8x",
  "audio.miniplayer-playback-speed-control.speed-label-10x": "1.0x",
  "audio.miniplayer-playback-speed-control.speed-label-12x": "1.2x",
  "audio.miniplayer-playback-speed-control.speed-label-15x": "1.5x",
  "audio.miniplayer-playback-speed-control.speed-label-17x": "1.7x",
  "audio.miniplayer-playback-speed-control.speed-label-20x": "2.0x",
  "audio.miniplayer.playlist-title": "播放清單",
  "audio.panel.error.img.alt": "音訊面板錯誤插圖",
  "audio.panel.error.message": "無法載入此摘要的音訊。\n請再試一次。",
  "audio.panel.sendFeedbackLabel": "傳送意見反應",
  "audio.play-button.label": "播放音訊",
  "audio.play-pause-button.loading-label": "載入中",
  "audio.play-pause-button.pause-label": "暫停",
  "audio.play-pause-button.resume-label": "繼續",
  "audio.stop-button.label": "停止播放音訊",
  "automated-meeting-notes.spotlight.closeButtonLabel": "關閉",
  "automated-meeting-notes.spotlight.description": "使用適用於會議的 Loom AI 追蹤交辦事項、做記錄並傳送會議回顧。",
  "automated-meeting-notes.spotlight.startRecording": "開始錄製",
  "automated-meeting-notes.spotlight.title": "不需要再做會議記錄",
  "automation-discovery.add-label.message": "請嘗試建立此自動化規則：當您選擇的使用者發佈新頁面時，使用其名稱為標示該頁面。",
  "automation-discovery.add-label.template-description": "特定作者發布頁面時新增特定標籤",
  "automation-discovery.add-label.title": "Confluence 可以自動新增標籤",
  "automation-discovery.archive.from-archive-modal": "Confluence 可以自動封存舊頁面",
  "automation-discovery.archive.message": "嘗試建立此自動化規則：封存此空間中至少 3 個月未更新的頁面。",
  "automation-discovery.archive.success": "您的頁面已封存",
  "automation-discovery.archive.success-header": "已成功封存",
  "automation-discovery.archive.template-description": "排程時封存非作用中的頁面",
  "automation-discovery.archive.view-in-archive": "在封存中檢視",
  "automation-discovery.automation-menu-smart-button-spotlight.body": "智慧型按鈕可簡化複雜的工作流程。使用自動化規則來提高效率，讓任何人都能觸發複雜的動作。",
  "automation-discovery.automation-menu-smart-button-spotlight.cta": "顯示方法",
  "automation-discovery.automation-menu-smart-button-spotlight.dismiss": "關閉",
  "automation-discovery.automation-menu-smart-button-spotlight.link-to-blog": "進一步了解智慧型按鈕",
  "automation-discovery.automation-menu-smart-button-spotlight.title": "此處提供智慧型按鈕",
  "automation-discovery.bulk-archive.modal.body": "{archivePageCount, plural, other {已成功在「{spaceName}」空間中封存 {archivePageCount} 個頁面}}",
  "automation-discovery.bulk-archive.template.cta": "Confluence 可以自動封存舊頁面！",
  "automation-discovery.bulk-change-page-owner.modal.header": "已成功變更負責人",
  "automation-discovery.bulk-change-page-owner.placeholder": "尋找使用者...",
  "automation-discovery.bulk-change-page-owner.prompt": "當移動頁面時，Confluence 可以自動變更頁面的負責人！",
  "automation-discovery.bulk-change-page-owner.template.action": "將頁面負責人變更為",
  "automation-discovery.bulk-change-page-owner.template.cta": "移動頁面時變更頁面的負責人",
  "automation-discovery.bulk-change-page-owner.template.trigger": "移動頁面時",
  "automation-discovery.common.building-rule": "正在建置規則",
  "automation-discovery.common.create-rule": "啟用規則",
  "automation-discovery.common.create-rule-success": "規則已啟用",
  "automation-discovery.common.dismiss": "稍後再說",
  "automation-discovery.common.edit-in-rule-builder": "在規則建置器中編輯",
  "automation-discovery.common.error-flag.description": "建立規則時發生非預期的錯誤。",
  "automation-discovery.common.error-flag.title": "無法建立規則",
  "automation-discovery.common.show-me-how": "顯示方法",
  "automation-discovery.common.view-rule": "檢視規則",
  "automation-discovery.component.add-label.action.description": "然後新增標籤 {labelPrefix}-頁面",
  "automation-discovery.component.archive-page.action.description": "封存頁面",
  "automation-discovery.component.page-published.trigger.description": "當頁面發布時",
  "automation-discovery.component.scheduled.trigger.description": "每月第一天早上 9:00",
  "automation-discovery.component.stale-page.branch.description": "上次檢視時間超過 12 個月前的頁面",
  "automation-discovery.component.user.condition.description": "如果觸發事件的使用者是 {user}",
  "automation-discovery.component.user.condition.placeholder": "尋找使用者...",
  "automation-discovery.default-space-assigned.header": "預設空間已更新",
  "automation-discovery.global-public-link.cta.text": "要自動封鎖所有新空間的公開連結嗎？",
  "automation-discovery.global-public-link.modal.close.icon.label": "強制回應的關閉圖示",
  "automation-discovery.global-public-link.public-link-turned-off.header": "此網站上不再允許使用公開連結",
  "automation-discovery.global-public-link.public-link-turned-on.header": "此網站現在允許使用公開連結",
  "automation-discovery.global-public-link.success.icon.label": "成功勾選圖示",
  "automation-discovery.hover-page-title.header": "要自動封存舊頁面嗎？",
  "automation-discovery.hover-page-title.message": "此頁面最近沒有更新。自動化規則每月可以封存舊頁面一次。",
  "automation-discovery.jira-link.cta.text": "要自動連結 Jira 議題嗎？",
  "automation-discovery.manual-trigger.body": "團隊成員可以將此選單中的規則套用到單一頁面。",
  "automation-discovery.manual-trigger.cta.text": "建立規則",
  "automation-discovery.manual-trigger.dismiss": "完成",
  "automation-discovery.manual-trigger.title": "頁面自動化選單",
  "automation-discovery.meeting-notes.cta.text": "要自動摘要頁面嗎？",
  "automation-discovery.meeting-notes.message": "嘗試建立此自動化規則：根據您的會議排程發布新的會議記錄頁面。",
  "automation-discovery.meeting-notes.modal.body": "已成功在「{spaceName}」空間發佈「{publishedPageTitle}」",
  "automation-discovery.meeting-notes.modal.close.icon.label": "強制回應的關閉圖示",
  "automation-discovery.meeting-notes.success": "您的頁面已發布",
  "automation-discovery.meeting-notes.success.icon.label": "成功勾選圖示",
  "automation-discovery.meeting-notes.title": "Confluence 可以自動發布頁面",
  "automation-discovery.page-public-link.cta.text": "要在 X 天後自動關閉公開連結嗎？",
  "automation-discovery.page-public-link.public-link-turned-off.header": "您的公開連結已關閉",
  "automation-discovery.page-public-link.public-link-turned-on.header": "已開啟和複製您的公開連結",
  "automation-discovery.productivity-insights.time-saved.message": "{timeSaved, plural, other {透過設定此自動化規則，每一季為您的團隊省下<b> {timeSaved} 分鐘</b>的時間！}}",
  "automation-discovery.rovo.feedback-analysis.analysis.trigger.keyword": "分析",
  "automation-discovery.rovo.feedback-analysis.feedback.trigger.keyword": "意見反應",
  "automation-discovery.rovo.feedback-analysis.modal.cta": "要透過範本自動化您的意見反應分析嗎？",
  "automation-discovery.rovo.feedback-analysis.modal.header": "已成功在「{spaceName}」空間發佈「{publishedPageTitle}」",
  "automation-discovery.rovo.feedback-analysis.summary.trigger.keyword": "摘要",
  "automation-discovery.rovo.product-requirements.modal.cta": "要自動化您的產品需求工作嗎？",
  "automation-discovery.rovo.product-requirements.modal.header": "已成功在「{spaceName}」空間發佈「{publishedPageTitle}」",
  "automation-discovery.rovo.product-requirements.product.trigger.keyword": "產品",
  "automation-discovery.rovo.product-requirements.requirement.trigger.keyword": "需求",
  "automation-discovery.rovo.release-note.trigger.keyword": "版本資訊",
  "automation-discovery.rovo.release-notes.modal.cta": "要自動化建立版本資料的流程嗎？",
  "automation-discovery.rovo.release-notes.modal.header": "已成功在「{spaceName}」空間發布「{publishedPageTitle}」",
  "automation-discovery.share.slack.action": "傳送 Slack 訊息",
  "automation-discovery.share.slack.cta": "當頁面狀態變更時，Confluence 可以自動傳送 Slack 訊息",
  "automation-discovery.share.slack.modal.body": "{sharedPageTitle} 已成功分享。",
  "automation-discovery.share.slack.template": "當頁面狀態變更時通知人員",
  "automation-discovery.share.slack.trigger": "當頁面狀態變更時",
  "automation-discovery.space-assigned-bulk.header": "{guestCount, plural, other {有 {guestCount,number} 位訪客已被指派到「{spaceName}」空間}}",
  "automation-discovery.space-assigned-single.header": "已變更空間存取權",
  "automation-discovery.space-assigned.cta.text": "要將先前未指派的所有訪客新增到此空間嗎？",
  "automation-discovery.verified-content.body": "使用 Confluence 自動化排程驗證內容的審閱。",
  "automation-discovery.verified-content.title": "想要管理已驗證的頁面嗎？",
  "automation-discovery.whiteboard.modal.cta": "要自動建立白板嗎？",
  "automation-discovery.whiteboard.modal.header": "已成功在「{spaceName}」空間發佈「{publishedPageTitle}」",
  "automation-discovery.whiteboard.template": "發布頁面時自動建立白板",
  "automation-discovery.whiteboard.template.action": "使用 {templateName} 範本建立白板",
  "automation-discovery.whiteboard.template.pir": "事件事後分析",
  "automation-discovery.whiteboard.template.roadmap": "優先順序",
  "automation-discovery.whiteboard.template.team": "團隊成立指南",
  "automation-discovery.whiteboard.template.trigger": "發布標題有「{keyword}」的頁面時",
  "automation-discovery.whiteboard.trigger.pir": "「事件回顧檢討」",
  "automation-discovery.whiteboard.trigger.roadmap": "「藍圖」",
  "automation-discovery.whiteboard.trigger.team": "「職位和責任」",
  "automation-extensions.edit.info.panel": "此按鈕可能連結在多個頁面上。此處所做的變更將變更所有連結的按鈕。",
  "automation-extensions.edit.info.panel.missing-edit-permissions": "您沒有編輯此自動化的權限。",
  "automation-extensions.flag.invocation.failure.description": "發生問題，我們無法執行自動化",
  "automation-extensions.flag.invocation.failure.title": "抱歉，我們遇到了問題",
  "automation-extensions.flag.invocation.success.title": "您的自動化正在進行中",
  "automation-extensions.smart-button.add-label.field.label.placeholder": "輸入以篩選標籤",
  "automation-extensions.smart-button.add-label.field.label.title": "標籤",
  "automation-extensions.smart-button.add-label.invalid-value.message": "請至少提供一個有效值。",
  "automation-extensions.smart-button.add-label.missing-config.message": "找不到新增標籤的組態。",
  "automation-extensions.smart-button.add-label.title": "新增標籤",
  "automation-extensions.smart-button.available-templates": "可用範本",
  "automation-extensions.smart-button.by-user": "由任何已登入的使用者點擊",
  "automation-extensions.smart-button.change-owner.field.owner.disabled": "無法取得",
  "automation-extensions.smart-button.change-owner.field.owner.placeholder": "尋找人員...",
  "automation-extensions.smart-button.change-owner.field.owner.title": "負責人",
  "automation-extensions.smart-button.change-owner.title": "變更頁面負責人",
  "automation-extensions.smart-button.change-page-status.invalid-value.message": "請提供有效值。",
  "automation-extensions.smart-button.change-page-status.missing-config.message": "找不到變更頁面狀態的組態。",
  "automation-extensions.smart-button.change-status.component.title": "變更頁面狀態",
  "automation-extensions.smart-button.change-status.field.status.placeholder": "選取頁面狀態",
  "automation-extensions.smart-button.change-status.field.status.title": "狀態",
  "automation-extensions.smart-button.clicked": "已點擊智慧按鈕",
  "automation-extensions.smart-button.config-form.template-editor-info-box": "發布此頁面範本時，您可以編輯這些智慧按鈕欄位。",
  "automation-extensions.smart-button.config.title": "智慧按鈕",
  "automation-extensions.smart-button.copy-page.description": "此動作會建立新的頁面，並盡可能複製所有頁面資料。",
  "automation-extensions.smart-button.copy-page.destination.description": "將目前的頁面複製到：",
  "automation-extensions.smart-button.copy-page.field.new-title.title": "新標題",
  "automation-extensions.smart-button.copy-page.invalid-value.message": "請提供有效值。",
  "automation-extensions.smart-button.copy-page.title": "複製頁面",
  "automation-extensions.smart-button.create-database.description": "在下方建立新的資料庫：",
  "automation-extensions.smart-button.create-database.field.new-title.title": "資料庫標題",
  "automation-extensions.smart-button.create-database.title": "建立資料庫",
  "automation-extensions.smart-button.create-folder.description": "將新資料夾建立於：",
  "automation-extensions.smart-button.create-folder.field.new-title.title": "資料夾名稱",
  "automation-extensions.smart-button.create-folder.title": "建立資料夾",
  "automation-extensions.smart-button.create-jira-issue.connect": "連接",
  "automation-extensions.smart-button.create-jira-issue.invalid-issueType": "請選取有效的議題類型。",
  "automation-extensions.smart-button.create-jira-issue.invalid-project": "請選取有效的專案。",
  "automation-extensions.smart-button.create-jira-issue.manage": "管理",
  "automation-extensions.smart-button.create-jira-issue.product-name": "Jira Cloud",
  "automation-extensions.smart-button.create-jira-issue.title": "在 Jira 中建立議題",
  "automation-extensions.smart-button.create-page.invalid-value.message": "請提供有效值。",
  "automation-extensions.smart-button.create-whiteboard.description": "在下方建立新的白板：",
  "automation-extensions.smart-button.create-whiteboard.field.new-title.title": "白板標題",
  "automation-extensions.smart-button.create-whiteboard.title": "建立白板",
  "automation-extensions.smart-button.create.failure.body": "建立智慧按鈕時發生錯誤。請再試一次。",
  "automation-extensions.smart-button.create.failure.title": "無法建立智慧按鈕",
  "automation-extensions.smart-button.create.success.body": "您的智慧按鈕現已可供使用。",
  "automation-extensions.smart-button.create.success.title": "已建立智慧按鈕",
  "automation-extensions.smart-button.default-smart-button-name": "新增按鈕",
  "automation-extensions.smart-button.description": "允許使用者建立智慧按鈕，以執行自動化規則",
  "automation-extensions.smart-button.extension-title": "智慧按鈕",
  "automation-extensions.smart-button.form-data.invalid-smart-value.message": "請輸入格式正確的輸入智慧值，放在雙大括號中。",
  "automation-extensions.smart-button.form-data.invalid-text-value.message": "請提供有效值。",
  "automation-extensions.smart-button.generate-ai-action-items.helper-text": "使用 {smartValue} 存取您在其他動作中的交辦事項",
  "automation-extensions.smart-button.generate-ai-action-items.placeholder": "輸入智慧值",
  "automation-extensions.smart-button.generate-ai-action-items.textfield.title": "智慧值",
  "automation-extensions.smart-button.generate-ai-action-items.title": "產生 AI 交辦事項",
  "automation-extensions.smart-button.generate-ai-summary.helper-text": "使用 {smartValue} 存取其他動作中的摘要",
  "automation-extensions.smart-button.generate-ai-summary.placeholder": "輸入智慧值",
  "automation-extensions.smart-button.generate-ai-summary.textfield.title": "智慧值",
  "automation-extensions.smart-button.generate-ai-summary.title": "使用 AI 產生摘要",
  "automation-extensions.smart-button.inline-message.ai-notes.first-sentence": "AI 產生的內容只會用於此規則中，不會儲存。",
  "automation-extensions.smart-button.inline-message.ai-notes.second-sentence": "如果您的管理員停用 AI，此規則將不會執行。",
  "automation-extensions.smart-button.inline-message.ai-notes.title": "AI 動作的附註",
  "automation-extensions.smart-button.issue-form.description.label": "描述",
  "automation-extensions.smart-button.issue-form.description.placeholder": "在此輸入...",
  "automation-extensions.smart-button.issue-form.issue-type.label": "議題類型",
  "automation-extensions.smart-button.issue-form.issue-type.placeholder": "選取議題類型...",
  "automation-extensions.smart-button.issue-form.project.label": "專案",
  "automation-extensions.smart-button.issue-form.project.placeholder": "選取專案...",
  "automation-extensions.smart-button.issue-form.summary.label": "摘要",
  "automation-extensions.smart-button.issue-form.summary.placeholder": "簡短描述...",
  "automation-extensions.smart-button.manage-connection.connection.column": "連結",
  "automation-extensions.smart-button.manage-connection.done": "完成",
  "automation-extensions.smart-button.manage-connection.new-connection": "新連結",
  "automation-extensions.smart-button.manage-connection.owner.column": "負責人",
  "automation-extensions.smart-button.manage-connection.selected": "使用中",
  "automation-extensions.smart-button.manage-connection.title": "變更連結",
  "automation-extensions.smart-button.manage-connection.use-connection": "使用連結",
  "automation-extensions.smart-button.move-page.invalid-value.message": "請提供有效值。",
  "automation-extensions.smart-button.move-page.missing-config.message": "找不到移動頁面的組態。",
  "automation-extensions.smart-button.move-page.title": "移動頁面",
  "automation-extensions.smart-button.name": "智慧按鈕",
  "automation-extensions.smart-button.outgoing-email.missing-config.message": "找不到外寄電子郵件的組態。",
  "automation-extensions.smart-button.outgoing-email.missing-recipient.message": "請至少提供一位收件者。",
  "automation-extensions.smart-button.page-owner.invalid-value.message": "請提供有效值。",
  "automation-extensions.smart-button.page-owner.missing-config.message": "找不到變更頁面負責人的組態。",
  "automation-extensions.smart-button.page-picker-with-space.parent-field.title": "父系頁面",
  "automation-extensions.smart-button.page-picker-with-space.space-field.title": "空間",
  "automation-extensions.smart-button.page-picker-with-space.unavailable": "無法選取",
  "automation-extensions.smart-button.preview.then": "則",
  "automation-extensions.smart-button.preview.when-clicked": "點擊智慧按鈕時",
  "automation-extensions.smart-button.publish-page.component.title": "發布頁面",
  "automation-extensions.smart-button.publish-page.field.destination.title": "在以下位置發布新頁面：",
  "automation-extensions.smart-button.publish-page.field.new-title.label": "輸入頁面標題",
  "automation-extensions.smart-button.publish-page.field.template-space.label": "範本空間",
  "automation-extensions.smart-button.publish-page.field.template.label": "範本",
  "automation-extensions.smart-button.restrict-page.field.placeholder": "尋找使用者或群組",
  "automation-extensions.smart-button.restrict-page.field.restrict-operation.label": "限制操作",
  "automation-extensions.smart-button.restrict-page.field.unavailable": "無法取得",
  "automation-extensions.smart-button.restrict-page.field.update-select.label": "可以更新的使用者或群組",
  "automation-extensions.smart-button.restrict-page.field.view-select.label": "可以檢視的使用者或群組",
  "automation-extensions.smart-button.restrict-page.invalid-value.message": "請選取有效的使用者或群組。若要允許空間中的任何人檢視和更新頁面，請使用「此空間中的任何人都可以檢視和編輯」。",
  "automation-extensions.smart-button.restrict-page.missing-config.message": "找不到限制頁面的組態。",
  "automation-extensions.smart-button.restrict-page.title": "限制頁面",
  "automation-extensions.smart-button.rule-preview.error": "我們無法載入此資訊。",
  "automation-extensions.smart-button.save": "儲存按鈕",
  "automation-extensions.smart-button.select-connection.cancel": "取消",
  "automation-extensions.smart-button.select-connection.help-text": "這會建立自動化規則與 Jira 之間的連結。",
  "automation-extensions.smart-button.select-connection.label": "選取 Jira 網站",
  "automation-extensions.smart-button.select-connection.save": "儲存",
  "automation-extensions.smart-button.select-connection.title": "建立連結",
  "automation-extensions.smart-button.send-email.field.content.label": "內容",
  "automation-extensions.smart-button.send-email.field.content.placeholder": "文字",
  "automation-extensions.smart-button.send-email.field.subject.label": "主旨",
  "automation-extensions.smart-button.send-email.field.subject.placeholder": "「{smartValue}」頁面已更新！",
  "automation-extensions.smart-button.send-email.field.to.label": "到",
  "automation-extensions.smart-button.send-email.field.to.placeholder": "選取使用者以傳送電子郵件",
  "automation-extensions.smart-button.send-email.title": "傳送電子郵件",
  "automation-extensions.smart-button.template-card.add-label-and-change-page-status.description": "新增標籤並變更頁面的狀態",
  "automation-extensions.smart-button.template-card.change-page-owner-and-send-email.description": "變更頁面負責人並傳送電子郵件",
  "automation-extensions.smart-button.template-card.change-page-restrictions-and-send-email.description": "變更頁面的限制並傳送電子郵件",
  "automation-extensions.smart-button.template-card.change-page-status-and-send-email.description": "變更頁面的狀態並傳送電子郵件",
  "automation-extensions.smart-button.template-card.copy-page-and-change-owner-and-status-and-restrictions.description": "複製頁面、變更頁面負責人、頁面狀態以及頁面的限制",
  "automation-extensions.smart-button.template-card.create-database-and-send-email.description": "建立資料庫並傳送電子郵件",
  "automation-extensions.smart-button.template-card.create-folder-and-publish-new-page.description": "建立資料夾並發布新頁面",
  "automation-extensions.smart-button.template-card.create-whiteboard-and-send-email.description": "建立白板並傳送電子郵件",
  "automation-extensions.smart-button.template-card.move-page-and-add-label.description": "移動頁面並新增標籤",
  "automation-extensions.smart-button.template-card.publish-new-page-add-label-create-jira-issue.description": "在 Jira 中發布新頁面、新增標籤和建立議題",
  "automation-extensions.smart-button.template-card.publish-new-page-and-add-label.description": "發布新頁面並新增標籤",
  "automation-extensions.smart-button.template-card.publish-page-and-change-owner-and-status-and-restrictions.description": "發布新頁面、變更頁面負責人、頁面狀態以及頁面的限制",
  "automation-extensions.smart-button.template-card.summarize-with-ai-and-generate-ai-action-items-and-send-email.description": "使用 AI 摘要，產生 AI 交辦事項並傳送電子郵件",
  "automation-extensions.smart-button.template-card.update-data-classification-and-change-restrictions-and-send-email.description": "更新資料分類、變更限制和傳送電子郵件",
  "automation-extensions.smart-button.template-panel.template-editor-info-box": "選取此頁面範本的智慧按鈕組態。規則在頁面上發布時，您可以加以編輯。",
  "automation-extensions.smart-button.template.none-selected": "未選取範本",
  "automation-extensions.smart-button.then": "則",
  "automation-extensions.smart-button.tooltip.ai-disabled-and-ai-rule-button": "智慧按鈕已停用，因為您的管理員已關閉 Atlassian Intelligence。",
  "automation-extensions.smart-button.tooltip.click-to-edit": "按一下以編輯",
  "automation-extensions.smart-button.tooltip.disabled": "智慧按鈕已停用。請與管理員連絡。",
  "automation-extensions.smart-button.tooltip.edit-mode.unconfigured": "按鈕沒有動作",
  "automation-extensions.smart-button.tooltip.missing-permissions-default": "此規則的負責人是唯一可加以編輯的人。",
  "automation-extensions.smart-button.tooltip.missing-permissions-with-owner": "{userName} 擁有此規則，是唯一可加以編輯的人。",
  "automation-extensions.smart-button.tooltip.moved": "此智慧按鈕會在另一個空間中執行規則。請與管理員連絡。",
  "automation-extensions.smart-button.tooltip.page-only": "智慧按鈕在部落格上無法運作。我們已停用此按鈕。",
  "automation-extensions.smart-button.tooltip.predefined-template.unconfigured": "未設定按鈕",
  "automation-extensions.smart-button.tooltip.premium-only": "智慧按鈕是 Premium 功能。請與管理員連絡。",
  "automation-extensions.smart-button.tooltip.removed": "智慧按鈕已移除。請與管理員連絡。",
  "automation-extensions.smart-button.tooltip.rule-not-runnable": "發生問題，我們無法執行自動化。請重新整理頁面。如果持續發生問題，請連絡支援人員。",
  "automation-extensions.smart-button.tooltip.select-to-edit": "選擇進行編輯",
  "automation-extensions.smart-button.tooltip.unconfigured": "此按鈕沒有設定規則。若要建立您自己的按鈕，請從工具列中選取 (+) 圖示，或輸入 /智慧按鈕。",
  "automation-extensions.smart-button.update": "更新按鈕",
  "automation-extensions.smart-button.update-data-classification.data-classification-picker.title": "資料分類層級",
  "automation-extensions.smart-button.update-data-classification.error.not-published": "此選項無法使用。您的組織可能已更新您的分類層級或政策。請選擇其他層級。",
  "automation-extensions.smart-button.update-data-classification.invalid-value.message": "請選取有效的資料分類等級。",
  "automation-extensions.smart-button.update-data-classification.learn-more": "深入了解",
  "automation-extensions.smart-button.update-data-classification.missing-config.message": "找不到更新資料的分類組態。",
  "automation-extensions.smart-button.update-data-classification.placeholder": "選取資料分類層級",
  "automation-extensions.smart-button.update-data-classification.space-default-level": "空間的預設層級",
  "automation-extensions.smart-button.update-data-classification.title": "更新資料分類",
  "automation-extensions.smart-button.update-data-classification.warning.not-enabled": "您必須先在管理中心中啟用資料分類，才能設定此元件。",
  "automation-extensions.smart-button.update.failure.body": "更新智慧按鈕時發生錯誤，請再試一次。",
  "automation-extensions.smart-button.update.failure.invalid-config.body": "請檢查您的組態。",
  "automation-extensions.smart-button.update.failure.invalid-config.title": "無法更新智慧按鈕",
  "automation-extensions.smart-button.update.failure.permissions.body": "您沒有此專案的存取權。請選取其他專案，然後再試一次。",
  "automation-extensions.smart-button.update.failure.title": "智慧按鈕更新失敗",
  "automation-extensions.smart-button.update.success.body": "您的智慧按鈕已更新。",
  "automation-extensions.smart-button.update.success.title": "智慧按鈕已更新",
  "automation-extensions.smart-button.when": "時間",
  "automation-extensions.template.return": "返回範本選取",
  "automation-extensions.template.unavailable": "無法選取",
  "automation-menu.automation-grouped-page-button.icon.label": "自動化選單圖示",
  "automation-menu.automation-grouped-page-button.tooltip": "自動化",
  "automation-menu.automation-grouped-page-button.tooltip.aria-label": "自動化選單",
  "automation-menu.empty-state.get-started.button": "開始使用",
  "automation-menu.empty-state.image.alt": "空白的自動化列表圖片",
  "automation-menu.empty-state.learn-more.button": "深入了解自動化",
  "automation-menu.empty-state.learn-more.link": "進一步了解手動觸發程序",
  "automation-menu.empty.automations.admin.description": "例如，從頁面移除所有限制，並按一下按鈕通知團隊。",
  "automation-menu.empty.automations.title": "將常見的任務和流程自動化",
  "automation-menu.empty.automations.user.description": "管理員尚未建立任何可以在這裡使用的自動化。",
  "automation-menu.error.description": "顯示這些內容的時間比預期的時間長。這可能是暫時性的問題。請嘗試重新整理或導覽至另一個頁面。",
  "automation-menu.error.image.alt": "「錯誤」圖片",
  "automation-menu.error.title": "我們遇到問題",
  "automation-menu.flag.invocation.failure.description": "發生問題，我們無法執行自動化",
  "automation-menu.flag.invocation.failure.title": "抱歉，我們遇到了問題",
  "automation-menu.flag.invocation.success.title": "您的自動化正在進行中",
  "automation-menu.header": "自動化",
  "automation-menu.modal.empty.automations.admin.description": "使用手動觸發程序填入選項選單，讓任何人或您指定的人員都可以在頁面上套用為一鍵式自動化功能。",
  "automation-menu.modal.empty.automations.user.description": "管理員尚未為此空間設定任何頁面自動化。當管理員設定時，可能會包含變更頁面限制等一鍵式動作。",
  "automation-menu.modal.error.description": "載入時間過長。請嘗試重新整理頁面。",
  "automation-menu.modal.error.image.alt": "「錯誤」圖片",
  "automation-menu.modal.footer.automate-button": "自動化",
  "automation-menu.modal.footer.cancel-button": "取消",
  "automation-menu.modal.footer.get-started-button": "建立自動化",
  "automation-menu.modal.footer.ok-button": "確定",
  "automation-menu.modal.header.context-hint": "將自動化套用至 <b>{contentTitle}</b>。",
  "automation-menu.modal.header.description": "可用的選項是由 Confluence 和空間管理員所控制。",
  "automation-menu.modal.header.icon.label": "自動化模式標頭圖示",
  "automation-menu.modal.header.learn-more": "進一步了解手動觸發程序",
  "automation-menu.modal.header.title": "自動化",
  "automation-menu.page-quick-action-menu.title": "頁面自動化",
  "automation-menu.page-rovo-button-menu.title": "頁面自動化",
  "automation-menu.page-url-menu.title": "頁面自動化",
  "automation-menu.popup.run-rule.footer.audit-log-item": "稽核記錄",
  "automation-menu.popup.run-rule.footer.create-automation-item": "建立自動化",
  "automation-menu.popup.run-rule.footer.manage-automations-item": "管理自動化",
  "automation-menu.rule.icon.label": "「自動化規則」圖示",
  "automation.execution-limit.content": "使用 Premium 方案，解鎖每月每位使用者 1,000 個動作，讓團隊保持動力。",
  "automation.execution-limit.content.warning": "您已經使用了 80% 的團隊動作。請升級至 Premium 方案，解鎖每位使用者 1,000 個每月動作。",
  "automation.execution-limit.heading": "您已達到自動化上限",
  "automation.execution-limit.heading.warning": "您的團隊很接近自動化上限",
  "automation.execution-limit.learn-more": "深入了解自動化",
  "automation.execution-limit.premium": "試用 Premium 方案",
  "banners.dismissible-banner.close-label": "關閉",
  "banners.icons.close": "「關閉」圖示",
  "banners.icons.more": "更多圖示",
  "banners.icons.warning": "警告圖示",
  "beta-features.beta-feature-lozenge.label": "測試版",
  "beta-features.beta-feature-site-settings-page.heading": "測試版功能",
  "beta-features.beta-feature-site-settings-page.new.features.heading": "新功能",
  "beta-features.content.wrapper.auto.opted-in-description.first": "由於您啟用了即時文件，因此您的網站也啟用了新版內容版面配置。若要變更，請連絡支援人員。",
  "beta-features.content.wrapper.auto.opted-in-description.second": "加入<CommunityLink>社群群組</CommunityLink>，以便在我們努力改善體驗時，取得更新內容並提供意見反應。",
  "beta-features.content.wrapper.error-flag-body": "請重新整理，然後再試一次。 如果此問題持續發生，請連絡支援部門。",
  "beta-features.content.wrapper.error-flag-report-issue": "回報問題",
  "beta-features.content.wrapper.error-flag-title": "發生錯誤",
  "beta-features.content.wrapper.independent.ga-description": "加入<CommunityLink>社群群組</CommunityLink>，以便在我們努力改善體驗時，取得更新內容並提供意見反應。",
  "beta-features.content.wrapper.independent.opted-in-description": "加入<CommunityLink>社群群組</CommunityLink>，以便在我們努力改善體驗時，取得更新內容並提供意見反應。若要關閉，請連絡支援團隊。",
  "beta-features.content.wrapper.opt-in.flag.description": "現有內容保持不變。",
  "beta-features.content.wrapper.opt-in.flag.link": "進一步了解新的版面配置",
  "beta-features.content.wrapper.opt-in.flag.title": "已啟用新的內容版面配置",
  "beta-features.content.wrapper.secondary-heading-opted-in": "已啟用新的版面配置",
  "beta-features.content.wrapper.settings.customer.agreement.link": "Atlassian 客戶協議",
  "beta-features.content.wrapper.settings.description": "在頁面、白板、資料庫和智慧連結上提供全新、一致的體驗，方便您專注並找到需要的內容。重要的改善包含：簡化的標頭和經過重新整理的選單，外加浮動動作列，其中有新的留言面板可用於簡化協作，還有詳細資料面板可顯示重要的中繼資料和資訊。",
  "beta-features.content.wrapper.settings.link": "進一步了解新的版面配置",
  "beta-features.content.wrapper.settings.lozenge.label": "測試版",
  "beta-features.content.wrapper.settings.lozenge.label.modal": "測試版",
  "beta-features.content.wrapper.settings.modal.agree.button.label": "同意並啟用",
  "beta-features.content.wrapper.settings.modal.cancel.button.label": "取消",
  "beta-features.content.wrapper.settings.modal.description": "在建立內容時體驗嶄新的外觀和風格。這些更新會在頁面、白板、資料庫和智慧連結上提供一致體驗，方便您專注並找到需要的內容。",
  "beta-features.content.wrapper.settings.modal.extension.points.text": "某些第三方應用程式的延伸點可能會受到影響。",
  "beta-features.content.wrapper.settings.modal.key.items.text": "主要改善包括：",
  "beta-features.content.wrapper.settings.modal.list.item.four": "全新的<strong>詳細資料面板</strong>，集中顯示重要的中繼資料和資訊",
  "beta-features.content.wrapper.settings.modal.list.item.one": "簡化的<strong>標頭</strong>和經過重新整理的<strong>更多動作「...」</strong>選單",
  "beta-features.content.wrapper.settings.modal.list.item.three": "新的<strong>留言面板</strong>，用於簡化協作",
  "beta-features.content.wrapper.settings.modal.list.item.two": "包含以下功能的<strong>浮動動作列</strong>：",
  "beta-features.content.wrapper.settings.modal.onboarding.text": "啟用後，會有簡短的入門流程，向所有使用者介紹新的版面配置。",
  "beta-features.content.wrapper.settings.modal.things.to.know.text": "開啟此功能的須知事項：",
  "beta-features.content.wrapper.settings.modal.title": "新的內容版面配置",
  "beta-features.content.wrapper.settings.privacy.policy.link": "Atlassian 隱私政策",
  "beta-features.content.wrapper.settings.terms.text": "按一下「同意並啟用」即表示您已確認上述內容，同意新版面配置的使用受 {customerAgreementLink} 管理，並已確認 {privacyPolicyLink}。根據《Atlassian 客戶協議》第 17 條，新的版面配置被視為「免費或測試版產品」。",
  "beta-features.content.wrapper.settings.title": "新的內容版面配置",
  "beta-features.content.wrapper.settings.turn.on.button.label": "啟用",
  "beta-features.content.wrapper.things-to-know.item.one": "某些第三方應用程式的延伸點可能會受到影響。",
  "beta-features.content.wrapper.things-to-know.item.two": "如果您已啟用即時文件測試版，則可以視需要停用新版內容版面配置，這不會停用即時文件。",
  "beta-features.content.wrapper.things-to-know.title": "須知事項...",
  "beta-features.content.wrapper.things-to-know.tooltip": "了解須知事項",
  "beta-features.empty.bodyLineOne": "我們目前正在開發新的功能供您試用。",
  "beta-features.empty.bodyLineTwo": "請追蹤公告或在返回此處查看。",
  "beta-features.empty.heading": "即將推出新功能",
  "beta-features.live-docs.acknowledgement-message": "按一下「同意並啟用」即表示您已確認上述內容，同意即時文件的使用受 <TermsOfServiceLink>Atlassian 客戶協議</TermsOfServiceLink>管理，並已確認 <PrivacyPolicyLink>Atlassian 隱私政策</PrivacyPolicyLink>。根據《Atlassian 客戶協議》第 17 條，即時文件被視為「免費或測試版產品」。",
  "beta-features.live-docs.cancel-button": "取消",
  "beta-features.live-docs.description": "在書面內容上工作和協作，無須發布。透過頁面和其他功能為您的網站啟用，以便立即嘗試。",
  "beta-features.live-docs.enable-button": "同意並啟用",
  "beta-features.live-docs.error-flag-body": "請重新整理，然後再試一次。 如果此問題持續發生，請連絡支援部門。",
  "beta-features.live-docs.error-flag-report-issue": "回報問題",
  "beta-features.live-docs.error-flag-title": "發生錯誤",
  "beta-features.live-docs.find-out-more-link": "了解更多有關即時文件的資訊",
  "beta-features.live-docs.flag-find-out-more": "了解更多有關即時文件的資訊",
  "beta-features.live-docs.ga-description": "加入<CommunityLink>社群群組</CommunityLink>，以便在我們努力改善體驗時，取得更新內容並提供意見反應。",
  "beta-features.live-docs.give-feedback-button": "提供意見反應",
  "beta-features.live-docs.heading": "即時文件",
  "beta-features.live-docs.opt-in-button": "開啟",
  "beta-features.live-docs.opt-in-flag-body": "現有內容保持不變。",
  "beta-features.live-docs.opt-in-live-docs-and-content-wrapper-flag-title": "已啟用即時文件和新的版面配置",
  "beta-features.live-docs.opt-in-only-live-docs-flag-title": "即時文件已啟用",
  "beta-features.live-docs.opted-in-description": "加入<CommunityLink>社群群組</CommunityLink>，以便在我們努力改善體驗時，取得更新內容並提供意見反應。若要關閉，請連絡支援團隊。",
  "beta-features.live-docs.secondary-heading-opted-in": "已啟用",
  "beta-features.live-docs.things-to-know.0": "即時文件在啟用後便無法從整個網站上移除。但是，<ConfigurationLink>空間管理員</ConfigurationLink>可以隨時在空間層級開啟或關閉即時文件。",
  "beta-features.live-docs.things-to-know.1": "<InfoLink>即時文件的預設存取權和可見性</InfoLink>與標準頁面不同。啟用後，將會有簡要的入門流程，向所有使用者介紹即時文件及這些差異。",
  "beta-features.live-docs.things-to-know.2": "即時文件在啟用後，可能需要幾分鐘的時間才會將其存取權推出到所有空間。 根據預設，知識庫空間會關閉即時文件。",
  "beta-features.live-docs.things-to-know.3": "如果啟用即時文件，也會啟用新功能計畫的搶先體驗，包括<ContentLayoutLink>更新的內容版面配置</ContentLayoutLink>、升級的留言功能、新的 Marketplace 延伸點服務，以及統一的分享和評估管理功能。這些功能將套用至您的 Confluence 網站，而不只是套用至即時文件。",
  "beta-features.live-docs.things-to-know.3-with-editor-panel": "如果啟用即時文件，也會啟用新功能計畫的搶先體驗，包括浮動的編輯器工具列、<ContentLayoutLink>更新的內容版面配置</ContentLayoutLink>、留言功能、新的 Marketplace 延伸點服務，以及統一的分享和評估管理功能。這些功能將套用至您的 Confluence 網站，而不只是套用至即時文件。",
  "beta-features.live-docs.things-to-know.4": "不支援頁面和即時文件標頭中的 Marketplace 應用程式按鈕。即將在其他位置支援受影響的應用程式。若要深入了解，請前往此<StatusLink>狀態頁面</StatusLink>。",
  "beta-features.live-docs.things-to-know.5": "即時文件隨時可以轉換為頁面，頁面也可以隨時轉換為即時文件。",
  "beta-features.live-docs.things-to-know.heading": "開啟此功能的須知事項：",
  "beta-features.live-docs.things-to-know.title": "須知事項...",
  "beta-features.live-docs.things-to-know.tooltip": "了解須知事項",
  "beta-features.nav4-opt-in.button.text": "開啟",
  "beta-features.nav4-opt-in.modal.cancel": "取消",
  "beta-features.nav4-opt-in.modal.checkbox-text": "我知道這項變更永遠無法復原",
  "beta-features.nav4-opt-in.modal.description": "這將為您 Confluence 網站上的所有人啟用新版導覽功能。",
  "beta-features.nav4-opt-in.modal.error.description": "請檢查連線，然後再試一次。",
  "beta-features.nav4-opt-in.modal.error.title": "我們無法開啟新版導覽",
  "beta-features.nav4-opt-in.modal.header": "永久開啟新版導覽",
  "beta-features.nav4-opt-in.modal.submit": "為所有人開啟",
  "beta-features.nav4-opt-in.site-wide.modal.header": "開啟新版導覽",
  "beta-features.nav4-opt-in.site.wide.modal.description": "這將為您 Confluence 網站上的所有人啟用新版導覽功能，但其他 Confluence 管理員除外。Confluence 管理員可以手動開啟新版導覽。<br></br><br></br>我們將在未來幾週內將您的網站永久移轉至新版導覽功能，在此之前，您隨時可切換回舊版導覽功能。",
  "beta-features.nav4-opt-in.success.description": "我們已將您 Confluence 網站上的每個人移至新版導覽。",
  "beta-features.nav4-opt-in.success.title": "已啟用新版導覽",
  "beta-features.nav4-opt-opt.modal.header": "關閉新版導覽功能",
  "beta-features.nav4-opt-out.button.text": "停用",
  "beta-features.nav4-opt-out.modal.cancel": "取消",
  "beta-features.nav4-opt-out.modal.description": "這將為您 Confluence 網站上的所有人暫時停用新版導覽功能。在您繼續之前，請考量到舊版導覽功能只能再使用一段時間，之後便會永久切換。\n\n如果您短期內需要舊版導覽功能的全網站存取權，再繼續此動作。",
  "beta-features.nav4-opt-out.modal.error.description": "請檢查連線，然後再試一次。",
  "beta-features.nav4-opt-out.modal.error.title": "我們無法開啟舊版導覽功能",
  "beta-features.nav4-opt-out.modal.submit": "為所有人關閉此功能",
  "beta-features.navigation.description": "新版導覽可供您自訂，提供全新的外觀和風格，提升在工作之間移動的效率。",
  "beta-features.navigation.explore-the-new-navigation": "什麼是新版導覽？",
  "beta-features.navigation.heading": "新版導覽",
  "beta-features.navigation.opt-in-button": "開啟",
  "beta-features.navigation.opt-in-for-everyone-description": "立即掌握變更，並將團隊移到新版導覽。",
  "beta-features.navigation.opt-in-for-everyone-header": "為所有人開啟 (Confluence 管理員除外)",
  "beta-features.navigation.opt-in-for-you-description": "先探索新功能，以便為團隊提供更好的支援。",
  "beta-features.navigation.opt-in-for-you-header": "只為您自己開啟",
  "beta-features.navigation.opted-in-for-everyone-description": "您的團隊目前正在使用新版導覽。",
  "beta-features.navigation.toggle.opt-in-for-you-header": "只為您自己開啟",
  "beta-features.navigation.toggle.opt-in-label": "啟用",
  "beta-features.navigation.toggle.opt-out-label": "停用",
  "beta-features.navigation.warning-message": "新版導覽如果沒有手動開啟，將在未來幾週內自動向所有使用者推出。",
  "beta-features.rbac-beta-admin-optin.modal.agree.button.label": "同意並啟用",
  "beta-features.rbac-beta-admin-optin.modal.cancel.button.label": "取消",
  "beta-features.rbac-beta-admin-optin.modal.description": "在書面內容上工作和協作，無須發布。透過頁面和其他功能為您的網站開啟，以便立即嘗試。",
  "beta-features.rbac-beta-admin-optin.modal.things-to-know.0": "啟用後，無法在整個網站範圍內移除以角色為基礎的存取控制。",
  "beta-features.rbac-beta-admin-optin.modal.things-to-know.1": "啟用後，可能需要幾分鐘的時間，以角色為基礎的存取控制才會在所有空間中推出。",
  "beta-features.rbac-beta-admin-optin.modal.things.to.know.text": "開啟此功能的須知事項：",
  "beta-features.rbac-beta-admin-optin.modal.title": "以角色為基礎的存取控制",
  "beta-features.rbac-beta-admin-optin.terms.text": "按一下「同意並啟用」即表示您已確認上述內容、同意以角色為基礎的存取控管功能的使用受 <TermsOfServiceLink>Atlassian 客戶協議</TermsOfServiceLink>管理，並已確認 <PrivacyPolicyLink>Atlassian 隱私政策</PrivacyPolicyLink>。根據《Atlassian 客戶協議》第 17 條，以角色為基礎的存取控管功能被視為「免費或測試版產品」。",
  "beta-features.rbac-beta-post-optin.independent.opted-in-description": "加入<CommunityLink>社群群組</CommunityLink>，以便在我們努力改善體驗時，取得更新內容並提供意見反應。若要變更，請連絡支援人員。",
  "beta-features.rbac-beta-post-optin.learn-more-link": "進一步了解以角色為基礎的存取控管",
  "beta-features.rbac-beta-post-optin.secondary-description": "角色可協助您管理使用者對空間的存取權，達成一致性、可預測性和擴充性。 每個角色都有相關且不同的個別權限，讓您充分掌握每一位使用者可以執行的動作。",
  "beta-features.rbac-beta-post-optin.secondary-heading": "已啟用「以角色為基礎的存取控管」",
  "beta-features.rbac-beta-post-optin.things-to-know.item.one": "某些第三方應用程式的延伸點可能會受到影響。",
  "beta-features.rbac-beta-post-optin.things-to-know.item.two": "如果您已啟用即時文件測試版，則可以視需要停用新版內容版面配置，這不會停用即時文件。",
  "beta-features.rbac-beta-post-optin.things-to-know.title": "須知事項...",
  "beta-features.rbac-beta-post-optin.things-to-know.tooltip": "了解須知事項",
  "beta-features.rbac-beta-pre-optin.description": "角色可協助您管理使用者對空間的存取權，達成一致性、可預測性和擴充性。每個角色都有相關且不同的個別權限，讓您充分掌握每一位使用者可以執行的動作。",
  "beta-features.rbac-beta-pre-optin.error-flag-body": "請重新整理，然後再試一次。 如果此問題持續發生，請連絡支援部門。",
  "beta-features.rbac-beta-pre-optin.error-flag-report-issue": "回報問題",
  "beta-features.rbac-beta-pre-optin.error-flag-title": "發生錯誤",
  "beta-features.rbac-beta-pre-optin.link": "進一步了解角色",
  "beta-features.rbac-beta-pre-optin.lozenge.label": "測試版",
  "beta-features.rbac-beta-pre-optin.opt-in-flag-body": "現有權限保持不變。",
  "beta-features.rbac-beta-pre-optin.opt-in-flag-find-out-more": "深入了解「以角色為基礎的存取控管」",
  "beta-features.rbac-beta-pre-optin.opt-in-flag-title": "已啟用以角色為基礎的存取控管",
  "beta-features.rbac-beta-pre-optin.title": "以角色為基礎的存取控制",
  "beta-features.rbac-beta-pre-optin.turn.on.button.label": "開啟",
  "blank-page-quick-actions.allTemplates": "所有範本",
  "blank-page-quick-actions.brainstormAltText": "使用腦力激盪插入內容",
  "blank-page-quick-actions.brainstormDescription": "使用腦力激盪插入內容",
  "blank-page-quick-actions.brainstormName": "腦力激盪",
  "blank-page-quick-actions.helperText": "選取一個元素以開始使用，或直接輸入",
  "blank-page-quick-actions.infoPanelAltText": "插入資訊面板以在彩色面板中醒目顯示資訊",
  "blank-page-quick-actions.infoPanelDescription": "在彩色面板中醒目顯示資訊",
  "blank-page-quick-actions.infoPanelName": "資訊面板",
  "blank-page-quick-actions.moreElements": "更多元素",
  "blank-page-quick-actions.smartButtonAltText": "插入智慧按鈕",
  "blank-page-quick-actions.smartButtonName": "智慧按鈕",
  "blank-page-quick-actions.smartButtonTitle": "智慧按鈕",
  "blank-page-quick-actions.startWithAI": "透過 AI 開始",
  "blank-page-quick-actions.tableAltText": "插入表格",
  "blank-page-quick-actions.tableDescription": "插入表格",
  "blank-page-quick-actions.tableName": "表格",
  "blank-page-quick-actions.tableOfContentsAltText": "插入目錄",
  "blank-page-quick-actions.tableOfContentsDescription": "根據內容的標題建立目錄",
  "blank-page-quick-actions.tableOfContentsName": "目錄",
  "blank-page-quick-actions.tableOfContentsTitle": "目錄",
  "blank-page-quick-actions.templateLoadError": "我們在載入建議範本時遇到問題 - 請重新整理或前往<button>所有範本。</button>",
  "blank-page-quick-actions.templateSuccessFlagBrowserOtherTemplatesLink": "瀏覽其他範本",
  "blank-page-quick-actions.templateSuccessFlagClearEditorLink": "全部清除",
  "blank-page-quick-actions.templateSuccessFlagDescription": "您可以隨時變更範本。",
  "blank-page-quick-actions.templateSuccessFlagTitle": "已選擇「{templateName}」範本",
  "blog-tree.empty-state-description": "此空間中沒有部落格",
  "blog-tree.failed-to-load.error.message": "無法載入部落格樹狀結構",
  "blog-tree.failed-to-load.tooltip": "請再等一下，我們正在努力解決此問題。",
  "blog-tree.load-more-button": "顯示更多部落格",
  "blog-tree.paginate.failed.description": "我們在載入更多部落格時遇到網路錯誤。請重新整理頁面，然後再試一次。如果這種情況持續發生，請連絡您的空間管理員。",
  "blog-tree.paginate.failed.title": "發生錯誤",
  "blog-tree.section.header.title": "部落格",
  "blog-tree.section.header.tooltip": "檢視此空間中的所有部落格",
  "blog-tree.status.draft": "草稿",
  "blog-tree.untitled-draft": "未命名",
  "breadcrumbs.ancestors.dropdown.button.label": "更多軌跡瀏覽",
  "breadcrumbs.archived-content-list-link": "已封存",
  "breadcrumbs.archived-pages-list-link": "封存的內容",
  "breadcrumbs.dropdown.button.chevron.tooltip": "顯示導覽路徑",
  "breadcrumbs.dropdown.move.text": "移動",
  "breadcrumbs.dropdown.untitled-page.default-title": "未命名",
  "breadcrumbs.folder.empty": "此資料夾中還沒有任何內容。",
  "breadcrumbs.folder.error": "載入資料夾內容時發生錯誤",
  "breadcrumbs.navigation.space-settings-breadcrumb-link.hub-name": "{hubName, select, other {{hubName}} undefined {公司中心}}",
  "breadcrumbs.navigation.space-settings-breadcrumb-link.hub-settings": "公司中心設定",
  "breadcrumbs.navigation.space-settings-breadcrumb-link.landing-page": "空間設定",
  "breadcrumbs.picker.folder": "資料夾",
  "browser-not-supported.title": "瀏覽器不受支援",
  "browser-not-supported.view-supported": "檢視支援的瀏覽器",
  "browser-status-indicator.back.online": "編輯已恢復",
  "browser-status-indicator.collab.edit.timeout": "您的連線已中斷，因此我們已暫停編輯功能，以避免發生任何問題。您可以在重新連線後再次編輯，但可能需要立即複製並儲存此工作。正在嘗試重新連線",
  "browser-status-indicator.page.was.backgrounded": "您的內容可能尚未完全載入。請嘗試 {refreshLink}",
  "browser-status-indicator.permission.change.offline": "已花費比平常更久的時間儲存您所做的存取更新，因此我們已停用編輯功能以避免發生任何問題。完成變更內容的儲存之後，您即可編輯。正在儲存",
  "browser-status-indicator.refresh.the.page": "立即重新整理",
  "browser-status-indicator.user.offline.editor.disabled": "您的連線已中斷，因此我們已停用編輯功能，以避免發生任何問題。重新連線後，您即可編輯。正在嘗試重新連線",
  "browser-status-indicator.user.offline.editor.enabled": "您的連線已中斷。重新連結後，將會儲存您的變更。正在嘗試重新連線",
  "browser-status-indicator.user.offline.editor.offline-mode.disabled": "您似乎已離線。您所做的任何變更都將自動儲存。某些功能將無法使用。",
  "browser-status-indicator.user.offline.editor.offline-mode.enabled": "您重新連上線了。您現在可以使用所有編輯功能。",
  "bulk-page-actions.bulk-actions.flag.refresh.link-text": "重新整理",
  "bulk-page-actions.bulk-actions.flag.support.link-text": "Atlassian 支援",
  "bulk-page-actions.change-owner.common.flag.error.body": "請確保您擁有正確的權限，且所有選取的項目都是頁面，然後再試一次。",
  "bulk-page-actions.change-owner.common.flag.error.body.livedocs": "請確保您擁有正確的權限，且所有選取的項目都是頁面或即時文件，然後再試一次。",
  "bulk-page-actions.change-owner.common.flag.error.bodyV2": "請確保您擁有正確的權限，且所有選取的項目都是頁面或即時文件，然後再試一次。",
  "bulk-page-actions.change-owner.common.flag.error.title": "您的要求發生問題",
  "bulk-page-actions.change-owner.content.flag.progress.title": "正在更新項目負責人...",
  "bulk-page-actions.change-owner.content.flag.success.title": "{count, plural, =0 {沒有任何所選項目已變更負責人} other {{count} 個項目的負責人已變更}}",
  "bulk-page-actions.change-status.common.flag.error.body": "請確保您擁有正確的權限，且所有選取的項目都是頁面，然後再試一次。",
  "bulk-page-actions.change-status.common.flag.error.body.livedocs": "請確保您擁有正確的權限，且所有選取的項目都是頁面或即時文件，然後再試一次。",
  "bulk-page-actions.change-status.common.flag.error.bodyV2": "請確保您擁有正確的權限，且所有選取的項目都是頁面或即時文件，然後再試一次。",
  "bulk-page-actions.change-status.common.flag.error.title": "您的要求發生問題",
  "bulk-page-actions.change-status.content.flag.progress.title": "正在更新內容狀態...",
  "bulk-page-actions.change-status.content.flag.success.title": "{count, plural, =0 {沒有任何所選項目已變更狀態} other {{count} 個項目的狀態已變更}}",
  "bulk-page-actions.common.flag.error.body": "您的團隊正在處理大量項目。佇列有時間清除後，請<b>稍後再試一次</b>。{lineBreak}{lineBreak}如果這種情況持續發生，請嘗試連絡{supportLink}。",
  "bulk-page-actions.common.flag.error.title": "您的刪除要求發生問題",
  "bulk-page-actions.convert-page-to-live-doc.common.flag.error.body": "請確保您擁有正確的權限，且選取的項目都是已發布的頁面，然後再試一次。",
  "bulk-page-actions.convert-page-to-live-doc.common.flag.error.title": "您的要求發生問題",
  "bulk-page-actions.convert-page-to-live-doc.content.flag.progress.title": "正在將頁面轉換為即時文件...",
  "bulk-page-actions.convert-page-to-live-doc.content.flag.success.title": "{count, plural, =0 {並未轉換任何所選項目} other {已轉換 {count} 個項目}}",
  "bulk-page-actions.delete-content.flag.no-archive-permission-error.title": "您沒有封存這項內容的權限",
  "bulk-page-actions.delete.archive-secondary-button": "封存",
  "bulk-page-actions.delete.content.flag.progress.title": "正在傳送到垃圾桶...",
  "bulk-page-actions.delete.content.flag.success.title": "已傳送到垃圾桶",
  "bulk-page-actions.delete.error.bulk-queue-busy": "您的團隊正在處理大量項目。佇列有時間清除後，請<b>稍後再試一次</b>。{lineBreak} {lineBreak} 如果這種情況繼續發生，請嘗試連絡 {supportLink}。",
  "bulk-page-actions.delete.error.content-tree-too-deep.bulk": "您選擇的一或多個巢狀內容項目有過多層級，無法刪除。請嘗試改為單獨刪除其子系。",
  "bulk-page-actions.delete.error.content-tree-too-deep.nested": "您的巢狀內容有過多層級，無法刪除。請嘗試改為單獨刪除其子系。",
  "bulk-page-actions.delete.error.default-message": "您的要求發生異常錯誤。<b>請稍後再試一次</b>。{lineBreak} {lineBreak} 如果這種情況繼續發生，請嘗試連絡 {supportLink}。",
  "bulk-page-actions.delete.error.duplicate-pages": "您的刪除要求包含重複的項目。請檢查您的選項，然後再次嘗試刪除。{lineBreak} {lineBreak} 如果這種情況繼續發生，請嘗試連絡 {supportLink}。",
  "bulk-page-actions.delete.error.invalid-content-ids": "您的刪除要求包含疑似不存在的項目。請檢查您的選項，然後再次嘗試刪除。{lineBreak} {lineBreak} 如果這種情況繼續發生，請嘗試連絡 {supportLink}。",
  "bulk-page-actions.delete.error.invalid-content-status": "您選取的一個或多個項目無法刪除，因為是草稿、已封存或已刪除。",
  "bulk-page-actions.delete.error.invalid-perimissions": "您的刪除要求包含您沒有權限刪除的項目。請檢查您的選項，然後再次嘗試刪除。",
  "bulk-page-actions.delete.error.long-task-timeout": "處理您的要求花費了比平常更久的時間。請稍後返回查看是否處理完成。",
  "bulk-page-actions.delete.error.too-many-items-deleted": "您的刪除要求包含過多項目。請選擇較少的項目，然後再次嘗試刪除",
  "bulk-page-actions.delete.nested.page-tree.actionable-label": "您具有刪除權限",
  "bulk-page-actions.delete.nested.page-tree.nonactionable-descendants-tooltip": "您沒有刪除一個或多個巢狀項目的權限。",
  "bulk-page-actions.delete.nested.page-tree.nonactionable-label": "您沒有刪除權限",
  "bulk-page-actions.delete.nested.page-tree.permission-column-header": "刪除權限",
  "bulk-page-actions.delete.nested.restricted.info": "刪除個別父系項目可能會變更誰能夠查看底下的巢狀項目。{lineBreak}{lineBreak}完成後請確認巢狀項目的權限。",
  "bulk-page-actions.delete.nested.restricted.no-actionable-descendants.description": "{visibleDescendantsCount, plural, other {「<strong>{contentName}</strong>」有 {visibleDescendantsCount,number} 個巢狀項目。}}",
  "bulk-page-actions.delete.nested.restricted.no-actionable-descendants.title": "此項目有巢狀項目",
  "bulk-page-actions.delete.nested.restricted.no-actionable-descendants.warning": "您沒有刪除巢狀項目的權限。",
  "bulk-page-actions.delete.nested.restricted.selection-limit.description": "{visibleDescendantsCount, plural, other {<strong>{contentName}</strong> 有 {visibleDescendantsCount,number} 個巢狀項目。這些項目無法刪除 - 一次只能移動 100 個項目。}}",
  "bulk-page-actions.delete.nested.restricted.selection-limit.title": "刪除個別項目",
  "bulk-page-actions.delete.nested.restricted.selection-limit.warning": "巢狀項目會保留在內容樹狀結構中。",
  "bulk-page-actions.delete.nested.unentitled.description": "刪除「<strong>{contentName}</strong>」可能會變更誰可以查看底下的巢狀項目。{lineBreak}{lineBreak}完成後，請確認可以檢視的人員。",
  "bulk-page-actions.delete.nested.unentitled.title": "此項目有巢狀項目",
  "bulk-page-actions.delete.nested.unrestricted.description": "{visibleDescendantsCount, plural, other {「<strong>{contentName}</strong>」有 {visibleDescendantsCount,number} 個巢狀項目。如果您想要一併將其刪除，請勾選此方塊。}}",
  "bulk-page-actions.delete.nested.unrestricted.description.subtext": "若要將項目存檔以供未來參考，請改為封存項目。",
  "bulk-page-actions.delete.nested.unrestricted.descriptionM2": "{visibleDescendantsCount, plural, other {「{contentName}」有 {visibleDescendantsCount,number} 個巢狀項目。如果您也想將其刪除，請勾選方塊。{lineBreak}{lineBreak}若要將項目存檔以供未來參考，請改為封存項目。}}",
  "bulk-page-actions.delete.nested.unrestricted.exclude-nested.info": "刪除個別父系項目可能會變更能夠查看底下巢狀項目的人員。完成後，請確認巢狀項目的權限。",
  "bulk-page-actions.delete.nested.unrestricted.input-subtextM2": "不會刪除草稿",
  "bulk-page-actions.delete.nested.unrestricted.inputM2": "包含巢狀項目",
  "bulk-page-actions.delete.nested.unrestricted.nonactionable-descendants.info": "其餘巢狀項目不會被刪除，而且會在內容樹狀結構中向上移動。{lineBreak}{lineBreak}這可能會變更繼承的權限，因此請在完成後，確認可以檢視的人員。",
  "bulk-page-actions.delete.nested.unrestricted.nonactionable-descendants.warning": "{actionableDescendantsCount, plural, =0 {您沒有刪除巢狀項目的權限。} other {您只能刪除 {actionableDescendantsCount,number} 個巢狀項目。}}",
  "bulk-page-actions.delete.nested.unrestricted.title.pages-and-whiteboards": "刪除父系內容",
  "bulk-page-actions.delete.submit-button": "刪除",
  "bulk-page-actions.dialog-base.action-dialog-base.button.cancel": "取消",
  "bulk-page-actions.dialog-base.inherited-restrictions.link.aria-description": "繼承的檢視限制 - 在新分頁中開啟連結",
  "bulk-page-actions.dialog-base.inherited-restrictions.message": "此內容項目受父系限制。刪除後，不會套用這些限制。<a>進一步了解繼承限制</a>",
  "bulk-page-actions.dialog-base.inherited-restrictions.title": "已刪除項目的存取權將會變更",
  "bulk-page-actions.dialog.change-owner.description": "{expectedPageCount, plural, other {為這些項目選擇新的負責人。}}",
  "bulk-page-actions.dialog.change-owner.validation-error.content-error.body": "變更所有權的功能受到內容類型和檢視/編輯條件所限制。<a>深入了解</a>",
  "bulk-page-actions.dialog.change-owner.validation-error.content-error.title": "{restrictedItemsCount, plural, other {<strong>有 {restrictedItemsCount,number} 個項目不會受到此變更影響</strong>{lineBreak}{lineBreak}}}",
  "bulk-page-actions.dialog.change-owner.validation-error.space-error.body": "若要授予所有權，該使用者必須具有此空間的存取權。{lineBreak}{lineBreak}",
  "bulk-page-actions.dialog.change-owner.validation-error.space-error.learn-more-link": "<a>管理空間權限</a>",
  "bulk-page-actions.dialog.change-owner.validation-error.space-error.title": "<strong>這位使用者沒有此空間的存取權</strong>{lineBreak}{lineBreak}",
  "bulk-page-actions.dialog.change-owner.validation-table.content-column.header": "內容",
  "bulk-page-actions.dialog.change-owner.validation-table.status-column.header": "新的負責人",
  "bulk-page-actions.dialog.change-owner.validation-table.status-column.icon.tooltip.error": "您無法變更此項目的負責人。",
  "bulk-page-actions.dialog.change-owner.validation-table.status-column.icon.tooltip.success": "此項目的負責人將會更新。",
  "bulk-page-actions.dialog.change-owner.validation.error-message": "發生錯誤。請再試一次。",
  "bulk-page-actions.dialog.change-status.control-label": "選取狀態",
  "bulk-page-actions.dialog.change-status.custom-space-statuses": "自訂",
  "bulk-page-actions.dialog.change-status.description": "{expectedPageCount, plural, other {更新或移除這些項目的狀態。}}",
  "bulk-page-actions.dialog.change-status.remove-content-status": "移除所有項目的狀態",
  "bulk-page-actions.dialog.change-status.suggested-space-statuses": "建議的",
  "bulk-page-actions.dialog.change-status.validation.error-message": "發生錯誤。 請再試一次。",
  "bulk-page-actions.dialog.convert-to-live-doc.button": "轉換為即時文件",
  "bulk-page-actions.dialog.convert-to-live-doc.description": "{expectedPageCount, plural, other {這會將這些項目轉換為即時文件。編輯的結果將會即時顯示。}}",
  "bulk-page-actions.dialog.convert-to-live-doc.description-info": "只有您有權存取的已發布頁面才會轉換。所有其他項目將保有目前的內容類型。",
  "bulk-page-actions.dialog.convert-to-live-doc.no-valid-selection-warning": "只有已發布頁面才能轉換為即時文件。請檢閱您目前的選取項目。",
  "bulk-page-actions.dialog.convert-to-live-doc.title": "{expectedPageCount, plural, other {準備好針對 {expectedPageCount,number} 個項目切換到即時文件了嗎？}}",
  "bulk-page-actions.dialog.delete.description": "這些頁面將移至空間的垃圾桶。直到管理員清除或還原之前，會保留在該處。{lineBreak}{lineBreak}若要將項目存檔以供未來參考，請改為封存項目。",
  "bulk-page-actions.dialog.delete.inherited-restrictions.info.link.aria-description": "繼承的檢視限制 - 在新分頁中開啟連結",
  "bulk-page-actions.dialog.delete.nested.inherited-restrictions.info": "如果項目正在從巢狀群組中移除，請記得檢查是否有<a>繼承的檢視限制。</a>{lineBreak}{lineBreak}針對每個子系目設定特定檢視權限，以確保移動後不會向不必要的受眾顯示。",
  "bulk-page-actions.dialog.delete.nonactionable-descendants.warning": "{nonActionableDescendantsCount, plural, other {您沒有刪除 {nonActionableDescendantsCount,number} 個所選頁面的權限。即使繼續執行，這些頁面仍將保留在內容樹狀結構中。}}",
  "bulk-page-actions.dialog.nested-change-owner.confirm-button": "變更負責人",
  "bulk-page-actions.dialog.nested-change-owner.description": "{expectedPageCount, plural, other {為這些項目選擇新的負責人。}}",
  "bulk-page-actions.dialog.nested-change-owner.exclude-nested.info": "刪除個別父系項目可能會變更能夠查看底下巢狀子項目的人員。完成後，請確認巢狀項目的權限。",
  "bulk-page-actions.dialog.nested-change-owner.info": "剩餘的巢狀項目負責人不會更新。",
  "bulk-page-actions.dialog.nested-change-owner.input": "包含巢狀項目",
  "bulk-page-actions.dialog.nested-change-owner.title": "{expectedPageCount, plural, other {變更 {expectedPageCount,number} 個項目的負責人}}",
  "bulk-page-actions.dialog.nested-change-owner.warning": "{actionableDescendantsCount, plural, =0 {您沒有變更巢狀項目負責人的權限。} other {您只能變更 {actionableDescendantsCount,number} 個巢狀項目的負責人。}}",
  "bulk-page-actions.dialog.nested.change-owner.description": "{expectedPageCount, plural, other {為這些項目選擇新的負責人。}}",
  "bulk-page-actions.dialog.nested.change-owner.description-info": "只有您有權變更負責人的內容項目才會更新。所有其他項目將保留目前的負責人。",
  "bulk-page-actions.dialog.nested.change-owner.no-valid-selection-warning": "只有頁面項目可以變更負責人。請檢閱您目前的選項。",
  "bulk-page-actions.dialog.nested.change-owner.no-valid-selection-warning.contentitems": "只有支援的內容項目可以變更負責人。請檢閱您目前的選取項目。",
  "bulk-page-actions.dialog.nested.change-owner.no-valid-selection-warning.livedocs": "只有頁面和即時文件可以變更負責人。請檢閱您目前的選取項目。",
  "bulk-page-actions.dialog.nested.change-owner.validation-error.space-error.body": "若要授予所有權，該使用者必須具有此空間的存取權。{lineBreak}{lineBreak}",
  "bulk-page-actions.dialog.nested.change-owner.validation-error.space-error.learn-more-link": "<a>管理空間權限</a>",
  "bulk-page-actions.dialog.nested.change-owner.validation-error.space-error.title": "<strong>這位使用者沒有此空間的存取權</strong>{lineBreak}{lineBreak}",
  "bulk-page-actions.dialog.nested.change-status.description-info": "只有您具有變更狀態權限的頁面項目才會更新。所有其他項目將保留目前的狀態。",
  "bulk-page-actions.dialog.nested.change-status.description-infoV2": "只有您有權變更狀態的內容項目才會更新。所有其他項目將保留目前的狀態。",
  "bulk-page-actions.dialog.nested.change-status.no-valid-selection-warning": "只有頁面項目可以變更狀態。請檢閱您目前的選項。",
  "bulk-page-actions.manage-page-tree.archive.description": "<a>封存</a>功能會將內容移至封存檔，可以在該處檢視 (和復原)，且能讓內容樹狀結構保持整潔。",
  "bulk-page-actions.manage-page-tree.archive.link.aria-description": "封存 - 在新分頁中開啟連結",
  "bulk-page-actions.manage-page-tree.default.description": "選取您要移除的項目。",
  "bulk-page-actions.manage-page-tree.delete.description": "<a>刪除</a>功能會將內容移至垃圾桶，管理員可以在該處將其永久清除。",
  "bulk-page-actions.manage-page-tree.delete.link.aria-description": "刪除 - 在新分頁中開啟連結",
  "bulk-page-actions.manage-page-tree.title": "管理內容樹狀結構",
  "bulk-page-actions.nested-page-tree.error.title": "我們無法載入整個內容的樹狀結構",
  "bulk-page-actions.nested-page-tree.nested-pages-column": "項目",
  "bulk-page-actions.single-page.archive.flag.failure.body": "您的團隊正在封存大量內容項目。佇列有時間清除後，請<b>稍後再試一次</b>。{lineBreak}{lineBreak}如果這種情況持續發生，請嘗試連絡{supportLink}。",
  "bulk-page-actions.single-page.archive.flag.failure.title": "封存佇列已滿",
  "bulk-page-actions.single-page.archive.flag.progress.title": "{count, plural, other {內容項目封存中...}}",
  "bulk-page-actions.single-page.archive.flag.success.link-text": "在封存中檢視",
  "bulk-page-actions.single-page.archive.flag.success.title": "{count, plural, other {內容項目已封存}}",
  "bulk-page-actions.single-page.restore.flag.failure.body": "您的團隊正在復原大量項目。佇列有時間清除後，請<b>稍後再試一次</b>。{lineBreak}{lineBreak}如果這種情況持續發生，請嘗試連絡{supportLink}。",
  "bulk-page-actions.single-page.restore.flag.failure.title": "還原佇列已滿",
  "bulk-page-actions.single-page.restore.flag.progress.title": "{count, plural, other {內容復原中...}}",
  "bulk-page-actions.single-page.restore.flag.success.link-text": "檢視項目",
  "bulk-page-actions.single-page.restore.flag.success.title": "{count, plural, other {已復原項目}}",
  "bulk-permissions.info-popup.view-role-permissions-label": "檢視角色權限",
  "bulk-permissions.restricted.title": "此項目受到限制",
  "bulk-permissions.space-permissions-link": "空間權限",
  "bulk-permissions.space-role.select-placeholder": "選取角色",
  "bulk-permissions.space-settings.restricted.message": "如果您認為您應該有存取權，請嘗試向將您派到此處的人員尋求協助。",
  "bulk-permissions.space.action-selection-add": "新增或變更存取權",
  "bulk-permissions.space.action-selection-header": "要執行的動作<asterisk>*</asterisk>",
  "bulk-permissions.space.action-selection-remove": "移除存取權",
  "bulk-permissions.space.add-all.confirmation-dialog-description": "這會讓他們可以存取您網站上的<b>所有空間</b> (使用所選權限)。",
  "bulk-permissions.space.add-button-text": "新增至全部",
  "bulk-permissions.space.add-exclude-personal.confirmation-dialog-description": "這會讓他們可以透過所選權限，存取您網站上的<b>所有空間</b> (不包含個人空間)。",
  "bulk-permissions.space.add-personal.confirmation-dialog-description": "這會讓他們可以透過所選權限，存取您網站上的<b>所有個人空間</b>。",
  "bulk-permissions.space.add.confirmation-dialog": "要將 {principalName} 新增到選取的空間嗎？",
  "bulk-permissions.space.apply-button-text-add": "新增至全部",
  "bulk-permissions.space.apply-button-text-remove": "從所有空間移除",
  "bulk-permissions.space.archived-spaces-tooltip": "已封存的空間不會包含在大量權限動作中。",
  "bulk-permissions.space.archived-spaces-tooltip-icon-label": "已封存的空間資訊",
  "bulk-permissions.space.async.update.success-flag-description": "這些變更可能需要一些時間。我們將在完成時通知您。",
  "bulk-permissions.space.async.update.success-flag-title": "大量權限變更處理",
  "bulk-permissions.space.bulk-roles-button": "啟動大量存取動作",
  "bulk-permissions.space.bulk-roles-description": "在 Confluence 網站上的所有空間，快速新增、變更或移除個別使用者或群組的存取權。",
  "bulk-permissions.space.bulk-roles-title": "大量管理空間存取權",
  "bulk-permissions.space.button": "選擇使用者或群組",
  "bulk-permissions.space.cancel-button-text": "取消",
  "bulk-permissions.space.confirmation-dialog-warning": "<b>此動作無法復原。</b>",
  "bulk-permissions.space.description": "在您 Confluence 網站上的所有空間，快速新增 (或移除) 個別使用者或群組。",
  "bulk-permissions.space.error-flag-description": "我們在完成大量權限變更時遇到問題。請再試一次。",
  "bulk-permissions.space.error-flag-title": "大量權限變更失敗",
  "bulk-permissions.space.header": "將人員新增至所有空間",
  "bulk-permissions.space.loading-dialog-description": "請勿離開或重新整理。",
  "bulk-permissions.space.loading-title": "我們正在處理您的變更",
  "bulk-permissions.space.permissions-selection-header": "選擇空間權限",
  "bulk-permissions.space.permissions-selection-subtext": "選取使用者或群組應在所有空間中擁有哪些權限。這將覆寫他們任何現有的權限。<b>這無法復原</b>，因此請務必再次檢查您要新增的人以及他們應該擁有的權限。",
  "bulk-permissions.space.permissions-selection-subtext-additional": "若要從所有空間移除權限，請取消勾選檢視權限。",
  "bulk-permissions.space.remove-all.confirmation-dialog-description": "這將從網站上的<b>所有空間</b>中將其移除。",
  "bulk-permissions.space.remove-button-text": "從所有空間移除",
  "bulk-permissions.space.remove-exclude-personal.confirmation-dialog-description": "這將從您網站上的<b>所有空間</b> (不包含個人空間) 中將其移除。",
  "bulk-permissions.space.remove-personal.confirmation-dialog-description": "這將從您網站上的<b>所有個人空間</b>中將其移除。",
  "bulk-permissions.space.remove.confirmation-dialog": "要從所選空間中移除 {principalName} 嗎？",
  "bulk-permissions.space.requirement-message": "<asterisk>*</asterisk> 必須執行動作",
  "bulk-permissions.space.role-access-header": "大量管理空間存取權",
  "bulk-permissions.space.role-select-label": "角色",
  "bulk-permissions.space.role-selection-header": "具備哪一項存取權<asterisk>*</asterisk>",
  "bulk-permissions.space.role-selection-sub-header": "選擇他們應具備的存取權角色。",
  "bulk-permissions.space.role-selection-warning": "這將覆寫他們任何現有的存取權。<b>此動作無法復原</b>，因此請務必再次檢查您的選取內容。",
  "bulk-permissions.space.space-access-selection-header": "在哪些空間上<asterisk>*</asterisk>",
  "bulk-permissions.space.space-selection-header": "選擇空間",
  "bulk-permissions.space.space-selection-one": "全部 (不包含個人)",
  "bulk-permissions.space.space-selection-three": "僅限個人",
  "bulk-permissions.space.space-selection-two": "全部",
  "bulk-permissions.space.table.header.allViewTooltipContent": "檢視權限可決定誰可以存取該空間。",
  "bulk-permissions.space.table.header.allViewTooltipIconLabel": "進一步了解檢視權限",
  "bulk-permissions.space.table.header.column.Add": "新增",
  "bulk-permissions.space.table.header.column.add-delete": "新增/刪除",
  "bulk-permissions.space.table.header.column.admin": "管理員",
  "bulk-permissions.space.table.header.column.archive": "封存",
  "bulk-permissions.space.table.header.column.delete": "刪除",
  "bulk-permissions.space.table.header.column.delete-own": "刪除自己的",
  "bulk-permissions.space.table.header.column.export": "匯出",
  "bulk-permissions.space.table.header.column.view": "檢視",
  "bulk-permissions.space.table.header.deleteOwnTooltipContent": "可讓使用者刪除自己的內容和附件。(對於留言，「新增」權限包含「刪除自己的」)",
  "bulk-permissions.space.table.header.deleteOwnTooltipIconLabel": "進一步了解如何刪除自己的",
  "bulk-permissions.space.table.header.group.all": "全部",
  "bulk-permissions.space.table.header.group.attachments": "附件",
  "bulk-permissions.space.table.header.group.blogs": "部落格",
  "bulk-permissions.space.table.header.group.comments": "留言",
  "bulk-permissions.space.table.header.group.mail": "郵件",
  "bulk-permissions.space.table.header.group.pages": "頁面",
  "bulk-permissions.space.table.header.group.pages-databases-embeds": "頁面、資料庫和智慧連結",
  "bulk-permissions.space.table.header.group.pages-databases-embeds.livedocs": "頁面、即時文件、資料庫和智慧連結",
  "bulk-permissions.space.table.header.group.pages-embeds": "頁面和智慧連結",
  "bulk-permissions.space.table.header.group.pages-embeds.livedocs": "頁面、即時文件和智慧連結",
  "bulk-permissions.space.table.header.group.pages-whiteboards-databases": "頁面、白板和資料庫",
  "bulk-permissions.space.table.header.group.pages-whiteboards-databases-embeds": "頁面、白板、資料庫和智慧連結",
  "bulk-permissions.space.table.header.group.pages-whiteboards-databases-embeds.livedocs": "頁面、即時文件、白板、資料庫和智慧連結",
  "bulk-permissions.space.table.header.group.pages-whiteboards-databases.livedocs": "頁面、即時文件、白板和資料庫",
  "bulk-permissions.space.table.header.group.pages-whiteboards-embeds": "頁面、白板和智慧連結",
  "bulk-permissions.space.table.header.group.pages-whiteboards-embeds.livedocs": "頁面、即時文件、白板、資料庫和智慧連結",
  "bulk-permissions.space.table.header.group.pages.livedocs": "頁面和即時文件",
  "bulk-permissions.space.table.header.group.restrictions": "限制",
  "bulk-permissions.space.table.header.group.select-all": "全選",
  "bulk-permissions.space.table.header.group.space": "空間",
  "bulk-permissions.space.table.header.restrictionsTooltipContent": "允許使用者直接新增和移除內容的限制。這不會影響繼承的限制。",
  "bulk-permissions.space.table.header.restrictionsTooltipIconLabel": "限制新增/刪除工具提示",
  "bulk-permissions.space.title": "將人員新增至所有空間",
  "bulk-permissions.space.title-subtext": "在您 Confluence 網站上的所有空間，快速新增 (或移除) 個別使用者或群組。這將覆寫他們任何現有的存取權，也就是說，這也很適合變更所有空間中使用者或群組的存取權。",
  "bulk-permissions.space.user-picker-access-header": "誰<asterisk>*</asterisk>",
  "bulk-permissions.space.user-picker-header": "選擇要新增或移除的人員 <asterisk>*</asterisk>",
  "bulk-permissions.space.user-picker-placeholder": "輸入人員或群組",
  "bulk-permissions.space.user-picker-subtext": "此動作只能選取一位。",
  "calendar3.admin.delete.subscriptions.description": "使用者可以透過專屬的私密連結來訂閱行事曆。如果發生安全性事件，您可能會想要刪除所有行事曆訂閱連結。",
  "calendar3.admin.delete.subscriptions.warning.description": "如果您這麼做，所有使用者都必須重新訂閱他們的行事曆。您無法復原此動作。",
  "calendar3.admin.delete.subscriptions.warning.title": "此動作無法復原",
  "calendar3.admin.disable.privateurls.description": "私密 URL 可讓使用者安全地訂閱團隊行事曆，而不需要登入憑證。這在與一些 Web 型行事曆應用程式 (如 Google Calendare) 整合時必須使用。如果停用，這些外部服務的訂閱將無法運作，但使用者仍可以透過桌面應用程式 (例如 Microsoft Outlook) 訂閱。",
  "calendar3.admin.enable.displayweeknumber.label": "顯示週數",
  "calendar3.admin.enable.siteadmins.label": "允許網站管理員管理行事曆",
  "calendar3.admin.enable.timeformat.description": "修改所有使用者的顯示格式。",
  "calendar3.admin.global.description": "您可以在此設定會影響所有使用者的「團隊行事曆」設定",
  "calendar3.admin.set.disableprivateurls.label": "安全性",
  "calendar3.admin.set.startofweek.default": "預設",
  "calendar3.admin.set.startofweek.description": "如果設為預設，使用者所選語言將用於判斷一週的第一天。",
  "calendar3.admin.set.startofweek.label": "當週第一天",
  "calendar3.admin.set.timeformat.displayTimeFormat12": "下午 1:00",
  "calendar3.admin.set.timeformat.displayTimeFormat24": "13:00 (24 小時制)",
  "calendar3.admin.set.timeformat.label": "顯示時間格式",
  "calendar3.admin.settings.updated": "設定已更新",
  "calendar3.event.submit.name": "提交",
  "category-selector.featured.category.name": "精選",
  "category-selector.inline.collapse-categories.button": "較少類別",
  "category-selector.inline.expand-categories.button": "更多類別",
  "category-selector.more.categories.button": "更多類別",
  "category-selector.my-templates.category.name": "我的範本",
  "category-selector.my-templates.category.name.label": "篩選條件",
  "category-selector.popular.category.name": "熱門",
  "change-edition.admin-announcement-banner.explore": "探索公告橫幅",
  "change-edition.admin-announcement-banner.upsell-section-message": "建立排程，以管理橫幅何時要在團隊中顯示或隱藏。",
  "change-edition.admin-announcement-banner.upsell-section-message-bold": "提前策略規劃橫幅。",
  "change-edition.admin-center.learn-more": "深入了解",
  "change-edition.admin-center.upsell-section-message": "<b>使用任務控制中心監督 Confluence。</b>Confluence Premium 的管理員可透過強大的方法，來主動監控 Confluence 活動、存取權和警示，並採取具體的行動。",
  "change-edition.ai-search-upsell.banner-message-admin": "<b>透過 Atlassian Intelligence 取得答案。</b>在搜尋中提出問題，並透過 Atlassian Intelligence 取得答案，藉此在 Confluence 中取得實用知識。",
  "change-edition.ai-search-upsell.banner-message-non-admin": "<b>透過 Atlassian Intelligence 取得答案。</b>在搜尋中提出問題，並透過 Atlassian Intelligence 取得答案，藉此在 Confluence 中取得實用知識。請要求您的管理員升級方案。",
  "change-edition.ai-search-upsell.description": "在搜尋中提出問題，並透過 Atlassian Intelligence 取得答案，藉此在 Confluence 中取得實用知識。",
  "change-edition.ai-search-upsell.description-append": "請要求您的管理員升級方案。",
  "change-edition.ai-search-upsell.explore-button-text": "探索 Atlassian Intelligence",
  "change-edition.ai-search-upsell.learn-more-button-text": "深入了解",
  "change-edition.ai-search-upsell.popup-header-text": "在搜尋中透過 Atlassian Intelligence 取得答案",
  "change-edition.card.dismiss-modal-btn": "關閉強制回應",
  "change-edition.cards-insert.body.non-admin": "將連結轉換為精美的動態卡片，讓工作更加生動有趣。請您的管理員立即升級。",
  "change-edition.cards-insert.close-modal": "關閉強制回應",
  "change-edition.cards-insert.learn-more": "深入了解",
  "change-edition.cards-insert.title": "使用卡片讓內容脫穎而出",
  "change-edition.carousel-insert.body.admin": "將連結和圖片轉換為動態、旋轉的框架集合，讓內容更加生動。",
  "change-edition.carousel-insert.title": "透過輪播吸引注意力",
  "change-edition.company-home-builder.body": "透過可自訂的動態中心，讓每個人掌握最新資訊。",
  "change-edition.company-home-builder.learn-more": "深入了解",
  "change-edition.company-home-builder.title": "為您的公司提供一個專屬位置。",
  "change-edition.elevate-automation.explore-automation": "探索自動化",
  "change-edition.elevate-automation.upsell-image": "提升自動化追加銷售圖片",
  "change-edition.elevate-automation.upsell-section-message": "自動化規則有助於封存非作用中的頁面、變更頁面狀態，或提醒團隊成員完成任務。開始免費的 Premium 試用以解鎖這項功能。",
  "change-edition.elevate-automation.upsell-section-message-bold": "保持內容井然有序，並推動工作進展。",
  "change-edition.elevate-automation.upsell-section-message.livedocs": "自動化規則有助於封存非作用中的頁面和即時文件、變更內容狀態，或提醒團隊夥伴完成任務。開始免費的 Premium 試用以解鎖這項功能。",
  "change-edition.elevate-automation.video-modal.close-modal.label": "關閉強制回應",
  "change-edition.export-upsell.text": "公開連結可方便您變更內容並讓所有人保持一致。",
  "change-edition.export-upsell.title": "以公開連結分享",
  "change-edition.extension-config-panel.learn-more": "深入了解",
  "change-edition.extension-config-panel.title": "需要變更一些內容嗎？",
  "change-edition.general.button.cancel": "取消",
  "change-edition.inline-message.share-and-restrict-dialog.body": "您可以將此內容限制為只有付費方案的特定人員可以存取。",
  "change-edition.inline-message.share-and-restrict-dialog.learn-more-link": "深入了解",
  "change-edition.notification.dialog.confirmation.failed.desc": "我們無法從 {contentTitle} 頁面中移除頁面限制。請再試一次。",
  "change-edition.notification.dialog.confirmation.failed.title": "限制未移除",
  "change-edition.notification.dialog.confirmation.success.desc": "任何已登入的使用者現在都可以檢視和編輯「{contentTitle}」。",
  "change-edition.notification.dialog.confirmation.success.title": "限制已移除",
  "change-edition.notification.dialog.content.text.remove-restrictions-2": "任何已登入的使用者都能夠檢視和編輯此內容。<b>此動作無法復原。</b>您無法在稍後重設限制。",
  "change-edition.notification.dialog.general.button.grant-permissions": "授予權限",
  "change-edition.notification.dialog.general.button.remove-restrictions": "移除限制",
  "change-edition.notification.dialog.general.title.remove-restrictions-2": "要移除頁面限制嗎？",
  "change-edition.notification.dialog.grand-permissions.confirmation.failed.desc": "我們無法將空間權限授予 {spaceName} 空間的所有使用者。請再試一次。",
  "change-edition.notification.dialog.grand-permissions.confirmation.failed.title": "未授予空間權限",
  "change-edition.notification.dialog.grand-permissions.confirmation.success.desc": "任何已登入的使用者現在都可以檢視「{spaceName}」空間、在其中新增內容等等。",
  "change-edition.notification.dialog.grand-permissions.confirmation.success.title": "已授予空間權限",
  "change-edition.notification.dialog.grand-permissions.text": "您即將對所有使用者授予此空間的權限。<b>此動作無法復原。</b>您將無法在稍後重設空間權限。",
  "change-edition.notification.dialog.grand-permissions.title": "要授予空間權限嗎？",
  "change-edition.notification.dialog.space.text.remove-restrictions": "您使用的是 Free 方案，因此只能從「<b>{contentTitle}</b>」中<b>移除所有限制</b>。<b>此動作無法復原。</b>您無法在稍後重設限制。",
  "change-edition.page-insights.body": "當您升級至 Confluence Standard 方案時，追蹤檢視次數以了解您的內容成效。",
  "change-edition.page-insights.learn-more-link": "探索深入解析",
  "change-edition.page-insights.title": "利用內容深入解析來查看趨勢",
  "change-edition.page-restrictions.body.bullet.one": "{checkIcon} 選擇誰可以在內容上檢視、編輯或留言",
  "change-edition.page-restrictions.body.bullet.two": "{checkIcon} 確保您的內容安全",
  "change-edition.page-restrictions.learn-more-link": "探索限制",
  "change-edition.page-restrictions.title": "升級以控管存取權",
  "change-edition.premium-extension-config-panel.body.admin": "升級以讓此內容保持在最新狀態。",
  "change-edition.premium-extension-config-panel.body.non-admin": "請聯繫您的管理員進行升級，以編輯此內容。",
  "change-edition.premium-extension-insert.body.admin": "使用進階的樣式和呈現方式，為您的內容提供與眾不同的新外觀。",
  "change-edition.premium-extension-insert.body.non-admin": "使用進階的樣式和呈現方式，為您的內容提供與眾不同的新外觀。請聯繫管理員進行升級。",
  "change-edition.premium-extension-insert.title": "讓頁面脫穎而出",
  "change-edition.public-links.banner-dismiss-label": "關閉",
  "change-edition.public-links.edit-whiteboard-upsell-learn-more-link-text": "進一步了解 Confluence 方案",
  "change-edition.public-links.edit-whiteboard-upsell-message": "<b>升級以取得可編輯的公開白板。</b>透過分享網際網路上任何人皆可檢視且可編輯的白板，增進此網站上使用者的協作。",
  "change-edition.public-links.upsell.share-page-description": "您的團隊可以使用公開連結，與網際網路上的任何人分享內容。",
  "change-edition.public-links.upsell.share-page-title": "公開分享此內容",
  "change-edition.public-links.upsell.upgrade-button-text": "升級",
  "change-edition.public-links.upsell.upgrade-learn-more-button-text": "深入了解",
  "change-edition.section.message.content-restrictions.grandfathered.body": "此內容會繼承「{parent}」的限制。",
  "change-edition.section.message.content-restrictions.grandfathered.title": "只有部分人員能檢視此內容",
  "change-edition.section.message.content.grandfathered.button.link-2": "移除內容的限制",
  "change-edition.section.message.general.button.link": "深入瞭解",
  "change-edition.section.message.non-admin-space.body": "您使用的是免費方案，因此無法為新空間設定預設權限。任何已登入的使用者都可以檢視新空間、在其中新增頁面等等。",
  "change-edition.section.message.non-admin.content.grandfathered.body": "您使用的是免費方案，因此無法變更這些權限。",
  "change-edition.section.message.non-admin.global-permissions.title": "全域權限僅適用於付費方案",
  "change-edition.section.message.non-admin.grandfathered.space-restricted-pages.body": "您使用的是 Free 方案，因此只能按一下下方的鎖定圖示，來移除內容的所有限制。",
  "change-edition.section.message.non-admin.page-restrictions.body": "您使用的是免費方案，因此任何已登入的使用者都可以檢視和編輯。",
  "change-edition.section.message.non-admin.space-permissions.title": "空間權限僅適用於付費方案",
  "change-edition.section.message.non-admin.space-restricted-pages.body": "您使用的是免費方案，因此任何已登入的使用者都可以檢視和編輯所有內容。",
  "change-edition.section.message.non-site-admin-audit-logs.body": "您使用的是免費方案，因此無法在稽核記錄中檢視和追蹤在您網站上所做的變更。",
  "change-edition.section.message.non-site-admin.audit-logs.title": "稽核記錄僅適用於付費方案",
  "change-edition.section.message.non-site-admin.content-restrictions.title": "內容層級限制僅適用於付費方案",
  "change-edition.section.message.non-site-admin.global.body": "您使用的是免費方案，因此無法變更全域權限，用以定義他人可在您的網站上執行的動作。",
  "change-edition.section.message.non-site-admin.space-permissions.grandfathered.can.clear.body": "您使用的是免費方案，因此無法變更空間權限。如有需要，您可以對所有使用者授予此空間的權限。(匿名使用者不會獲得權限。)",
  "change-edition.section.message.non-site-admin.space-permissions.grandfathered.cant.clear.body": "您使用的是 Free 方案，因此任何已登入的使用者都可以檢視此空間、在其中新增內容等等。",
  "change-edition.section.message.site-admin-audit-logs.body": "您使用的是免費方案，因此無法在稽核記錄中檢視和追蹤在您網站上所做的變更。若要存取稽核記錄，請升級您的方案。",
  "change-edition.section.message.site-admin-space.body": "您使用的是免費方案，因此無法為新空間設定預設權限。任何已登入的使用者都可以檢視新空間、在其中新增頁面等等。若要設定預設空間權限，請升級您的方案。",
  "change-edition.section.message.site-admin.audit-logs.title": "升級以取得稽核記錄",
  "change-edition.section.message.site-admin.content-restrictions.title": "針對內容層級限制升級",
  "change-edition.section.message.site-admin.content.grandfathered.body": "您使用的是免費方案，因此無法變更這些權限。若要設定限制，請升級您的方案。",
  "change-edition.section.message.site-admin.global-permissions.title": "升級以取得全域權限",
  "change-edition.section.message.site-admin.global.body": "您使用的是免費方案，因此無法變更這些權限。若要設定全域權限，並定義他人可在您的網站上執行哪些動作，請升級您的方案。",
  "change-edition.section.message.site-admin.page-restrictions.body": "您使用的是免費方案，因此任何已登入的使用者都可以檢視和編輯。若要設定限制，請升級您的方案。",
  "change-edition.section.message.site-admin.space-permissions.title": "升級以取得空間權限",
  "change-edition.section.message.site-admin.space-restricted-pages.body": "您使用的是免費方案，因此任何已登入的使用者都可以檢視和編輯所有內容。若要設定限制，請升級您的方案。",
  "change-edition.section.message.space-permissions.grandfathered.button.link": "將此空間的權限授予所有使用者",
  "change-edition.section.message.space-permissions.grandfathered.noclear.text": "您使用的是免費方案，因此無法變更空間權限。若要設定空間的權限，請升級您的方案。",
  "change-edition.section.message.space-permissions.grandfathered.text": "您使用的是免費方案，因此無法變更空間權限。若要設定空間的權限，請升級您的方案。如有需要，您可以對所有使用者授予此空間的權限。(匿名使用者不會獲得權限。)",
  "change-edition.section.message.space-restricted-pages.text": "您使用的是 Free 方案，因此只能按一下下方的鎖定圖示，來移除內容的所有限制。若要設定限制，請升級您的方案。",
  "change-edition.section.message.try.free": "免費試用",
  "change-edition.share-and-restrict-dialog.inspect-permissions.learn-more-link": "深入了解",
  "change-edition.share-and-restrict-dialog.inspect-permissions.upsell-info": "升級至 Premium 方案以了解為什麼使用者會無法存取內容。",
  "change-edition.share-and-restrict-dialog.inspect-permissions.upsell-title": "檢查權限",
  "change-edition.share-and-restrict-dialog.restrictions.body": "您正在使用 Free 方案。在付費方案中，您可以將內容限制為只有特定人員可以存取。",
  "change-edition.share-and-restrict-dialog.restrictions.learn-more-link": "深入了解",
  "change-edition.share-and-restrict-dialog.restrictions.title": "控管誰可以檢視和編輯內容",
  "change-edition.share-and-restrict-inline-message.open-up-access": "開放存取權",
  "change-edition.team-calendar.explore-team-calendar": "探索團隊行事曆",
  "change-edition.team-calendar.upsell-section-message": "將多個行事曆整合至單一平台，大幅提升團隊的生產力。",
  "change-edition.team-calendar.upsell-section-message-bold": "透過團隊行事曆，將人員、截止日期和排程整合在一起。",
  "change-edition.team-calendar.upsell.image.alt-text": "「團隊行事曆」圖片",
  "change-edition.upflow-commerce-router.error-flag.message": "請再試一次。如果問題持續發生，請嘗試聯繫 {supportLink}",
  "change-edition.upflow-commerce-router.error-flag.title": "我們現在無法升級您的方案",
  "change-edition.upgrade.try.free": "免費試用",
  "change-edition.upgrade.try.now": "立即試用",
  "change-edition.upgrade.try.premium": "試用 Premium 方案",
  "change-edition.user-access.bold.message": "升級以檢查權限。",
  "change-edition.user-access.explore-permissions.button.label": "探索權限",
  "change-edition.user-access.message": "查看使用者在要求來自父系項目或空間的權限時是否遭到拒絕。如需診斷及修正權限議題的工具，請升級至 Premium 方案。",
  "change-edition.whiteboard-upsell.paywall-read-only-banner.text-admin": "<b>此白板為唯讀模式。</b>您目前所用的方案只能有三個作用中的白板。請升級至 Premium 方案，即可使用不限數量的白板。",
  "change-edition.whiteboard-upsell.paywall-read-only-banner.text-non-admin": "<b>此白板為唯讀模式。</b>您目前所用的方案只能有三個作用中的白板。請向管理員提議升級至 Premium 方案，即可使用不限數量的白板。",
  "change-edition.whiteboards-upsell.modal.closeButtonLabel": "關閉強制回應",
  "change-stager.cancel-button-label": "取消",
  "change-stager.edit-button-label": "編輯",
  "change-stager.save-button-label": "儲存",
  "changes-diff.added-content.end": "插入的內容結束。",
  "changes-diff.added-content.start": "插入的內容開始：",
  "changes-diff.changed-content.end": "格式變更結束。",
  "changes-diff.changed-content.start": "格式變更開始：",
  "changes-diff.removed-content.end": "刪除的內容結束。",
  "changes-diff.removed-content.start": "刪除的內容開始：",
  "color-picker.blue": "藍色",
  "color-picker.bold-blue": "個性藍",
  "color-picker.bold-gray": "個性灰",
  "color-picker.bold-green": "個性綠",
  "color-picker.bold-lime": "個性檸檬黃",
  "color-picker.bold-magenta": "個性洋紅",
  "color-picker.bold-orange": "個性橘",
  "color-picker.bold-purple": "個性紫",
  "color-picker.bold-red": "個性紅",
  "color-picker.bold-teal": "個性藍綠",
  "color-picker.bold-yellow": "個性黃",
  "color-picker.color-picker-dropdown.close-button-label": "關閉",
  "color-picker.color-picker-dropdown.header-text": "選取顏色",
  "color-picker.color-picker-dropdown.reset-button-text": "重設為預設值",
  "color-picker.color-validation-messages.confirmation-message": "已新增顏色選擇",
  "color-picker.color-validation-messages.contrast-ratio-fail-message": "未通過輔助工具標準",
  "color-picker.color-validation-messages.contrast-ratio-pass-message": "通過輔助工具標準",
  "color-picker.color-validation-messages.error-message": "輸入有效的顏色",
  "color-picker.custom-palette.add-button-text": "新增",
  "color-picker.default-blue": "預設藍色",
  "color-picker.default-white": "預設白色",
  "color-picker.gray": "灰色",
  "color-picker.green": "綠色",
  "color-picker.light-blue": "淺藍色",
  "color-picker.light-gray": "淺灰色",
  "color-picker.light-green": "淺綠色",
  "color-picker.light-lime": "淺檸檬黃",
  "color-picker.light-magenta": "淺洋紅色",
  "color-picker.light-orange": "淺橘色",
  "color-picker.light-purple": "淺紫色",
  "color-picker.light-red": "淺紅色",
  "color-picker.light-teal": "淺藍綠色",
  "color-picker.light-yellow": "淺黃色",
  "color-picker.lime": "檸檬黃",
  "color-picker.magenta": "洋紅色",
  "color-picker.orange": "橘色",
  "color-picker.pressable-color-tile.check-icon-label": "已選取",
  "color-picker.purple": "紫色",
  "color-picker.red": "紅色",
  "color-picker.subtle-blue": "內斂藍",
  "color-picker.subtle-gray": "內斂灰",
  "color-picker.subtle-green": "內斂綠",
  "color-picker.subtle-lime": "內斂檸檬黃",
  "color-picker.subtle-magenta": "內斂洋紅",
  "color-picker.subtle-orange": "內斂橘",
  "color-picker.subtle-purple": "內斂紫",
  "color-picker.subtle-red": "內斂紅",
  "color-picker.subtle-teal": "內斂藍綠",
  "color-picker.subtle-yellow": "內斂黃",
  "color-picker.teal": "藍綠色",
  "color-picker.white": "白色",
  "color-picker.yellow": "黃色",
  "comment-button.tooltip": "顯示留言",
  "comment-dialogs.unsaved.warning.dialog.heading": "您想要放棄此留言嗎？",
  "comment-dialogs.warning.dialog.cancel.button": "取消",
  "comment-dialogs.warning.dialog.delete.action": "刪除",
  "comment-dialogs.warning.dialog.delete.content": "如果這麼做，您的留言會永久移除。",
  "comment-dialogs.warning.dialog.delete.heading": "您要刪除此留言嗎？",
  "comment-dialogs.warning.dialog.unsaved.action": "捨棄",
  "comment-dialogs.warning.dialog.unsaved.content": "如果這麼做，您將會失去留言。",
  "comment-extension-handlers.fallback.action": "按一下以檢視內容",
  "comment-extension-handlers.fallback.reason": "無法內嵌顯示，因為這是在舊版\n          Confluence 中建立的。",
  "comment-extension-handlers.unsupported.fallback": "無法顯示此內容，因為這是在舊版 Confluence 中建立的且不受支援。",
  "comment-simple.add.prompt.placeholder": "撰寫留言...",
  "comment.create.draft.annotation.removed": "醒目提示的內容已刪除，因此無法新增此留言。請複製留言並將新內容醒目提示，以便新增。",
  "comment.editor.add.button": "新增",
  "comment.editor.add.object.comment.button": "新增留言",
  "comment.editor.aria.label.text": "留言區域，開始打字即可輸入文字。",
  "comment.editor.cancel.button": "取消",
  "comment.editor.draft.load.title": "留言已還原",
  "comment.editor.draft.load.title.question": "要還原留言嗎？",
  "comment.editor.empty.comment": "您的留言空白。新增意見反應，然後按一下「新增」。",
  "comment.editor.error.unexpected": "儲存此留言時發生問題。請關閉留言或重新整理，然後再次嘗試新增留言。",
  "comment.editor.media.add.warning": "您沒有在此處新增檔案或圖片的權限。請與您的空間管理員聯繫。",
  "comment.editor.placeholder.easy.ai": "輸入 /ai 即表示 Atlassian Intelligence，輸入 / 可新增元素，輸入 @ 可提及某人 (我們會通知他們)。",
  "comment.editor.placeholder.easy.mentions": "輸入 @ 以提及某人。我們會通知他們。",
  "comment.editor.placeholder.easy.mentions.guests": "留下留言...",
  "comment.editor.placeholder.panel": "新增文字、@提及他人，或使用 / 輸入元素",
  "comment.editor.reply.placeholder": "回覆",
  "comment.editor.save.button": "儲存",
  "comment.editor.unable.to.load.draft": "無法載入您的留言草稿。請再試一次或重新建立留言",
  "comment.editor.unsaved.comment.lost": "您的留言將會遺失",
  "comment.loomButton.addLoomVideoComment": "錄製 Loom 影片留言",
  "comment.loomButton.crossJoinEntryPointAriaLabel": "加入 Loom 上的團隊，以錄製影片",
  "comment.loomButton.crossSellPopupCardDescription": "為您的團隊提供更多背景資訊，以便他們快速理解內容和給予回應。",
  "comment.loomButton.crossSellPopupCardTitle": "透過影片新增更多背景資訊",
  "comment.loomButton.recordLoomVideoComment": "錄製",
  "comment.no.delete.overflow.menu.label": "刪除",
  "comment.no.delete.reason.text": "您無法刪除此留言，因為已有人回覆此留言。",
  "comment.no.edit.action.text": "新增留言",
  "comment.no.edit.inline.label": "無法進行編輯",
  "comment.no.edit.overflow.menu.label": "編輯",
  "comment.no.edit.reason.text": "因為無法編輯此項；其包含在舊版 Confluence 中建立的內容。",
  "comment.refresh.content.instructions": "並且醒目顯示以儲存您的留言。",
  "comment.refresh.content.link": "取得最新版本",
  "comment.renderer.definition.restricted.to.blogpost.option": "在這篇部落格貼文上",
  "comment.renderer.definition.restricted.to.page.option": "此頁面上",
  "comment.renderer.definition.restricted.to.site.option": "在這個網站上",
  "comment.renderer.definition.restricted.to.space.option": "在這個空間中",
  "comment.renderer.display.name.anonymous": "匿名",
  "comment.renderer.edited.by": "{username} 已於 {at} 編輯",
  "comment.renderer.edited.in.parentheses": "(已編輯)",
  "comment.resolved.comment.action.label": "此留言已解決",
  "comment.unsaved.warning.prompt": "您想要放棄此留言嗎？如果這麼做，您將會失去留言。",
  "comments-panel.comment-bulk-actions.all-comments-marked-as-read": "所有留言皆已標示為已讀",
  "comments-panel.comment-bulk-actions.all-comments-marked-as-resolved": "所有留言皆已標示為已解決",
  "comments-panel.comment-bulk-actions.comments-failed-to-resolve": "留言無法解決。請再試一次。",
  "comments-panel.comment-bulk-actions.failed-to-mark-all-comments-as-read": "無法將所有留言標示為已讀。請再試一次。",
  "comments-panel.comment-bulk-actions.mark-all-as-read": "全部標示為已讀",
  "comments-panel.comment-bulk-actions.mark-all-as-resolved": "全部標示為已解決",
  "comments-panel.comment-bulk-actions.retry-now": "立即重試",
  "comments-panel.comment-thread.general.nested.replies.has.unread": "有未讀取的回覆",
  "comments-panel.comment-thread.go.to.nested.general.reply": "前往更多回覆",
  "comments-panel.comment-thread.hide.replies": "隱藏回覆",
  "comments-panel.comment-thread.hide.reply": "隱藏回覆",
  "comments-panel.comment-thread.show.more.replies": "{numOfHiddenReplies, plural, other {顯示其他 {numOfHiddenReplies,number} 則回覆}}",
  "comments-panel.comment-thread.show.more.replies.for.standalone": "{numOfHiddenReplies, plural, other {其他 {numOfHiddenReplies,number} 則回覆}}",
  "comments-panel.comment-thread.show.reply": "顯示回覆",
  "comments-panel.comment.reopen.failed.flag.cta.retry": "立即重試",
  "comments-panel.comment.reopen.failed.flag.title": "無法重新開啟留言",
  "comments-panel.comment.reopened.flag.title": "已重新開啟留言",
  "comments-panel.comment.thread.type-seperator": "一般留言",
  "comments-panel.comments.add.prompt-placeholder": "新增文字、@提及他人，或使用 / 輸入元素",
  "comments-panel.comments.panel.header-icon.label": "留言",
  "comments-panel.could.not.delete.title": "無法刪除留言",
  "comments-panel.empty.open.comments.body.text": "醒目提示某些文字並選取 {highlighted}，或在此面板底部新增留言。",
  "comments-panel.empty.open.comments.header.text": "成為第一個留言的人",
  "comments-panel.empty.unread.comments.body.text": "您尚未閱讀的留言將會顯示在這裡。",
  "comments-panel.empty.unread.comments.header.text": "沒有未讀留言",
  "comments-panel.empty.unread.comments.view.open.comments": "檢視待處理的留言",
  "comments-panel.error.panel.message": "發生錯誤。",
  "comments-panel.error.panel.retry.button.label": "立即重試",
  "comments-panel.filter.and.sort.label": "篩選和排序",
  "comments-panel.filter.title": "篩選",
  "comments-panel.general-comments.label": "一般留言",
  "comments-panel.inline-comments.label": "內嵌留言",
  "comments-panel.most-recent.label": "新 → 舊",
  "comments-panel.open.view.label": "開啟",
  "comments-panel.page-order.label": "頂端 → 底部",
  "comments-panel.panel.header.label": "留言",
  "comments-panel.reply.action": "回覆",
  "comments-panel.resolved.view.empty.header.text": "沒有已解決的留言",
  "comments-panel.resolved.view.empty.text": "有不需要的留言嗎？可以標示為已解決。留言將顯示在此處，以便您重新開啟並在未來新增回來。",
  "comments-panel.resolved.view.label": "已解決",
  "comments-panel.show.title": "顯示",
  "comments-panel.sort.title": "排序",
  "comments-panel.unread.view.label": "未讀取",
  "common-edit-button.edit.button": "編輯",
  "company-home-builder.company-hub-space-create-modal.create-system-space-error-flag-description": "再試一次以繼續設定您的登陸頁面。",
  "company-home-builder.company-hub-space-create-modal.create-system-space-error-flag-title": "發生錯誤",
  "company-home-builder.company-hub-space-create-modal.create-system-space-permissions-error-flag-button": "前往權限",
  "company-home-builder.company-hub-space-create-modal.create-system-space-permissions-error-flag-description": "您需要<b>建立空間</b>的權限，才能建立此中心。",
  "company-home-builder.company-hub-space-create-modal.create-system-space-permissions-error-flag-title": "您需要權限",
  "company-home-builder.company-hub-space-create-modal.create-system-space-stale-permissions-error-flag-button": "知道了",
  "company-home-builder.company-hub-space-create-modal.create-system-space-stale-permissions-error-flag-description": "只有產品管理員才能建立和啟動<a>公司中心</a>",
  "company-home-builder.company-hub-space-create-modal.create-system-space-stale-permissions-error-flag-title": "我們無法建立您的中心",
  "company-home-builder.customize-navigation.heading": "自訂導覽",
  "company-home-builder.error-screen.not-found": "找不到",
  "company-home-builder.error-screen.restricted-content": "受限制的內容",
  "company-home-builder.save-success-message": "設定已更新",
  "company-home-builder.update-site-look-and-feel-mutation.error-flag.description": "無法儲存您的喜好設定。請再試一次。",
  "company-home-builder.update-site-look-and-feel-mutation.error-flag.title": "未儲存的喜好設定",
  "company-hub-utils.change-hub-name-dialog.cancel": "取消",
  "company-hub-utils.change-hub-name-dialog.confirm": "確認",
  "company-hub-utils.change-hub-name-dialog.description": "該名稱將顯示在導覽和中心的自訂 Web 連結中。{lineBreak}您可以視需要隨時變更。",
  "company-hub-utils.change-hub-name-dialog.field-label": "命名此中心",
  "company-hub-utils.change-hub-name-dialog.first-time-description": "歡迎來到公司中心，員工可在此處取得他們最需要的新資訊。{lineBreak}請先為中心提供不重複的名稱。您可以在稍後視需要變更名稱。",
  "company-hub-utils.change-hub-name-dialog.first-time-helper-text": "此名稱將顯示在導覽和中心的自訂網路連結中 (例如：「Acme Central」、「Globex Hub」)。",
  "company-hub-utils.change-hub-name-dialog.first-time-title": "將此中心設為新的據點",
  "company-hub-utils.change-hub-name-dialog.helper-text": "例如：「Acme Central」、「Globex Hub」",
  "company-hub-utils.change-hub-name-dialog.new-lozenge-label": "全新",
  "company-hub-utils.change-hub-name-dialog.skip": "略過",
  "company-hub-utils.change-hub-name-dialog.submit": "提交",
  "company-hub-utils.change-hub-name-dialog.title": "變更中心名稱",
  "company-hub-utils.feedback-collector.preamble.first-line": "您的意見非常寶貴，能讓 Atlassian 知道如何更加符合您的需求。這項功能有哪裡可以改善？{lineBreak}",
  "company-hub-utils.feedback-collector.summary-placeholder": "哪些功能效果很好？有哪裡可以改善？",
  "company-hub-utils.feedback-collector.title-generic": "歡迎提供意見反應",
  "company-hub-utils.feedback-collector.title-specific": "{type, select, Cards {我們很樂於收到關於卡片的意見反應} Carousel {我們很樂於收到關於輪播的意見反應} Linksmenu {歡迎提供關於「連結」選單的意見反應} Spotlight {歡迎提供關於「聚光燈」的意見反應} Section {歡迎提供關於「區段」的意見反應} Companyhub {歡迎提供關於「公司中心」的意見反應} other {歡迎提供意見反應}}",
  "company-hub-utils.hub-app-change-hub-name-dialog.submit": "提交",
  "company-hub-utils.hub-app.change-hub-name-dialog.field-label": "為您的中心提供專屬名稱",
  "company-hub-utils.hub-app.change-hub-name-dialog.first-time-description": "為整個組織自訂一個官方資訊終點站。",
  "company-hub-utils.hub-app.change-hub-name-dialog.first-time-helper-text": "此名稱將顯示在導覽和中心的自訂網路連結中 (例如：「Acme Central」、「Globex Hub」)。",
  "company-hub-utils.hub-app.change-hub-name-dialog.first-time-title": "歡迎來到公司中心",
  "company-hub-utils.hub-app.change-hub-name-dialog.skip": "暫時跳過",
  "company-hub-utils.hub-name-change.dialog.on-submit.error.text": "發生錯誤，請重新載入並再試一次。",
  "company-hub-utils.hub-name-change.dialog.on-submit.success-flag.description": "您的中心現在是「{hubName}」。",
  "company-hub-utils.hub-name-change.dialog.on-submit.success-flag.title": "中心名稱已變更",
  "company-hub-utils.hub-name-change.dialog.validation-error.name-too-long": "名稱必須在 25 個字元以內。",
  "company-hub-utils.hub-settings.button-tooltip": "管理",
  "company-hub-utils.hub-settings.entry-button": "中心設定",
  "company-hub-utils.hub-status-lozenge.general.dashboard.pill.not-published": "未發布",
  "company-hub-utils.hub-status-lozenge.general.dashboard.pill.published": "已發佈",
  "company-hub-utils.hub-status-lozenge.general.dashboard.tooltip.not-published": "只有您和其他管理員、編輯者才能看到您的中心。 在您發布之前，公司其他人將不會看到您的中心。",
  "company-hub-utils.hub-status-lozenge.general.dashboard.tooltip.published": "公司中的所有人都可以看到您的中心",
  "company-hub-utils.share-feedback-button.label": "分享有關公司中心的意見反應",
  "company-hub.analytics-page.error-screen.not-found": "找不到",
  "company-hub.analytics-page.hub-settings.analytics.title": "分析",
  "company-hub.analytics.analytic-box-base.clicks-info-icon-label": "{timePeriod, select, DAY {{count, plural, other {在過去 {count} 天內，於中心內所有已連結內容中收到的點擊次數總計}}} WEEK {{count, plural, other {在過去 {count} 週內，於中心內所有已連結內容中收到的點擊次數總計}}} MONTH {{count, plural, other {在過去 {count} 個月內，於中心內所有已連結內容中收到的點擊次數總計}}} other {在過去於中心內所有已連結內容中收到的點擊次數總計}}",
  "company-hub.analytics.analytic-box-base.ctr-info-icon-label": "收到的點擊次數與中心的總曝光次數相比的平均百分比。",
  "company-hub.analytics.analytic-box-base.error.title": "擷取資料時發生錯誤",
  "company-hub.analytics.analytic-box-base.unique-visitors-info-icon-label": "{timePeriod, select, DAY {{count, plural, other {在過去 {count} 天內，至少造訪過中心一次的不同使用者數目}}} WEEK {{count, plural, other {在過去 {count} 週內，至少造訪過中心一次的不同使用者數目}}} MONTH {{count, plural, other {在過去 {count} 個月內，至少造訪過中心一次的不同使用者數目}}} other {在過去至少造訪過中心一次的不同使用者數目}}",
  "company-hub.analytics.analytic-box-base.views-info-icon-label": "{timePeriod, select, DAY {{count, plural, other {在過去 {count} 天內，瀏覽器存取中心的次數。\n\t\t\t檢視畫面只會呈現在此執行個體上託管的內容。}}} WEEK {{count, plural, other {在過去 {count} 週內，瀏覽器存取中心的次數。\n\t\t\t檢視畫面只會呈現在此執行個體上託管的內容。}}} MONTH {{count, plural, other {在過去 {count} 個月內，瀏覽器存取中心的次數。\n\t\t\t檢視畫面只會呈現在此執行個體上託管的內容。}}} other {瀏覽器在過去存取中心的次數。\n\t\t\t檢視畫面只會呈現在此執行個體上託管的內容。}}",
  "company-hub.analytics.boxes-row.clicks-title": "點擊次數",
  "company-hub.analytics.boxes-row.ctr-title": "點擊率 (平均)",
  "company-hub.analytics.boxes-row.unique-visitors-title": "不重複的造訪者",
  "company-hub.analytics.boxes-row.views-title": "檢視",
  "company-hub.analytics.hub-analytics-chart.hub-clicks-label": "點擊次數",
  "company-hub.analytics.hub-analytics-chart.hub-ctr-label": "點擊率 (平均)",
  "company-hub.analytics.hub-analytics-chart.hub-unique-visitors-label": "不重複的造訪者",
  "company-hub.analytics.hub-analytics-chart.hub-views-label": "檢視次數",
  "company-hub.analytics.hub-analytics-chart.main-statistic": "{value} 個{lastGranularityDescription}",
  "company-hub.analytics.hub-analytics-table.caption": "最高中心曝光次數",
  "company-hub.analytics.hub-analytics-table.clicks-column-heading": "點擊次數",
  "company-hub.analytics.hub-analytics-table.ctr-column-heading": "點擊率",
  "company-hub.analytics.hub-analytics-table.ctr-tooltip-message": "連結的點擊率",
  "company-hub.analytics.hub-analytics-table.error-message": "擷取表格資料時發生錯誤。",
  "company-hub.analytics.hub-analytics-table.publish-date-column-heading": "發布日期",
  "company-hub.analytics.hub-analytics-table.search-empty": "沒有符合您條件的結果",
  "company-hub.analytics.hub-analytics-table.seen-by-column-heading": "查看次數",
  "company-hub.analytics.hub-analytics-table.title-column-heading": "標題",
  "company-hub.analytics.hub-analytics-table.unique-visitors-column-heading": "不重複的造訪者",
  "company-hub.analytics.search-filter.clear-label": "清除搜尋",
  "company-hub.analytics.search-filter.label": "熱門內容搜尋",
  "company-hub.analytics.search-filter.placeholder": "依標題搜尋",
  "company-hub.edit-perms-banner.close": "關閉",
  "company-hub.edit-perms-banner.message": "<b>只有您和其他中心編輯者可以檢視和進行變更。</b>準備好後，選取<b>發布</b>，向所有人顯示中心。",
  "company-hub.hub-editor-preview.close-button-label": "關閉",
  "company-hub.hub-editor-preview.preview-pill-text": "預覽",
  "company-hub.hub-preview-as-dropdown.accessible-to-everyone-option": "共同檢視",
  "company-hub.hub-preview-as-dropdown.admin-hub-group-redirect": "在「管理」中檢視群組成員",
  "company-hub.hub-preview-as-dropdown.preview-as.default": "預覽：共同檢視",
  "company-hub.hub-preview-as-dropdown.preview-as.group": "預覽：{groupName}",
  "company-hub.hub-preview-as-dropdown.search-groups": "搜尋群組",
  "company-hub.hub-preview-header.restore-button-label": "還原此版本",
  "company-hub.hub-preview-header.title": "第 {version} 版",
  "company-hub.hub-settings.general.dashboard.edit-hub-button-label": "編輯中心",
  "company-hub.hub-settings.general.dashboard.edited-time": "已編輯 {formattedTime}",
  "company-hub.hub-settings.general.dashboard.ellipsis-menu.deactivate": "停用",
  "company-hub.hub-settings.general.dashboard.ellipsis-menu.deactivate.tooltip": "只有產品管理員可以停用中心。",
  "company-hub.hub-settings.general.dashboard.ellipsis-menu.history": "歷程記錄",
  "company-hub.hub-settings.general.dashboard.ellipsis-menu.label": "更多動作",
  "company-hub.hub-settings.general.dashboard.ellipsis-menu.rename": "重新命名",
  "company-hub.hub-settings.general.dashboard.ellipsis-menu.rename.tooltip": "只有中心管理員可以重新命名中心。",
  "company-hub.hub-settings.general.dashboard.error.primary.title": "我們在載入此卡片時遇到問題。",
  "company-hub.hub-settings.general.dashboard.error.secondary-title": "請重新載入以再試一次。",
  "company-hub.hub-settings.general.dashboard.version-label": "第 {versionNumber} 版",
  "company-hub.hub-settings.general.header-title": "您的中心",
  "company-hub.hub-settings.general.share-feedback-button.label": "提供有關公司中心的意見反應",
  "company-hub.hub-settings.header-description": "公司中心是您的動態和自訂資訊中心，員工可以在其中獲取經過驗證的最新消息和公告，以及他們最需要的資源。<link>深入了解</link>",
  "company-hub.hub-settings.header-title": "公司中心設定",
  "company-hub.hub-settings.navigation.analytics-title": "分析",
  "company-hub.hub-settings.navigation.general-title": "一般",
  "company-hub.hub-settings.navigation.users-title": "使用者",
  "company-hub.hub-settings.permissions.info.description": "您可以在「管理員設定」中找到。",
  "company-hub.hub-settings.permissions.info.redirect": "前往「公司中心」權限",
  "company-hub.hub-settings.permissions.info.title": "我們正在更新中心的權限",
  "company-hub.hub-settings.permissions.no.access.description": "目前只有管理員可以變更「公司中心」權限。{supportLink}",
  "company-hub.hub-settings.permissions.no.access.description.link": "深入了解",
  "company-hub.hub-settings.permissions.no.access.title": "無法檢視設定",
  "company-hub.hub-view.hub-preview-footer.next-version-label": "後續版本",
  "company-hub.hub-view.hub-preview-footer.previous-version-label": "先前的版本",
  "company-hub.publish-hub-dialog.cancel-button.label": "取消",
  "company-hub.publish-hub-dialog.description.text": "選取 <strong>{submitButtonLabel}</strong> 以啟動您的中心，並且向整個公司顯示。",
  "company-hub.publish-hub-dialog.submit-button.label": "確認",
  "company-hub.publish-hub-dialog.title.text": "準備好向所有人顯示這個中心了嗎？",
  "company-hub.recent-activity-chart.main-statistic": "{value} 個{lastGranularityDescription}",
  "company-hub.recent-activity-chart.title": "中心檢視",
  "company-hub.recent-activity-chart.views-label": "檢視次數",
  "company-hub.recent-activity-section.title": "最近的活動",
  "company-hub.recent-activity.error.description": "請重新整理頁面。如果持續發生問題，請<Link>連絡支援人員</Link>。",
  "company-hub.recent-activity.error.title": "載入錯誤",
  "company-hub.recent-activity.error.title.icon-label": "錯誤圖示",
  "company-hub.recent-activity.leaderboard-row.label": "{count, plural, other {{count} 次點擊}}",
  "company-hub.recent-activity.leaderboard.empty": "還沒有可以顯示的。請稍後再返回查看。",
  "company-hub.recent-activity.leaderboard.title": "點擊次數最多的項目",
  "company-hub.recent-activity.view-analytics-link": "檢視分析",
  "company-hub.unpublish-hub-dialog.cancel-button.label": "取消",
  "company-hub.unpublish-hub-dialog.description.text": "若要關閉此中心，避免再次顯示於整個公司，請選取 <strong>{submitButtonLabel}</strong>。",
  "company-hub.unpublish-hub-dialog.error-flag.description": "我們無法停用此中心。請再試一次。",
  "company-hub.unpublish-hub-dialog.error-flag.title": "發生錯誤",
  "company-hub.unpublish-hub-dialog.submit-button.label": "確認",
  "company-hub.unpublish-hub-dialog.success-flag.description": "不會再向任何人顯示中心。您可以隨時發布以重新啟用。",
  "company-hub.unpublish-hub-dialog.success-flag.title": "此中心已停用",
  "company-hub.unpublish-hub-dialog.title.text": "要停用此中心嗎？",
  "conditional-publish-dialog.cancel.button": "取消",
  "confluence-analytics.abbreviatedByLineUpSell.buttonText": "查看檢視次數",
  "confluence-analytics.active-readers-card.title": "最活躍的讀者",
  "confluence-analytics.active-readers-card.views-count": "{count, plural, other {<b>{count}</b><small> 次檢視</small>}}",
  "confluence-analytics.analytics-dialog.user-list.engagement-column.label": "參與",
  "confluence-analytics.analytics-dialog.user-list.engagement-column.tooltip": "已參與檢視是指使用者在頁面上花費超過 20 秒的工作階段。",
  "confluence-analytics.analytics-dialog.user-list.engagement-column.tooltip.label": "參與資訊",
  "confluence-analytics.analytics-dialog.user-list.recent-viewers-column.label": "最近查閱者",
  "confluence-analytics.analytics-growth-card.enagement-tooltip.brief": "檢視時間不到 20 秒",
  "confluence-analytics.analytics-growth-card.enagement-tooltip.brief-viewer": "檢視不到 20 秒的使用者",
  "confluence-analytics.analytics-growth-card.enagement-tooltip.engaged": "檢視時間超過 20 秒",
  "confluence-analytics.analytics-growth-card.enagement-tooltip.engaged-viewer": "檢視 20 秒以上的使用者",
  "confluence-analytics.analytics-list-card.empty-message": "選取的時間範圍和分組可能無法顯示有意義的資料。請考慮調整設定，以獲得更好的深入解析。",
  "confluence-analytics.analytics-list-card.view-all-button-title": "全部檢視",
  "confluence-analytics.analytics-table.empty-state-message": "自「分析」開始追蹤活動以來，還沒有人檢視過此頁面。",
  "confluence-analytics.analytics-table.empty-state-message.livedocs": "自「分析」開始追蹤活動以來，還沒有人檢視過此頁面或文件。",
  "confluence-analytics.analytics-table.no-results-state-message": "找不到結果",
  "confluence-analytics.analytics-table.pagination-next-button-label": "下一頁",
  "confluence-analytics.analytics-table.pagination-page-results-count-label": "所有結果的第 {start}-{end} 項",
  "confluence-analytics.analytics-table.pagination-page-results-count-with-total-label": "{total, plural, other {第 {start}-{end} 個結果 (總共有 {total,number} 個)}}",
  "confluence-analytics.analytics-table.pagination-previous-button-label": "上一頁",
  "confluence-analytics.analytics-table.sort-asc-icon": "依遞增順序排序",
  "confluence-analytics.analytics-table.sort-desc-icon": "依遞減順序排序",
  "confluence-analytics.avg-ctr-card.no-change": "{dateRange, select, 7D {自上週以來沒有變更} 1M {自上個月以來沒有變更} 3M {自 3 個月以來沒有變更} YTD {自 1 月 1 日以來沒有變更} AllTime {自上週以來沒有變更} other {沒有變更 }}",
  "confluence-analytics.avg-ctr-card.no-new-clicks": "尚未點擊",
  "confluence-analytics.avg-ctr-card.percentage-change": "{dateRange, select, 7D {從 {customPercentage} (自上週以來)} 1M {從 {customPercentage} (自上個月以來)} 3M {從 {customPercentage} (自 3 個月前以來)} YTD {從 {customPercentage} (自 1 月 1 日以來)} AllTime {從 {customPercentage} (自上週以來)} other {從 {customPercentage} }}",
  "confluence-analytics.avg-ctr-card.title-inbound": "來自輸入連結的檢視",
  "confluence-analytics.avg-ctr-card.title-outbound": "平均點擊率",
  "confluence-analytics.avg-ctr-card.tooltip-explanation-outbound": "平均點擊率 (CTR) 是所有連結的點擊次數總計除以檢視次數總計，以百分比表示。",
  "confluence-analytics.avg-ctr-card.up-from-zero-new-clicks": "{dateRange, select, 7D {自上週以來的 0% 提升} 1M {自上個月以來的 0% 提升} 3M {自 3 個月前以來的 0% 提升} YTD {自 1 月 1 日以來的 0% 提升} AllTime {自上週以來的 0% 提升} other {自 0% 提升 }}",
  "confluence-analytics.byLineUpSell.buttonText": "查看有多少人已檢視過此",
  "confluence-analytics.byline.abbreviated-user-views.message": "{count}",
  "confluence-analytics.byline.page-viewers.message": "檢視次數",
  "confluence-analytics.byline.user-views.message": "{count, plural, =0 {分析} other {{count} 個人已檢視}}",
  "confluence-analytics.changeboarding.cancelButton": "關閉",
  "confluence-analytics.changeboarding.content": "全頁分析服務的實用性剛才已大幅提升，並且有了嶄新的外觀！追蹤頁面的成效和相關人員檢視變得比以往還要簡單許多。",
  "confluence-analytics.changeboarding.ctaButton": "立即查看",
  "confluence-analytics.changeboarding.title": "增強的頁面分析",
  "confluence-analytics.chart.accessible-table.caption": "頁面檢視次數",
  "confluence-analytics.chart.accessible-table.header.date": "日期",
  "confluence-analytics.chart.accessible-table.header.view-count": "檢視次數",
  "confluence-analytics.chart.accessible-table.no-view-count-data": "並未檢視",
  "confluence-analytics.chart.default-loading-text": "正在重新整理分析資料...",
  "confluence-analytics.chart.tooltip.no-views-data": "無資料",
  "confluence-analytics.chart.tooltip.views-overall": "{count, plural, other {{count} 次檢視}}",
  "confluence-analytics.chart.tooltip.views-today-so-far": "{count, plural, other {到目前為止有 {count} 次檢視}}",
  "confluence-analytics.content-activity-table.aria-label": "內容活動",
  "confluence-analytics.content-activity-table.column.title-comments": "留言",
  "confluence-analytics.content-activity-table.column.title-created": "已建立",
  "confluence-analytics.content-activity-table.column.title-last-modified": "上次修改",
  "confluence-analytics.content-activity-table.column.title-last-viewed": "上次檢視",
  "confluence-analytics.content-activity-table.column.title-users-viewed": "已檢視的使用者",
  "confluence-analytics.content-activity-table.column.title-views": "檢視",
  "confluence-analytics.content-activity-table.name-search-placeholder": "搜尋內容",
  "confluence-analytics.dialog.close-aria-label": "關閉 Confluence Analytics 非強制回應對話方塊",
  "confluence-analytics.dialog.close-label": "關閉強制回應",
  "confluence-analytics.dialog.container-aria-label": "Confluence Analytics",
  "confluence-analytics.dialog.header": "分析",
  "confluence-analytics.dialog.links-tab.clicks.column-header": "點擊次數",
  "confluence-analytics.dialog.links-tab.error-content-item": "載入此連結時發生錯誤。請重新整理頁面，並再試一次。",
  "confluence-analytics.dialog.links-tab.external-link-content-item": "外部連結",
  "confluence-analytics.dialog.links-tab.external-link-content-item.info.tooltip": "對於外部網站連結，僅提供彙總資料。",
  "confluence-analytics.dialog.links-tab.external-link-content-item.info.tooltip-label": "外部連結工具提示按鈕",
  "confluence-analytics.dialog.links-tab.inbound.column-header": "熱門輸入連結",
  "confluence-analytics.dialog.links-tab.no-inbound-links": "沒有其他頁面參照此頁面。當此頁面從其他來源吸引流量時，這些連結就會顯示在此處。",
  "confluence-analytics.dialog.links-tab.no-outbound-links": "此頁面上沒有輸出連結。當您新增一個輸出連結時，即可在此處追蹤其點擊次數。",
  "confluence-analytics.dialog.links-tab.outbound.column-header": "熱門輸出連結",
  "confluence-analytics.dialog.links-tab.view-all-link": "全部檢視",
  "confluence-analytics.dialog.links-tab.view-more-button": "查看更多深入解析",
  "confluence-analytics.dialog.loading": "正在載入資料...",
  "confluence-analytics.dialog.loading.error-message": "我們在載入分析時遇到問題。",
  "confluence-analytics.dialog.loading.error-suggestion": "請重新整理以再試一次。",
  "confluence-analytics.dialog.loading.mentioned": "正在載入提及資料...",
  "confluence-analytics.dialog.mentioned-users-all-seen": "提及的所有人皆已檢視過",
  "confluence-analytics.dialog.mentioned-users-viewed": "{seenMentionedUsersCount, plural, other {位提及的使用者已檢視此頁面}}",
  "confluence-analytics.dialog.mentions-list.mentioned-people.label": "已提及的人員",
  "confluence-analytics.dialog.mentions-list.not-viewed.label": "未檢視",
  "confluence-analytics.dialog.mentions-list.viewed.label": "已檢視",
  "confluence-analytics.dialog.progress-bar-aria-label": "提及的使用者進度列",
  "confluence-analytics.dialog.progress-bar.count-aria-label": "{seenMentionedUsersCount, plural, other {有 {seenMentionedUsersCount} 位提及的使用者已檢視此頁面 (總共 {totalMentionedUsersCount} 位)}}",
  "confluence-analytics.dialog.user-list.anonymous-user-name": "匿名",
  "confluence-analytics.dialog.user-list.deactivated-user-label": "已停用",
  "confluence-analytics.dialog.viewers-list.viewed-days-ago": "{dayCount, plural, other {{dayCount} 天前}}",
  "confluence-analytics.dialog.viewers-list.viewed-hours-ago": "{hourCount, plural, other {{hourCount} 小時前}}",
  "confluence-analytics.dialog.viewers-list.viewed-just-now": "剛才",
  "confluence-analytics.dialog.viewers-list.viewed-minutes-ago": "{minuteCount, plural, other {{minuteCount} 分鐘前}}",
  "confluence-analytics.dialog.viewers-list.viewed-months-ago": "{monthCount, plural, other {{monthCount} 個月前}}",
  "confluence-analytics.dialog.viewers-list.viewed-weeks-ago": "{weekCount, plural, other {{weekCount} 週前}}",
  "confluence-analytics.dialog.viewers-list.viewed-years-ago": "{yearCount, plural, other {{yearCount} 年前}}",
  "confluence-analytics.engagement-cell.brief": "簡短",
  "confluence-analytics.engagement-cell.engaged": "已參與",
  "confluence-analytics.export-csv-button-title": "匯出為 CSV",
  "confluence-analytics.filters.date-option-1M": "1 個月",
  "confluence-analytics.filters.date-option-1M-expanded-form": "過去 1 個月",
  "confluence-analytics.filters.date-option-3M": "3 個月",
  "confluence-analytics.filters.date-option-3M-expanded-form": "過去 3 個月",
  "confluence-analytics.filters.date-option-7D": "7 天",
  "confluence-analytics.filters.date-option-7D-expanded-form": "過去 7 天",
  "confluence-analytics.filters.date-option-YTD": "年初至今",
  "confluence-analytics.filters.date-option-YTD-expanded-form": "年初至今",
  "confluence-analytics.filters.date-option-all-time": "所有時間",
  "confluence-analytics.filters.date-option-all-time-expanded-form.creation-date-limit": "從 {startDate}開始 (建立日期。)",
  "confluence-analytics.filters.date-option-all-time-expanded-form.one-year-limit": "從 {startDate}開始 (資料最多可用 1 年。)",
  "confluence-analytics.filters.date-option-cal-icon-label": "行事曆圖示",
  "confluence-analytics.filters.date-option-custom": "自訂日期範圍",
  "confluence-analytics.filters.date-option-custom-expanded-form": "自訂日期範圍",
  "confluence-analytics.filters.date-option-expand-icon-label": "展開圖示",
  "confluence-analytics.filters.links": "連結",
  "confluence-analytics.filters.mentions": "提及",
  "confluence-analytics.filters.reset-all-button-text": "全部重設",
  "confluence-analytics.filters.views": "檢視",
  "confluence-analytics.graph.granularity.week": "{date}當週",
  "confluence-analytics.graph.label.created-at": "建立於 {date} {time}",
  "confluence-analytics.graph.label.date-to-datetime": "{fromDate} 至 {toDate} ({toTime})",
  "confluence-analytics.growth-card.engaged-metric-label": "已參與",
  "confluence-analytics.growth-states.decrease-icon-label": "與上週相比，指標下降",
  "confluence-analytics.growth-states.increase-icon-label": "與上週相比，指標上升",
  "confluence-analytics.growth-states.no-change-icon-label": "與上週相比，指標沒有變化",
  "confluence-analytics.help-and-support.label": "協助與支援",
  "confluence-analytics.last-version-visited-cell.version": "第 {versionNumber} 版",
  "confluence-analytics.last-version-visited-cell.version-deleted": "已刪除",
  "confluence-analytics.mention-reminders.all-users-reminded.error.message": "已提醒所有已提及的使用者。",
  "confluence-analytics.mention-reminders.cancel.button": "取消",
  "confluence-analytics.mention-reminders.deactivated.lozenge": "已停用",
  "confluence-analytics.mention-reminders.generic.error.message": "{remindersCount, plural, other {提醒無法傳送，請嘗試再次傳送。}}",
  "confluence-analytics.mention-reminders.modal.default.helper": "這會重新傳送通知給您選取的 @提及人員。",
  "confluence-analytics.mention-reminders.modal.header": "提醒團隊成員檢視此內容",
  "confluence-analytics.mention-reminders.modal.subtext": "已提及的使用者",
  "confluence-analytics.mention-reminders.no-users-selected.error.message": "選取要傳送提醒的對象。",
  "confluence-analytics.mention-reminders.not-viewed.lozenge": "未檢視",
  "confluence-analytics.mention-reminders.reminder-sent.lozenge": "已傳送提醒",
  "confluence-analytics.mention-reminders.select-all.button": "全選",
  "confluence-analytics.mention-reminders.send.button": "傳送",
  "confluence-analytics.mention-reminders.unlicensed.lozenge": "未授權",
  "confluence-analytics.mention-reminders.unselect-all.button": "全部取消選取",
  "confluence-analytics.mention-reminders.user-limit.error.message": "一次的提醒只能使用 {maxLimit} 個。請移除一些以繼續。",
  "confluence-analytics.mention-reminders.viewed.lozenge": "已檢視",
  "confluence-analytics.mentioned-users-card.all-mentioned-viewed": "提及的所有人皆已檢視過",
  "confluence-analytics.mentioned-users-card.no-mentions": "尚未提及任何使用者",
  "confluence-analytics.mentioned-users-card.not-viewed.label": "尚未檢視",
  "confluence-analytics.mentioned-users-card.remind-teammates-button": "傳送提醒",
  "confluence-analytics.mentioned-users-card.success-flag-title": "已傳送提醒",
  "confluence-analytics.mentioned-users-card.title": "已提及的使用者",
  "confluence-analytics.mentioned-users-card.viewed-label": "已檢視",
  "confluence-analytics.mentioned-users-card.viewed-label.v2": "已檢視此頁面",
  "confluence-analytics.mentioned-users-card.viewed-metric-label.v2": "已檢視",
  "confluence-analytics.mentioned-users-table.anonymous-user": "匿名",
  "confluence-analytics.mentioned-users-table.column.title-last-viewed": "上次檢視",
  "confluence-analytics.mentioned-users-table.column.title-name": "名稱",
  "confluence-analytics.mentioned-users-table.column.title-version": "已檢視的最新版本",
  "confluence-analytics.mentioned-users-table.column.title-views": "檢視",
  "confluence-analytics.mentioned-users-table.filters.all": "全部",
  "confluence-analytics.mentioned-users-table.filters.not-viewed": "未檢視",
  "confluence-analytics.mentioned-users-table.filters.trigger-label": "檢視狀態",
  "confluence-analytics.mentioned-users-table.filters.viewed": "已檢視",
  "confluence-analytics.mentioned-users-table.filters.viewed-latest-version": "已檢視最新版本",
  "confluence-analytics.mentioned-users-table.view-status-icon.has-viewed": "已檢視",
  "confluence-analytics.mentions-tab.mentioned-users-table-title": "已提及的使用者",
  "confluence-analytics.mentions-tab.page-title": "已提及的使用者",
  "confluence-analytics.mentions-tab.resend-notification-message": "重新傳送通知以鼓勵 @提及的團隊成員檢視頁面。",
  "confluence-analytics.mentions-tab.resend-notification-send-reminders": "傳送提醒",
  "confluence-analytics.mentions-tab.success-flag-title": "已傳送提醒",
  "confluence-analytics.metric-selector.legend-color-aria-label": "{metric} 的顏色圖例",
  "confluence-analytics.metrics.unique-viewers-all-time": "不重複的檢視者 (所有時間)",
  "confluence-analytics.metrics.views-all-time": "檢視 (所有時間)",
  "confluence-analytics.overview-tab.engagement-availability-message": "只有 2025 年 2 月 24 日之後的參與狀態資料。在此日期之前的檢視不會計入參與度。",
  "confluence-analytics.overview-tab.page-title": "參與概述",
  "confluence-analytics.overview-tab.viewers-table-title": "查閱者",
  "confluence-analytics.page-analytics-card.chart.unique-viewers.engaged-label": "參與的查閱者：",
  "confluence-analytics.page-analytics-card.count-change.no-new-views": "沒有變更",
  "confluence-analytics.page-analytics-card.count-change.no-new-views.custom": "沒有變更 ({startDate}-{endDate})",
  "confluence-analytics.page-analytics-card.count-change.up-from-zero-new-views": "自 0 次檢視提升",
  "confluence-analytics.page-analytics-card.percentage-change.custom": "{percentage}% ({startDate}-{endDate})",
  "confluence-analytics.page-analytics-card.percentage-change.month": "自上個月以來 {percentage}%",
  "confluence-analytics.page-analytics-card.percentage-change.three-months": "自 3 個月前以來 {percentage}%",
  "confluence-analytics.page-analytics-card.percentage-change.week": "自上週以來 {percentage}%",
  "confluence-analytics.page-analytics-card.percentage-change.ytd": "自 1 月 1 日以來 {percentage}%",
  "confluence-analytics.page-analytics-card.title.unique-viewers": "不重複的查閱者",
  "confluence-analytics.page-analytics-card.title.v2": "總檢視次數",
  "confluence-analytics.page-analytics-card.total-views.chart.brief-label": "簡要檢視：",
  "confluence-analytics.page-analytics-card.total-views.chart.engaged-label": "已參與檢視：",
  "confluence-analytics.page-analytics-card.unique-viewers.chart.brief-label": "簡要查閱者：",
  "confluence-analytics.page-analytics.content-type-error-message.description": "請重新載入或與您的網站管理員連絡。",
  "confluence-analytics.page-analytics.content-type-error-message.title": "發生錯誤。",
  "confluence-analytics.page-analytics.links-tab-title": "已連結內容",
  "confluence-analytics.page-analytics.live-doc.title": "即時文件分析",
  "confluence-analytics.page-analytics.lozenge.new": "全新",
  "confluence-analytics.page-analytics.mentions-tab-title": "提及",
  "confluence-analytics.page-analytics.overview-tab-title": "概觀",
  "confluence-analytics.page-analytics.title": "頁面分析",
  "confluence-analytics.page-links-tab.inbound-link-availability-message": "已顯示在 {linkClickStartDate}之後，頁面、即時文件和部落格上點擊次數的資料。受限制、已刪除或已封存的連結不會包含在內。如果空間索引鍵、頁面標題或空間已變更，那麼對於在啟用「編輯空間索引鍵」功能之後建立的空間，其連結也不會包含在內。",
  "confluence-analytics.page-links-tab.inbound-links-tab-title": "輸入",
  "confluence-analytics.page-links-tab.inbound-links-table.column-name.link-added-date": "新增的日期",
  "confluence-analytics.page-links-tab.inbound-links-table.column-name.total-clicks": "點擊次數總計",
  "confluence-analytics.page-links-tab.inbound-links-table.column-name.unique-clicks": "不重複的點擊次數",
  "confluence-analytics.page-links-tab.inbound-links-table.empty": "沒有其他頁面參照此頁面。當此頁面從其他來源吸引流量時，這些連結就會顯示在此處，並且包含其產生的造訪次數。",
  "confluence-analytics.page-links-tab.inbound-links-table.live-doc.empty": "沒有其他頁面參照此即時文件。當此即時文件從其他來源吸引流量時，這些連結就會顯示在此處，並且包含其產生的造訪次數。",
  "confluence-analytics.page-links-tab.inbound-links-table.search-placeholder.inbound-links": "搜尋輸入連結",
  "confluence-analytics.page-links-tab.learn-more": "深入了解",
  "confluence-analytics.page-links-tab.link-availability-message": "已顯示在 {linkClickStartDate}之後，頁面、即時文件和部落格上點擊次數的資料。不會顯示受限、已被刪除或已封存的連結。",
  "confluence-analytics.page-links-tab.links-activity-service.external-links": "外部連結",
  "confluence-analytics.page-links-tab.links-table-title-cell.error": "載入此連結時發生錯誤。請重新整理頁面，並再試一次。",
  "confluence-analytics.page-links-tab.links-table-title-cell.tooltip.content": "對於外部網站連結，僅提供彙總資料。",
  "confluence-analytics.page-links-tab.links-table-title-cell.tooltip.label": "外部連結工具提示按鈕",
  "confluence-analytics.page-links-tab.outbound-links-tab-title": "輸出",
  "confluence-analytics.page-links-tab.outbound-links-table.column-name.ctr": "點擊率",
  "confluence-analytics.page-links-tab.outbound-links-table.column-name.link-added-date": "新增的日期",
  "confluence-analytics.page-links-tab.outbound-links-table.column-name.total-clicks": "點擊次數總計",
  "confluence-analytics.page-links-tab.outbound-links-table.column-name.unique-clicks": "不重複的點擊次數",
  "confluence-analytics.page-links-tab.outbound-links-table.empty": "此頁面上沒有輸出連結。當您新增一個輸出連結時，即可在此處追蹤其點擊次數。",
  "confluence-analytics.page-links-tab.outbound-links-table.live-doc.empty": "此即時文件上沒有輸出連結。當您新增一個輸出連結時，即可在此處追蹤其點擊次數。",
  "confluence-analytics.page-links-tab.outbound-links-table.search-placeholder.outbound-links": "搜尋輸出連結",
  "confluence-analytics.page-links-tab.page-title": "已連結內容",
  "confluence-analytics.period-selector.date-option-daily": "每日",
  "confluence-analytics.period-selector.date-option-hourly": "每小時",
  "confluence-analytics.period-selector.date-option-monthly": "每月",
  "confluence-analytics.period-selector.date-option-weekly": "每週",
  "confluence-analytics.popular-searches-card.search-count": "{count, plural, other {<b>{count}</b><small> 次搜尋</small>}}",
  "confluence-analytics.popular-searches-card.search-icon-label": "{count, plural, other {搜尋詞彙「{term}」，已搜尋 {count,number} 次}}",
  "confluence-analytics.popular-searches-card.title": "最熱門的搜尋內容",
  "confluence-analytics.popular-spaces-card.space-icon-label": "{spaceName} 的空間標誌",
  "confluence-analytics.popular-spaces-card.title": "熱門空間",
  "confluence-analytics.popular-spaces-card.views-count": "{count, plural, other {<b>{count}</b><small> 次檢視</small>}}",
  "confluence-analytics.search-field.clear-icon-label": "清除搜尋欄位",
  "confluence-analytics.search-field.search-icon-label": "按文字搜尋",
  "confluence-analytics.search-panel-graph.click-through-rate-title": "點擊率",
  "confluence-analytics.search-panel-graph.date-range-title": "{fromDate} 至 {toDate} (今天)",
  "confluence-analytics.search-panel-graph.metric-average": "平均",
  "confluence-analytics.search-panel-graph.metric-total": "總計",
  "confluence-analytics.search-panel-graph.no-new-clicks": "沒有新的點擊次數",
  "confluence-analytics.search-panel-graph.no-new-searches": "沒有新的搜尋次數",
  "confluence-analytics.search-panel-graph.percentage-change": "自上週以來 {percentage}% (+{count})",
  "confluence-analytics.search-panel-graph.searches-title": "搜尋",
  "confluence-analytics.search-panel-graph.up-from-zero-new-clicks": "搜尋次數已從上週的 0 次向上增加",
  "confluence-analytics.search-panel-graph.up-from-zero-new-searches": "搜尋次數已從上週的 0 次向上增加",
  "confluence-analytics.search-panel-graph.x-new-clicks": "{count, plural, other {新增 {count,number} 次點擊}}",
  "confluence-analytics.search-panel-graph.x-new-searches": "{count, plural, other {新增 {count,number} 次搜尋}}",
  "confluence-analytics.search-panel-most-clicked-contents.clicks-metric-text": "{count, plural, other {<b>{count}</b> <small>次點擊</small>}}",
  "confluence-analytics.search-panel-most-clicked-contents.empty-state-text": "尚未由此搜尋結果中點擊任何內容",
  "confluence-analytics.search-panel-most-clicked-contents.title": "點擊次數最多的內容",
  "confluence-analytics.search-panel-most-clicked-spaces.clicks-metric-text": "{count, plural, other {<b>{count}</b> <small>次點擊</small>}}",
  "confluence-analytics.search-panel-most-clicked-spaces.empty-state-text": "尚未由此搜尋結果中點擊任何空間",
  "confluence-analytics.search-panel-most-clicked-spaces.title": "點擊次數最多的空間",
  "confluence-analytics.search-panel.close-label": "關閉強制回應",
  "confluence-analytics.search-panel.most-clicked-space-label": "點擊次數最多的空間",
  "confluence-analytics.search-table.column.click-through-by-anonymous-description": "所有搜尋均由匿名使用者進行，無法連結其檢視次數",
  "confluence-analytics.search-table.column.click-through-by-anonymous-label": "未知",
  "confluence-analytics.search-table.column.click-through-rate-description": "促使已登入的使用者進行檢視的搜尋次數百分比",
  "confluence-analytics.search-table.column.title-created": "已搜尋的使用者",
  "confluence-analytics.search-table.column.title-updated": "點擊率",
  "confluence-analytics.search-table.column.title-views": "搜尋",
  "confluence-analytics.search-table.term-search-placeholder": "搜尋詞彙",
  "confluence-analytics.server-error-message.description": "請重新載入或與您的網站管理員連絡。",
  "confluence-analytics.server-error-message.expanded-description": "(錯誤：{errorMessage})",
  "confluence-analytics.server-error-message.title": "我們無法擷取您的資料。",
  "confluence-analytics.site-analytics-filters.content-type": "內容",
  "confluence-analytics.site-analytics-filters.content-type-blogs": "部落格",
  "confluence-analytics.site-analytics-filters.content-type-live-docs": "即時文件",
  "confluence-analytics.site-analytics-filters.content-type-pages": "頁面",
  "confluence-analytics.site-analytics-filters.filters-title": "篩選條件",
  "confluence-analytics.site-analytics-filters.space-type": "空間類型",
  "confluence-analytics.site-analytics-filters.space-type-global": "網站",
  "confluence-analytics.site-analytics-filters.space-type-personal": "個人",
  "confluence-analytics.site-analytics-overview.page-title": "參與概述",
  "confluence-analytics.site-analytics-page.content-availability-message": "目前只有頁面和部落格的資料可以使用",
  "confluence-analytics.site-analytics-page.content-availability-message.livedocs": "目前只有頁面、即時文件和部落格的資料可用",
  "confluence-analytics.site-analytics-page.page-title": "網站分析",
  "confluence-analytics.site-analytics-page.search-availability-message": "您的 Confluence 管理員已關閉搜尋分析。",
  "confluence-analytics.site-analytics-page.tab-title.overview": "概觀",
  "confluence-analytics.site-analytics-page.tab-title.search": "搜尋",
  "confluence-analytics.site-analytics-page.tab-title.spaces": "空間",
  "confluence-analytics.site-analytics-page.tab-title.users": "使用者",
  "confluence-analytics.site-analytics-permissions-page.access-allowed": "允許存取",
  "confluence-analytics.site-analytics-permissions-page.access-denied": "存取遭拒",
  "confluence-analytics.site-analytics-permissions-page.cancel-button": "取消",
  "confluence-analytics.site-analytics-permissions-page.deselect-all": "全部取消選取",
  "confluence-analytics.site-analytics-permissions-page.edit-button": "編輯權限",
  "confluence-analytics.site-analytics-permissions-page.error-flag": "發生意外錯誤",
  "confluence-analytics.site-analytics-permissions-page.group-column-header": "群組名稱",
  "confluence-analytics.site-analytics-permissions-page.learn-more": "進一步了解權限。",
  "confluence-analytics.site-analytics-permissions-page.page-title": "分析權限",
  "confluence-analytics.site-analytics-permissions-page.section-content": "將分析權限授予群組的所有成員。",
  "confluence-analytics.site-analytics-permissions-page.section-title": "全域權限",
  "confluence-analytics.site-analytics-permissions-page.select-all": "全選",
  "confluence-analytics.site-analytics-permissions-page.submit-button": "儲存",
  "confluence-analytics.site-analytics-permissions-page.success-flag": "權限變更已儲存",
  "confluence-analytics.site-analytics-permissions-page.success-flag-title": "分析權限",
  "confluence-analytics.site-analytics-permissions-page.table-label": "權限表格",
  "confluence-analytics.site-analytics-permissions-page.use-analytics-column-header": "使用分析",
  "confluence-analytics.site-analytics-search-tab.page-title": "搜尋活動",
  "confluence-analytics.site-analytics-space-tab.page-title": "空間參與",
  "confluence-analytics.site-analytics-users-tab.page-title": "使用者活動",
  "confluence-analytics.site-overview-chart.empty-state-message": "選取的時間範圍和分組可能無法顯示有意義的資料。請考慮調整設定，以獲得更好的深入解析。",
  "confluence-analytics.site-overview-chart.filters.display-option-total-views": "總計",
  "confluence-analytics.site-overview-chart.filters.display-option-unique-viewers": "不重複",
  "confluence-analytics.site-overview-chart.filters.metric-created": "已建立",
  "confluence-analytics.site-overview-chart.filters.metric-searches": "搜尋",
  "confluence-analytics.site-overview-chart.filters.metric-updated": "更新時間",
  "confluence-analytics.site-overview-chart.filters.metric-views": "檢視",
  "confluence-analytics.space-analytics-content-tab.export-download.failure.msg": "下載報告時出現錯誤。請重新載入或與您的網站管理員連絡。",
  "confluence-analytics.space-analytics-content-tab.export.failure.msg": "匯出資料時發生錯誤。請重新載入或與您的網站管理員連絡。",
  "confluence-analytics.space-analytics-content-tab.export.naviagtion-out.warning.msg": "您確定要離開此頁面嗎？您的匯出內容將會遺失。",
  "confluence-analytics.space-analytics-content-tab.export.success.msg": "已成功匯出報告。",
  "confluence-analytics.space-analytics-content-tab.page-title": "內容活動",
  "confluence-analytics.space-analytics-page.content-availability-message": "目前只有頁面和部落格的資料可以使用",
  "confluence-analytics.space-analytics-page.content-availability-message.livedocs": "目前只有頁面、即時文件和部落格的資料可用",
  "confluence-analytics.space-analytics-page.page-title": "空間分析",
  "confluence-analytics.space-analytics-page.tab-title.content": "內容",
  "confluence-analytics.space-analytics-page.tab-title.overview": "概觀",
  "confluence-analytics.space-analytics-page.tab-title.users": "使用者",
  "confluence-analytics.space-analytics-permissions-page.can-use-analytics": "可以使用分析",
  "confluence-analytics.space-analytics-permissions-page.cancel-button": "取消",
  "confluence-analytics.space-analytics-permissions-page.error-flag": "發生意外錯誤",
  "confluence-analytics.space-analytics-permissions-page.global-link": "檢視全域權限",
  "confluence-analytics.space-analytics-permissions-page.learn-more-link": "深入了解",
  "confluence-analytics.space-analytics-permissions-page.max-permission-warning": "最多有 50 個使用者或群組可以設定權限。若要新增，請先移除既有的使用者或群組。",
  "confluence-analytics.space-analytics-permissions-page.no-permission-warning": "確保「Analytics for Confluence Cloud」使用者具有「空間管理員」權限，然後再試一次。",
  "confluence-analytics.space-analytics-permissions-page.remove-button": "移除",
  "confluence-analytics.space-analytics-permissions-page.restrictions-disabled-message": "所有已登入的使用者都可以檢視分析",
  "confluence-analytics.space-analytics-permissions-page.restrictions-disabled-select": "無限制",
  "confluence-analytics.space-analytics-permissions-page.restrictions-enabled-message": "只有一些人可以檢視分析",
  "confluence-analytics.space-analytics-permissions-page.restrictions-enabled-select": "檢視分析已受限",
  "confluence-analytics.space-analytics-permissions-page.section-content": "管理員可以使用全域權限來覆寫空間權限。",
  "confluence-analytics.space-analytics-permissions-page.submit-button": "儲存",
  "confluence-analytics.space-analytics-permissions-page.success-flag": "權限變更已儲存",
  "confluence-analytics.space-analytics-permissions-page.success-flag-title": "分析權限",
  "confluence-analytics.space-analytics-permissions-page.table-name-heading": "名稱",
  "confluence-analytics.space-analytics-permissions-page.table-permission-heading": "權限",
  "confluence-analytics.space-analytics.content-filter.all": "所有內容",
  "confluence-analytics.space-analytics.content-filter.blogs": "部落格",
  "confluence-analytics.space-analytics.content-filter.livedocs": "即時文件",
  "confluence-analytics.space-analytics.content-filter.pages": "頁面",
  "confluence-analytics.space-analytics.content-filter.pages.livedocs": "頁面和即時文件",
  "confluence-analytics.space-analytics.display-option.total": "總計",
  "confluence-analytics.space-analytics.display-option.unique": "不重複",
  "confluence-analytics.space-analytics.most-active-contributors-card.edits-count-type-label": "個編輯",
  "confluence-analytics.space-analytics.most-active-contributors-card.title": "最活躍的參與者",
  "confluence-analytics.space-analytics.most-active-readers-card.title": "最活躍的讀者",
  "confluence-analytics.space-analytics.most-active-readers-card.views-count-type-label": "檢視",
  "confluence-analytics.space-analytics.overview-chart.empty-state-message": "選取的時間範圍、內容和指標可能無法顯示有意義的資料。{lineBreak}請考慮調整設定，以獲得更好的深入解析。",
  "confluence-analytics.space-analytics.overview-chart.series-option-color-legend": "{displayOption} 的顏色圖例",
  "confluence-analytics.space-analytics.overview-chart.series.created": "已建立",
  "confluence-analytics.space-analytics.overview-chart.series.updates": "更新",
  "confluence-analytics.space-analytics.overview-chart.series.views": "檢視",
  "confluence-analytics.space-analytics.overview-chart.title": "參與摘要",
  "confluence-analytics.space-analytics.overview-tab.heading": "參與概述",
  "confluence-analytics.space-analytics.popular-content-card.popular-content.title": "熱門內容",
  "confluence-analytics.space-analytics.popular-content-card.views-count-type-label": "檢視",
  "confluence-analytics.space-analytics.users-tab.heading": "使用者活動",
  "confluence-analytics.space-analytics.users-table.anonymous-user": "匿名",
  "confluence-analytics.space-analytics.users-table.aria-label": "使用者活動",
  "confluence-analytics.space-analytics.users-table.column.title-views": "檢視",
  "confluence-analytics.space-analytics.users-table.column.title.comments": "留言",
  "confluence-analytics.space-analytics.users-table.column.title.created": "已建立",
  "confluence-analytics.space-analytics.users-table.column.title.updated": "更新時間",
  "confluence-analytics.spaces-table.column.title-created": "已建立",
  "confluence-analytics.spaces-table.column.title-last-viewed": "上次檢視",
  "confluence-analytics.spaces-table.column.title-updated": "更新時間",
  "confluence-analytics.spaces-table.column.title-users-viewed": "已檢視的使用者",
  "confluence-analytics.spaces-table.column.title-views": "檢視",
  "confluence-analytics.spaces-table.name-search-placeholder": "搜尋空間",
  "confluence-analytics.total-clicks-card.no-new-clicks": "尚未點擊",
  "confluence-analytics.total-clicks-card.percentage-change": "{dateRange, select, 7D {自上週以來 {percentage}%} 1M {自上個月以來 {percentage}%} 3M {自 3 個月前以來 {percentage}%} YTD {自 1 月 1 日以來 {percentage}%} AllTime {自上週以來 {percentage}%} other {{percentage}% ({startDate}-{endDate})}}",
  "confluence-analytics.total-clicks-card.title": "點擊次數總計",
  "confluence-analytics.total-clicks-card.up-from-zero-new-clicks": "{dateRange, select, 7D {自上週以來的 0 次點擊提升} 1M {自上個月以來的 0 次點擊提升} 3M {自 3 個月前以來的 0 次點擊提升} YTD {自 1 月 1 日以來的 0 次點擊提升} AllTime {自上週以來的 0 次點擊提升} other {自 0 次點擊提升 }}",
  "confluence-analytics.total-views-card.no-new-views": "沒有新的檢視",
  "confluence-analytics.total-views-card.percentage-change": "自上週以來 {percentage}% (+{count})",
  "confluence-analytics.total-views-card.title": "總檢視次數 (全部時間)",
  "confluence-analytics.total-views-card.up-from-zero-new-views": "{count, plural, other {{count} 次新檢視}}",
  "confluence-analytics.unique-viewers-card.no-new-views": "沒有新的查閱者",
  "confluence-analytics.unique-viewers-card.percentage-change": "自上週以來 {percentage}% (+{count})",
  "confluence-analytics.unique-viewers-card.title": "不重複的檢視者 (全部時間)",
  "confluence-analytics.unique-viewers-card.up-from-zero-new-views": "{count, plural, other {{count} 位新的查閱者}}",
  "confluence-analytics.users-table.column.title-comments": "留言",
  "confluence-analytics.users-table.column.title-created": "已建立",
  "confluence-analytics.users-table.column.title-searches": "搜尋",
  "confluence-analytics.users-table.column.title-updated": "更新時間",
  "confluence-analytics.users-table.column.title-views": "檢視",
  "confluence-analytics.users-table.user-search-placeholder": "搜尋使用者",
  "confluence-analytics.view-chart.empty-state-message": "選取的時間範圍和分組可能無法顯示有意義的資料。請考慮調整設定，以獲得更好的深入解析。",
  "confluence-analytics.view-chart.filters.display-option-engaged-viewers": "參與的查閱者",
  "confluence-analytics.view-chart.filters.display-option-engaged-views": "已參與檢視",
  "confluence-analytics.view-chart.filters.display-option-metric-color-legend": "{metric} 的色彩圖例",
  "confluence-analytics.view-chart.filters.display-option-total-views": "總檢視次數",
  "confluence-analytics.view-chart.filters.display-option-unique-viewers": "不重複的查閱者",
  "confluence-analytics.view-more-insights.button": "查看更多深入解析",
  "confluence-analytics.viewers-table.anonymous-user": "匿名",
  "confluence-analytics.viewers-table.column.engagement-cell.brief": "簡短",
  "confluence-analytics.viewers-table.column.engagement-cell.brief-filter.label": "簡介",
  "confluence-analytics.viewers-table.column.engagement-cell.engaged": "已參與",
  "confluence-analytics.viewers-table.column.engagement-cell.engaged-filter.label": "已參與檢視",
  "confluence-analytics.viewers-table.column.engagement-cell.tooltip.info": "已參與檢視是指使用者在頁面上花費超過 20 秒的工作階段。",
  "confluence-analytics.viewers-table.column.engagement-filter.all": "全部",
  "confluence-analytics.viewers-table.column.title-engagement": "參與",
  "confluence-analytics.viewers-table.column.title-last-viewed": "上次檢視",
  "confluence-analytics.viewers-table.column.title-version": "已檢視的最新版本",
  "confluence-analytics.viewers-table.column.title-views": "檢視",
  "confluence-analytics.viewers-table.name-search-placeholder": "依名稱篩選",
  "confluence-analytics.viewers-table.upsell.activity.category.body": "檢視網站和空間分析，以識別主要參與者和最活躍的讀者。",
  "confluence-analytics.viewers-table.upsell.activity.category.title": "了解團隊的活動模式",
  "confluence-analytics.viewers-table.upsell.body": "取得整個網站、空間和頁面的分析。使用頁面分析，查看誰檢視過此頁面、檢視的時間和頻率。<a>探索分析</a>",
  "confluence-analytics.viewers-table.upsell.body.livedocs": "取得整個網站、空間、頁面和即時文件的分析。透過頁面和即時文件分析，查看有誰已檢視頁面或即時文件、檢視時間和頻率。<a>探索分析</a>",
  "confluence-analytics.viewers-table.upsell.category.button.title": "了解您的團隊可以如何運用分析",
  "confluence-analytics.viewers-table.upsell.heading": "使用 Premium 分析做出更明智的決策",
  "confluence-analytics.viewers-table.upsell.identity.category.body": "使用熱門的搜尋詞彙，針對其他說明文件或改善功能做出明智決定。",
  "confluence-analytics.viewers-table.upsell.identity.category.title": "找出資訊落差",
  "confluence-analytics.viewers-table.upsell.track.category.body": "檢視您網站或空間上參與度最高的內容，以決定有哪些要分享或更新。",
  "confluence-analytics.viewers-table.upsell.track.category.title": "追蹤熱門內容並設定優先順序",
  "confluence-analytics.viewers-table.upsell.upgrade.button.label": "免費試用",
  "confluence-analytics.viewers-table.version": "第 {versionNumber} 版",
  "confluence-databases-extension.create-database.description": "建立空白資料庫",
  "confluence-databases-extension.create-database.icon-alt-text": "建立資料庫圖示",
  "confluence-databases-extension.create-database.title": "建立資料庫",
  "confluence-databases-extension.description": "建立空白資料庫",
  "confluence-databases-extension.error-flag.description": "請重新整理或等待幾分鐘，然後再試一次。如果這種情況持續發生，請連絡支援人員。",
  "confluence-databases-extension.error-flag.title": "我們目前無法建立",
  "confluence-databases-extension.error.invalid-parent-error-description": "此頁面已刪除或封存。您可以在不同的頁面上建立資料庫。",
  "confluence-databases-extension.error.invalid-parent-error-description.livedocs": "此項目已被刪除或封存。您可以在不同的頁面或即時文件上建立資料庫。",
  "confluence-databases-extension.error.invalid-parent-error-title": "我們無法建立資料庫",
  "confluence-databases-extension.error.parent-page-moved-error-description": "請重新整理以在新位置建立內容。",
  "confluence-databases-extension.error.parent-page-moved-error-title": "父系已移動",
  "confluence-databases-extension.error.permission-removed-error-description": "您沒有在此建立內容的權限，或該空間已在最近遭到刪除。",
  "confluence-databases-extension.error.permission-removed-error-title": "我們無法建立此內容",
  "confluence-databases-extension.reference-database.description": "顯示現有的資料庫、項目或值",
  "confluence-databases-extension.reference-database.icon-alt-text": "參照資料庫圖示",
  "confluence-databases-extension.reference-database.modal-label": "參照資料庫強制回應",
  "confluence-databases-extension.reference-database.title": "嵌入資料庫",
  "confluence-databases-extension.success-flag.action": "前往資料庫",
  "confluence-databases-extension.success-flag.description": "已在樹狀結構中建立來源資料庫。請前往資料庫以移動其位置或變更其權限。",
  "confluence-databases-extension.success-flag.title": "資料庫已新增至內容樹狀結構",
  "confluence-databases-extension.title": "資料庫擴充功能",
  "confluence-databases.database-migrated-home.alt-text": "一個帶有 Atlassian 標誌和向右指箭頭的標誌",
  "confluence-databases.database-migrated-home.description": "您的資料庫看起來有點空虛，所以已加入您內容樹狀結構中的剩餘工作。",
  "confluence-databases.database-migrated-home.title": "資料庫已移動",
  "confluence-databases.mobile-web-view-description": "在 Web 版本的 Confluence Cloud 上檢視。",
  "confluence-databases.mobile-web-view-details": "使用資料庫來管理以及在 Confluence 中同步資料。",
  "confluence-databases.mobile-web-view-img-alt-text": "資料庫的圖形",
  "confluence-databases.mobile-web-view-title": "行動裝置上還無法使用資料庫",
  "confluence-embeds.add-smart-link-embed-drawer.button-description": "超過 1,000 種支援的產品",
  "confluence-embeds.add-smart-link-embed-form-content.submit-button-text": "新增智慧連結",
  "confluence-embeds.add-smart-link-embed-form-content.submit-button-text.edit-link": "取代",
  "confluence-embeds.add-smart-link-embed-form-wrapper.update-error-message-description": "請重新整理頁面，然後再試一次。",
  "confluence-embeds.add-smart-link-embed-form-wrapper.update-error-message-title": "發生錯誤",
  "confluence-embeds.add-smart-link-embed-overlay.form-description": "智慧連結會將您的工作帶入 Confluence，方便團隊掌握一致資訊。",
  "confluence-embeds.add-smart-link-embed-overlay.form-description.edit-link": "如果編輯此連結，將會在內容樹狀結構中，將連結替換為新的智慧連結。",
  "confluence-embeds.add-smart-link-embed-overlay.form-title": "在單一位置完成所有工作",
  "confluence-embeds.add-smart-link-embed-overlay.form-title.edit-link": "取代智慧連結",
  "confluence-embeds.edit-link-button-label": "取代連結",
  "confluence-embeds.edit-smart-link-embed-form-wrapper.edit-error-message-description": "空間管理員可能需要授予您在此空間中編輯項目的權限。",
  "confluence-embeds.edit-smart-link-embed-form-wrapper.edit-error-message-title": "您沒有編輯此智慧連結的權限",
  "confluence-embeds.embed-edited-notification-flag.description": "{userName} 已將先前的連結替換為這個。",
  "confluence-embeds.embed-edited-notification-flag.title": "此連結已被替換",
  "confluence-embeds.embed-shell.linked-content-permissions-banner": "連結的權限可能會影響誰可以在 Confluence 中檢視此內容。<SACLink>深入了解連結限制</SACLink>",
  "confluence-embeds.embed-shell.linked-content-permissions-banner.close-button-label": "關閉橫幅",
  "confluence-embeds.empty-embed-edited-notification-flag.description": "{userName} 已更新此智慧連結。",
  "confluence-embeds.open-in-new-tab-button-label": "在新分頁中開啟",
  "confluence-embeds.open-in-product-button-label": "在 {product} 中開啟",
  "confluence-embeds.smart-link-banner.adobe-xd": "我們無法顯示此 Adobe XD 連結類型的內容。新增 Adobe XD 檔案以檢視完整的智慧連結。",
  "confluence-embeds.smart-link-banner.asana": "我們無法顯示此 Asana 連結類型的內容。新增 Asana 任務以檢視完整的智慧連結。",
  "confluence-embeds.smart-link-banner.atlas": "我們無法顯示此 Atlas 連結類型的內容。新增 Atlas 專案以檢視完整的智慧連結。",
  "confluence-embeds.smart-link-banner.avp": "我們無法顯示此 AVP 連結類型的內容。新增 AVP 儀表板以檢視完整的智慧連結。",
  "confluence-embeds.smart-link-banner.clickup": "我們無法顯示此 ClickUp 連結類型的內容。新增 ClickUp 任務以檢視完整的智慧連結。",
  "confluence-embeds.smart-link-banner.dovetail": "我們無法顯示此 Dovetail 連結類型的內容。新增 Dovetail 深入解析以檢視完整的智慧連結。",
  "confluence-embeds.smart-link-banner.figma": "我們無法顯示此 Figma 連結類型的內容。新增 Figma 檔案以檢視完整的智慧連結。",
  "confluence-embeds.smart-link-banner.global-state": "我們無法顯示此 Global State 連結類型的內容。新增 Global State 程式以檢視完整的智慧連結。",
  "confluence-embeds.smart-link-banner.google-drive": "我們無法顯示此 Google Drive 連結類型的內容。新增 Google Drive 檔案以檢視完整的智慧連結。",
  "confluence-embeds.smart-link-banner.link": "為什麼某些智慧連結中的內容無法顯示？",
  "confluence-embeds.smart-link-banner.message": "我們無法完全顯示此智慧連結。請在新分頁中開啟連結，以檢視內容。",
  "confluence-embeds.smart-link-banner.message-with-provider": "我們無法顯示此 {provider} 連結類型的內容。請在新分頁中開啟連結，以檢視內容。",
  "confluence-embeds.smart-link-banner.miro": "我們無法顯示此 Miro 連結類型的內容。新增 Miro 看板以檢視完整的智慧連結。",
  "confluence-embeds.smart-link-banner.trello": "我們無法顯示此 Trello 連結類型的內容。新增 Trello 看板以檢視完整的智慧連結。",
  "confluence-embeds.smart-link-embed-resolving-view.loading": "正在載入...",
  "confluence-embeds.smart-link-info-section-message.link": "深入了解內容樹狀結構中的智慧值",
  "confluence-embeds.smart-link-info-section-message.message": "我們無法以內嵌的形式顯示此連結，只能以卡片的形式顯示。",
  "confluence-embeds.unembeddable-link-view.open-in-new-tab-button-text": "在新的分頁中開啟",
  "confluence-embeds.unembeddable-link-view.unembeddable-link-description": "我們無法以內嵌的形式顯示此連結。<a>深入了解內容樹狀結構中的智慧連結</a>",
  "confluence-embeds.unresolved-view.open-in-new-tab-button-text": "在新分頁中開啟",
  "confluence-fabric-editor.extension.placeholder.can-not-render-in-editor": "編輯時不會顯示此元素的結果。請預覽頁面或將其發佈，以查看頁面。",
  "confluence-fabric-editor.extension.placeholder.can-not-render-in-live-page-editor": "編輯即時文件時不會顯示此元素的結果。請將此文件轉換為頁面，並透過 <menuIcon></menuIcon> 選單發布以完整顯示。",
  "confluence-fabric-editor.extension.placeholder.missing-config": "編輯以進行設定",
  "confluence-recap.close.icon.label": "關閉強制回應",
  "confluence-recap.cover.page.headline": "您的 Confluence 回顧在此處",
  "confluence-recap.cover.page.image.alt.text": "Confluence 回顧強制回應圖片",
  "confluence-recap.cover.page.preview-recap.button": "預覽我的回顧",
  "confluence-recap.preview.close.icon.label": "關閉預覽",
  "confluence-recap.preview.publish.button": "發布我的回顧",
  "confluence-recap.preview.view.draft.button": "檢視草稿",
  "confluence.blueprints.space.customer-support-team.name": "客戶支援團隊空間",
  "confluence.blueprints.space.design-team.name": "產品設計團隊空間",
  "confluence.blueprints.space.documentation.name": "說明文件空間",
  "confluence.blueprints.space.finance-team.name": "財務團隊空間",
  "confluence.blueprints.space.hr-team.name": "人力資源團隊空間",
  "confluence.blueprints.space.it-team.name": "IT 團隊空間",
  "confluence.blueprints.space.legal-team.name": "法務團隊空間",
  "confluence.blueprints.space.marketing-team.name": "行銷團隊空間",
  "confluence.blueprints.space.operations-team.name": "營運團隊空間",
  "confluence.blueprints.space.product-management-team.name": "產品管理團隊空間",
  "confluence.blueprints.space.project-management-team.name": "專案管理團隊空間",
  "confluence.blueprints.space.research-team.name": "研究團隊空間",
  "confluence.blueprints.space.sales-team.name": "銷售團隊空間",
  "confluence.blueprints.space.sp.name": "軟體專案空間",
  "confluence.blueprints.space.team.name": "團隊空間",
  "connect-addon.failed.to.load": "連接附加元件載入失敗",
  "connect-addon.timeout.message": "等待還是<CancelButton>取消</CancelButton>？",
  "contact-administrator.disabled.go-to-home": "前往首頁",
  "contact-administrator.disabled.no-admin-emails": "所有網站管理員的電子郵件地址都尚未設定，因此無法透過此方法連絡管理員。",
  "contact-administrator.disabled.no-mail-server": "尚未設定郵件伺服器，因此無法以此方式連絡網站管理員。",
  "contact-administrator.disabled.no-recaptcha": "此 Confluence 網站未配置 CAPTCHA 安全措施。表單已停用，因為無法安全地傳送。",
  "contact-administrator.disabled.title": "無法使用管理員連絡表單",
  "contact-administrator.error.description": "無法載入頁面。請重新整理以再試一次。",
  "contact-administrator.error.refresh": "重新整理頁面",
  "contact-administrator.error.title": "糟糕，發生錯誤！",
  "contact-administrator.form.cancel": "取消",
  "contact-administrator.form.error": "提交表單時發生錯誤。請重新整理頁面，然後再試一次。",
  "contact-administrator.form.from.label": "來自",
  "contact-administrator.form.header.required": "所有欄位皆為必填",
  "contact-administrator.form.request-details.label": "要求詳細資料",
  "contact-administrator.form.subject.label": "主旨",
  "contact-administrator.form.submit": "提交",
  "contact-administrator.form.to.label": "接收者",
  "contact-administrator.page.description": "請輸入要提供給網站管理員的要求相關資訊。如果您要回報錯誤，請務必包含問題發生時您正在執行的作業和時間資訊。",
  "contact-administrator.page.title": "連絡網站管理員",
  "contact-administrator.success.return-to-home": "返回首頁",
  "contact-administrator.success.title": "您對管理員的要求已提交",
  "content-header.by-line.abbreviated.created.by.expanded": "{showByLinePoweredByTemplates, select, true {作者：{author}，{withTemplate}} false {作者：{author}} other {作者：{author}}}",
  "content-header.by-line.apps-show-more": "顯示更多",
  "content-header.by-line.apps.show-less": "顯示較少",
  "content-header.by-line.comment.count": "{count, plural, other {{count,number} 個頁面留言}}",
  "content-header.by-line.comment.count.livedocs": "{count, plural, other {{count,number} 個一般留言}}",
  "content-header.by-line.created.by.expanded": "{showByLinePoweredByTemplates, select, true {已由 {author} {withTemplate} 建立} false {建立者為 {author}} other {建立者為 {author}}}",
  "content-header.by-line.last.updated.expanded": "上次更新時間：{date} 更新者：{contributor}",
  "content-header.by-line.last.updated.self.expanded": "上次更新時間：{date}",
  "content-header.by-line.last.updated.version.comment.indicator": "版本註解",
  "content-header.by-line.live-pages.last.updated.friendly.just.now": "剛才",
  "content-header.by-line.live-pages.last.updated.icon.label": "上次更新",
  "content-header.by-line.live-pages.last.updated.tooltip": "最後更新時間：{day} {time}",
  "content-header.livepages.by-line.by.expanded": "作者：{author}",
  "content-header.livepages.by-line.showAllApps": "顯示所有應用程式",
  "content-header.livepages.by-line.showLess": "顯示較少",
  "content-history.company-hub-history.page-title": "{companyHubName} 歷程記錄",
  "content-history.compare-cell.current": "目前",
  "content-history.compare-cell.version": "版本",
  "content-history.header.viewPage": "檢視",
  "content-history.link.pageInfo": "返回頁面資訊",
  "content-history.page.title": "版本歷程記錄",
  "content-history.table.actions": "動作",
  "content-history.table.caption": "版本",
  "content-history.table.comment": "留言",
  "content-history.table.compareSelected": "選取",
  "content-history.table.compareSelectedVersions": "比較所選的版本",
  "content-history.table.contributors": "變更者",
  "content-history.table.delete.modal.close": "關閉",
  "content-history.table.delete.modal.delete": "刪除",
  "content-history.table.delete.modal.text": "您確定要刪除 {versionNumber} 版的 {pageTitle}？",
  "content-history.table.delete.modal.title": "確認刪除",
  "content-history.table.deleteVersion": "刪除",
  "content-history.table.instructions": "一次只能比較兩個版本",
  "content-history.table.page.status": "狀態",
  "content-history.table.published": "日期",
  "content-history.table.restore.modal.cancel": "取消",
  "content-history.table.restore.modal.commentInputLabel": "留言",
  "content-history.table.restore.modal.confirm": "確定",
  "content-history.table.restore.modal.defaultComment": "從 {versionNumber} 版還原",
  "content-history.table.restore.modal.text": "某些變更可能尚未儲存。如果您確定要繼續，請選取「確定」。",
  "content-history.table.restore.modal.title": "恢復",
  "content-history.table.restoreVersion": "還原",
  "content-history.table.version": "版本",
  "content-history.version-cell-content.current-and-version-text": "{current} (版本 {versionNumber})",
  "content-history.version-cell-content.current-text": "目前",
  "content-history.version-cell-content.version-text": "{versionNumber} 版",
  "content-metadata.draft.status.unpublished": "未發佈的變更",
  "content-metadata.scheduled.status.lozenge": "發佈已列入排程",
  "content-metadata.scheduled.status.tooltip": "{date} {time}",
  "content-ownership.byline-button.tooltip": "管理所有權",
  "content-ownership.byline-button.tooltip.read.only": "更多詳細資料",
  "content-ownership.byline-popup.change-owner-button": "變更負責人",
  "content-ownership.byline-popup.created-by": "已由 <b>{user}</b> 於 {date} 建立",
  "content-ownership.byline-popup.created-by.unknown-date": "由 <b>{user}</b> 建立，日期未知",
  "content-ownership.byline-popup.last-owned-by": "最後負責人：<b>{user}</b>",
  "content-ownership.byline-popup.trigger-label": "管理所有權",
  "content-ownership.byline.abbreviated-main-text": "作者：{user}",
  "content-ownership.byline.abbreviated-owner-message": "負責人",
  "content-ownership.byline.main-text": "負責人：{user}",
  "content-ownership.byline.main-text.with-template": "負責人：{user}，{withTemplate}建立",
  "content-ownership.byline.owner-with-contributors-dropdown.tooltip": "檢視負責人和參與者",
  "content-ownership.change-owner.close-modal-label": "關閉強制回應",
  "content-ownership.change-owner.error-flag-message": "無法轉移所有權",
  "content-ownership.change-owner.spotlight.body": "您或管理員現在可以將內容擁有權轉移給其他人。",
  "content-ownership.change-owner.spotlight.learn-more-button": "深入了解",
  "content-ownership.change-owner.spotlight.ok-button": "確定",
  "content-ownership.change-owner.spotlight.title": "變更頁面負責人",
  "content-ownership.change-owner.spotlight.title.livedocs": "變更頁面或即時文件的負責人",
  "content-ownership.change-owner.success-flag-message": "所有權已轉移給 {user}",
  "content-ownership.change-warning-dialog.body": "將擁有權轉移給其他人之後，便無法還原。",
  "content-ownership.change-warning-dialog.cancel-button": "取消",
  "content-ownership.change-warning-dialog.continue-button": "繼續",
  "content-ownership.change-warning-dialog.title": "這項變更無法還原",
  "content-ownership.content-header.confirm-owner-modal.body": "轉移此內容的所有權後，只有管理員或新的負責人可以復原該頁面。<button>深入了解</button>",
  "content-ownership.content-header.confirm-owner-modal.cancel-button": "取消",
  "content-ownership.content-header.confirm-owner-modal.confirm-change-owner-button": "繼續",
  "content-ownership.content-header.confirm-owner-modal.current-owner": "目前的負責人",
  "content-ownership.content-header.confirm-owner-modal.new-owner": "新的負責人",
  "content-ownership.content-header.confirm-owner-modal.title": "確認要轉移此擁有權嗎？",
  "content-ownership.content-header.owner-modal.body-enabled-for-all-content": "選擇新的負責人",
  "content-ownership.content-header.owner-modal.cancel-button": "取消",
  "content-ownership.content-header.owner-modal.change-owner-button": "變更負責人",
  "content-ownership.content-header.owner-modal.current-owner": "目前的負責人",
  "content-ownership.content-header.owner-modal.title-enabled-for-all-content": "變更負責人",
  "content-ownership.content-owner-item.accessible-avatar-label": "{displayName} 的設定檔圖片",
  "content-ownership.content-owner-item.change-owner": "變更負責人",
  "content-ownership.content-owner-item.creator": "建立者",
  "content-ownership.content-owner-item.owner": "負責人",
  "content-ownership.content-owner-popup.ariaLabel": "{name} 的更多資訊",
  "content-ownership.content-owner-popup.change-owner": "變更負責人",
  "content-ownership.content-owner-popup.creator": "<b>建立者</b>",
  "content-ownership.content-owner-popup.owner": "<b>負責人</b>",
  "content-ownership.mailto.body.space": "您好，%0D%0A%0D%0A我這邊有需要存取空間的人員，但我們沒有人可以變更其存取層級。您可以協助查看嗎？%0D%0A%0D%0A謝謝！%0D%0A{currentUser}%0D%0A%0D%0A需要存取權的使用者：%0D%0A{requestedUser}%0D%0A%0D%0A「{spaceName}」空間的權限連結：%0D%0A{spacePermissionsUrl}%0D%0A%0D%0A「{pageTitle}」內容的連結：%0D%0A{pageUrl}",
  "content-ownership.mailto.subject.space": "[Confluence] Confluence 使用者需要空間存取權",
  "content-ownership.manage.parent.page.restriction.button": "深入了解",
  "content-ownership.manage.premium.restriction.button": "檢查權限",
  "content-ownership.manage.restriction.button": "管理存取權",
  "content-ownership.manage.space.restriction.button": "請連絡空間管理員",
  "content-ownership.manage.space.restriction.button.admin": "管理空間權限",
  "content-ownership.owner.parent.page.restriction.message": "若要授予擁有權，您須提供此頁面和任何必要父系項目的編輯權限。",
  "content-ownership.owner.parent.page.restriction.title": "這位使用者沒有此內容和/或其父系的編輯權限。",
  "content-ownership.owner.premium.restriction.message": "若要授予擁有權，您須提供此頁面和任何其他必要父系項目的編輯權限。",
  "content-ownership.owner.premium.restriction.title": "此人員無法存取此內容和/或父系內容。",
  "content-ownership.owner.restriction.message": "若要授予擁有權，您必須先授予此內容的編輯權限。",
  "content-ownership.owner.restriction.title": "這位使用者沒有編輯權限",
  "content-ownership.owner.space.restriction.message": "為了授予所有權，他們必須具有此空間的存取權。",
  "content-ownership.owner.space.restriction.title": "這位使用者沒有此空間的存取權",
  "content-ownership.ownership-transfer.arrow-right-icon": "所有權轉移",
  "content-ownership.page-ownership-by-line-with-contributors-dropdown.dropdown-content.contributors-section-message": "{contributorsCount, plural, other {{contributorsCount} 名參與者}}",
  "content-ownership.page-ownership-by-line-with-contributors-dropdown.dropdown-content.contributors-section-message.no-contributors": "沒有其他參與者",
  "content-ownership.page-ownership-by-line-with-contributors-dropdown.dropdown-content.error.message": "再試一次",
  "content-ownership.page-ownership-by-line-with-contributors-dropdown.dropdown-content.error.title": "參與者無法載入",
  "content-ownership.powered-by-templates.byline.text": "使用範本",
  "content-prerequisites.timeout-error-screen.contact-admin": "如果這種情況持續發生，請要求您的管理員聯繫<SupportLink>我們的支援團隊</SupportLink>，並將此頁面的 URL 提供給他們。",
  "content-prerequisites.timeout-error-screen.convert-to-cloud-editor": "<EditLink>返回編輯模式</EditLink>並立即轉換為<SACLink>雲端編輯器</SACLink>",
  "content-prerequisites.timeout-error-screen.heading": "無法載入頁面。",
  "content-prerequisites.timeout-error-screen.reload-page": "重新載入此頁面",
  "content-prerequisites.timeout-error-screen.remove-excerpt-macro-or-break-page-content": "請移除一個或多個摘錄巨集，或將此頁面內容分成幾個較小的頁面",
  "content-prerequisites.timeout-error-screen.resolution-options": "若要解決此問題，您可能需要：",
  "content-renderer-extension-handlers.expand-macro.default-title": "按一下此處以展開...",
  "content-renderer.definition.restricted.to.blogpost.option": "在這篇部落格貼文上",
  "content-renderer.definition.restricted.to.page.option": "此頁面上",
  "content-renderer.definition.restricted.to.site.option": "在這個網站上",
  "content-renderer.definition.restricted.to.space.option": "在這個空間中",
  "content-renderer.inlineComment.marker.end": "內嵌留言結束",
  "content-renderer.inlineComment.marker.start": "內嵌留言開始",
  "content-state.add-custom-status": "新增自訂狀態",
  "content-state.add-status.floating-toolbar": "狀態",
  "content-state.allow.custom.content.states.body": "允許作者建立自己的自訂狀態",
  "content-state.allow.custom.content.states.title": "建立自訂狀態",
  "content-state.cancel": "取消",
  "content-state.cancel.text": "取消",
  "content-state.change-status": "變更狀態",
  "content-state.create.status.button.text": "建立狀態",
  "content-state.custom": "自訂",
  "content-state.default.status.in.progress": "進行中",
  "content-state.default.status.ready.for.review": "可供檢閱",
  "content-state.default.status.remove.tooltip": "移除",
  "content-state.default.status.rough.draft": "粗略草稿",
  "content-state.default.status.suggestions.body": "決定建議使用哪些狀態 (最多 5 個)。",
  "content-state.default.status.suggestions.body.restore.default": "恢復預設",
  "content-state.default.status.suggestions.title": "建議狀態",
  "content-state.default.status.verified": "已驗證",
  "content-state.enable.content.state.body": "關閉以隱藏建立頁面或部落格貼文時，新增狀態的功能",
  "content-state.enable.content.state.body.livedocs": "關閉以隱藏當建立頁面、即時文件或部落格貼文時，新增狀態的功能",
  "content-state.enable.content.state.title": "內容狀態",
  "content-state.error.flag.body": "請重新整理，然後再試一次。",
  "content-state.error.flag.title": "我們無法設定您的狀態",
  "content-state.feature.disabled.message": "在此空間中未啟用內容狀態功能。",
  "content-state.just-a-moment": "就在剛才",
  "content-state.last-updated": "上次更新",
  "content-state.max.length.editor.creation": "長度上限為 20",
  "content-state.more.info.message": "移除建議不會影響使用建議的頁面或貼文。",
  "content-state.more.info.message.livedocs": "移除建議不會影響使用建議的頁面、文件或貼文。",
  "content-state.none.text": "無",
  "content-state.page-status": "狀態",
  "content-state.remove": "移除",
  "content-state.restore.default.suggestions": "恢復預設建議",
  "content-state.restore.default.suggestions.confirm": "確認",
  "content-state.save": "儲存",
  "content-state.save.status.button.text": "儲存",
  "content-state.set-blog-status": "設定部落格貼文狀態",
  "content-state.set-page-status": "設定狀態",
  "content-state.show.more.statuses": "顯示更多狀態",
  "content-state.space.admin.duplicate.status.flag.description": "具有相同文字和顏色指示的狀態會被視為重複項目，無法建立。",
  "content-state.space.admin.duplicate.status.flag.title": "您建立的狀態已存在",
  "content-state.status.create.status.max.length": "長度上限為 20",
  "content-state.status.empty.status.flag.description": "狀態必須包含符號或英數字元。",
  "content-state.status.empty.status.flag.title": "無法儲存您的狀態",
  "content-state.status.maker.add.status.placeholder.text": "新增狀態",
  "content-state.status.maker.error.message": "必要",
  "content-state.suggested": "建議的",
  "content-state.team-presence.description": "開啟之後，查閱者即可查看還有誰在檢視已發布的頁面和部落格貼文。<a>進一步了解頭像可見性</a>",
  "content-state.team-presence.title": "已發布內容上的頭像",
  "content-state.team-presence.tooltip.disabled": "網站管理員已關閉",
  "content-state.verified-restricted": "此內容已經過驗證。只有其負責人或管理員可以變更狀態。",
  "content-tools.advanced.nested.section.heading": "進階詳細資料",
  "content-tools.attachments.nested.section.heading": "附件",
  "content-tools.button.tooltip": "更多動作",
  "content-tools.eop.flag.description": "自動生成的建議如若適用，將顯示在此內容下方。",
  "content-tools.eop.flag.no-results": "如果有可向您顯示的自動生成建議時，將顯示在此內容下方。",
  "content-tools.eop.flag.refresh": "重新整理以檢查相關內容",
  "content-tools.eop.flag.results": "自動生成的建議現在會顯示在此內容下方。",
  "content-tools.eop.flag.title": "已顯示相關內容",
  "content-tools.eop.flag.tooltip": "已關閉此空間的相關內容顯示功能",
  "content-tools.eop.hide": "隱藏相關內容",
  "content-tools.eop.show": "顯示相關內容",
  "content-tools.export.nested.section.heading": "匯出",
  "content-tools.files.nested.section.heading.custom-contents": "自訂內容",
  "content-tools.files.nested.section.heading.files": "檔案",
  "content-tools.more.icon.label": "更多動作",
  "content-tools.placeholder.ellipsis.more": "更多",
  "content-tools.third-party-apps.nested.section.heading": "應用程式",
  "content-types-experiments.spotlight.body.text": "使用白板，針對構想協同合作並呈現工作。",
  "content-types-experiments.spotlight.dismiss.button": "關閉",
  "content-types-experiments.spotlight.try.whiteboards.button": "試用白板",
  "content-types-header.advanced.label": "進階詳細資料",
  "content-types-header.automations.label": "自動化",
  "content-types-header.automations.title": "頁面自動化",
  "content-types-header.close.draft.name": "關閉草稿",
  "content-types-header.close.name": "關閉",
  "content-types-header.collaborators.follow-cursor-message": "{name} (按一下即可追蹤)",
  "content-types-header.collaborators.follow-cursor-onboarding-button": "確定",
  "content-types-header.collaborators.follow-cursor-onboarding-message": "點擊任何人的頭像，以便在白板上追蹤。",
  "content-types-header.content-types-actions.whiteboards.whiteboard-teammate-button.name": "白板客服人員",
  "content-types-header.content-types-actions.whiteboards.whiteboard-teammate-button.whiteboard-agent-beta-lozenge": "測試版",
  "content-types-header.content-types-title.database-permissions-tooltip": "您沒有此資料庫的編輯權限",
  "content-types-header.content-types-title.database-title-placeholder": "無標題資料庫",
  "content-types-header.content-types-title.duplicate-database-title-error": "此空間中已存在具有此標題的資料庫",
  "content-types-header.content-types-title.duplicate-embed-title-error": "此空間中已經存在此標題的智慧連結",
  "content-types-header.content-types-title.duplicate-title-error": "此空間中已存在具有此標題的白板",
  "content-types-header.content-types-title.embed-permissions-tooltip": "您沒有編輯此智慧連結的權限",
  "content-types-header.content-types-title.embed-title-placeholder": "無標題智慧連結",
  "content-types-header.content-types-title.general-error": "我們這端發生錯誤。請重新整理，然後再試一次。",
  "content-types-header.content-types-title.onboarding-spotlight-body": "為白板提供不重複的名稱",
  "content-types-header.content-types-title.permissions-tooltip": "您沒有編輯此白板的權限",
  "content-types-header.content-types-title.placeholder": "無標題白板",
  "content-types-header.content-types-title.rename-tooltip": "重新命名",
  "content-types-header.content-types-title.title-length-error": "{maxLength, plural, other {標題不能超過 {maxLength} 個字元數}}",
  "content-types-header.content-types.more-actions.archive-and-delete": "封存和刪除",
  "content-types-header.content-types.more-actions.delete": "刪除",
  "content-types-header.content-types.more-actions.delete-draft": "刪除草稿",
  "content-types-header.content-types.more-actions.disabled-tooltip": "即將推出",
  "content-types-header.content-types.more-actions.dont-tell-me-again": "不再顯示通知",
  "content-types-header.content-types.more-actions.label": "更多動作",
  "content-types-header.content-types.more-actions.trying-to-find-something": "找不到您需要的項目嗎？請查看浮動動作列中的<strong>詳細資料</strong>面板。<link>向我顯示</link>",
  "content-types-header.content-types.share.close": "關閉",
  "content-types-header.content-types.share.copied-text": "已將連結複製到剪貼簿！",
  "content-types-header.content-types.share.copy-button": "複製連結",
  "content-types-header.content-types.share.link-field-label": "分享連結文字欄位",
  "content-types-header.content-types.share.restrictions-button": "管理隱私權和可見性",
  "content-types-header.content-types.share.share-button": "分享",
  "content-types-header.content-types.share.share-database-dialog-title": "共用資料庫",
  "content-types-header.content-types.share.share-dialog-title": "共用白板",
  "content-types-header.content-types.view.changes.label": "檢視變更",
  "content-types-header.content-types.view.changes.title": "最近變更",
  "content-types-header.discard.draft.name": "捨棄草稿",
  "content-types-header.editor.close.publish.tooltip": "儲存變更而不發布",
  "content-types-header.editor.close.update.tooltip": "儲存變更而不更新",
  "content-types-header.editor.discard.close.tooltip": "捨棄空白草稿",
  "content-types-header.ellipsis.open.ellipsis.archive": "封存",
  "content-types-header.ellipsis.open.ellipsis.ask-to-edit": "要求編輯",
  "content-types-header.ellipsis.open.ellipsis.convert": "轉換",
  "content-types-header.ellipsis.open.ellipsis.convert-to-page": "轉換為頁面",
  "content-types-header.ellipsis.open.ellipsis.copy": "複製",
  "content-types-header.ellipsis.open.ellipsis.copy.database": "複製資料庫",
  "content-types-header.ellipsis.open.ellipsis.editor-find-replace": "尋找與取代",
  "content-types-header.ellipsis.open.ellipsis.editor-redo": "重做",
  "content-types-header.ellipsis.open.ellipsis.editor-undo": "復原",
  "content-types-header.ellipsis.open.ellipsis.export": "匯出",
  "content-types-header.ellipsis.open.ellipsis.help": "說明",
  "content-types-header.ellipsis.open.ellipsis.hub.share-feedback": "提供有關公司中心的意見反應",
  "content-types-header.ellipsis.open.ellipsis.manage": "管理",
  "content-types-header.ellipsis.open.ellipsis.page.apps": "應用程式",
  "content-types-header.ellipsis.open.ellipsis.present": "呈現",
  "content-types-header.ellipsis.open.ellipsis.preview": "預覽",
  "content-types-header.ellipsis.open.ellipsis.templates": "範本和匯入",
  "content-types-header.last-edited.edited": "已編輯 {timestamp}",
  "content-types-header.last-edited.editedOn": "{contributor} 已於 {timestamp} 編輯",
  "content-types-header.last-edited.published": "發布時間：{timestamp}",
  "content-types-header.last-edited.publishedOn": "{contributor} 已於 {timestamp} 發布",
  "content-types-header.last-edited.saved": "已儲存",
  "content-types-header.last-edited.shortJustNow": "剛才",
  "content-types-header.last-edited.shortXDaysAgo": "{timeAgo} 天前",
  "content-types-header.last-edited.shortXHoursAgo": "{timeAgo} 小時以前",
  "content-types-header.last-edited.shortXMinutesAgo": "{timeAgo} 分鐘前",
  "content-types-header.last-edited.tooltipDate": "{date}",
  "content-types-header.last-edited.tooltipFullDate": "{date} {time}",
  "content-types-header.last-edited.updated": "已於 {timestamp} 更新",
  "content-types-header.last-edited.updatedOn": "{contributor} 已於 {timestamp} 更新",
  "content-types-header.object-header-items.unpublished-changes.link.text": "未發佈的變更",
  "content-types-header.revert.label": "回復到先前版本",
  "content-types-header.share-title.database": "共用資料庫",
  "content-types-header.share-title.embed": "分享連結",
  "content-types-header.share-title.whiteboard": "共用白板",
  "content-types-header.start.watch": "追蹤",
  "content-types-header.stop.watch": "停止追蹤",
  "content-types-header.version.history.label": "版本歷程記錄",
  "contextual-create.create-blog.label": "建立部落格",
  "contextual-create.create-child-page.label": "建立子系項目",
  "contextual-create.create-page.label": "建立頁面",
  "contextual-invite-nudge-flag.adminCTA": "複製可分享的邀請連結",
  "contextual-invite-nudge-flag.adminCTA.copied": "已複製！",
  "contextual-invite-nudge-flag.description": "新增您的團隊成員，讓他們可以與您協作。",
  "contextual-invite-nudge-flag.nthUserCTA": "邀請人員",
  "contextual-invite-nudge-flag.title": "您已建立第一個頁面 🎉",
  "contextual-reading-aids.acronym-highlight-spotlight.dismiss-button.text": "關閉",
  "contextual-reading-aids.acronym-highlight-spotlight.text": "無需離開頁面即可醒目顯示出並定義公司特定的詞彙、專案名稱和術語！",
  "contextual-reading-aids.changeboarding-modal.body-text": "您現在可以使用 Atlassian Intelligence 來定義：",
  "contextual-reading-aids.changeboarding-modal.body-text-list-description-1": "例如「Confluence 空間」",
  "contextual-reading-aids.changeboarding-modal.body-text-list-description-2": "例如「GTM」(上市)",
  "contextual-reading-aids.changeboarding-modal.body-text-list-description-3": "例如「ABC 專案」",
  "contextual-reading-aids.changeboarding-modal.body-text-list-heading-1": "不熟悉的詞彙",
  "contextual-reading-aids.changeboarding-modal.body-text-list-heading-2": "縮寫或簡稱",
  "contextual-reading-aids.changeboarding-modal.body-text-list-heading-3": "專案和團隊",
  "contextual-reading-aids.changeboarding-modal.give-it-a-try-body": "當您選取 Atlassian Intelligence 可以定義的特定詞彙、縮寫或內部專案/團隊名稱時，最適合使用這項功能。",
  "contextual-reading-aids.changeboarding-modal.give-it-a-try-title": "透過選取更少的字詞來嘗試",
  "contextual-reading-aids.changeboarding-modal.heading": "提升理解的程度和速度",
  "contextual-reading-aids.changeboarding-modal.next-button": "下一個",
  "contextual-reading-aids.changeboarding-modal.try-something-else-title": "嘗試選取其他項目，以查看此功能的實際操作",
  "contextual-reading-aids.changeboarding-spotlight.got-it-button": "知道了",
  "contextual-reading-aids.changeboarding-spotlight.text": "提醒您，當您選取特定詞彙、縮寫或內部專案/團隊名稱時，最適合使用這項功能。",
  "contextual-reading-aids.edit.definition.restricted.to.blogpost.option": "在這篇部落格貼文上",
  "contextual-reading-aids.edit.definition.restricted.to.page.option": "此頁面上",
  "contextual-reading-aids.edit.definition.restricted.to.site.option": "在這個網站上",
  "contextual-reading-aids.edit.definition.restricted.to.space.option": "在這個空間中",
  "contextual-reading-aids.search-ai-dialog.query-pretext": "什麼是 {queryText}？",
  "copy-content-link.copied.tooltip": "已複製！",
  "copy-content-link.error.tooltip": "發生錯誤。",
  "copy-content-link.icon.label": "複製連結",
  "copy-page-tree-dialog.back": "上一步",
  "copy-page-tree-dialog.cancel": "取消",
  "copy-page-tree-dialog.content.preview.tree.description": "以下是新內容的預覽",
  "copy-page-tree-dialog.copy": "複製",
  "copy-page-tree-dialog.copying": "複製中...",
  "copy-page-tree-dialog.customiseContentDescription": "空間中的每個內容類型都需要不重複的標題。由於您一次複製多個內容類型，您可能需大量為其重新命名或修改標題。",
  "copy-page-tree-dialog.description": "選取要複製的位置。",
  "copy-page-tree-dialog.error": "發生錯誤。請稍後再試一次。",
  "copy-page-tree-dialog.error-copy": "發生錯誤。請稍後再試一次。",
  "copy-page-tree-dialog.errorContentActiveTaskBody": "這可能需要幾分鐘的時間。",
  "copy-page-tree-dialog.errorContentActiveTaskTitle": "我們仍在努力複製您的內容",
  "copy-page-tree-dialog.errorContentSectionBody": "您需要變更標題才能複製。請嘗試替換關鍵字。",
  "copy-page-tree-dialog.errorContentSectionTitle": "具有此標題的內容已存在",
  "copy-page-tree-dialog.errorGenericBody": "請稍後再試一次。",
  "copy-page-tree-dialog.errorGenericTitle": "發生錯誤。",
  "copy-page-tree-dialog.errorMaxCharacterLengthTitle": "標題必須在 255 個字元以內",
  "copy-page-tree-dialog.errorNoPageIdBody": "您要貼上此項目的空間沒有首頁，因此您必須選取父系項目。",
  "copy-page-tree-dialog.errorNoPageIdTitle": "您必須在這個空間中選取此項目的父系",
  "copy-page-tree-dialog.field-label.copyLabels": "標籤",
  "copy-page-tree-dialog.field-label.copyPermissions": "限制",
  "copy-page-tree-dialog.field-label.includeChildPage": "包含 1 個子系",
  "copy-page-tree-dialog.field-label.includeChildPages": "{pageCount, plural, other {包含 {pageCount,number} 個子系}}",
  "copy-page-tree-dialog.field-label.prefix": "所有標題的開頭皆為：",
  "copy-page-tree-dialog.field-label.replace": "替換成哪個字詞：",
  "copy-page-tree-dialog.field-label.search": "要替換的標題字詞：",
  "copy-page-tree-dialog.field-label.space": "空間",
  "copy-page-tree-dialog.field-set-label.include": "包含",
  "copy-page-tree-dialog.field-set-label.include.colon": "包含：",
  "copy-page-tree-dialog.flagInfoTitle": "我知道了。立即複製您的內容。",
  "copy-page-tree-dialog.generalizedRestrictionMessageDescription": "因為設定的關係，限制無法轉移至選取的目的地空間。複製的內容將重設為預設存取權。",
  "copy-page-tree-dialog.generalizedRestrictionTitle": "您正在複製受限制的內容",
  "copy-page-tree-dialog.helper-message.contentCountExceedsLimit": "一次最多只能複製 {pagesLimit} 個項目",
  "copy-page-tree-dialog.hierarchicalContentCopyTitle": "複製內容",
  "copy-page-tree-dialog.learn-more-link": "深入了解",
  "copy-page-tree-dialog.learnMoreButtonAriaLabel": "瞭解如何複製頁面",
  "copy-page-tree-dialog.learnMoreButtonAriaLabel.livedocs": "了解如何複製頁面或即時文件",
  "copy-page-tree-dialog.next": "下一步",
  "copy-page-tree-dialog.notify-mentioned-users": "通知所有 @已提及的使用者",
  "copy-page-tree-dialog.select-space-placeholder": "選取空間",
  "copy-page-tree-dialog.singlePageCopytitle": "複製",
  "copy-page-tree-dialog.space-info-error": "無法擷取空間資訊。請再試一次。",
  "copy-page-tree-dialog.successful-copy-content.body": "檢視複製的內容",
  "copy-page-tree-dialog.successful-copy.title": "複製完成",
  "copy-space-permissions.for-existing-space.source-space.dropdown": "從另一個空間複製權限",
  "copy-space-permissions.for-existing-space.source-space.placeholder": "選擇空間",
  "copy-space-permissions.for-existing-space.upsell.description": "從現有空間複製權限，以節省時間並避免錯誤。",
  "copy-space-permissions.for-existing-space.upsell.title": "管理權限變得更輕鬆了",
  "copy-space-permissions.for-new-space.option-select.label": "空間權限",
  "copy-space-permissions.for-new-space.upsell.description": "透過 Premium 方案，從另一個空間快速複製您的專屬權限。",
  "copy-space-permissions.for-new-space.upsell.title": "設定權限的速度比以往還要快",
  "copy-space-permissions.from-existing-space.apply.button": "套用",
  "copy-space-permissions.from-existing-space.completion-flag.description.copy-permissions-from-another-space": "您的空間現在正使用 <b>{sourceSpaceName}</b> 空間的權限",
  "copy-space-permissions.from-existing-space.completion-flag.description.default-permissions": "您的空間現在使用的是預設空間權限",
  "copy-space-permissions.from-existing-space.completion-flag.description.default-permissions-company-hub": "您的中心現在已設定為預設權限。",
  "copy-space-permissions.from-existing-space.completion-flag.description.only-visible-to-me": "現在只有您可以看到您的空間",
  "copy-space-permissions.from-existing-space.completion-flag.title.copy-permissions-from-another-space": "已複製空間權限",
  "copy-space-permissions.from-existing-space.completion-flag.title.default-permissions": "預設權限集",
  "copy-space-permissions.from-existing-space.completion-flag.title.default-permissions-company-hub": "已復原預設權限",
  "copy-space-permissions.from-existing-space.completion-flag.title.only-visible-to-me": "觀看權限受限於您",
  "copy-space-permissions.from-existing-space.confirmation.apply.copy-permissions-from-another-space": "複製權限",
  "copy-space-permissions.from-existing-space.confirmation.apply.default-permissions": "使用預設值",
  "copy-space-permissions.from-existing-space.confirmation.apply.default-permissions-company-hub": "立即重設",
  "copy-space-permissions.from-existing-space.confirmation.apply.only-visible-to-me": "限制觀看權限",
  "copy-space-permissions.from-existing-space.confirmation.body.copy-permissions-from-another-space": "您即將從 <b>{sourceSpaceName}</b> 複製權限。<b>{sourceSpaceName}</b> 中的權限將覆寫您空間上的所有權限。<b>此動作無法復原。</b>",
  "copy-space-permissions.from-existing-space.confirmation.body.default-permissions": "您即將使用管理員所設定的預設空間權限。預設權限將覆寫您空間上的所有權限。<b>此動作無法復原。</b>",
  "copy-space-permissions.from-existing-space.confirmation.body.default-permissions-company-hub": "經過此重設後，只有網站管理員才會有編輯公司中心的權限。<b>此動作無法復原。</b>",
  "copy-space-permissions.from-existing-space.confirmation.body.only-visible-to-me": "您即將讓您的空間僅供自己查看。這會覆寫該空間的所有權限。<b>此動作無法復原。</b>",
  "copy-space-permissions.from-existing-space.confirmation.cancel": "取消",
  "copy-space-permissions.from-existing-space.confirmation.error-flag.description": "如果這個問題持續發生，請透過 {atlassianSupportLink} 通知我們",
  "copy-space-permissions.from-existing-space.confirmation.error-flag.description-company-hub": "我們無法復原預設權限。{br}請再試一次。",
  "copy-space-permissions.from-existing-space.confirmation.error-flag.title": "無法變更空間權限",
  "copy-space-permissions.from-existing-space.confirmation.error-flag.title-company-hub": "發生錯誤",
  "copy-space-permissions.from-existing-space.confirmation.heading.copy-permissions-from-another-space": "是否要複製空間權限？",
  "copy-space-permissions.from-existing-space.confirmation.heading.default-permissions": "是否使用預設權限？",
  "copy-space-permissions.from-existing-space.confirmation.heading.default-permissions-company-hub": "要重設中心權限嗎？",
  "copy-space-permissions.from-existing-space.confirmation.heading.only-visible-to-me": "將觀看權限限制為只有您能看到？",
  "copy-space-permissions.from-existing-space.guest-warning": "此空間中的訪客不包含在內，因為訪客一次只能存取一個空間。",
  "copy-space-permissions.option-select.source-space.guests-warning": "此空間中的訪客不包含在內，因為訪客一次只能存取一個空間。",
  "copy-space-permissions.option-select.source-space.validation-error": "此空間不能做為來源。",
  "copy-space-permissions.restore-defaults.button": "還原預設值",
  "copy-space-permissions.restore-defaults.tooltip": "將所有權限重設為網站管理員設定的預設值",
  "copy-space-permissions.selector.items.copy.from.existing.space": "從另一個空間複製權限",
  "copy-space-permissions.selector.items.copy.from.existing.space.description": "使用來自類似空間的權限",
  "copy-space-permissions.selector.items.default": "預設權限",
  "copy-space-permissions.selector.items.default.description": "使用管理員設定的空間權限",
  "copy-space-permissions.selector.items.private": "只有我能看見",
  "copy-space-permissions.selector.items.private.description": "只有您可以檢視此空間",
  "copy-space-permissions.selector.placeholder": "選取選項",
  "copy-space-permissions.space-selector.placeholder": "選擇空間",
  "copy-space-permissions.space-selector.prompt": "複製來源",
  "core-invites-provider.contextual-invite-nudge.live-pages.body": "新增您的團隊成員，讓他們可以與您協作。",
  "core-invites-provider.contextual-invite-nudge.live-pages.title": "<strong>一起使用 Confluence 可發揮更大成效</strong> {emoji}",
  "core-invites-provider.contextual-invite-nudge.message": "新增您的團隊成員，讓他們可以與您協作。",
  "core-invites-provider.contextual-invite-nudge.title": "<strong>您已經建立第一頁</strong> {emoji}",
  "create-blank-fabric-page.content-tree-onboarding.new-database": "新增您的第一個資料庫",
  "create-blank-fabric-page.content-tree-onboarding.new-live-doc": "新增您的第一個即時文件",
  "create-blank-fabric-page.content-tree-onboarding.new-page": "新增您的第一頁",
  "create-blank-fabric-page.content-tree-onboarding.new-whiteboard": "新增您的第一個白板",
  "create-blank-fabric-page.contextual-create.button.simple-create-label": "建立",
  "create-blank-fabric-page.contextual-create.button.simple-create-label-for-title": "為 {pageTitle} 建立子系內容",
  "create-blank-fabric-page.create-content-menu-item.create": "建立",
  "create-blank-fabric-page.create.content.aria.label": "建立內容",
  "create-blank-fabric-page.create.content.blog.title": "部落格",
  "create-blank-fabric-page.create.content.database.title": "資料庫",
  "create-blank-fabric-page.create.content.folder.creating-folder": "正在建立資料夾",
  "create-blank-fabric-page.create.content.folder.title": "資料夾",
  "create-blank-fabric-page.create.content.live-doc.title": "即時文件",
  "create-blank-fabric-page.create.content.loom-video.opening-loom-recorder": "正在開啟 Loom 錄製工具",
  "create-blank-fabric-page.create.content.loom-video.title": "Loom 影片",
  "create-blank-fabric-page.create.content.page.live.description": "無需發布即可建立和編輯",
  "create-blank-fabric-page.create.content.page.title": "頁面",
  "create-blank-fabric-page.create.content.popover.button": "建立",
  "create-blank-fabric-page.create.content.smart-link-embed.title": "智慧連結",
  "create-blank-fabric-page.create.content.whiteboard.title": "白板",
  "create-blank-fabric-page.create.content.whiteboard.tooltip.text-anonymous": "登入以建立白板",
  "create-blank-fabric-page.create.content.whiteboard.tooltip.text-unlicensed": "註冊 Confluence 以建立白板",
  "create-blank-fabric-page.error.duplicate-error-description": "請使用不同的名稱來儲存。",
  "create-blank-fabric-page.error.duplicate-error-title": "該名稱已經存在",
  "create-blank-fabric-page.error.invalid-permissions": "您沒有正確的權限，請洽詢管理員來調整權限。",
  "create-blank-fabric-page.error.page-creation-error": "請重新整理頁面，然後再試一次。如果這種情況持續發生，請連絡支援人員。",
  "create-blank-fabric-page.error.page-creation-network-error": "請檢查您的網際網路連線、重新整理頁面，然後再試一次。",
  "create-blank-fabric-page.error.page-creation-unauthorized-error": "重新載入此畫面，然後再試一次。",
  "create-blank-fabric-page.error.parent-page-id-not-found-error-title": "請重新整理頁面，並再試一次。",
  "create-blank-fabric-page.error.parentid-and-spacekey-mismatch-error": "{contentType, select, whiteboard {重新整理以在新位置建立子系白板。} liveDoc {重新整理以在新位置建立子系即時文件。} other {重新整理以在新位置建立子系頁面。}}",
  "create-blank-fabric-page.error.parentid-and-spacekey-mismatch-error-title": "{contentType, select, whiteboard {白板已移動} liveDoc {已移動即時文件} other {該頁面已移動}}",
  "create-blank-fabric-page.error.rate-limited-error": "請稍候幾分鐘，然後再試一次。如果這種情況持續發生，請連絡支援人員。",
  "create-blank-fabric-page.error.status-403-error": "{contentType, select, blog {您沒有在此建立部落格的權限，或該空間已在最近遭到刪除。請連絡空間管理員，讓他們對此問題進行疑難排解。} whiteboard {您沒有在這裡建立白板的權限，或最近已刪除空間。請連絡空間管理員，讓他們對此問題進行疑難排解。} liveDoc {您沒有在此建立即時文件的權限，或該空間已在最近遭到刪除。請連絡空間管理員，讓他們對此問題進行疑難排解。} other {您沒有在此建立頁面的權限，或該空間已在最近遭到刪除。請連絡空間管理員，讓他們對此問題進行疑難排解。}}",
  "create-blank-fabric-page.error.title": "{contentType, select, blog {我們無法為您建立部落格} whiteboard {我們無法為您建立白板} liveDoc {我們無法為您建立即時文件} other {我們無法為您建立頁面}}",
  "create-blank-fabric-page.error.title.temporary": "{contentType, select, blog {我們目前無法為您建立部落格} whiteboard {我們現在無法為您建立白板} liveDoc {我們目前無法為您建立即時文件} other {我們目前無法為您建立頁面}}",
  "create-blank-fabric-page.error.whiteboard-enablement-in-progress.description": "最近已啟用建立白板功能。請在數分鐘之後再試一次。",
  "create-blank-fabric-page.error.whiteboard-enablement-in-progress.title": "我們還無法建立白板",
  "create-blank-fabric-page.generic.error.content-creation-error": "請重新整理或等待幾分鐘，然後再試一次。如果這種情況持續發生，請連絡支援人員。",
  "create-blank-fabric-page.generic.error.content-creation-title": "我們目前無法建立",
  "create-blank-fabric-page.generic.error.internet-connection-message": "請檢查您的網際網路連線、重新整理，然後再試一次。",
  "create-blank-fabric-page.generic.error.internet-connection-title": "我們在連線時遇到問題",
  "create-blank-fabric-page.generic.error.moved-parent-message": "請重新整理以在新位置建立。",
  "create-blank-fabric-page.generic.error.moved-parent-title": "父系已移動",
  "create-blank-fabric-page.generic.error.permission-message": "您沒有正確的建立權限。",
  "create-blank-fabric-page.generic.error.permission-title": "我們無法為您建立",
  "create-blank-fabric-page.generic.error.status-403-error": "您沒有在此建立的權限，或該空間已在最近遭到刪除。",
  "create-blank-fabric-page.generic.error.title": "我們無法建立此內容",
  "create-blank-fabric-page.global-create.ga-spotlight-body": "可以隨時使用此按鈕建立白板。",
  "create-blank-fabric-page.global-create.ga-spotlight-close": "普通",
  "create-blank-fabric-page.global-create.spotlight-body": "每當靈感來襲時，都可以在 Confluence 中的任何位置建立白板。",
  "create-blank-fabric-page.global-create.spotlight-close": "知道了",
  "create-blank-fabric-page.loom-cross-join-popover-item.crossJoinPopupCardDescription": "透過影片說明、示範、更新等等，節省時間並與團隊互動。",
  "create-blank-fabric-page.loom-cross-join-popover-item.crossJoinPopupCardTitle": "透過影片分享工作內容",
  "create-blank-fabric-page.loom-cross-join-popover-item.popoverItemAriaLabel": "加入 Loom 上的團隊，以錄製影片",
  "create-blank-fabric-page.loom-cross-join-popover-item.popoverItemLabel": "Loom 影片",
  "create-blank-fabric-page.loom-cross-join-popover-item.popoverItemLozenge": "加入",
  "create-blank-fabric-page.standalone.error.unsupported-content-type.description": "請再次檢查 URL，然後再試一次。",
  "create-blank-fabric-page.standalone.error.unsupported-content-type.generic-title": "我們無法建立此內容",
  "create-blank-fabric-page.tree-create-content-button.create-aria-label-for-space": "在此空間中建立內容",
  "create-blank-fabric-page.tree-create-content-button.create-label": "建立",
  "create-blank-fabric-page.universal-create.blog.title": "部落格",
  "create-blank-fabric-page.universal-create.create.text": "建立",
  "create-blank-fabric-page.universal-create.liveDoc.lozenge": "測試版",
  "create-blank-fabric-page.universal-create.liveDoc.new.lozenge": "全新",
  "create-blank-fabric-page.universal-create.liveDoc.title": "即時文件",
  "create-blank-fabric-page.universal-create.loom.cross-join-lozenge": "加入",
  "create-blank-fabric-page.universal-create.loom.crossJoinCTA": "立即試用",
  "create-blank-fabric-page.universal-create.loom.crossJoinPopupDescription": "透過影片說明、示範、更新等等，節省時間並與團隊互動。",
  "create-blank-fabric-page.universal-create.loom.crossJoinPopupTitle": "透過影片分享工作內容",
  "create-blank-fabric-page.universal-create.loom.title": "Loom 影片",
  "create-blank-fabric-page.universal-create.page.database": "資料庫",
  "create-blank-fabric-page.universal-create.page.title": "頁面",
  "create-blank-fabric-page.universal-create.smart-link-embed.title": "智慧連結",
  "create-blank-fabric-page.universal-create.space.title": "空間",
  "create-blank-fabric-page.universal-create.suggestions": "建議",
  "create-blank-fabric-page.universal-create.whiteboard.title": "白板",
  "create-blank-fabric-page.universal-create.whiteboard.tooltip.text-anonymous": "登入以建立白板",
  "create-blank-fabric-page.universal-create.whiteboard.tooltip.text-unlicensed": "註冊 Confluence 以建立白板",
  "create-blank-fabric-page.whiteboard-creation-paywall-dialog.body": "設有三個可編輯白板的上限。如果您建立新的白板，舊的白板將變為唯讀。",
  "create-blank-fabric-page.whiteboard-creation-paywall-dialog.bodyUpsell": "若要建立不限數量的白板，請升級至 Premium 方案。",
  "create-blank-fabric-page.whiteboard-creation-paywall-dialog.createWhiteboard": "建立白板",
  "create-blank-fabric-page.whiteboard-creation-paywall-dialog.defaultWhiteboardName": "較舊的看板將變成唯讀",
  "create-blank-fabric-page.whiteboard-creation-paywall-dialog.learnMore": "了解使用量",
  "create-blank-fabric-page.whiteboard-creation-paywall-dialog.title": "{whiteboardName} 將變成唯讀",
  "create-from-template.inline-extension.create-from-template": "透過範本建立",
  "create-from-template.inline-extension.create-from-template.error": "您可能沒有在目標空間中新增內容的權限。請檢查權限，或在「從範本建立」巨集中編輯空間索引鍵。",
  "create-from-template.inline-extension.create-from-template.not-found-graphql-error.error": "請重新整理頁面，並再試一次。",
  "create-from-template.inline-extension.create-from-template.not-found-graphql-error.error.title": "我們無法為您建立新內容",
  "create-from-template.inline-extension.create-from-template.unavailable-template.error": "原始範本已刪除。請為「從範本建立」巨集選取新範本。",
  "create-space.button": "建立空間",
  "create-space.drawer.close": "關閉",
  "create-space.drawer.config.analytics": "分析",
  "create-space.drawer.config.automation": "自動化",
  "create-space.drawer.config.back-button": "返回",
  "create-space.drawer.config.blogs": "部落格",
  "create-space.drawer.config.calendars": "行事曆",
  "create-space.drawer.config.content-types": "內容類型",
  "create-space.drawer.config.content-types-sub-title": "您希望這個空間包含哪些類型的內容？",
  "create-space.drawer.config.create-space-button": "建立空間",
  "create-space.drawer.config.databases": "資料庫",
  "create-space.drawer.config.early-access-lozenge": "搶先體驗",
  "create-space.drawer.config.embed": "智慧連結",
  "create-space.drawer.config.features": "功能",
  "create-space.drawer.config.features-sub-title": "您想在這個空間中顯示哪些功能？",
  "create-space.drawer.config.folders": "資料夾",
  "create-space.drawer.config.header-with-space-type": "{spaceType, select, knowledge_base {確認您的知識庫} project_collaboration {確認您的協作空間} other {確認您的自訂空間}}",
  "create-space.drawer.config.live-docs": "即時文件",
  "create-space.drawer.config.live-pages": "即時頁面",
  "create-space.drawer.config.live-pages.livedocs": "即時文件",
  "create-space.drawer.config.loading": "{spaceType, select, knowledge_base {正在建置您的 {spaceName} 知識庫空間...} project_collaboration {正在建置您的 {spaceName} 協作空間...} other {正在建置您的 {spaceName} 自訂空間...}}",
  "create-space.drawer.config.more-about-features": "深入了解功能",
  "create-space.drawer.config.next": "下一步",
  "create-space.drawer.config.questions": "問題",
  "create-space.drawer.config.restore-defaults": "還原預設值",
  "create-space.drawer.config.restore-defaults-description": "啟用此按鈕後，在「功能表」中所做的變更將會恢復。",
  "create-space.drawer.config.whiteboards": "白板",
  "create-space.drawer.details-required-fields": "必填欄位標有星號",
  "create-space.drawer.details.alias.help": "一旦建立空間後，就無法修改此索引鍵。該索引鍵將以唯一識別碼的形式出現在空間的 URL 上。",
  "create-space.drawer.details.back-button": "返回",
  "create-space.drawer.details.create-space-button": "建立空間",
  "create-space.drawer.details.header": "將詳細資料新增至新的空間",
  "create-space.drawer.details.help.label": "說明",
  "create-space.drawer.details.icon": "空間圖示",
  "create-space.drawer.details.key": "使用索引鍵識別此空間",
  "create-space.drawer.details.key.error.empty": "需要有空間索引鍵。",
  "create-space.drawer.details.key.error.invalid-chars": "空間索引鍵只能是字母和數字。",
  "create-space.drawer.details.key.error.not-unique": "這個空間索引鍵已在使用中。",
  "create-space.drawer.details.key.error.too-long": "空間索引鍵必須在 255 個字元以內。",
  "create-space.drawer.details.name": "為您的空間命名",
  "create-space.drawer.details.name.error.empty": "需要空間名稱。",
  "create-space.drawer.details.name.error.too-long": "空間名稱必須在 200 個字元以內。",
  "create-space.drawer.details.next": "下一步",
  "create-space.drawer.details.permissions": "權限",
  "create-space.drawer.details.progress-indicator-1of2": "步驟 1 (共 2 個步驟)",
  "create-space.drawer.details.progress-indicator-2of2": "步驟 2 (共 2 個步驟)",
  "create-space.drawer.details.space-types.header": "建立新空間",
  "create-space.drawer.details.space-types.icon": "選擇圖示",
  "create-space.drawer.details.space-types.key": "空間索引鍵",
  "create-space.drawer.details.space-types.key.placeholder": "空間索引鍵",
  "create-space.drawer.details.space-types.name": "為此空間命名",
  "create-space.drawer.details.space-types.name.placeholder": "空間名稱",
  "create-space.drawer.details.space-types.permissions": "選取權限",
  "create-space.drawer.details.space-types.show-more-details": "自訂空間索引鍵",
  "create-space.drawer.details.space-types.template": "為此空間選擇用途",
  "create-space.drawer.details.subheader": "個人化您的空間",
  "create-space.drawer.dialogLabel": "建立新空間",
  "create-space.drawer.error.description": "請稍候片刻，然後再試一次。",
  "create-space.drawer.error.duplicate-space-key-error.generated-key.description": "已自動產生新的空間索引鍵。請再次提交。",
  "create-space.drawer.error.duplicate-space-key-error.manual-key.description": "輸入新的空間索引鍵，然後再次提交。",
  "create-space.drawer.error.duplicate-space-key-error.title": "這個空間索引鍵已被使用",
  "create-space.drawer.error.invalid-space-logo-error.description": "上傳新的空間標誌，然後再次提交。",
  "create-space.drawer.error.invalid-space-logo-error.title": "此空間標誌無效",
  "create-space.drawer.error.null-space-key-error.description": "確定已輸入空間索引鍵，然後再次提交。",
  "create-space.drawer.error.null-space-key-error.title": "尚未提交空間索引鍵",
  "create-space.drawer.error.private-space-wrong-edition-error.description": "若要繼續建立空間，請選取「預設權限」，然後再試一次。",
  "create-space.drawer.error.private-space-wrong-edition-error.title": "私密空間僅適用於付費方案",
  "create-space.drawer.error.title": "嗯...發生錯誤",
  "create-space.drawer.illustration.about": "關於",
  "create-space.drawer.illustration.additional-perks-and-discounts": "額外福利和折扣",
  "create-space.drawer.illustration.all-content": "所有內容",
  "create-space.drawer.illustration.analytics": "分析",
  "create-space.drawer.illustration.automation": "自動化",
  "create-space.drawer.illustration.blank-space": "空白空間",
  "create-space.drawer.illustration.blogs": "部落格",
  "create-space.drawer.illustration.brainstorm": "腦力激盪",
  "create-space.drawer.illustration.build-your-space": "建置自己的空間",
  "create-space.drawer.illustration.calendar": "行事曆",
  "create-space.drawer.illustration.collaboration.title": "專案協作空間",
  "create-space.drawer.illustration.contact": "連絡",
  "create-space.drawer.illustration.contact-us": "連絡我們",
  "create-space.drawer.illustration.content": "內容",
  "create-space.drawer.illustration.customer-support-space.get-the-most": "充分運用您的空間",
  "create-space.drawer.illustration.customer-support-team-space.assessment": "客戶影響評估",
  "create-space.drawer.illustration.customer-support-team-space.customer-stories": "客戶案例",
  "create-space.drawer.illustration.customer-support-team-space.journey": "客戶旅程對應",
  "create-space.drawer.illustration.customer-support-team-space.meet": "認識團隊",
  "create-space.drawer.illustration.customer-support-team-space.title": "客戶支援團隊空間",
  "create-space.drawer.illustration.database": "資料庫",
  "create-space.drawer.illustration.decision-documentation": "決策說明文件",
  "create-space.drawer.illustration.design-team.design-review": "設計審查",
  "create-space.drawer.illustration.design-team.design-sprint": "設計衝刺",
  "create-space.drawer.illustration.design-team.design-system": "設計系統",
  "create-space.drawer.illustration.design-team.in-flight-designs": "目前的設計",
  "create-space.drawer.illustration.design-team.title": "設計團隊空間",
  "create-space.drawer.illustration.documentation-space": "說明文件空間",
  "create-space.drawer.illustration.documentation-space-tips": "說明文件空間提示",
  "create-space.drawer.illustration.documents": "文件",
  "create-space.drawer.illustration.employee-recognition-and-rewards": "員工認可及獎勵",
  "create-space.drawer.illustration.error-documentation": "錯誤說明文件",
  "create-space.drawer.illustration.featured": "精選內容",
  "create-space.drawer.illustration.finance-team.business-status-update": "業務狀態更新",
  "create-space.drawer.illustration.finance-team.financial-dashboards": "重要財務儀表板",
  "create-space.drawer.illustration.finance-team.title": "財務團隊空間",
  "create-space.drawer.illustration.finance-team.vendor-agreement": "供應商合約",
  "create-space.drawer.illustration.get-the-most": "充分運用您的空間",
  "create-space.drawer.illustration.health-and-medical-benefits": "健康和醫療福利",
  "create-space.drawer.illustration.how-to": "操作指南",
  "create-space.drawer.illustration.hr-team.career-development-plan": "職涯發展計畫",
  "create-space.drawer.illustration.hr-team.employee-handbook": "員工手冊",
  "create-space.drawer.illustration.hr-team.hr-knowledge-base": "人力資源知識庫",
  "create-space.drawer.illustration.hr-team.resources": "資源",
  "create-space.drawer.illustration.hr-team.title": "人力資源團隊空間",
  "create-space.drawer.illustration.ideas": "構想",
  "create-space.drawer.illustration.important-pages": "重要頁面",
  "create-space.drawer.illustration.it-team.it-change-management": "IT 變更管理",
  "create-space.drawer.illustration.it-team.it-project-poster": "IT 專案海報",
  "create-space.drawer.illustration.it-team.itsm-runbook": "ITSM 標準執行程序",
  "create-space.drawer.illustration.it-team.recent-updates": "最近的更新",
  "create-space.drawer.illustration.it-team.title": "IT 團隊空間",
  "create-space.drawer.illustration.jira-board": "Jira 面板",
  "create-space.drawer.illustration.jira-issues": "Jira 議題",
  "create-space.drawer.illustration.knowledge-base-space": "知識庫空間",
  "create-space.drawer.illustration.knowledge-base.database": "資料庫",
  "create-space.drawer.illustration.knowledge-base.whiteboard": "白板",
  "create-space.drawer.illustration.legal-and-identity-protection": "法律和身份保護",
  "create-space.drawer.illustration.legal-team.areas-of-responsibility": "職責",
  "create-space.drawer.illustration.legal-team.risk-assessment": "風險評估",
  "create-space.drawer.illustration.legal-team.title": "法律團隊空間",
  "create-space.drawer.illustration.marketing-team.marketing-campaign": "行銷活動",
  "create-space.drawer.illustration.marketing-team.marketing-campaigns": "行銷活動",
  "create-space.drawer.illustration.marketing-team.marketing-plan": "行銷計畫",
  "create-space.drawer.illustration.marketing-team.title": "行銷團隊空間",
  "create-space.drawer.illustration.meet": "認識團隊",
  "create-space.drawer.illustration.meeting-notes": "會議記錄",
  "create-space.drawer.illustration.mission": "任務",
  "create-space.drawer.illustration.operations-team.status-update": "業務狀態更新",
  "create-space.drawer.illustration.operations-team.strategic-plan": "策略性計畫",
  "create-space.drawer.illustration.operations-team.swot-analysis": "SWOT 分析",
  "create-space.drawer.illustration.operations-team.team-okrs": "團隊目標與關鍵成果 (OKR)",
  "create-space.drawer.illustration.operations-team.title": "營運團隊空間",
  "create-space.drawer.illustration.page": "頁面",
  "create-space.drawer.illustration.policies": "政策",
  "create-space.drawer.illustration.popular-labels": "熱門標籤",
  "create-space.drawer.illustration.product-management-team.product-requirements": "產品需求",
  "create-space.drawer.illustration.product-management-team.product-strategy": "產品策略",
  "create-space.drawer.illustration.product-management-team.roadmap": "藍圖",
  "create-space.drawer.illustration.product-management-team.team-okrs": "團隊目標與關鍵成果 (OKR)",
  "create-space.drawer.illustration.product-management-team.title": "產品管理團隊空間",
  "create-space.drawer.illustration.product-requirements": "產品需求",
  "create-space.drawer.illustration.product-roadmap": "產品藍圖",
  "create-space.drawer.illustration.project-collaboration.key-projects": "重要專案",
  "create-space.drawer.illustration.project-collaboration.title": "專案協作空間",
  "create-space.drawer.illustration.project-management-team.key-projects": "重要專案",
  "create-space.drawer.illustration.project-management-team.status-report": "狀態報告",
  "create-space.drawer.illustration.project-management-team.title": "專案管理團隊空間",
  "create-space.drawer.illustration.project-plan": "專案計畫",
  "create-space.drawer.illustration.q3-planning": "Q3 規畫",
  "create-space.drawer.illustration.questions": "問題",
  "create-space.drawer.illustration.recent": "最近更新",
  "create-space.drawer.illustration.recently-updated": "最近更新的內容",
  "create-space.drawer.illustration.research": "研究",
  "create-space.drawer.illustration.research-team.brainstorming": "腦力激盪",
  "create-space.drawer.illustration.research-team.customer-report": "客戶訪談報告",
  "create-space.drawer.illustration.research-team.personas": "角色",
  "create-space.drawer.illustration.research-team.recent-updates": "最近的更新",
  "create-space.drawer.illustration.research-team.title": "研究團隊空間",
  "create-space.drawer.illustration.retirement-and-financial-benefits": "退休及財務福利",
  "create-space.drawer.illustration.roadmap": "藍圖",
  "create-space.drawer.illustration.sales-team-sales-goals": "銷售目標",
  "create-space.drawer.illustration.sales-team.business-review": "業務檢討",
  "create-space.drawer.illustration.sales-team.sales-planning": "銷售規劃",
  "create-space.drawer.illustration.sales-team.sales-portal": "銷售入口網站",
  "create-space.drawer.illustration.sales-team.title": "銷售團隊空間",
  "create-space.drawer.illustration.search": "搜尋",
  "create-space.drawer.illustration.settings": "設定",
  "create-space.drawer.illustration.software-project-space": "軟體專案空間",
  "create-space.drawer.illustration.status": "狀態",
  "create-space.drawer.illustration.team-goals": "團隊目標",
  "create-space.drawer.illustration.team-space": "團隊空間",
  "create-space.drawer.illustration.time-off-and-leave": "休假和請假",
  "create-space.drawer.illustration.top-topics": "熱門主題",
  "create-space.drawer.illustration.troubleshooting": "疑難排解文章",
  "create-space.drawer.illustration.verified": "已驗證",
  "create-space.drawer.illustration.weekly-status-reports": "每週狀態報告",
  "create-space.drawer.illustration.whiteboard": "白板",
  "create-space.drawer.illustration.work-life-balance-and-flexibility": "工作與生活平衡和彈性",
  "create-space.drawer.jira-project.label": "選取 Jira 專案",
  "create-space.drawer.jira-project.placeholder": "選取 Jira 專案",
  "create-space.drawer.jira-project.warning": "具有空間存取權的任何人都能查看 Jira 專案名稱。",
  "create-space.drawer.jira-server.connect.link": "連接您的 Jira 執行個體",
  "create-space.drawer.jira-server.connect.project": "連接 Jira 專案以將其包含在您的空間導覽中。",
  "create-space.drawer.jira-server.connect.refresh": "{connectLink} 並重新整理以繼續",
  "create-space.drawer.jira-server.label": "選取 Jira 執行個體",
  "create-space.drawer.jira-server.placeholder": "選取 Jira 執行個體",
  "create-space.drawer.show-more-details": "其他選項",
  "create-space.drawer.space-type.collab.title": "專案協作空間",
  "create-space.drawer.space-type.key-features": "主要功能",
  "create-space.drawer.space-type.knowledge-base-space-template": "知識管理空間",
  "create-space.drawer.space-type.knowledge-base-space-template.short-title": "知識管理",
  "create-space.drawer.space-type.knowledge-base-space.details.description": "將團隊集體知識轉換成可共享的單一事實來源，藉此節省時間。",
  "create-space.drawer.space-type.knowledge-base-space.details.item1.description": "建立長期保存的知識，以保存背景資訊，也藉此避免知識隨員工離職而煙消雲散。適用於商務團隊以及具有內部相關人員的團隊。",
  "create-space.drawer.space-type.knowledge-base-space.details.item1.title": "操作說明與最佳做法",
  "create-space.drawer.space-type.knowledge-base-space.details.item2.description": "透過搜尋、標籤和直覺式內容階層輕鬆找到答案。",
  "create-space.drawer.space-type.knowledge-base-space.details.item2.title": "井然有序，易於尋找",
  "create-space.drawer.space-type.project-collaboration.details.description": "簡化團隊的工作流程，使專案保持運作狀態，並將計畫記錄在單一位置。",
  "create-space.drawer.space-type.project-collaboration.details.item1.description": "透過追蹤時間軸、記錄決策並與所有團隊成員保持同步來掌握時程。",
  "create-space.drawer.space-type.project-collaboration.details.item1.title": "在專案期限內完成",
  "create-space.drawer.space-type.project-collaboration.details.item2.description": "在集中位置整理您的專案、計畫和流程，以便輕鬆存取。",
  "create-space.drawer.space-type.project-collaboration.details.item2.title": "讓一切保持井然有序",
  "create-space.drawer.space-type.project-collaboration.short-title": "專案協作",
  "create-space.drawer.space-type.project-collaboration.title": "專案協作空間",
  "create-space.drawer.space-type.value-propositions.automated-busywork-description": "自動提醒可讓您的團隊維持工作進度",
  "create-space.drawer.space-type.value-propositions.automated-busywork-title": "將繁忙的工作自動化",
  "create-space.drawer.space-type.value-propositions.built-in-page-history-description": "查看變更的內容並根據需要恢復成舊版",
  "create-space.drawer.space-type.value-propositions.built-in-page-history-title": "內建頁面歷史記錄",
  "create-space.drawer.space-type.value-propositions.live-docs-description": "即時建立和編輯",
  "create-space.drawer.space-type.value-propositions.live-docs-title": "即時文件",
  "create-space.drawer.space-type.value-propositions.live-knowledge-base": "協同合作頁面",
  "create-space.drawer.space-type.value-propositions.live-knowledge-base-description": "快速推動工作進展，並在需要時發布。",
  "create-space.drawer.space-type.value-propositions.live-updates-description": "檢視者會看到您的即時變更",
  "create-space.drawer.space-type.value-propositions.live-updates-title": "即時頁面",
  "create-space.drawer.space-type.value-propositions.live-updates-title.livedocs": "即時文件",
  "create-space.drawer.space-type.value-propositions.publish-your-pages": "發布您的頁面",
  "create-space.drawer.space-type.value-propositions.publishing-by-default-description": "在後台編輯，並且在您準備就緒時發布",
  "create-space.drawer.space-type.value-propositions.publishing-by-default-title": "依預設發布",
  "create-space.drawer.space-type.value-propositions.visual-brainstorming-description": "白板可協助您記錄初步想法",
  "create-space.drawer.space-type.value-propositions.visual-brainstorming-title": "圖像式腦力激盪",
  "create-space.drawer.template.blank-space-template": "空白空間",
  "create-space.drawer.template.blank-space-template.short-title": "空白",
  "create-space.drawer.template.blank-space.details.description": "自訂您的空間以符合您的特定需求。",
  "create-space.drawer.template.blank-space.details.item1.description": "整理內容、與您使用的工具整合，以及與您的團隊協同合作。",
  "create-space.drawer.template.blank-space.details.item1.title": "運用 Confluence 的強大功能",
  "create-space.drawer.template.blank-space.details.item2.description": "從超過 75 個可自訂的範本中選擇，或自行建立。無論是管理專案、業務狀態更新或行銷計畫，都有適合的範本。",
  "create-space.drawer.template.blank-space.details.item2.title": "在 Confluence 中建立所有內容",
  "create-space.drawer.template.cancel": "取消",
  "create-space.drawer.template.customer-support-team-space-template": "客戶支援團隊空間",
  "create-space.drawer.template.customer-support-team-space-template.short-title": "客戶支援",
  "create-space.drawer.template.customer-support-team-space.details.description": "集中管理團隊的知識並讓成員方便取得，以便為您的客戶提供更好的支援。",
  "create-space.drawer.template.customer-support-team-space.details.item1.description": "在單一位置建立專案、文件和程序並進行協同合作，確保您的團隊保持同步。",
  "create-space.drawer.template.customer-support-team-space.details.item1.title": "在單一位置建立和協同合作",
  "create-space.drawer.template.customer-support-team-space.details.item2.description": "集中管理集體知識，確保所有團隊成員都能存取最新的資訊，以利推動工作進展。",
  "create-space.drawer.template.customer-support-team-space.details.item2.title": "建立事實來源",
  "create-space.drawer.template.description": "選擇一個範本以快速開始使用。",
  "create-space.drawer.template.description.learn-more": "深入了解",
  "create-space.drawer.template.design-team-space-template": "設計團隊空間",
  "create-space.drawer.template.design-team-space-template.short-title": "設計",
  "create-space.drawer.template.design-team-space.details.description": "將專案、流程和資產整理在一個位置，以簡化設計協同合作。",
  "create-space.drawer.template.design-team-space.details.item1.description": "展示您的團隊及他們正在進行的工作。輕鬆尋找和聯繫合適的人員，以推動工作進展。",
  "create-space.drawer.template.design-team-space.details.item1.title": "展示團隊的工作",
  "create-space.drawer.template.design-team-space.details.item2.description": "整理內容、與您使用的工具整合，以及與您的團隊協同合作。",
  "create-space.drawer.template.design-team-space.details.item2.title": "運用 Confluence 的強大功能",
  "create-space.drawer.template.documentation-space-template": "說明文件空間",
  "create-space.drawer.template.documentation-space-template.short-title": "說明文件",
  "create-space.drawer.template.documentation-space.details.description": "建立說明文件和產品需求的存放庫。",
  "create-space.drawer.template.documentation-space.details.item1.description": "集中管理集體知識，以縮短回答問題與搜尋內部說明文件的時間。非常適合技術團隊。",
  "create-space.drawer.template.documentation-space.details.item1.title": "建立事實來源",
  "create-space.drawer.template.documentation-space.details.item2.description": "透過進階搜尋、標籤和直覺式內容樹狀結構，輕鬆地整理與尋找內容。",
  "create-space.drawer.template.documentation-space.details.item2.title": "讓資訊易於尋找",
  "create-space.drawer.template.finance-team-space-template": "財務團隊空間",
  "create-space.drawer.template.finance-team-space-template.short-title": "財務",
  "create-space.drawer.template.finance-team-space.details.description": "建立事實來源，讓您的團隊和相關人員能夠推動策略計畫的進展。",
  "create-space.drawer.template.finance-team-space.details.item1.description": "透過建立內容事實來源並與合適的相關人員分享，順利與您的內部財務團隊進行合作。",
  "create-space.drawer.template.finance-team-space.details.item1.title": "協同合作並保持同步",
  "create-space.drawer.template.finance-team-space.details.item2.description": "在單一位置整理您的計畫、分析和流程，方便後續尋找。",
  "create-space.drawer.template.finance-team-space.details.item2.title": "保持井然有序",
  "create-space.drawer.template.header": "建立新空間",
  "create-space.drawer.template.hr-team-space-template": "人力資源團隊空間",
  "create-space.drawer.template.hr-team-space-template.short-title": "人力資源",
  "create-space.drawer.template.hr-team-space.details.description": "將團隊的工作流程和資源整理在一個容易尋找的位置，藉此加以簡化。",
  "create-space.drawer.template.hr-team-space.details.item1.description": "集中管理集體知識，確保所有團隊成員都能存取最新的資訊，以利推動工作進展。",
  "create-space.drawer.template.hr-team-space.details.item1.title": "建立事實來源",
  "create-space.drawer.template.hr-team-space.details.item2.description": "在單一位置整理您的專案、計畫和流程，方便後續尋找。",
  "create-space.drawer.template.hr-team-space.details.item2.title": "保持井然有序",
  "create-space.drawer.template.it-team-space-template": "IT 團隊空間",
  "create-space.drawer.template.it-team-space-template.short-title": "IT",
  "create-space.drawer.template.it-team-space.details.description": "在一個整齊的空間中記錄和分享團隊知識，藉此提升工作效率。",
  "create-space.drawer.template.it-team-space.details.item1.description": "在單一位置建立並掌握專案計畫、記錄決策以及分享流程。",
  "create-space.drawer.template.it-team-space.details.item1.title": "讓您的團隊保持同步",
  "create-space.drawer.template.it-team-space.details.item2.description": "集中管理集體知識，確保所有團隊成員都能存取最新的資訊，以利推動工作進展。",
  "create-space.drawer.template.it-team-space.details.item2.title": "建立事實來源",
  "create-space.drawer.template.knowledge-base-space-template": "知識庫空間",
  "create-space.drawer.template.knowledge-base-space-template.short-title": "知識庫",
  "create-space.drawer.template.knowledge-base-space.details.item1.description": "建立長期保存的知識，以保存背景資訊，也藉此避免知識隨員工離職而煙消雲散。適用於商務團隊以及具有內部相關人員的團隊。",
  "create-space.drawer.template.knowledge-base-space.details.item1.title": "操作說明與最佳做法",
  "create-space.drawer.template.knowledge-base-space.details.item2.description": "透過搜尋、標籤和直覺式內容階層輕鬆找到答案。",
  "create-space.drawer.template.knowledge-base-space.details.item2.title": "井然有序，易於尋找",
  "create-space.drawer.template.knowledge-space.details.description": "將團隊集體知識轉換成可共享的單一事實來源，藉此節省時間。",
  "create-space.drawer.template.legal-team-space-template": "法務團隊空間",
  "create-space.drawer.template.legal-team-space-template.short-title": "法律",
  "create-space.drawer.template.legal-team-space.details.description": "在單一位置共用和協作法律專案，以提高團隊的效率。",
  "create-space.drawer.template.legal-team-space.details.item1.description": "選擇從超過 75 個可自訂的範本來建立，或自行製作內容。透過使用標籤，以符合直覺的內容階層來整理內容，並使用捷徑輕鬆存取重要資訊。",
  "create-space.drawer.template.legal-team-space.details.item1.title": "根據團隊需求進行設定和調整",
  "create-space.drawer.template.legal-team-space.details.item2.description": "建立會議記錄以便採取後續行動、追蹤進度，並分享流程。",
  "create-space.drawer.template.legal-team-space.details.item2.title": "讓您的團隊保持同步",
  "create-space.drawer.template.marketing-team-space-template": "行銷團隊空間",
  "create-space.drawer.template.marketing-team-space-template.short-title": "行銷",
  "create-space.drawer.template.marketing-team-space.details.description": "在單一個集中位置協作行銷專案和協調發布事項。",
  "create-space.drawer.template.marketing-team-space.details.item1.description": "與您的團隊快速建立、分享和評論內容，以推動工作進展。",
  "create-space.drawer.template.marketing-team-space.details.item1.title": "輕鬆協同合作",
  "create-space.drawer.template.marketing-team-space.details.item2.description": "掌握時間軸、追蹤決策，並讓每個人保持同步，以推動您的專案。",
  "create-space.drawer.template.marketing-team-space.details.item2.title": "準時交付專案",
  "create-space.drawer.template.next": "下一步",
  "create-space.drawer.template.operations-team-space-template": "營運團隊空間",
  "create-space.drawer.template.operations-team-space-template.short-title": "作業",
  "create-space.drawer.template.operations-team-space.details.description": "輕鬆協作並分享團隊的工作，以推動進展。",
  "create-space.drawer.template.operations-team-space.details.item1.description": "透過建立準確可靠的內容並與相關人員分享，輕鬆進行協作。",
  "create-space.drawer.template.operations-team-space.details.item1.title": "協同合作並保持一致",
  "create-space.drawer.template.operations-team-space.details.item2.description": "展示您的團隊及他們正在進行的工作。輕鬆尋找和聯繫合適的人員，以推動工作進展。",
  "create-space.drawer.template.operations-team-space.details.item2.title": "醒目顯示團隊的工作",
  "create-space.drawer.template.product-management-team-space-template": "產品管理團隊空間",
  "create-space.drawer.template.product-management-team-space-template.short-title": "產品管理",
  "create-space.drawer.template.product-management-team-space.details.description": "在單一位置整理和協作產品計畫，藉此推動工作進展。",
  "create-space.drawer.template.product-management-team-space.details.item1.description": "在單一位置輕鬆建立和協作產品策略、需求和計畫，以保持一致。",
  "create-space.drawer.template.product-management-team-space.details.item1.title": "協同合作並保持一致",
  "create-space.drawer.template.product-management-team-space.details.item2.description": "展示您的團隊及他們正在進行的工作。輕鬆尋找和聯繫合適的人員，以推動工作進展。",
  "create-space.drawer.template.product-management-team-space.details.item2.title": "強調團隊的工作",
  "create-space.drawer.template.progress-indicator": "步驟 1 (共 2 個步驟)",
  "create-space.drawer.template.project-management-team-space-template": "專案管理團隊空間",
  "create-space.drawer.template.project-management-team-space-template.short-title": "專案管理",
  "create-space.drawer.template.project-management-team-space.details.description": "簡化團隊的工作流程，使專案保持運作狀態，並將計畫記錄在單一位置。",
  "create-space.drawer.template.project-management-team-space.details.item1.description": "透過追蹤時間軸、記錄決策並與所有團隊成員保持同步來掌握時程。",
  "create-space.drawer.template.project-management-team-space.details.item1.title": "在專案期限內完成",
  "create-space.drawer.template.project-management-team-space.details.item2.description": "在集中位置整理您的專案、計畫和流程，以便輕鬆存取。",
  "create-space.drawer.template.project-management-team-space.details.item2.title": "讓一切保持井然有序",
  "create-space.drawer.template.project-space-template": "軟體專案空間",
  "create-space.drawer.template.project-space-template.short-title": "軟體專案",
  "create-space.drawer.template.project-space.details.description": "透過彈性的工作區開始您的軟體專案。",
  "create-space.drawer.template.project-space.details.item1.description": "將開發計畫連結至強大的 Jira 整合功能，包括議題追蹤和動態更新藍圖。",
  "create-space.drawer.template.project-space.details.item1.title": "Jira 整合",
  "create-space.drawer.template.project-space.details.item2.description": "使用空白頁面從頭開始，或從超過 75 個可自訂的範本中選擇，以完成專案。從策略擬定到規劃文件和報告等等全都適用。",
  "create-space.drawer.template.project-space.details.item2.description.livedocs": "從空白狀態開始，或從超過 75 個可自訂的範本中選擇，以完成各種專案。從策略擬定到規劃文件和報告等等全都適用。",
  "create-space.drawer.template.project-space.details.item2.title": "最佳做法範本",
  "create-space.drawer.template.research-team-space-template": "研究團隊空間",
  "create-space.drawer.template.research-team-space-template.short-title": "研究",
  "create-space.drawer.template.research-team-space.details.description": "在一個集中的位置輕鬆協作、記錄和分享深入解析。",
  "create-space.drawer.template.research-team-space.details.item1.description": "展示您的團隊及他們正在進行的工作。輕鬆尋找和聯繫合適的人員，以推動工作進展。",
  "create-space.drawer.template.research-team-space.details.item1.title": "展示團隊的工作",
  "create-space.drawer.template.research-team-space.details.item2.description": "集中管理集體知識，確保所有團隊成員都能存取最新的資訊，以利推動工作進展。",
  "create-space.drawer.template.research-team-space.details.item2.title": "將團隊知識集中在一處",
  "create-space.drawer.template.sales-team-space-template": "銷售團隊空間",
  "create-space.drawer.template.sales-team-space-template.title": "銷售",
  "create-space.drawer.template.sales-team-space.details.description": "讓銷售團隊輕鬆整理和找到結案所需的合適資訊，藉此提升團隊戰鬥力。",
  "create-space.drawer.template.sales-team-space.details.item1.description": "集中整理銷售素材、深入解析和策略，讓您的團隊能夠輕鬆存取重要資源。",
  "create-space.drawer.template.sales-team-space.details.item1.title": "將團隊知識集中在一處",
  "create-space.drawer.template.sales-team-space.details.item2.description": "突顯團隊和績效。輕鬆尋找和聯繫合適的人員，以推動工作進展。",
  "create-space.drawer.template.sales-team-space.details.item2.title": "展示團隊的影響力",
  "create-space.drawer.template.team-space-template": "團隊空間",
  "create-space.drawer.template.team-space-template.short-title": "團隊",
  "create-space.drawer.template.team-space.details.description": "建立一個井然有序的地方，讓團隊進行分工合作。",
  "create-space.drawer.template.team-space.details.item1.description": "展示您的團隊及他們正在進行的工作。輕鬆尋找和聯繫合適的人員，以推動工作進展。",
  "create-space.drawer.template.team-space.details.item1.title": "展示團隊的工作",
  "create-space.drawer.template.team-space.details.item2.description": "建立會議記錄以便採取後續行動、追蹤進度，並分享流程。",
  "create-space.drawer.template.team-space.details.item2.title": "讓您的團隊保持同步",
  "create-space.drawer.type.space-types.blank.description": "手動設定您的空間",
  "create-space.drawer.type.space-types.blank.title": "自訂",
  "create-space.drawer.type.space-types.collaboration.description": "探索並與團隊持續合作",
  "create-space.drawer.type.space-types.collaboration.description.live-pages": "即時探索並與團隊持續合作",
  "create-space.drawer.type.space-types.collaboration.title": "協作",
  "create-space.drawer.type.space-types.knowledge.description": "建立、發布並分享重要的說明文件",
  "create-space.drawer.type.space-types.knowledge.title": "知識庫",
  "create-space.illustration.side-nav.analytics": "分析",
  "create-space.illustration.side-nav.blog": "部落格",
  "create-space.illustration.side-nav.calendar": "行事曆",
  "create-space.illustration.side-nav.overview": "概觀",
  "create-space.illustration.side-nav.pages": "頁面",
  "create-space.illustration.side-nav.shortcuts": "捷徑",
  "create-space.menu-item-with-icon": "空間",
  "create-space.project-linker.atlas": "Atlas",
  "create-space.project-linker.connect-tools": "連接您的專案管理工具",
  "create-space.project-linker.extension.description": "提供一種方便的方式，連結至空間概觀上的專案",
  "create-space.project-linker.extension.title": "專案連結工具",
  "create-space.project-linker.jira": "Jira",
  "create-space.project-linker.link-picker.aria-label": "專案追蹤連結選擇器",
  "create-space.project-linker.link-picker.link-label": "搜尋專案或工單",
  "create-space.project-linker.link-picker.link-placeholder": "尋找最近的專案",
  "custom-content-page.custom-content-on-page.custom-content": "自訂內容",
  "custom-content.custom-content-space-list-view.contributors": "參與者",
  "custom-content.custom-content-space-list-view.errorBody": "請稍後再試一次。",
  "custom-content.custom-content-space-list-view.errorTitle": "發生錯誤。",
  "custom-content.custom-content-space-list-view.lastModified": "上次修改",
  "custom-content.custom-content-space-list-view.name": "名稱",
  "custom-content.custom-content-space-list-view.noItems": "沒有項目",
  "custom-content.custom-content-space-list-view.noResults": "這裡目前什麼都沒有，只有潛力無限",
  "custom-content.custom-content-space-list-view.timeToFill": "是時候讓此空間變得與眾不同了。",
  "custom-content.page-list-view.cell.delete": "刪除",
  "custom-content.page-list-view.cell.delete.body": "您確定要將「{contentTitle}」丟到垃圾桶嗎？只有空間管理員可以復原此動作。",
  "custom-content.page-list-view.cell.delete.cancel": "取消",
  "custom-content.page-list-view.cell.delete.header": "「{contentTitle}」刪除確認",
  "custom-content.page-list-view.column-header.actions": "動作",
  "custom-content.page-list-view.column-header.creation-date": "建立日期",
  "custom-content.page-list-view.column-header.creator": "建立者",
  "custom-content.page-list-view.column-header.labels": "標籤",
  "custom-content.page-list-view.column-header.name": "名稱",
  "custom-header-footer.unsupported.macros.list": "{type} 中目前不支援下列巨集：",
  "custom-header-footer.unsupported.macros.title": "不支援的巨集",
  "custom-sites-extensions.add.header.image.message.floating-toolbar": "標頭圖片",
  "custom-sites-extensions.cards.hub-element.description": "顯示連結、圖片等等",
  "custom-sites-extensions.cards.hub-element.title": "卡片",
  "custom-sites-extensions.carousel.card-strip.card.label": "第 {positionInSet} 張投影片 (共 {setSize} 張)",
  "custom-sites-extensions.carousel.config-panel.field.frames.error.invalid-list": "新增框架",
  "custom-sites-extensions.carousel.config-panel.layouts.solid-color-background.label": "純色背景",
  "custom-sites-extensions.carousel.config-panel.layouts.split-design-content.label": "分割設計",
  "custom-sites-extensions.carousel.config-panel.preamble": "建立動態框架的三重輪替。 {supportLink}",
  "custom-sites-extensions.carousel.config-panel.preamble-link.label": "需要協助嗎？",
  "custom-sites-extensions.carousel.config-panel.preamble-link.label-v2": "深入了解輪播",
  "custom-sites-extensions.carousel.config-panel.style.general.title": "一般",
  "custom-sites-extensions.carousel.config-panel.style.navigation.title": "導覽",
  "custom-sites-extensions.carousel.config-panel.styles.autoplay-label": "自動播放",
  "custom-sites-extensions.carousel.config-panel.tab.content.label": "內容",
  "custom-sites-extensions.carousel.config-panel.tab.styles.label": "樣式",
  "custom-sites-extensions.carousel.config-panel.title": "輪播",
  "custom-sites-extensions.carousel.hero-card.label": "第 {positionInSet} 張投影片 (共 {setSize} 張)",
  "custom-sites-extensions.carousel.hub-element.description": "一組好看的輪播架構",
  "custom-sites-extensions.carousel.hub-element.title": "輪播",
  "custom-sites-extensions.carousel.manifest.macro-description": "建立動態框架的三重輪替。",
  "custom-sites-extensions.carousel.manifest.macro-title": "輪播",
  "custom-sites-extensions.carousel.manifest.macro-title.new": "輪播 [新功能]",
  "custom-sites-extensions.config-panel.add-card-cta": "新增卡片",
  "custom-sites-extensions.config-panel.feedback-collector.preamble.first-line": "您的意見非常寶貴，能讓我們知道如何更加符合您的需求。有哪裡可以改善的嗎？",
  "custom-sites-extensions.config-panel.feedback-collector.summary-placeholder": "哪些功能效果很好？有哪裡可以改善的嗎？",
  "custom-sites-extensions.config-panel.feedback-section.preamble": "您的意見反應有助於我們改善產品。",
  "custom-sites-extensions.config-panel.feedback-section.share-feedback-button.text-extension": "{type, select, Cards {提供有關卡片的意見反應} Carousel {提供有關輪播的意見反應} Linksmenu {提供有關連結選單的意見反應} Spotlight {提供有關聚光燈的意見反應} Section {提供有關「區段」的意見反應} Companyhub {提供有關公司中心的意見反應} other {分享您的想法}}",
  "custom-sites-extensions.config-panel.new-lozenge-label": "全新",
  "custom-sites-extensions.config-panel.render-variant.dropdown.label": "卡片類型",
  "custom-sites-extensions.config-panel.render-variant.dropdown.option.label.dynamic": "動態",
  "custom-sites-extensions.config-panel.render-variant.dropdown.option.label.manual": "手動",
  "custom-sites-extensions.config-panel.render-variant.dynamic": "<p>動態</p>",
  "custom-sites-extensions.config-panel.render-variant.dynamic.description": "使用<strong>動態</strong>卡片來建置篩選條件，立即產生一組自動更新的卡片。",
  "custom-sites-extensions.config-panel.render-variant.manual": "<p>手動</p>",
  "custom-sites-extensions.config-panel.render-variant.manual.description": "使用<strong>手動</strong>卡片，將特定連結、文字或圖片新增至中心。",
  "custom-sites-extensions.elements.config-panel.title": "元素",
  "custom-sites-extensions.hero-card.view": "檢視",
  "custom-sites-extensions.hubElementPlaceholder.manifest.extension-title.non-final": "中心元素預留位置",
  "custom-sites-extensions.hubElementPlaceholder.newLozenge": "全新",
  "custom-sites-extensions.hubElementPlaceholder.subHeading": "這裡還沒有任何內容可以顯示。想看看可以放哪些內容...",
  "custom-sites-extensions.hubElementPlaceholder.viewAllOptions": "檢視所有選項",
  "custom-sites-extensions.link-cards-config-panel.content-tab.label": "內容",
  "custom-sites-extensions.link-cards-config-panel.styles-tab.label": "樣式",
  "custom-sites-extensions.link-cards-content.card-components.build-dynamic-cards": "建置動態卡片",
  "custom-sites-extensions.link-cards-content.card-components.card-count-label": "卡片數目",
  "custom-sites-extensions.link-cards-content.card-components.dynamic-content-modal-dialog.cancel-button": "取消",
  "custom-sites-extensions.link-cards-content.card-components.dynamic-content-modal-dialog.clear-all-filters-button": "清除所有篩選條件",
  "custom-sites-extensions.link-cards-content.card-components.dynamic-content-modal-dialog.confirm-button": "確認",
  "custom-sites-extensions.link-cards-content.card-components.dynamic-content-modal-dialog.header": "建置動態卡片",
  "custom-sites-extensions.link-cards-content.card-components.dynamic-content-modal-dialog.header-subtext": "建立一組自訂的自動填入卡片，以顯示最新資訊。使用篩選條件，按標籤、空間、負責人等等選取卡片內容。",
  "custom-sites-extensions.link-cards-content.card-components.error-states.loading-cards-error-preamble": "我們在載入這些卡片時遇到問題。",
  "custom-sites-extensions.link-cards-content.card-components.error-states.loading-cards-error-support": "請重新載入以再試一次。",
  "custom-sites-extensions.link-cards-content.card-components.error-states.no-dynamic-cards.header": "尚未有動態卡片",
  "custom-sites-extensions.link-cards-content.card-components.error-states.no-results.description": "內容不存在或在新增此連結後可能已變更",
  "custom-sites-extensions.link-cards-content.card-components.error-states.no-results.header": "我們無法向您顯示此內容",
  "custom-sites-extensions.link-cards-content.card-components.error-states.restricted-content.button.label": "要求存取權",
  "custom-sites-extensions.link-cards-content.card-components.error-states.restricted-content.description": "您需要取得要求存取權或嘗試其他帳戶，才能查看此預覽",
  "custom-sites-extensions.link-cards-content.card-components.error-states.restricted-content.header": "受限制的內容",
  "custom-sites-extensions.link-cards-content.card-components.view-current-filters": "檢視目前的篩選條件",
  "custom-sites-extensions.link-cards.autoscroll-wrapper.pause": "暫停",
  "custom-sites-extensions.link-cards.autoscroll-wrapper.play": "播放",
  "custom-sites-extensions.link-cards.card.background.color": "背景顏色",
  "custom-sites-extensions.link-cards.card.collapse.label": "摺疊卡片",
  "custom-sites-extensions.link-cards.card.color-contrast.fail": "您的文字和背景顏色搭配無法凸顯內容。",
  "custom-sites-extensions.link-cards.card.color-contrast.success": "您的文字和背景顏色搭配可以凸顯內容。",
  "custom-sites-extensions.link-cards.card.expand.label": "展開卡片",
  "custom-sites-extensions.link-cards.card.image.section.label": "圖片",
  "custom-sites-extensions.link-cards.card.remove.card.label": "移除卡片",
  "custom-sites-extensions.link-cards.card.text.color": "文字顏色",
  "custom-sites-extensions.link-cards.card.title": "卡片 {order}",
  "custom-sites-extensions.link-cards.cards-area-container-components.draggable-card-container.arrow.down": "向下",
  "custom-sites-extensions.link-cards.cards-area-container-components.draggable-card-container.arrow.up": "向上",
  "custom-sites-extensions.link-cards.cards-area-container-components.draggable-card-container.move.down.label": "下移",
  "custom-sites-extensions.link-cards.cards-area-container-components.draggable-card-container.move.up.label": "向上移動",
  "custom-sites-extensions.link-cards.cards-area-container-components.draggable-card-container.reorder": "重新排序",
  "custom-sites-extensions.link-cards.config-panel.link.field.label": "連結",
  "custom-sites-extensions.link-cards.description.ai-disclaimer": "內容品質可能會變動",
  "custom-sites-extensions.link-cards.description.button.suggest-description.label": "建議描述",
  "custom-sites-extensions.link-cards.description.field.label": "描述",
  "custom-sites-extensions.link-cards.description.link.label.ai": "進一步了解 Atlassian 人工智慧",
  "custom-sites-extensions.link-cards.error-states.no-data.description-text": "請嘗試刪除此巨集並建立新的巨集。",
  "custom-sites-extensions.link-cards.error-states.no-data.header-text": "沒有可顯示的資料",
  "custom-sites-extensions.link-cards.fetch-cover-image.fetch.error.description": "請重新整理頁面，然後再試一次",
  "custom-sites-extensions.link-cards.fetch-cover-image.fetch.error.title": "我們無法上傳您的圖片",
  "custom-sites-extensions.link-cards.image-failed-to-load": "圖片無法載入",
  "custom-sites-extensions.link-cards.link-cards-config-panel.alignment-text-label": "對齊",
  "custom-sites-extensions.link-cards.link-cards-config-panel.alignment-text-label.center": "置中",
  "custom-sites-extensions.link-cards.link-cards-config-panel.alignment-text-label.left": "靠左",
  "custom-sites-extensions.link-cards.link-cards-config-panel.alignment-text-label.right": "靠右",
  "custom-sites-extensions.link-cards.link-cards-config-panel.alignment-text-label.v2": "對齊",
  "custom-sites-extensions.link-cards.link-cards-config-panel.alignment-text-label.v2.center": "置中",
  "custom-sites-extensions.link-cards.link-cards-config-panel.alignment-text-label.v2.left": "靠左",
  "custom-sites-extensions.link-cards.link-cards-config-panel.alignment-text-label.v2.right": "靠右",
  "custom-sites-extensions.link-cards.link-cards-config-panel.cards.content.display-options.title": "顯示選項",
  "custom-sites-extensions.link-cards.link-cards-config-panel.cards.error.invalid-list": "新增卡片",
  "custom-sites-extensions.link-cards.link-cards-config-panel.cards.style.general.title": "一般",
  "custom-sites-extensions.link-cards.link-cards-config-panel.cards.text.description": "顯示連結、圖片等。{link}",
  "custom-sites-extensions.link-cards.link-cards-config-panel.cards.text.description.link": "進一步了解卡片。",
  "custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.item.all-cards.label": "所有卡片",
  "custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.item.each-card.label": "每張卡片",
  "custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.item.v2.all-cards.label": "全部卡片",
  "custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.item.v2.each-card.label": "每張卡片",
  "custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.v2.item.no-segmentation.label": "無",
  "custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-field.info-label": "為每張卡片新增目標群組",
  "custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-groups-text-label": "目標群組",
  "custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-groups-text-label.v2": "目標受眾群",
  "custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-text-label": "目標內容：",
  "custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-text.v2.label": "目標受眾",
  "custom-sites-extensions.link-cards.link-cards-config-panel.size-field.drop-down.item.large.label": "大",
  "custom-sites-extensions.link-cards.link-cards-config-panel.size-field.drop-down.item.medium.label": "中",
  "custom-sites-extensions.link-cards.link-cards-config-panel.size-field.drop-down.item.small.label": "小",
  "custom-sites-extensions.link-cards.link-cards-config-panel.size-text-label": "大小",
  "custom-sites-extensions.link-cards.link-cards-config-panel.styles.autoscroll-label": "自動捲動",
  "custom-sites-extensions.link-cards.link-cards-config-panel.styles.autoscroll-tooltip-content": "當您退出編輯模式時，畫面中容納不下的卡片將會開始捲動",
  "custom-sites-extensions.link-cards.link-cards-config-panel.styles.display-as-label": "顯示為",
  "custom-sites-extensions.link-cards.link-cards-config-panel.styles.row-description": "卡片在一列中滾動",
  "custom-sites-extensions.link-cards.link-cards-config-panel.styles.row-label": "列",
  "custom-sites-extensions.link-cards.link-cards-config-panel.styles.stacked-description": "卡片換到新行",
  "custom-sites-extensions.link-cards.link-cards-config-panel.styles.stacked-label": "堆疊",
  "custom-sites-extensions.link-cards.link-cards-config-panel.title-text-label": "卡片",
  "custom-sites-extensions.link-cards.link-cards-config-panel.type-field.toggle.avatar.label": "顯示負責人",
  "custom-sites-extensions.link-cards.link-cards-config-panel.type-field.toggle.avatar.label-v2": "頁面負責人",
  "custom-sites-extensions.link-cards.link-cards-config-panel.type-field.toggle.info-icon-label": "選擇哪些 Confluence 使用者群組會看到您的卡片",
  "custom-sites-extensions.link-cards.link-cards-config-panel.type-field.toggle.info-icon-label-v2": "選擇哪些 Confluence 使用者群組會看到您的卡片",
  "custom-sites-extensions.link-cards.link-cards-config-panel.type-field.toggle.new-lozenge-label": "全新",
  "custom-sites-extensions.link-cards.link-cards-config-panel.type-field.toggle.new-lozenge-label-v2": "全新",
  "custom-sites-extensions.link-cards.link-cards-config-panel.type-field.toggle.publish-date.label": "顯示上次更新時間",
  "custom-sites-extensions.link-cards.link-cards-config-panel.type-field.toggle.publish-date.label-v2": "上次更新",
  "custom-sites-extensions.link-cards.link-cards-config-panel.type-field.toggle.segmentation.label": "選擇目標受眾",
  "custom-sites-extensions.link-cards.link-cards-config-panel.type-field.toggle.segmentation.label-v2": "目標受眾",
  "custom-sites-extensions.link-cards.link-cards-content.segmentation-message.restricted": "與您相關",
  "custom-sites-extensions.link-cards.manifest.macro-description": "將連結顯示為卡片",
  "custom-sites-extensions.link-cards.manifest.macro-title": "卡片",
  "custom-sites-extensions.link-cards.manifest.macro-title.new": "卡片 [新功能]",
  "custom-sites-extensions.link-cards.recommended.field.label": "(推薦)",
  "custom-sites-extensions.link-cards.row-orientation.next": "下一步",
  "custom-sites-extensions.link-cards.row-orientation.previous": "上一頁",
  "custom-sites-extensions.link-cards.smart-card.empty-state.placeholder-title": "新增標題",
  "custom-sites-extensions.link-cards.smart-card.extra-small-card.placeholder-title": "新增標題",
  "custom-sites-extensions.link-cards.smart-card.hero.empty-state.description.placeholder-text": "自訂此動態框架以建立旋轉輪播。",
  "custom-sites-extensions.link-cards.smart-card.hero.empty-state.placeholder-title": "新增標題",
  "custom-sites-extensions.link-cards.smart-card.no-results-title": "這裡還沒有任何內容可以顯示。請稍後再返回查看。",
  "custom-sites-extensions.link-cards.title.field.label": "標題",
  "custom-sites-extensions.link-cards.warning": "無法載入圖片的警告圖示",
  "custom-sites-extensions.link.cards.image.upload.error.flag.description": "請重新整理頁面，然後再試一次。",
  "custom-sites-extensions.link.cards.image.upload.error.flag.title": "我們無法上傳您的圖片",
  "custom-sites-extensions.links-menu.alignment.title": "對齊",
  "custom-sites-extensions.links-menu.all.borders.label-text": "每一邊",
  "custom-sites-extensions.links-menu.background.color": "背景顏色",
  "custom-sites-extensions.links-menu.background.title": "背景",
  "custom-sites-extensions.links-menu.border.color": "邊框顏色",
  "custom-sites-extensions.links-menu.border.position": "邊框位置",
  "custom-sites-extensions.links-menu.bottom.border.label-text": "底部邊框",
  "custom-sites-extensions.links-menu.center.option": "置中",
  "custom-sites-extensions.links-menu.config-panel.add-link-button.description": "新增重要連結",
  "custom-sites-extensions.links-menu.config-panel.add-link-button.text": "連結",
  "custom-sites-extensions.links-menu.config-panel.add-menu-button.description": "將相關連結分成一組",
  "custom-sites-extensions.links-menu.config-panel.add-menu-button.disabled.tooltip-text": "您已達到巢狀層級的數量上限。",
  "custom-sites-extensions.links-menu.config-panel.add-menu-button.text": "選單",
  "custom-sites-extensions.links-menu.config-panel.delete-nested-items-modal.cancel-text": "取消",
  "custom-sites-extensions.links-menu.config-panel.delete-nested-items-modal.confirm-text": "刪除",
  "custom-sites-extensions.links-menu.config-panel.delete-nested-items-modal.description-text": "此動作將刪除此項目和所有巢狀項目。",
  "custom-sites-extensions.links-menu.config-panel.delete-nested-items-modal.title-text": "刪除項目",
  "custom-sites-extensions.links-menu.config-panel.item-dropdown.add-sub-item-button.text": "新增子項目",
  "custom-sites-extensions.links-menu.config-panel.item-dropdown.delete-item-button.text": "刪除項目",
  "custom-sites-extensions.links-menu.config-panel.item-dropdown.edit-properties-button.text": "編輯屬性",
  "custom-sites-extensions.links-menu.config-panel.item-dropdown.move-item-down.text": "向下移動",
  "custom-sites-extensions.links-menu.config-panel.item-dropdown.move-item-up.text": "向上移動",
  "custom-sites-extensions.links-menu.config-panel.item-dropdown.open-link-button.text": "開啟連結",
  "custom-sites-extensions.links-menu.config-panel.items.label": "項目",
  "custom-sites-extensions.links-menu.config-panel.new-item-button.disabled.tooltip-text": "您已達到可新增至連結選單的項目數量上限。",
  "custom-sites-extensions.links-menu.config-panel.new-item-button.text": "新項目",
  "custom-sites-extensions.links-menu.config-panel.preamble": "新增連結並使用子選單加以整理。{linksMenuSupportLink}",
  "custom-sites-extensions.links-menu.config-panel.preamble-link.label": "進一步了解連結選單",
  "custom-sites-extensions.links-menu.config-panel.property-config.cancel-button-label": "取消",
  "custom-sites-extensions.links-menu.config-panel.property-config.confirm-button-label": "確認",
  "custom-sites-extensions.links-menu.config-panel.property-config.display-text-error": "請填寫此欄位。",
  "custom-sites-extensions.links-menu.config-panel.property-config.display-text-label": "顯示文字",
  "custom-sites-extensions.links-menu.config-panel.property-config.display-text-placeholder": "項目名稱",
  "custom-sites-extensions.links-menu.config-panel.property-config.link.submit-button-label": "確認",
  "custom-sites-extensions.links-menu.config-panel.property-config.more-button-label": "更多",
  "custom-sites-extensions.links-menu.config-panel.styles.label": "樣式",
  "custom-sites-extensions.links-menu.config-panel.sub-item-button.disabled.tooltip-text": "您已達到可新增至連結選單的項目數量上限。",
  "custom-sites-extensions.links-menu.config-panel.title": "連結選單",
  "custom-sites-extensions.links-menu.corner.style": "角落樣式",
  "custom-sites-extensions.links-menu.corner.style-round": "圓形",
  "custom-sites-extensions.links-menu.corner.style-square": "正方形",
  "custom-sites-extensions.links-menu.fixed.option": "固定在頂部",
  "custom-sites-extensions.links-menu.left.option": "靠左",
  "custom-sites-extensions.links-menu.links-menu-content.links-menu-items.more.title": "更多",
  "custom-sites-extensions.links-menu.manifest.extension-description": "將多個連結和子選單新增至「公司中心」",
  "custom-sites-extensions.links-menu.manifest.extension-title": "連結選單 [新功能]",
  "custom-sites-extensions.links-menu.manifest.first-default-item": "關於我們",
  "custom-sites-extensions.links-menu.manifest.nested-default-item": "團隊 1",
  "custom-sites-extensions.links-menu.manifest.second-default-item": "福利",
  "custom-sites-extensions.links-menu.manifest.third-default-item": "團隊",
  "custom-sites-extensions.links-menu.no.border.label-text": "無",
  "custom-sites-extensions.links-menu.right.option": "靠右",
  "custom-sites-extensions.links-menu.section.collapse.label": "摺疊區段",
  "custom-sites-extensions.links-menu.section.expand.label": "展開區段",
  "custom-sites-extensions.links-menu.selected.state.color": "選取的狀態顏色",
  "custom-sites-extensions.links-menu.text.color": "文字顏色",
  "custom-sites-extensions.links-menu.text.title": "文字",
  "custom-sites-extensions.page-title.alignment.error.description": "請再試一次或重新整理頁面。",
  "custom-sites-extensions.page-title.alignment.error.title": "無法更新標題一致性",
  "custom-sites-extensions.page-title.popup.fixed-width.option": "固定寬度",
  "custom-sites-extensions.page-title.popup.full-width.option": "全寬",
  "custom-sites-extensions.page-title.popup.label": "標題影像",
  "custom-sites-extensions.page-title.popup.label.subtext": "我們建議您使用 1100 像素或更寬的圖片。",
  "custom-sites-extensions.page-title.popup.remove-image": "移除圖片",
  "custom-sites-extensions.page-title.popup.reposition": "重新定位",
  "custom-sites-extensions.page-title.popup.update.header.image": "更新標頭影像",
  "custom-sites-extensions.refined.unsplash.search.placeholder": "瀏覽 Unsplash",
  "custom-sites-extensions.search.custom-search-config-panel.corner-style-label": "轉角",
  "custom-sites-extensions.search.custom-search-config-panel.default-placeholder-text": "搜尋經過驗證的公告、資源和政策",
  "custom-sites-extensions.search.custom-search-config-panel.filters-title": "篩選條件",
  "custom-sites-extensions.search.custom-search-config-panel.placeholder-text-label": "預留位置文字",
  "custom-sites-extensions.search.custom-search-config-panel.placeholder-tooltip-label": "自訂讀者會看到的提示",
  "custom-sites-extensions.search.custom-search-config-panel.preamble": "新增經過篩選的搜尋列",
  "custom-sites-extensions.search.custom-search-config-panel.round-corner-style-label": "圓形",
  "custom-sites-extensions.search.custom-search-config-panel.sharp-corner-style-label": "正方形",
  "custom-sites-extensions.search.custom-search-config-panel.styles-fill-color-label": "填入顏色",
  "custom-sites-extensions.search.custom-search-config-panel.styles-text-color-label": "文字顏色",
  "custom-sites-extensions.search.custom-search-config-panel.styles-title": "樣式",
  "custom-sites-extensions.search.custom-search-config-panel.title": "自訂搜尋",
  "custom-sites-extensions.search.manifest.default-placeholder-text": "搜尋經過驗證的公告、資源和政策",
  "custom-sites-extensions.search.manifest.macro-description": "新增經過篩選的搜尋列",
  "custom-sites-extensions.search.manifest.macro-title": "自訂搜尋",
  "custom-sites-extensions.search.more-button": "檢視更多結果",
  "custom-sites-extensions.section.config-panel.background-color-field.background-color": "背景顏色",
  "custom-sites-extensions.section.config-panel.content-width-field.full-label": "完整",
  "custom-sites-extensions.section.config-panel.content-width-field.full-tooltip": "全寬",
  "custom-sites-extensions.section.config-panel.content-width-field.label": "內容寬度",
  "custom-sites-extensions.section.config-panel.content-width-field.narrow-label": "窄",
  "custom-sites-extensions.section.config-panel.content-width-field.narrow-tooltip": "窄",
  "custom-sites-extensions.section.config-panel.content-width-field.wide-label": "寬",
  "custom-sites-extensions.section.config-panel.content-width-field.wide-tooltip": "寬",
  "custom-sites-extensions.section.config-panel.preamble": "透過可自訂的背景和風格設定，將相關元素整理成不同區段。{supportLink}",
  "custom-sites-extensions.section.config-panel.preamble-link.label": "進一步了解如何設計您的中心。",
  "custom-sites-extensions.section.config-panel.title": "區段",
  "custom-sites-extensions.section.error-loading-content": "載入內容時發生錯誤",
  "custom-sites-extensions.section.manifest.content.header": "為您的區域命名",
  "custom-sites-extensions.section.manifest.content.placeholder-title": "預留位置",
  "custom-sites-extensions.section.manifest.content.sub-header": "透過可自訂的背景，將元素整理成區段。",
  "custom-sites-extensions.section.manifest.extension-lozenge-title": "區段",
  "custom-sites-extensions.section.manifest.extension-title": "區段 [新]",
  "custom-sites-extensions.section.manifest.macro-description": "透過背景將元素分組",
  "custom-sites-extensions.shared-components.link-picker.clear-icon-label": "清除連結選取",
  "custom-sites-extensions.shared-components.link-picker.popup-placeholder-text": "新增任何連結",
  "custom-sites-extensions.shared-components.unsplash-search.upload.error.description": "請重新整理頁面，然後再試一次",
  "custom-sites-extensions.shared-components.unsplash-search.upload.error.title": "圖片無法載入",
  "custom-sites-extensions.spotlight.background.color": "背景顏色",
  "custom-sites-extensions.spotlight.button-label.placeholder": "檢視",
  "custom-sites-extensions.spotlight.color-contrast.fail": "您的文字和背景顏色搭配無法凸顯內容。",
  "custom-sites-extensions.spotlight.color-contrast.success": "您的文字和背景顏色搭配可以凸顯內容。",
  "custom-sites-extensions.spotlight.config-panel.preamble": "透過視覺聚光燈凸顯重要訊息。{supportLink}",
  "custom-sites-extensions.spotlight.config-panel.preamble-link.label": "進一步了解聚光燈",
  "custom-sites-extensions.spotlight.config-panel.title": "聚光燈",
  "custom-sites-extensions.spotlight.hub-element.description": "凸顯重要訊息",
  "custom-sites-extensions.spotlight.hub-element.title": "聚光燈",
  "custom-sites-extensions.spotlight.manifest.initial-state.alt-image-text": "沙漠的橫式照片",
  "custom-sites-extensions.spotlight.manifest.initial-state.text-description": "設計聚光燈以凸顯您最重要的資訊。透過自訂顏色、強大的圖片和彈性版面配置，讓最重要的訊息更加生動。",
  "custom-sites-extensions.spotlight.manifest.initial-state.text-title": "為聚光燈提供標題",
  "custom-sites-extensions.spotlight.manifest.macro-description": "透過視覺聚光燈凸顯重要訊息。",
  "custom-sites-extensions.spotlight.manifest.macro-title": "聚光燈",
  "custom-sites-extensions.spotlight.manifest.macro-title.new": "聚光燈 [新功能]",
  "custom-sites-extensions.spotlight.spotlight-config-panel.button-heading": "按鈕",
  "custom-sites-extensions.spotlight.spotlight-config-panel.button-text-placeholder": "檢視",
  "custom-sites-extensions.spotlight.spotlight-config-panel.content-tab.label": "內容",
  "custom-sites-extensions.spotlight.spotlight-config-panel.dark-button-style-label": "替代方案",
  "custom-sites-extensions.spotlight.spotlight-config-panel.delete-icon-label": "刪除",
  "custom-sites-extensions.spotlight.spotlight-config-panel.general-title": "一般",
  "custom-sites-extensions.spotlight.spotlight-config-panel.layouts-title": "版面配置",
  "custom-sites-extensions.spotlight.spotlight-config-panel.layouts.image-background.description": "內容背後的完整尺寸圖片",
  "custom-sites-extensions.spotlight.spotlight-config-panel.layouts.image-background.label": "圖片背景",
  "custom-sites-extensions.spotlight.spotlight-config-panel.layouts.solid-color-background.description": "全寬度顏色前面的內容",
  "custom-sites-extensions.spotlight.spotlight-config-panel.layouts.solid-color-background.label": "純色背景",
  "custom-sites-extensions.spotlight.spotlight-config-panel.layouts.split-design-content-first.description": "右側的大圖片有很多顯示內容的空間",
  "custom-sites-extensions.spotlight.spotlight-config-panel.layouts.split-design-content-first.label": "分割設計 (內容優先)",
  "custom-sites-extensions.spotlight.spotlight-config-panel.layouts.split-design-image-first.description": "左側的大圖片有很多顯示內容的空間",
  "custom-sites-extensions.spotlight.spotlight-config-panel.layouts.split-design-image-first.label": "分割設計 (圖片優先)",
  "custom-sites-extensions.spotlight.spotlight-config-panel.light-button-style-label": "預設",
  "custom-sites-extensions.spotlight.spotlight-config-panel.mdia-picker-helper-message": "選擇 1200px 或更寬的高解析度圖片，以呈現最佳效果。",
  "custom-sites-extensions.spotlight.spotlight-config-panel.media-picker-button-label": "選擇媒體",
  "custom-sites-extensions.spotlight.spotlight-config-panel.media-picker-content-title": "媒體",
  "custom-sites-extensions.spotlight.spotlight-config-panel.styles-tab.label": "樣式",
  "custom-sites-extensions.spotlight.spotlight-config-panel.text-description-label": "描述",
  "custom-sites-extensions.spotlight.spotlight-config-panel.text-description-placeholder": "聚光燈會為您的團隊凸顯重要訊息。使用圖片、自訂顏色、簡短的描述和連結來設計您的聚光燈。",
  "custom-sites-extensions.spotlight.spotlight-config-panel.text-image-label": "圖片",
  "custom-sites-extensions.spotlight.spotlight-config-panel.text-title-label": "標題",
  "custom-sites-extensions.spotlight.spotlight-config-panel.text-title-placeholder": "為聚光燈提供標題",
  "custom-sites-extensions.spotlight.text.color": "文字顏色",
  "custom-sites-extensions.unsplash-search.default-image-picker.no-image": "沒有圖片",
  "custom-sites-extensions.unsplash.background-img.default.label": "上傳預覽器的預設背景圖片",
  "custom-sites-extensions.unsplash.delete.image.text": "移除圖片",
  "custom-sites-extensions.unsplash.error.bad-request-message": "我們無法從 Unsplash 收到回覆。請重新整理，然後再試一次。",
  "custom-sites-extensions.unsplash.error.rate-limited-message": "我們無法從 Unsplash 收到回覆。請稍候，然後再試一次。",
  "custom-sites-extensions.unsplash.legal": "使用來自 Unsplash 的圖片，即表示您同意其{unsplashLicenseLink}和{unsplashTermsOfServiceLink}。",
  "custom-sites-extensions.unsplash.license": "授權",
  "custom-sites-extensions.unsplash.search.error.no-network-message": "連線已中斷。請再試一次。",
  "custom-sites-extensions.unsplash.search.load.more.unsplash.photos": "載入更多",
  "custom-sites-extensions.unsplash.search.no.more.results.to.load.text": "沒有更多相符項目，請嘗試其他搜尋",
  "custom-sites-extensions.unsplash.search.no.results.text": "沒有任何項目符合您的搜尋內容",
  "custom-sites-extensions.unsplash.terms.of.service.": "服務條款",
  "custom-sites-extensions.unsplash.upload.label": "上傳",
  "custom-sites-extensions.unsplash.upload.text": "上傳",
  "custom.page.content.description-v2": "自訂 Confluence 中所有頁面和即時文件的外觀。使用 <a>Wiki 標記</a>來新增文字、連結、巨集和圖片 (從 Web 或附加至空間中的頁面或即時文件)。",
  "custom.page.content.description.livedocs": "自訂 Confluence 中所有頁面和即時文件的外觀。使用 <a>Wiki 標記</a>來新增文字、連結、巨集和圖片 (從 Web 或附加至空間中的頁面或即時文件)。",
  "customize-navigation.color-field.background-color-section-description": "主要導覽列的背景顏色。",
  "customize-navigation.color-field.backgroundColor-section-title": "背景顏色",
  "customize-navigation.color-field.highlight-color-section-description": "「建立」按鈕和任何所選導覽項目的顏色。",
  "customize-navigation.color-field.highlightColor-section-title": "醒目提示顏色",
  "customize-navigation.color-field.section-title": "選取導覽顏色",
  "customize-navigation.color-field.subsection-title": "選擇調色盤或新增一個您自己的調色盤。在深色和淺色主題之間切換時，會自動調整。",
  "customize-navigation.discard-button.label": "捨棄變更",
  "customize-navigation.feedback-solicitation": "<p>您的意見反應可協助我們改善服務。<button>分享您的想法</button></p>",
  "customize-navigation.save-button.label": "儲存",
  "customize-navigation.site-logo.logo-upload-contents-remove-custom-logo": "移除自訂標誌",
  "customize-navigation.site-logo.logo-upload-contents-upload-description-cta": "<p><button>選取要上傳的檔案</button>或拖放到此處</p>",
  "customize-navigation.site-logo.logo-upload-contents-uploading-message": "正在上傳...",
  "customize-navigation.site-logo.logo-upload-dropzone.custom-alt-text-image-label": "上傳的圖片",
  "customize-navigation.site-logo.logo-upload-fle-status.upload-error": "圖片無法上傳 - 請再試一次...",
  "customize-navigation.site-logo.logo-upload-fle-status.upload-success": "標誌已上傳",
  "customize-navigation.site-logo.logo-upload.section-text": "選擇至少 200 x 200 像素的 PNG 或 JPEG 檔案。",
  "customize-navigation.site-logo.logo-upload.section-title": "上傳自訂標誌",
  "customize-navigation.title.info.v2": "為導覽列選取自訂標誌和顏色配置。下方會顯示您所選項目的預覽畫面。",
  "data-classification.content-classification-tag.error-primary-text": "無法載入所有資料",
  "data-classification.content-classification-tag.error-secondary-text": "請立即嘗試重新載入。",
  "data-classification.content-classification.error-flag.description": "請再試一次。",
  "data-classification.content-classification.error-flag.title": "分類更新無法儲存",
  "data-classification.content-classification.tag.tooltip": "這個「{contentType}」已分類為「{classification}」",
  "data-classification.copy-page.change-warning-remove-classification": "<b>分類。</b>將內容複製到此空間將移除其資料分類層級。",
  "data-classification.copy-page.change-warning-set-classifications": "<b>分類。</b>如果複製，此內容將繼承新目的地空間的預設分類層級。複製之後，根據目的地空間的預設分類層級，內容將被歸類為「{classification}」。",
  "data-classification.copy-page.change-warning-title": "<h3>將內容複製到此空間將會變更內容屬性。</h3>",
  "data-classification.copy-page.change-warning-update-classifications": "<b>分類。</b>如果複製，此內容將繼承新目的地空間的預設分類層級。將內容複製到此空間會將其資料分類層級從「{originalClassification}」更新為「{classification}」。",
  "data-classification.editor-component.add-classification-below-breadcrumbs": "新增分類",
  "data-classification.editor-component.add-classification-toolbar": "新增資料分類",
  "data-classification.editor-component.error-message": "無法載入分類。請再試一次。",
  "data-classification.editor-component.floating-toolbar": "資料分類",
  "data-classification.ellipsis-classification-menu-item.classify-content": "分類內容",
  "data-classification.no-classification-option": "空間預設值 - 無分類",
  "data-classification.read-view-popup.no-guidelines": "沒有指南",
  "data-classification.settings-panel.all-classification-levels-archived-description.link": "進一步了解資料分類",
  "data-classification.settings-panel.all-classification-levels-archived-footnote": "為空間中的內容設定 {link}，即可方便您識別和保護機密資訊。",
  "data-classification.settings-panel.all-classification-levels-archived-footnote.link": "預設分類層級",
  "data-classification.settings-panel.classifications-error-action": "請重新整理以再試一次",
  "data-classification.settings-panel.classifications-error-title": "分類層次無法載入",
  "data-classification.settings-panel.description-2": "選取最能描述此空間內容的分類層級。{br}使用預設值開始，即可方便您一次分類空間中的所有頁面和部落格。使用者仍然可以重新分類他們建立的內容，或具有編輯權限的內容。{link}",
  "data-classification.settings-panel.error-flag-action": "重新整理",
  "data-classification.settings-panel.error-flag-body": "尚未為此空間設定新的分類。請再次嘗試儲存。",
  "data-classification.settings-panel.error-flag-title": "無法儲存預設值",
  "data-classification.settings-panel.generic-guidance-copy": "沒有定義",
  "data-classification.settings-panel.link-text-2": "進一步了解資料分類。",
  "data-classification.settings-panel.navigation-lockout-message": "變更不會儲存。如果您現在離開，將會捨棄這些變更。",
  "data-classification.settings-panel.no-classification": "無分類",
  "data-classification.settings-panel.org-default-classification": "組織預設",
  "data-classification.settings-panel.success-flag-body": "在預設情況下，{spaceName} 空間中的內容現在為 {classification}。",
  "data-classification.settings-panel.success-flag-title": "已儲存預設值",
  "data-classification.settings-panel.summary": "分類資料以識別機密資訊。",
  "data-classification.settings-panel.warning-modal": "如果設定此空間的預設分類層級，此空間中的所有內容都將更新。",
  "data-classification.settings-panel.warning-modal-with-count": "{itemCount, plural, =0 {設定此空間的預設分類層級表示此空間中的任何項目都不會更新。} other {設定此空間的預設分類層級表示此空間中的 {itemCount,number} 個項目將會更新。}}",
  "data-classification.settings-panel.warning-modal.button": "指派分類",
  "data-classification.settings-panel.warning-modal.title": "設定預設分類層級",
  "data-classification.shared-messages.fetch-error.primary": "無法載入分類。請再試一次。",
  "data-classification.shared-messages.fetch-error.secondary": "請立即嘗試重新載入。",
  "data-classification.shared-messages.save-error.primary": "分類更新無法儲存",
  "data-classification.shared-messages.save-error.secondary": "請再試一次。",
  "data-classification.space-default-classification-option": "空間預設值",
  "data-lifecycle-management.messages.learn-more": "進一步了解資料保留政策。",
  "data-lifecycle-management.messages.site-access.delete-permission.warning": "此網站已被指定為保留所有內容。作用中的資料保留政策會覆寫您在此處設定的任何刪除權限。",
  "data-lifecycle-management.messages.space-access.delete-permission.warning": "此空間已被指定為保留所有內容。作用中的資料保留政策會覆寫您在此處設定的任何刪除權限。",
  "databases-onboarding-ga.create.content.spotlight.body": "您可以使用資料庫，整理、追蹤和同步位於 Confluence 和 Jira 之上的工作。<a>探索資料庫</a>",
  "databases-onboarding-ga.create.content.spotlight.dismissButton": "關閉",
  "databases-onboarding-ga.create.content.spotlight.header": "整理和同步工作",
  "databases-onboarding-ga.create.content.spotlight.tryButton": "試用資料庫",
  "databases-onboarding-ga.editor-table.body": "資料庫可以整理、追蹤和同步表格版面配置中的資料。<a>探索資料庫</a>",
  "databases-onboarding-ga.editor-table.close": "稍後再說",
  "databases-onboarding-ga.editor-table.cta": "試用資料庫",
  "databases-onboarding-ga.editor-table.heading": "需要更智慧型的表格嗎？",
  "databases-onboarding-ga.getting-started.content.spotlight.help.body": "隨時取得協助或深入了解資料庫。",
  "databases-onboarding-ga.getting-started.content.spotlight.help.dismissBtn": "確定",
  "databases-onboarding.ga-modal.body1": "使用資料庫來組織和管理您的工作。",
  "databases-onboarding.ga-modal.body2": "嘗試建立資料庫，以便與您的團隊開始使用！🚀",
  "databases-onboarding.ga-modal.closeButton": "關閉強制回應",
  "databases-onboarding.ga-modal.explore": "探索資料庫",
  "databases-onboarding.ga-modal.header": "資料庫可供所有人使用",
  "databases-onboarding.ga-modal.tryDatabases": "試用資料庫",
  "databases-onboarding.version-history-modal.body": "檢視和復原舊版本的資料庫。查看更新時間軸以了解最新變更。",
  "databases-onboarding.version-history-modal.closeButton": "關閉強制回應",
  "databases-onboarding.version-history-modal.dismiss": "關閉",
  "databases-onboarding.version-history-modal.header": "版本歷史記錄在這裡",
  "databases-onboarding.version-history-modal.imageAltText": "顯示版本歷史記錄面板的圖片",
  "databases-onboarding.version-history-modal.ok": "確定",
  "debounced-search-bar.cross.icon.label": "清除搜尋列中的文字",
  "debounced-search-bar.hintText": "搜尋",
  "debounced-search-bar.label": "搜尋",
  "debounced-search-bar.search.icon.label": "「搜尋」圖示",
  "default-space-permissions.add-group.save-success": "已新增預設群組",
  "default-space-permissions.all-space-tab-title": "所有空間",
  "default-space-permissions.allspaces.description": "這些都是您網站上目前的空間。",
  "default-space-permissions.allspaces.title": "空間",
  "default-space-permissions.default-tab.description": "這些是有人新增空間時，指派給群組的預設權限。",
  "default-space-permissions.default-tab.permission-table.generic-message": "表格發生錯誤。",
  "default-space-permissions.default-tab.permission-table.message": "未選取空間管理員。空間至少需要一個空間管理員。",
  "default-space-permissions.default-tab.table-empty-view": "目前沒有群組擁有此空間的存取權。",
  "default-space-permissions.default-tab.title": "預設空間權限",
  "default-space-permissions.defaults-tab-title": "新空間的預設值",
  "default-space-permissions.edit-confirmation-modal.cancel-button": "取消",
  "default-space-permissions.edit-confirmation-modal.save-button": "儲存",
  "default-space-permissions.filter.button": "篩選",
  "default-space-permissions.filter.description": "依索引鍵篩選",
  "default-space-permissions.individual-spaces.query-error-message": "無法擷取您的空間。",
  "default-space-permissions.learn-more-link": "深入了解",
  "default-space-permissions.manage.permissions": "管理存取權",
  "default-space-permissions.popup.custom-access-learn-more": "深入了解",
  "default-space-permissions.popup.manage-permissions-label": "管理存取權",
  "default-space-permissions.popup.manage-roles-label": "管理權限",
  "default-space-permissions.recover-permission-friction-dialog.cancel-button-text": "取消",
  "default-space-permissions.recover-permission-friction-dialog.confirm-button-text": "確認",
  "default-space-permissions.recover-permission-friction-dialog.content": "您確定要將此空間的空間管理員權限授予自己嗎？將會記錄此動作。",
  "default-space-permissions.recover-permission-friction-dialog.title": "復原權限",
  "default-space-permissions.recover-permission.mutation-error-message": "無法復原所選空間的空間管理員權限。",
  "default-space-permissions.recover-permission.mutation-success-message": "已復原所選空間的管理員權限。",
  "default-space-permissions.recover.permissions": "復原管理員權限",
  "default-space-permissions.remove-group-modal.body-access-class": "建立的新空間不會自動允許此使用者類別的一般存取權。",
  "default-space-permissions.remove-group-modal.cancel.non-final": "取消",
  "default-space-permissions.remove-group-modal.remove-access-class-success": "已更新一般存取權",
  "default-space-permissions.remove-group-modal.remove-access-class-success-button": "移除預設存取權",
  "default-space-permissions.remove-group-modal.remove-last-admin-error": "無法從預設組態中移除最後一位管理員。",
  "default-space-permissions.remove-group-modal.remove-success": "已移除預設群組",
  "default-space-permissions.remove-group-modal.remove.non-final": "移除",
  "default-space-permissions.remove-group-modal.title": "要移除預設群組嗎？",
  "default-space-permissions.remove-group-modal.title-access-class": "要移除使用者類別的預設存取權嗎？",
  "default-space-permissions.roles-management-tab-title": "角色",
  "default-space-permissions.roles-management.custom-roles-add": "新增自訂角色",
  "default-space-permissions.roles-management.custom-roles-body": "這些是您可以在空間等級上使用的角色。<learnmorelink>進一步了解自訂角色</learnmorelink>",
  "default-space-permissions.roles-management.custom-roles-count": "{count, plural, other {有 {count,number} 個自訂角色可用}}",
  "default-space-permissions.roles-management.custom-roles-heading": "自訂角色",
  "default-space-permissions.roles-management.default-roles-body": "這些是您可以在空間等級上指派的自訂角色。<learnmorelink>進一步了解角色</learnmorelink>",
  "default-space-permissions.roles-management.default-roles-heading": "預設角色",
  "default-space-permissions.roles-management.delete-role-modal.body": "刪除此角色將會影響所有空間中獲派此角色的使用者。您可以重新指派不同的角色給他們，也可以選擇不重新指派。<b>此動作無法復原。</b>",
  "default-space-permissions.roles-management.delete-role-modal.cancel-button": "取消",
  "default-space-permissions.roles-management.delete-role-modal.delete-option": "刪除他們目前的指派 (這會將他們從空間中移除)",
  "default-space-permissions.roles-management.delete-role-modal.delete-option-confirm": "刪除並移除",
  "default-space-permissions.roles-management.delete-role-modal.no-deletion-confirm": "確認",
  "default-space-permissions.roles-management.delete-role-modal.reassign-option": "對具有此角色的所有使用者指派其他角色 (這將適用於所有空間)",
  "default-space-permissions.roles-management.delete-role-modal.reassign-option-confirm": "刪除並重新指派",
  "default-space-permissions.roles-management.delete-role-modal.title": "要刪除自訂角色「{roleName}」嗎？",
  "default-space-permissions.roles-management.delete-role-modal.v1.body.role-is-not-used": "使用者目前擔任此角色。如果您想刪除此角色，則需要移除所有擔任此角色的使用者",
  "default-space-permissions.roles-management.delete-role-modal.v1.body.role-is-used": "使用者目前擔任此角色。如果您想刪除此角色，則需要移除所有擔任此角色的使用者",
  "default-space-permissions.roles-management.delete-role-modal.v1.title.role-is-not-used": "刪除角色",
  "default-space-permissions.roles-management.delete-role-modal.v1.title.role-is-used": "無法刪除此角色",
  "default-space-permissions.roles-management.delete-role.success.non-final.details": "請等候我們處理大量權限變更",
  "default-space-permissions.roles-management.duplicate-permissions-modal.body.non-final": "已有一個角色具有這些權限：",
  "default-space-permissions.roles-management.duplicate-permissions-modal.cancel-button": "返回",
  "default-space-permissions.roles-management.duplicate-permissions-modal.save-button": "儲存並繼續",
  "default-space-permissions.roles-management.duplicate-permissions-modal.title.non-final": "正在複製角色權限",
  "default-space-permissions.roles-management.edit-confirmation-modal.body": "變更這些權限將會針對已被指派此角色的每個人調整權限。<b>此動作無法復原。</b>",
  "default-space-permissions.roles-management.edit-confirmation-modal.delete-option": "將具有此角色的所有使用者重新指派為不同角色",
  "default-space-permissions.roles-management.edit-confirmation-modal.reassign-option": "變更與此角色相關聯的所有權限",
  "default-space-permissions.roles-management.edit-confirmation-modal.title": "要編輯角色「{roleName}」嗎？",
  "default-space-permissions.roles-management.role-list.permissions-count": "{count, plural, other {已選取 {count,number} 項權限}}",
  "default-space-permissions.roles-management.role-list.view-permissions": "檢視權限",
  "default-space-permissions.roles-management.set-role.update-success-async.non-final.details": "請等候我們處理角色變更",
  "default-space-permissions.section-body": "依預設，這些群組將可存取任何已建立的新空間。",
  "default-space-permissions.section-title": "使用者",
  "default-space-permissions.set-role-modal.cancel-button": "取消",
  "default-space-permissions.set-role-modal.duplicate-permissions-info": "已有角色具有這些權限",
  "default-space-permissions.set-role-modal.role-description-heading": "角色描述<asterisk>*</asterisk>",
  "default-space-permissions.set-role-modal.role-description-max-length": "長度上限為 100",
  "default-space-permissions.set-role-modal.role-description-placeholder": "新增描述",
  "default-space-permissions.set-role-modal.role-name-extra-info": "誰可以看到您的角色名稱？",
  "default-space-permissions.set-role-modal.role-name-heading": "角色名稱<asterisk>*</asterisk>",
  "default-space-permissions.set-role-modal.role-name-max-length": "長度上限為 25",
  "default-space-permissions.set-role-modal.role-name-placeholder": "新增名稱",
  "default-space-permissions.set-role-modal.role-name-unique-error": "名稱已在使用中，請避免重複",
  "default-space-permissions.set-role-modal.role-permissions-heading": "選取角色權限<asterisk>*</asterisk>",
  "default-space-permissions.set-role-modal.save-button": "儲存",
  "default-space-permissions.set-role-modal.title": "建立角色",
  "default-space-permissions.set-role-modal.title-subtext": "為您的角色提供名稱和描述，方便空間管理員識別。",
  "default-space-permissions.set-role.view-content-missing-error": "無法在沒有「{viewContentDisplayName}」權限的狀態下建立角色。",
  "default-space-permissions.space-permissions-header": "空間權限",
  "default-space-permissions.space-roles-column.access-class": "預設存取權",
  "default-space-permissions.space-roles-column.group": "群組",
  "default-space-permissions.table.access-column-header": "具有預設存取權的人",
  "default-space-permissions.table.all-licensed-users-display-name": "所有 Confluence 使用者",
  "default-space-permissions.table.all-product-admins-display-name": "所有 Confluence 管理員",
  "default-space-permissions.table.allspaces.header.key": "索引鍵",
  "default-space-permissions.table.allspaces.header.name": "名稱",
  "default-space-permissions.table.allspaces.header.operations": "動作",
  "default-space-permissions.table.custom-access-placeholder": "自訂存取權",
  "default-space-permissions.table.custom-roles-menu.delete-role": "刪除自訂角色",
  "default-space-permissions.table.custom-roles-menu.edit-role": "編輯自訂角色",
  "default-space-permissions.table.custom-roles-menu.view-permissions": "檢視權限",
  "default-space-permissions.table.group-count": "{count, plural, other {{count,number} 個人}}",
  "default-space-permissions.table.load-more-button": "載入更多",
  "default-space-permissions.table.load-more-error": "載入更多列時發生錯誤",
  "default-space-permissions.table.no-permissions-display-name": "無存取權",
  "default-space-permissions.table.role-column-header": "角色",
  "default-space-permissions.table.table-actions-menu.learn-more-about-roles": "進一步了解角色",
  "default-space-permissions.table.table-actions-menu.manage-permissions": "管理存取權",
  "default-space-permissions.table.table-actions-menu.remove-default": "移除預設群組",
  "default-space-permissions.table.type-column-header": "使用者類別",
  "default-space-permissions.table.update-last-admin-error": "預設組態中的最後一位管理員必須保留其目前角色。",
  "default-space-permissions.table.update-role-success": "存取權已更新",
  "default-space-permissions.update-group.last-admin-error": "預設組態中的最後一位管理員必須保留其管理員權限。",
  "delete-pages.content.flag.failed.title": "我們無法刪除此內容",
  "delete-pages.content.flag.success.title": "內容已刪除",
  "delete-pages.dialog.archive-option-content": "如果您願意，您也可以改為封存此內容。",
  "delete-pages.dialog.body": "空間管理員可以還原或清除垃圾桶中的項目。{learnMoreLink}",
  "delete-pages.dialog.body.draft": "如果您刪除未發布的頁面，頁面會永久消失。",
  "delete-pages.dialog.button.archive": "封存",
  "delete-pages.dialog.button.cancel": "取消",
  "delete-pages.dialog.button.delete": "刪除",
  "delete-pages.dialog.child-warning": "{count, plural, other {「{pageTitle}」的 <strong>{count,number} 個子系</strong>將成為「{parentTitle}」的子系}}",
  "delete-pages.dialog.child-warning.no-parent": "{count, plural, other {「{pageTitle}」的 <strong>{count,number} 個子系</strong>將不再有父系}}",
  "delete-pages.dialog.coming-soon.tooltip": "即將推出",
  "delete-pages.dialog.delete-page-aria-label": "了解如何刪除、還原或清除內容",
  "delete-pages.dialog.header": "傳送到垃圾桶嗎？",
  "delete-pages.dialog.header.draft": "要刪除未發佈的頁面嗎？",
  "delete-pages.dialog.incoming-links-warning": "{incomingLinksCount, plural, other {當您刪除此內容時，<a>{incomingLinksCount,number} 個傳入連結</a>將會中斷}}",
  "delete-pages.dialog.inherited-restrictions.link.aria-description": "繼承的檢視限制 - 在新分頁中開啟連結",
  "delete-pages.dialog.inherited-restrictions.message": "此項目受父項目限制。刪除後，不會套用這些限制。<a>進一步了解繼承限制</a>",
  "delete-pages.dialog.inherited-restrictions.title": "已刪除項目的存取權將會變更",
  "delete-pages.dialog.learnmore.link": "深入了解",
  "delete-pages.flag.failed.already-deleted": "有人已將其刪除。請重新整理以查看最新更新。",
  "delete-pages.flag.failed.body": "請再試一次。如果這種情況持續發生，請試著連絡 {supportLink} 或空間管理員。",
  "delete-space.archive.space.learn.more.link": "如何封存空間？",
  "delete-space.delete.space.archive.description.soft.deletion.enabled": "如果您希望能自行復原空間，可以改為將其封存。",
  "delete-space.delete.space.description.soft.deletion.enabled": "如果將此空間丟到垃圾桶，空間裡的所有內容也會一起送到垃圾桶。放在垃圾桶超過 60 天的空間將被永久刪除。",
  "delete-space.delete.space.dialog.button": "將此空間丟到垃圾桶",
  "delete-space.dialog.learn.more.link": "深入了解",
  "delete-space.modal.archive.button": "封存",
  "delete-space.modal.body.description.soft.one": "只有 Confluence 管理員才能恢復已丟棄的空間。",
  "delete-space.modal.body.description.soft.two": "如果您不確定是否要丟到垃圾桶，請改為封存空間。",
  "delete-space.modal.cancel.button": "取消",
  "delete-space.modal.delete.button": "丟到垃圾桶",
  "delete-space.modal.header.soft-delete": "要將 {spaceName} 空間丟到垃圾桶嗎？",
  "details-panel.activity-section.classification-row": "分類",
  "details-panel.activity-section.classification-row.add-classification-label": "新增分類",
  "details-panel.activity-section.views-row": "檢視次數",
  "details-panel.connections-section.title": "連線",
  "details-panel.contributor-row.contributors": "參與者",
  "details-panel.error-icon-label": "錯誤圖示",
  "details-panel.error-info": "無法載入",
  "details-panel.error-retry": "重試",
  "details-panel.info-section.title": "資訊",
  "details-panel.jira-work-items-panel.header-navigation.icon-button": "返回內容詳細資料",
  "details-panel.jira-work-items-panel.header-navigation.left-arrow-icon": "返回的圖示",
  "details-panel.jira-work-items.header.icon.label": "Jira 工作項目圖示",
  "details-panel.jira-work-items.header.label": "Jira 工作項目",
  "details-panel.labels-section.add-button-label": "新增標籤",
  "details-panel.labels-section.title": "標籤",
  "details-panel.links-section.custom-content-row": "自訂內容",
  "details-panel.links-section.files-row": "檔案",
  "details-panel.links-section.incoming-links-row": "傳入的連結",
  "details-panel.links-section.jira-work-item-row": "Jira 工作項目",
  "details-panel.links-section.jira-work-items-panel-body.authentication-needed": "需要驗證",
  "details-panel.links-section.jira-work-items-panel-body.login-to-retrieve-data": "登入以從以下位置擷取資料：",
  "details-panel.links-section.jira-work-items-panel-body.reload-page": "請重新載入頁面以再試一次",
  "details-panel.links-section.jira-work-items-panel-body.view-more-link-text": "在 Jira 系統中檢視其他 {count} 個",
  "details-panel.links-section.jira-work-items-panel-body.work-items-count": "{count, plural, other {{count,number} 個工作項目}}",
  "details-panel.links-section.jira-work-items-row": "Jira 工作項目",
  "details-panel.links-section.outgoing-links-row": "傳出連結",
  "details-panel.none-label": "無",
  "details-panel.panel.header.label": "詳細資料",
  "details-panel.properties-section.created-row": "已建立",
  "details-panel.properties-section.creator-row": "建立者",
  "details-panel.properties-section.creator-row.accessible-avatar-label": "{displayName} 的設定檔圖片",
  "details-panel.properties-section.last-updated-row": "上次更新者",
  "details-panel.properties-section.last-updated-row.accessible-avatar-label": "{displayName} 的設定檔圖片",
  "details-panel.properties-section.length-row": "長度",
  "details-panel.properties-section.redaction-row": "編輯",
  "details-panel.properties-section.status-row": "狀態",
  "details-panel.stats-section.title": "統計",
  "document-title.document-edit-page-title.company-hub.title": "公司中心",
  "document-title.document-space-title.company-hub.title": "公司中心",
  "document-title.edit.name": "編輯",
  "document-title.edit.page.template": "編輯範本",
  "document-title.not.found": "找不到頁面",
  "edit-button.edit.embed.label": "編輯此嵌入連結",
  "edit-button.edit.label": "編輯此內容",
  "edit-button.edit.text": "編輯",
  "edit-button.tooltip": "編輯",
  "edit-features.edit-features-list.analytics": "分析",
  "edit-features.edit-features-list.apps": "應用程式",
  "edit-features.edit-features-list.automation": "自動化",
  "edit-features.edit-features-list.blogs": "部落格",
  "edit-features.edit-features-list.calendars": "行事曆",
  "edit-features.edit-features-list.content": "內容",
  "edit-features.edit-features-list.content-manager": "內容管理員",
  "edit-features.edit-features-list.databases": "資料庫",
  "edit-features.edit-features-list.embed": "智慧連結",
  "edit-features.edit-features-list.features": "功能",
  "edit-features.edit-features-list.find-out-more": "深入了解",
  "edit-features.edit-features-list.folders": "資料夾",
  "edit-features.edit-features-list.live-pages": "即時頁面",
  "edit-features.edit-features-list.live-pages.description": "新頁面將會是即時頁面。目前頁面不會變更，您可以隨時將其關閉。",
  "edit-features.edit-features-list.live-pages.description.livedocs": "目前頁面不會受到影響，您可以隨時將其關閉。",
  "edit-features.edit-features-list.live-pages.livedocs": "即時文件",
  "edit-features.edit-features-list.query-error-description": "請重新載入並再試一次。",
  "edit-features.edit-features-list.query-error-title": "發生錯誤",
  "edit-features.edit-features-list.questions": "問題",
  "edit-features.edit-features-list.sections": "區段",
  "edit-features.edit-features-list.shortcuts": "捷徑",
  "edit-features.edit-features-list.update-space-type-settings-mutation-error-title": "我們無法更新側邊欄",
  "edit-features.edit-features-list.whiteboards": "白板",
  "edit-features.header": "開啟和關閉此空間的功能：",
  "edit-features.live-pages-toggle-feedback-collector.community-group": "搶先體驗方案社群群組",
  "edit-features.live-pages-toggle-feedback-collector.dismiss": "關閉",
  "edit-features.live-pages-toggle-feedback-collector.flag-community-group": "加入社群群組",
  "edit-features.live-pages-toggle-feedback-collector.flag-description": "我們希望您能保持聯繫，並隨時掌握此搶先體驗方案的資訊。",
  "edit-features.live-pages-toggle-feedback-collector.flag-find-out-more": "深入了解",
  "edit-features.live-pages-toggle-feedback-collector.flag-title": "感謝您提交意見反應",
  "edit-features.live-pages-toggle-feedback-collector.placeholder-text": "即時頁面有哪些優點？有哪裡可以改善？",
  "edit-features.live-pages-toggle-feedback-collector.placeholder-text.livedocs": "即時文件有哪些優點？有哪些地方可以改善？",
  "edit-features.live-pages-toggle-feedback-collector.text-area-label": "告訴我們您的體驗",
  "edit-features.live-pages-toggle-feedback-collector.title": "歡迎針對即時頁面提供意見反應",
  "edit-features.live-pages-toggle-feedback-collector.title-details": "您的意見非常寶貴，能讓我們知道如何更加符合您的需求。有哪裡可以改善的嗎？{lineBreak}{lineBreak}若要隨時掌握此功能的資訊，請加入我們的 {communityGroupLink}。",
  "edit-features.live-pages-toggle-feedback-collector.title.livedocs": "歡迎針對即時文件提供意見反應",
  "edit-features.live-pages.expanded-eap-changeboarding-button-findOutMore": "深入了解",
  "edit-features.live-pages.expanded-eap-changeboarding-button-gotIt": "知道了",
  "edit-features.live-pages.expanded-eap-changeboarding-settings-off-features-body": "將此空間中的新頁面設定為即時頁面。視需要切換開/關。",
  "edit-features.live-pages.expanded-eap-changeboarding-settings-off-features-header": "試用即時頁面",
  "edit-features.live-pages.expanded-eap-changeboarding-settings-on-features-body": "此空間中的新頁面現在是即時頁面。視需要切換開/關。",
  "edit-features.live-pages.expanded-eap-changeboarding-settings-on-features-header": "您已有即時頁面",
  "edit-space-logo.actions.cancel": "取消",
  "edit-space-logo.actions.restore-default": "還原預設值",
  "edit-space-logo.actions.restore.error.body": "嘗試還原預設空間標誌時發生非預期的錯誤",
  "edit-space-logo.actions.restore.error.title": "無法還原預設標誌",
  "edit-space-logo.actions.save": "儲存",
  "edit-space-logo.actions.save.error.body": "嘗試儲存變更時發生非預期的錯誤",
  "edit-space-logo.actions.save.error.title": "無法儲存空間設定",
  "edit-space-logo.actions.save.success.title": "您的空間詳細資料已更新。",
  "edit-space-logo.drop-zone.drag-and-drop": "請將 PNG、JPEG 或 GIF 檔案拖放到此處",
  "edit-space-logo.drop-zone.file-format-error": "上傳影像時發生錯誤。請確認您的檔案是有效的 JPEG、GIF 或 PNG。",
  "edit-space-logo.drop-zone.file-size-error": "上傳影像時發生錯誤。請確認影像大小小於 10MB",
  "edit-space-logo.drop-zone.upload-file": "上傳檔案",
  "edit-space-logo.inline-space-logo-picker.button": "查看更多",
  "edit-space-logo.inline-space-logo-picker.tooltip": "查看更多圖示選項",
  "edit-space-logo.space-details.edit-icon": "編輯空間圖示",
  "edit-space-logo.space-details.edit-name-and-icon": "編輯空間名稱和圖示",
  "edit-space-logo.space-icon-alt-text.custom": "自訂空間圖示",
  "edit-space-logo.space-icon-alt-text.default1": "白色資料夾，搭配藍色背景",
  "edit-space-logo.space-icon-alt-text.default10": "淡藍色無尾熊咀嚼著尤加利樹葉，搭配深藍色背景",
  "edit-space-logo.space-icon-alt-text.default11": "紫色外星人飛碟，搭配綠色背景",
  "edit-space-logo.space-icon-alt-text.default12": "藍色鸚鵡，搭配紫色背景",
  "edit-space-logo.space-icon-alt-text.default13": "三個白色的操控桿，設為中間、上方和底部，搭配紅色背景",
  "edit-space-logo.space-icon-alt-text.default14": "具有正極充電記號的藍色和橘色電池，搭配綠色背景",
  "edit-space-logo.space-icon-alt-text.default15": "兩座冰山山峰後方的日落，搭配藍色背景",
  "edit-space-logo.space-icon-alt-text.default16": "熱狗，搭配紫色背景",
  "edit-space-logo.space-icon-alt-text.default17": "紅色的外帶咖啡杯，白色杯套上有綠色標誌，搭配綠色背景",
  "edit-space-logo.space-icon-alt-text.default18": "一般介面，搭配紅色背景",
  "edit-space-logo.space-icon-alt-text.default19": "微笑雲，搭配藍色背景",
  "edit-space-logo.space-icon-alt-text.default2": "白色和綠色箭頭轉向相反方向，搭配紫色背景",
  "edit-space-logo.space-icon-alt-text.default20": "裝滿紅色液體的實驗室燒杯，搭配紫色背景",
  "edit-space-logo.space-icon-alt-text.default21": "向上飛行的白色飛機，搭配藍色背景",
  "edit-space-logo.space-icon-alt-text.default22": "塞滿錢的深藍色皮夾，搭配橘色背景",
  "edit-space-logo.space-icon-alt-text.default23": "紫色的電動車，以及充電站，搭配黃色背景",
  "edit-space-logo.space-icon-alt-text.default24": "向上飛行的藍綠色火箭，以及白色星星，搭配紫色背景",
  "edit-space-logo.space-icon-alt-text.default25": "正在響鈴的手機，搭配綠色背景",
  "edit-space-logo.space-icon-alt-text.default26": "暴風雲，搭配紫色背景",
  "edit-space-logo.space-icon-alt-text.default27": "橘色電鑽，搭配紫色背景",
  "edit-space-logo.space-icon-alt-text.default3": "鉛筆和筆記本，搭配藍色背景",
  "edit-space-logo.space-icon-alt-text.default4": "紅白相間的救生圈，搭配藍色背景",
  "edit-space-logo.space-icon-alt-text.default5": "畫架上的風景畫，搭配橘色背景",
  "edit-space-logo.space-icon-alt-text.default6": "黑色和藍色的黑膠唱片，搭配紅色背景",
  "edit-space-logo.space-icon-alt-text.default7": "銀色扳手工具，搭配紅色背景",
  "edit-space-logo.space-icon-alt-text.default8": "白色旗桿上的紅色旗子，搭配橘色背景",
  "edit-space-logo.space-icon-alt-text.default9": "滑鼠箭頭指向一般介面，搭配紅色背景",
  "edit-space-logo.space-logo-picker.drop-zone.divider": "或者",
  "edit-space-logo.space-logo-picker.drop-zone.drag-and-drop": "在此拖放 .png、.jpeg 或 .gif 檔案",
  "edit-space-logo.space-logo-picker.drop-zone.file-format-error": "上傳圖片時發生錯誤。請檢查您的檔案是否為有效的 JPEG、GIF 或 PNG 檔案",
  "edit-space-logo.space-logo-picker.drop-zone.file-size-error": "上傳圖片時發生錯誤。請檢查圖片尺寸是否小於 10MB",
  "edit-space-logo.space-logo-picker.drop-zone.upload-file": "從您的電腦上傳",
  "edit-space-logo.space-logo-picker.image-cropper.cross-icon-label": "移除圖片",
  "edit-space-logo.space-logo-picker.image-cropper.scale-large-icon-label": "設定最大比例",
  "edit-space-logo.space-logo-picker.image-cropper.scale-small-icon-label": "設定最小比例",
  "edit-space-logo.space-logo-picker.modal.close": "關閉",
  "edit-space-logo.space-logo-picker.modal.title": "變更空間圖示",
  "edit-space-logo.space-logo-picker.popup.title": "變更空間圖示",
  "edit-space-logo.space-logo-picker.popup.upload-image": "上傳圖片",
  "edit-space-logo.space-logo-picker.popup.upload-image-link": "選擇圖示或<a>上傳圖片</a>。",
  "edit-space-logo.space-logo-picker.tooltip": "變更空間圖示",
  "edit-space-logo.space-logo-picker.upload-image.apply": "套用",
  "edit-space-logo.space-logo-picker.upload-image.cancel": "取消",
  "edit-space-logo.space-name": "空間名稱",
  "edit-space-logo.space-name-label": "空間名稱輸入",
  "edit-space-logo.tabs.gallery": "圖庫",
  "edit-space-logo.tabs.upload-content": "上傳內容",
  "editor-action-bar.editor-controls-onboarding.close": "關閉",
  "editor-action-bar.editor-controls-onboarding.highlighted-message": "<strong>正在尋找工具列嗎？</strong>",
  "editor-action-bar.editor-controls-onboarding.image-alt-text": "新的格式設定工具列按鈕",
  "editor-action-bar.editor-controls-onboarding.lozenge": "全新",
  "editor-action-bar.editor-controls-onboarding.message": "在選取文字時，嘗試顯示的新版格式設定工具列。透過懸停時顯示的 + 插入元素。<link>深入了解</link>。",
  "editor-action-bar.editor-controls-onboarding.message-classic": "將工具列保持在頂部或試用<link>新版浮動工具列</link>。試用看看，並分享您的<feedback>意見</feedback>。",
  "editor-action-bar.editor-controls-onboarding.message-inline-toolbar": "選取文字以開啟<link>內嵌工具列</link>。",
  "editor-action-bar.editor-controls-onboarding.message-live-pages": "在選取文字時，嘗試顯示的<link>新版格式設定工具列</link>，並分享您的<feedback>意見</feedback>。",
  "editor-action-bar.editor-controls-onboarding.message-live-pages-inline-toolbar": "針對<link>要顯示的內嵌工具列</link>選取文字。",
  "editor-action-bar.editor-controls-onboarding.message-top-toolbar": "將工具列保持在頂部或試用<link>內嵌工具列</link>。當您選取文字時，就會顯示。",
  "editor-action-bar.editor-controls-onboarding.share-your-feedback": "分享您的<feedback>意見反應</feedback>。",
  "editor-action-bar.feedback-banner.close": "關閉",
  "editor-action-bar.feedback-banner.message": "這是即時頁面！即時編輯，無需發布。<link>分享意見反應</link>",
  "editor-action-bar.feedback-banner.message-view-only": "這是即時頁面！任何具有編輯權限的人都可以即時編輯，無須發布。<link>分享意見反應</link>",
  "editor-action-bar.feedback-banner.message-view-only.livedocs": "這是即時文件！任何具有編輯權限的人都可以即時更新，無須發布。<link>提供意見反應</link>",
  "editor-action-bar.feedback-banner.message.livedocs": "這是即時文件！您可以立即更新，無須發布。<link>提供意見反應</link>",
  "editor-action-bar.feedback-collector.community-group": "社群群組",
  "editor-action-bar.feedback-collector.title": "提供意見反應",
  "editor-action-bar.feedback-collector.title-details": "您的寶貴想法可協助改善我們的產品。{lineBreak}{lineBreak}如果您想進一步與我們聊天，並隨時掌握此搶先體驗方案的資訊，請加入我們的 {communityGroupLink}。",
  "editor-action-bar.feedback-flag.community-group": "加入社群群組",
  "editor-action-bar.feedback-flag.description": "保持聯繫並隨時掌握此搶先體驗方案的資訊。",
  "editor-action-bar.feedback-flag.find-out-more": "深入了解",
  "editor-action-bar.feedback-flag.title": "感謝您提交意見反應",
  "editor-appearance-button.toggle.fixed.width": "設為全寬",
  "editor-appearance-button.toggle.full.width": "設為固定寬度",
  "editor-context-panel-content-creation-panel.close-label": "關閉範本與匯入視窗",
  "editor-context-panel-content-creation-panel.template-panel.tabs.import-doc.label": "匯入",
  "editor-context-panel-content-creation-panel.template-panel.tabs.templates.label": "範本",
  "editor-context-panel.panel-close-button.close-label": "關閉組態面板",
  "editor-conversion.auto-conversion-byline.byline": "{editorType}",
  "editor-conversion.auto-conversion-byline.legacyEditorTooltip": "此頁面使用舊版編輯器。",
  "editor-conversion.auto-conversion-byline.newEditorTooltip": "此頁面使用新版編輯器。",
  "editor-conversion.onboarding.button": "知道了",
  "editor-conversion.onboarding.learn.more": "深入了解",
  "editor-conversion.onboarding.modal.body": "您的管理員已自動從舊版編輯器轉換此空間中符合資格的頁面。{learnMoreLink}",
  "editor-conversion.onboarding.modal.title": "自動轉換頁面",
  "editor-conversion.panel.body": "將此空間中符合完全轉換資格的所有頁面，自動轉換為新版編輯器。{learnMoreLink}轉換頁面。",
  "editor-conversion.panel.learn.more": "深入了解",
  "editor-conversion.panel.notification.title": "自動轉換頁面",
  "editor-conversion.revert-editor.dialog.body": "此頁面將失去新版編輯器的功能和效能優勢。",
  "editor-conversion.revert-editor.dialog.button.cancel": "取消",
  "editor-conversion.revert-editor.dialog.button.revert": "還原為舊版",
  "editor-conversion.revert-editor.dialog.header": "要還原為舊版編輯器嗎？",
  "editor-conversion.revert-editor.flag.failed.body": "請再試一次。如果這種情況持續發生，請嘗試連絡{supportLink}或空間管理員。",
  "editor-conversion.revert-editor.flag.failed.title": "我們無法還原此頁面",
  "editor-conversion.revert-editor.flag.success.body": "其已成功還原為此頁面的舊版編輯器。",
  "editor-conversion.revert-editor.flag.success.title": "編輯器已還原",
  "editor-conversion.site.enabled.lozenge": "已啟用",
  "editor-conversion.site.settings.banner.body": "若要變更此設定，請{contactAdminLink}。",
  "editor-conversion.site.settings.banner.contact.admin": "連絡您的網站管理員",
  "editor-conversion.site.settings.banner.title": "此設定是由您的網站管理員所配置。",
  "editor-ellipsis-dropdown.ellipsis.open.ellipsis.advanced": "進階詳細資料",
  "editor-ellipsis-dropdown.ellipsis.open.ellipsis.archive": "封存",
  "editor-ellipsis-dropdown.ellipsis.open.ellipsis.attachments": "附件",
  "editor-ellipsis-dropdown.ellipsis.open.ellipsis.copy": "複製",
  "editor-ellipsis-dropdown.ellipsis.open.ellipsis.custom.contents": "自訂內容",
  "editor-ellipsis-dropdown.ellipsis.open.ellipsis.export": "匯出",
  "editor-ellipsis-dropdown.ellipsis.open.ellipsis.files": "檔案",
  "editor-ellipsis-dropdown.ellipsis.open.ellipsis.page.apps": "應用程式",
  "editor-ellipsis-dropdown.ellipsis.open.ellipsis.presenter-mode": "呈現",
  "editor-ellipsis-dropdown.ellipsis.open.ellipsis.publish": "發布",
  "editor-ellipsis-dropdown.ellipsis.open.ellipsis.publish-dots": "發布中...",
  "editor-ellipsis-dropdown.ellipsis.open.ellipsis.publish-dots.live-docs": "轉換為頁面...",
  "editor-ellipsis-dropdown.ellipsis.open.ellipsis.publish.live-docs": "轉換為頁面",
  "editor-ellipsis-dropdown.ellipsis.open.ellipsis.templates": "範本",
  "editor-ellipsis-dropdown.ellipsis.open.ellipsis.templates.and.import": "範本和匯入文件",
  "editor-ellipsis-dropdown.ellipsis.open.ellipsis.view.changes.title": "最近變更",
  "editor-ellipsis-dropdown.live-pages-expanded-eap-changeboarding-spotlight.body": "將此頁面切換為即時編輯，立即進行編輯，無需發布。",
  "editor-ellipsis-dropdown.live-pages-expanded-eap-changeboarding-spotlight.body.livedocs": "將此頁面轉換為即時文件，立即進行編輯，無需發布。",
  "editor-ellipsis-dropdown.live-pages-expanded-eap-changeboarding-spotlight.findOutMore": "深入了解",
  "editor-ellipsis-dropdown.live-pages-expanded-eap-changeboarding-spotlight.gotIt": "知道了",
  "editor-ellipsis-dropdown.live-pages-expanded-eap-changeboarding-spotlight.header": "無需點擊即可快速編輯",
  "editor-ellipsis-dropdown.live-pages-expanded-eap-changeboarding-spotlight.image-alt": "您可以透過「更多動作」選單，切換至即時編輯",
  "editor-ellipsis-dropdown.live-pages-expanded-eap-changeboarding-spotlight.image-alt.livedocs": "透過「更多動作」選單將此頁面轉換為即時文件",
  "editor-ellipsis-dropdown.live-pages.publish-button-spotlight.action-button.text": "確定",
  "editor-ellipsis-dropdown.live-pages.publish-button-spotlight.body": "如果您需要進一步控管編輯和版本歷史記錄，請發布您的頁面。",
  "editor-ellipsis-dropdown.live-pages.publish-button-spotlight.body.livedocs": "如果您需要進一步控管編輯和版本歷史記錄，請將此文件轉換為頁面。",
  "editor-ellipsis-dropdown.live-pages.publish-button-spotlight.title": "想要發布嗎？",
  "editor-ellipsis-dropdown.open.ellipsis.blogpost.delete": "刪除未發佈的部落格貼文",
  "editor-ellipsis-dropdown.open.ellipsis.edit.labels": "新增標籤",
  "editor-ellipsis-dropdown.open.ellipsis.editor.find.replace": "尋找與取代",
  "editor-ellipsis-dropdown.open.ellipsis.editor.redo": "重做",
  "editor-ellipsis-dropdown.open.ellipsis.editor.undo": "復原",
  "editor-ellipsis-dropdown.open.ellipsis.hub.share-feedback": "提供有關公司中心的意見反應",
  "editor-ellipsis-dropdown.open.ellipsis.more": "更多",
  "editor-ellipsis-dropdown.open.ellipsis.more.actions.tooltip": "更多動作",
  "editor-ellipsis-dropdown.open.ellipsis.page.delete": "刪除未發佈的頁面",
  "editor-ellipsis-dropdown.open.ellipsis.resolved.comments": "已解決的留言",
  "editor-ellipsis-dropdown.open.ellipsis.revert": "回復到先前版本",
  "editor-ellipsis-dropdown.open.ellipsis.revert.editor": "還原至舊版編輯器",
  "editor-ellipsis-dropdown.open.ellipsis.update.without.notify": "在不通知追蹤者的情況下更新",
  "editor-ellipsis-dropdown.open.ellipsis.view.changes": "檢視變更",
  "editor-ellipsis-dropdown.open.template.browser": "開啟範本瀏覽器",
  "editor-ellipsis-dropdown.placeholder.ellipsis.more": "更多",
  "editor-ellipsis-dropdown.preview": "預覽",
  "editor-features.ai-feedback-collector.can-contact.label": "Atlassian 可以連絡我來了解此意見反應。請參閱我們的{privacyPolicyLink}。",
  "editor-features.ai-feedback-collector.flag-description": "您的意見反應很珍貴，能幫助我們持續改善產品。",
  "editor-features.ai-feedback-collector.flag-title": "謝謝您！",
  "editor-features.ai-feedback-collector.improve-atlassian": "我想要加入 {researchGroupLink}，協助改善 Atlassian 產品。",
  "editor-features.ai-feedback-collector.privacy-policy.link": "隱私政策",
  "editor-features.ai-feedback-collector.research-group.link": "Atlassian 研究團隊",
  "editor-features.ai-feedback-collector.summary-placeholder": "讓我們知道您嘗試執行的動作，以及該功能如何改善",
  "editor-features.ai-feedback-collector.title": "協助我們讓 Atlassian Intelligence 更臻完美",
  "editor-features.ai-feedback-collector.user-consent-checkbox-label": "在意見反應中包含我的最後一個提示和回應。",
  "editor-features.ai-optin-modal.admin-turn-on-text": "為 Atlassian Administration 的使用者開啟 Atlassian Intelligence 功能。",
  "editor-features.ai-optin-modal.close-cta-text": "稍後再說",
  "editor-features.ai-optin-modal.description": "運用 Atlassian Intelligence (AI) 協助提升寫作能力。讓 AI 提升清晰度、維持專業語調，或產生簡潔的內容。",
  "editor-features.ai-optin-modal.free-plan-text": "您使用的是 Free 方案。",
  "editor-features.ai-optin-modal.get-started-cta-text": "開始使用",
  "editor-features.ai-optin-modal.learn-more-cta-text": "深入了解",
  "editor-features.ai-optin-modal.learn-more.link.text": "<a>參閱 Atlassian Intelligence</a>",
  "editor-features.ai-optin-modal.standard-plan-text": "您使用的是 Standard 方案。",
  "editor-features.ai-optin-modal.title": "提升團隊的寫作",
  "editor-features.ai-optin-modal.upgrade-plan-text": "若要開始在產品中使用 Atlassian Intelligence，請升級您的方案。",
  "editor-features.ai-optin-modal.upsell-text": "您的團隊可以運用 Atlassian Intelligence (AI)，更快產出簡潔、清晰且專業的內容。",
  "editor-features.alt-text.invalid": "我們無法接受 Alt 文字中的所有可能字元。所有 Unicode 字母和數字都可用，但這唯一可接受的符號如下：, ' . - _ ( )。",
  "editor-features.front-cover.publish.error-title": "發生錯誤",
  "editor-features.page-has-been-converted-description": "此頁面已轉換為新的編輯體驗",
  "editor-features.page-has-been-converted-learn-more-link": "深入了解",
  "editor-features.page-has-been-converted-title": "頁面已經過轉換",
  "editor-features.publish.front-cover.error-message": "由於發生錯誤，此登陸頁面無法發布。請重新載入並再次發布。",
  "editor-features.same.file.name.description": "您選擇的檔案和現有附件名稱相同，新的檔案將取代現有檔案。",
  "editor-features.same.file.name.learn.more": "深入了解附件。",
  "editor-features.same.file.name.title": "「{file}」已存在",
  "editor-features.success.convertAndPublish.title": "已轉換和發布！",
  "editor-features.success.front-cover.publish.title": "{companyHubName} 現已處於作用中的狀態",
  "editor-features.success.front-cover.update.title": "{companyHubName} 已更新",
  "editor-features.success.publish.title": "已發布！",
  "editor-features.success.update.title": "已更新！",
  "editor-features.title-keyword-for-automation-discovery.": "會議",
  "editor-features.use-publish.network-error.description": "請檢查您的網路連線、重新整理頁面，然後再試一次。如果此問題持續發生，請連絡您的管理員以取得協助。",
  "editor-features.use-publish.network-error.title": "無法儲存變更",
  "editor-features.use-publish.outdated-refetch-error-flag.description": "{pageTitle} 已轉換和發布，但我們無法重新導向到轉換後的頁面。如果這種情況持續發生，請連絡支援人員。",
  "editor-features.use-publish.outdated-refetch-error-flag.refresh": "重新整理",
  "editor-features.use-publish.outdated-refetch-error-flag.title": "若要檢視已發布的頁面，請立即重新整理",
  "editor-features.user.convertAndPublish.success": "{pageTitle} 已轉換為頁面並發布。",
  "editor-features.user.copied-page": "已複製",
  "editor-features.user.copy-your-page": "複製連結",
  "editor-features.user.publish.front-cover.success": "現在所有人都可以看到此中樞。您可以隨時加以更新。",
  "editor-features.user.publish.success": "已成功發布 {pageTitle}",
  "editor-features.user.publish.success.with.space.name": "已成功在 {spaceName} 空間發布 {pageTitle}",
  "editor-features.user.update.front-cover.success": "現在所有人都可以看到您最近的更新。",
  "editor-features.user.update.success": "已成功更新 {pageTitle}",
  "editor-features.user.update.success.with.space.name": "已成功在 {spaceName} 空間中更新 {pageTitle}",
  "editor-flags.collab-status-error.description": "請複製您的工作並重新整理，然後我們會嘗試重新連線。",
  "editor-flags.collab-status-error.title": "無法儲存變更",
  "editor-flags.error.cancel.scheduled.publish": "請重新整理頁面，然後再試一次。",
  "editor-flags.error.cancel.scheduled.publish.title": "我們在取消此排定的發佈時發生問題",
  "editor-flags.error.cancel.scheduled.update.title": "我們取消此排定的更新時發生問題",
  "editor-flags.error.conflict.draft.header": "無法發布草稿",
  "editor-flags.error.conflict.draft.message": "由於伺服器發生錯誤，無法發布這份草稿。請將此內容複製並貼到新的草稿中，以進行發布。",
  "editor-flags.error.conflict.refresh-page.header": "請重新整理此頁面以進行發布",
  "editor-flags.error.conflict.refresh-page.message": "此版本已由其他使用者更新。請重新整理頁面，以便同步內容並發布您的變更。",
  "editor-flags.error.delayed.publishText": "發佈",
  "editor-flags.error.delayed.publishing": "我們會繼續嘗試發布。如果花費時間太長，請重新整理頁面並按一下 {buttonText}。",
  "editor-flags.error.delayed.publishing.title": "我們在發佈時遇到問題",
  "editor-flags.error.delayed.updateText": "更新",
  "editor-flags.error.delayed.updating": "我們會繼續嘗試更新。如果花費時間太長，請重新整理頁面並按一下 {buttonText}。",
  "editor-flags.error.delayed.updating.title": "我們在更新時遇到問題",
  "editor-flags.error.edit-page.duplicate-blog-title-error.message": "請重新命名頁面，然後再以部落格的形式將其發佈。",
  "editor-flags.error.edit-page.duplicate-blog-title-error.title": "具有此名稱的部落格已存在",
  "editor-flags.error.edit-page.parent-not-published.message": "處於草稿狀態的頁面下不能有已發布的頁面。請先發布<link>父系頁面</link>，再發布此頁面。",
  "editor-flags.error.edit-page.parent-not-published.title": "無法發佈此草稿",
  "editor-flags.error.edit-page.update.duplicate-blog-title-error.message": "請重新命名頁面，然後再以部落格的形式更新。",
  "editor-flags.error.invalid.template.variable.message": "具有相同名稱「{variableNames}」但參數不同的多個範本變數。",
  "editor-flags.error.live.page.trashed.message": "複製您的內容，然後將其新增至新文件，或<link>從垃圾桶復原此文件</link>，然後再試一次。",
  "editor-flags.error.login.link": "登入或切換至其他帳號",
  "editor-flags.error.no.access.message": "您的工作階段可能已到期。您必須再次登入或切換至其他帳戶，才能繼續運作。{loginLink}",
  "editor-flags.error.no.authorize.message": "您的工作階段已到期。您必須再次登入或切換至其他帳戶，才能繼續運作。{loginLink}",
  "editor-flags.error.page.trashed.message": "複製您的內容，然後將其新增至新頁面，或<link>從垃圾桶還原此頁面</link>，然後再試一次。",
  "editor-flags.error.page.trashed.message.link": "從垃圾桶復原此內容",
  "editor-flags.error.recovery.body": "您的變更是安全的。請重新整理，然後再試一次。",
  "editor-flags.error.recovery.title": "載入編輯器時發生錯誤",
  "editor-flags.error.schedule.publish": "請重新整理頁面，然後再試一次。",
  "editor-flags.error.schedule.publish.title": "我們在設定排程時間時發生問題",
  "editor-flags.error.scheduled.publish.no-title-error": "請新增標題，然後您就可以設定發佈的日期和時間。",
  "editor-flags.error.scheduled.publish.no-title-error.title": "您的頁面需要一個名稱",
  "editor-flags.error.scheduled.update.no-title-error": "請新增標題，然後您就可以設定更新的日期和時間。",
  "editor-flags.error.tenant.suspended.description": "您的 Atlassian Cloud 網站因為已排程的維護而無法使用。",
  "editor-flags.error.tenant.suspended.title": "您現在無法編輯此內容",
  "editor-flags.error.update.conflict.refresh-page.header": "請重新整理以進行更新",
  "editor-flags.error.update.conflict.refresh-page.message": "此版本已由其他使用者更新。請立即重新整理，以同步您的變更。",
  "editor-flags.error.view-page.duplicate-blog-title-error.message": "請重新命名頁面，然後再將其轉換為部落格。",
  "editor-flags.error.view-page.duplicate-blog-title-error.title": "具有此名稱的部落格已存在",
  "editor-flags.generate.ai.description": "Atlassian Intelligence (AI) 正在為此頁面產生標題，因為需要標題才能發布。請選取<bold>接受</bold>以發布具有此標題的頁面，或編輯標題並手動發布。<Link>內容品質可能會變動。</Link>",
  "editor-flags.generate.ai.error.description": "Atlassian Intelligence 目前無法為您產生標題。您可以改為手動新增標題並發布頁面。<Link>為什麼會發生此情況？</Link>",
  "editor-flags.generate.ai.error.title": "我們無法為您產生標題",
  "editor-flags.generate.ai.title": "檢閱您透過 AI 產生的標題",
  "editor-flags.move-error.duplicate-live-page-name-within-editor.description": "若要將此即時文件移至「{destinationSpace}」空間，請提供不重複的標題。",
  "editor-flags.move-error.duplicate-live-page-name-within-editor.title": "為此文件提供不重複的標題以便移動",
  "editor-flags.move-error.duplicate-live-page-name-within-editor.update.description": "若要將此即時文件移至「{destinationSpace}」空間，請先提供不重複的標題並進行更新。",
  "editor-flags.move-error.duplicate-page-name-within-editor.description": "若要將此頁面移至 {destinationSpace} 空間，請先為其提供不重複的標題並發布頁面。",
  "editor-flags.move-error.duplicate-page-name-within-editor.title": "為此頁面提供不重複的標題以便移動",
  "editor-flags.move-error.duplicate-page-name-within-editor.update.description": "若要將此頁面移至 {destinationSpace} 空間，請先提供不重複的標題並進行更新。",
  "editor-flags.offline.save.error": "請稍候幾秒鐘重新連線，連線後您即可繼續完成工作。",
  "editor-flags.offline.save.error.generic": "重新整理頁面，然後再按一次「發布」。",
  "editor-flags.offline.save.error.generic.title": "您的工作很安全，但有一個議題",
  "editor-flags.offline.save.error.title": "我們現在無法連線",
  "editor-flags.offline.update.save.error.generic": "重新整理頁面，然後再按一次「更新」。",
  "editor-flags.page.is.too.big": "大於 2MB 限制的頁面載入速度會很慢。請將您的內容分成兩個頁面，然後使用「包含頁面」巨集在此顯示內容。",
  "editor-flags.page.is.too.big.livedocs": "大於 2MB 上限的內容載入速度會很慢。請將您的內容分成幾個頁面或即時文件，然後使用「包含頁面」巨集在此顯示內容。",
  "editor-flags.page.is.too.big.title": "我們無法儲存您的內容",
  "editor-flags.page.title.invalid.header": "標題無效，請再試一次。",
  "editor-flags.page.title.invalid.message": "請使用其他標題，且最多 255 個字元。",
  "editor-flags.page.title.required.header": "標題是必要項目",
  "editor-flags.save.live.page.exist.content.title": "為您的文件提供不重複的名稱",
  "editor-flags.save.live.page.exist.message": "空間內的即時文件名稱不能重複。請為您的文件提供不同的名稱。",
  "editor-flags.save.page.exist.content.title": "為您的頁面提供唯一的名稱",
  "editor-flags.save.page.exist.message": "在空間內的頁面名稱必須是唯一的。為您的頁面提供不同的名稱以便發佈。",
  "editor-flags.save.update-page.exist.message": "空間內的頁面名稱不能重複。請為您的頁面提供不同的名稱以便更新。",
  "editor-flags.template.can.not.parse.content": "當範本包含損毀或不支援的元素時，就會發生這種情況。",
  "editor-flags.template.can.not.parse.content.title": "我們無法開啟此範本",
  "editor-flags.template.can.not.save.error.title.blank.header": "我們無法儲存此範本",
  "editor-flags.template.can.not.save.error.title.blank.message": "範本不能有空白的標題。為範本提供要發布的標題。",
  "editor-flags.template.can.not.save.error.title.duplicate": "在空間內的範本名稱必須是唯一的。為您的範本提供不同的名稱以便儲存。",
  "editor-flags.template.can.not.save.error.title.duplicate.title": "具有此名稱的範本已存在",
  "editor-flags.template.is.too.big": "大於 2MB 限制的範本載入速度會很慢。請將您的內容分為兩個範本。",
  "editor-flags.template.is.too.big.title": "我們無法儲存您的範本",
  "editor-flags.template.save.error.generic.message": "請再次嘗試按一下「儲存」。",
  "editor-flags.template.save.error.generic.title": "儲存範本時發生問題",
  "editor-flags.template.save.error.spacekey.invalid.header": "在此空間中建立範本時發生問題",
  "editor-flags.template.save.error.spacekey.invalid.message": "檢查空間是否存在，以及您是否具有建立範本的管理員權限。",
  "editor-flags.title.too.long": "標題的上限為 255 個字元。",
  "editor-flags.title.too.long.title": "您的標題太長。",
  "editor-flags.update-page.title.invalid.header": "我們無法更新具有該名稱的頁面。",
  "editor-flags.update.page.title.required.update.message": "請在更新前新增標題。",
  "editor-heading-links.link-component.icon.label": "「連結」圖示",
  "editor-heading-links.link-component.tooltip.copied": "已複製！",
  "editor-heading-links.link-component.tooltip.copy": "複製標題連結",
  "editor-help.editor-help-center.images.details": "<p>選取圖片並拖曳控點來調整圖片大小，或使用浮動選單來變更其對齊方式。</p>",
  "editor-help.editor-help-center.images.title": "圖片",
  "editor-help.editor-help-center.layouts.details": "<p>新增直欄，並使用浮動選單切換組態。</p>",
  "editor-help.editor-help-center.layouts.title": "版面配置",
  "editor-help.editor-help-center.slashCommands.details": "<p>輸入 <kbd>/</kbd> 即可開啟選單，以及在您的內容中隨意插入表格、巨集和日期等元素。</p>",
  "editor-help.editor-help-center.slashCommands.title": "斜線指令",
  "editor-help.editor-help-center.tables.details": "<p>使用可在邊界、儲存格和浮動選單中選取的格式設定選項，來轉換您的表格。</p>",
  "editor-help.editor-help-center.tables.title": "表格",
  "editor-help.editor-help-center.templates.details": "<p>尋找符合您需求的範本，加快建立速度。如果面板已關閉，請選取 (•••) 將其重新開啟。</p>",
  "editor-help.editor-help-center.templates.title": "範本",
  "editor-help.fabric.help.center.feedback.item": "意見反應",
  "editor-insert-menu-shortcut-hint.text": "快速鍵：按 \"/\" 以在您輸入資料時插入項目。",
  "editor-main-buttons.close.draft.name": "關閉草稿",
  "editor-main-buttons.close.name": "關閉",
  "editor-main-buttons.discard.draft.name": "捨棄草稿",
  "editor-main-buttons.edit.schedule.tooltip": "編輯排程",
  "editor-main-buttons.editor.buttons.disable.by.empty.title.tooltip": "您的頁面需有標題，才能進行發佈。",
  "editor-main-buttons.editor.buttons.disable.by.not.saving.tooltip": "仍在處理中...",
  "editor-main-buttons.editor.buttons.disable.by.saving.tooltip": "我們仍在儲存您的頁面。",
  "editor-main-buttons.editor.close.publish.tooltip": "儲存變更而不發布",
  "editor-main-buttons.editor.close.update.tooltip": "儲存變更而不更新",
  "editor-main-buttons.editor.discard.close.tooltip": "捨棄空白草稿",
  "editor-main-buttons.editor.publish.external.share.label": "外部分享",
  "editor-main-buttons.empty.blogPostTitle": "無標題部落格貼文",
  "editor-main-buttons.empty.default-livePageTitle": "無標題即時文件",
  "editor-main-buttons.empty.default-pageTitle": "無標題頁面",
  "editor-move-page-button.move.page.description": "移動",
  "editor-presence-avatar-group.invite-to-edit.title": "邀請使用者進行編輯",
  "editor-presets.comment.editorLoomButton.crossSellPopupCardDescription": "為您的團隊提供更多背景資訊，以便他們快速理解內容和給予回應。",
  "editor-presets.comment.editorLoomButton.crossSellPopupCardTitle": "透過影片新增更多背景資訊",
  "editor-presets.conflict-resolution-plugin.conflict-body.deleted.non-final": "刪除或保留已編輯的文字",
  "editor-presets.conflict-resolution-plugin.conflict-body.header.deleted.non-final": "文字衝突",
  "editor-presets.conflict-resolution-plugin.conflict-body.header.non-final": "同步問題",
  "editor-presets.conflict-resolution-plugin.conflict-body.non-final": "檢閱文字變更",
  "editor-presets.conflict-resolution-plugin.conflict-header.done.button.label.non-final": "完成",
  "editor-presets.conflict-resolution-plugin.conflict.delete.action.non-final": "刪除",
  "editor-presets.conflict-resolution-plugin.conflict.resolve-all.action.non-final": "全部關閉",
  "editor-presets.conflict-resolution-plugin.conflict.resolve.action.non-final": "關閉",
  "editor-presets.conflict-resolution-plugin.conflict.restore.action.non-final": "保留",
  "editor-presets.full-page-editor.crossSellPopupCardDescription": "透過此頁面的影片介紹來節省時間並與團隊互動。",
  "editor-presets.full-page-editor.crossSellPopupCardTitle": "透過影片分享工作內容",
  "editor-preview.back-button": "返回",
  "editor-preview.breadcrumbs.blog": "部落格",
  "editor-preview.edit-button": "編輯",
  "editor-schedule-publish.success.reschedule.publish": "已重新安排在 {date}的 {time} 發布「{pageTitle}」",
  "editor-schedule-publish.success.reschedule.publish.with.space.name": "已重新安排在 {date}的 {time}，於「{spaceName}」空間發布「{pageTitle}」",
  "editor-schedule-publish.success.reschedule.update": "已重新安排在 {date}的 {time} 更新「{pageTitle}」",
  "editor-schedule-publish.success.reschedule.update.with.space.name": "已重新安排在 {date}的 {time}，於「{spaceName}」空間更新「{pageTitle}」",
  "editor-schedule-publish.success.schedule.publish.message": "{pageTitle} 將會於 {date} 的 {time} 發布",
  "editor-schedule-publish.success.schedule.publish.message.with.space.name": "「{pageTitle}」將在 {date}的 {time}，於「{spaceName}」空間發布",
  "editor-schedule-publish.success.schedule.publish.title": "發布已列入排程",
  "editor-schedule-publish.success.schedule.update.message": "{pageTitle} 將會於 {date} 的 {time} 更新",
  "editor-schedule-publish.success.schedule.update.message.with.space.name": "「{pageTitle}」將在 {date}的 {time}，於「{spaceName}」空間更新",
  "editor-schedule-publish.success.schedule.update.title": "更新已列入排程",
  "editor-title.ai.title.error.dismiss": "關閉",
  "editor-title.editor.onboarding.title.placeholder": "給此頁面一個標題",
  "editor-title.existing.blogpost.placeholder": "部落格貼文標題",
  "editor-title.live-pages-title.duplicate-title-error": "此空間中已經有名為「{pageTitle}」的內容。 請為這個頁面提供不重複的標題。",
  "editor-title.live-pages-title.duplicate-title-error.livedocs": "此空間中已經有名為「{pageTitle}」的內容。 請為這個文件提供不重複的標題。",
  "editor-title.live-pages-title.empty-title-error": "為您的頁面提供一個不重複的標題，方便稍後尋找",
  "editor-title.live-pages-title.empty-title-error.livedocs": "為您的即時文件提供一個不重複的標題，方便稍後尋找",
  "editor-title.live-pages-title.general-error": "我們這端發生錯誤。請重新整理，然後再試一次。",
  "editor-title.live-pages-title.placeholder": "給此頁面一個標題",
  "editor-title.live-pages-title.placeholder.livedocs": "為此即時文件提供標題",
  "editor.adf.parsing.error.details": "錯誤詳細資料：",
  "editor.adf.parsing.error.message.prod": "我們的團隊已收到通知。{br}如果問題持續發生，請連絡 <alink>Atlassian 支援團隊</alink>。",
  "editor.adf.parsing.error.message.staging": "我們的團隊已收到通知，但您也可以在 Slack 的 <alink>#cc-content-experience</alink> 頻道中討論此問題。",
  "editor.adf.parsing.error.title.prod": "我們無法載入編輯器。",
  "editor.adf.parsing.error.title.staging": "將此文件轉換為 ADF 時發生問題",
  "editor.discard-to-published.error.message": "我們目前無法取得最後發布的頁面版本。請稍後片刻，然後嘗試再次捨棄草稿。",
  "editor.discard-to-published.error.title": "無法恢復到上次發布的版本",
  "editor.help.dev-only-ncs-editor": "僅限開發人員：NCS 編輯器",
  "editor.help.dev-only-synchrony-editor": "僅限開發人員：Synchrony 編輯器",
  "editor.help.dev-tools": "開發工具",
  "editor.help.templates": "使用頁面範本",
  "embedded-confluence.content.placeholder": "您知道您可以在此頁面中新增目錄、日期或藍圖等各式各樣的酷炫項目嗎？輸入 / 以開啟清單。",
  "embedded-confluence.content.placeholder.ai": "輸入 /ai 即表示 Atlassian Intelligence，輸入 / 可新增元素，輸入 @ 可提及某人 (我們會通知他們)。",
  "embedded-publish-button.publish-button-text": "發布",
  "embedded-publish-button.publish-hotkey-description": "若要發布此內容，請在鍵盤上選取 {keyCombination}。",
  "embedded-publish-button.update-button-text": "更新",
  "emoji-title.add-emoji.floating-toolbar": "表情符號",
  "emoji-title.change-emoji": "變更表情符號",
  "emoji-title.icon.blogpost": "部落格",
  "emoji-title.icon.document": "文件",
  "emoji-title.icon.embed": "嵌入",
  "emoji-title.live-docs-default-icon-label": "即時文件表情符號",
  "emoji-title.remove-emoji": "移除表情符號",
  "emoji-title.restore-emoji": "復原表情符號",
  "emoji-title.space-icon-alt": "空間圖示",
  "entity-view.attachment.lastmodified": "已上傳",
  "entity-view.blog.label": "部落格",
  "entity-view.content.archived": "已封存",
  "entity-view.content.draft": "草稿",
  "entity-view.content.lastmodified": "已更新",
  "entity-view.content.scheduled": "發佈已列入排程",
  "entity-view.content.spaceArchived": "已封存",
  "entity-view.content.spaceStarred": "已標上星號",
  "entity-view.content.unpublishes": "未發佈的變更",
  "entity-view.content.untitled": "未命名",
  "entity-view.database.label": "資料庫",
  "entity-view.folder.label": "資料夾",
  "entity-view.generic.label": "內容圖示",
  "entity-view.live.page.label": "即時文件",
  "entity-view.page.label": "頁面",
  "entity-view.whiteboard.label": "白板",
  "error-app.detail": "請檢視我們的{link}並訂閱服務更新。",
  "error-app.link-name": "狀態頁面",
  "error-app.sub-title": "我們正在努力解決問題。",
  "error-app.title": "發生錯誤。",
  "error-boundary.close": "關閉",
  "error-boundary.code": "與此錯誤相關聯的代碼：{code}",
  "error-boundary.code-block.copy.failure": "無法複製到剪貼簿",
  "error-boundary.code-block.copy.success": "已複製！",
  "error-boundary.code-block.copy.tooltip": "複製",
  "error-boundary.code.in-code-block": "雜湊：{code}",
  "error-boundary.description": "這個議題應該會自行解決。於此同時，您可以檢查<statuslink>狀態頁面</statuslink>。可能有已報告的事件與<kblink>此錯誤</kblink>相關。如果這種情況持續發生，請要求您的管理員聯繫<supportlink>我們的支援團隊</supportlink>，並提供他們：",
  "error-boundary.description.refresh-link": "重新整理",
  "error-boundary.description.support-link": "Atlassian 支援",
  "error-boundary.editor.title": "無法載入內容",
  "error-boundary.error-message.description": "如果這個問題持續發生，請{refreshLink}，或連絡 {atlassianSupportLink}。",
  "error-boundary.refresh": "嘗試重新整理。{refreshLink}",
  "error-boundary.reload-page": "重新載入頁面",
  "error-boundary.status.403.action.reload": "立即重新載入",
  "error-boundary.status.403.description": "若要解決此問題，請嘗試重新載入或聯絡您的管理員，以取得存取權。您也可以檢查<statuslink>狀態頁面</statuslink>，了解與此<kblink>錯誤</kblink>相關的潛在已知事件。如果此問題持續存在，請要求您的管理員連絡<supportlink>支援團隊</supportlink>，並提供：",
  "error-boundary.title": "我們這端發生問題",
  "error-boundary.trace": "追蹤：{traceId}",
  "error-boundary.url": "此頁面的 URL",
  "error.server-error.body": "請稍後再試一次。",
  "error.server-error.title": "發生錯誤",
  "excerpt-include.empty": "找不到摘錄。",
  "excerpt-include.empty.edit": "選取 {editIcon} 以選擇其他來源頁面。",
  "excerpt-include.recursive-error.description": "此插入摘錄巨集無法插入其嵌套的摘錄。",
  "excerpt-include.untitled": "未命名的摘錄",
  "experiment-aua-improve-conversion.feature-name-column.atlassian-support": "Atlassian 支援",
  "experiment-aua-improve-conversion.feature-name-column.free-guest-access": "免費的訪客存取權",
  "experiment-aua-improve-conversion.feature-name-column.page-insights": "頁面深入解析",
  "experiment-aua-improve-conversion.feature-name-column.page-permissions": "頁面權限",
  "experiment-aua-improve-conversion.feature-name-column.unlimited-pages": "不限數量的頁面",
  "experiment-aua-improve-conversion.feature-name-column.unlimited-users": "不限數量的使用者",
  "experiment-aua-improve-conversion.floating-recommendation.based-on-your-usage": "根據您的使用量",
  "experiment-aua-improve-conversion.floating-recommendation.gestural-line-alt-text": "指向 Standard 版本的手勢",
  "experiment-aua-improve-conversion.floating-recommendation.recommended": "建議",
  "experiment-aua-improve-conversion.free-edition-column.title": "免費",
  "experiment-aua-improve-conversion.primary-cta": "立即試用",
  "experiment-aua-improve-conversion.standard-edition-column.title": "Standard",
  "experiment-aua-improve-conversion.subheading": "開始 Standard 方案的 14 天免費試用。可隨時取消，我們會在試用期結束前 3 天提醒您。",
  "experiment-auto-provisioning-edition-parity.manage-your-trial.title": "管理您的試用",
  "experiment-auto-provisioning-edition-parity.ok.button": "確定",
  "experiment-auto-provisioning-edition-parity.trial-description": "了解您的 Premium 功能，並隨時管理您的試用。",
  "experiment-confluence-ea-dropdown.advanced-permissions.description": "控制人員可以做什麼和建立什麼",
  "experiment-confluence-ea-dropdown.advanced-permissions.title": "進階權限",
  "experiment-confluence-ea-dropdown.ask-your-admin": "要求您的管理員新增付款選項，以便您繼續使用 Premium 方案。",
  "experiment-confluence-ea-dropdown.atlassian-intelligence.description": "建立內容摘要、取得寫作協助等",
  "experiment-confluence-ea-dropdown.atlassian-intelligence.title": "Atlassian Intelligence",
  "experiment-confluence-ea-dropdown.billing-info.analytics.description": "查看活動以更妥善地管理內容",
  "experiment-confluence-ea-dropdown.buy-now": "立即購買",
  "experiment-confluence-ea-dropdown.calendar.description": "透過共用的檢視方式保持井然有序",
  "experiment-confluence-ea-dropdown.calendar.title": "行事曆",
  "experiment-confluence-ea-dropdown.make-the-most": "充分運用您的試用機會",
  "experiment-confluence-ea-dropdown.no-billing-info.analytics.description": "查看檢視項目的人員和時間",
  "experiment-confluence-ea-dropdown.non-admin.analytics": "分析",
  "experiment-confluence-ea-dropdown.ready-to-buy": "我準備要購買",
  "experiment-confluence-ea-dropdown.switch-plans": "切換方案",
  "experiment-confluence-ea-dropdown.team-calendar.description": "規劃各團隊的期限和休假",
  "experiment-confluence-ea-dropdown.team-calendar.title": "團隊行事曆",
  "experiment-confluence-ea-dropdown.time-to-make-a-choice": "是時候做出選擇了",
  "experiment-confluence-ea-dropdown.trial-includes": "您的 Premium 試用版包括：",
  "experiment-confluence-ea-dropdown.trial-includes-end-of-trial": "保留下列 Premium 方案的功能：",
  "experiment-confluence-ea-dropdown.unlimited-users.description": "新增您的團隊和相關人員",
  "experiment-confluence-ea-dropdown.unlimited-users.title": "不限數量的使用者",
  "experiment-content-type-visuals-in-create.blog.description": "使用部落格發布構想和想法，並且與團隊中的更多人分享。",
  "experiment-content-type-visuals-in-create.blog.title": "使用部落格分享構想",
  "experiment-content-type-visuals-in-create.database.description": "使用資料庫追蹤和同步資訊。",
  "experiment-content-type-visuals-in-create.database.title": "整理和同步資訊",
  "experiment-content-type-visuals-in-create.folder.description": "使用資料夾來打造更清潔、更有條理的空間。",
  "experiment-content-type-visuals-in-create.folder.title": "使用資料夾整理",
  "experiment-content-type-visuals-in-create.live-doc.description": "使用即時文件進行快速協作和建立構想。",
  "experiment-content-type-visuals-in-create.live-doc.title": "使用即時文件進行內容協作",
  "experiment-content-type-visuals-in-create.loom.description": "建立 Loom 影片以提供工作的逐步說明、快速非同步專案更新等等。",
  "experiment-content-type-visuals-in-create.loom.title": "記錄 Loom 更新",
  "experiment-content-type-visuals-in-create.page.description": "將頁面用於發布和分享知識。",
  "experiment-content-type-visuals-in-create.page.title": "分享知識",
  "experiment-content-type-visuals-in-create.smart-link.description": "直接將連結嵌入內容樹狀結構中，並隨時存取。",
  "experiment-content-type-visuals-in-create.smart-link.title": "嵌入智慧連結",
  "experiment-content-type-visuals-in-create.space.title": "整理空間中的工作",
  "experiment-content-type-visuals-in-create.whiteboard.description": "使用白板在空白畫布上進行腦力激盪。",
  "experiment-content-type-visuals-in-create.whiteboard.title": "團隊腦力激盪",
  "experiment-edition-awareness-for-standard-to-premium.section.message.persistent-upgrade.menuitem.premiumplan.title": "升級",
  "experiment-enhance-orientation-tour.back.button": "返回",
  "experiment-enhance-orientation-tour.creation-start.description": "文件、白板、資料庫等都可從這裡建立。",
  "experiment-enhance-orientation-tour.creation-start.title": "從這裡開始建立",
  "experiment-enhance-orientation-tour.done.button": "完成",
  "experiment-enhance-orientation-tour.explore-space.description": "了解如何放心導覽 Confluence。",
  "experiment-enhance-orientation-tour.explore-space.link": "進行導覽",
  "experiment-enhance-orientation-tour.explore-space.title": "一起來探索這個空間",
  "experiment-enhance-orientation-tour.nailed-it.description": "您即將成為專業人士。",
  "experiment-enhance-orientation-tour.nailed-it.title": "完成了！",
  "experiment-enhance-orientation-tour.navigate-around.description": "查看團隊活動、檢閱最近和已標上星號的工作等等。",
  "experiment-enhance-orientation-tour.navigate-around.title": "輕鬆導覽",
  "experiment-enhance-orientation-tour.next.button": "下一步",
  "experiment-enhance-orientation-tour.organize-space.description": "團隊可使用空間彙整內容，並搭配資料夾，以增加結構。",
  "experiment-enhance-orientation-tour.organize-space.title": "空間可用於整理工作",
  "experiment-home-onboarding-takeover-v2.add-profile-picture-nth-user.description": "新增個人檔案照片，以協助團隊成員辨識您。",
  "experiment-home-onboarding-takeover-v2.add-profile-picture.cta": "新增相片",
  "experiment-home-onboarding-takeover-v2.add-profile-picture.description": "透過熟悉的面孔歡迎團隊成員加入 Confluence。",
  "experiment-home-onboarding-takeover-v2.add-profile-picture.title": "新增設定檔相片",
  "experiment-home-onboarding-takeover-v2.atlassian-com.subtitle": "atlassian.com 上的文章",
  "experiment-home-onboarding-takeover-v2.atlassian-marketplace.subtitle": "Atlassian Marketplace",
  "experiment-home-onboarding-takeover-v2.become-an-effective-confluence-admin.cta": "了解方法",
  "experiment-home-onboarding-takeover-v2.become-an-effective-confluence-admin.description": "管理使用者、空間和範本，以建立卓越的內容體驗。",
  "experiment-home-onboarding-takeover-v2.become-an-effective-confluence-admin.title": "成為高效的 Confluence 管理員",
  "experiment-home-onboarding-takeover-v2.carousel.heading": "認識 Confluence (已完成 {total} 張卡片，總共 {completed} 張)",
  "experiment-home-onboarding-takeover-v2.change-site-theme.cta": "新增品牌",
  "experiment-home-onboarding-takeover-v2.change-site-theme.description": "選擇顏色並新增標誌，為 Confluence 提供熟悉的外觀。",
  "experiment-home-onboarding-takeover-v2.change-site-theme.title": "新增您公司的品牌",
  "experiment-home-onboarding-takeover-v2.collapse-expand-button.collapse": "摺疊指南",
  "experiment-home-onboarding-takeover-v2.collapse-expand-button.expand": "繼續學習基礎概念",
  "experiment-home-onboarding-takeover-v2.completed-card-text": "您已完成此步驟。",
  "experiment-home-onboarding-takeover-v2.confluence-page.subtitle": "Confluence 頁面",
  "experiment-home-onboarding-takeover-v2.create-intro-blog.cta": "查看範本",
  "experiment-home-onboarding-takeover-v2.create-intro-blog.description": "建立專屬的介紹範本，輕鬆與團隊成員分享您的故事和興趣。",
  "experiment-home-onboarding-takeover-v2.create-intro-blog.title": "向新同事自我介紹",
  "experiment-home-onboarding-takeover-v2.create-livedoc.cta": "建立即時文件",
  "experiment-home-onboarding-takeover-v2.create-livedoc.title": "建立即時文件",
  "experiment-home-onboarding-takeover-v2.create-page.cta": "建立頁面",
  "experiment-home-onboarding-takeover-v2.create-page.description": "規劃專案、記筆記和追蹤任務。試用範本或從頭開始。",
  "experiment-home-onboarding-takeover-v2.create-page.title": "建立頁面",
  "experiment-home-onboarding-takeover-v2.create-space.description": "為團隊的專案和文件建立單一事實來源。",
  "experiment-home-onboarding-takeover-v2.create-space.title": "設定團隊空間",
  "experiment-home-onboarding-takeover-v2.create-whiteboard-nth-user.description": "使用白板不拘一格地協作和呈現，以創造新構想。",
  "experiment-home-onboarding-takeover-v2.create-whiteboard.cta": "建立白板",
  "experiment-home-onboarding-takeover-v2.create-whiteboard.description": "產生新構想並呈現您的工作。",
  "experiment-home-onboarding-takeover-v2.create-whiteboard.title": "在白板上腦力激盪",
  "experiment-home-onboarding-takeover-v2.dismiss-card-button-label": "關閉此動作",
  "experiment-home-onboarding-takeover-v2.dismiss-icon-label": "關閉橫幅",
  "experiment-home-onboarding-takeover-v2.download-mobile-app.cta": "了解應用程式",
  "experiment-home-onboarding-takeover-v2.download-mobile-app.description": "與您的團隊協作，並在所有裝置上同步工作。",
  "experiment-home-onboarding-takeover-v2.download-mobile-app.title": "隨時隨地使用 Confluence",
  "experiment-home-onboarding-takeover-v2.empower-your-team.cta": "開始使用",
  "experiment-home-onboarding-takeover-v2.empower-your-team.description": "透過符合自己步調的簡短課程，讓您的團隊在 Confluence 中快速開始運作。",
  "experiment-home-onboarding-takeover-v2.empower-your-team.title": "為團隊提供基礎知識",
  "experiment-home-onboarding-takeover-v2.explore-ai.cta": "觀看影片",
  "experiment-home-onboarding-takeover-v2.explore-ai.description": "加速搜尋、寫作和行動 - 可在您的自動 Premium 試用版中使用。",
  "experiment-home-onboarding-takeover-v2.explore-ai.title": "探索 Confluence AI",
  "experiment-home-onboarding-takeover-v2.explore-premium.cta": "查看 Premium 功能",
  "experiment-home-onboarding-takeover-v2.explore-premium.description": "您正在使用 Confluence Premium 的 {trialDaysLeft} 天免費試用。查看有哪些功能包含在內，然後試用看看。",
  "experiment-home-onboarding-takeover-v2.explore-premium.title": "試用 Premium 功能",
  "experiment-home-onboarding-takeover-v2.get-certified.cta": "獲得認證",
  "experiment-home-onboarding-takeover-v2.get-certified.description": "展示您的技能並脫穎而出：透過認證來驗證您的 Confluence 知識。",
  "experiment-home-onboarding-takeover-v2.get-certified.title": "在 Confluence Essentials 中獲得認證",
  "experiment-home-onboarding-takeover-v2.header.description": "您想如何開始？",
  "experiment-home-onboarding-takeover-v2.header.heading": "{name}，歡迎您！👋",
  "experiment-home-onboarding-takeover-v2.header.heading.backup": "歡迎！👋",
  "experiment-home-onboarding-takeover-v2.header.heading.collaped": "開始探索 Confluence",
  "experiment-home-onboarding-takeover-v2.header.invite": "邀請人員",
  "experiment-home-onboarding-takeover-v2.header.success-description": "您已完成入職任務",
  "experiment-home-onboarding-takeover-v2.header.success-heading": "{name}，恭喜您！🏆",
  "experiment-home-onboarding-takeover-v2.header.success-heading.backup": "恭喜！🏆",
  "experiment-home-onboarding-takeover-v2.home-nudge.description": "當您準備好繼續著手使用後，請返回首頁。",
  "experiment-home-onboarding-takeover-v2.home-nudge.dismiss-cta": "關閉",
  "experiment-home-onboarding-takeover-v2.home-nudge.go-home-cta.": "前往首頁",
  "experiment-home-onboarding-takeover-v2.jira-get-started.title": "從 Jira 開始使用 Confluence",
  "experiment-home-onboarding-takeover-v2.jira-planning-to-action.title": "透過 Confluence 和 Jira，從規劃到實際付諸行動",
  "experiment-home-onboarding-takeover-v2.jira-streamline-release.title": "透過 Confluence 和 Jira 簡化版本資訊",
  "experiment-home-onboarding-takeover-v2.join-community.cta": "加入社群",
  "experiment-home-onboarding-takeover-v2.join-community.description": "向和您相似的新使用者學習，或與社區中的其他人分享所學知識。",
  "experiment-home-onboarding-takeover-v2.join-community.title": "在「Atlassian 社群」上加入和您相似的使用者",
  "experiment-home-onboarding-takeover-v2.jsm-add-ons.title": "透過附加元件加強您的服務工作流程",
  "experiment-home-onboarding-takeover-v2.jsm-five-steps.title": "為您的服務工作流程設定知識庫的 5 個步驟",
  "experiment-home-onboarding-takeover-v2.jsm-learn-more.title": "了解 The Very Group 如何將服務管理現代化",
  "experiment-home-onboarding-takeover-v2.learning-opportunity.heading": "透過 Atlassian University 了解",
  "experiment-home-onboarding-takeover-v2.learning-path.cta": "開始使用",
  "experiment-home-onboarding-takeover-v2.learning-path.description": "按照簡短且可調控步調的課程內容，在 Confluence 上開始工作。",
  "experiment-home-onboarding-takeover-v2.learning-path.title": "Atlassian University 上有免費的學習路徑",
  "experiment-home-onboarding-takeover-v2.nth-user-home-nudge.button-dismiss": "關閉",
  "experiment-home-onboarding-takeover-v2.nth-user-home-nudge.button-try-it": "試試看",
  "experiment-home-onboarding-takeover-v2.nth-user-home-nudge.header": "開始使用 Confluence",
  "experiment-home-onboarding-takeover-v2.nth-user-home-nudge.text": "快速了解 Confluence 並成為 Confluence 專家",
  "experiment-home-onboarding-takeover-v2.nth-user-learning-opportunity.heading": "透過更多資源學習",
  "experiment-home-onboarding-takeover-v2.nth-user.collapse-expand-button.collapse": "摺疊入門",
  "experiment-home-onboarding-takeover-v2.nth-user.collapse-expand-button.expand": "展開入門",
  "experiment-home-onboarding-takeover-v2.nth-user.header.beginner": "初學者",
  "experiment-home-onboarding-takeover-v2.nth-user.header.heading": "Confluence 專業知識：{level}",
  "experiment-home-onboarding-takeover-v2.nth-user.header.intermediate": "中級",
  "experiment-home-onboarding-takeover-v2.nth-user.header.professional": "專業",
  "experiment-home-onboarding-takeover-v2.support-resources.cta": "深入了解",
  "experiment-home-onboarding-takeover-v2.support-resources.description": "在「Atlassian 支援」網站上，瀏覽所有與 Confluence 相關的文章。",
  "experiment-home-onboarding-takeover-v2.support-resources.title": "探索「Atlassin 支援」資源",
  "experiment-home-onboarding-takeover-v2.third-party-apps.cta": "探索應用程式",
  "experiment-home-onboarding-takeover-v2.third-party-apps.description": "使用適合團隊工作流程的應用程式自訂 Confluence。",
  "experiment-home-onboarding-takeover-v2.third-party-apps.title": "連接第三方應用程式",
  "experiment-home-onboarding-takeover-v2.view-popular-content.cta": "查看熱門內容",
  "experiment-home-onboarding-takeover-v2.view-popular-content.description": "深入了解熱門內容，並透過有趣的回應或留言分享您的看法。",
  "experiment-home-onboarding-takeover-v2.view-popular-content.title": "探索和回應熱門內容",
  "experiment-home-onboarding-takeover-v2.work-life.subtitle": "Atlassian 的「工作生活」文章",
  "experiment-home-onboarding-takeover-v2.xflow.tailored-tips-heading": "為您的團隊量身打造的提示",
  "experiment-legacy-content-macro.collab-warning": "舊版內容不支援協作功能。在其他人編輯時，編輯或發布此內容可能會導致變更遺失。",
  "experiment-onboarding-content-type-spotlight.dismiss.action": "關閉",
  "experiment-onboarding-content-type-spotlight.nth-user.content-types.content.description": "{contentType, select, page {快速查看頁面，了解 Confluence 頁面的運作方式。} whiteboard {快速查看白板，了解 Confluence 白板的運作方式。} liveDoc {快速查看即時文件，了解 Confluence 即時文件的運作方式。} database {快速查看資料庫，了解 Confluence 資料庫的運作方式。} databaseDefault {快速查看頁面，了解 Confluence 資料庫的運作方式。} other {快速查看內容，了解 Confluence 內容類型的運作方式。}}",
  "experiment-onboarding-content-type-spotlight.nth-user.content-types.non-popular.heading": "{contentType, select, page {這是您空間中的範例頁面} whiteboard {這是您空間中的範例白板} liveDoc {這是您空間中的範例即時文件} database {此頁面會說明如何使用資料庫} other {這是您空間中所選內容類型的範例}}",
  "experiment-onboarding-content-type-spotlight.nth-user.content-types.popular.heading": "{contentType, select, page {這是您網站中最熱門的頁面} whiteboard {這是您網站中最熱門的白板} liveDoc {這是您網站中最熱門的即時文件} database {這是您網站中最熱門的資料庫} other {此內容在您的網站上很熱門}}",
  "experiment-onboarding-whats-new-in-confluence.banner.heading": "Confluence 中的新功能",
  "experiment-onboarding-whats-new-in-confluence.banner.subheading": "更新和版本",
  "experiment-onboarding-whats-new-in-confluence.card.ai-whiteboard.content": "使用新的 AI 功能改善工作坊！產生構想、按主題整理構想，並建立摘要以新增至 Confluence 頁面。",
  "experiment-onboarding-whats-new-in-confluence.card.ai-whiteboard.cta": "開始使用",
  "experiment-onboarding-whats-new-in-confluence.card.ai-whiteboard.heading": "現已推出：Confluence 白板中的 AI",
  "experiment-onboarding-whats-new-in-confluence.card.ai-whiteboard.label": "Atlassian intelligence",
  "experiment-onboarding-whats-new-in-confluence.card.highlights.content": "以下是我們在 2024 年發布的主要項目，從嶄新的功能到能帶來大幅影響的小更新都有。",
  "experiment-onboarding-whats-new-in-confluence.card.highlights.cta": "查看列表",
  "experiment-onboarding-whats-new-in-confluence.card.highlights.heading": "回顧：Confluence 2024 年的最佳項目",
  "experiment-onboarding-whats-new-in-confluence.card.highlights.label": "2024 年亮點",
  "experiment-onboarding-whats-new-in-confluence.card.jira-task.content": "不需要在工作流程中切換分頁。讓「Atlassian Intelligence 工作建立」將 Confluence 頁面轉換為 Jira 任務。",
  "experiment-onboarding-whats-new-in-confluence.card.jira-task.cta": "查看",
  "experiment-onboarding-whats-new-in-confluence.card.jira-task.heading": "從 Confluence 建立 Jira 任務",
  "experiment-onboarding-whats-new-in-confluence.card.jira-task.label": "Jira + confluence",
  "experiment-onboarding-whats-new-in-confluence.card.modernize-confluence.content": "我們已推出一些有趣的變更，後續也還會再推出，以便提升團隊協作並協助您盡可能發揮工作的影響力。",
  "experiment-onboarding-whats-new-in-confluence.card.modernize-confluence.cta": "檢視變更",
  "experiment-onboarding-whats-new-in-confluence.card.modernize-confluence.heading": "認識新的 Confluence",
  "experiment-onboarding-whats-new-in-confluence.card.modernize-confluence.label": "提升協作",
  "experiment-onboarding-whats-new-in-confluence.card.public-whiteboard.content": "公開白板近期已升級！現在已可在上方編輯，因此內部和外部的使用者可以即時協作。",
  "experiment-onboarding-whats-new-in-confluence.card.public-whiteboard.cta": "立即查看",
  "experiment-onboarding-whats-new-in-confluence.card.public-whiteboard.heading": "公開白板現已可編輯",
  "experiment-onboarding-whats-new-in-confluence.card.public-whiteboard.label": "公開白板",
  "experiment-onboarding-whats-new-in-confluence.footer": "您使用的是最新版本",
  "experiment-onboarding-whats-new-in-confluence.spotlight.action": "確定",
  "experiment-onboarding-whats-new-in-confluence.spotlight.content": "請在此處查看新產品更新和版本。",
  "experiment-personalized-templates-v2.action.plan.template": "行動計畫",
  "experiment-personalized-templates-v2.brainstorm.on.whiteboard": "在白板上腦力激盪",
  "experiment-personalized-templates-v2.brainstorm.on.whiteboard.cta": "建立白板",
  "experiment-personalized-templates-v2.brainstorm.on.whiteboard.description": "產生新構想並呈現您的工作。",
  "experiment-personalized-templates-v2.brainwriting.template": "腦力激盪",
  "experiment-personalized-templates-v2.completed.cta": "已完成",
  "experiment-personalized-templates-v2.concept.map.template": "概念圖",
  "experiment-personalized-templates-v2.create.page": "建立頁面",
  "experiment-personalized-templates-v2.create.page.cta": "建立頁面",
  "experiment-personalized-templates-v2.create.page.description": "規劃專案、記筆記和追蹤任務。",
  "experiment-personalized-templates-v2.create.team.profile": "建立團隊設定檔",
  "experiment-personalized-templates-v2.create.team.profile.cta": "建立團隊",
  "experiment-personalized-templates-v2.create.team.profile.description": "將每個人整合到您可以指派工作的一個團隊之中。",
  "experiment-personalized-templates-v2.database.template": "資料庫範本",
  "experiment-personalized-templates-v2.dismiss.label": "關閉建議",
  "experiment-personalized-templates-v2.dismiss.onboarding.label": "關閉上線",
  "experiment-personalized-templates-v2.disruptive.brainstorm.template": "破壞性腦力激盪",
  "experiment-personalized-templates-v2.document.template": "文件範本",
  "experiment-personalized-templates-v2.fishbone.diagram.template": "魚骨圖",
  "experiment-personalized-templates-v2.flowchart.template": "流程圖",
  "experiment-personalized-templates-v2.focus.area.diagram.template": "焦點區域圖",
  "experiment-personalized-templates-v2.four.ls.template": "4 L 回顧",
  "experiment-personalized-templates-v2.gap.analysis.template": "差距分析",
  "experiment-personalized-templates-v2.getting.started.header": "開始使用",
  "experiment-personalized-templates-v2.heading": "推薦給您嘗試的範本",
  "experiment-personalized-templates-v2.icebreakers.template": "破冰器",
  "experiment-personalized-templates-v2.incident.postmortem.template": "事件事後分析",
  "experiment-personalized-templates-v2.network.of.teams.template": "團隊網路",
  "experiment-personalized-templates-v2.org.chart.template": "組織圖",
  "experiment-personalized-templates-v2.page.template": "頁面範本",
  "experiment-personalized-templates-v2.prioritization.matrix.template": "優先順序矩陣",
  "experiment-personalized-templates-v2.product.annual-calendar.template": "年度行事曆",
  "experiment-personalized-templates-v2.product.crazy-8s-brainstorming.template": "Crazy 8s 腦力激盪",
  "experiment-personalized-templates-v2.product.executive-summary.template": "執行摘要",
  "experiment-personalized-templates-v2.product.roadmap.template": "產品藍圖",
  "experiment-personalized-templates-v2.product.root-cause.template": "根本原因分析",
  "experiment-personalized-templates-v2.product.stakeholder-mapping.template": "相關人員對應",
  "experiment-personalized-templates-v2.product.vision.board.template": "產品視覺看板",
  "experiment-personalized-templates-v2.see.more.templates.button": "再多顯示 {numberTemplateSuggestions} 個",
  "experiment-personalized-templates-v2.service.blueprint.template": "服務藍圖",
  "experiment-personalized-templates-v2.setup.team.space": "設定團隊空間",
  "experiment-personalized-templates-v2.setup.team.space.cta": "設定空間",
  "experiment-personalized-templates-v2.setup.team.space.description": "為團隊的專案和文件建立單一事實來源。",
  "experiment-personalized-templates-v2.show.fewer.button": "顯示較少",
  "experiment-personalized-templates-v2.simple.retrospective.template": "簡單回顧",
  "experiment-personalized-templates-v2.swimlanes.process.map.template": "泳道流程圖",
  "experiment-personalized-templates-v2.swot.analysis.template": "SWOT 分析",
  "experiment-personalized-templates-v2.team.charter.template": "團隊約章範本",
  "experiment-personalized-templates-v2.team.health.monitor.template": "團隊運作狀態監控",
  "experiment-personalized-templates-v2.template-list.template-card.havent-used-before": "尚未使用",
  "experiment-personalized-templates-v2.template-list.template-card.used-before": "{count, plural, other {之前已使用 {count} 次}}",
  "experiment-personalized-templates-v2.timeline.workflow.template": "時間軸工作流程",
  "experiment-personalized-templates-v2.user.story.map.template": "使用者故事地圖",
  "experiment-personalized-templates-v2.whiteboard.template": "白板範本",
  "experiment-personalized-templates-v2.workflow.template": "工作流程",
  "experiment-prompt-whiteboard-competitor-link.prompt-popup.create-button-default": "建立白板",
  "experiment-prompt-whiteboard-competitor-link.prompt-popup.create-button-import": "從「{competitorName}」匯入",
  "experiment-prompt-whiteboard-competitor-link.prompt-popup.description-default": "我們注意到您已貼上 {competitorName} 連結。請改為使用 Confluence 白板，來減少背景資訊的切換。",
  "experiment-prompt-whiteboard-competitor-link.prompt-popup.description-import": "我們注意到您已貼上 {competitorName} 連結。 請改為將工作匯入 Confluence 白板，來減少背景資訊的切換。",
  "experiment-prompt-whiteboard-competitor-link.prompt-popup.dismiss-button": "不再顯示",
  "experiment-prompt-whiteboard-competitor-link.prompt-popup.title": "試用 Confluence 白板",
  "experiment-quick-summary.admin.cta": "立即試用",
  "experiment-quick-summary.atlassian-intelligence-icon.alt-text": "Atlassian Intelligence",
  "experiment-quick-summary.body.text": "使用 <link>Atlassian Intelligence</link> 摘要此內容，並且把時間花在重要的工作上。開始免費試用 30 天的 Premium 方案，以嘗試此功能。",
  "experiment-quick-summary.footer.message": "由 Atlassian Intelligence 提供技術支援",
  "experiment-quick-summary.nonadmin.cta": "請管理員嘗試",
  "experiment-quick-summary.nonadmin.message.sent": "已傳送給管理員",
  "experiment-quick-summary.num.interested.users": "{usersInterested, plural, other {您團隊中有 {usersInterested} 人想要試用 AI}}",
  "experiment-quick-summary.title.text": "要閱讀的內容太多了嗎？使用 AI 了解重點",
  "experiment-recommend-trial-to-free.permissions-svg.svg-text-1": "限制",
  "experiment-recommend-trial-to-free.permissions-svg.svg-text-2": "STANDARD 方案",
  "experiment-recommend-trial-to-free.permissions-svg.svg-text-3": "只有特定人員可以檢視或編輯",
  "experiment-recommend-trial-to-free.permissions-svg.svg-text-4": "可以檢視",
  "experiment-recommend-trial-to-free.permissions-svg.svg-text-5": "可以檢視和編輯",
  "experiment-recommend-trial-to-free.reload-page-modal.close-button-title": "關閉",
  "experiment-recommend-trial-to-free.reload-page-modal.info-icon-label": "「資訊」圖示",
  "experiment-recommend-trial-to-free.reload-page-modal.modal-content-body": "如果您已升級，請重新載入此頁面以開始試用。最多可能需要一分鐘的時間才會變更。",
  "experiment-recommend-trial-to-free.reload-page-modal.modal-header": "重新載入此頁面",
  "experiment-recommend-trial-to-free.reload-page-modal.reload-button-title": "重新載入",
  "experiment-recommend-trial-to-free.update-success-modal.cta-button": "免費試用",
  "experiment-recommend-trial-to-free.update-success-modal.modal-content-body": "開始免費試用 14 天的 Standard 方案，以設定誰可以檢視或編輯內容。",
  "experiment-recommend-trial-to-free.update-success-modal.modal-content-header": "選擇誰可以檢視",
  "experiment-recommend-trial-to-free.update-success-modal.modal-header": "您的內容已更新",
  "experiment-recommend-trial-to-free.update-success-modal.success-icon-label": "成功圖示",
  "experiment-recommend-trial-to-free.update-success-modal.x-button-label": "關閉強制回應",
  "experiment-share-new-whiteboard.flag-cta": "共用白板",
  "experiment-share-new-whiteboard.flag-description": "使用投票、計時器、整合等工具開始即時協作。",
  "experiment-share-new-whiteboard.flag-title": "與您的團隊分享此白板",
  "experiment-show-not-tell-feature-gates.cta.learnMore": "深入了解",
  "experiment-show-not-tell-feature-gates.cta.tryItNow": "立即試用",
  "experiment-show-not-tell-feature-gates.page-insights.body.admin": "開始 14 天免費試用，即可查看總檢視次數。此外，還可以獲得更多進階功能。",
  "experiment-show-not-tell-feature-gates.page-insights.body.notAdmin": "請連絡您的管理員，開始 14 天免費試用，以查看總檢視次數。",
  "experiment-show-not-tell-feature-gates.page-insights.exampleData": "範例資料",
  "experiment-show-not-tell-feature-gates.page-insights.ten": "10",
  "experiment-show-not-tell-feature-gates.page-insights.title": "免費試用深入解析",
  "experiment-show-not-tell-feature-gates.page-insights.twenty": "20",
  "experiment-show-not-tell-feature-gates.page-insights.uniqueViewers": "不重複的檢視者",
  "experiment-show-not-tell-feature-gates.page-insights.views": "檢視",
  "experiment-show-not-tell-feature-gates.page-restrictions.admin.body": "開始免費試用 14 天，以選擇誰可以檢視或編輯內容。此外，還可以獲得更多進階功能。",
  "experiment-show-not-tell-feature-gates.page-restrictions.admin.title": "免費試用內容存取控制",
  "experiment-show-not-tell-feature-gates.page-restrictions.cta.maybe-later": "稍後再說",
  "experiment-show-not-tell-feature-gates.page-restrictions.cta.upgrade": "升級",
  "experiment-show-not-tell-feature-gates.page-restrictions.grandfathered-page.admin.body": "此內容項目已繼承其父項目上設定的限制。開始免費試用 14 天以進行變更。",
  "experiment-show-not-tell-feature-gates.page-restrictions.grandfathered-page.not-admin.body": "此內容項目已繼承其父項目上設定的限制。若要變更，請要求您的管理員升級。",
  "experiment-show-not-tell-feature-gates.page-restrictions.grandfathered-page.title": "升級以重設內容限制",
  "experiment-show-not-tell-feature-gates.page-restrictions.not-admin.body": "請連絡您的管理員，開始免費試用 14 天，以選擇誰可以檢視或編輯內容。",
  "experiment-show-not-tell-feature-gates.public-sharable-link.body.admin.pages": "開始 14 天免費試用，與任何人分享唯讀頁面。此外，還能獲得更多功能。",
  "experiment-show-not-tell-feature-gates.public-sharable-link.body.admin.pages.livedocs": "開始免費試用 14 天，與任何人分享唯讀頁面和即時文件。此外，還能使用更多功能。",
  "experiment-show-not-tell-feature-gates.public-sharable-link.body.admin.whiteboard": "開始 14 天免費試用，與任何人分享唯讀白板。此外，還能獲得更多功能。",
  "experiment-show-not-tell-feature-gates.public-sharable-link.body.hoverTooltip": "升級以啟用此連結",
  "experiment-show-not-tell-feature-gates.public-sharable-link.body.notAdmin.pages": "請連絡您的管理員，開始 14 天免費試用，以便與任何人分享唯讀頁面。",
  "experiment-show-not-tell-feature-gates.public-sharable-link.body.notAdmin.pages.livedocs": "請連絡您的管理員，開始免費試用 14 天，以便與任何人分享唯讀頁面和即時文件。",
  "experiment-show-not-tell-feature-gates.public-sharable-link.body.notAdmin.whiteboard": "請連絡您的管理員，開始 14 天免費試用，以便與任何人分享唯讀白板。",
  "experiment-show-not-tell-feature-gates.public-sharable-link.body.toggleTooltip": "升級以啟用公開連結",
  "experiment-show-not-tell-feature-gates.public-sharable-link.title": "免費試用公開連結",
  "experiment-show-not-tell-feature-gates.select-audience-option-anyone-can-view": "任何人都可以檢視，但只有某些人可以編輯",
  "experiment-show-not-tell-feature-gates.select-audience-option-anyone-can-view-and-edit": "此空間中的任何人都可以檢視或編輯",
  "experiment-show-not-tell-feature-gates.select-audience-option-specific-can-view-or-edit": "只有特定人員可以檢視或編輯",
  "experiment-show-not-tell-feature-gates.select-audience-option-upgrade": "升級以獲取檢視和編輯選項",
  "experiment-show-not-tell-feature-gates.space-permissions-table.edit": "編輯",
  "experiment-show-not-tell-feature-gates.space-permissions-table.tooltip-upgrade-to-edit": "升級以編輯",
  "experiment-show-not-tell-feature-gates.space-permissions.body.admin": "開始免費試用 Standard 方案 14 天，以設定誰可以檢視、建立或刪除內容。此外，還可以獲得更多進階功能。",
  "experiment-show-not-tell-feature-gates.space-permissions.body.not-admin": "請連絡您的管理員，開始免費試用 Standard 方案 14 天，以設定誰可以檢視、建立或刪除內容。此外，還可以獲得更多進階功能。",
  "experiment-show-not-tell-feature-gates.space-permissions.default-space-permissions-body": "將此空間的權限授予群組的所有成員。",
  "experiment-show-not-tell-feature-gates.space-permissions.title": "免費試用空間權限",
  "experiment-space-tour.spaceGettingStartedTour.button.dismiss": "關閉",
  "experiment-space-tour.spaceGettingStartedTour.button.done": "確定",
  "experiment-space-tour.spaceGettingStartedTour.button.goBack": "返回",
  "experiment-space-tour.spaceGettingStartedTour.button.next": "下一步",
  "experiment-space-tour.spaceGettingStartedTour.button.takeTour": "進入導覽",
  "experiment-space-tour.spaceGettingStartedTour.createContent.description": "最後，使用「+」圖示來新增內容 — 將會保存在您所在的頁面下方。",
  "experiment-space-tour.spaceGettingStartedTour.createContent.header": "建立新內容",
  "experiment-space-tour.spaceGettingStartedTour.navigateSpace.description": "使用此選單即可切換空間、尋找您已標上星號的空間，或重新瀏覽最近的工作。",
  "experiment-space-tour.spaceGettingStartedTour.navigateSpace.header": "在不同空間之間瀏覽",
  "experiment-space-tour.spaceGettingStartedTour.spaceContent.description": "探索範例，以便開始使用。在區段之間拖放內容以重新整理。",
  "experiment-space-tour.spaceGettingStartedTour.spaceContent.header": "這就是內容的所在之處",
  "experiment-space-tour.spaceGettingStartedTour.welcomeSpace.description": "空間是頁面、部落格和其他內容的所在之處。",
  "experiment-space-tour.spaceGettingStartedTour.welcomeSpace.description.livedocs": "空間是頁面、即時文件、部落格和其他內容的所在之處。",
  "experiment-space-tour.spaceGettingStartedTour.welcomeSpace.header": "歡迎來到您的空間！",
  "export-space.disabled.section-message": "您的管理員已透過資料安全政策停用此功能。",
  "export-space.error.action": "重新整理",
  "export-space.error.title": "空間匯出選項無法載入",
  "external-collab-ui.add-comment-prompt-nudge-tooltip-for-external-collaborator": "透過留言分享意見反應，並開始與您的團隊合作。",
  "external-collab-ui.group-guest-lozenge": "訪客",
  "external-collab-ui.group-guest-lozenge.tooltip": "訪客群組只能存取特定空間，而且只能存取有限的使用者資訊。",
  "external-collab-ui.guest-features-list.1": "在沒有付費授權的情況下使用 Confluence (有限制)",
  "external-collab-ui.guest-features-list.2": "在單一空間中檢視、建立和編輯",
  "external-collab-ui.guest-features-list.3": "建立空間",
  "external-collab-ui.guest-features-list.4": "檢視其他人的個人檔案",
  "external-collab-ui.guest-features-list.5": "提及任何人",
  "external-collab-ui.guest-mention.learn-more-button": "深入了解",
  "external-collab-ui.guest-mention.restricted.flag.description": "若要提及他人，您需要具有 Confluence 的完整存取權。",
  "external-collab-ui.guest-mention.restricted.flag.title": "您無法以訪客的身分提及他人",
  "external-collab-ui.guest-onboarding-modal.footer": "<b>附註：</b>您的管理員可能會進一步限制您在這些預設設定中的功能。",
  "external-collab-ui.guest-onboarding-modal.img-alt-text": "讓訪客開始使用功能",
  "external-collab-ui.guest-onboarding-modal.learn-more": "深入了解",
  "external-collab-ui.guest-onboarding-modal.ok-button": "確定",
  "external-collab-ui.guest-onboarding-modal.subtitle": "有些 Confluence 功能不適用於訪客。依預設，您可以：",
  "external-collab-ui.guest-onboarding-modal.title": "Confluence 訪客，歡迎您！",
  "external-collab-ui.guest-profile-banner.message": "您在此 Confluence 網站上的身分為訪客。",
  "external-collab-ui.guest-request-space-access.description": "您的團隊仍需要 Confluence 管理員核准存取權，您才能協同合作。存取權獲得核准後，您會收到電子郵件。我們已通知管理員您正在等候核准。",
  "external-collab-ui.guest-request-space-access.title": "即將完成！",
  "external-collab-ui.guest-request-to-upgrade-flag.error-description": "重新整理以再次提交要求，或稍後再試一次。",
  "external-collab-ui.guest-request-to-upgrade-flag.error-title": "未傳送要求",
  "external-collab-ui.guest-request-to-upgrade-flag.learn-more-button": "深入了解",
  "external-collab-ui.guest-request-to-upgrade-flag.request-sent-description": "核准之後，您會收到管理員的確認電子郵件。",
  "external-collab-ui.guest-request-to-upgrade-flag.request-sent-title": "已傳送要求",
  "external-collab-ui.guest-request-to-upgrade-learn-more-modal-copy": "您是這個 Confluence 網站上的訪客。要求取得授權使用者的存取權以解鎖新功能，管理員會審核您的要求。",
  "external-collab-ui.guest-request-to-upgrade-learn-more-modal-copy-spaces-menu": "由於您是訪客，您對此 Confluence 網站的存取權設有限制，但可以要求取得完整的存取權，以解鎖新的協作方式。",
  "external-collab-ui.guest-request-to-upgrade-learn-more-modal-footer-secondary-button": "稍後再說",
  "external-collab-ui.guest-request-to-upgrade-learn-more-modal-footer-secondary-button-when-primary-disabled": "關閉",
  "external-collab-ui.guest-request-to-upgrade-learn-more-modal-guest-card-benefit-row-one": "在此空間中檢視、建立和編輯",
  "external-collab-ui.guest-request-to-upgrade-learn-more-modal-guest-card-benefit-row-two": "在此空間中留言",
  "external-collab-ui.guest-request-to-upgrade-learn-more-modal-guest-card-copy": "您的管理員可能會進一步限制您在這些預設設定中的功能。",
  "external-collab-ui.guest-request-to-upgrade-learn-more-modal-guest-card-copy-spaces-menu": "您的存取權僅限於執行以下操作：",
  "external-collab-ui.guest-request-to-upgrade-learn-more-modal-guest-card-title": "訪客",
  "external-collab-ui.guest-request-to-upgrade-learn-more-modal-guest-card-title-lozenge": "您",
  "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-benefit-row-five": "建立並加入團隊",
  "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-benefit-row-four": "提及其他人",
  "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-benefit-row-one": "建立您自己的空間",
  "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-benefit-row-three": "查看其他人的個人檔案",
  "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-benefit-row-two": "在其他空間中檢視和協同合作",
  "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-copy": "訪客身分的所有項目，外加：",
  "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-copy-spaces-menu": "解鎖以下操作：",
  "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-title": "授權使用者",
  "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-title-spaces-menu": "完整存取權",
  "external-collab-ui.guest-request-to-upgrade-learn-more-modal-title": "要求取得授權使用者的存取權，以加入團隊成員的行列",
  "external-collab-ui.guest-request-to-upgrade-learn-more-modal-title-spaces-menu": "要求完整的存取權",
  "external-collab-ui.guest-request-to-upgrade-page-tree.body": "您是本網站的訪客，存取權受到限制。",
  "external-collab-ui.guest-request-to-upgrade-page-tree.pending-body": "您是本網站的訪客。",
  "external-collab-ui.guest-request-to-upgrade-page-tree.request-to-upgrade-button": "要求完整的存取權",
  "external-collab-ui.guest-request-to-upgrade-page-tree.request-to-upgrade-pending-button": "要求待核准",
  "external-collab-ui.guest-request-to-upgrade-spaces-menu.heading": "解鎖更多空間",
  "external-collab-ui.guest-request-to-upgrade-spaces-mneu.body": "要求此 Confluence 網站的完整存取權，以便在多個空間中與您的團隊協作。{learnmorelink}",
  "external-collab-ui.guest-request-to-upgrade.body": "您目前是此 Confluence 網站的訪客。成為授權使用者即可使用更多功能。",
  "external-collab-ui.guest-request-to-upgrade.flag-error-description": "重新整理以再次提交要求，或稍後再試一次。",
  "external-collab-ui.guest-request-to-upgrade.flag-error-title": "未傳送要求",
  "external-collab-ui.guest-request-to-upgrade.flag-success-description": "如果要求經過核准，管理員會傳送確認訊息給您",
  "external-collab-ui.guest-request-to-upgrade.flag-success-title": "已傳送授權使用者要求！",
  "external-collab-ui.guest-request-to-upgrade.heading": "要求存取權以加入團隊成員的行列",
  "external-collab-ui.guest-request-to-upgrade.learn-more-button": "深入了解",
  "external-collab-ui.guest-request-to-upgrade.upgrade-request-note": "這位訪客已要求 Confluence 授權",
  "external-collab-ui.guests-info-banner-space-perms.close-banner": "關閉",
  "external-collab-ui.guests-info-banner-space-perms.description": "訪客是組織外部的承包商、顧問和其他協作者。因為是訪客，所以僅限於存取一個空間、會清楚標示為訪客，且對於使用者資訊的存取權會受到限制。",
  "external-collab-ui.guests-info-banner-space-perms.guests-doc-cta": "深入了解",
  "external-collab-ui.guests-info-banner-space-perms.guests-section-cta": "將訪客新增至此空間",
  "external-collab-ui.guests-info-banner-space-perms.title": "與訪客在外部進行協作",
  "external-collab-ui.learn-more": "深入了解",
  "external-collab-ui.satisfaction-survey.button.cancel": "取消",
  "external-collab-ui.satisfaction-survey.button.submit": "提交",
  "external-collab-ui.satisfaction-survey.checkbox.can-contact": "Atlassian 可以連絡我來了解此意見反應",
  "external-collab-ui.satisfaction-survey.description": "您的訪客使用體驗如何？",
  "external-collab-ui.satisfaction-survey.final.description": "感謝您協助我們改善 Confluence！",
  "external-collab-ui.satisfaction-survey.final.title": "已提交意見反應",
  "external-collab-ui.satisfaction-survey.question.bad": "我們很遺憾得知這個消息。 您不滿意的項目為何？有任何讓您喜歡的地方嗎？(選擇性)",
  "external-collab-ui.satisfaction-survey.question.good": "太棒了！您喜歡其中哪一個部分？有什麼可以改進的嗎？(選擇性)",
  "external-collab-ui.satisfaction-survey.question.okay": "您是否能再提供多一點資訊？您喜歡其中哪一個部分？有什麼可以改進的嗎？(選擇性)",
  "external-collab-ui.satisfaction-survey.reaction.amazing": "非常好",
  "external-collab-ui.satisfaction-survey.reaction.bad": "不佳",
  "external-collab-ui.satisfaction-survey.reaction.great": "很好",
  "external-collab-ui.satisfaction-survey.reaction.okay": "普通",
  "external-collab-ui.satisfaction-survey.reaction.terrible": "很糟糕",
  "external-collab-ui.satisfaction-survey.title": "告訴我們您的想法",
  "external-collab-ui.space-guest-count-lozenge": "{guestCount, plural, other {有 {guestCount,number} 位訪客}}",
  "external-collab-ui.space-guest-lozenge.tooltip": "此空間與可能屬於組織外部的訪客共用。",
  "external-collab-ui.user-guest-lozenge": "訪客",
  "external-collab-ui.user-guest-lozenge.tooltip": "訪客只能存取特定空間，而且使用者資訊的存取方式有所限制。",
  "external-share.join.button": "加入您的團隊",
  "external-share.learn-more-lozenge.title": "提供技術支援的一方：",
  "external-share.learn-more.button": "深入了解",
  "external-share.log-in-to-confluence.button": "登入",
  "external-share.not-found.description": "我們已盡可能嘗試尋找，但是這個公開連結不存在，或已不再設為公開。",
  "external-share.not-found.title": "我們找不到公開連結",
  "external-share.page.error.title": "無法載入內容",
  "external-share.powered-by-confluence.learn-more-modal.background-image-alt-tag": "背景",
  "external-share.powered-by-confluence.learn-more-modal.benefit-five": "白板",
  "external-share.powered-by-confluence.learn-more-modal.benefit-four": "超過 75 個最佳做法範本",
  "external-share.powered-by-confluence.learn-more-modal.benefit-one": "最多可供 10 位使用者免費使用",
  "external-share.powered-by-confluence.learn-more-modal.benefit-six": "Atlassian Intelligence",
  "external-share.powered-by-confluence.learn-more-modal.benefit-three": "即時協作",
  "external-share.powered-by-confluence.learn-more-modal.benefit-two": "無需信用卡",
  "external-share.powered-by-confluence.learn-more-modal.close-button-label": "關閉強制回應",
  "external-share.powered-by-confluence.learn-more-modal.logo-tagline": "提供技術支援的一方：",
  "external-share.redacted.macro.anonymous": "您沒有查看此內容的存取權",
  "external-share.redacted.macro.confluence-user": "<redirectLink>在 Confluence 中開啟</redirectLink>以查看此內容。",
  "external-share.redacted.macro.org-member": "<redirectLink>加入 Confluence</redirectLink> 以查看此內容。",
  "external-share.redirect.button": "在 Confluence 中開啟",
  "external-share.try-confluence.button": "免費試用 Confluence",
  "external-share.try-confluence.button.shortened": "免費試用",
  "fabric-extension-handlers.inline-extension.valid-anchor-macro.icon.label": "錨點連結",
  "fabric-extension-handlers.inline-image.imageFailed": "影像無法載入",
  "fabric-extension-handlers.inline-image.openLink": "在新分頁中開啟連結",
  "fabric-extension-handlers.invalid-extension.combination.cannot.be.edited.in.new.editor": "轉換頁面時，您不會遺失任何內容，但看起來會像這樣，因為這個組合無法在新的編輯器中編輯。",
  "fabric-extension-handlers.invalid-extension.unsupported.content.editor": "無法在新編輯器中編輯此元素",
  "fabric-extension-handlers.invalid-extension.unsupported.content.view": "此元素有轉換問題",
  "fabric-extension-handlers.invalid-extension.unsupported.macro.title": "不支援的巨集",
  "fabric-extension-handlers.unmodifiable.macro.dialog.body": "此巨集已新增至從舊版編輯器轉換的頁面中。此巨集無法編輯，因為與<alink>目前的編輯器</alink>不相容。",
  "fabric-extension-handlers.unmodifiable.macro.dialog.close": "關閉",
  "fabric-extension-handlers.unmodifiable.macro.dialog.learn.more": "深入了解",
  "fabric-extension-handlers.unmodifiable.macro.dialog.title": "無法編輯此巨集",
  "fabric-extension-legacy-macro-renderer.legacy-macro-renderer-query.highlightedPageIncludeError": "無法呈現 {include}",
  "fabric-extension-legacy-macro-renderer.legacy-macro-renderer-query.nonhighlightedPageIncludeRenderedError": "已包含頁面「{pageTitle}」，正在停止。",
  "fabric-extension-legacy-macro-renderer.legacymacrorenderer.error": "無法取得巨集詳細資料",
  "fabric-extension-lib.anchor.config-panel.name-field.description": "為這個錨點連結提供一個不重複的名稱，以便參照。",
  "fabric-extension-lib.anchor.config-panel.name-field.label": "名稱",
  "fabric-extension-lib.anchor.description": "建立任何位置的連結",
  "fabric-extension-lib.anchor.placeholder.icon-label": "無效的錨點連結",
  "fabric-extension-lib.anchor.title": "錨點連結",
  "fabric-extension-lib.children.field.all.label": "顯示所有層級",
  "fabric-extension-lib.children.field.allChildren.label": "顯示所有子系項目",
  "fabric-extension-lib.children.field.depth.item.eight": "8 個層級",
  "fabric-extension-lib.children.field.depth.item.five": "5 個層級",
  "fabric-extension-lib.children.field.depth.item.four": "4 個層級",
  "fabric-extension-lib.children.field.depth.item.nine": "9 個層級",
  "fabric-extension-lib.children.field.depth.item.one": "1 個層級",
  "fabric-extension-lib.children.field.depth.item.seven": "7 個層級",
  "fabric-extension-lib.children.field.depth.item.six": "6 個層級",
  "fabric-extension-lib.children.field.depth.item.three": "3 個層級",
  "fabric-extension-lib.children.field.depth.item.two": "2 個層級",
  "fabric-extension-lib.children.field.depth.label": "層級數量上限",
  "fabric-extension-lib.children.field.excerptType.description": "列表可以顯示子系項目頂部或其摘錄內容的預覽。",
  "fabric-extension-lib.children.field.excerptType.item.none": "無",
  "fabric-extension-lib.children.field.excerptType.item.richContent": "預覽內容",
  "fabric-extension-lib.children.field.excerptType.item.simple": "摘錄預覽",
  "fabric-extension-lib.children.field.excerptType.label": "顯示預覽",
  "fabric-extension-lib.children.field.first.label": "列表中的數量上限",
  "fabric-extension-lib.children.field.page.label": "父系項目",
  "fabric-extension-lib.children.field.page.placeholder": "目前",
  "fabric-extension-lib.children.field.sort.group.creation": "已建立",
  "fabric-extension-lib.children.field.sort.group.default": "內容樹狀結構",
  "fabric-extension-lib.children.field.sort.group.modified": "已修改",
  "fabric-extension-lib.children.field.sort.group.title": "標題",
  "fabric-extension-lib.children.field.sort.item.creation": "最新 → 最舊",
  "fabric-extension-lib.children.field.sort.item.creationreverse": "最舊 → 最新",
  "fabric-extension-lib.children.field.sort.item.default": "目前",
  "fabric-extension-lib.children.field.sort.item.defaultreverse": "反向",
  "fabric-extension-lib.children.field.sort.item.modified": "舊 → 最近",
  "fabric-extension-lib.children.field.sort.item.modifiednreverse": "最近 → 舊",
  "fabric-extension-lib.children.field.sort.item.title": "A → Z",
  "fabric-extension-lib.children.field.sort.item.titlereverse": "Z → A",
  "fabric-extension-lib.children.field.sort.label": "排序順序",
  "fabric-extension-lib.children.field.style.item.default": "已加上項目符號",
  "fabric-extension-lib.children.field.style.item.h1": "H1",
  "fabric-extension-lib.children.field.style.item.h2": "H2",
  "fabric-extension-lib.children.field.style.item.h3": "H3",
  "fabric-extension-lib.children.field.style.item.h4": "H4",
  "fabric-extension-lib.children.field.style.item.h5": "H5",
  "fabric-extension-lib.children.field.style.item.h6": "H6",
  "fabric-extension-lib.children.field.style.label": "列表樣式",
  "fabric-extension-lib.children.live-docs.description": "顯示在頁面或即時文件下建立巢狀的自訂內容列表。",
  "fabric-extension-lib.children.live-docs.title": "子系項目 (子系頁面)",
  "fabric-extension-lib.config.tab.basic.label": "基本",
  "fabric-extension-lib.config.tab.display.label": "顯示",
  "fabric-extension-lib.content.properties.placeholder.livedocs": "新增具有鍵/值配對的表格，以使用內容屬性報告巨集，在其他頁面或文件上顯示其資料。",
  "fabric-extension-lib.deprecation.description": "此巨集已被淘汰。<alink>進一步了解這項變更</alink>",
  "fabric-extension-lib.details-summary.live-docs.description": "顯示頁面與即時文件 (包含內容屬性巨集和特定標籤) 的表格。此表格包含每個項目的連結，以及該頁面或文件上巨集的摘要。",
  "fabric-extension-lib.details-summary.live-docs.title": "內容屬性報告 (頁面屬性報告)",
  "fabric-extension-lib.details.live-docs.description": "在此巨集中輸入摘要資訊表格，並使用內容屬性報告巨集將其顯示在其他頁面或即時文件上。您需要將標籤新增至此內容，並在報告巨集中指定該標籤。",
  "fabric-extension-lib.details.live-docs.title": "內容屬性 (頁面屬性)",
  "fabric-extension-lib.excerpt.placeholder": "在此輸入或貼上內容，以轉換成摘錄。",
  "fabric-extension-lib.field-mappings.details.field.hidden.description": "在檢視畫面中隱藏巨集內容，但繼續在「內容屬性報告」巨集中顯示這些內容。",
  "fabric-extension-lib.field-mappings.details.field.hidden.label": "在檢視畫面中隱藏",
  "fabric-extension-lib.field-mappings.details.field.id.description": "如果您在此頁面或文件上有多個內容屬性巨集，而且想要分開報告這些巨集，請指定 ID。",
  "fabric-extension-lib.field-mappings.details.field.id.label": "內容屬性 ID (選填)",
  "fabric-extension-lib.field-mappings.include.field.contentInclude.label": "要包含的內容",
  "fabric-extension-lib.field-mappings.pagetree.field.excerpt.label": "在內容樹狀結構中包含摘錄",
  "fabric-extension-lib.field-mappings.pagetree.field.expandCollapseAll.description": "在內容樹狀結構頂端顯示「全部展開」和「全部摺疊」連結。",
  "fabric-extension-lib.field-mappings.pagetree.field.expandCollapseAll.label": "顯示展開/摺疊連結",
  "fabric-extension-lib.field-mappings.pagetree.field.reverse.description": "僅搭配「內容排序依據」欄位使用。",
  "fabric-extension-lib.field-mappings.pagetree.field.reverse.label": "反向排序",
  "fabric-extension-lib.field-mappings.pagetree.field.root.label": "根內容",
  "fabric-extension-lib.field-mappings.pagetree.field.searchBox.label": "在內容樹狀結構上方包含搜尋方塊",
  "fabric-extension-lib.field-mappings.pagetree.field.sort.label": "內容排序依據",
  "fabric-extension-lib.field-mappings.pagetree.field.spaces.label": "受限於此空間索引鍵",
  "fabric-extension-lib.field-mappings.pagetree.field.startDepth.description": "顯示的子系項目層級數。",
  "fabric-extension-lib.field-mappings.pagetree.field.startDepth.label": "樹狀結構深度",
  "fabric-extension-lib.five": "5",
  "fabric-extension-lib.four": "4",
  "fabric-extension-lib.include.live-docs.description": "顯示頁面或即時文件的完整內容。",
  "fabric-extension-lib.include.live-docs.title": "包含內容 (包含頁面)",
  "fabric-extension-lib.one": "1",
  "fabric-extension-lib.page.properties.placeholder": "新增具有鍵/值配對的表格，以使用「頁面屬性報告」巨集，在其他頁面上顯示其資料。",
  "fabric-extension-lib.page.properties.placeholder.livedocs": "新增具有鍵/值配對的表格，以使用「頁面屬性報告」巨集，在其他頁面或文件上顯示其資料。",
  "fabric-extension-lib.pagetree.live-docs.description": "顯示完整或部分的內容樹狀結構。",
  "fabric-extension-lib.pagetree.live-docs.title": "內容樹狀結構 (頁面樹)",
  "fabric-extension-lib.recently-updated.field.author.label": "依使用者篩選",
  "fabric-extension-lib.recently-updated.field.author.placeholder": "搜尋並選取使用者",
  "fabric-extension-lib.recently-updated.field.hideHeading.label": "隱藏列表標頭",
  "fabric-extension-lib.recently-updated.field.labels.label": "依標籤篩選",
  "fabric-extension-lib.recently-updated.field.labels.placeholder": "搜尋並選取標籤",
  "fabric-extension-lib.recently-updated.field.max.label": "更新數量上限",
  "fabric-extension-lib.recently-updated.field.maxToggle.label": "顯示所有更新",
  "fabric-extension-lib.recently-updated.field.spaces.label": "空間",
  "fabric-extension-lib.recently-updated.field.spaces.placeholder": "按名稱搜尋和選取",
  "fabric-extension-lib.recently-updated.field.theme.item.concise": "標題 + 使用者名稱",
  "fabric-extension-lib.recently-updated.field.theme.item.full": "100% 的框架",
  "fabric-extension-lib.recently-updated.field.theme.item.half": "50％ 的框架",
  "fabric-extension-lib.recently-updated.field.theme.item.quarter": "25% 的框架",
  "fabric-extension-lib.recently-updated.field.theme.item.sidebar": "標題",
  "fabric-extension-lib.recently-updated.field.theme.item.social": "使用者名稱 + 個人檔案圖片",
  "fabric-extension-lib.recently-updated.field.theme.item.threeQuarters": "75% 的框架",
  "fabric-extension-lib.recently-updated.field.theme.label": "列表樣式",
  "fabric-extension-lib.recently-updated.field.types.item.all": "全部",
  "fabric-extension-lib.recently-updated.field.types.item.attachment": "附件",
  "fabric-extension-lib.recently-updated.field.types.item.blogpost": "部落格貼文",
  "fabric-extension-lib.recently-updated.field.types.item.comment": "留言",
  "fabric-extension-lib.recently-updated.field.types.item.live-page": "即時文件",
  "fabric-extension-lib.recently-updated.field.types.item.page": "頁面",
  "fabric-extension-lib.recently-updated.field.types.label": "包含在列表中",
  "fabric-extension-lib.recently-updated.field.types.placeholder": "選取一個以上",
  "fabric-extension-lib.recently-updated.field.width.label": "列表寬度",
  "fabric-extension-lib.recently-updated.field.width.placeholder": "選取或輸入寬度",
  "fabric-extension-lib.recently-updated.tab.basic.label": "基本",
  "fabric-extension-lib.recently-updated.tab.display.label": "顯示",
  "fabric-extension-lib.six": "6",
  "fabric-extension-lib.three": "3",
  "fabric-extension-lib.toc.advanced-tab": "進階",
  "fabric-extension-lib.toc.basic-tab": "基本",
  "fabric-extension-lib.toc.brace-separator": "大括弧",
  "fabric-extension-lib.toc.bracket-separator": "括號",
  "fabric-extension-lib.toc.bullet-bullet-style": "項目符號",
  "fabric-extension-lib.toc.bullet-style": "項目符號樣式",
  "fabric-extension-lib.toc.circle-bullet-style": "圓圈",
  "fabric-extension-lib.toc.css-class-name.description": "輸入有效的 CSS 屬性以自訂此目錄周圍的 <code><div></code>",
  "fabric-extension-lib.toc.css-class-name.label": "CSS 類別名稱",
  "fabric-extension-lib.toc.custom-bullet-style": "自訂",
  "fabric-extension-lib.toc.description": "根據內容的標題建立目錄",
  "fabric-extension-lib.toc.displate-as": "顯示為",
  "fabric-extension-lib.toc.exclude-headings-with.label": "排除包含以下項目的標題：",
  "fabric-extension-lib.toc.exclude-pdf-export": "排除 PDF 匯出",
  "fabric-extension-lib.toc.headings-with.description": "輸入一或多個關鍵字，並以 | , 或任何規則運算式分隔",
  "fabric-extension-lib.toc.horizontal-list": "水平列表",
  "fabric-extension-lib.toc.include-heading-levels-from": "納入標題層級，從",
  "fabric-extension-lib.toc.include-heading-levels-to": "至",
  "fabric-extension-lib.toc.include-headings-with.label": "納入包含以下項目的標題：",
  "fabric-extension-lib.toc.include-section-numbers": "納入段落編號",
  "fabric-extension-lib.toc.indent-headings.description": "輸入有效的 CSS 單位值",
  "fabric-extension-lib.toc.indent-headings.label": "縮排標題",
  "fabric-extension-lib.toc.mixed-bullet-style": "混合",
  "fabric-extension-lib.toc.none-style": "無",
  "fabric-extension-lib.toc.number-bullet-style": "編號",
  "fabric-extension-lib.toc.pipe-separator": "豎線",
  "fabric-extension-lib.toc.placeholder": "此處會顯示目錄，以此內容中的標題為依據。",
  "fabric-extension-lib.toc.separate-sections": "分隔段落依據：",
  "fabric-extension-lib.toc.square-bullet-style": "正方形",
  "fabric-extension-lib.toc.title": "目錄",
  "fabric-extension-lib.toc.vertical-list": "垂直列表",
  "fabric-extension-lib.toc.zone.placeholder": "此處會顯示目錄，以此框架內的標題為依據。",
  "fabric-extension-lib.two": "2",
  "fabric-extension-manager-plugin.anchor.copy-link-button.label": "複製連結",
  "fabric-extension-manager-plugin.anchor.copy-link-button.tooltip": "複製錨點連結",
  "fabric-extension-manager-plugin.anchor.copy-link-button.tooltip.copied": "已複製！",
  "fabric-extension-manager-plugin.anchor.copy-link-button.tooltip.disabled": "編輯以建立連結",
  "fabric-media-support.attachment-size-limit-error.description": "附件必須小於或等於 {size}。",
  "fabric-media-support.attachment-size-limit-error.learn-more": "深入了解",
  "fabric-media-support.attachment-size-limit-error.title": "{fileName} 太大，無法上傳",
  "fabric-media-support.attachment-zero-byte-error.title": "{fileName} 空白 (零位元組)",
  "fabric-media-support.attachment-zero-byte.description": "附件大小必須至少為 1 個位元組",
  "fabric-media-support.mentions-provider.x-product-user-invite.success.description": "我們已傳送電子郵件給 <b>{name}</b>，確認您已將他們新增到 Confluence。",
  "fabric-media-support.mentions-provider.x-product-user-invite.success.title": "已成功新增",
  "fabric-media-support.tasklist.error.flag.description": "嘗試變更任務的狀態時發生錯誤。請稍後再試一次。",
  "fabric-media-support.tasklist.error.flag.title": "發生錯誤",
  "fabric-page-optin-migration.banner.message": "{displayName} 您好，您現在可以\n                                            將現有的頁面轉換為新的編輯經驗。\n                                            ",
  "fabric-page-optin-migration.content.not.eligible": "我們還無法轉換此頁面；一旦解決了這個問題，就可以轉換此頁面",
  "fabric-page-optin-migration.content.partially.supported": "新的編輯器不支援某些頁面元素",
  "fabric-page-optin-migration.content.preview.page": "預覽頁面",
  "fabric-page-optin-migration.eligible.footer.text": "此頁面可以轉換為新的編輯器",
  "fabric-page-optin-migration.eligible.migration.modal.bullet1.body": "包括即時巨集、Markdown 和快速插入。",
  "fabric-page-optin-migration.eligible.migration.modal.bullet1.title": "取得新功能的存取權",
  "fabric-page-optin-migration.eligible.migration.modal.bullet2.body": "轉換之前，使用預覽來查看頁面在新體驗中的外觀。",
  "fabric-page-optin-migration.eligible.migration.modal.bullet2.title": "先預覽您的頁面",
  "fabric-page-optin-migration.eligible.migration.modal.bullet3.body": "不喜歡顯示的內容嗎？您可以隨時透過<link>頁面歷程記錄</link>來復原變更。在頁面轉換期間，系統會建立一個版本 (但不會通知追蹤者)，以便您可以還原至最近的舊版本。",
  "fabric-page-optin-migration.eligible.migration.modal.bullet3.title": "隨時回復您的頁面",
  "fabric-page-optin-migration.eligible.migration.modal.button.cancel": "取消",
  "fabric-page-optin-migration.eligible.migration.modal.button.convert": "轉換頁面",
  "fabric-page-optin-migration.eligible.migration.modal.button.preview": "預覽",
  "fabric-page-optin-migration.eligible.migration.modal.dialog.title.full.eligibility": "此頁面可以轉換為新的編輯體驗。",
  "fabric-page-optin-migration.eligible.migration.modal.dialog.title.partial.eligibility": "您可將此頁面轉換為新的編輯體驗；不過，您可能會注意到些微變更。",
  "fabric-page-optin-migration.eligible.migration.modal.error.flag.message.contact": "連絡支援人員",
  "fabric-page-optin-migration.eligible.migration.modal.error.flag.message.description": "此頁面無法轉換為新的編輯體驗。",
  "fabric-page-optin-migration.eligible.migration.modal.error.flag.message.title": "此頁面無法轉換",
  "fabric-page-optin-migration.feedback.placeholder": "頁面預覽看起來不太對嗎？讓我們了解發生什麼問題，以便予以修正。",
  "fabric-page-optin-migration.footer.collab.editing": "協同編輯時無法轉換頁面",
  "fabric-page-optin-migration.ineligible.migration.modal.body": "<link>深入了解</link>新的編輯體驗中不支援的功能。",
  "fabric-page-optin-migration.ineligible.migration.modal.button.cancel": "取消",
  "fabric-page-optin-migration.ineligible.migration.modal.button.preview": "預覽",
  "fabric-page-optin-migration.ineligible.migration.modal.title": "按現狀轉換此頁面可能會{break}導致資料遺失。",
  "fabric-page-optin-migration.migration-modal.cancel-button": "稍後再說",
  "fabric-page-optin-migration.migration-modal.description": "選取<b>更新頁面</b>以獲取最新的編輯器體驗。",
  "fabric-page-optin-migration.migration-modal.title": "獲取最新的編輯體驗",
  "fabric-page-optin-migration.migration-modal.unsupported": "此頁面無法轉換",
  "fabric-page-optin-migration.migration-modal.update-button": "更新頁面",
  "fabric-page-optin-migration.modal.preview.page": "預覽頁面",
  "fabric-page-optin-migration.page.has.been.migrated.close.modal": "關閉",
  "fabric-page-optin-migration.page.has.been.migrated.continue.editing.this.page": "繼續編輯此頁面",
  "fabric-page-optin-migration.page.has.been.migrated.modal.body.edit.mode": "按一下下面的按鈕，從您離開的位置繼續執行。別擔心，我們已儲存您所有的工作。",
  "fabric-page-optin-migration.page.has.been.migrated.modal.body.learn.more": "按一下 {here} 以進一步了解新的編輯體驗。",
  "fabric-page-optin-migration.page.has.been.migrated.modal.body.view.mode": "若要獲得全新的編輯體驗，請按一下下方的重新整理按鈕",
  "fabric-page-optin-migration.page.has.been.migrated.refresh.page": "重新整理頁面",
  "fabric-page-optin-migration.page.has.been.migrated.to.fabric": "此頁面已轉換為新的編輯體驗",
  "fabric-page-optin-migration.preview.cancel": "取消",
  "fabric-page-optin-migration.preview.convert.page": "轉換頁面",
  "fabric-page-optin-migration.preview.give.feedback": "提供意見反應",
  "fabric.editor.page.removed.description": "請立即重新整理。",
  "fabric.editor.page.removed.title": "此頁面最近已封存或刪除",
  "fabric.editor.permission.removed.description": "已變更此頁面的權限。請連絡管理員以取得協助。",
  "fabric.editor.permission.removed.title": "我們無法顯示此頁面",
  "favourite-button.content.star.label": "標上星號",
  "favourite-button.content.unstar.label": "移除星號",
  "feed.card.activity.error.generic.message": "我們無法載入最近的動作",
  "feed.card.anonymousUser": "匿名使用者",
  "feed.card.byline.createdBy": "建立者為 {name}",
  "feed.card.byline.ownedBy": "負責人：{name}",
  "feed.card.byline.profile": "個人檔案",
  "feed.card.byline.space": "空間",
  "feed.card.categories.following": "追蹤項目",
  "feed.card.categories.popular": "熱門",
  "feed.card.comment.showMore": "顯示更多",
  "feed.card.comment.viewComment": "檢視留言",
  "feed.card.comments.label": "留言",
  "feed.card.editAction": "{num, plural, other {已編輯 {num} 次}}",
  "feed.card.otherActions": "{num, plural, other {{num} 個最近的動作}}",
  "feed.card.otherActionsWithoutNumber": "最近的動作",
  "feed.card.publishAction": "已發佈",
  "feed.card.star.general": "標上星號",
  "feed.card.star.mutation.error.description": "請再試一次。",
  "feed.card.star.mutation.error.title": "我們在為該項目標上星號時遇到問題",
  "feed.card.unknownAction": "未知的更新",
  "feed.card.unstar.general": "移除星號",
  "feed.card.unstar.mutation.error.title": "我們在移除該項目的星號時遇到問題",
  "feed.card.unwatch": "取消追蹤",
  "feed.card.updateAction": "{num, plural, other {已更新 {num} 次}}",
  "feed.card.watch": "追蹤",
  "feed.comment.collapse": "隱藏留言",
  "feed.comment.count": "{numComments, plural, other {{numComments,number} 則留言}}",
  "feed.comment.expand": "顯示留言",
  "feed.end-of-feed-home-banner.farewell": "在 Home 應用程式中查看還有誰即將從 Atlassian 離職",
  "feed.end-of-feed-home-banner.farewell-link": "檢視所有離職",
  "feed.end-of-feed-home-banner.popular": "在 Home 應用程式中探索 Confluence、Loom 之內的熱門內容等等",
  "feed.end-of-feed-home-banner.popular-link": "檢視所有熱門內容",
  "feed.end-of-feed-home-banner.welcome": "在 Home 應用程式中查看還有誰是 Atlassian 的新成員",
  "feed.end-of-feed-home-banner.welcome-link": "檢視所有迎新",
  "feed.end-of-feed.button.text": "編輯摘要",
  "feed.end-of-feed.description": "請稍後回來查看或重新調整您的摘要，以取得更多更新",
  "feed.end-of-feed.header": "沒有其他活動",
  "feed.error.generic.button.text": "重新整理",
  "feed.error.generic.description": "請重新整理以再試一次。",
  "feed.error.generic.header": "我們無法載入此摘要",
  "feed.error.pagination.button.text": "再試一次",
  "feed.error.pagination.header": "我們無法載入更多內容",
  "feed.exit-feed-button": "退出摘要",
  "feed.fallback.manage.following": "編輯摘要",
  "feed.fallback.message": "若要查看專屬活動，請追蹤人員和空間以編輯您的摘要。",
  "feed.farewell-label": "離別",
  "feed.header.closeLabel": "關閉訊息方塊",
  "feed.header.description": "追蹤人員和空間來掌握情況。他們的活動會顯示在您的摘要中，但您不會收到有關該活動的電子郵件通知。隨時新增或編輯您的摘要。",
  "feed.header.editFeed": "編輯摘要",
  "feed.header.learnMore": "深入了解",
  "feed.header.manage.following": "編輯摘要",
  "feed.header.sortBy.following.recent": "排序方式：上次活動",
  "feed.header.sortBy.following.relevant": "排序方式：最相關",
  "feed.header.title": "我們會讓您取得最新消息",
  "feed.popular.day": "今天",
  "feed.popular.dropdown.prefix.day": "熱門：今天",
  "feed.popular.dropdown.prefix.month": "熱門：過去 30 天",
  "feed.popular.dropdown.prefix.twoWeeks": "熱門：過去 14 天",
  "feed.popular.dropdown.prefix.week": "熱門：過去 7 天",
  "feed.popular.dropdown.prefix.year": "熱門：過去一年",
  "feed.popular.header.closeLabel": "關閉訊息方塊",
  "feed.popular.header.description": "目前這裡似乎沒有熱門內容。熱門內容是由檢視次數和參與度所決定，因此請稍後返回查看，或透過留言和回應參與內容，以將合適的內容提升至頂端。",
  "feed.popular.header.title": "還沒有熱門的內容。🚀",
  "feed.popular.month": "過去 30 天",
  "feed.popular.twoWeeks": "過去 14 天",
  "feed.popular.week": "過去 7 天",
  "feed.popular.year": "過去一年",
  "feed.recommendation.dismiss": "隱藏建議",
  "feed.recommendation.dismiss.description": "一個月內不要顯示此卡片",
  "feed.recommendation.flag.dismiss.error": "無法關閉建議",
  "feed.recommendation.flag.dismiss.error.description": "請稍後再試一次",
  "feed.recommendation.flag.follow.action": "關閉",
  "feed.recommendation.flag.follow.error": "無法追蹤 {name}",
  "feed.recommendation.flag.follow.error.description": "請稍後再試一次",
  "feed.recommendation.flag.follow.success": "已追蹤 {name}",
  "feed.recommendation.tile.dismiss.label": "關閉 {name} 的建議",
  "feed.recommendation.tile.follow": "追蹤",
  "feed.recommendation.tile.follow.label": "追蹤 {name}",
  "feed.recommendation.tile.profile": "{name} 設定檔",
  "feed.recommendation.tile.space": "空間",
  "feed.recommendation.title": "改善您的摘要",
  "feed.recommendations.carousel.left": "向左捲動",
  "feed.recommendations.carousel.right": "向右捲動",
  "feed.recommendations.more.label": "顯示更多選項",
  "feed.title": "了解正在進行的事項",
  "feed.welcome-label": "歡迎",
  "feed.whatsNew-label": "Confluence 中的新功能",
  "folder-conversion.convert-page-to-folder.banner.close": "關閉",
  "folder-conversion.convert-page-to-folder.banner.message": "將父系項目轉換為資料夾，以簡化您的空間。<link>顯示方法</link>",
  "folder-conversion.convert-page-to-folder.dialog.cancel": "取消",
  "folder-conversion.convert-page-to-folder.dialog.description": "我們會封存原始頁面，因此您無須擔心會丟失工作。",
  "folder-conversion.convert-page-to-folder.dialog.header": "要將此頁面轉換為資料夾嗎？",
  "folder-conversion.convert-page-to-folder.dialog.submit": "轉換",
  "folder-conversion.convert-page-to-folder.flags.error-message.action": "再試一次",
  "folder-conversion.convert-page-to-folder.flags.error-message.description.placeholder-title": "發生錯誤，我們無法將此頁面轉換為資料夾。",
  "folder-conversion.convert-page-to-folder.flags.error-message.edit-permissions.description": "如果要將此頁面轉換為資料夾，您需要具有編輯和封存該頁面的權限。",
  "folder-conversion.convert-page-to-folder.flags.error-message.edit-permissions.title": "要求編輯和封存存取權以繼續",
  "folder-conversion.convert-page-to-folder.flags.error-message.name-collision.description": "為了避免標題重複，您需要重新命名此頁面，然後才能將其轉換為資料夾並封存原始內容。",
  "folder-conversion.convert-page-to-folder.flags.error-message.name-collision.title": "重新命名此頁面以繼續",
  "folder-conversion.convert-page-to-folder.flags.error-message.name-length-limit.description": "{numCharsOverLimit, plural, other {在我們將此頁面轉換為資料夾之前 (封存原始頁面)，您需要提供標題，其字元數必須至少減少 {numCharsOverLimit,number} 個。}}",
  "folder-conversion.convert-page-to-folder.flags.error-message.name-length-limit.title": "為此頁面提供更短的標題",
  "folder-conversion.convert-page-to-folder.flags.error-message.title": "我們無法將頁面轉換為資料夾",
  "folder-conversion.convert-page-to-folder.flags.success-message.description.placeholder-title": "我們已將頁面轉換為資料夾。",
  "folder-conversion.convert-page-to-folder.flags.success-message.title": "轉換完成",
  "folder-onboarding.convert-to-folder.spotlight.body": "選取<strong>轉換為資料夾</strong>，將此父頁面轉換為簡單的容器。進一步了解<a>父頁面和資料夾之間的差異</a>。",
  "folder-onboarding.convert-to-folder.spotlight.dismiss-button": "關閉",
  "folder-onboarding.create.content.spotlight.body": "建立資料夾以將結構新增至空間，並在內容樹狀結構中，將相關的工作整理在一起。",
  "folder-onboarding.create.content.spotlight.dismiss-button": "關閉",
  "folder.empty.description": "您有許多項目，但「{folderTitle}」是空的。請將游標暫留在內容樹中的資料夾上，然後點選 <b>+</b> 以在其中建立內容項目。",
  "folder.empty.image.alt": "空白資料夾的插圖",
  "folder.empty.title": "這裡還沒有任何內容可以顯示",
  "forge-ui.components.custom-content-page-list-view.errorBody": "請稍後再試一次。",
  "forge-ui.components.custom-content-page-list-view.errorTitle": "發生錯誤。",
  "forge-ui.components.custom-content-space-list-view.errorBody": "請稍後再試一次。",
  "forge-ui.components.custom-content-space-list-view.errorTitle": "發生錯誤。",
  "forge-ui.components.restricted-page.errorBodyWithTitle": "您的管理員已透過資料安全政策在此空間中封鎖 <b>{appName}</b>。{br}{br}如有任何問題，請聯繫您的組織管理員。",
  "forge-ui.components.restricted-page.errorBodyWithoutTitle": "您的管理員已透過資料安全政策，在此空間中封鎖<b>此應用程式</b>。{br}{br}如有任何問題，請聯繫您的組織管理員。",
  "forge-ui.components.restricted-page.errorTitle": "管理員已封鎖此應用程式",
  "forge-ui.components.restricted-page.goHomeLink": "前往首頁",
  "forge-ui.custom.content.extension.point.error.message.description": "請連絡網站管理員以安裝應用程式。",
  "forge-ui.custom.content.extension.point.error.message.title": "無法使用登錄 ''{contentType}' 自訂內容的應用程式。",
  "forge-ui.global.page.extension.point.error.message.description": "請連絡網站管理員以安裝應用程式。",
  "forge-ui.global.page.extension.point.error.message.title": "無法使用應用程式",
  "forge-ui.global.settings.breadcrumbs.manage-apps": "管理應用程式",
  "forge-ui.global.settings.breadcrumbs.settings": "設定",
  "forge-ui.space.page.extension.point.error.message.description": "請連絡網站管理員以安裝應用程式。",
  "forge-ui.space.page.extension.point.error.message.title": "無法使用應用程式",
  "full-page-editor.content.placeholder.empty.doc": "輸入 / 以插入元素",
  "full-page-editor.navigation-lockout-message": "剛才所做的變更可能無法儲存。",
  "full-page-editor.permissions.blogpost-access": "此部落格的預設存取權現已生效。",
  "full-page-editor.place.holder.bracket.hint": "任何元素均可藉由輸入 / 快速插入",
  "full-page-editor.unsupported-macro.fallback-flag.action": "深入了解此搶先體驗方案",
  "full-page-editor.unsupported-macro.fallback-flag.description": "若要完全顯示和使用此元素，請透過工具列上的 <menuIcon></menuIcon> 選單發布您的頁面。",
  "full-page-editor.unsupported-macro.fallback-flag.live-page.description": "編輯即時文件時不會顯示此元素的結果。請將此文件轉換為頁面，並透過 <menuIcon></menuIcon> 選單發布以完整顯示。",
  "full-page-editor.unsupported-macro.fallback-flag.title": "此元素可能需要您發布",
  "global-feedback-collector.can-contact.label": "Atlassian 可以連絡我來了解此意見反應。請參閱我們的{privacyPolicyLink}。",
  "global-feedback-collector.can-contact.label.new": "是，Atlassian 可以連絡我來了解此意見反應。請參閱我們的<privacyLink>隱私政策</privacyLink>。",
  "global-feedback-collector.comments.component": "留言",
  "global-feedback-collector.components-helper.message": "開始輸入以取得可能符合項目的列表，或按向下鍵以選取。",
  "global-feedback-collector.components-helper.message.new": "您要針對哪一項功能提供意見反應？",
  "global-feedback-collector.components.field.label": "元件",
  "global-feedback-collector.components.field.label.new": "功能",
  "global-feedback-collector.databases.component": "資料庫",
  "global-feedback-collector.editor.component": "編輯器",
  "global-feedback-collector.emoji-rating-selector.label": "為您的體驗評分：",
  "global-feedback-collector.flags.feedback-submitted.description": "隨時掌握近期版本的最新資訊，如果您需要協助，請與我們連絡。",
  "global-feedback-collector.flags.feedback-submitted.get-help": "取得協助",
  "global-feedback-collector.flags.feedback-submitted.see-whats-new": "查看最新消息",
  "global-feedback-collector.flags.feedback-submitted.title": "感謝您提交意見反應",
  "global-feedback-collector.improve-atlassian": "我想要加入 {researchGroupLink}，協助改善 Atlassian 產品。",
  "global-feedback-collector.improve-atlassian.new": "是的，我希望加入 <researchLink>Atlassian 研究團隊</researchLink>，以協助改善 Atlassian 產品。",
  "global-feedback-collector.live.docs.component": "即時文件",
  "global-feedback-collector.menus.and.options.component": "選單和選項",
  "global-feedback-collector.navigation.component": "導覽",
  "global-feedback-collector.other.component": "其他",
  "global-feedback-collector.pages.component": "頁面",
  "global-feedback-collector.preamble.first-line": "您的寶貴想法可協助改善我們的產品。",
  "global-feedback-collector.preamble.first-line.new": "您的意見非常寶貴，能讓我們知道如何更加符合您的需求。",
  "global-feedback-collector.preamble.link": "支援網站",
  "global-feedback-collector.preamble.second-line": "如果您想要尋求協助或想要回報錯誤，請造訪我們的 {preambleLink}。",
  "global-feedback-collector.preamble.second-line.new": "如果您想要尋求協助或回報錯誤，請造訪我們的<preambleLinkTag>支援網站</preambleLinkTag>。",
  "global-feedback-collector.privacy-policy.link": "隱私政策",
  "global-feedback-collector.research-group.link": "Atlassian 研究團隊",
  "global-feedback-collector.sharing-and-permissions.component": "分享與權限",
  "global-feedback-collector.summary-placeholder": "讓我們知道您的想法",
  "global-feedback-collector.summary-placeholder.new": "我們有哪些優點？有哪些地方可以改善？",
  "global-feedback-collector.summary-title": "進一步描述您的體驗",
  "global-feedback-collector.title": "提供意見反應",
  "global-feedback-collector.title.new": "歡迎提供意見反應",
  "global-feedback-collector.whiteboards.component": "白板",
  "grant-access-dialog.dialog.action.deny": "拒絕",
  "grant-access-dialog.dialog.action.grant.edit": "授予編輯權限",
  "grant-access-dialog.dialog.action.grant.view": "授予檢視權限",
  "grant-access-dialog.dialog.message.request.edit.access.to.content": "{person} 已要求 <b>{contentTitle}</b> 的編輯權限。",
  "grant-access-dialog.dialog.message.request.view.access.to.content": "{person} 已要求 <b>{contentTitle}</b> 的檢視權限。",
  "grant-access-dialog.dialog.title.edit": "編輯權限要求",
  "grant-access-dialog.dialog.title.view": "檢視權限要求",
  "grant-access-dialog.error.generic": "很抱歉，授予存取權時發生非預期的錯誤。",
  "grant-access-dialog.error.no-mail-server": "已授予存取權，但未設定郵件伺服器，因此無法傳送通知。",
  "grant-access-dialog.error.send-email": "已授予存取權，但傳送通知時發生非預期的錯誤。",
  "grant-access-dialog.error.title": "存取要求錯誤",
  "grant-access-dialog.flag.action.deny": "拒絕",
  "grant-access-dialog.flag.action.grant": "核准",
  "grant-access-dialog.flag.message.request.edit.access.to.content": "要允許編輯「<b>{contentTitle}</b>」嗎？",
  "grant-access-dialog.flag.message.request.view.access.to.content": "要允許檢視「<b>{contentTitle}</b>」嗎？",
  "grant-access-dialog.flag.title.edit": "{name} 已要求編輯您的內容",
  "grant-access-dialog.flag.title.view": "{name} 已要求檢視您的內容",
  "grant-access-dialog.request-access-popup.approve-btn": "要求編輯",
  "grant-access-dialog.request-access-popup.error-flag-content": "我們在處理您的要求時遇到問題。請重新整理，然後再試一次。",
  "grant-access-dialog.request-access-popup.error-flag-title": "我們無法傳送您的要求",
  "grant-access-dialog.request-access-popup.error-icon-label": "錯誤",
  "grant-access-dialog.request-access-popup.flag-content": "當您的要求獲得核准時，會收到一封電子郵件。",
  "grant-access-dialog.request-access-popup.flag-title": "要請求編輯此內容嗎？",
  "grant-access-dialog.request-access-popup.success-flag-content": "我們已要求內容負責人授予您編輯權限。 在要求獲得核准後，您就會收到一封電子郵件。",
  "grant-access-dialog.request-access-popup.success-flag-title": "已傳送要求",
  "grant-access-dialog.request-access-popup.success-icon-label": "成功",
  "grant-access-dialog.success.already-granted": "已將存取權授予使用者。",
  "grant-access-dialog.success.generic": "已授予存取權，將會傳送通知給使用者。",
  "grant-access-dialog.success.title": "已授予存取要求",
  "highlight-actions.create-issue": "建立議題",
  "highlight-actions.create-issue-issue-term-refresh": "建立工作項目",
  "highlight-actions.create-jira-issue": "Jira 議題",
  "highlight-actions.create-jira-issue-issue-term-refresh": "Jira 工作項目",
  "highlight-actions.create-jira-work-item": "建立 Jira 工作項目",
  "highlight-actions.define": "定義",
  "highlight-actions.define.unsupported": "突顯術語、縮寫或簡稱",
  "highlight-actions.dropdown-group.apps": "應用程式",
  "highlight-actions.edit.definition.restricted.to.blogpost.option": "在這篇部落格貼文上",
  "highlight-actions.edit.definition.restricted.to.page.option": "此頁面上",
  "highlight-actions.edit.definition.restricted.to.site.option": "在這個網站上",
  "highlight-actions.edit.definition.restricted.to.space.option": "在這個空間中",
  "highlight-actions.inline-comments.comment": "留言",
  "highlight-actions.inline-comments.comment.create.disabled": "您只能在文字、標題、表情符號、日期、提及、連結和狀態上留言。",
  "highlight-actions.inline-comments.comment.no.permission": "{contentType, select, blogpost {您沒有將留言新增至此部落格貼文的權限} page {您沒有將留言新增至此頁面的權限} other {您沒有將留言新增至此頁面的權限}}",
  "highlight-actions.inline-comments.comment.unsupported": "留言只能新增至不包含表情符號、巨集或 @提及的文字",
  "highlight-actions.inline-comments.comment.unsupported.archive": "留言無法新增至已封存的項目",
  "highlight-actions.inline.comment.tooltip": "留言",
  "highlight-actions.multiple-issues": "多個議題",
  "highlight-actions.multiple-issues-issue-term-refresh": "多個工作項目",
  "highlight-actions.select.app": "選取應用程式",
  "highlight-actions.single-issue": "建立單一議題",
  "highlight-actions.single-issue-issue-term-refresh": "建立單一工作項目",
  "highlight-actions.toolbar.alert": "可以使用浮動工具列。按下 Tab 鍵即可存取",
  "home.administration.header": "管理",
  "home.administration.item.mission-control": "任務控制",
  "home.calendar.title": "行事曆",
  "home.empty-message": "檢視或建立空間後，這些空間會顯示在此處。",
  "home.feed.announcements.title": "公告",
  "home.feed.calendar.title": "行事曆",
  "home.feedback.cancel": "取消",
  "home.feedback.confirmation": "已提交意見反應",
  "home.feedback.confirmation.description.v2": "感謝您協助我們改善首頁！",
  "home.feedback.description": "您會如何評價此體驗？",
  "home.feedback.followup": "請詳細說明您的回應",
  "home.feedback.rating.bad": "不佳",
  "home.feedback.rating.good": "良好",
  "home.feedback.rating.great": "太棒了",
  "home.feedback.rating.okay": "普通",
  "home.feedback.rating.terrible": "很糟糕",
  "home.feedback.submit": "提交",
  "home.feedback.title.v2": "感謝您試用首頁",
  "home.for-you.title": "與您相關的內容",
  "home.h1.text": "Confluence 首頁",
  "home.home-views.create-live-doc": "建立即時文件",
  "home.home-views.create-page": "建立頁面",
  "home.ibo.people-section.names.IT": "IT",
  "home.ibo.people-section.names.closeButton": "關閉嵌入式入門區段",
  "home.ibo.people-section.names.consultant": "顧問",
  "home.ibo.people-section.names.marketing": "行銷",
  "home.ibo.people-section.names.me": "我",
  "home.ibo.people-section.names.product": "產品",
  "home.ibo.people-section.names.product-management": "專案管理",
  "home.ibo.people-section.names.stakeholder": "相關人員",
  "home.ibo.people-section.names.teammate": "團隊成員",
  "home.navigation.drafts": "草稿",
  "home.navigation.go-personal-space": "您的空間",
  "home.navigation.overview": "概觀",
  "home.navigation.recent": "最近的工作",
  "home.navigation.side": "側面",
  "home.navigation.starred": "已標上星號",
  "home.navigation.tasks-home": "任務",
  "home.navigation.watching": "追蹤中",
  "home.onboarding.onboarding-takeover.create-button-text": "建立頁面",
  "home.onboarding.onboarding-takeover.create-live-page-button-text": "建立即時文件",
  "home.onboarding.onboarding-takeover.create-whiteboard-button-text": "建立白板",
  "home.onboarding.onboarding-takeover.invite-button-text": "邀請團隊成員",
  "home.onboarding.onboarding-takeover.invite-description": "<highlight>邀請</highlight>人員協助設定您的網站和空間，並開始在內容上協作，如下所示：",
  "home.onboarding.onboarding-takeover.invite-description-simplified": "邀請人員協助設定您的網站和空間，並開始在內容上協作。",
  "home.onboarding.onboarding-takeover.invite-heading": "與團隊成員一起使用 Confluence。",
  "home.onboarding.onboarding-takeover.invite-heading-simplified": "Confluence 適合與<highlight>團隊成員</highlight>一起使用。",
  "home.onboarding.onboarding-takeover.premium-trial.awareness-description": "試用期於 {endDate} 結束後，您將自動切換到 Free 方案。",
  "home.onboarding.onboarding-takeover.premium-trial.awareness-heading": "您正在免費試用 <highlight>Confluence Premium</highlight>",
  "home.onboarding.onboarding-takeover.premium-trial.features-description": "Premium 試用可讓您存取<bold>分析、團隊行事曆、自動化</bold>等功能。您可以隨時<a>再次瀏覽 Premium 功能指南</a>。",
  "home.onboarding.onboarding-takeover.premium-trial.features-description.no-automation": "Premium 試用可讓您存取<bold>分析、團隊行事曆、不限數量的白板</bold>等功能。您可以隨時<a>再次瀏覽 Premium 功能指南</a>。",
  "home.onboarding.onboarding-takeover.recent-description": "您的個人空間中已經有頁面可協助您立即建立特定內容。",
  "home.onboarding.onboarding-takeover.recent-description-2": "您可以隨時選取藍色的<highlight>建立</highlight>按鈕，或按 <bold>c</bold> 來建立新內容。",
  "home.onboarding.onboarding-takeover.recent-description-simplified": "空間是由即時文件、頁面、白板和資料庫等內容所組成。",
  "home.onboarding.onboarding-takeover.recent-heading": "空間由<highlight>頁面</highlight>、<highlight>白板</highlight>和<highlight>部落格</highlight>貼文等內容組成。",
  "home.onboarding.onboarding-takeover.recent-heading-simplified": "您可以在 Confluence 中建立不同類型的<highlight>內容</highlight>。",
  "home.onboarding.onboarding-takeover.recent-heading.livedocs": "空間由<highlight>頁面</highlight>、<highlight>即時文件</highlight>、<highlight>白板</highlight>和<highlight>部落格</highlight>貼文等內容所組成。",
  "home.onboarding.onboarding-takeover.space-description": "空間到底是什麼？您可以將空間視為您個人、團隊和公司用來組織和處理構想、專案或文件等內容的地方。",
  "home.onboarding.onboarding-takeover.space-description-simplified": "空間是團隊整理專案文件、構想和關鍵資訊的位置。",
  "home.onboarding.onboarding-takeover.space-heading": "首先，您的 Confluence 網站是由<highlight>空間</highlight>所組成。",
  "home.onboarding.onboarding-takeover.space-heading-simplified": "您的 Confluence 網站由<highlight>空間</highlight>組成。",
  "home.onboarding.onboarding-takeover.title-with-name": "{userFirstName}，歡迎回來！",
  "home.spaces.header": "空間",
  "home.spaces.show-more-link": "顯示更多",
  "home.spaces.show-more-spaces-link": "顯示更多空間",
  "home.spaces.space.starred": "已標上星號",
  "home.spaces.view-all-link": "全部檢視",
  "home.spaces.view-all-spaces-link": "檢視所有空間",
  "home.starred-home-view.title": "已標上星號",
  "home.title": "首頁",
  "home.views.create-from-templates.guide-arrow-text": "剛開始使用 Confluence 的人都很喜歡這些範本",
  "home.views.create-from-templates.guide-arrow-text-for-specific-team": "和您有類似工作的人都很喜歡這些範本。",
  "home.views.create-from-templates.header": "透過範本建立",
  "home.views.create-from-templates.template-card.error-description": "請重新整理，然後再試一次。如果這種情況持續發生，請連絡支援人員。",
  "home.views.create-from-templates.template-card.error-title": "我們無法為您建立頁面",
  "home.views.create-from-templates.template-card.error-title.livedocs": "我們無法為您建立頁面或即時文件",
  "home.views.create-from-templates.template-card.secondary": "範本",
  "home.views.create-from-templates.templates-list.popular": "熱門",
  "home.views.create-from-templates.templates-list.popular-for": "{teamType} 的熱門項目",
  "home.views.create-from-templates.templates-list.recommended": "建議",
  "home.views.create-from-templates.templates-list.recommended-for": "建議用於 {teamType}",
  "home.views.create-from-templates.view-all": "全部檢視",
  "home.views.create-from-templates.whiteboard-card.primary": "建立白板",
  "home.views.create-from-templates.whiteboard-card.secondary": "選擇範本",
  "home.views.drafts.empty.body": "建立頁面之後，請選取<strong>關閉</strong>，而非<strong>發布</strong>，以便在發布前儲存您的想法。",
  "home.views.drafts.empty.header": "您尚未建立任何草稿",
  "home.views.drafts.no-results.no-drafts": "我們找不到任何相符的草稿。",
  "home.views.drafts.no-results.no-drafts-subtext": "<a>改為搜尋已發布的頁面</a>。",
  "home.views.drafts.title": "草稿",
  "home.views.error.action": "請重新整理，然後再試一次。",
  "home.views.error.header": "我們無法取得您的結果",
  "home.views.overview.recent-empty-state.body": "最近瀏覽、編輯或建立的頁面會顯示在此處。",
  "home.views.overview.recent-empty-state.body.livedocs": "最近瀏覽、編輯或建立的頁面或即時文件會顯示在此處。",
  "home.views.overview.recent-empty-state.header": "開始向外探索吧",
  "home.views.overview.recent-work": "從您離開的位置繼續",
  "home.views.overview.recent-work.action.commented": "您已於 {timeAgo} 留言",
  "home.views.overview.recent-work.action.commented.short": "已留言",
  "home.views.overview.recent-work.action.created": "您已於 {timeAgo} 建立",
  "home.views.overview.recent-work.action.created.short": "已建立",
  "home.views.overview.recent-work.action.edited": "您已於 {timeAgo} 編輯",
  "home.views.overview.recent-work.action.edited.short": "已編輯",
  "home.views.overview.recent-work.action.liked": "您已於 {timeAgo} 按讚",
  "home.views.overview.recent-work.action.liked.short": "已按讚",
  "home.views.overview.recent-work.action.visited": "您已於 {timeAgo} 造訪",
  "home.views.overview.recent-work.action.visited.short": "已造訪",
  "home.views.overview.recent-work.lozenge.unpublished": "未發佈的變更",
  "home.views.recent.empty.body": "最近瀏覽、編輯或建立的頁面會顯示在此處。",
  "home.views.recent.empty.body.livedocs": "最近瀏覽、編輯或建立的頁面或即時文件會顯示在此處。",
  "home.views.recent.empty.header": "開始向外探索吧",
  "home.views.recent.filtered-results-announcement": "{count, plural, other {找到 {count,number} 個結果}}",
  "home.views.recent.no-results.no-recent-created-by-me-results": "我們無法從您已建立的頁面找到相符項目。",
  "home.views.recent.no-results.no-recent-created-by-me-results-subtext": "<a>請改為搜尋其他人建立的頁面</a>。",
  "home.views.recent.no-results.no-recent-created-by-me-results-subtext.livedocs": "<a>請改為搜尋其他人建立的頁面和文件</a>。",
  "home.views.recent.no-results.no-recent-created-by-me-results.livedocs": "我們無法從您已建立的頁面或文件找到相符項目。",
  "home.views.recent.no-results.no-recent-results": "我們無法從最近 90 天造訪的頁面中找到相符項目。",
  "home.views.recent.no-results.no-recent-results-subtext": "<a>改為搜尋較舊的頁面</a>。",
  "home.views.recent.no-results.no-recent-results-subtext.livedocs": "<a>請改為搜尋較舊的頁面和即時文件</a>。",
  "home.views.recent.no-results.no-recent-results.livedocs": "我們無法從最近 90 天造訪的頁面或即時文件中找到相符項目。",
  "home.views.recent.options.all": "全部",
  "home.views.recent.options.created-by-me": "由我建立",
  "home.views.recent.options.filter.description": "結果將在您輸入時更新。",
  "home.views.recent.options.owned-by-me": "由我所負責",
  "home.views.recent.options.placeholder": "依標題篩選",
  "home.views.recent.options.worked-on": "已處理",
  "home.views.recent.title": "最近的頁面",
  "home.views.starred.empty.body": "標記對您而言重要的頁面，以便在稍後返回查看。您不會就標上星號的頁面收到任何通知。",
  "home.views.starred.empty.body.livedocs": "標記對您而言重要的頁面和即時文件，以便在稍後返回查看。您不會就標上星號的內容收到任何通知。",
  "home.views.starred.empty.header": "您尚未對任何頁面標上星號",
  "home.views.starred.empty.header.livedocs": "您尚未對任何頁面或即時文件標上星號",
  "home.views.starred.no-results": "我們無法從已標上星號的內容中找到相符項目。",
  "home.views.starred.no-results-subtext": "<a>改為搜尋所有頁面</a>。",
  "home.views.starred.no-results-subtext.livedocs": "<a>請改為搜尋所有頁面和即時文件</a>。",
  "home.views.tasks.assigned.pill": "指派給我 <b>{count}</b>",
  "home.views.tasks.assignee.column": "受託人",
  "home.views.tasks.created.pill": "由我建立 <b>{count}</b>",
  "home.views.tasks.creator.column": "建立者",
  "home.views.tasks.date.column": "截止日期",
  "home.views.tasks.description.column": "描述",
  "home.views.tasks.description.error": "無法載入任務描述",
  "home.views.tasks.filters.assignee.placeholder": "按名稱搜尋或選取",
  "home.views.tasks.filters.creator.placeholder": "按名稱搜尋或選取",
  "home.views.tasks.filters.label.assignee": "受託人",
  "home.views.tasks.filters.label.assignee.max.users": "已達到最大值",
  "home.views.tasks.filters.label.assignee.number.users": "最多可加入 10 人",
  "home.views.tasks.filters.label.clearFilters": "清除",
  "home.views.tasks.filters.label.completion": "狀態",
  "home.views.tasks.filters.label.creator": "建立者",
  "home.views.tasks.filters.label.creator.max.users": "已達到最大值",
  "home.views.tasks.filters.label.creator.number.users": "最多可加入 10 人",
  "home.views.tasks.filters.label.dueDate": "截止日期",
  "home.views.tasks.filters.label.filterLabel": "篩選條件",
  "home.views.tasks.filters.label.filtersButton": "{count, plural, =0 {篩選條件} other {已套用 {count,number} 個篩選條件}}",
  "home.views.tasks.filters.label.from": "從",
  "home.views.tasks.filters.label.page": "頁面",
  "home.views.tasks.filters.label.page.livedocs": "頁面或文件",
  "home.views.tasks.filters.label.space": "空間",
  "home.views.tasks.filters.label.to": "到",
  "home.views.tasks.filters.option.custom": "自訂",
  "home.views.tasks.filters.option.no.date": "沒有截止日期",
  "home.views.tasks.filters.option.one.month": "一個月內",
  "home.views.tasks.filters.option.one.week": "一星期內",
  "home.views.tasks.filters.option.overdue": "逾期",
  "home.views.tasks.filters.option.two.weeks": "兩星期內",
  "home.views.tasks.filters.options.completion.done": "完成",
  "home.views.tasks.filters.options.completion.ongoing": "正在進行",
  "home.views.tasks.noResultsMessage": "沒有可顯示的內容",
  "home.views.tasks.noResultsSubtext": "請調整篩選條件，然後再試一次。",
  "home.views.tasks.page.column": "頁面",
  "home.views.tasks.page.column.livedocs": "頁面或文件",
  "home.views.tasks.sort.ascending": "從 A 到 Z 排序",
  "home.views.tasks.sort.descending": "從 Z 到 A 排序",
  "home.views.tasks.sort.furthest": "從最遠排序到最近",
  "home.views.tasks.sort.soonest": "從最近排序到最遠",
  "home.views.tasks.sorting.unavailable": "排序不適用於建立者、受託人或空間",
  "home.views.tasks.space.column": "空間",
  "home.views.tasks.taskEmptyMessageBodyAssigned": "您沒有受指派的任務",
  "home.views.tasks.taskEmptyMessageBodyCreated": "祝您有美好的一天！",
  "home.views.tasks.taskEmptyMessageHeaderAssigned": "放輕鬆，休息一下",
  "home.views.tasks.taskEmptyMessageHeaderCreated": "這裡沒有任務",
  "home.views.tasks.taskFlagBody": "{count, plural, other {您已完成 {count,number} 項任務。}}",
  "home.views.tasks.taskIncompleteFlagBody": "{count, plural, other {您已重新開啟先前標示為完成的 {count,number} 項任務。}}",
  "home.views.tasks.taskSuccessFlag": "完成！",
  "home.views.tasks.taskSuccessIncompleteFlag": "{count, plural, other {已重新開啟任務}}",
  "home.views.tasks.title": "任務",
  "home.views.untitled": "未命名",
  "home.welcomeMessage.announcements": "公告",
  "home.welcomeMessage.customize": "自訂",
  "home.welcomeMessage.error.message.description": "重新整理或稍後再試。",
  "home.welcomeMessage.error.message.title": "我們無法載入您網站的歡迎訊息",
  "home.welcomeMessage.moreInfo": "更多資訊",
  "icons.content-icon.label.blogpost": "部落格",
  "icons.content-icon.label.database": "資料庫",
  "icons.content-icon.label.folder": "資料夾",
  "icons.content-icon.label.live-doc": "即時文件",
  "icons.content-icon.label.page": "頁面",
  "icons.content-icon.label.space": "空間",
  "icons.content-icon.label.whiteboard": "白板",
  "import-content.beta-lozenge": "測試版",
  "import-content.button.text": "從其他工具匯入",
  "import-content.close-drawer-warning-modal.cancel-button": "取消",
  "import-content.close-drawer-warning-modal.stop-importing-button": "停止匯入",
  "import-content.close-drawer-warning-modal.stop-importing-description": "您尚未完成內容匯入。如果現在停止，你將需要重新開始。",
  "import-content.close-drawer-warning-modal.stop-importing-header": "要停止匯入嗎？",
  "import-content.connect-data-step.access-token-added-button-text": "已新增存取權杖",
  "import-content.connect-data-step.access-token-errors-step-one": "請輸入有效的 Notion 存取權杖。",
  "import-content.connect-data-step.access-token-errors-step-two": "請輸入有效的 Notion 存取權杖。",
  "import-content.connect-data-step.access-token-modal-description": "這可讓 Confluence 讀取和匯入權限和使用者群組資料。若要取得存取權杖：",
  "import-content.connect-data-step.access-token-modal-paste": "您取得存取權杖後，請貼到此處以繼續。",
  "import-content.connect-data-step.access-token-step-five": "按一下 <b>www.notion.so</b>。",
  "import-content.connect-data-step.access-token-step-four": "在側邊欄中，按一下 <b>Cookies</b> 資料夾旁邊的 ⏵ 切換開關，以將其展開。",
  "import-content.connect-data-step.access-token-step-one": "在瀏覽器中前往 <a>Notion</a>，確保您只登入到一個帳戶。",
  "import-content.connect-data-step.access-token-step-seven": "在<b>值</b>欄位中選取文字，然後複製 (Cmd/Ctrl + C)",
  "import-content.connect-data-step.access-token-step-seven-firefox-edge": "在<b>值</b>欄位中選取文字，然後複製 (Cmd/Ctrl + C)",
  "import-content.connect-data-step.access-token-step-six": "找到名為 <b>token_v2</b> 的項目，然後按兩下以開啟詳細資料。",
  "import-content.connect-data-step.access-token-step-six-firefox-edge": "找到名為 <b>token_v2</b> 的項目。",
  "import-content.connect-data-step.access-token-step-three": "前往<b>儲存空間</b>分頁。",
  "import-content.connect-data-step.access-token-step-three-edge": "前往<b>應用程式</b>分頁。",
  "import-content.connect-data-step.access-token-step-two": "以滑鼠右鍵按一下畫面上的任何位置，然後選取<b>檢查元素</b>以開啟「開發人員工具」。",
  "import-content.connect-data-step.access-token-step-two-firefox-edge": "以滑鼠右鍵按一下畫面上的任何位置，然後按一下<b>檢查</b>以開啟「開發人員工具」。",
  "import-content.connect-data-step.access-token-text-field-label": "Notion 存取權杖",
  "import-content.connect-data-step.access-token-text-field-placeholder": "將存取權杖貼至此處",
  "import-content.connect-data-step.add-an-access-token-button-text": "新增存取權杖",
  "import-content.connect-data-step.add-an-integration-token-button-text": "新增整合權杖",
  "import-content.connect-data-step.add-remaining-members-description": "這會為所有 Notion 工作區成員建立 Confluence 帳戶 (如果還沒有帳戶的話)，以便我們將其名稱新增至頁面、留言和 @提及中。",
  "import-content.connect-data-step.add-remaining-members-description.livedocs": "這會為所有 Notion 工作區成員建立 Confluence 帳戶 (如果還沒有帳戶的話)，以便我們將其名稱新增至頁面、即時文件、留言和 @提及中。",
  "import-content.connect-data-step.add-remaining-members-licensing-description": "他們將自動新增到您的使用者列表中，這可能會影響您的使用者計數，並產生額外費用。<a>進一步了解授權</a>",
  "import-content.connect-data-step.add-remaining-members-toggle-text": "將剩餘成員新增至 Confluence",
  "import-content.connect-data-step.cant-add-remaining-members-description": "您可以先要求組織管理員邀請這些成員加入 Confluence 再繼續匯入，也可以略過他們直接繼續。",
  "import-content.connect-data-step.copy-notion-page-permissions-description": "這會將權限和使用者群組資料從 Notion 複製到 Confluence。如果您匯出檔案後，內容或存取權已變更，權限可能會有所不同。<a>深入了解權限</a>",
  "import-content.connect-data-step.copy-notion-page-permissions-toggle-text": "複製 Notion 頁面權限",
  "import-content.connect-data-step.dont-add-remaining-members-description": "由不存在於 Confluence 中的成員所撰寫的頁面和留言會將您列為作者。其 @提及將轉換為純文字。",
  "import-content.connect-data-step.dont-copy-notion-page-permissions-description": "所有頁面將設定為「空間中的任何人都可以檢視或編輯」。您可以透過設定空間權限來限制存取權。",
  "import-content.connect-data-step.dont-map-notion-members-description": "所有匯入的頁面和留言會將您列為作者。使用者 @提及將轉換為純文字。",
  "import-content.connect-data-step.dont-map-notion-members-info-box": "稍後無法對應使用者設定檔。如果未來要將成員的名稱新增至其內容，您需要重新執行整個匯入。",
  "import-content.connect-data-step.integration-token-added-button-text": "已新增整合權杖",
  "import-content.connect-data-step.integration-token-modal-description": "這會讓 Confluence 可以讀取和匯入 @提及，以及頁面和留言的建立者/編輯者資料。您必須是 Notion 工作區的負責人，才能取得權杖。若要建立您的內部整合權杖：",
  "import-content.connect-data-step.integration-token-modal-paste": "您取得整合權杖後，請貼到此處以繼續。",
  "import-content.connect-data-step.integration-token-modal-permissions": "接下來，授予整合權限以讀取您的 Notion 頁面：",
  "import-content.connect-data-step.integration-token-modal-repeat": "<b>重要事項：</b>針對工作區中的所有頂層頁面，重複步驟 8-12。",
  "import-content.connect-data-step.integration-token-step-eight": "在新分頁中，導覽至您匯出的 Notion 頁面",
  "import-content.connect-data-step.integration-token-step-eleven": "搜尋您的整合並加以選取 (您可能需要重新整理頁面)",
  "import-content.connect-data-step.integration-token-step-fifteen": "在「內部整合密碼」欄位中，按一下<b>顯示</b>，然後按一下<b>複製</b>",
  "import-content.connect-data-step.integration-token-step-five": "輸入任何名稱，例如「Confluence 匯入」，然後按一下<b>提交</b>",
  "import-content.connect-data-step.integration-token-step-four": "按一下<b>新整合</b>按鈕",
  "import-content.connect-data-step.integration-token-step-fourteen": "瀏覽至左側導覽中的<b>秘密</b>",
  "import-content.connect-data-step.integration-token-step-nine": "開啟右上方的 ••• 選單",
  "import-content.connect-data-step.integration-token-step-one": "前往",
  "import-content.connect-data-step.integration-token-step-seven": "啟用<b>讀取留言</b>和<b>讀取使用者資訊 (包括電子郵件地址)</b>，然後按一下<b>儲存變更</b>。將此分頁保持開啟。",
  "import-content.connect-data-step.integration-token-step-six": "瀏覽至左側導覽中的<b>功能</b>",
  "import-content.connect-data-step.integration-token-step-ten": "向下捲動至<b>連線至</b>",
  "import-content.connect-data-step.integration-token-step-thirteen": "返回整合權杖分頁",
  "import-content.connect-data-step.integration-token-step-three": "按一下<b>開發或管理整合</b>連結",
  "import-content.connect-data-step.integration-token-step-twelve": "按一下<b>確認</b>",
  "import-content.connect-data-step.integration-token-step-two": "瀏覽至<b>設定和成員 > 連線</b>",
  "import-content.connect-data-step.integration-token-text-field-label": "Notion 整合權杖",
  "import-content.connect-data-step.integration-token-text-field-placeholder": "將權杖貼到此處",
  "import-content.connect-data-step.login-to-notion-button-text": "登入 Notion",
  "import-content.connect-data-step.map-notion-members-description-one": "這會識別具有 Confluence 帳戶的成員，因此我們可以將其名稱新增到頁面、留言和 @提及中。您必須是 Notion 工作區負責人才能執行此操作。",
  "import-content.connect-data-step.map-notion-members-description-two": "您後續將有機會新增沒有 Confluence 帳戶的成員。",
  "import-content.connect-data-step.map-notion-members-toggle-text": "將 Notion 成員對應到其 Confluence 設定檔",
  "import-content.connect-data-step.modal-cancel-button-text": "取消",
  "import-content.connect-data-step.modal-submit-button-text": "提交",
  "import-content.connect-data-step.notion-connection-error": "我們無法自動連接到 Notion。請嘗試新增權杖或略過轉移使用者。",
  "import-content.connect-data-step.skip-button": "略過",
  "import-content.connect-data-step.title": "轉移使用者 (選擇性)",
  "import-content.connect-data-step.user-count-text": "位成員",
  "import-content.content-step.description": "您可以從各種來源 (例如瀏覽器和其他工具) 匯出至 HTML。將您的檔案壓縮成單一 zip 檔案。上傳 zip 檔案，包含您要匯入的內容。",
  "import-content.content-step.link": "進一步了解如何匯出至 HTML",
  "import-content.content-step.title": "上傳內容",
  "import-content.footer.back": "返回",
  "import-content.footer.cancel": "取消",
  "import-content.footer.learn-more-link": "進一步了解如何從 Notion 匯入內容",
  "import-content.footer.learn-more-link-html": "進一步了解如何從 HTML 匯入",
  "import-content.footer.learn-more-link-miro": "進一步了解如何從 Miro 匯入內容",
  "import-content.footer.next": "下一步",
  "import-content.footer.skip": "略過",
  "import-content.migration.media.session.error": "發生錯誤",
  "import-content.miro.review.confirm-details": "開始匯入之前，請確認或更正下列詳細資料。",
  "import-content.miro.review.data-file": "Miro 資料檔案",
  "import-content.miro.review.existing-space-card.sub-title.non-final": "Miro 看板被匯入到現有空間。",
  "import-content.miro.review.existing-space-card.title": "匯入到現有空間「{spaceName}」",
  "import-content.miro.review.file-being-uploaded": "檔案正在上傳，請稍候。",
  "import-content.miro.review.file-card.title": "資料檔案：{fileSize}",
  "import-content.miro.review.formatting-disclaimer": "大多數格式設定都會保留，但某些情況例外。<a>查看支援的內容</a>",
  "import-content.miro.review.import-settings": "匯入設定",
  "import-content.miro.review.invite-card.sub-title": "可以將更多使用者新增到您的訂閱。",
  "import-content.miro.review.invite-card.title": "邀請不在 Confluence 中的成員",
  "import-content.miro.review.permission.none.message": "使用管理員設定的空間權限。",
  "import-content.miro.review.permission.restricted.message": "只有我能看見",
  "import-content.miro.review.space-card.sub-title": "空間權限：{permissionMessage}",
  "import-content.miro.review.space-card.title": "匯入到新空間「{spaceName}」",
  "import-content.miro.review.third-party-disclaimer": "此功能仰賴第三方產品，Atlassian 不保證其可用性、效能、安全性或是否可順利運作。按一下<b>開始匯入</b>即表示您同意您擁有適當的權利、權限，且同意將所選內容匯入 Confluence。",
  "import-content.miro.review.title": "審核摘要",
  "import-content.miro.review.upload-complete": "上傳完成。您可以立即開始匯入",
  "import-content.miro.space-step.description": "為我們將匯入內容的新 Confluence 空間命名，並設定權限，以決定誰可以存取。",
  "import-content.miro.space-step.destination-space-radio.existing-space": "選擇空間",
  "import-content.miro.space-step.destination-space-radio.new-space": "建立新空間",
  "import-content.miro.space-step.page-selector.label": "資料夾或父系頁面 (選用)",
  "import-content.miro.space-step.page-selector.placeholder": "選擇資料夾或父系頁面",
  "import-content.miro.space-step.permissions-link": "深入了解權限",
  "import-content.miro.space-step.space-graphic-alt": "Miro 和 Confluence 空間",
  "import-content.miro.space-step.space-name-error.too-long": "空間名稱必須少於 200 個字元",
  "import-content.miro.space-step.space-name-error.too-short": "請輸入空間名稱",
  "import-content.miro.space-step.space-name-label": "為您的空間命名",
  "import-content.miro.space-step.space-selector.label": "Confluence 空間",
  "import-content.miro.space-step.space-selector.placeholder": "選擇空間",
  "import-content.miro.space-step.step-description": "若要匯入 Confluence，請選取現有的 Confluence 空間或建立新空間，然後設定權限以決定誰可以存取。",
  "import-content.miro.space-step.title": "設定空間",
  "import-content.miro.transfer-users.access-token-modal.access-token-placeholder": "將存取權杖貼至此處",
  "import-content.miro.transfer-users.access-token-modal.fifth-step": "選取<b>產生新權杖</b>。<b>產生新的 SCIM 權杖</b>的對話方塊隨即開啟。",
  "import-content.miro.transfer-users.access-token-modal.first-step": "在瀏覽器中前往 <a>Miro</a>。(請確保您已透過 <b>Enterprise 帳戶的管理員</b>身分登入)",
  "import-content.miro.transfer-users.access-token-modal.footer.cancel": "取消",
  "import-content.miro.transfer-users.access-token-modal.footer.submit": "提交",
  "import-content.miro.transfer-users.access-token-modal.fourth-step": "將 <b>SCIM 佈建</b>切換為<b>開啟</b>。",
  "import-content.miro.transfer-users.access-token-modal.instructions-header": "若要產生存取權杖，請按照下列步驟操作：",
  "import-content.miro.transfer-users.access-token-modal.miro-access-token": "Miro 存取權杖",
  "import-content.miro.transfer-users.access-token-modal.miro-documentation": "請參閱 <a>Miro 的說明文件</a>，以獲取更多詳細資料。",
  "import-content.miro.transfer-users.access-token-modal.second-step": "請按一下您的<b>設定檔圖示</b> > 選取<b>管理員主控台</b>。",
  "import-content.miro.transfer-users.access-token-modal.sixth-step": "選取<b>產生</b>。",
  "import-content.miro.transfer-users.access-token-modal.third-step": "前往<b>應用程式與整合</b> > 選取 <b>Enterprise 整合 (企業整合)</b>。",
  "import-content.miro.transfer-users.access-token-modal.title": "新增存取權杖",
  "import-content.miro.upload-content.bulk.enterprise.api": "如果您使用的是 Miro Enterprise 方案：",
  "import-content.miro.upload-content.bulk.first-point": "您可以使用 Miro 的大量匯出 API，以大量匯出看板。",
  "import-content.miro.upload-content.bulk.not.enterprise": "如果您使用的不是 Miro Enterprise 方案：",
  "import-content.miro.upload-content.bulk.second-point": "第三方應用程式可以協助匯出。",
  "import-content.miro.upload-content.bulk.third-party": "了解第三方應用程式",
  "import-content.miro.upload-content.description": "首先，將您的 Miro 看板匯出為 ZIP 檔案再上傳。請選擇最適合您的方法：",
  "import-content.miro.upload-content.fifth-point": "(針對您想要匯入的所有看板重複。)",
  "import-content.miro.upload-content.first-point": "選取並開啟看板。",
  "import-content.miro.upload-content.fourth-point": "選擇<b>向量</b>，然後按一下<b>匯出</b>。",
  "import-content.miro.upload-content.learn-how": "了解如何使用 API",
  "import-content.miro.upload-content.prepare-file": "準備要匯入的檔案：",
  "import-content.miro.upload-content.ready-to-upload": "當您的 ZIP 檔案準備就緒之後，請上傳到此處以繼續。",
  "import-content.miro.upload-content.second-point": "按一下看板名稱旁邊的點狀選單 → 選取<b>看板 > 匯出 > 另存為圖片。</b>",
  "import-content.miro.upload-content.section.bulk-export": "如果是要完整匯出工作區、匯出專案層級，或是匯出超過 15 個看板，我們建議您將流程自動化：",
  "import-content.miro.upload-content.section.manual-export": "如果您只需要移轉特定看板，可以從 Miro 個別匯出，並上傳至 Confluence。",
  "import-content.miro.upload-content.sixth-point": "將所有向量 PDF 壓縮為 <b>ZIP 檔案</b>。確保其中包含：",
  "import-content.miro.upload-content.sixth-point.sub-point.one": "僅限向量 PDF。",
  "import-content.miro.upload-content.sixth-point.sub-point.two": "沒有資料夾。",
  "import-content.miro.upload-content.tab.bulk-export": "大量匯出看板",
  "import-content.miro.upload-content.tab.manual-export": "個別匯出看板",
  "import-content.miro.upload-content.third-point": "拖曳框架以包含您要匯出的區域。",
  "import-content.miro.upload-content.title": "上傳 Miro 內容",
  "import-content.miro.user-step.disabled-error": "Miro SCIM 整合目前已停用。您需要在「Miro 設定 > Enterprise 整合 (企業整合)」中重新啟用，然後再試一次。",
  "import-content.miro.user-step.network-error": "請確定您已連線至網際網路，然後再試一次。",
  "import-content.miro.user-step.rate-limit-error": "您已達到 Miro API 速率上限。請稍後再試一次。",
  "import-content.miro.user-step.server-error": "Miro API 遇到一些問題。請嘗試再次新增 API 權杖，或聯繫 Miro 支援人員。",
  "import-content.miro.user-step.skip-button": "暫時跳過",
  "import-content.miro.user-step.title": "轉移使用者 (選擇性)",
  "import-content.miro.user-step.token-button.add-token": "新增 API 權杖",
  "import-content.miro.user-step.token-button.token-added": "已新增 API 權杖",
  "import-content.miro.user-step.unauthorized-error": "此 Miro API 權杖無效/未取得授權。請確保您擁有 Miro 管理員權限，且您的 Miro SCIM 權杖正確無誤，然後再試一次。",
  "import-content.miro.user-step.unknown-error": "聯繫 Miro API 時發生意外錯誤。若要繼續，我們建議您目前先不要新增 Miro 使用者。",
  "import-content.miro.users-step.do-not-add-members": "來自 Miro 的成員將不會匯入到 Confluence 中。",
  "import-content.miro.users-step.enterprise-plan": "使用 <b>Enterprise 方案</b>。",
  "import-content.miro.users-step.miro-admin": "Miro 管理員",
  "import-content.miro.users-step.otherwise-skip": "否則，請跳過此步驟。您仍然可以在稍後邀請使用者。",
  "import-content.miro.users-step.remaining-members.anyone": "這將邀請尚未有 Confluence 帳戶的 Miro 工作區成員，或為他們要求存取權。我們會為他們建立帳戶。",
  "import-content.miro.users-step.remaining-members.domain-restricted": "這會從已核准的網域邀請 Miro 工作區成員，或是為尚未有 Confluence 帳戶的 Miro 工作區成員要求存取權。",
  "import-content.miro.users-step.remaining-members.licensing-description": "注意：新增使用者可能會增加您的使用者數量，並產生額外費用。<a>進一步了解授權</a>",
  "import-content.miro.users-step.remaining-members.none": "若要透過匯入的方式傳輸使用者，請要求組織管理員邀請這些成員。",
  "import-content.miro.users-step.remaining-members.request-access": "這會代表任何尚未有 Confluence 帳戶的 Miro 工作區成員要求存取權。",
  "import-content.miro.users-step.to-complete-step": "若要完成此步驟，您必須：",
  "import-content.modal.app-card-description": "將其他應用程式的內容和使用者納入 Confluence。",
  "import-content.modal.app-card-title": "從應用程式匯入",
  "import-content.modal.cancel": "取消",
  "import-content.modal.description": "使用匯入的資料建立新空間。首先，請選取產品或來源。",
  "import-content.modal.feedback-dialog": "您接下來想要看到哪些產品？<a>請告訴我們。</a>",
  "import-content.modal.file-import": "HTML 匯入",
  "import-content.modal.html-card-description": "從檔案匯入。",
  "import-content.modal.html-card-title": "找不到您的應用程式嗎？",
  "import-content.modal.more-support-description": "您接下來想要看到哪些產品？<a>請讓我們知道</a>",
  "import-content.modal.more-support-title": "即將推出更多支援",
  "import-content.modal.start-import": "開始匯入",
  "import-content.modal.title": "從其他工具匯入工作",
  "import-content.modal.updated-description": "選取產品以從中匯入資料，並建立新空間。",
  "import-content.notion-export-format.selection.html": "HTML",
  "import-content.notion-export-format.selection.markdown-and-csv": "Markdown 和 CSV",
  "import-content.notion-export-format.selection.pdf": "PDF",
  "import-content.notion-export-format.title": "匯出格式",
  "import-content.permissions-selector.betaLozenge": "測試版",
  "import-content.permissions-selector.default": "預設空間權限",
  "import-content.permissions-selector.default-explanation-updated": "使用管理員設定的空間權限。",
  "import-content.permissions-selector.default-subtext": "使用在 Confluence 中設定的預設權限",
  "import-content.permissions-selector.notion": "Notion 權限",
  "import-content.permissions-selector.notion-explanation": "已匯入的空間將立即適用於可在 Notion 中存取的使用者。",
  "import-content.permissions-selector.notion-subtext": "從 Notion 複製團隊空間或父系頁面權限",
  "import-content.permissions-selector.restricted-explanation-updated": "只有您可以查看此空間。這讓您可以在其他人看到之前檢查匯入的內容。您可以稍後在「空間設定」中變更權限。",
  "import-content.permissions-selector.restricted-subtext": "只有您可以檢視空間",
  "import-content.permissions-selector.restricted-updated": "只有我能看見",
  "import-content.permissions-selector.sectionHeading": "空間權限",
  "import-content.permissions-selector.title": "權限",
  "import-content.progress-tracker.content": "內容",
  "import-content.progress-tracker.import": "開始匯入",
  "import-content.progress-tracker.review": "檢閱",
  "import-content.progress-tracker.spaces": "空間",
  "import-content.progress-tracker.users": "使用者",
  "import-content.review-details-step.copy-page-permissions-subtext": "保留 Notion 中的頁面層級權限",
  "import-content.review-details-step.copy-page-permissions-title": "複製 Notion 頁面權限",
  "import-content.review-details-step.create-new-space-title": "建立一個新的 Confluence 空間「{spaceName}」",
  "import-content.review-details-step.data-file": "資料檔案：{fileSize}",
  "import-content.review-details-step.data-file-title": "HTML 資料檔案",
  "import-content.review-details-step.default-space-permissions": "空間權限：預設",
  "import-content.review-details-step.description-one": "開始匯入之前，請確認或更正下列詳細資料。",
  "import-content.review-details-step.description-two": "大多數格式設定都會保留，但某些情況例外。例如，資料庫將匯入為靜態表格。<a>查看支援的功能</a>",
  "import-content.review-details-step.dont-copy-page-permissions-subtext": "所有頁面將設定為「空間中的任何人都可以檢視或編輯」",
  "import-content.review-details-step.dont-copy-page-permissions-title": "不要複製 Notion 頁面權限",
  "import-content.review-details-step.dont-invite-new-members-subtext": "其頁面和留言會將您列為作者。使用者 @提及將轉換為純文字。",
  "import-content.review-details-step.dont-invite-new-members-title": "不要邀請不在 Confluence 中的工作區成員",
  "import-content.review-details-step.dont-transfer-notion-members-subtext": "頁面和留言會將您列為作者。使用者 @提及將轉換為純文字。",
  "import-content.review-details-step.dont-transfer-notion-members-title": "不要轉移 Notion 成員",
  "import-content.review-details-step.formatting-warning": "大多數格式設定都會保留，但某些情況例外。<a>查看支援的功能</a>",
  "import-content.review-details-step.free-plan-info-box-one": "您使用的是 Free 方案。如果此匯入超過 <b>10 位使用者上限</b>，我們將為您啟動 Standard 方案的 14 天免費試用。",
  "import-content.review-details-step.free-plan-info-box-two": "如果超過 <b>2GB 儲存空間上限</b>，您可能需要手動清理儲存空間。",
  "import-content.review-details-step.import-new-space-title": "匯入到新空間「{spaceName}」",
  "import-content.review-details-step.import-settings-title": "匯入設定",
  "import-content.review-details-step.invite-new-members-subtext": "將其名稱新增至頁面、留言和 @提及，無論其是否加入可以將更多使用者新增到您的訂閱。",
  "import-content.review-details-step.invite-new-members-title": "邀請不在 Confluence 中的成員",
  "import-content.review-details-step.legal-disclaimer": "此功能仰賴第三方產品，Atlassian 不保證其可用性、效能或是否可順利運作。選取<b>開始匯入</b>即表示您同意您擁有適當的權利、權限，且同意將所選內容匯入 Confluence。",
  "import-content.review-details-step.map-notion-space-title": "每個 Notion 團隊空間都將成為 Confluence 空間",
  "import-content.review-details-step.notion-space-permissions": "空間權限：從 Notion 複製",
  "import-content.review-details-step.restricted-space-permissions": "空間權限：僅限於您",
  "import-content.review-details-step.space-permissions-default": "空間權限：使用管理員設定的空間權限。",
  "import-content.review-details-step.title": "審核摘要",
  "import-content.review-details-step.transfer-notion-members-subtext": "將其名稱新增至頁面、留言和 @提及",
  "import-content.review-details-step.uploaded": "上傳完成。您可以立即開始匯入。",
  "import-content.review-details-step.uploading": "檔案正在上傳，請稍候。",
  "import-content.set-up-spaces-step.learn-more-link": "深入了解權限",
  "import-content.set-up-spaces-step.plural-description": "每個 Notion 團隊空間都將成為 Confluence 空間。設定權限以決定誰可以存取。",
  "import-content.set-up-spaces-step.plural-title": "設定空間",
  "import-content.set-up-spaces-step.singular-description": "為我們將匯入內容的新 Confluence 空間命名，並設定權限，以決定誰可以存取。",
  "import-content.set-up-spaces-step.singular-title": "設定空間",
  "import-content.set-up-spaces-step.space-name-error": "請輸入空間名稱",
  "import-content.set-up-spaces-step.space-name-label": "為您的空間命名",
  "import-content.set-up-spaces-step.space-name-too-long": "空格名稱必須少於 200 個字元",
  "import-content.space-step.description": "為我們將匯入內容的新 Confluence 空間命名，並設定權限，以決定誰可以存取。",
  "import-content.space-step.error-too-long": "空格名稱必須少於 200 個字元",
  "import-content.space-step.error-too-short": "請輸入空間名稱",
  "import-content.upload-file-dropzone.or-drag-and-drop": "或拖放",
  "import-content.upload-file-dropzone.too-big-file-error-end-user": "此檔案超過附件上限。請您的組織或網站管理員提高上限並重試。",
  "import-content.upload-file-dropzone.too-many-files-error": "我們一次只能上傳 1 個 zip 檔案",
  "import-content.upload-file-dropzone.unsupported-file-error": "不支援此檔案。請嘗試上傳 ZIP 檔案。",
  "import-content.upload-file-dropzone.upload-file-error": "上傳檔案時發生錯誤，請再試一次",
  "import-content.upload-file-dropzone.zip-selection": "選取 ZIP 檔案",
  "import-content.upload-file-status-display.remove-file-aria-label": "移除檔案",
  "import-content.upload-file-status-display.title": "{content} 資料檔案",
  "import-content.upload-file-status-display.uploaded": "已上傳",
  "import-content.upload-file-status-display.uploading": "您可以在檔案上傳時繼續執行下一步。",
  "import-content.upload-file-step.bottom-instructions": "如果您有檔案，請將其上傳到此處以繼續。",
  "import-content.upload-file-step.bottom-tip": "提示：請團隊成員將私密頁面移至團隊空間，以將其包含在匯出檔案中。{learnMoreLink}",
  "import-content.upload-file-step.description": "首先，您需要針對您要匯入的內容，產生並下載匯出檔案。 您正在匯入什麼？",
  "import-content.upload-file-step.detailed-steps-title": "若要取得 Notion 的匯出檔案：",
  "import-content.upload-file-step.entire-notion-workspace": "整個 Notion 工作區",
  "import-content.upload-file-step.learn-more-link": "深入了解",
  "import-content.upload-file-step.learn-more-link-aria-label": "進一步了解如何匯入私人頁面",
  "import-content.upload-file-step.page-with-subpages": "具有子頁面的選定頁面",
  "import-content.upload-file-step.step-eight-subpages": "選取<b>匯出</b>",
  "import-content.upload-file-step.step-five": "選擇是否要匯出留言",
  "import-content.upload-file-step.step-five-subpages": "啟用「包含子頁面」",
  "import-content.upload-file-step.step-four": "啟用「建立子頁面資料夾」",
  "import-content.upload-file-step.step-four-subpages": "在匯出格式下，選取 <b>HTML</b>",
  "import-content.upload-file-step.step-one": "前往工作區設定",
  "import-content.upload-file-step.step-one-subpages": "前往您要匯出的頁面",
  "import-content.upload-file-step.step-seven-subpages": "選擇是否要匯出留言",
  "import-content.upload-file-step.step-six": "選取<b>匯出</b>",
  "import-content.upload-file-step.step-six-subpages": "啟用「建立子頁面資料夾」",
  "import-content.upload-file-step.step-three": "在匯出格式下，選取 <b>HTML</b>",
  "import-content.upload-file-step.step-three-subpages": "選取<b>匯出</b>",
  "import-content.upload-file-step.step-two": "選取<b>匯出所有工作區內容</b>",
  "import-content.upload-file-step.step-two-subpages": "開啟右上方的 ••• 選單",
  "import-content.upload-file-step.title": "上傳 Notion 內容",
  "import-content.user-data-preview.comment-author": "您",
  "import-content.user-data-preview.comments-title": "10 則留言",
  "import-content.user-data-preview.created-by": "建立者為 {createdBySubject}",
  "import-content.user-data-preview.created-by-subject": "您",
  "import-content.user-data-preview.new-users-description": "如果這些使用者尚未在您的 Confluence 中，就會新增到您的訂閱中。",
  "import-content.user-data-preview.new-users-description.direct-invite": "這些使用者將會新增至您的 Confluence 訂閱，如果尚未包含在您的帳戶中，則會為他們要求存取權。",
  "import-content.user-data-preview.new-users-description.request-access": "如果這些使用者尚未包含在您的帳戶中，也會為他們要求存取權。",
  "import-content.user-data-preview.new-users-label": "新使用者",
  "import-content.user-data-preview.new-users-title": "{maximumNewUsers, plural, other {最多 {maximumNewUsers,number} 位使用者}}",
  "import-content.user-data-preview.no-new-users-description": "沒有任何新使用者會新增至您的訂閱。只會對應現有使用者。",
  "import-content.user-data-preview.no-new-users-title": "0 位使用者",
  "import-content.user-data-preview.preview-title": "使用者資料預覽",
  "import-content.user-data-preview.restricted-tooltip": "無限制",
  "import-content.user-data-preview.specific-tooltip": "只有特定人員可以檢視和編輯",
  "import-content.users-step.remaining-members.anyone": "這將邀請尚未有 Confluence 帳戶的 {application} 工作區成員，或為他們要求存取權。我們會為他們建立一個帳戶，以便您將其名稱新增至頁面、留言和@提及。",
  "import-content.users-step.remaining-members.do-not-add": "由不存在於 Confluence 中的成員所撰寫的頁面和留言會將您列為作者。 其 @提及將轉換為純文字。",
  "import-content.users-step.remaining-members.domain-restricted": "這會從已核准的網域邀請 {application} 工作區成員，或是為尚未有 Confluence 帳戶的 {application} 工作區成員要求存取權。對於受到邀請的使用者，這會建立 Confluence 帳戶。- 以便我們將其名稱新增至頁面、留言和 @提及。",
  "import-content.users-step.remaining-members.licensing-description": "這可能會影響您的使用者計數，並產生額外費用。<a>進一步了解授權</a>",
  "import-content.users-step.remaining-members.none": "您可以先要求組織管理員邀請這些成員加入 Confluence 再繼續匯入，也可以略過他們直接繼續。",
  "import-content.users-step.remaining-members.request-access": "這會代表任何尚未有 Confluence 帳戶的 {application} 工作區成員要求存取權。",
  "import-content.workflow.close-drawer": "關閉選單",
  "import-feedback.banner-text": "此內容已匯入。外觀如何？",
  "import-feedback.data-format-options.notion.attachments": "附件",
  "import-feedback.data-format-options.notion.audio-embedded-link": "音訊 (內嵌連結)",
  "import-feedback.data-format-options.notion.block-equation": "方塊等式",
  "import-feedback.data-format-options.notion.breadcrumb": "軌跡瀏覽",
  "import-feedback.data-format-options.notion.bulleted-lists": "項目符號列表",
  "import-feedback.data-format-options.notion.button": "按鈕",
  "import-feedback.data-format-options.notion.callout": "重點提示",
  "import-feedback.data-format-options.notion.code-block": "程式碼區塊",
  "import-feedback.data-format-options.notion.code-mermaid": "程式碼 - Mermaid (圖表)",
  "import-feedback.data-format-options.notion.customized-text": "自訂文字",
  "import-feedback.data-format-options.notion.database-child-page-properties": "資料庫子系頁面屬性",
  "import-feedback.data-format-options.notion.dates": "日期",
  "import-feedback.data-format-options.notion.dividers": "分隔線",
  "import-feedback.data-format-options.notion.embed": "嵌入 (例如 Figma)",
  "import-feedback.data-format-options.notion.emojis": "表情符號",
  "import-feedback.data-format-options.notion.header-images": "標頭圖片",
  "import-feedback.data-format-options.notion.headings": "標題",
  "import-feedback.data-format-options.notion.images": "圖片",
  "import-feedback.data-format-options.notion.inline-equation": "內嵌等式",
  "import-feedback.data-format-options.notion.link-to-page": "頁面連結",
  "import-feedback.data-format-options.notion.mentions": "@提及",
  "import-feedback.data-format-options.notion.numbered-lists": "編號清單",
  "import-feedback.data-format-options.notion.other": "其他",
  "import-feedback.data-format-options.notion.page-comments": "頁面留言",
  "import-feedback.data-format-options.notion.page-emojis": "頁面表情符號",
  "import-feedback.data-format-options.notion.quotes": "引述",
  "import-feedback.data-format-options.notion.reminder": "提醒",
  "import-feedback.data-format-options.notion.static-tables": "靜態表格",
  "import-feedback.data-format-options.notion.synced-block": "已同步區塊",
  "import-feedback.data-format-options.notion.table-customization": "表格自訂",
  "import-feedback.data-format-options.notion.table-data": "表格資料",
  "import-feedback.data-format-options.notion.table-of-contents": "目錄",
  "import-feedback.data-format-options.notion.todo-list": "待辦事項清單",
  "import-feedback.data-format-options.notion.toggle-heading": "切換標題",
  "import-feedback.data-format-options.notion.toggle-list": "切換列表",
  "import-feedback.data-format-options.notion.two-columns": "2 欄",
  "import-feedback.data-format-options.notion.video-embedded-link": "影片 (內嵌連結)",
  "import-feedback.data-format-options.notion.web-bookmark": "網頁書籤",
  "import-feedback.feedback-modal.close-button": "取消",
  "import-feedback.feedback-modal.data-format-clear-control-label": "清除選取的資料格式",
  "import-feedback.feedback-modal.data-format-helper-text": "開始輸入以取得可能符合項目的列表，或按向下鍵以選取。",
  "import-feedback.feedback-modal.data-format-label": "具有議題的資料格式",
  "import-feedback.feedback-modal.feedback-button": "傳送意見反應",
  "import-feedback.feedback-modal.feedback-text": "這是從 {source} 匯入的內容。請告訴我們您在下方找到哪些議題！",
  "import-feedback.feedback-modal.required-fields-asterisk": "必填欄位標有星號",
  "import-feedback.feedback-modal.select-data-format-error": "請選取資料格式",
  "import-feedback.feedback-modal.submitted-description": "您的意見反應很珍貴，能幫助我們持續改善產品。",
  "import-feedback.feedback-modal.submitted-title": "謝謝！",
  "import-feedback.feedback-modal.tell-us-about-your-experience": "告訴我們您的體驗",
  "import-feedback.feedback-modal.tell-us-about-your-experience-placeholder": "請詳細介紹這項匯入內容可以改善的地方。",
  "import-feedback.feedback-modal.title": "提供有關匯入內容的意見反應",
  "import-from-sources.bulk-limit-modal.bulkLimitModalDialogDocsSelectedLength": "{docsNumber, plural, other {已選取 {docsNumber,number} 份文件}}",
  "import-from-sources.bulk-limit-modal.bulkLimitModalDialogRetryHeading": "您無法一次匯入超過 {bulkLimit} 個文件。",
  "import-from-sources.bulk-limit-modal.bulkLimitModalDialogRetryHeadingExtended": "{bulkLengthLimit, plural, other {您一次最多只能匯入 {bulkLengthLimit,number} 份文件，而且所有文件的大小總計不能超過 {bulkSizeLimit} MB。}}",
  "import-from-sources.bulk-limit-modal.bulkLimitModalDialogSizeCouldNotIdentify": "無法確定大小",
  "import-from-sources.bulk-limit-modal.bulkLimitModalDialogSizeUnit": "MB",
  "import-from-sources.bulk-limit-modal.bulkLimitModalDialogTotalSelectedDocsSize": "總大小 {totalSize} MB",
  "import-from-sources.bulk-limit-modal.cancelAction": "取消",
  "import-from-sources.bulk-limit-modal.retryAction": "重試",
  "import-from-sources.bulk-upload-error-popup.content": "我們遇到了問題，因為檔案可能是錯誤的類型、受到密碼保護或處於唯讀狀態。",
  "import-from-sources.bulk-upload-error-popup.title": "無法匯入這些檔案",
  "import-from-sources.cookies-not-allowed.gotItAction": "知道了",
  "import-from-sources.cookies-not-allowed.moreOnCookiesAction": "進一步查看 cookies",
  "import-from-sources.cookies-not-allowed.text": "如果要從 Google 文件匯入內容，請先清除瀏覽器 cookies、重新整理頁面，然後允許所有 cookies。",
  "import-from-sources.cookies-not-allowed.title": "無法匯入",
  "import-from-sources.discard-modal.cancelAction": "取消",
  "import-from-sources.discard-modal.createAction": "建立",
  "import-from-sources.discard-modal.discardDraftAction": "捨棄草稿",
  "import-from-sources.discard-modal.live-doc.title": "要建立新的即時文件嗎？",
  "import-from-sources.discard-modal.live-page.discardDraftAction": "刪除目前的頁面",
  "import-from-sources.discard-modal.live-page.text": "您的新頁面不會包含目前頁面中的任何內容",
  "import-from-sources.discard-modal.live-page.text.livedocs": "您的新文件不會包含目前文件中的任何內容",
  "import-from-sources.discard-modal.text": "您的新頁面不會包含目前草稿中的任何內容",
  "import-from-sources.discard-modal.title": "是否要建立新頁面？",
  "import-from-sources.error-message.elementErrorProcessWarningMessage": "無法匯入某些元素。我們在匯入文件的某些元素 (圖片、字型等) 時遇到問題。",
  "import-from-sources.error-message.elementErrorUserRateLimitMessage": "我們匯入這個檔案時遇到問題。請在幾分鐘後完成此次匯入並重試上傳。",
  "import-from-sources.error-message.fileExceedsLimitGdBulk": "此文件超過了 Google 雲端硬碟的 10 MB 匯出限制。",
  "import-from-sources.error-message.fileExceedsLimitLocalBulk": "此文件為 {fileSize} MB，超過了 {uploadFileLimitMb} MB 的限制。您可以將內容分成較小的檔案，然後分別匯入。",
  "import-from-sources.error-message.imageErrorProcessWarningMessage": "無法匯入某些圖片。我們在文件中匯入一或多個圖片時發生問題。我們已在新頁面中為這些圖片建立預留位置。",
  "import-from-sources.error-message.imageErrorProcessWarningMessage.livedocs": "無法匯入某些圖片。我們在文件中匯入一或多個圖片時發生問題。我們已為這些圖片建立預留位置。",
  "import-from-sources.error-message.liveDocWithThisNameAlreadyExists": "具有此名稱的即時文件已存在。標題在空間內不能重複。請為您的文件提供不同的名稱。",
  "import-from-sources.error-message.operationAborted": "已取消匯入",
  "import-from-sources.error-message.pageWithThisNameAlreadyExists": "具有此名稱的頁面已存在。在空間內的頁面名稱必須是唯一的。為您的頁面提供不同的名稱以便發佈。",
  "import-from-sources.error-message.payloadTooLargeErrorMessage": "內容太長。您可以將內容拆分為較小的檔案，然後單獨匯入。",
  "import-from-sources.error-message.strictFormatErrorMessage": "檔案格式不受支援。匯入的 .docx 檔案儲存為 Strict Open XML。請將其儲存為 Word 文件 .docx並再次匯入。",
  "import-from-sources.global-import-modal.cancelAction": "取消",
  "import-from-sources.global-import-modal.restrictedAccessDescription": "在嘗試匯入之前，請與您的管理員聯繫，並要求在空間中建立內容的權限。",
  "import-from-sources.global-import-modal.restrictedAccessHeader": "您需要存取權才能編輯空間",
  "import-from-sources.global-import-modal.restrictedStateButton": "好的，知道了",
  "import-from-sources.global-import-modal.subtitle": "將外部文件轉換為 Confluence 頁面。",
  "import-from-sources.global-import-modal.subtitle.livedocs": "將外部文件轉換為 Confluence 頁面或即時文件。",
  "import-from-sources.global-import-modal.title": "匯入您現有的工作",
  "import-from-sources.global-import-modal.use-create-page-mutation.defaultTitle": "匯入",
  "import-from-sources.import-from-gd-modal.cancelAction": "取消",
  "import-from-sources.import-from-gd-modal.singIn": "透過 Google 登入",
  "import-from-sources.import-from-gd-modal.text": "連結您的 Google 帳號以便繼續",
  "import-from-sources.import-from-gd-modal.title": "匯入 Google 文件",
  "import-from-sources.import-from-onedrive-confirm-modal.cancelAction": "取消",
  "import-from-sources.import-from-onedrive-confirm-modal.continue": "繼續",
  "import-from-sources.import-from-onedrive-confirm-modal.header": "開啟 OneDrive",
  "import-from-sources.import-from-onedrive-confirm-modal.text": "此網站正在嘗試啟動 OneDrive。您要繼續嗎？",
  "import-from-sources.import-from-onedrive.no-access": "我們無法開啟檔案",
  "import-from-sources.import-from-onedrive.no-permission": "您可能沒有存取檔案的權限，或檔案可能已不存在。",
  "import-from-sources.import-from-onedrive.noAccessCommon": "一或多個檔案無法開啟",
  "import-from-sources.import-from-onedrive.noPermissionsCommon": "您可能沒有存取檔案的權限，或檔案可能已不存在。",
  "import-from-sources.process-warning-popup.elementErrorProcessWarningPopupContent": "我們在匯入文件的某些元素 (影像、字型等) 時遇到問題。",
  "import-from-sources.process-warning-popup.elementErrorProcessWarningPopupTitle": "無法匯入某些元素",
  "import-from-sources.process-warning-popup.imageErrorProcessPopupTitle": "無法匯入某些影像",
  "import-from-sources.process-warning-popup.imageErrorProcessWarningPopupContent": "我們在文件中匯入一或多個影像時發生問題。我們已在新頁面中為這些影像建立預留位置。",
  "import-from-sources.process-warning-popup.submitAction": "確定",
  "import-from-sources.sources-list.gdocCardDataName": "Google 文件",
  "import-from-sources.sources-list.importDescriptionLabel": "將外部文件轉換為 Confluence 頁面",
  "import-from-sources.sources-list.importDescriptionLabel.livedocs": "將外部文件轉換為 Confluence 頁面或即時文件",
  "import-from-sources.sources-list.msWordCardDataName": "Microsoft Word",
  "import-from-sources.sources-list.oneDriveSourcesListCardDataName": "OneDrive",
  "import-from-sources.upload-error-popup.close": "關閉",
  "import-from-sources.upload-error-popup.content": "我們遇到了問題，因為檔案可能是錯誤的類型、受到密碼保護或處於唯讀狀態。",
  "import-from-sources.upload-error-popup.failedBulkImportPopupContent": "我們在匯入您的檔案時遇到問題。請檢查您的網際網路連線，然後再試一次。",
  "import-from-sources.upload-error-popup.failedBulkImportPopupTitle": "大量匯入失敗",
  "import-from-sources.upload-error-popup.title": "無法匯入此檔案",
  "import-from-sources.upload-error-popup.tryDifferentDocument": "選取新檔案",
  "import-from-sources.upload-error-popup.tryDifferentDocuments": "選取新檔案",
  "import-from-sources.upload-error-popup.type-content": "我們無法匯入您選取的檔案，因為其檔案類型錯誤。請選取其他檔案並繼續。",
  "import-from-sources.upload-error-popup.type-title": "僅支援 .DOCX 檔案",
  "import-from-sources.upload-error-popup.type-tryDifferentDocument": "選取另一個檔案",
  "import-from-sources.upload-modal.cancelAction": "取消",
  "import-from-sources.upload-modal.finishAction": "完成",
  "import-from-sources.upload-modal.progressTitle": "正在匯入文件...",
  "import-from-sources.upload-modal.progressTitleBulk": "正在匯入文件...",
  "import-from-sources.upload-modal.progressTitleSuccess": "匯入完成！",
  "import-from-sources.upload-modal.uploadModalProgressTitleBulkFailed": "大量匯入失敗！",
  "import-from-sources.warning-modal.RestrictionWarningModalBody": "您沒有權限，無法限制此空間中的內容。組織中的任何人都可以檢視和編輯此處匯入的所有內容。",
  "import-from-sources.warning-modal.RestrictionWarningModalSubmit": "繼續",
  "import-from-sources.warning-modal.RestrictionWarningModalTitle": "對子系頁面沒有限制",
  "import-from-sources.warning-modal.cancel-btn": "取消",
  "import-from-sources.warning-modal.fileExceedsLimit": "{fileName} 的大小為 {fileSize} MB，其超過 100 MB 的上限。您可以將內容分成較小的檔案，然後分別匯入。",
  "import-from-sources.warning-modal.fileGoogleExceedsLimit": "{fileName} 超過 Google Drive 的 10 MB 匯出限制。",
  "import-from-sources.warning-modal.fileTooBig": "此檔案太大",
  "import-from-sources.warning-modal.payloadTooLargeModalBody": "您可以將內容拆分為較小的檔案，然後單獨匯入。",
  "import-from-sources.warning-modal.payloadTooLargeModalTitle": "內容太長",
  "import-from-sources.warning-modal.strictFormatModalBody": "匯入的 .docx 檔案儲存為 Strict Open XML。請將其儲存為 Word 文件 .docx並再次匯入。",
  "import-from-sources.warning-modal.strictFormatModalTitle": "檔案格式不受支援",
  "import-from-sources.warning-modal.submit-btn": "選取新檔案",
  "in-product-help.about.confluence.heading": "關於 Confluence",
  "in-product-help.close.text": "關閉",
  "in-product-help.header.close.text": "標頭關閉",
  "in-product-help.learn.more.export.wiki.data": "有關匯出 Wiki 資料的詳細資訊",
  "in-product-help.links.about": "關於",
  "in-product-help.links.notice.at.collection": "收集時的通知",
  "in-product-help.links.privacy.policy": "隱私權政策",
  "in-product-help.links.terms.of.use": "使用規範",
  "in-product-help.open-source.attributions.heading": "開放原始碼程式庫的屬性",
  "in-product-help.resource.ask.community": "詢問社群",
  "in-product-help.resource.feed.builder": "摘要產生器",
  "in-product-help.resource.feedback": "提供意見反應",
  "in-product-help.resource.get.mobile": "取得 Confluence Mobile",
  "in-product-help.resource.help.articles": "閱讀說明文章",
  "in-product-help.resource.keyboard.shortcuts": "鍵盤快速鍵",
  "in-product-help.resource.new": "新功能",
  "in-product-help.resource.site.status": "網站狀態",
  "inline-comments-common.a11y.comment.wrapper.label": "留言者為 {username}",
  "inline-comments-common.action.reopen": "重新開啟",
  "inline-comments-common.collapsed.replies.more": "還有 {numCollapsedReplies} 個回覆",
  "inline-comments-common.comment.actions.menu.label": "更多動作",
  "inline-comments-common.comment.reopened.flag.cta.gotocomment": "前往留言",
  "inline-comments-common.comment.reopened.flag.cta.undo": "復原",
  "inline-comments-common.content.unavailable": "內容無法使用",
  "inline-comments-common.copy.link": "複製連結",
  "inline-comments-common.could.not.edit.title": "無法編輯留言",
  "inline-comments-common.deleted": "[已刪除]",
  "inline-comments-common.deleted.comment.action.label": "此留言已被刪除",
  "inline-comments-common.display.name.anonymous": "匿名",
  "inline-comments-common.edited": "已編輯",
  "inline-comments-common.editor.error.message": "嘗試 {action} 時您的留言時發生問題。請關閉編輯器，然後再試一次。",
  "inline-comments-common.error.action.not.permitted": "您無法在此空間中對內嵌留言執行該動作。空間管理員可以修改您的權限。",
  "inline-comments-common.error.action.not.permitted.title": "未經授權的動作",
  "inline-comments-common.error.cannot.reply.to.resolved": "您無法回覆此留言，因為此留言最近已由其他使用者解決。請重新整理以檢視最新更新。",
  "inline-comments-common.error.cannot.update.resolved": "您無法編輯此留言，因為此留言最近已由其他使用者解決。請重新整理以檢視最新更新。",
  "inline-comments-common.error.comment.already.deleted": "此留言已被其他人刪除。請重新整理以檢視最新更新。",
  "inline-comments-common.error.content.out.of.date": "您無法在此處建立留言，因為文字已變更或移除。",
  "inline-comments-common.error.create.content.removed": "您醒目提示的文字已被其他人刪除。請重新整理以檢視最新更新。",
  "inline-comments-common.error.create.not.permitted": "您無法在此空間中建立留言。空間管理員可以修改您的權限。",
  "inline-comments-common.error.create.timeout": "您要建立留言的要求已逾時。請稍等片刻，然後再次儲存留言。",
  "inline-comments-common.error.delete.not.permitted": "您無法在此空間中刪除留言。空間管理員可以修改您的權限。",
  "inline-comments-common.error.delete.with.replies": "您再也無法刪除此留言，因為有其他人回覆了留言。請重新整理以查看所有回覆。",
  "inline-comments-common.error.edit.not.permitted": "您無法在此空間中編輯留言。空間管理員可以修改您的權限。",
  "inline-comments-common.error.invalid.highlight": "我們無法新增您的留言。請嘗試增加或減少反白的文字。",
  "inline-comments-common.error.no.comments.found.for.given.marker.ref": "找不到此留言。請重新整理以檢視最新更新。",
  "inline-comments-common.error.reply.not.allowed.parent.deleted": "您無法回覆此留言，因為留言剛才已被其他人刪除。請重新整理以檢視最新更新。",
  "inline-comments-common.error.reply.not.permitted": "您無法在此空間中回覆留言。空間管理員可以修改您的權限。",
  "inline-comments-common.error.resolve.not.permitted": "您無法在此空間中解決留言。空間管理員可以修改您的權限。",
  "inline-comments-common.error.stale.content": "請重新整理以檢視最新的更新，然後再次嘗試新增留言。",
  "inline-comments-common.error.unable.to.apply.annotation": "將此留言新增到文件時出現問題。請重新整理以查看您的留言。",
  "inline-comments-common.error.unable.to.apply.dangling.comment.annotation": "您的留言已建立，但無法新增至文件，因為文字已變更或已移除。",
  "inline-comments-common.error.unable.to.generate.step": "您無法建立留言，因為醒目提示發生錯誤。請關閉此視窗並建立新的醒目提示。",
  "inline-comments-common.error.unable.to.mark.dom": "您的留言已成功建立。請重新整理以進行檢視。",
  "inline-comments-common.error.unexpected": "儲存此留言時發生問題。請關閉留言或重新整理，然後再次嘗試新增留言。",
  "inline-comments-common.error.view.not.permitted": "您的權限設定不允許您檢視此留言。如果您需要此功能，請洽詢管理員。",
  "inline-comments-common.heading": "成為第一個新增內嵌留言的人",
  "inline-comments-common.message": "醒目提示文字並選取「{text}」，分享您的意見反應或提出問題。",
  "inline-comments-common.next-comment-label": "下一則留言",
  "inline-comments-common.original.content.deleted": "原始內容已刪除",
  "inline-comments-common.previous-comment-label": "上一則留言",
  "inline-comments-common.reopened.by.tooltip.text.comments.panel": "已於 {createdAtNonLocalized} 新增，已由 {username} 重新開啟",
  "inline-comments-common.reopened.date.info.text": "已於 {friendlyDate} 重新開啟",
  "inline-comments-common.reopened.message": "已由 {person} 重新開啟",
  "inline-comments-common.reply-comment-placeholder": "回覆",
  "inline-comments-common.reply.placeholder": "回覆",
  "inline-comments-common.resolved": "[已解決]",
  "inline-comments-common.resolved-comment-description": "您可以從「更多動作」選單中檢視所有留言。",
  "inline-comments-common.resolved-comment-title": "留言已解決",
  "inline-comments-common.resolved.by.info.text": "解決者為 {username} {friendlyDate}",
  "inline-comments-common.resolved.by.tooltip.text": "解決者為 {username}",
  "inline-comments-common.resolved.by.tooltip.text.comments.panel": "作者：{username}",
  "inline-comments-common.resolved.date.info.text": "解決時間：{friendlyDate}",
  "inline-comments-common.resolved.flag.text": "留言已解決",
  "inline-comments-common.sample.comment.author": "Confluence",
  "inline-comments-common.sample.comment.body": "反白內容即可新增內嵌留言。所有檢視者都可以看到這些內容，因此非常適合針對特定字詞或詞組進行討論",
  "inline-comments-common.sample.comment.delete.header": "只有您可以看見。",
  "inline-comments-common.sample.comment.delete.icon": "「刪除」圖示",
  "inline-comments-common.sample.comment.delete.icon.label": "關閉範例留言",
  "inline-comments-common.sample.comment.delete.tooltip": "刪除範例留言",
  "inline-comments-common.sample.reply.input": "已停用回覆輸入",
  "inline-comments-common.sample.reply.placeholder": "回覆",
  "inline-comments-common.sample.reply.tooltip": "範例留言不適用回覆功能",
  "inline-comments-common.tooltip.copy.link": "複製留言的連結",
  "inline-comments-common.tooltip.link.has.been.copied": "已複製！",
  "inline-comments-common.undo-resolved-comment": "復原已解決的留言",
  "inline-comments-common.unread.inline.comment": "這是未讀的內嵌留言",
  "inline-comments-common.view.action.delete": "刪除",
  "inline-comments-common.view.action.edit": "編輯",
  "inline-comments-common.view.action.resolve": "解決",
  "inline-comments-common.view.action.resolved": "已解決",
  "inline-comments-common.view.tooltip.general.comment": "一般留言",
  "inline-comments-reattach.a11y.comment.wrapper": "留言者為 {username}",
  "inline-comments-reattach.close.icon.tooltip": "關閉側邊欄 (])",
  "inline-comments-reattach.error.unable.to.generate.step": "您無法重新附加留言，因為醒目顯示發生錯誤。請建立新的醒目顯示項目，然後再試一次。",
  "inline-comments-reattach.reattach.attach.button.redesign": "新增留言",
  "inline-comments-reattach.reattach.error.not.dangling": "此留言已被其他人重新附加。請重新整理以查看最新更新。",
  "inline-comments-reattach.reattach.error.unexpected": "重新附加此留言時發生錯誤。請關閉留言或重新整理，然後再次嘗試重新附加留言。",
  "inline-comments-reattach.reattach.instructions.redesign": "反白一些文字，以將此留言附加到其中。",
  "inline-comments.close.icon.tooltip": "關閉側邊欄 (])",
  "inspect-permissions.chevron.row.collapse": "摺疊",
  "inspect-permissions.chevron.row.expand": "展開",
  "inspect-permissions.contact.button.page": "聯繫作者",
  "inspect-permissions.contact.button.page.owner": "聯繫負責人",
  "inspect-permissions.contact.button.product": "請連絡 Confluence 管理員",
  "inspect-permissions.contact.button.space": "請連絡空間管理員",
  "inspect-permissions.contact.column.heading": "連絡人",
  "inspect-permissions.contacts.former.user": "前一位使用者",
  "inspect-permissions.dialog.close.button": "確定",
  "inspect-permissions.dialog.description": "瞭解內容、空間和產品階層的每個層級是否允許或拒絕某人取得權限。",
  "inspect-permissions.dialog.help.button": "說明",
  "inspect-permissions.dialog.help.button.aria-label": "進一步了解檢查權限",
  "inspect-permissions.dialog.show-full-page-tree.toggle": "顯示所有層級",
  "inspect-permissions.dialog.title": "檢查權限",
  "inspect-permissions.hierarchy.column.heading.all.levels": "所有層級",
  "inspect-permissions.hierarchy.column.heading.relevant.levels": "相關層級",
  "inspect-permissions.mailto.body.page": "您好，%0D%0A%0D%0A我這邊有需要存取內容的人員，但我們沒有人可以變更其存取層級。您可以協助查看嗎？%0D%0A%0D%0A謝謝！%0D%0A{currentUser}%0D%0A%0D%0A需要存取權的使用者：%0D%0A{inspectedUser}%0D%0A%0D%0A內容「{pageTitle}」連結：%0D%0A{pageUrl}",
  "inspect-permissions.mailto.body.product": "您好，%0D%0A%0D%0A我這邊有需要存取內容的人員，但我們沒有人可以變更其存取層級。您可以協助查看嗎？%0D%0A%0D%0A謝謝！%0D%0A{currentUser}%0D%0A%0D%0A需要存取權的使用者：%0D%0A{inspectedUser}%0D%0A%0D%0A「{pageTitle}」內容連結：%0D%0A{pageUrl}%0D%0A%0D%0A「{spaceName}」空間的權限連結：%0D%0A{spacePermissionsUrl}",
  "inspect-permissions.mailto.body.space": "您好，%0D%0A%0D%0A我這邊有需要存取空間的人員，但我們沒有人可以變更其存取層級。您可以協助查看嗎？%0D%0A%0D%0A謝謝！%0D%0A{currentUser}%0D%0A%0D%0A需要存取權的使用者：%0D%0A{inspectedUser}%0D%0A%0D%0A「{spaceName}」空間的權限連結：%0D%0A{spacePermissionsUrl}%0D%0A%0D%0A「{pageTitle}」內容的連結：%0D%0A{pageUrl}",
  "inspect-permissions.mailto.subject.page": "[Confluence] Confluence 使用者需要存取您的內容",
  "inspect-permissions.mailto.subject.product": "[Confluence] Confluence 使用者需要存取權",
  "inspect-permissions.mailto.subject.space": "[Confluence] Confluence 使用者需要空間存取權",
  "inspect-permissions.permission.allowed": "已允許",
  "inspect-permissions.permission.comment.page.false.1": "{displayName} 無法檢視或留言，因為他們<b>在 1 個層級上的權限遭到拒絕</b>",
  "inspect-permissions.permission.comment.page.false.1.view.true": "{displayName} 可以檢視但無法留言，因為他們<b>在 1 個層級上的權限遭到拒絕</b>",
  "inspect-permissions.permission.comment.page.false.n": "{numberOfDenials, plural, other {{displayName} 無法檢視或留言，因為其<b>在 {numberOfDenials,number} 個層級上的權限遭到拒絕</b>}}",
  "inspect-permissions.permission.comment.page.false.n.view.true": "{numberOfDenials, plural, other {{displayName} 可以檢視但無法留言，因為其<b>在 {numberOfDenials,number} 個層級上的權限遭到拒絕</b>}}",
  "inspect-permissions.permission.comment.page.true": "{displayName} 可以檢視和留言",
  "inspect-permissions.permission.denied": "已拒絕",
  "inspect-permissions.permission.edit.page.false.1": "{displayName} 無法檢視或編輯，因為他們<b>在 1 個層級上的權限遭到拒絕</b>",
  "inspect-permissions.permission.edit.page.false.1.view.true": "{displayName} 可以檢視但無法編輯，因為他們<b>在 1 個層級上的權限遭到拒絕</b>",
  "inspect-permissions.permission.edit.page.false.n": "{numberOfDenials, plural, other {{displayName} 無法檢視或編輯，因為其<b>在 {numberOfDenials,number} 個層級上的權限遭到拒絕</b>}}",
  "inspect-permissions.permission.edit.page.false.n.view.true": "{numberOfDenials, plural, other {{displayName} 可以檢視但無法編輯，因為其<b>在 {numberOfDenials,number} 個層級上的權限遭到拒絕</b>}}",
  "inspect-permissions.permission.edit.page.true": "{displayName} 可以檢視和編輯",
  "inspect-permissions.permission.inherited": "繼承",
  "inspect-permissions.permission.irrelevant": "無關",
  "inspect-permissions.permission.option.can.comment": "可以檢視和發表留言",
  "inspect-permissions.permission.option.can.edit": "可以檢視和編輯",
  "inspect-permissions.permission.option.can.view": "可以檢視",
  "inspect-permissions.permission.select.label": "權限",
  "inspect-permissions.permission.view.page.false.1": "{displayName} 無法檢視，因為他們<b>在 1 個層級上的權限遭到拒絕</b>",
  "inspect-permissions.permission.view.page.false.n": "{numberOfDenials, plural, other {{displayName} 無法檢視，因為其<b>在 {numberOfDenials,number} 個層級上的權限遭到拒絕</b>}}",
  "inspect-permissions.permission.view.page.true": "{displayName} 可以檢視",
  "inspect-permissions.row.permission.access.product.allowed": "{displayName} 具有 Confluence 的存取權",
  "inspect-permissions.row.permission.access.product.denied": "{displayName} 沒有存取 Confluence 的權限",
  "inspect-permissions.row.permission.comment.page.allowed": "{displayName} 具有檢視和留言的權限",
  "inspect-permissions.row.permission.comment.page.denied": "{displayName} 沒有檢視和留言的權限",
  "inspect-permissions.row.permission.comment.page.inherited.1": "{displayName} 具有檢視權限，但無法在此空間中留言",
  "inspect-permissions.row.permission.comment.page.inherited.n": "{displayName} 沒有檢視和留言的權限，因為其父系或空間上有一項以上的限制",
  "inspect-permissions.row.permission.comment.space.allowed": "{displayName} 具有在此空間中檢視和留言的權限",
  "inspect-permissions.row.permission.comment.space.denied": "{displayName} 沒有在此空間中檢視和留言的權限",
  "inspect-permissions.row.permission.comment.space.denied.view.allowed": "{displayName} 具有檢視權限，但無法在此空間中留言",
  "inspect-permissions.row.permission.edit.page.allowed": "{displayName} 具有檢視和編輯權限",
  "inspect-permissions.row.permission.edit.page.denied": "{displayName} 沒有檢視和編輯的權限",
  "inspect-permissions.row.permission.edit.page.denied.view.allowed": "{displayName} 具有檢視權限，但無法編輯",
  "inspect-permissions.row.permission.edit.page.inherited.1": "{displayName} 具有檢視權限，但無法在此空間中編輯",
  "inspect-permissions.row.permission.edit.page.inherited.n": "{displayName} 沒有檢視和編輯的權限，因為其父系或空間上有一項以上的限制",
  "inspect-permissions.row.permission.edit.page.irrelevant": "{displayName} 具有檢視權限，但無法編輯。這項限制不會影響子系。",
  "inspect-permissions.row.permission.edit.space.allowed": "{displayName} 具有在此空間中檢視和編輯的權限",
  "inspect-permissions.row.permission.edit.space.denied": "{displayName} 沒有在此空間中檢視和編輯的權限",
  "inspect-permissions.row.permission.edit.space.denied.view.allowed": "{displayName} 具有檢視權限，但無法在此空間中編輯",
  "inspect-permissions.row.permission.view.page.allowed": "{displayName} 具有檢視權限",
  "inspect-permissions.row.permission.view.page.denied": "{displayName} 沒有檢視權限",
  "inspect-permissions.row.permission.view.page.inherited.n": "{displayName} 沒有檢視權限，因為其父系或空間有一項以上的限制",
  "inspect-permissions.row.permission.view.space.allowed": "{displayName} 具有在此空間中檢視的權限",
  "inspect-permissions.row.permission.view.space.denied": "{displayName} 沒有在此空間中檢視的權限",
  "inspect-permissions.user.search.label": "使用者名稱",
  "inspect-permissions.view.global.permissions": "檢視全域權限",
  "inspect-permissions.view.page": "檢視",
  "inspect-permissions.view.space.settings": "檢視空間權限",
  "issue-create-side-panel.ai-toggle-label": "使用 AI 產生摘要和描述",
  "issue-create-side-panel.ai-upsell-modal.body": "使用 AI，透過 Confluence 頁面中的資訊快速填寫議題描述。透過 Premium 免費試用嘗試。",
  "issue-create-side-panel.ai-upsell-modal.body-issue-term-refresh": "使用 AI，透過 Confluence 頁面中的資訊快速填寫工作項目描述。透過免費試用的 Premium 方案嘗試。",
  "issue-create-side-panel.ai-upsell-modal.body.livedocs": "使用 AI，透過 Confluence 頁面和即時文件中的資訊快速填寫議題描述。透過 Premium 免費試用以便嘗試。",
  "issue-create-side-panel.ai-upsell-modal.button.cancel": "稍後再說",
  "issue-create-side-panel.ai-upsell-modal.button.confirm": "免費試用",
  "issue-create-side-panel.ai-upsell-modal.title": "透過 AI 的協助達成事半功倍",
  "issue-create-side-panel.beta-text": "測試版",
  "issue-create-side-panel.body.ai-loading": "正在產生議題",
  "issue-create-side-panel.body.ai-loading-issue-experiment": "Atlassian Intelligence 正在產生摘要和描述，這可能需要幾分鐘的時間。",
  "issue-create-side-panel.body.ai-loading-issue-term-refresh": "正在產生工作項目",
  "issue-create-side-panel.body.project.heading": "專案：",
  "issue-create-side-panel.body.site.heading": "網站：",
  "issue-create-side-panel.bulk-body.ai-loading": "正在產生議題",
  "issue-create-side-panel.bulk-body.ai-loading-issue-term-refresh": "正在產生工作項目",
  "issue-create-side-panel.bulk-configure.footer.cancel": "取消",
  "issue-create-side-panel.bulk-configure.footer.save": "儲存",
  "issue-create-side-panel.bulk-configure.form.default.issue.type": "預設議題類型",
  "issue-create-side-panel.bulk-configure.form.default.issue.type-issue-term-refresh": "預設工作項目類型",
  "issue-create-side-panel.bulk-configure.form.project": "專案",
  "issue-create-side-panel.bulk-configure.form.project-selector.projects": "專案",
  "issue-create-side-panel.bulk-configure.form.project-selector.recent-projects": "最近的專案",
  "issue-create-side-panel.bulk-configure.form.site": "網站",
  "issue-create-side-panel.bulk-configure.header": "設定",
  "issue-create-side-panel.bulk-configure.jira-error": "本網站中沒有可用的專案。",
  "issue-create-side-panel.bulk-configure.map-table-to-issue.add-mapping": "新增對應",
  "issue-create-side-panel.bulk-configure.map-table-to-issue.description": "您可以將醒目顯式的表格欄對應到議題中的特定欄位。",
  "issue-create-side-panel.bulk-configure.map-table-to-issue.description-issue-term-refresh": "您可以將醒目顯示的表格直欄對應到工作項目中的特定欄位。",
  "issue-create-side-panel.bulk-configure.map-table-to-issue.error.column-not-selected": "必須選取欄。",
  "issue-create-side-panel.bulk-configure.map-table-to-issue.error.field-already-mapped": "另一個欄已對應到選取的欄位。",
  "issue-create-side-panel.bulk-configure.map-table-to-issue.error.field-not-selected": "必須選取欄位。",
  "issue-create-side-panel.bulk-configure.map-table-to-issue.issue-field": "議題欄位",
  "issue-create-side-panel.bulk-configure.map-table-to-issue.issue-field-issue-term-refresh": "工作項目欄位",
  "issue-create-side-panel.bulk-configure.map-table-to-issue.table-column": "表格欄",
  "issue-create-side-panel.bulk-configure.map-table-to-issue.title": "將表格對應至議題欄位",
  "issue-create-side-panel.bulk-configure.map-table-to-issue.title-issue-term-refresh": "將表格對應至工作項目欄位",
  "issue-create-side-panel.bulk-configure.missing-table-column-mapping-error-header": "缺少表格欄對應",
  "issue-create-side-panel.bulk-configure.missing-table-column-mapping-error-text": "請更新並儲存表格欄到工作項目欄位的對應。",
  "issue-create-side-panel.bulk-create-ai-error-description": "Atlassian Intelligence 目前無法提供回應。請再試一次或醒目顯示特定文字，以手動建立。",
  "issue-create-side-panel.bulk-create-connect-jira-project-error-description": "我們無法連結到您的 Jira 專案，請再試一次。",
  "issue-create-side-panel.bulk-create-edit.header": "編輯議題",
  "issue-create-side-panel.bulk-create-edit.header-issue-term-refresh": "編輯工作項目",
  "issue-create-side-panel.bulk-create-issue-generation-error-description": "Atlassian Intelligence 目前無法提供回應。請新增更多內容，然後再試一次。或者醒目顯示特定文字，以手動建立。",
  "issue-create-side-panel.bulk-create.body.required-fields-message-description": "編輯每個建議並填寫必要欄位，以建立議題",
  "issue-create-side-panel.bulk-create.body.required-fields-message-description-issue-term-refresh": "編輯每個建議並填寫必要欄位，以建立工作項目",
  "issue-create-side-panel.bulk-create.body.required-fields-message-title": "這些建議包含必填欄位",
  "issue-create-side-panel.bulk-create.card.description-icon": "描述",
  "issue-create-side-panel.bulk-create.configure.body": "變更這些設定可能會重新產生議題列表。",
  "issue-create-side-panel.bulk-create.configure.body-issue-term-refresh": "變更這些設定可能會重新產生工作項目列表。",
  "issue-create-side-panel.bulk-create.error.message": "{issuesCount, plural, other {我們無法儲存您的議題，請再試一次。}}",
  "issue-create-side-panel.bulk-create.error.message-issue-term-refresh": "{issuesCount, plural, other {我們無法儲存您的工作項目，請再試一次。}}",
  "issue-create-side-panel.bulk-create.footer-button.cancel": "取消",
  "issue-create-side-panel.bulk-create.footer-button.create-all": "建立全部",
  "issue-create-side-panel.bulk-create.header": "建立 Jira 議題",
  "issue-create-side-panel.bulk-create.header-issue-term-refresh": "建立 Jira 工作項目",
  "issue-create-side-panel.bulk-create.issue-insertion-heading": "已連結 Jira 議題",
  "issue-create-side-panel.bulk-create.issue-insertion-heading-issue-term-refresh": "已連結 Jira 工作項目",
  "issue-create-side-panel.bulk-create.partial.error.message": "我們無法建立您的某些議題。請在剩餘議題上選取勾號，一次建立一個。",
  "issue-create-side-panel.bulk-create.partial.error.message-issue-term-refresh": "我們無法建立您的某些工作項目。請在剩餘工作項目上選取勾號，一次建立一個。",
  "issue-create-side-panel.error.button.create-manually": "手動建立",
  "issue-create-side-panel.error.button.try-again": "再試一次",
  "issue-create-side-panel.ethical-violation-ai-error-description": "您所選的內容或此頁面上的其他內容可能不符合我們的<link>可接受使用政策</link>。您可以隨時手動建立議題。",
  "issue-create-side-panel.ethical-violation-ai-error-description-issue-term-refresh": "您所選的內容或此頁面上的其他內容可能不符合我們的<link>可接受使用政策</link>。您可以隨時手動建立工作項目。",
  "issue-create-side-panel.exceed-token-limit-description": "Atlassian Intelligence 目前無法為長篇 Confluence 頁面建立議題。您可以隨時手動建立議題。",
  "issue-create-side-panel.exceed-token-limit-description-issue-term-refresh": "Atlassian Intelligence 目前無法為長篇 Confluence 頁面建立工作項目。您可以隨時手動建立工作項目。",
  "issue-create-side-panel.footer.ai-text": "由 AI 提供技術支援",
  "issue-create-side-panel.footer.cancel": "取消",
  "issue-create-side-panel.footer.disclaimer-text": "內容品質可能會變動",
  "issue-create-side-panel.footer.submit": "提交",
  "issue-create-side-panel.header": "建立 Jira 議題",
  "issue-create-side-panel.header-issue-term-refresh": "建立 Jira 工作項目",
  "issue-create-side-panel.multiple.flag-copy-link": "複製連結",
  "issue-create-side-panel.multiple.flag-view-issue": "{issueCount, plural, other {檢視 Jira 中的議題}}",
  "issue-create-side-panel.multiple.insert-link-failure-flag.title-issue-term-refresh": "{issueCount, plural, other {我們無法插入 {issueCount} 個工作項目的頁面連結}}",
  "issue-create-side-panel.multiple.sucess-flag-title": "{issueCount, plural, other {您已成功建立 {issueCount} 個議題}}",
  "issue-create-side-panel.multiple.sucess-flag-title-issue-term-refresh": "{issueCount, plural, other {您已建立 {issueCount} 個工作項目}}",
  "issue-create-side-panel.no-answer-suggested-issues-ai-error-description": "我們無法理解內容以建議議題。請選取不同的內容或手動建立議題。",
  "issue-create-side-panel.no-answer-suggested-issues-ai-error-description-issue-term-refresh": "我們無法理解內容以建議工作項目。請選取不同的內容或手動建立工作項目。",
  "issue-create-side-panel.rate-limit-ai-error-description": "我們近期收到過多 Atlassian Intelligence (AI) 要求。請在幾分鐘後再試一次，或<link>參閱 AI 使用過量</link>。您可以隨時手動建立議題。",
  "issue-create-side-panel.rate-limit-ai-error-description-issue-term-refresh": "我們近期收到過多 Atlassian Intelligence (AI) 要求。請在幾分鐘後再試一次，或<link>參閱 AI 使用過量</link>。您可以隨時手動建立工作項目。",
  "issue-create-side-panel.single-create-ai-error-description": "Atlassian Intelligence 目前無法提供回應。 請再試一次或手動建立議題。",
  "issue-create-side-panel.single-create-ai-error-description-issue-term-refresh": "Atlassian Intelligence 目前無法提供回應。 請再試一次或手動建立工作項目。",
  "issue-create-side-panel.sucess-flag-title": "您已建立「<link>{issueKey} {issueSummary}</link>」議題",
  "issue-create-side-panel.sucess-flag-title-issue-term-refresh": "您已建立「<link>{issueKey} {issueSummary}</link>」工作項目",
  "issue-create-side-panel.unsaved-issue.warning.dialog.action.cancel": "取消",
  "issue-create-side-panel.unsaved-issue.warning.dialog.action.discard": "捨棄",
  "issue-create-side-panel.unsaved-issue.warning.dialog.content": "您的議題將會遺失。",
  "issue-create-side-panel.unsaved-issue.warning.dialog.content-issue-term-refresh": "{issuesCount, plural, =0 {您的工作項目將會遺失。} other {您的工作項目將會遺失。}}",
  "issue-create-side-panel.unsaved-issue.warning.dialog.heading": "是否捨棄議題？",
  "issue-create-side-panel.unsaved-issue.warning.dialog.heading-issue-term-refresh": "{issuesCount, plural, =0 {是否捨棄工作項目？} other {要捨棄工作項目嗎？}}",
  "jira-project-board.ad-controls.privacy-policy": "進一步了解您所適用的 Atlassian 資料隱私權",
  "jira-project-board.board-created-flag-description": "建立任務以開始管理專案、連結至 Confluence 等等。",
  "jira-project-board.board-created-flag-title": "已建立 Jira 看板！",
  "jira-project-board.change-project-cancel": "取消",
  "jira-project-board.change-project-confirm": "確認",
  "jira-project-board.change-project-description": "變更此專案將取代 Jira 專案看板中目前的專案。",
  "jira-project-board.change-project-select-project-placeholder": "搜尋 Jira",
  "jira-project-board.change-project-title": "變更 Jira 專案",
  "jira-project-board.connect-project-action": "連接至 Jira",
  "jira-project-board.connect-project-close-action": "取消",
  "jira-project-board.connect-project-connect-action": "連接",
  "jira-project-board.connect-project-select-placeholder": "搜尋 Jira",
  "jira-project-board.connect-project-selection-title": "選擇一個專案以連接到您的空間。",
  "jira-project-board.connect-project-title": "將空間連接到 Jira",
  "jira-project-board.connect-project-value-proposition-sync-item": "將即時資料從 Jira 同步到 Confluence 中的任何文件",
  "jira-project-board.connect-project-value-proposition-title": "讓專案和文件更加靠近",
  "jira-project-board.connect-project-value-proposition-track-item": "細分專案並且追蹤進度",
  "jira-project-board.cross-flow-action": "下一步",
  "jira-project-board.cross-flow-cancel-anytime-link": "可隨時取消",
  "jira-project-board.cross-flow-customer-agreement-link": "Atlassian 客戶協議",
  "jira-project-board.cross-flow-pricing-link": "目前定價",
  "jira-project-board.cross-flow-privacy-policy-link": "隱私權政策",
  "jira-project-board.cross-flow-terms-standard-and-premium": "選取「開始免費試用」即表示您同意{customerAgreementLink}和{privacyPolicyLink}。如果您在試用期間未取消，訂閱帳單將根據 {pricingLink} 開始每月續訂。{cancelAnytimeLink}。",
  "jira-project-board.cross-flow-terms-standard-and-premium-no-payment-details": "選取「下一步」即表示您同意{customerAgreementLink}和{privacyPolicyLink}。",
  "jira-project-board.cross-flow-trial-action": "開始免費試用",
  "jira-project-board.cross-flow-value-proposition-sync-item": "將即時資料從 Jira 同步到 Confluence 中的任何文件",
  "jira-project-board.cross-flow-value-proposition-title": "讓專案和文件更加靠近",
  "jira-project-board.cross-flow-value-proposition-track-item": "細分專案並且追蹤進度",
  "jira-project-board.cross-flow-value-proposition-trial-period-item-free": "免費，可隨時取消",
  "jira-project-board.cross-flow-value-proposition-trial-period-item-premium": "30 天免費試用 Jira 的 Premium 方案",
  "jira-project-board.cross-flow-value-proposition-trial-period-item-standard": "14 天免費試用 Jira 的 Standard 方案",
  "jira-project-board.default-error-flag-description": "請重新整理頁面，然後再試一次",
  "jira-project-board.default-error-flag-refresh-action": "重新整理頁面",
  "jira-project-board.default-error-flag-title": "我們遇到了意外困難",
  "jira-project-board.dismiss-flag-description": "此接觸點以後會較少出現在這裡。",
  "jira-project-board.dismiss-flag-title": "知道了，謝謝您告訴我們",
  "jira-project-board.error-creating-jira-board-flag-description": "通常發生這種情況是因為網站尚未付款。請檢查您的付款是否為最新狀態。",
  "jira-project-board.error-creating-jira-board-flag-title": "我們在新增 Jira 時遇到問題",
  "jira-project-board.footer-jira-link-label": "在 Jira 中檢視",
  "jira-project-board.footer-logo-prefix": "提供技術支援的一方：",
  "jira-project-board.header-change-project": "變更專案",
  "jira-project-board.header-more-actions": "更多動作",
  "jira-project-board.header-project-label": "Jira 專案",
  "jira-project-board.header-view-in-jira": "在 Jira 中檢視",
  "jira-project-board.jira-board-create-error-contact-action": "連絡支援人員",
  "jira-project-board.jira-board-create-error-trobleshoot-action": "疑難排解指南",
  "jira-project-board.more-actions-label": "更多動作",
  "jira-project-board.navigation-item-label": "Jira 專案",
  "jira-project-board.new-lozenge": "全新",
  "jira-project-board.reasons-modal-bullet-one": "您團隊的規模",
  "jira-project-board.reasons-modal-bullet-two": "您現有的 Atlassian 產品",
  "jira-project-board.reasons-modal-explanation": "我們認為 <strong>Jira</strong> 將提高您團隊的生產力。這項建議的依據是：",
  "jira-project-board.reasons-modal-title": "為什麼我會看到此內容？",
  "jira-project-board.request-access-action": "要求存取權",
  "jira-project-board.request-access-description": "您需要存取 Jira 才能連接專案和文件。要求存取 Jira 以開始使用。",
  "jira-project-board.request-access-title": "要求存取 Jira",
  "jira-project-board.requested-access-description": "我們已經讓管理員知道您想存取 Jira。當他們接受您的要求後，您將收到一封電子郵件。",
  "jira-project-board.requested-access-title": "已傳送要求！",
  "jira-project-board.requested-trial-description": "我們已經讓管理員知道您想試用 Jira。當他們接受您的要求後，您將收到一封電子郵件。",
  "jira-project-board.requested-trial-title": "已傳送要求！",
  "jira-project-board.spotlight-description": "將即時資料鏈連結至任何文件、取得自動更新，以及輕鬆建立報告。",
  "jira-project-board.spotlight-dismiss": "關閉",
  "jira-project-board.spotlight-heading": "管理 Confluence 中的專案",
  "jira-project-board.spotlight-try-now": "立即試用",
  "jira-project-board.success-icon-label": "成功",
  "jira-project-board.template-select-action": "開始使用",
  "jira-project-board.template-select-business-description": "管理行銷、銷售、HR 等等的工作",
  "jira-project-board.template-select-business-title": "業務",
  "jira-project-board.template-select-description": "您可以隨時變更",
  "jira-project-board.template-select-kanban-description": "輕鬆查看並將工作從「待處理」移到「完成」",
  "jira-project-board.template-select-kanban-title": "Kanban",
  "jira-project-board.template-select-scrum-description": "規劃、管理和完成衝刺",
  "jira-project-board.template-select-scrum-title": "Scrum",
  "jira-project-board.template-select-title": "選取範本以開始使用",
  "jira-project-board.trial-action": "要求試用",
  "jira-project-board.trial-item-request": "要求管理員的核准以試用 Jira",
  "jira-project-board.trial-item-sync": "將即時資料從 Jira 同步到 Confluence 中的任何文件",
  "jira-project-board.trial-item-track": "細分專案並且追蹤進度",
  "jira-project-board.trial-title": "讓專案和文件更加靠近",
  "jira-project-board.try-lozenge": "試用",
  "jira-work-create-extension.single-create-work-item.name": "建立 Jira 工作項目",
  "keyboard-shortcuts-dialog.add-blog": "新增部落格貼文",
  "keyboard-shortcuts-dialog.add-page": "新增頁面",
  "keyboard-shortcuts-dialog.autoformat.autocomplete.image-media": "影像/媒體",
  "keyboard-shortcuts-dialog.autoformat.autocomplete.link": "連結",
  "keyboard-shortcuts-dialog.autoformat.autocomplete.macro": "巨集",
  "keyboard-shortcuts-dialog.autoformat.autocomplete.mention": "提及",
  "keyboard-shortcuts-dialog.autoformat.autocomplete.mention.description": "提及",
  "keyboard-shortcuts-dialog.autoformat.font.bold": "**粗體**",
  "keyboard-shortcuts-dialog.autoformat.font.bold.description": "<b>粗體</b>",
  "keyboard-shortcuts-dialog.autoformat.font.italic": "*斜體*",
  "keyboard-shortcuts-dialog.autoformat.font.italic.description": "<i>斜體</i>",
  "keyboard-shortcuts-dialog.autoformat.font.monospace": "「等寬」",
  "keyboard-shortcuts-dialog.autoformat.font.monospace.description": "等寬",
  "keyboard-shortcuts-dialog.autoformat.font.strikethrough": "~~刪除線~~",
  "keyboard-shortcuts-dialog.autoformat.font.strikethrough.description": "<s>刪除線</s>",
  "keyboard-shortcuts-dialog.autoformat.icons.checkmark": "✅",
  "keyboard-shortcuts-dialog.autoformat.icons.smile": "🙂",
  "keyboard-shortcuts-dialog.autoformat.list.bullet": "項目符號清單",
  "keyboard-shortcuts-dialog.autoformat.list.numbered": "編號清單",
  "keyboard-shortcuts-dialog.autoformat.list.task": "任務",
  "keyboard-shortcuts-dialog.autoformat.style.heading1": "標題 1",
  "keyboard-shortcuts-dialog.autoformat.style.heading3": "標題 3",
  "keyboard-shortcuts-dialog.autoformat.style.quote": "引述",
  "keyboard-shortcuts-dialog.autoformat.table.simple": "簡單表格",
  "keyboard-shortcuts-dialog.autoformat.table.with-header": "含標頭的表格",
  "keyboard-shortcuts-dialog.autoformatting-tab": "自動設定格式",
  "keyboard-shortcuts-dialog.cmd.mac": "Cmd",
  "keyboard-shortcuts-dialog.cmd.win": "Ctrl",
  "keyboard-shortcuts-dialog.comment": "留言",
  "keyboard-shortcuts-dialog.create-content": "建立內容",
  "keyboard-shortcuts-dialog.ctrl": "Ctrl",
  "keyboard-shortcuts-dialog.down.arrow": "↓",
  "keyboard-shortcuts-dialog.edit": "編輯",
  "keyboard-shortcuts-dialog.edit-labels": "編輯標籤",
  "keyboard-shortcuts-dialog.editing-actions.find-and-replace": "尋找與取代",
  "keyboard-shortcuts-dialog.editing-actions.find-and-replace-key": "尋找與取代",
  "keyboard-shortcuts-dialog.editing-actions.preview": "預覽",
  "keyboard-shortcuts-dialog.editing-actions.save": "發佈",
  "keyboard-shortcuts-dialog.editing-actions.save-and-comment": "與附註一起發佈",
  "keyboard-shortcuts-dialog.editing-tab": "編輯",
  "keyboard-shortcuts-dialog.editor.autocomplete": "自動完成",
  "keyboard-shortcuts-dialog.editor.icons": "表情符號",
  "keyboard-shortcuts-dialog.editor.lists": "清單",
  "keyboard-shortcuts-dialog.editor.styles": "樣式",
  "keyboard-shortcuts-dialog.editor.tables": "表格",
  "keyboard-shortcuts-dialog.favorite-content": "最愛的內容",
  "keyboard-shortcuts-dialog.favourite-page": "我的最愛頁面",
  "keyboard-shortcuts-dialog.footer.close": "關閉",
  "keyboard-shortcuts-dialog.format.bullet-list": "項目符號清單",
  "keyboard-shortcuts-dialog.format.heading1": "標題 1",
  "keyboard-shortcuts-dialog.format.heading6": "標題 6",
  "keyboard-shortcuts-dialog.format.numbered-list": "編號清單",
  "keyboard-shortcuts-dialog.format.paragraph": "段落",
  "keyboard-shortcuts-dialog.format.quote": "引述",
  "keyboard-shortcuts-dialog.formatting-tab": "設定格式",
  "keyboard-shortcuts-dialog.formatting-tab.addColumnAfter": "在此項目後面新增欄：",
  "keyboard-shortcuts-dialog.formatting-tab.addColumnBefore": "在此項目前面新增欄：",
  "keyboard-shortcuts-dialog.formatting-tab.addRowAbove": "在上方新增列",
  "keyboard-shortcuts-dialog.formatting-tab.addRowbelow": "在下方新增列",
  "keyboard-shortcuts-dialog.formatting-tab.alignCenter": "置中對齊",
  "keyboard-shortcuts-dialog.formatting-tab.alignLeft": "靠左對齊",
  "keyboard-shortcuts-dialog.formatting-tab.alignRight": "靠右對齊",
  "keyboard-shortcuts-dialog.formatting-tab.bold": "粗體",
  "keyboard-shortcuts-dialog.formatting-tab.bulletList": "項目符號清單",
  "keyboard-shortcuts-dialog.formatting-tab.code": "程式碼",
  "keyboard-shortcuts-dialog.formatting-tab.filesAndImages": "檔案和影像",
  "keyboard-shortcuts-dialog.formatting-tab.heading1": "標題 1",
  "keyboard-shortcuts-dialog.formatting-tab.heading6": "標題 6",
  "keyboard-shortcuts-dialog.formatting-tab.highlight": "以黃色醒目提示選取的內容",
  "keyboard-shortcuts-dialog.formatting-tab.insertMarkup": "插入標記",
  "keyboard-shortcuts-dialog.formatting-tab.italic": "斜體",
  "keyboard-shortcuts-dialog.formatting-tab.link": "連結",
  "keyboard-shortcuts-dialog.formatting-tab.macro": "巨集",
  "keyboard-shortcuts-dialog.formatting-tab.numberedList": "編號清單",
  "keyboard-shortcuts-dialog.formatting-tab.panel-title.blockFormatting": "區塊格式設定",
  "keyboard-shortcuts-dialog.formatting-tab.panel-title.contentFormatting": "內容格式設定",
  "keyboard-shortcuts-dialog.formatting-tab.panel-title.textPanelTitle": "文字",
  "keyboard-shortcuts-dialog.formatting-tab.paragraph": "段落",
  "keyboard-shortcuts-dialog.formatting-tab.quote": "引述",
  "keyboard-shortcuts-dialog.formatting-tab.table": "表格",
  "keyboard-shortcuts-dialog.formatting-tab.underline": "底線",
  "keyboard-shortcuts-dialog.general-tab": "一般",
  "keyboard-shortcuts-dialog.general-tab.comment": "留言",
  "keyboard-shortcuts-dialog.general-tab.createBlogPost": "建立部落格貼文",
  "keyboard-shortcuts-dialog.general-tab.createInlineComment": "建立內嵌留言",
  "keyboard-shortcuts-dialog.general-tab.createLiveDoc": "建立即時文件",
  "keyboard-shortcuts-dialog.general-tab.createPage": "建立頁面",
  "keyboard-shortcuts-dialog.general-tab.edit": "編輯",
  "keyboard-shortcuts-dialog.general-tab.editLabels": "編輯標籤",
  "keyboard-shortcuts-dialog.general-tab.enterPresenterMode": "進入簡報者模式",
  "keyboard-shortcuts-dialog.general-tab.favoriteContent": "最愛的內容",
  "keyboard-shortcuts-dialog.general-tab.findReplace": "尋找與取代",
  "keyboard-shortcuts-dialog.general-tab.goHome": "前往首頁",
  "keyboard-shortcuts-dialog.general-tab.goToSpaceOverview": "前往空間概述",
  "keyboard-shortcuts-dialog.general-tab.nextComment": "下一則留言",
  "keyboard-shortcuts-dialog.general-tab.nextUnreadComment": "下一個未讀留言",
  "keyboard-shortcuts-dialog.general-tab.openCommentsPanel": "開啟留言面板",
  "keyboard-shortcuts-dialog.general-tab.openDetailsPanel": "開啟詳細資料面板",
  "keyboard-shortcuts-dialog.general-tab.openNotifications": "開啟通知",
  "keyboard-shortcuts-dialog.general-tab.openRecent": "開啟最近的項目",
  "keyboard-shortcuts-dialog.general-tab.openShortcutHelp": "開啟快速鍵說明",
  "keyboard-shortcuts-dialog.general-tab.openStarred": "開啟已標上星號的項目",
  "keyboard-shortcuts-dialog.general-tab.previousComment": "上一則留言",
  "keyboard-shortcuts-dialog.general-tab.publish": "發布",
  "keyboard-shortcuts-dialog.general-tab.publishWithNote": "與附註一起發佈",
  "keyboard-shortcuts-dialog.general-tab.quickInsert": "快速插入",
  "keyboard-shortcuts-dialog.general-tab.quickSearch": "快速搜尋",
  "keyboard-shortcuts-dialog.general-tab.rovoChat": "開啟 Rovo 聊天",
  "keyboard-shortcuts-dialog.general-tab.share": "分享",
  "keyboard-shortcuts-dialog.general-tab.toggleInlineComments": "切換內嵌留言",
  "keyboard-shortcuts-dialog.general-tab.toggleSidebar": "切換側邊欄",
  "keyboard-shortcuts-dialog.general-tab.viewAttachments": "檢視附件",
  "keyboard-shortcuts-dialog.general-tab.watch": "追蹤",
  "keyboard-shortcuts-dialog.global-tab.panel-title.contentActions": "內容動作",
  "keyboard-shortcuts-dialog.global-tab.panel-title.globalActions": "全域動作",
  "keyboard-shortcuts-dialog.go-to-dashboard": "前往儀表板",
  "keyboard-shortcuts-dialog.go-to-space-overview": "前往空間概述",
  "keyboard-shortcuts-dialog.left.arrow": "←",
  "keyboard-shortcuts-dialog.link-to-content": "連結至內容",
  "keyboard-shortcuts-dialog.link-to-page": "連結至頁面",
  "keyboard-shortcuts-dialog.markdown-tab": "Markdown",
  "keyboard-shortcuts-dialog.markdown-tab.actionItem": "交辦事項",
  "keyboard-shortcuts-dialog.markdown-tab.bold": "粗體",
  "keyboard-shortcuts-dialog.markdown-tab.bulletList": "項目符號清單",
  "keyboard-shortcuts-dialog.markdown-tab.checkMarkIcon": "✅",
  "keyboard-shortcuts-dialog.markdown-tab.code": "程式碼",
  "keyboard-shortcuts-dialog.markdown-tab.codeSnippet": "程式碼片段",
  "keyboard-shortcuts-dialog.markdown-tab.decision": "決策",
  "keyboard-shortcuts-dialog.markdown-tab.divider": "分隔線",
  "keyboard-shortcuts-dialog.markdown-tab.emoji": "表情符號",
  "keyboard-shortcuts-dialog.markdown-tab.heading1": "標題 1",
  "keyboard-shortcuts-dialog.markdown-tab.heading2": "標題 2",
  "keyboard-shortcuts-dialog.markdown-tab.heading36": "標題 (3-6)",
  "keyboard-shortcuts-dialog.markdown-tab.imageOrMedia": "圖片或媒體",
  "keyboard-shortcuts-dialog.markdown-tab.italic": "斜體",
  "keyboard-shortcuts-dialog.markdown-tab.link": "連結",
  "keyboard-shortcuts-dialog.markdown-tab.macro": "巨集",
  "keyboard-shortcuts-dialog.markdown-tab.mention": "提及",
  "keyboard-shortcuts-dialog.markdown-tab.monospace": "等寬",
  "keyboard-shortcuts-dialog.markdown-tab.numberedList": "編號清單",
  "keyboard-shortcuts-dialog.markdown-tab.panel-title.autoComplete": "自動完成",
  "keyboard-shortcuts-dialog.markdown-tab.panel-title.emoticons": "表情符號",
  "keyboard-shortcuts-dialog.markdown-tab.panel-title.lists": "清單",
  "keyboard-shortcuts-dialog.markdown-tab.panel-title.tables": "表格",
  "keyboard-shortcuts-dialog.markdown-tab.panel-title.text": "文字",
  "keyboard-shortcuts-dialog.markdown-tab.quote": "引述",
  "keyboard-shortcuts-dialog.markdown-tab.redo": "重做",
  "keyboard-shortcuts-dialog.markdown-tab.simpleTable": "簡單表格",
  "keyboard-shortcuts-dialog.markdown-tab.smileIcon": "🙂",
  "keyboard-shortcuts-dialog.markdown-tab.strikethrough": "刪除線",
  "keyboard-shortcuts-dialog.markdown-tab.tableWithHeader": "含標頭的表格",
  "keyboard-shortcuts-dialog.markdown-tab.task": "任務",
  "keyboard-shortcuts-dialog.markdown-tab.undo": "復原",
  "keyboard-shortcuts-dialog.minus": "-",
  "keyboard-shortcuts-dialog.navigation-tab": "導覽",
  "keyboard-shortcuts-dialog.navigation-tab.goHome": "前往首頁",
  "keyboard-shortcuts-dialog.navigation-tab.goToSpaceOverview": "前往空間概述",
  "keyboard-shortcuts-dialog.navigation-tab.navigateToEditorToolbar": "導覽至編輯器工具列",
  "keyboard-shortcuts-dialog.navigation-tab.navigateToFloatingToolbar": "導覽至浮動工具列",
  "keyboard-shortcuts-dialog.navigation-tab.nextComment": "下一則留言",
  "keyboard-shortcuts-dialog.navigation-tab.nextUnreadComment": "下一個未讀留言",
  "keyboard-shortcuts-dialog.navigation-tab.openCommentsPanel": "開啟留言面板",
  "keyboard-shortcuts-dialog.navigation-tab.openNotifications": "開啟通知",
  "keyboard-shortcuts-dialog.navigation-tab.openRecent": "開啟最近的項目",
  "keyboard-shortcuts-dialog.navigation-tab.openShortcutHelp": "開啟快速鍵說明",
  "keyboard-shortcuts-dialog.navigation-tab.openStarred": "開啟已標上星號的項目",
  "keyboard-shortcuts-dialog.navigation-tab.panel-title.commentsNavigation": "留言導覽",
  "keyboard-shortcuts-dialog.navigation-tab.panel-title.confluenceNavigation": "Confluence 導覽",
  "keyboard-shortcuts-dialog.navigation-tab.previousComment": "上一則留言",
  "keyboard-shortcuts-dialog.navigation-tab.quickSearch": "快速搜尋",
  "keyboard-shortcuts-dialog.navigation-tab.showContentDetails": "顯示內容詳細資料",
  "keyboard-shortcuts-dialog.navigation-tab.toggleInlineComments": "切換內嵌留言",
  "keyboard-shortcuts-dialog.navigation-tab.toggleSidebar": "切換側邊欄",
  "keyboard-shortcuts-dialog.next-inline-comment": "下一個內嵌留言",
  "keyboard-shortcuts-dialog.next-unread-comment": "下一個未讀取的內嵌註解",
  "keyboard-shortcuts-dialog.open-notifications": "開啟通知",
  "keyboard-shortcuts-dialog.open-recent": "開啟最近的項目",
  "keyboard-shortcuts-dialog.open-shortcuts-help": "開啟快速鍵說明",
  "keyboard-shortcuts-dialog.open-starred": "開啟已標上星號的項目",
  "keyboard-shortcuts-dialog.opt.mac": "Opt",
  "keyboard-shortcuts-dialog.opt.win": "Alt",
  "keyboard-shortcuts-dialog.panel-title.block-formatting": "區塊格式設定",
  "keyboard-shortcuts-dialog.panel-title.font-formatting": "字型格式設定",
  "keyboard-shortcuts-dialog.panel-title.global-shortcuts": "全域快速鍵",
  "keyboard-shortcuts-dialog.panel-title.page-blog-actions": "內容動作",
  "keyboard-shortcuts-dialog.panel-title.rich-formatting": "多樣的格式設定",
  "keyboard-shortcuts-dialog.plus": "+",
  "keyboard-shortcuts-dialog.presenterMode": "進入簡報者模式",
  "keyboard-shortcuts-dialog.prev-inline-comment": "上一個內嵌留言",
  "keyboard-shortcuts-dialog.quick-search": "快速搜尋",
  "keyboard-shortcuts-dialog.rich-format.add-column-after": "在此項目後面新增欄：",
  "keyboard-shortcuts-dialog.rich-format.add-row-above": "在上方新增列",
  "keyboard-shortcuts-dialog.rich-format.add-row-below": "在下方新增列",
  "keyboard-shortcuts-dialog.rich-format.column-before": "在此項目前面新增欄：",
  "keyboard-shortcuts-dialog.rich-format.files-and-images": "檔案和影像",
  "keyboard-shortcuts-dialog.rich-format.insert-markup": "插入標記",
  "keyboard-shortcuts-dialog.rich-format.link": "連結",
  "keyboard-shortcuts-dialog.rich-format.macro": "巨集",
  "keyboard-shortcuts-dialog.rich-format.table": "表格",
  "keyboard-shortcuts-dialog.right.arrow": "→",
  "keyboard-shortcuts-dialog.share": "分享",
  "keyboard-shortcuts-dialog.shift": "Shift",
  "keyboard-shortcuts-dialog.shortcuts-connector": "或者",
  "keyboard-shortcuts-dialog.switcher.enable-general-shortcuts": "啟用一般快速鍵",
  "keyboard-shortcuts-dialog.tables-tab": "表格",
  "keyboard-shortcuts-dialog.tables-tab.decreaseTableOrMediaSize": "減少表格或媒體大小",
  "keyboard-shortcuts-dialog.tables-tab.focusTableResizeHandle": "焦點表格調整大小控點",
  "keyboard-shortcuts-dialog.tables-tab.increaseTableOrMediaSize": "增加表格或媒體大小",
  "keyboard-shortcuts-dialog.tables-tab.insertTableColumn": "插入桌面欄",
  "keyboard-shortcuts-dialog.tables-tab.insertTableRow": "插入桌面列",
  "keyboard-shortcuts-dialog.tables-tab.openCellOptions": "開啟儲存格選項",
  "keyboard-shortcuts-dialog.tables-tab.panel-title.tableAutoformatting": "表格自動格式設定",
  "keyboard-shortcuts-dialog.tables-tab.panel-title.tableNavigation": "表格導覽",
  "keyboard-shortcuts-dialog.tables-tab.selectTableColumn": "選取表格欄",
  "keyboard-shortcuts-dialog.tables-tab.selectTableRow": "選取表格列",
  "keyboard-shortcuts-dialog.tables-tab.simpleTable": "簡單表格",
  "keyboard-shortcuts-dialog.tables-tab.tableWithHeader": "含標頭的表格",
  "keyboard-shortcuts-dialog.title": "鍵盤快速鍵",
  "keyboard-shortcuts-dialog.toggle-space-sidebar": "切換側邊欄",
  "keyboard-shortcuts-dialog.toggle-space-sidebar-from-edit": "從編輯器切換側邊欄",
  "keyboard-shortcuts-dialog.toggleInlineComment": "切換內嵌留言",
  "keyboard-shortcuts-dialog.toggleInlineCommentEditor": "從編輯器切換內嵌留言",
  "keyboard-shortcuts-dialog.up.arrow": "↑",
  "keyboard-shortcuts-dialog.view-attachments": "檢視附件",
  "keyboard-shortcuts-dialog.watch-content": "追蹤",
  "keyboard-shortcuts-dialog.whiteboards-tab": "白板",
  "keyboard-shortcuts-dialog.whiteboards-tab.addALink": "新增連結",
  "keyboard-shortcuts-dialog.whiteboards-tab.bigNudgeElement": "大幅推動元素",
  "keyboard-shortcuts-dialog.whiteboards-tab.bringToFront": "帶到前面",
  "keyboard-shortcuts-dialog.whiteboards-tab.copy": "複製",
  "keyboard-shortcuts-dialog.whiteboards-tab.createJiraIssue": "建立 Jira 議題",
  "keyboard-shortcuts-dialog.whiteboards-tab.cut": "剪下",
  "keyboard-shortcuts-dialog.whiteboards-tab.delete": "刪除",
  "keyboard-shortcuts-dialog.whiteboards-tab.duplicate": "複製",
  "keyboard-shortcuts-dialog.whiteboards-tab.ellipseTool": "橢圓工具",
  "keyboard-shortcuts-dialog.whiteboards-tab.exitFullscreenMode": "退出全螢幕模式",
  "keyboard-shortcuts-dialog.whiteboards-tab.fullscreenMode": "全螢幕模式",
  "keyboard-shortcuts-dialog.whiteboards-tab.handTool": "手掌工具",
  "keyboard-shortcuts-dialog.whiteboards-tab.lineTool": "線條工具",
  "keyboard-shortcuts-dialog.whiteboards-tab.lockUnlock": "鎖定/解除鎖定",
  "keyboard-shortcuts-dialog.whiteboards-tab.moveWhiteboard": "移動白板",
  "keyboard-shortcuts-dialog.whiteboards-tab.nudgeElement": "推動元素",
  "keyboard-shortcuts-dialog.whiteboards-tab.panel-title.advanced": "進階",
  "keyboard-shortcuts-dialog.whiteboards-tab.panel-title.edit": "編輯",
  "keyboard-shortcuts-dialog.whiteboards-tab.panel-title.navigate": "導覽",
  "keyboard-shortcuts-dialog.whiteboards-tab.panel-title.tools": "工具",
  "keyboard-shortcuts-dialog.whiteboards-tab.paste": "貼上",
  "keyboard-shortcuts-dialog.whiteboards-tab.redo": "重做",
  "keyboard-shortcuts-dialog.whiteboards-tab.selectAll": "全選",
  "keyboard-shortcuts-dialog.whiteboards-tab.selectTool": "選取工具",
  "keyboard-shortcuts-dialog.whiteboards-tab.sendToBack": "送往後方",
  "keyboard-shortcuts-dialog.whiteboards-tab.showHideUI": "顯示/隱藏 UI",
  "keyboard-shortcuts-dialog.whiteboards-tab.stickyTool": "便利貼工具",
  "keyboard-shortcuts-dialog.whiteboards-tab.textBoxTool": "文字方塊工具",
  "keyboard-shortcuts-dialog.whiteboards-tab.toggleComments": "切換留言",
  "keyboard-shortcuts-dialog.whiteboards-tab.undo": "復原",
  "keyboard-shortcuts-dialog.whiteboards-tab.zoomInOut": "放大/縮小",
  "keyboard-shortcuts-dialog.whiteboards-tab.zoomTo100": "縮放至 100％",
  "keyboard-shortcuts-dialog.whiteboards-tab.zoomToFit": "縮放至合適大小",
  "keyboard-shortcuts-dialog.whiteboards-tab.zoomToSelection": "縮放至選取範圍",
  "labels.count.tooltip": "{count, plural, other {{count} 個標籤}}",
  "labels.dialog.close": "關閉",
  "labels.error.generic": "請重新整理，然後再試一次。",
  "labels.error.title.generic": "嗯...這並沒有作用",
  "labels.error.validation.invalid-character": "標籤不能包含「{invalidChar}」字元",
  "labels.error.validation.length": "標籤的字元數必須在 255 個以內。",
  "labels.error.validation.tilde": "標籤不能以「 ~ 」字元開頭",
  "labels.help.link.text.learn-more": "深入了解",
  "labels.labels-moved-changeboarding.dismiss": "關閉",
  "labels.labels-moved-changeboarding.message": "<bold>正在尋找標籤嗎？</bold>現在可以在浮動動作列上的詳細資料面板中找到。<link>向我顯示</link>",
  "labels.labels-select.create-new-label": "建立新標籤",
  "labels.labels-select.create-new-label-already-added": "「{inputValue}」已新增至頁面",
  "labels.labels-select.create-new-label-already-added.livedocs": "已新增 {inputValue}",
  "labels.labels-select.get-labels-error": "標籤未載入。請重新整理以再試一次。",
  "labels.labels-select.input-placeholder": "搜尋或建立表格",
  "labels.labels-select.labels-search-error": "建議並未載入。請嘗試再次寫入或重新整理。",
  "labels.labels-select.template.create-new-label-already-added": "{inputValue} 已新增至範本",
  "labels.labels-select.template.labels-search-error": "無法載入建議。請嘗試再次寫入或重新整理範本。",
  "labels.modal.description": "新增或移除標籤，以協助其他人找到您的內容。",
  "labels.modal.title.add-label": "新增標籤",
  "labels.modal.title.edit-label": "編輯標籤",
  "labels.use-labels-select-props.suggested-labels": "建議的標籤",
  "labels.view-page-labels.placeholder": "新增標籤",
  "link-to-this-page-dialog.close": "關閉",
  "link-to-this-page-dialog.error": "發生錯誤。請稍後再試一次。",
  "link-to-this-page-dialog.field-label.copy-link": "複製連結",
  "link-to-this-page-dialog.field-label.copy-tiny-link": "複製簡短連結",
  "link-to-this-page-dialog.field-label.link": "連結",
  "link-to-this-page-dialog.field-label.tiny-link": "簡短連結",
  "link-to-this-page-dialog.footer": "捷徑提示：按下 <strong>{shortcut}</strong> 也會開啟此對話方塊",
  "link-to-this-page-dialog.link-copied": "已複製連結。",
  "link-to-this-page-dialog.tiny-link-copied": "已複製簡短連結。",
  "link-to-this-page-dialog.title": "連結至此內容",
  "live-pages-features.beta.lozenge": "測試版",
  "live-pages-features.byline.reactions.add.new": "新增",
  "live-pages-features.byline.reactions.add.reaction": "新增回應",
  "live-pages-features.convert-to-live-page-flag.findOutMore": "深入了解",
  "live-pages-features.convert-to-live-page-flag.findOutMore.livedocs": "了解更多有關即時文件的資訊",
  "live-pages-features.convert-to-live-page-flag.flagBody": "此頁面的更新內容現在會立即呈現、即時顯示。",
  "live-pages-features.convert-to-live-page-flag.flagBody.livedocs": "此文件的更新內容現在會立即呈現、即時顯示。",
  "live-pages-features.convert-to-live-page-flag.flagTitle": "此頁面已切換為即時頁面",
  "live-pages-features.convert-to-live-page-flag.flagTitle.livedocs": "此頁面已轉換為即時文件",
  "live-pages-features.convert-to-live-page-flag.reloadButton": "重新載入",
  "live-pages-features.convert-to-live-page-flag.switcherFlagTitle": "您已切換為即時頁面",
  "live-pages-features.convert-to-live-page-flag.switcherFlagTitle.livedocs": "您已轉換為即時文件",
  "live-pages-features.converttolivepage.draft-conversion-title-conflict.description": "此空間中已經有名為「{pageTitle}」的內容。請為這個頁面提供不重複的標題。",
  "live-pages-features.converttolivepage.draft-conversion-title-conflict.description.livedocs": "此空間中已經有名為「{pageTitle}」的內容。請為這個頁面提供不重複的標題。",
  "live-pages-features.converttolivepage.draft-conversion-title-conflict.title": "無法將草稿轉換為即時頁面",
  "live-pages-features.converttolivepage.draft-conversion-title-conflict.title.livedocs": "無法將草稿轉換為即時文件",
  "live-pages-features.converttolivepage.generic-error.title": "發生錯誤",
  "live-pages-features.converttolivepage.modal.body.hiddenComments": "頁面留言將不會顯示，但再次發布時將會重新顯示。",
  "live-pages-features.converttolivepage.modal.body.hiddenComments.livedocs": "頁尾留言將不會顯示，但會在您轉換回頁面時重新顯示。",
  "live-pages-features.converttolivepage.modal.body.instantEdits": "頁面編輯將會立即呈現、即時顯示。",
  "live-pages-features.converttolivepage.modal.body.instantEdits.livedocs": "編輯結果會立即顯示，無需發布。",
  "live-pages-features.converttolivepage.modal.body.macrosLimitation": "某些元素可能需要發布頁面，才能完整顯示和運作。",
  "live-pages-features.converttolivepage.modal.body.macrosLimitation.livedocs": "某些元素可能無法如預期般顯示。",
  "live-pages-features.converttolivepage.modal.body.savedVersions": "此頁面的目前版本和先前版本已儲存。",
  "live-pages-features.converttolivepage.modal.body.savedVersions.livedocs": "版本歷史記錄會保持儲存狀態。",
  "live-pages-features.converttolivepage.modal.body.savedVersions.viewScreen": "此頁面的目前版本和先前版本已儲存。",
  "live-pages-features.converttolivepage.modal.body.savedVersions.viewScreen.livedocs": "內容將包含任何未發布的變更，而版本歷史記錄仍會儲存。",
  "live-pages-features.converttolivepage.modal.cancelButton": "取消",
  "live-pages-features.converttolivepage.modal.confirmButton": "確認",
  "live-pages-features.converttolivepage.modal.error.contentServiceException": "要求的內容無法使用。",
  "live-pages-features.converttolivepage.modal.error.legacyPageConversionError": "由於格式過時，此頁面無法切換為即時頁面。",
  "live-pages-features.converttolivepage.modal.error.legacyPageConversionError.livedocs": "由於格式過時，此頁面無法轉換為即時文件。",
  "live-pages-features.converttolivepage.modal.error.noEditPermissions": "您沒有將其轉換為即時頁面的必要權限。",
  "live-pages-features.converttolivepage.modal.error.noEditPermissions.livedocs": "您沒有將其轉換為即時文件的必要權限。",
  "live-pages-features.converttolivepage.modal.error.pageAlreadyLive": "此頁面已經切換為即時頁面。",
  "live-pages-features.converttolivepage.modal.error.pageAlreadyLive.livedocs": "此頁面已轉換為即時文件。",
  "live-pages-features.converttolivepage.modal.error.pageNotFound": "您嘗試編輯的頁面不存在。",
  "live-pages-features.converttolivepage.modal.error.serverException": "發生未預期的錯誤。請稍後再試一次。",
  "live-pages-features.converttolivepage.modal.error.unknown": "發生錯誤。請再試一次。",
  "live-pages-features.converttolivepage.modal.error.view-screen-conversion-title-conflict": "空間中已經有內容使用此頁面的更新標題。請為這個頁面提供不重複的標題。",
  "live-pages-features.converttolivepage.modal.title": "準備好切換為即時頁面了嗎？",
  "live-pages-features.converttolivepage.modal.title.livedocs": "要將此頁面轉換為即時文件嗎？",
  "live-pages-features.editor.distinction.banner.close.button.label": "關閉編輯器橫幅",
  "live-pages-features.editor.distinction.banner.message": "您正在編輯此頁面。選取<b>更新</b>即可發布變更。",
  "live-pages-features.live-edit-lozenge.beta.label": "測試版",
  "live-pages-features.live-edit-lozenge.label": "即時",
  "live-pages-features.live-pages-mode-switcher.editing.edit-dropdown": "繼續編輯",
  "live-pages-features.live-pages-mode-switcher.editing.edit-tooltip": "編輯",
  "live-pages-features.live-pages-mode-switcher.editing.label": "編輯",
  "live-pages-features.live-pages-mode-switcher.editing.view-dropdown": "切換到檢視",
  "live-pages-features.live-pages-mode-switcher.editing.view-tooltip": "切換到檢視",
  "live-pages-features.live-pages-mode-switcher.label": "頁面模式",
  "live-pages-features.live-pages-open-beta-prompt-modal.body-description.new": "現在可以體驗<link>全新功能和升級</link>的<b>測試版</b>。",
  "live-pages-features.live-pages-open-beta-prompt-modal.body-title.new": "使用全新的 Confluence 來建立內容和協作",
  "live-pages-features.live-pages-open-beta-prompt-modal.dismiss-button": "關閉",
  "live-pages-features.live-pages-open-beta-prompt-modal.turn-on-button.new": "開始吧",
  "live-pages-features.live-pages.edit-mode-flag.description": "提示：若要切換至唯讀，請使用鍵盤快速鍵 {keyCombination}。",
  "live-pages-features.live-pages.edit-mode-flag.title": "您正在編輯此頁面",
  "live-pages-features.live-pages.edit-mode-flag.title.livedocs": "您正在編輯此即時文件",
  "live-pages-features.live-pages.view-mode-flag.description": "提示：若要開始編輯，請在鍵盤上按 {keyCombination}。",
  "live-pages-features.live-pages.view-mode-flag.title": "您正在檢視此頁面",
  "live-pages-features.live-pages.view-mode-flag.title.livedocs": "您正在檢視此即時文件",
  "live-pages-features.new.lozenge": "全新",
  "live-pages-features.site-settings-feedback.body": "您的意見非常寶貴，能讓我們知道如何更加符合您的需求。有哪些地方可以改善？{lineBreak}{lineBreak}<link>深入了解即時頁面</link>",
  "live-pages-features.site-settings-feedback.body.livedocs": "您的意見非常寶貴，能讓我們知道如何更加符合您的需求。有哪些地方可以改善？{lineBreak}{lineBreak}<link>深入了解即時文件</link>",
  "live-pages-features.site-settings-feedback.dismiss": "關閉",
  "live-pages-features.site-settings-feedback.label": "告訴我們您的體驗",
  "live-pages-features.site-settings-feedback.placeholder": "即時頁面有哪些優點？有哪裡可以改善？",
  "live-pages-features.site-settings-feedback.placeholder.livedocs": "即時文件有哪些優點？有哪些地方可以改善？",
  "live-pages-features.site-settings-feedback.title": "歡迎針對即時頁面提供意見反應",
  "live-pages-features.site-settings-feedback.title.livedocs": "歡迎針對即時文件提供意見反應",
  "live-pages-features.site-settings.benefit-body-1": "即時建立頁面，無需發布或選取「編輯」。",
  "live-pages-features.site-settings.benefit-body-2": "比以往更輕鬆快速地處理工作和協作。",
  "live-pages-features.site-settings.benefit-header": "即時頁面有哪些優點？",
  "live-pages-features.site-settings.heading": "即時頁面",
  "live-pages-features.site-settings.info-header": "這會如何影響現有頁面？",
  "live-pages-features.site-settings.opt-in-flag-body": "現有頁面保持不變。",
  "live-pages-features.site-settings.opt-out-flag-body": "現有的頁面將自動發布。",
  "live-pages-features.site-settings.opted-in-body": "<link>即時頁面</link>可讓您建立和編輯，無須發布。網站管理員可以隨時為此執行個體開啟或關閉即時頁面。",
  "live-pages-features.site-settings.opted-in-button": "關閉即時頁面",
  "live-pages-features.site-settings.opted-in-flag-title": "即時頁面已開啟",
  "live-pages-features.site-settings.opted-in-header": "目前已開啟即時頁面",
  "live-pages-features.site-settings.opted-in-out-error-flag-body": "請重新整理，然後再試一次。如果此問題持續發生，請連絡支援部門。",
  "live-pages-features.site-settings.opted-in-out-error-flag-title": "發生錯誤",
  "live-pages-features.site-settings.opted-in-out-flag-find-out-more": "深入了解",
  "live-pages-features.site-settings.opted-in-out-flag-report-issue": "回報問題",
  "live-pages-features.site-settings.opted-in.info-body-1": "您可以隨時視需要發布頁面或切換回即時頁面。",
  "live-pages-features.site-settings.opted-in.info-body-2": "如果關閉此功能，在建立時開啟該功能的即時頁面將會自動發布。",
  "live-pages-features.site-settings.opted-out-button": "開啟即時頁面",
  "live-pages-features.site-settings.opted-out-flag-title": "即時頁面已關閉",
  "live-pages-features.site-settings.opted-out-header": "開啟即時頁面，體驗嶄新的 Confluence 功能",
  "live-pages-features.site-settings.opted-out.info-body-1": "可以<b>開啟</b>即時頁面，作為這整個執行個體新頁面的預設值。現有頁面不會受到影響。",
  "live-pages-features.site-settings.opted-out.info-body-2": "開啟時，您仍然可以隨時發布頁面，或切換回即時頁面。",
  "live-pages-features.view-page-distinction-banner.message": "已發布 — <pageHistoryLink>第 {versionNumber} 版</pageHistoryLink>",
  "live-pages-features.view-page-distinction-banner.version.tooltip.message": "前往版本歷程記錄",
  "live-pages.closed-beta-changeboarding-modal-body": "我們參酌了您的寶貴意見，在近期<link>改善</link>了一些功能，希望您會喜歡。請持續關注最新消息！",
  "live-pages.closed-beta-changeboarding-modal-got-it": "知道了",
  "live-pages.closed-beta-changeboarding-modal-header": "即時頁面的成效已提升",
  "live-pages.closed-beta-changeboarding-modal-join-private-forum": "加入我們的私人論壇",
  "live-pages.closed-beta-spotlight-body": "無需發布即可建立和編輯頁面。",
  "live-pages.closed-beta-spotlight-body.livedocs": "無需發布即可建立和編輯。",
  "live-pages.closed-beta-spotlight-find-out-more": "深入了解",
  "live-pages.closed-beta-spotlight-go-to-settings": "前往設定",
  "live-pages.closed-beta-spotlight-header": "可使用即時頁面",
  "live-pages.closed-beta-spotlight-header.livedocs": "即時文件可供使用",
  "live-pages.expanded-eap-changeboarding-button-dismiss": "關閉",
  "live-pages.expanded-eap-changeboarding-button-findOutMore": "深入了解",
  "live-pages.expanded-eap-changeboarding-button-gotIt": "知道了",
  "live-pages.expanded-eap-changeboarding-button-next": "下一步",
  "live-pages.expanded-eap-changeboarding-modal-body": "此空間中的<b>新頁面</b>現在將是即時頁面。空間管理員可以隨時透過<link>空間設定</link>關閉此功能。",
  "live-pages.expanded-eap-changeboarding-modal-body-space-setting-off": "空間管理員可以隨時透過<link>空間設定</link><b>開啟此功能</b>。",
  "live-pages.expanded-eap-changeboarding-modal-body.livedocs": "您現在可以在此空間中立即建立和協作即時文件。空間管理員可以隨時透過<link>空間設定</link>將其關閉。",
  "live-pages.expanded-eap-changeboarding-modal-docs-link": "運作方式為何？",
  "live-pages.expanded-eap-changeboarding-modal-got-it": "知道了",
  "live-pages.expanded-eap-changeboarding-modal-header": "無需發布即可建立和編輯頁面",
  "live-pages.expanded-eap-changeboarding-modal-header.livedocs": "無需發布即可建立和編輯",
  "live-pages.expanded-eap-changeboarding-publishButton-body": "在適合做進一步的版本控管時發布頁面。",
  "live-pages.expanded-eap-changeboarding-publishButton-header": "還想發布嗎？",
  "live-pages.expanded-eap-changeboarding-publishButton-image-alt-text": "「發布」按鈕顯示在「更多動作」選單中",
  "live-pages.expanded-eap-changeboarding-restrictions-body": "任何人都可以檢視和編輯此即時頁面。可以隨時設為私密。",
  "live-pages.expanded-eap-changeboarding-restrictions-header": "可供協作",
  "live-search.label": "搜尋",
  "live-search.no-result-1": "我們找不到與您搜尋內容相符的結果",
  "live-search.no-result-2": "請使用不同的詞彙再試一次",
  "live-search.search-icon-label": "放大鏡",
  "live-search.search-more": "查看更多搜尋結果",
  "live-search.tooltip": "即時搜尋巨集",
  "local-storage-quota-subscriber.flag.quota-exceeded.description": "我們注意到可能會影響您的 Confluence 體驗的問題。請選取下方的「重新整理」以進行修正。",
  "local-storage-quota-subscriber.flag.quota-exceeded.title": "我們遇到了問題",
  "local-storage-quota-subscriber.flag.refresh.title": "重新整理",
  "loom-onboarding.create.content.globalCreate.spotlight.body": "記錄此頁面的逐步流程，以分享更新和進度。",
  "loom-onboarding.create.content.spotlight.body": "使用可分享的非同步影片，說明一次此頁面的背景資訊。",
  "loom-onboarding.create.content.spotlight.dismissButton": "關閉",
  "loom-onboarding.create.content.spotlight.recordButton": "錄製",
  "loom-onboarding.editor-toolbar-button-spotlight.content": "錄製 Loom 影片以加入背景資訊或內容逐步說明。",
  "loom-onboarding.editor-toolbar-button-spotlight.dismissButton": "關閉",
  "loom-onboarding.editor-toolbar-button-spotlight.tryItOutButton": "試試看",
  "loom-onboarding.inline-comment-button-spotlight.content": "使用非同步影片，瀏覽您的問題或留言。",
  "loom-onboarding.inline-comment-button-spotlight.dismissButton": "關閉",
  "loom-onboarding.inline-comment-button-spotlight.tryItOutButton": "試試看",
  "loom-onboarding.loom-migration-modal.emigration-modal-header": "您的試用延長已開始",
  "loom-onboarding.loom-migration-modal.main-image-alt-text": "使用者在 Confluence 中錄製 Loom 影片。",
  "loom-onboarding.loom-migration-modal.migration-close-modal-button-text": "關閉",
  "loom-onboarding.loom-migration-modal.migration-modal-body-text": "您現在可以選擇透過新增付款詳細資料來進行升級。",
  "loom-onboarding.loom-migration-modal.migration-timeline-item-one": "今天：試用已開始",
  "loom-onboarding.loom-migration-modal.migration-timeline-item-one-description": "您現在可以進行升級。您將開始收到試用電子郵件。",
  "loom-onboarding.loom-migration-modal.migration-timeline-item-two": "2024 年 12 月 18 日：試用結束",
  "loom-onboarding.loom-migration-modal.migration-timeline-item-two-description": "除非您在此日期前新增付款詳細資料，否則您將降級為 Free 方案。",
  "loom-onboarding.loom-migration-modal.premigration-close-modal-text": "好的，明白了",
  "loom-onboarding.loom-migration-modal.premigration-modal-body-text": "為了感謝您的參與，您將獲得 Loom Business + AI 的延長試用。試用開始後，您將在 Confluence 和 Jira 中獲得更多功能。您也可以在 <a>admin.atlassian.com</a> 上管理使用者、訂閱和付款。",
  "loom-onboarding.loom-migration-modal.premigration-modal-header": "Confluence 測試版中的 Loom 即將結束",
  "loom-onboarding.loom-migration-modal.premigration-payments-button-text": "新增付款詳細資料",
  "loom-onboarding.loom-migration-modal.premigration-timeline-item-one": "2024 年 10 月 16 日至 31 日：延長開始",
  "loom-onboarding.loom-migration-modal.premigration-timeline-item-one-description": "您的延長期會在此期間開始。一旦開始，您將會收到與試用相關的電子郵件。",
  "loom-onboarding.loom-migration-modal.premigration-timeline-item-two": "2024 年 12 月 18 日：您的 Business + AI 試用結束",
  "loom-onboarding.loom-migration-modal.premigration-timeline-item-two-description": "除非您在此日期前新增付款詳細資料，否則您將降級為 Free 方案。",
  "loom-onboarding.page-header-button-spotlight.dismissButton": "關閉",
  "loom-onboarding.page-header-button-spotlight.ga-button-text": "錄製",
  "loom-onboarding.page-header-button-spotlight.ga-content": "錄製 Loom 影片，以針對內容建立您個人的逐步說明。",
  "loom-utils.error-flag.description.be-ff-not-enabled-yet": "最近已啟用 Loom。請在數分鐘之後再試一次。",
  "loom-utils.error-flag.description.incompatible-browser": "您目前使用的瀏覽器與 Loom 不相容 (或者您可以嘗試在私密/無痕模式下使用)。<a>哪些瀏覽器是相容的？</a>",
  "loom-utils.error-flag.description.loom-user-not-created-yet": "Loom 已啟用，只需要幾分鐘即可完成設定。您可以稍後再次嘗試錄製。",
  "loom-utils.error-flag.description.no-media-stream-support": "您可能需要嘗試不同的瀏覽器。<a>哪些瀏覽器是相容的？</a>",
  "loom-utils.error-flag.description.recording-already-in-progress": "完成目前的 Loom 影片，以便開始其他影片。",
  "loom-utils.error-flag.description.sdk-failed-to-initialize": "請稍候並重新整理，以再試一次。",
  "loom-utils.error-flag.description.sdk-not-initialized": "立即嘗試再次開始錄製。",
  "loom-utils.error-flag.description.third-party-cookie-disabled": "檢查您是否已啟用第三方 Cookie，然後再試一次。",
  "loom-utils.error-flag.description.unexpected-auth-token-failure": "Loom 錄製工具發生錯誤。請稍後再試一次，或連絡 Atlassian 支援人員尋求協助。",
  "loom-utils.error-flag.title.cannot-start": "我們無法開始您的錄製",
  "loom-utils.error-flag.title.not-ready": "Loom 錄製工具並未準備就緒",
  "loom-utils.error-flag.title.recording-already-in-progress": "已在錄製中",
  "loom-utils.loom-ad-control.dismiss-flag-description": "此接觸點以後會較少出現在這裡。",
  "loom-utils.loom-ad-control.dismiss-flag-title": "知道了，謝謝您告訴我們",
  "loom-utils.loom-ad-control.privacy-policy": "進一步了解您所適用的 Atlassian 資料隱私權",
  "loom-utils.loom-ad-control.reasons-modal-bullet-one": "您團隊的規模",
  "loom-utils.loom-ad-control.reasons-modal-bullet-two": "您現有的 Atlassian 產品",
  "loom-utils.loom-ad-control.reasons-modal-explanation": "我們認為 <strong>Loom</strong> 將提高您團隊的生產力。這項建議的依據是：",
  "loom-utils.loom-ad-control.reasons-modal-title": "為什麼我會看到此內容？",
  "loom-utils.loom-cross-sell-popup-card.crossJoinCTA": "立即試用",
  "loom-utils.loom-cross-sell-popup-card.tryNow": "立即試用",
  "loom-utils.non-mastered-user.modal.body.bullet1": "您所有現有的 Loom 影片都會保留在原位",
  "loom-utils.non-mastered-user.modal.body.bullet2": "開始錄製，然後直接在 Confluence 中嵌入 Loom",
  "loom-utils.non-mastered-user.modal.body.bullet3": "從 Atlassian 管理您的 Loom 設定檔",
  "loom-utils.non-mastered-user.modal.body.v2": "我們還無法將您新增到 Confluence 中的 Loom 測試版，因為您已經擁有此電子郵件的 Loom 帳戶。請放心，只需繼續像以前一樣建立 Loom，您就可以透過將連結貼到 Confluence，與您的團隊分享。當我們準備好合併您的 Loom 和 Confluence 帳戶時，將會通知您。",
  "loom-utils.non-mastered-user.modal.body.v3": "合併您的 {email} 帳戶，以使用統一的設定檔管理和專屬整合功能。",
  "loom-utils.non-mastered-user.modal.closeButton": "知道了",
  "loom-utils.non-mastered-user.modal.heading.v2": "我們看到您已經擁有 Loom 帳戶",
  "loom-utils.non-mastered-user.modal.heading.v3": "合併您的 Loom 和 Atlassian 設定檔",
  "loom-utils.non-mastered-user.modal.primary-action": "開始使用",
  "loom-utils.non-mastered-user.modal.secondary-action": "深入了解",
  "loom-utils.non-mastered-user.modal.x-button-label": "關閉強制回應",
  "manage-pages.automation.change.boarding.content": "智慧型按鈕可簡化複雜的工作流程。使用自動化規則來提高效率，讓任何人都能觸發複雜的動作。",
  "manage-pages.automation.change.boarding.cta": "顯示方法",
  "manage-pages.automation.change.boarding.dismiss": "關閉",
  "manage-pages.automation.change.boarding.header": "此處提供智慧型按鈕",
  "manage-pages.automation.on.boarding.content": "自動化重複性任務，例如建立標籤、提醒等等",
  "manage-pages.automation.on.boarding.dismiss": "確定",
  "manage-pages.automation.on.boarding.heading": "Free 和 Standard 方案上現已可使用自動化功能",
  "manage-pages.automation.on.boarding.learn-more": "深入了解自動化",
  "manage-pages.charlie-table.bulk-actions-controller.automation-cta-label": "自動化",
  "manage-pages.charlie-table.bulk-actions-controller.deselect-all": "全部取消選取",
  "manage-pages.charlie-table.bulk-actions-controller.selection-warning": "選取警告",
  "manage-pages.charlie-table.bulk-actions-controller.title": "大量動作",
  "manage-pages.charlie-table.bulk-actions-controller.total-selected": "總共有 {count} 個",
  "manage-pages.charlie-table.bulk-actions-row.back-to-top-button.aria-label": "返回最上方",
  "manage-pages.charlie-table.bulk-actions-row.back-to-top-button.tooltip": "返回大量動作和表格篩選條件",
  "manage-pages.charlie-table.bulk-actions-row.back-to-top-button.tooltip.no-rows-selected": "返回表格篩選條件",
  "manage-pages.charlie-table.bulk-actions-row.no-rows-selected": "選取資料列進行大量動作",
  "manage-pages.charlie-table.content-type.database": "資料庫",
  "manage-pages.charlie-table.content-type.embed": "智慧連結",
  "manage-pages.charlie-table.content-type.folder": "資料夾",
  "manage-pages.charlie-table.content-type.live-doc": "即時文件",
  "manage-pages.charlie-table.content-type.page": "頁面",
  "manage-pages.charlie-table.content-type.whiteboard": "白板",
  "manage-pages.charlie-table.label-cell.remove-action.error-flag.description": "請確保您擁有正確的權限",
  "manage-pages.charlie-table.label-cell.remove-action.error-flag.title": "標籤移除失敗",
  "manage-pages.charlie-table.label-cell.remove-action.success-flag.title": "標籤已成功移除",
  "manage-pages.charlie-table.label-cell.remove-button.label": "移除",
  "manage-pages.charlie-table.owner-cell.change-owner.tooltip.label": "變更負責人",
  "manage-pages.charlie-table.owner-cell.update-action.error-flag.description": "請確保您擁有正確的權限，而且新負責人是空間的成員",
  "manage-pages.charlie-table.owner-cell.update-action.error-flag.title": "變更負責人更新失敗",
  "manage-pages.charlie-table.owner-cell.update-action.success-flag.title": "內容負責人已成功更新",
  "manage-pages.charlie-table.status-cell.change-owner.tooltip.label": "變更狀態",
  "manage-pages.charlie-table.status-cell.remove-status-option.label": "移除狀態",
  "manage-pages.charlie-table.status-cell.update-action.error-flag.description": "請確保您擁有正確的權限，然後再試一次",
  "manage-pages.charlie-table.status-cell.update-action.error-flag.title": "內容狀態更新失敗",
  "manage-pages.charlie-table.status-cell.update-action.success-flag.title": "內容狀態已成功更新",
  "manage-pages.charlie-table.title-cell.rename-action.error-flag.description": "請確保您擁有正確的權限，且新標題未重複",
  "manage-pages.charlie-table.title-cell.rename-action.error-flag.title": "內容標題更新失敗",
  "manage-pages.charlie-table.title-cell.rename-action.success-flag.title": "內容標題已成功更新",
  "manage-pages.charlie-table.title-cell.rename-button.label": "重新命名",
  "manage-pages.fields.add-to-view.tooltip": "新增至檢視畫面",
  "manage-pages.fields.column-dropdown.title": "欄",
  "manage-pages.fields.disabled-field.tooltip": "您無法隱藏此欄位",
  "manage-pages.fields.dropdown.title": "顯示欄",
  "manage-pages.fields.remove-from-view.tooltip": "在檢視畫面中隱藏",
  "manage-pages.fields.side-panel-button.text": "檢視設定",
  "manage-pages.filtered-table.error.message.query": "我們無法載入此空間的內容。",
  "manage-pages.filters.active-owner.placeholder": "搜尋作用中的負責人",
  "manage-pages.filters.active-owners-button.label": "作用中",
  "manage-pages.filters.all-filters.clear-button": "清除",
  "manage-pages.filters.all-owners.label": "全部 (最多 100 個)",
  "manage-pages.filters.all-owners.trigger.label": "所有已停用的負責人",
  "manage-pages.filters.content-status.placeholder": "搜尋狀態",
  "manage-pages.filters.content-status.prefix": "狀態",
  "manage-pages.filters.content-type.database": "資料庫",
  "manage-pages.filters.content-type.embed": "智慧連結",
  "manage-pages.filters.content-type.folder": "資料夾",
  "manage-pages.filters.content-type.livedocs": "即時文件",
  "manage-pages.filters.content-type.page": "頁面",
  "manage-pages.filters.content-type.pages-livedocs": "頁面和即時文件",
  "manage-pages.filters.content-type.placeholder": "搜尋類型",
  "manage-pages.filters.content-type.prefix": "類型",
  "manage-pages.filters.content-type.whiteboard": "白板",
  "manage-pages.filters.content-under.placeholder": "搜尋頁面",
  "manage-pages.filters.content-under.prefix": "底下的內容",
  "manage-pages.filters.contributor.placeholder": "搜尋參與者",
  "manage-pages.filters.contributor.prefix": "參與者",
  "manage-pages.filters.created-date.label": "已建立",
  "manage-pages.filters.date-range-select.from-input-label": "從",
  "manage-pages.filters.date-range-select.placeholder-text": "日期",
  "manage-pages.filters.date-range-select.to-input-label": "到",
  "manage-pages.filters.former-users-option": "先前的使用者",
  "manage-pages.filters.inactive-owner.placeholder": "搜尋已停用的負責人",
  "manage-pages.filters.inactive-owners-button.label": "已停用",
  "manage-pages.filters.label.placeholder": "搜尋標籤",
  "manage-pages.filters.label.prefix": "標籤",
  "manage-pages.filters.last-active.clear-button": "清除",
  "manage-pages.filters.last-active.menu-footer": "活動只會在頁面上追蹤。其他內容類型將不會顯示。",
  "manage-pages.filters.last-active.menu-footer-v2": "系統只會追蹤頁面和即時文件上的活動。不會顯示其他內容類型。",
  "manage-pages.filters.last-active.one-month.title": "超過 1 個月前",
  "manage-pages.filters.last-active.prefix": "上次使用",
  "manage-pages.filters.last-active.selection-warning": "此篩選條件無法與其他的結合。<link>深入了解</link>",
  "manage-pages.filters.last-active.seven-days.title": "超過 7 天前",
  "manage-pages.filters.last-active.six-month.title": "超過 6 個月前",
  "manage-pages.filters.last-active.three-months.title": "超過 3 個月前",
  "manage-pages.filters.last-updated.label": "上次更新",
  "manage-pages.filters.more-filters-popup.clear": "清除篩選條件",
  "manage-pages.filters.more-filters-popup.label": "更多篩選條件",
  "manage-pages.filters.multi-select.clear-filter": "清除篩選條件",
  "manage-pages.filters.owner.prefix": "負責人",
  "manage-pages.header.display-fields.text": "欄位",
  "manage-pages.header.reset-fields.text": "重設欄位",
  "manage-pages.header.reset-fields.text.v2": "重設為預設值",
  "manage-pages.inactive-pages-table.info-msg": "此列表僅限於沒有子系的頁面。<link>深入了解</link>",
  "manage-pages.inactive-pages-table.info-msg-v2": "此列表中只有沒有子系的頁面和即時文件。<link>深入了解</link>",
  "manage-pages.pagination.next.button.label": "下一步",
  "manage-pages.pagination.page-number.button.label": "頁碼",
  "manage-pages.pagination.page-results-count.label": "結果 {pageStartingItem}-{pageEndingItem}",
  "manage-pages.pagination.page-size-selector.label": "每頁的結果：",
  "manage-pages.pagination.previous.button.label": "上一頁",
  "manage-pages.parent-navigation.see-full-location": "查看完整位置",
  "manage-pages.screen-title": "內容管理員",
  "manage-pages.search-input.clear-icon-label": "清除搜尋",
  "manage-pages.search-input.label": "依標題搜尋",
  "manage-pages.space-settings-breadcrumb": "空間設定",
  "manage-pages.space-settings-breadcrumb-label": "空間設定連結",
  "manage-pages.table-state.empty.body": "移除所有篩選條件，或以較籠統的內容搜尋",
  "manage-pages.table-state.empty.title": "沒有任何項目符合您的搜尋條件",
  "manage-pages.table-state.error.body": "請稍後再試一次",
  "manage-pages.table-state.error.title": "發生錯誤",
  "manage-pages.table.activity-just-now": "剛才",
  "manage-pages.table.activity.tooltip": "{days, plural, =0 {{date} (今天)} other {{date} ({days,number} 天前)}}",
  "manage-pages.table.cell.not-applicable": "不適用",
  "manage-pages.table.contributors-column": "參與者",
  "manage-pages.table.created-date": "已建立",
  "manage-pages.table.created-date-column": "已建立",
  "manage-pages.table.cta.archive.text": "封存",
  "manage-pages.table.cta.change-owner.text": "變更負責人",
  "manage-pages.table.cta.change-status.text": "變更狀態",
  "manage-pages.table.cta.convert-page-to-live-doc.text": "轉換為即時文件",
  "manage-pages.table.cta.delete.text": "刪除",
  "manage-pages.table.labels-column": "標籤",
  "manage-pages.table.last-active-date-column": "上次使用",
  "manage-pages.table.last-updated": "上次更新",
  "manage-pages.table.last-updated-date-column": "上次更新",
  "manage-pages.table.last-viewed": "上次檢視",
  "manage-pages.table.last-viewed-date-column": "上次檢視 (1 年)",
  "manage-pages.table.last-viewed-date-column.v2": "上次檢視",
  "manage-pages.table.last-viewed-date-column.v3": "上次使用",
  "manage-pages.table.owner-column": "負責人",
  "manage-pages.table.owner-column.v2": "負責人",
  "manage-pages.table.parents-column": "位置",
  "manage-pages.table.row.info-popup.delayed-update.message": "此欄資料的更新可能需要較長時間。",
  "manage-pages.table.row.info-popup.message": "此資料僅適用於過去一年內的檢視。",
  "manage-pages.table.status-column": "狀態",
  "manage-pages.table.status.none": "無",
  "manage-pages.table.title-column": "標題",
  "manage-pages.table.type-column": "類型",
  "manage-pages.table.view-count-column": "檢視數 (1 年)",
  "manage-pages.table.view-count-column.v2": "檢視",
  "manage-watcher-dialog.error": "發生錯誤。請稍後再試一次。",
  "manage-watcher-dialog.error.title": "糟糕！",
  "manage-watcher-dialog.followers.button": "管理追蹤者",
  "manage-watcher-dialog.no.view.permission.error": "我們無法新增此追蹤者。請確定其具有此內容或空間的讀取權限。",
  "manage-watcher-dialog.remove.watcher.button": "移除",
  "manage-watcher-dialog.tab.menu.database": "資料庫",
  "manage-watcher-dialog.tab.menu.page": "頁面",
  "manage-watcher-dialog.tab.menu.page.livedocs": "頁面和即時文件",
  "manage-watcher-dialog.tab.menu.space": "空間",
  "manage-watcher-dialog.tab.menu.whiteboard": "白板",
  "manage-watcher-dialog.title": "管理追蹤者",
  "manage-watcher-dialog.watcher-list.user-without-view-perm-lozenge": "無法檢視",
  "manage-watcher-dialog.watcher.button": "管理追蹤者",
  "manage-watcher-dialog.watcher.footer.close": "關閉",
  "manage-watcher-dialog.watcher.footer.learn.more.link": "深入了解",
  "manage-watcher-dialog.watcher.footer.learn.more.link.aria.label": "深入了解如何管理追蹤者",
  "manage-watcher-dialog.watcher.list.load.more.button": "載入更多",
  "manage-watcher-dialog.watcher.list.no.content.watchers": "沒有追蹤者",
  "manage-watcher-dialog.watcher.list.no.space.watchers": "沒有空間追蹤者",
  "manage-watcher-dialog.watcher.right.panel.add.watchers": "新增追蹤者",
  "manage-watcher-dialog.watcher.right.panel.content.description": "這些人員會在內容變更時收到通知。",
  "manage-watcher-dialog.watcher.right.panel.content.description.unfiltered": "這些人員會在內容變更時收到通知。權限不足的使用者 (標記為無法檢視) 將不會收到通知。",
  "manage-watcher-dialog.watcher.right.panel.space.description": "這些人員會在空間中有任何內容變更時收到通知。",
  "manage-watcher-dialog.watcher.right.panel.space.description.unfiltered": "這些人員會在空間中有任何內容變更時收到通知。權限不足的使用者 (標記為無法檢視) 將不會收到通知。",
  "mentions-notifications.mention.flag.acknowledge.button": "確定",
  "mentions-notifications.mention.flag.deleted.confirmation": "知道了",
  "mentions-notifications.mention.flag.deleted.description": "{name} 將不會再收到通知",
  "mentions-notifications.mention.flag.deleted.title": "您剛才移除了一個 @ 提及",
  "mentions-notifications.mention.flag.description": "使用者會收到提及通知。",
  "mentions-notifications.mention.flag.do.not.notify.button": "不要傳送通知",
  "mentions-notifications.mention.flag.do.not.notify.failure.description": "由於發生錯誤，我們無法取消此通知。",
  "mentions-notifications.mention.flag.do.not.notify.failure.title": "發生錯誤",
  "mentions-notifications.mention.flag.dont.share.button": "不要分享",
  "mentions-notifications.mention.flag.failed.description": "若要通知使用者，請再次 @ 提及他們。",
  "mentions-notifications.mention.flag.failed.generic.title": "我們無法通知該使用者",
  "mentions-notifications.mention.flag.failed.title": "我們無法通知 {displayName}",
  "mentions-notifications.mention.flag.no.permissions.description": "該使用者無法存取此內容，因此無法讓他們知道已被您提及。",
  "mentions-notifications.mention.flag.no.permissions.multiple.mentions.title": "{numOthers, plural, other {與 {displayName}、{somebodyElse} 和其他 {numOthers,number} 人分享}}",
  "mentions-notifications.mention.flag.no.permissions.parent.restrictions.description": "該使用者無法存取父系項目，因此無法讓他們知道已被您提及。",
  "mentions-notifications.mention.flag.no.permissions.space.restrictions.description": "該使用者無法存取空間，因此無法讓他們知道已被您提及。",
  "mentions-notifications.mention.flag.no.permissions.title": "要與 {displayName} 分享嗎？",
  "mentions-notifications.mention.flag.no.permissions.two.mentions.title": "要與 {displayName} 和 {somebodyElse} 分享嗎？",
  "mentions-notifications.mention.flag.no.space.parent.permissions.description": "該使用者需要空間或父系存取權，我們才能讓他們知道已被您提及。",
  "mentions-notifications.mention.flag.no.space.parent.permissions.multiple.mentions.title": "{numOthers, plural, other {{displayName}、{somebodyElse} 和其他 {numOthers,number} 人不會收到通知}}",
  "mentions-notifications.mention.flag.no.space.parent.permissions.title": "{displayName} 不會收到通知",
  "mentions-notifications.mention.flag.no.space.parent.permissions.two.mentions.title": "{displayName} 和 {somebodyElse} 不會收到通知",
  "mentions-notifications.mention.flag.share.failed.description": "請稍後再試一次。",
  "mentions-notifications.mention.flag.share.failed.title": "我們無法與 {displayName} 共用此內容",
  "mentions-notifications.mention.flag.share.now.button": "立即共用",
  "mentions-notifications.mention.flag.title": "{displayName} 將收到通知",
  "mentions-notifications.mention.flag.title.multiple.mentions": "{numOthers, plural, other {{displayName}、{somebodyElse} 和其他 {numOthers,number} 人將收到通知}}",
  "mentions-notifications.mention.flag.title.two.mentions": "{displayName} 和 {somebodyElse} 將收到通知",
  "mentions-notifications.task.mention.flag.description": "我們會讓該使用者知道已被您指派任務。",
  "mentions-notifications.task.mention.flag.no.permissions.description": "該使用者無法存取此內容，因此無法被指派任務，也無法收到通知。",
  "mentions-notifications.task.mention.flag.no.permissions.parent.restrictions.description": "該使用者無法存取父系項目，因此無法被指派任務，也無法收到通知。",
  "mentions-notifications.task.mention.flag.no.permissions.parent.space.restrictions.description": "該使用者無法存取父系項目或空間，因此無法被指派此任務，也無法收到通知。",
  "mentions-notifications.task.mention.flag.no.permissions.space.restrictions.description": "該使用者無法存取空間，因此無法被指派任務，也無法收到通知。",
  "mentions-notifications.task.mention.flag.no.permissions.title": "要與 {displayName} 分享嗎？",
  "mentions-notifications.task.mention.flag.title": "我們將通知 {displayName}",
  "mobile-web.app.opener.button.message": "在應用程式中開啟",
  "mobile-web.comments.no.comments": "沒有留言",
  "mobile-web.comments.reply": "回覆",
  "mobile-web.comments.show.more": "顯示更多留言...",
  "mobile-web.comments.title": "留言",
  "mobile-web.content.header.date.created": "建立日期：{formattedDate}",
  "mobile-web.content.header.date.updated": "上次更新日期：{formattedDate}",
  "mobile-web.content.header.space.prefix": "已在 {space} 中發佈",
  "mobile-web.full.page.concrete.benefits.body.message": "透過 Confluence Mobile 應用程式，您可以隨時隨地收到通知、新增留言和建立項目。",
  "mobile-web.full.page.concrete.benefits.header.message": "輕鬆提高效率",
  "mobile-web.full.page.continue.to.mobile.web.button.message": "繼續前往行動版網站",
  "mobile-web.full.page.get.the.app.today.button.message": "立即取得應用程式",
  "mobile-web.full.page.italicized.your.message": "您的",
  "mobile-web.global.nav.give.feedback": "提供意見反應",
  "mobile-web.global.nav.logout": "登出",
  "mobile-web.global.nav.menu.header": "Confluence",
  "mobile-web.global.nav.switch.to.desktop": "切換至桌面版本",
  "mobile-web.unsupported.macro.desktop": "在桌面版網站上檢視 {extensionKey}",
  "modal-carousel.modal-carousel.close-modal-button": "關閉強制回應",
  "modal-carousel.modal-carousel.done-button": "完成",
  "modal-carousel.modal-carousel.next-button": "下一頁",
  "modal-carousel.modal-carousel.overlayed-button-next": "下一張投影片",
  "modal-carousel.modal-carousel.overlayed-button-previous": "上一張投影片",
  "modal-carousel.modal-carousel.skip-button": "略過",
  "modernize-changeboarding.convert-to-page-spotlight.body": "<a>即時文件</a>可以隨時轉換和發布為頁面 (並且轉換回來)。",
  "modernize-changeboarding.convert-to-page-spotlight.heading": "將任何即時文件轉換為頁面",
  "modernize-changeboarding.cross-icon-close-button.dismiss": "關閉",
  "modernize-changeboarding.floating-menu-spotlight.body": "使用<a>浮動選單</a>讓您更接近內容，加快工作速度。",
  "modernize-changeboarding.floating-menu-spotlight.heading": "留言、詳細資料等等",
  "modernize-changeboarding.last-updated-spotlight.body": "立即追蹤內容<a>上次更新</a>的時間。",
  "modernize-changeboarding.last-updated-spotlight.heading": "這裡有上次更新時間",
  "modernize-changeboarding.live-doc-modal.body": "歡迎使用新版即時文件體驗，您可以在其中工作和<strong>即時</strong>協作，無須發布。",
  "modernize-changeboarding.live-doc-modal.cta": "開始吧",
  "modernize-changeboarding.live-doc-modal.heading": "使用即時文件進行即時編輯",
  "modernize-changeboarding.nav4-collapse-spotlight.body": "選取此圖示即可展開或摺疊側邊欄。",
  "modernize-changeboarding.nav4-collapse-spotlight.heading": "顯示或隱藏側邊欄",
  "modernize-changeboarding.nav4-global-spotlight.body": "有一部分的<a>導覽</a>已移至側邊欄，您可以根據自己的特殊需求加以自訂。",
  "modernize-changeboarding.nav4-global-spotlight.heading": "在側邊欄中找到所需的一切",
  "modernize-changeboarding.nav4-space-settings-spotlight.body": "在<strong>更多動作</strong> (<strong>•••</strong>) 中尋找<strong>空間設定</strong>，您可以在該處管理權限、存取權、內容，並且存取 Premium 功能。",
  "modernize-changeboarding.nav4-space-settings-spotlight.heading": "快速存取設定等等",
  "modernize-changeboarding.share-menu-spotlight.body": "當<a>即時文件</a>啟動時，會向此空間的所有人公開。您可以隨時設為私密。",
  "modernize-changeboarding.share-menu-spotlight.heading": "建立時向所有人公開",
  "modernize-changeboarding.useSpotlightActions.back": "返回",
  "modernize-changeboarding.useSpotlightActions.done": "完成",
  "modernize-changeboarding.useSpotlightActions.next": "下一步",
  "modernize-changeboarding.useSpotlightActions.progress": "{step}/{steps}",
  "modernize-confluence-ipm-modal.body": "透過這些嶄新的更新，提升協作並盡可能發揮團隊影響力。",
  "modernize-confluence-ipm-modal.closeVideoCta": "關閉影片",
  "modernize-confluence-ipm-modal.dismissCta": "關閉",
  "modernize-confluence-ipm-modal.enableFeaturesCta": "啟用測試版功能",
  "modernize-confluence-ipm-modal.gotItCta": "知道了",
  "modernize-confluence-ipm-modal.heading": "認識<b><u>新版</u> Confluence</b>",
  "modernize-confluence-ipm-modal.headsUp": "我們將在變更推出時為您提供引導。",
  "modernize-confluence-ipm-modal.learnMoreCta": "深入了解",
  "modernize-confluence-ipm-modal.playNow": "播放影片",
  "modernize-confluence-ipm-modal.showMeCta": "向我顯示",
  "modernize-confluence-ipm-modal.showVideoCtaAlt": "播放並開啟聲音",
  "modernize-confluence-ipm-modal.videoTitle": "Loom 影片播放器",
  "move-blog-modal.flag.error.default-move-error.default.description": "請重新整理頁面，然後再次嘗試移動。如果這樣無法解決問題，請稍後再試一次。",
  "move-blog-modal.flag.error.default-move-error.default.title": "我們在移動此部落格時遇到問題",
  "move-blog-modal.flag.error.duplicate-title-error.description": "選取的空間中已有標題和日期都相同的部落格",
  "move-blog-modal.flag.error.permissions-error.description": "您沒有移動此部落格的權限",
  "move-blog-modal.flag.success.title": "已移動「{title}」",
  "move-blog-modal.footer.cancel-button": "取消",
  "move-blog-modal.footer.change-warning-set-classification": "<b>分類。</b>如果移動，此內容將繼承新目的地空間的預設分類層級。移動之後，根據目的地空間的預設分類層級，內容將被歸類為「{classification}」。",
  "move-blog-modal.footer.content-state-warning-title": "將內容移至此空間將會變更其屬性",
  "move-blog-modal.footer.continue-button": "繼續",
  "move-blog-modal.footer.move-button": "移動",
  "move-blog-modal.header.close-button": "關閉移動部落格貼文強制回應對話方塊",
  "move-blog-modal.header.modal-title": "移動目的地",
  "move-blog-modal.moving-to-disabled-blog-space.space-admin.warning.description": "若要繼續，您需要<a>重新開啟部落格。</a>",
  "move-blog-modal.moving-to-disabled-blog-space.warning.description": "若要繼續，請要求<a>空間管理員</a>重新開啟部落格。",
  "move-blog-modal.moving-to-disabled-blog-space.warning.title": "此空間不允許部落格",
  "move-pencil-button.move-blog.edit-icon-tooltip": "移動此部落格",
  "move-pencil-button.move-page.edit-icon-tooltip": "移動此項目",
  "move-pencil-button.pencil-icon.move-blog-disabled-tooltip": "您沒有移動此部落格的權限",
  "move-pencil-button.pencil-icon.move-pagedisabled-tooltip": "您沒有移動此項目的權限",
  "native-collab.collab-limit-reached-description": "您已達到使用中編輯者的數目上限，請在比較少人使用時再試一次。",
  "native-collab.collab-limit-reached-title": "您現在無法編輯此內容",
  "native-collab.collab.under.collab-limit-description": "我們會自動儲存您的變更，因此您永遠不需要按儲存。",
  "native-collab.collab.under.collab-limit-title": "準備就緒",
  "native-collab.live-pages-limit-reached-description": "您已達到使用中查閱者的數目上限，請在比較少人使用時再試一次。",
  "native-collab.live-pages-limit-reached-title": "目前無法檢視此內容。請重新載入，然後再試一次。",
  "native-collab.live-pages.under.live-pages-limit-title": "準備就緒",
  "native-collab.title-keyword-for-automation-discovery.": "會議",
  "nav-menus.error.message": "我們目前無法顯示您的選單選項。請重新整理或稍後再試一次。",
  "nav-menus.error.title": "發生錯誤",
  "nav-menus.help-menu.help-us-improve-section.give-feedback.item": "提供意見回饋",
  "nav-menus.help-menu.help-us-improve-section.raise-a-bug.item": "提出錯誤",
  "nav-menus.help-menu.help-us-improve-section.title": "協助我們改善",
  "nav-menus.mobile.app.apple.store.alt.text": "從 Apple App Store 下載",
  "nav-menus.mobile.app.google.play.alt.text": "從 Google Play 取得",
  "nav-menus.nav4-opt-out.navigation": "導覽",
  "nav-menus.nav4-opt-out.switch-back": "切換回舊版導覽",
  "nav-menus.nav4-opt-out.turn-on": "開啟新版導覽",
  "nav-menus.navigation.about.confluence.heading": "關於 Confluence",
  "nav-menus.navigation.can.connect": "Atlassian 可以連絡我來了解此意見反應",
  "nav-menus.navigation.close.text": "關閉",
  "nav-menus.navigation.dialog.mobile.app.close.text": "關閉",
  "nav-menus.navigation.dialog.mobile.app.heading": "使用相機掃描 QR 代碼以取得應用程式",
  "nav-menus.navigation.dialog.mobile.app.text": "從任何裝置開啟深色模式或新增留言。Confluence 行動應用程式可讓您保持行動力，讓您在任何場所都能展現最佳工作表現。",
  "nav-menus.navigation.feeback.description": "您的意見反應可協助我們打造更好的體驗。",
  "nav-menus.navigation.feeback.title": "謝謝您！",
  "nav-menus.navigation.feedback.placeholder": "請說明您的 Confluence 使用體驗，以便讓我們進一步改進。",
  "nav-menus.navigation.feedback.textarea.label": "告訴我們您的體驗",
  "nav-menus.navigation.no.name": "否",
  "nav-menus.navigation.send.feedback": "傳送意見反應",
  "nav-menus.navigation.thanks.description": "您的意見反應可協助我們打造更好的體驗。",
  "nav-menus.navigation.thanks.title": "謝謝您！",
  "nav-menus.navigation.yes.name": "是",
  "nav-menus.popup-menu.profile.account.heading": "帳號",
  "nav-menus.popup-menu.profile.manage-account.label": "管理帳號",
  "nav-versions-misaligned.flag": "已為所有人開啟新版導覽",
  "nav-versions-misaligned.flag.description": "因為您之前選擇退出，因此目前仍使用舊版導覽。您可以在設定中更新導覽喜好設定。",
  "nav-versions-misaligned.flag.link": "前往設定",
  "nav4-feedback.feedback-collector.custom-text-area-label": "告訴我們您為什麼要切換回舊版",
  "nav4-feedback.feedback-collector.opt-out.title": "切換回舊版導覽",
  "nav4-feedback.feedback-collector.opt-out.title-details": "您的退出讓我們深感遺憾。為了協助我們改善所有使用者的導覽功能，請分享為什麼新版導覽不適合您。",
  "nav4-feedback.feedback-collector.submit-button-label": "切換回舊版",
  "nav4-feedback.feedback-collector.title": "協助我們改善新版導覽",
  "nav4-feedback.feedback-collector.title-details": "歡迎提供新版導覽的體驗心得。",
  "nav4-feedback.feedback-collector.title-details.opt-out": "歡迎提供新版導覽的體驗心得。如果需要，您可以<a>切換回舊版導覽</a>。",
  "nav4-onboarding.changeboarding-spotlight-1.heading": "顯示或隱藏側邊欄",
  "nav4-onboarding.changeboarding-spotlight-1.text": "選取此圖示即可展開或摺疊側邊欄。",
  "nav4-onboarding.changeboarding-spotlight-2.heading": "快速存取設定等等",
  "nav4-onboarding.changeboarding-spotlight-2.text": "在<strong>更多動作</strong> (<strong>•••</strong>) 中尋找<strong>空間設定</strong>，您可以在該處管理權限、存取權、內容，並且存取 Premium 功能。",
  "nav4-onboarding.changeboarding-spotlight.back": "返回",
  "nav4-onboarding.changeboarding-spotlight.dismiss": "完成",
  "nav4-onboarding.changeboarding-spotlight.next": "下一個",
  "nav4-onboarding.changeboarding-spotlight.skip": "略過",
  "nav4-onboarding.modal.body": "我們已將所有導覽移至側邊欄，方便您前往需要的位置。<a>關於新版導覽</a>",
  "nav4-onboarding.modal.dismissButton": "確定",
  "nav4-onboarding.modal.heading": "從側邊欄開始導覽",
  "navigation-lockout.message.default": "如果您離開此頁面，您的變更將不會儲存。",
  "navigation-lockout.tabs-confirm-dialog.body": "如果您現在離開，變更將不會儲存。",
  "navigation-lockout.tabs-confirm-dialog.cancel-cta": "取消",
  "navigation-lockout.tabs-confirm-dialog.confirm-cta": "離開",
  "navigation-lockout.tabs-confirm-dialog.heading": "離開並放棄儲存嗎？",
  "navigation-search-dialog.last-updated-date": "已更新 {datetime}",
  "navigation-search-dialog.placeholder": "搜尋",
  "navigation-search-dialog.quickfind.confluenceSpace": "Confluence 空間",
  "navigation-search-dialog.suppliers.contents": "內容",
  "navigation-search-dialog.suppliers.people": "人員",
  "navigation-search-dialog.suppliers.recentlyViewed": "最近檢視的項目",
  "navigation-search-dialog.suppliers.recentlyWorkedOn": "最近處理",
  "navigation-search-dialog.suppliers.spaces": "空間",
  "navigation-search-dialog.team": "團隊",
  "navigation.adg3.user.profile.other": "我的 Confluence",
  "navigation.adg3.user.profile.user-content": "Confluence",
  "navigation.help.name": "說明",
  "navigation.help.us.improve": "協助我們改善",
  "navigation.system.help.legal": "法律",
  "network-status-listener.flag.description.ip-blocked": "請檢查您的網路連線、{refreshLink}，然後再試一次。如果此問題持續發生，請連絡您的管理員以取得協助。",
  "network-status-listener.flag.description.rate-limited": "已達到速率上限。請等待一分鐘左右，讓系統完成重設，然後{refreshLink}並再試一次。",
  "network-status-listener.flag.refresh-link-text.ip-blocked": "重新整理",
  "network-status-listener.flag.refresh-link-text.rate-limited": "重新整理",
  "network-status-listener.flag.title.ip-blocked": "存取此內容時發生問題",
  "network-status-listener.flag.title.rate-limited": "我們無法載入此內容",
  "no-permission.direct.restricted.page.confirmation.message": "此內容受到限制，但您仍可加以檢視，以便進行疑難排解。系統將會記錄您對此內容的存取，並以電子郵件通知負責人。",
  "no-permission.edit.request.sent.button.label": "已傳送編輯要求",
  "no-permission.multiple.restricted.page.confirmation.message": "您沒有此內容的檢視權限，因為該項目本身有限制，或有間接來自父系項目或空間的限制。您仍可加以檢視，以便進行疑難排解。系統將會記錄您對此內容的存取，並以電子郵件通知負責人。",
  "no-permission.page.inherited.restricted.page.confirmation.message": "此內容會繼承父系項目的限制，但您仍可加以檢視，以便進行疑難排解。系統將會記錄您對此內容的存取，並以電子郵件通知負責人。",
  "no-permission.refresh.page": "立即重新整理",
  "no-permission.request.license": "要求完整的存取權",
  "no-permission.request.to.edit.button.label": "要求編輯",
  "no-permission.request.to.edit.button.placeholder.label": "要求編輯",
  "no-permission.request.to.edit.not.sent.flag.description": "我們在提交您的編輯要求時遇到問題。請再試一次或與您的管理員連絡。",
  "no-permission.request.to.edit.not.sent.flag.title": "您的要求尚未傳送",
  "no-permission.request.to.edit.request.sent.flag.action": "知道了",
  "no-permission.request.to.edit.request.sent.flag.description": "我們已要求 {ownerName} 授予您編輯權限。一旦要求獲得核准，您就會收到一封電子郵件。",
  "no-permission.request.to.edit.request.sent.flag.title": "已傳送編輯要求",
  "no-permission.restricted.page.confirmation.button": "檢視內容",
  "no-permission.restricted.page.confirmation.title": "檢視受限制的內容？",
  "no-permission.restricted.page.edit-but-can-view.title": "您沒有編輯此內容的權限",
  "no-permission.restricted.page.edit.body.cannot-edit-can-view": "這可能是因為您沒有編輯此特定內容的權限，或是因為空間管理員並未授予您在此空間中編輯內容的權限。",
  "no-permission.restricted.page.edit.request.access.from.author": "只有部分人員能編輯此項目。\n                如果您認為您應該是其中之一，請向作者要求存取權限。",
  "no-permission.restricted.page.edit.title": "此內容的編輯有所限制",
  "no-permission.restricted.page.flag.view-content": "立即檢視內容",
  "no-permission.restricted.page.inherited.message": "這是因為其沿用父系項目的限制。空間管理員或分享此內容的人可能會授予您存取權限。",
  "no-permission.restricted.page.manual.request.access.from.author": "只有部分人員能檢視此項目。如果您認為您應該擁有存取權，請嘗試向將您帶往此處的人員尋求協助。",
  "no-permission.restricted.page.request.access": "要求存取權",
  "no-permission.restricted.page.request.access.failed.message.2": "我們在提交您的存取要求時遇到問題。請再試一次或與您的管理員連絡。",
  "no-permission.restricted.page.request.access.failed.title": "存取要求失敗",
  "no-permission.restricted.page.request.access.successful.message": "我們已要求 {ownerName} 授予您存取權。\n在要求獲得核准後，您就會收到一封電子郵件",
  "no-permission.restricted.page.request.access.successful.title.2": "已傳送要求",
  "no-permission.restricted.page.request.to-edit": "要求編輯",
  "no-permission.restricted.page.view-content": "檢視內容",
  "no-permission.restricted.page.view.request.access.from.author": "只有部分人員能檢視此項目。\n                如果您認為您應該是其中之一，請向作者要求存取權限。",
  "no-permission.restricted.page.view.title": "您碰巧遇到了受限制的內容",
  "no-permission.restricted.space.guest.message": "您是此 Confluence 網站的訪客，因此您只能存取一個空間中的內容。{learnMoreLink}",
  "no-permission.restricted.space.guest.request-access.flag-error-description": "重新整理頁面以再次提交要求，或稍後再試一次。",
  "no-permission.restricted.space.guest.request-access.flag-error-title": "未傳送要求",
  "no-permission.restricted.space.guest.request-access.flag-success-description": "如果獲得核准，管理員會傳送確認訊息給您",
  "no-permission.restricted.space.guest.request-access.flag-success-title": "已傳送授權使用者要求！",
  "no-permission.restricted.space.guest.requestAccessMessage": "訪客使用者只能存取一個空間中的內容。要求授權使用者的存取權限，以解鎖更多空間中的內容。",
  "no-permission.restricted.space.guest.title": "您沒有此內容的存取權",
  "no-permission.restricted.space.learnMore": "進一步了解訪客使用者",
  "no-permission.restricted.space.learnMoreButton": "深入了解訪客使用者",
  "no-permission.restricted.space.licensed-user.request-access.general-error-flag-description": "重新整理頁面以再次提交要求，或稍後再試一次。",
  "no-permission.restricted.space.licensed-user.request-access.general-error-flag-title": "未傳送要求",
  "no-permission.restricted.space.licensed-user.request-access.go-home-button": "前往首頁",
  "no-permission.restricted.space.licensed-user.request-access.request-access-button": "要求空間存取權",
  "no-permission.restricted.space.licensed-user.request-access.request-access-pending-button": "已要求存取權",
  "no-permission.restricted.space.licensed-user.request-access.space-creator-unavailable-error-flag-description": "此空間的存取要求功能目前無法使用。如果您需要存取權，請聯繫組織中的管理員。",
  "no-permission.restricted.space.licensed-user.request-access.space-creator-unavailable-error-flag-title": "無法要求存取",
  "no-permission.restricted.space.licensed-user.request-access.success-flag.description": "我們已經要求空間管理員授予您存取權。",
  "no-permission.restricted.space.licensed-user.request-access.success-flag.title": "已傳送要求",
  "no-permission.restricted.space.licensed-user.request-access.title": "您無法存取此空間",
  "no-permission.restricted.space.message.authenticated.licensing.in.progress": "您應該能夠在大約 30 秒後，讓頁面更新存取權。",
  "no-permission.restricted.space.message.authenticated.unlicensed": "您對 Confluence 的存取權目前受到限制。若要檢視此空間，您需要提交完整存取權的要求。\n\t\t\t  如果此空間受到限制，您可能還需要提交空間存取權的要求。",
  "no-permission.restricted.space.request.access.requestAccess": "要求完整的存取權",
  "no-permission.restricted.space.request.access.requestAccessPending": "要求待核准",
  "no-permission.restricted.space.title.authenticated.licensing.in.progress": "您的存取權要求仍在處理當中",
  "no-permission.restricted.space.title.authenticated.unlicensed": "您需要完整的 Confluence 存取權，才能檢視此空間",
  "no-permission.space.restricted.page.confirmation.message": "此內容位於受限制的空間中。您沒有此空間的權限，但您仍然可以檢視其內容以進行疑難排解。系統將會記錄您對此內容的存取，並以電子郵件通知負責人。",
  "no-permission.space.restricted.page.confirmation.title": "要檢視受限制空間中的內容嗎？",
  "not-found.description": "我們已找遍四處，但該網頁似乎不存在，可能已遭到刪除。當然，除非 URL 中有錯字 😉",
  "not-found.header": "我們找不到您要尋找的內容",
  "not-found.link.to.homepage": "前往首頁",
  "not-found.overview.blankExperience.mainBanner": "嗯，這有點奇怪。",
  "not-found.overview.blankExperience.subBanner": "此空間沒有首頁，所以沒有可在此顯示的內容。這真令人難過。",
  "not-found.overview.blankExperience.subBanner2": "立即新增首頁來讓一切變得井然有序，並使用此首頁向訪客說明此空間的所有相關內容！",
  "not-found.set.space.home": "設定空間首頁",
  "notes-card-workspace.close-button-label": "關閉",
  "notes-card-workspace.collapse-button-label": "摺疊",
  "notes-card-workspace.delete-button-label": "刪除",
  "notes-card-workspace.delete-dialog-body": "您無法加以復原。",
  "notes-card-workspace.delete-dialog-cancel": "取消",
  "notes-card-workspace.delete-dialog-confirm": "是，請刪除",
  "notes-card-workspace.delete-dialog-header": "要刪除此附註嗎？",
  "notes-card-workspace.expand-button-label": "展開",
  "notes-card-workspace.more-button-label": "更多",
  "notes-card-workspace.saving": "正在儲存",
  "notes-card-workspace.title-label": "標題",
  "notes-card-workspace.title-placeholder": "標題",
  "notes-editor.editor.placeholder": "輸入 / 即可讓此筆記變得更加酷炫。",
  "notes-sidebar.add.note.tooltip": "建立附註",
  "notes-sidebar.empty.notes.state.explanation": "需要記下一些東西嗎？那就寫下來吧。",
  "notes-sidebar.empty.notes.state.notice": "您還沒有做任何筆記！",
  "notes-sidebar.empty.search.message": "沒有結果。請嘗試其他關鍵字！",
  "notes-sidebar.max.notes.explanation": "您已達到 50 則私人筆記的上限。若您需要更多筆記，{linkToGiveFeedback}",
  "notes-sidebar.max.notes.letUsKnowLink": "請透過這裡讓我們知道。",
  "notes-sidebar.max.notes.title": "您已達到筆記上限",
  "notes-sidebar.notes.early-access": "搶先體驗",
  "notes-sidebar.notes.title": "私人筆記",
  "notes-sidebar.preview-empty-note-text": "空白筆記",
  "notes-sidebar.preview-last-updated": "更新時間：{date}",
  "notes-sidebar.search.clear.tooltip": "清除",
  "notes-sidebar.search.close.tooltip": "關閉",
  "notes-sidebar.search.icon": "搜尋圖示",
  "notes-sidebar.search.placeholder": "搜尋筆記",
  "notes-sidebar.search.tooltip": "尋找筆記",
  "notifications.site-settings.changeboarding-spotlight.action": "設定",
  "notifications.site-settings.changeboarding-spotlight.content": "新增並管理自訂電子郵件地址，以傳送您組織的 Confluence 通知。",
  "notifications.site-settings.changeboarding-spotlight.dismiss": "關閉",
  "notifications.site-settings.changeboarding-spotlight.heading": "自訂電子郵件傳送地址",
  "notifications.site-settings.email-settings-section.desc": "全站通知設定適用於 Confluence 執行個體上的每位使用者。如果關閉這些通知，個別使用者將無法重新開啟通知。",
  "notifications.site-settings.email-settings-section.error-flag-title": "發生錯誤",
  "notifications.site-settings.email-settings-section.learn-more-link": "深入了解如何訂閱電子郵件通知。",
  "notifications.site-settings.email-settings-section.save-button": "儲存電子郵件設定的變更",
  "notifications.site-settings.email-settings-section.success-flag-title": "電子郵件設定已更新",
  "notifications.site-settings.email-settings-section.title": "電子郵件設定",
  "notifications.site-settings.email-settings.recommended-emails-desc": "推薦和熱門內容的每週列表，與每位使用者可存取的空間相關。使用者只會獲得他們有權檢視的推薦內容。",
  "notifications.site-settings.email-settings.recommended-emails-toggle": "推薦電子郵件",
  "notifications.site-settings.error-flag-action": "重新整理",
  "notifications.site-settings.error-flag-description": "請稍後再試或重新整理",
  "notifications.site-settings.error-flag-title": "未儲存通知設定",
  "notifications.site-settings.page-email-address-dropdown-label": "電子郵件地址",
  "notifications.site-settings.page-email-address-save-button": "儲存變更",
  "notifications.site-settings.page-email-section-add-custom-email-admin-hub-link": "新增電子郵件地址",
  "notifications.site-settings.page-email-section-add-custom-email-learn-more-link": "進一步了解如何從您的網域傳送電子郵件。",
  "notifications.site-settings.page-email-section-description": "本網站的通知電子郵件會自動從 Confluence 電子郵件地址傳送。若要使用您網域名稱的不同地址傳送電子郵件，請在下方選取自訂電子郵件地址。",
  "notifications.site-settings.page-email-section-issue-with-email-message-action": "編輯自訂電子郵件地址",
  "notifications.site-settings.page-email-section-issue-with-email-message-description": "由於有設定問題，我們無法使用此電子郵件地址。組織管理員可以從下面的下拉式清單中選擇其他電子郵件，或選取連結來編輯組織的自訂網域設定。",
  "notifications.site-settings.page-email-section-issue-with-email-message-title": "電子郵件地址問題",
  "notifications.site-settings.page-email-section-no-custom-email-message-description": "若要使用您網域的自訂電子郵件地址，組織管理員可以在 {adminHub} 上新增該電子郵件地址。",
  "notifications.site-settings.page-email-section-no-custom-email-message-title": "新增自訂電子郵件地址",
  "notifications.site-settings.page-email-section-title": "電子郵件地址",
  "notifications.site-settings.page-title": "通知",
  "notifications.site-settings.site-sender-email-success-flag-action": "知道了",
  "notifications.site-settings.site-sender-email-success-flag-description": "請注意，電子郵件變更最多可能需要一個小時才會生效",
  "notifications.site-settings.slack-settings-section.desc": "全站通知設定適用於 Confluence 執行個體上的每位使用者。 如果關閉這些通知，個別使用者將無法重新開啟通知。",
  "notifications.site-settings.slack-settings-section.error-flag-title": "發生錯誤",
  "notifications.site-settings.slack-settings-section.save-button": "儲存 Slack 設定變更",
  "notifications.site-settings.slack-settings-section.success-flag-title": "Slack 設定已更新",
  "notifications.site-settings.slack-settings-section.title": "Slack 設定",
  "notifications.site-settings.slack-settings.recommended-slack-desc": "每週推薦內容列表，與每位使用者可存取的空間以及追蹤的人相關。使用者只會收到他們有權檢視的推薦內容。",
  "notifications.site-settings.slack-settings.recommended-slack-toggle": "推薦 Slack 訊息",
  "notifications.site-settings.success-flag-title": "已更新通知設定",
  "notifications.site-settings.teams-settings-section.desc": "全站通知設定適用於 Confluence 執行個體上的每位使用者。 如果關閉這些通知，個別使用者將無法重新開啟通知。",
  "notifications.site-settings.teams-settings-section.error-flag-title": "發生錯誤",
  "notifications.site-settings.teams-settings-section.save-button": "儲存 Microsoft Teams 設定變更",
  "notifications.site-settings.teams-settings-section.success-flag-title": "Microsoft Teams 設定已更新",
  "notifications.site-settings.teams-settings-section.title": "Microsoft Teams 設定",
  "notifications.site-settings.teams-settings.recommended-teams-desc": "每週推薦內容列表，與每位使用者可存取的空間以及追蹤的人相關。 使用者只會收到他們有權檢視的推薦內容。",
  "notifications.site-settings.teams-settings.recommended-teams-toggle": "推薦的 Microsoft Teams 訊息",
  "object-comments.add-comment-prompt.text": "新增留言",
  "object-comments.comment.reopen.failed.flag.cta.retry": "立即重試",
  "object-comments.comment.reopen.failed.flag.title": "無法重新開啟留言",
  "object-comments.comment.reopened.flag.title": "已重新開啟留言",
  "object-comments.comment.thread.type-seperator": "一般留言",
  "object-comments.object-comment-header.text": "留言",
  "object-comments.page.reactions.add.new": "新增",
  "object-comments.page.reactions.add.reaction": "新增回應",
  "object-comments.reply.action": "回覆",
  "object-sidebar-components.audio.button.tooltip": "聆聽",
  "object-sidebar-components.close.panel.label": "關閉面板",
  "object-sidebar-components.collapse-toggle-label": "摺疊動作列",
  "object-sidebar-components.edit.and.live.page.close.label": "關閉面板",
  "object-sidebar-components.expand-toggle-label": "展開動作列",
  "object-sidebar-components.more-actions.tour.check-the-details-panel": "沒有看到您要尋找的內容嗎？請查看浮動動作列中，新的<strong>詳細資料</strong>面板。",
  "object-sidebar-components.more-actions.tour.dismiss": "關閉",
  "object-sidebar-components.more-actions.tour.easier-to-find-what-you-need": "我們會持續努力，讓您更輕鬆地找到所需內容。",
  "object-sidebar-components.more-actions.tour.get-the-details-you-need": "獲取您需要的詳細資料",
  "object-sidebar-components.more-actions.tour.go-there-now": "立即前往",
  "object-sidebar-components.more-actions.tour.ok": "確定",
  "object-sidebar-components.more-actions.tour.view-and-manage-activity": "在單一面板中檢視和管理活動、相關內容等等。",
  "object-sidebar-components.more-actions.tour.view-and-manage-ownership": "在單一面板中檢視和管理所有權、標籤等等。",
  "object-sidebar-components.more-actions.tour.we-have-reorganized": "我們做了一些重整",
  "object-sidebar-components.object-sidebar-control.tour": "{step}/{steps}",
  "object-sidebar-components.object-sidebar-control.tour.back": "返回",
  "object-sidebar-components.object-sidebar-control.tour.dismiss": "知道了",
  "object-sidebar-components.object-sidebar-control.tour.elevate-your-work": "利用 Atlassian Intelligence 提升您的工作效率",
  "object-sidebar-components.object-sidebar-control.tour.explore-ai-features": "探索頁面和留言摘要等 AI 功能，協助您提升工作方式。",
  "object-sidebar-components.object-sidebar-control.tour.finish": "完成",
  "object-sidebar-components.object-sidebar-control.tour.get-the-details-you-need": "獲取您需要的詳細資料",
  "object-sidebar-components.object-sidebar-control.tour.got-it": "知道了",
  "object-sidebar-components.object-sidebar-control.tour.new-home-for-comments": "存放留言等等的新位置",
  "object-sidebar-components.object-sidebar-control.tour.new-home-for-comments-ai-and-more": "為留言和 AI 等功能搬新家",
  "object-sidebar-components.object-sidebar-control.tour.next": "下一步",
  "object-sidebar-components.object-sidebar-control.tour.view-and-manage": "在單一面板中檢視和管理標籤、所有權和其他重要資訊。",
  "object-sidebar-components.object-sidebar-control.tour.work-even-faster": "使用浮動動作列讓您更靠近內容，加快工作速度。",
  "object-sidebar-components.object-sidebar-control.tour.x-button-label": "關閉",
  "object-sidebar-components.object-sidebar.feature-suggestion": "功能建議或要求",
  "object-sidebar-components.object-sidebar.feedback-category": "哪個類別最符合您的意見反應？(選擇性)",
  "object-sidebar-components.object-sidebar.feedback-collector-title": "幫助我們改善新的版面配置",
  "object-sidebar-components.object-sidebar.feedback-collector-tooltip": "針對新的版面配置提供意見反應",
  "object-sidebar-components.object-sidebar.feedback-success-flag-description": "感謝您撥空與我們分享意見。",
  "object-sidebar-components.object-sidebar.feedback-success-flag-title": "我們已記錄您的回應",
  "object-sidebar-components.object-sidebar.rate-experience": "請為新的版面配置評分：",
  "object-sidebar-components.object-sidebar.report-bug": "回報錯誤",
  "object-sidebar-components.object-sidebar.tell-us-more": "進一步描述您的體驗",
  "object-sidebar-components.object-sidebar.user-interface-quality": "使用者介面品質",
  "object-sidebar-components.open.comments.panel.label": "開啟留言面板",
  "object-sidebar-components.open.details.panel.label": "開啟詳細資料面板",
  "object-sidebar-components.reaction.button.add.reaction": "新增回應",
  "object-sidebar-components.reaction.button.more.emojis": "更多表情符號",
  "object-sidebar-components.show.comments.label": "顯示留言",
  "object-sidebar-components.show.details.label": "顯示詳細資料",
  "object-sidebar-components.unread.comments.icon.label": "您有未讀留言",
  "onboarding-account-setup-modal.atlassian.intelligence.title": "Atlassian Intelligence",
  "onboarding-account-setup-modal.buttons.finish": "完成",
  "onboarding-account-setup-modal.buttons.next": "下一步",
  "onboarding-account-setup-modal.buttons.skip": "略過",
  "onboarding-account-setup-modal.edition-communication.AI.feature": "<b>Atlassian Intelligence (AI)</b>，用以改善團隊的寫作能力",
  "onboarding-account-setup-modal.edition-communication.buttons.next": "下一頁",
  "onboarding-account-setup-modal.edition-communication.buttons.payment": "新增付款詳細資料",
  "onboarding-account-setup-modal.edition-communication.buttons.started": "開始使用",
  "onboarding-account-setup-modal.edition-communication.feature-list.footer.no-payment-details.no-trial-length": "繼續試用，或者您可以立即新增付款詳細資訊，以便在試用期結束後，持續不間斷地存取 {edition} 方案的所有進階功能。",
  "onboarding-account-setup-modal.edition-communication.feature.list.footer.has.payment.details": "您可以隨時在<link>管理訂閱</link>中取消試用或降級。我們將在試用結束之前提醒您。",
  "onboarding-account-setup-modal.edition-communication.feature.list.footer.no.payment.details": "{trialLength, plural, other {繼續使用 {trialLength,number} 天免費試用，或者您可以立即新增付款詳細資訊，以便在試用期結束後，持續不間斷地存取 {edition} 方案的所有進階功能。}}",
  "onboarding-account-setup-modal.edition-communication.file.storage.feature": "高達 2 GB 的檔案儲存空間",
  "onboarding-account-setup-modal.edition-communication.free.feature.list.footer": "若要從 Confluence 中獲得更多功能，您可以隨時<link>升級方案</link>。",
  "onboarding-account-setup-modal.edition-communication.free.feature.list.title": "您使用的是 Free 方案，此方案包含：",
  "onboarding-account-setup-modal.edition-communication.free.title": "歡迎使用 Confluence",
  "onboarding-account-setup-modal.edition-communication.page.insights.feature": "<b>內容深入解析</b>，顯示哪些人已檢視您的內容，以及與您的內容互動",
  "onboarding-account-setup-modal.edition-communication.paid.feature.list.title": "您可以透過試用版，存取如下進階功能：",
  "onboarding-account-setup-modal.edition-communication.paid.no.trial.length.title": "您正在使用 Confluence 的 {edition} 試用",
  "onboarding-account-setup-modal.edition-communication.paid.title": "{trialLength, plural, other {您正在使用 Confluence {edition} 的 {trialLength,number} 天免費試用}}",
  "onboarding-account-setup-modal.edition-communication.permissions.feature": "<b>使用者與內容權限</b>，以便更好地控管您的內容",
  "onboarding-account-setup-modal.edition-communication.step.index": "第 {number0} 步 (共 {number1} 步)",
  "onboarding-account-setup-modal.edition-communication.storage.feature": "<b>250 GB 的檔案儲存空間</b>，以便您根據需要新增任意數量的照片、圖表、影片或 PDF",
  "onboarding-account-setup-modal.edition-communication.team.calendars.feature": "<b>團隊行事曆</b>，讓每個人都朝關鍵里程碑邁進",
  "onboarding-account-setup-modal.edition-communication.unlimited.spaces.pages.feature": "不限數量的空間與頁面",
  "onboarding-account-setup-modal.edition-communication.unlimited.spaces.pages.feature.livedocs": "不限數量的空間、頁面和即時文件",
  "onboarding-account-setup-modal.edition-communication.unlimited.users.feature": "<b>不限數量的使用者</b>，以便整個團隊協同合作",
  "onboarding-account-setup-modal.edition-communication.user.feature": "多達 10 位使用者",
  "onboarding-account-setup-modal.file.storage.feature": "高達 2 GB 的檔案儲存空間",
  "onboarding-account-setup-modal.loading.text": "讓團隊展現合作優勢",
  "onboarding-account-setup-modal.more.file.storage.title": "更多檔案儲存空間",
  "onboarding-account-setup-modal.page.insights.title": "內容深入解析",
  "onboarding-account-setup-modal.productQuestions.collaboration-answer.description": "您的團隊感到孤軍奮戰，或看不到他們的工作如何能產生影響力。",
  "onboarding-account-setup-modal.productQuestions.collaboration-answer.title": "跨團隊協同合作",
  "onboarding-account-setup-modal.productQuestions.collaboration-image.ready-for-review": "可供檢閱",
  "onboarding-account-setup-modal.productQuestions.collaboration-image.title": "專案計畫",
  "onboarding-account-setup-modal.productQuestions.default-space-image.blog-title.fall-newsletter": "秋季電子報：團隊更新",
  "onboarding-account-setup-modal.productQuestions.default-space-image.page.page-title": "會議記錄",
  "onboarding-account-setup-modal.productQuestions.default-space-image.section-title.activity-feed": "活動摘要",
  "onboarding-account-setup-modal.productQuestions.default-space-image.section-title.recent-pages": "最近存取的頁面",
  "onboarding-account-setup-modal.productQuestions.default-space-image.section-title.recent-pages.livedocs": "最近的頁面和即時文件",
  "onboarding-account-setup-modal.productQuestions.default-space-image.section-title.spaces": "空間",
  "onboarding-account-setup-modal.productQuestions.default-space-image.title": "首頁",
  "onboarding-account-setup-modal.productQuestions.description": "您在這裡的選擇不會限制可用的功能。",
  "onboarding-account-setup-modal.productQuestions.knowledge-base-answer.description": "您的團隊需要單一事實來源或記錄工作的說明。",
  "onboarding-account-setup-modal.productQuestions.knowledge-base-answer.title": "建立知識庫",
  "onboarding-account-setup-modal.productQuestions.knowledge-base-image.section-title.instructions": "指示",
  "onboarding-account-setup-modal.productQuestions.knowledge-base-image.section-title.related-articles": "相關文章",
  "onboarding-account-setup-modal.productQuestions.knowledge-base-image.title": "操作說明文章",
  "onboarding-account-setup-modal.productQuestions.subtitle": "是什麼將您吸引到 Confluence？",
  "onboarding-account-setup-modal.productQuestions.title": "歡迎！",
  "onboarding-account-setup-modal.productQuestions.titleWithName": "{userFirstName}，歡迎使用！",
  "onboarding-account-setup-modal.productQuestions.trying-out-answer.description": "您想探索並了解 Confluence 如何適用於您的團隊。",
  "onboarding-account-setup-modal.productQuestions.trying-out-answer.title": "試試看",
  "onboarding-account-setup-modal.productQuestions.trying-out-image.template.brainwriting": "腦力激盪",
  "onboarding-account-setup-modal.productQuestions.trying-out-image.template.business-status-update": "業務狀態更新",
  "onboarding-account-setup-modal.productQuestions.trying-out-image.template.incident-postmortem": "事件事後分析",
  "onboarding-account-setup-modal.productQuestions.trying-out-image.template.introductory-blog": "簡介部落格",
  "onboarding-account-setup-modal.productQuestions.trying-out-image.template.prioritization-matrix": "優先順序對照表",
  "onboarding-account-setup-modal.productQuestions.trying-out-image.template.project-plan": "專案計畫",
  "onboarding-account-setup-modal.productQuestions.trying-out-image.title": "範本",
  "onboarding-account-setup-modal.revamp.invite.fields.invite.by.name.or.email.title": "透過名稱或電子郵件邀請",
  "onboarding-account-setup-modal.revamp.invite.suggested.teammates.subtitle": "我們建議您一起工作的團隊成員。",
  "onboarding-account-setup-modal.revamp.invite.title": "邀請您的團隊成員",
  "onboarding-account-setup-modal.space.description": "空間通常是為特定團隊或專案建立的，它是您的團隊可以共同作業和組織工作的地方。",
  "onboarding-account-setup-modal.space.inputTextPlaceholder": "空間名稱",
  "onboarding-account-setup-modal.space.title": "為您的第一個空間命名",
  "onboarding-account-setup-modal.step.index": "第 {number0} 步 (共 {number1} 步)",
  "onboarding-account-setup-modal.team.calendars.title": "團隊行事曆",
  "onboarding-account-setup-modal.team.default-spacename": "我的第一個空間",
  "onboarding-account-setup-modal.team.illustration.customer.service": "客戶服務團隊空間",
  "onboarding-account-setup-modal.team.illustration.customer.support": "客戶支援團隊空間",
  "onboarding-account-setup-modal.team.illustration.design": "設計團隊空間",
  "onboarding-account-setup-modal.team.illustration.finance": "財務團隊空間",
  "onboarding-account-setup-modal.team.illustration.hr": "人力資源團隊空間",
  "onboarding-account-setup-modal.team.illustration.it.support": "IT 支援團隊空間",
  "onboarding-account-setup-modal.team.illustration.legal": "法務團隊空間",
  "onboarding-account-setup-modal.team.illustration.marketing": "行銷團隊空間",
  "onboarding-account-setup-modal.team.illustration.operations": "營運團隊空間",
  "onboarding-account-setup-modal.team.illustration.product.management": "產品管理團隊空間",
  "onboarding-account-setup-modal.team.illustration.project.management": "專案管理團隊空間",
  "onboarding-account-setup-modal.team.illustration.research": "研究團隊空間",
  "onboarding-account-setup-modal.team.illustration.sales": "銷售團隊空間",
  "onboarding-account-setup-modal.team.illustration.software.development": "軟體開發團隊空間",
  "onboarding-account-setup-modal.team.illustration.team": "團隊空間",
  "onboarding-account-setup-modal.team.select.placeholder": "選取選項",
  "onboarding-account-setup-modal.team.subtitle": "了解您的團隊有助於我們為您提供專屬體驗。",
  "onboarding-account-setup-modal.team.title": "什麼樣的描述最適合貴團隊的工作？",
  "onboarding-account-setup-modal.team.welcome": "歡迎！",
  "onboarding-account-setup-modal.team.welcome.with.name": "{userFirstName}，歡迎使用！",
  "onboarding-account-setup-modal.unlimited.spaces.pages.feature": "不限數量的空間與頁面",
  "onboarding-account-setup-modal.unlimited.spaces.pages.feature.livedocs": "不限數量的空間、頁面和即時文件",
  "onboarding-account-setup-modal.unlimited.users.title": "不限數量的使用者",
  "onboarding-account-setup-modal.user.feature": "多達 10 位使用者",
  "onboarding-account-setup-modal.user.page.permissions.title": "使用者與內容權限",
  "onboarding-choose-a-space.back.button": "返回",
  "onboarding-choose-a-space.choose-a-space.next.button": "下一步",
  "onboarding-choose-a-space.description": "開始使用您目前團隊或專案的空間。您稍後就能建立更多空間。",
  "onboarding-choose-a-space.next.button": "下一步",
  "onboarding-choose-a-space.select.label": "空間名稱",
  "onboarding-choose-a-space.select.placeholder": "選取空間名稱",
  "onboarding-choose-a-space.space-card.description": "空間是性質相似的內容存留的地方。從貴公司網站上的熱門空間中選取。如果您已經有預想的空間，可直接搜尋。",
  "onboarding-choose-a-space.space-card.description.new": "團隊對空間中的文件和專案進行協作。選擇一個空間來探索並查看您的團隊如何使用 Confluence。",
  "onboarding-choose-a-space.space-card.description.watch-spaces": "了解您的團隊如何使用 Confluence - 選取一個空間以收到有關留言、任務和更新的通知。",
  "onboarding-choose-a-space.space-card.search": "搜尋空間",
  "onboarding-choose-a-space.space-card.title": "選擇一個空間以開始使用",
  "onboarding-choose-a-space.space-card.title.image.altText": "協作自行車圖片",
  "onboarding-choose-a-space.space-card.title.new": "讓我們選取一個空間來探索",
  "onboarding-choose-a-space.space-card.title.watch-spaces": "工作位於空間中",
  "onboarding-choose-a-space.title": "選擇要追蹤的空間",
  "onboarding-editor.contextual-invite.action": "邀請人員加入 Confluence",
  "onboarding-editor.contextual-invite.content": "傳送邀請給團隊成員，開始在新頁面上進行協作。",
  "onboarding-editor.contextual-invite.title": "下一步：共用您的工作",
  "onboarding-editor.draft.banner": "{boldedUnpublishedDraftText} 在您將其發佈或將連結提供給他人之前，只有您可以看得到。{learnMoreLink}",
  "onboarding-editor.land-in-editor.banner.description": "根據您的回應，這是一個最適合協助您開始使用的範本。",
  "onboarding-editor.land-in-editor.banner.title": "有一個適用的範本",
  "onboarding-editor.land-in-editor.blank-page": "從空白頁面開始",
  "onboarding-editor.land-in-editor.explore-templates": "探索所有範本",
  "onboarding-editor.learn.more": "深入了解",
  "onboarding-editor.modal.button.close": "關閉",
  "onboarding-editor.modal.button.publish": "發佈",
  "onboarding-editor.modal.description": "發佈此頁面之前，您需要先提供標題。",
  "onboarding-editor.modal.placeholder": "輸入標題",
  "onboarding-editor.modal.title": "此頁面需要標題",
  "onboarding-editor.tutorial.success.flag.content": "恭喜您完成編輯器教學課程！{emoji} {br}我們已將此頁面發佈到您的個人空間，以便您隨時返回。",
  "onboarding-editor.tutorial.success.flag.title": "頁面已發佈到您的個人空間",
  "onboarding-editor.unpublished.draft": "<b>這是未發佈的草稿。</b>",
  "onboarding-helpers.role.type": "您的角色",
  "onboarding-helpers.team.customer.support": "{emoji} 客戶支援",
  "onboarding-helpers.team.design": "{emoji} 設計",
  "onboarding-helpers.team.finance.v2": "{emoji} 財務",
  "onboarding-helpers.team.human.resources.v2": "{emoji} 人力資源",
  "onboarding-helpers.team.it.support.v2": "{emoji} IT 支援",
  "onboarding-helpers.team.legal.v2": "{emoji} 法務",
  "onboarding-helpers.team.marketing.v2": "{emoji} 行銷",
  "onboarding-helpers.team.operations.v2": "{emoji} 營運",
  "onboarding-helpers.team.other.v2": "{emoji} 其他",
  "onboarding-helpers.team.productManagement": "{emoji} 產品管理",
  "onboarding-helpers.team.projectManagement": "{emoji} 專案管理",
  "onboarding-helpers.team.research": "{emoji} 研究",
  "onboarding-helpers.team.sales.v2": "{emoji} 銷售",
  "onboarding-helpers.team.software.development.v2": "{emoji} 軟體開發",
  "onboarding-helpers.team.type": "您的團隊",
  "onboarding-helpers.teamStepPlaceholder": "選擇您的團隊",
  "onboarding-live-doc-changeboarding.collabSpotlight.back": "返回",
  "onboarding-live-doc-changeboarding.collabSpotlight.body": "任何人都可以檢視和編輯此即時文件。可以隨時設為私密。",
  "onboarding-live-doc-changeboarding.collabSpotlight.got-it": "知道了",
  "onboarding-live-doc-changeboarding.collabSpotlight.heading": "可供協作",
  "onboarding-live-doc-changeboarding.collabSpotlight.ok": "知道了",
  "onboarding-live-doc-changeboarding.collabSpotlight.stepOfSteps": "{step}/{steps}",
  "onboarding-live-doc-changeboarding.collabSpotlight.x-button-label": "關閉",
  "onboarding-live-doc-changeboarding.editorSpotlight.body": "即時編輯，無須發布。",
  "onboarding-live-doc-changeboarding.editorSpotlight.dismiss": "關閉",
  "onboarding-live-doc-changeboarding.editorSpotlight.heading": "使用即時文件開始工作",
  "onboarding-live-doc-changeboarding.editorSpotlight.next": "下一步",
  "onboarding-live-doc-changeboarding.editorSpotlight.stepOfSteps": "{step}/{steps}",
  "onboarding-live-doc-changeboarding.editorSpotlight.x-button-label": "關閉",
  "onboarding-live-doc-changeboarding.introSpotlight.body": "使用即時文件進行快速且文思泉湧的腦力激盪，並與團隊協作。",
  "onboarding-live-doc-changeboarding.introSpotlight.bodyGA": "使用即時文件進行快速的腦力激盪和團隊協作。",
  "onboarding-live-doc-changeboarding.introSpotlight.dismiss": "關閉",
  "onboarding-live-doc-changeboarding.introSpotlight.heading": "開始使用即時文件協作",
  "onboarding-live-doc-changeboarding.introSpotlight.headingGA": "使用即時文件實現構想",
  "onboarding-live-doc-changeboarding.introSpotlight.learnMore": "深入了解",
  "onboarding-live-doc-changeboarding.introSpotlight.tryItOut": "試試看",
  "onboarding-nth-user-setup-modal.watch-space.subtitle": "了解您的團隊如何使用 Confluence — 選取一個空間以收到有關留言、任務和更新的通知。",
  "onboarding-nth-user-setup-modal.watch-space.title": "工作位於空間中",
  "onboarding-quickstart.back.button": "上一步",
  "onboarding-quickstart.close.button": "關閉",
  "onboarding-quickstart.confluenceGuide.description": "根據團隊需求量身打造 Confluence，從軟體開發到行銷等情境都適用。",
  "onboarding-quickstart.confluenceGuide.link": "閱讀指南",
  "onboarding-quickstart.confluenceGuide.title": "查看團隊如何使用 Confluence",
  "onboarding-quickstart.createPage.description": "頁面是 Confluence 的建構元素，也是團隊在 Confluence 上協作的位置。",
  "onboarding-quickstart.createPage.description.livedocs": "頁面和即時文件是 Confluence 的建構元素，也是團隊在 Confluence 上協作的位置。",
  "onboarding-quickstart.createPage.link": "探索頁面範本",
  "onboarding-quickstart.createPage.link.livedocs": "探索範本",
  "onboarding-quickstart.createPage.shortcut": "隨時按 \"c\" 以建立頁面。",
  "onboarding-quickstart.createPage.shortcut.livedocs": "需要新的「即時文件」捷徑嗎？",
  "onboarding-quickstart.createSpace.description": "空間是您所有內容的家。您可以為團隊、專案和筆記建立任意數量的空間。",
  "onboarding-quickstart.createSpace.header": "瞧，您已經建立好一個空間！",
  "onboarding-quickstart.createSpace.title": "建立空間",
  "onboarding-quickstart.dismiss.flag.desc": "若要再次開啟快速入門，請選取您的頭像，然後選取<b>開啟快速入門</b>。",
  "onboarding-quickstart.dismiss.flag.desc.v2": "若要再次開啟快速入門，請從 {icon} 選單中選取「{openQuickstart}」。",
  "onboarding-quickstart.dismiss.flag.title": "需要再看一次嗎？",
  "onboarding-quickstart.dismiss.open.quickstart": "開啟快速入門",
  "onboarding-quickstart.integrations.button": "檢視所有應用程式",
  "onboarding-quickstart.integrations.default-message": "與您已經使用的工具整合",
  "onboarding-quickstart.integrations.description": "與您已經使用的工具整合。",
  "onboarding-quickstart.integrations.explore.button": "探索 Marketplace",
  "onboarding-quickstart.integrations.explore.button.v2": "取得應用程式",
  "onboarding-quickstart.integrations.get.button": "立即取得",
  "onboarding-quickstart.integrations.subtitle": "受到像您們這樣的團隊歡迎的應用程式",
  "onboarding-quickstart.integrations.subtitle.v2": "將您已經在使用的工具新增至 Confluence，以減少環境的切換。",
  "onboarding-quickstart.integrations.title": "安裝 Marketplace 應用程式",
  "onboarding-quickstart.integrations.title.v2": "新增您喜愛的應用程式",
  "onboarding-quickstart.invite.button": "新增人員",
  "onboarding-quickstart.invite.description": "將您的團隊集結起來！",
  "onboarding-quickstart.invite.description.v2": "將團隊成員新增至 Confluence 網站，以開始共同作業。",
  "onboarding-quickstart.invite.description.v3": "將最常與您合作的人員匯聚在 Confluence，讓所有人都掌握一致的資訊。",
  "onboarding-quickstart.invite.learnAboutPermissions.link": "瞭解權限",
  "onboarding-quickstart.invite.others.button": "邀請更多人",
  "onboarding-quickstart.invite.others.description": "您在找人嗎？隨時從「<b>人員</b>」選單中新增其他團隊成員。",
  "onboarding-quickstart.invite.others.nudge.description": "當您準備好時，可以從「<b>人員</b>」選單中邀請更多人來加入您的網站。",
  "onboarding-quickstart.invite.others.nudge.title": "隨時新增團隊成員",
  "onboarding-quickstart.invite.title": "邀請您的團隊成員",
  "onboarding-quickstart.invite.title.v2": "邀請您的團隊",
  "onboarding-quickstart.invited.flag.action": "檢視使用者",
  "onboarding-quickstart.invited.flag.all.desc": "我們遇到了問題，因此無法傳送您的邀請。",
  "onboarding-quickstart.invited.flag.all.title": "未傳送您的邀請",
  "onboarding-quickstart.invited.flag.success": "成功",
  "onboarding-quickstart.invited.flag.user": "您已邀請 {email} 加入 Confluence。",
  "onboarding-quickstart.invited.flag.user.desc": "我們遇到了問題，因此未傳送您對 {name} 的邀請。",
  "onboarding-quickstart.invited.flag.user.title": "未傳送您的邀請",
  "onboarding-quickstart.jira.xflow.desc.one": "從 70 個以上的範本中選擇，讓範本協助您建構思維、改善說明文件品質，並採用最佳做法來進行敏捷開發。",
  "onboarding-quickstart.jira.xflow.desc.three": "只需按兩下即可從 Confluence 回到您的 Jira 專案。",
  "onboarding-quickstart.jira.xflow.desc.two": "使用 Jira 議題、Jira 報告和 Jira 時間軸巨集，讓相關人員一目瞭然地查看您團隊的進度。這些巨集會自動更新，以反映您在 Jira 中所做的變更。",
  "onboarding-quickstart.jira.xflow.desc.two-issue-term-refresh": "使用 Jira 工作項目、Jira 報告和 Jira 時間軸巨集，讓相關人員一目瞭然地查看您團隊的進度。這些巨集會自動更新，以反映您在 Jira 中所做的變更。",
  "onboarding-quickstart.jira.xflow.spotlight.app-switcher.body": "在 Confluence 和您的 Jira 專案之間快速切換。",
  "onboarding-quickstart.jira.xflow.spotlight.app-switcher.heading": "返回 Jira",
  "onboarding-quickstart.jira.xflow.spotlight.page.tree.body": "拖放項目以移動項目。您在此所做的變更將會反映在 Jira 的專案頁面中。",
  "onboarding-quickstart.jira.xflow.spotlight.page.tree.heading": "在這裡尋找您的內容",
  "onboarding-quickstart.jira.xflow.spotlight.spaces.section.body": "空間是您用來整理專案相關內容的位置。此空間已經連結到您的 Jira 專案。",
  "onboarding-quickstart.jira.xflow.spotlight.spaces.section.heading": "探索您的空間",
  "onboarding-quickstart.jira.xflow.title": "Jira {icon} Confluence",
  "onboarding-quickstart.jira.xflow.title.one": "提升說明文件的品質",
  "onboarding-quickstart.jira.xflow.title.three": "在 Jira 和 Confluence 之間快速切換",
  "onboarding-quickstart.jira.xflow.title.two": "視覺化您的進度",
  "onboarding-quickstart.learnmore.link": "深入了解",
  "onboarding-quickstart.link.review-site-name": "自訂網站名稱",
  "onboarding-quickstart.migrations.add-emojis-and-header-image-description": "讓讀者透過表情符號和標頭圖片保持參與。表情符號會顯示在搜尋內容中，方便之後尋找內容。",
  "onboarding-quickstart.migrations.add-emojis-and-header-image-title": "新增表情符號和標頭圖像",
  "onboarding-quickstart.migrations.add-macros-description": "輸入 / 以存取元素列表。您也可以透過選取工具列中的 + 下拉式清單來新增元素。",
  "onboarding-quickstart.migrations.add-macros-title": "使用 / 鍵新增巨集",
  "onboarding-quickstart.migrations.collaborate-edit-live-description": "您可以和多達 12 名團隊夥伴同時進行編輯。您會即時看到所發生的每一個編輯動作。",
  "onboarding-quickstart.migrations.collaborate-edit-live-title": "以協作方式即時編輯",
  "onboarding-quickstart.migrations.collaborate-inline-comments-description": "醒目提示文字並選取「留言」。使用 @ 鍵來提及團隊成員，讓成員知道您有留言。",
  "onboarding-quickstart.migrations.collaborate-inline-comments-title": "在編輯時新增內嵌留言",
  "onboarding-quickstart.migrations.collaborate-title": "與團隊成員協作",
  "onboarding-quickstart.migrations.create-tables-description": "輸入 /表格或從工具欄中選取表格圖示來新增表格。使用表格邊框、下拉式清單和浮動選單進行自訂。",
  "onboarding-quickstart.migrations.create-tables-title": "建立和自訂表格",
  "onboarding-quickstart.migrations.edit-and-customize-content-title": "編輯和自訂內容",
  "onboarding-quickstart.migrations.find-and-organize-pages-access-description": "選取主要導覽列中的「最近的項目」。您可以在此處尋找最近已造訪、已處理、已草擬和已標上星號的內容。",
  "onboarding-quickstart.migrations.find-and-organize-pages-access-title": "存取您最近的頁面和草稿",
  "onboarding-quickstart.migrations.find-and-organize-pages-access-title.livedocs": "存取您最近的即時文件、頁面和草稿",
  "onboarding-quickstart.migrations.find-and-organize-pages-organize-description": "透過將項目拖放到內容樹狀結構中來建立內容階層。這可讓您更輕鬆地找到所需的內容。",
  "onboarding-quickstart.migrations.find-and-organize-pages-organize-title": "整理內容樹狀結構中的內容",
  "onboarding-quickstart.migrations.find-and-organize-pages-title": "尋找和整理內容",
  "onboarding-quickstart.migrations.find-and-organize-pages-work-description": "從行動裝置編輯頁面、新增留言和分享部落格。無論您身在何處，都能讓工作有所進展。",
  "onboarding-quickstart.migrations.find-and-organize-pages-work-title": "使用 Confluence Mobile 從任何地方處理工作",
  "onboarding-quickstart.migrations.free-training": "透過免費培訓進一步了解",
  "onboarding-quickstart.migrations.new-livedoc-title": "建立新的即時文件",
  "onboarding-quickstart.migrations.new-page-create-description": "在空間內，選取 + 圖示以建立新的頁面。您也可以使用主要導覽列中的「建立」按鈕來建立頁面。",
  "onboarding-quickstart.migrations.new-page-create-description.livedocs": "在空間內，選取 + 圖示以建立新的頁面或即時文件。您也可以使用主要導覽列中的「建立」按鈕來建立。",
  "onboarding-quickstart.migrations.new-page-create-title": "從頁面樹狀結構建立新的頁面",
  "onboarding-quickstart.migrations.new-page-create-title.livedocs": "從內容樹狀結構建立新的頁面或即時文件",
  "onboarding-quickstart.migrations.new-page-templates-description": "使用預先設定好格式的範本來節省時間。在選取範本之前，可先將滑鼠游標暫留在範本上以查看預覽。",
  "onboarding-quickstart.migrations.new-page-templates-title": "從 100 多個範本中選擇",
  "onboarding-quickstart.migrations.new-page-title": "建立新頁面",
  "onboarding-quickstart.migrations.welcome-home-description": "選取「首頁」以查看您最近的頁面和草稿。監控團隊成員的活動，例如新的編輯和留言。",
  "onboarding-quickstart.migrations.welcome-home-title": "在「首頁儀表板」上開始",
  "onboarding-quickstart.migrations.welcome-spaces-description": "使用「空間」下拉式清單即可導覽不同的空間。查看公告和行事曆，以了解最新消息。",
  "onboarding-quickstart.migrations.welcome-spaces-title": "切換空間並隨時掌握團隊消息",
  "onboarding-quickstart.migrations.welcome-title": "找到自己的方式",
  "onboarding-quickstart.mobile.description": "使用您的行動裝置掃描此 QR 代碼，即可在應用程式商店中看到 Confluence Cloud 行動應用程式。",
  "onboarding-quickstart.mobile.title": "取得行動應用程式",
  "onboarding-quickstart.next.button": "下一步",
  "onboarding-quickstart.nthuserv2.ask.community.button": "前往社群",
  "onboarding-quickstart.nthuserv2.collaborate.elements.cta": "進一步了解元素",
  "onboarding-quickstart.nthuserv2.collaborate.elements.desc": "「元素」包含行事曆、附註面板和版面配置等工具，可協助您提升頁面功能。",
  "onboarding-quickstart.nthuserv2.collaborate.elements.desc.livedocs": "「元素」指的是行事曆、附註面板和版面配置這類工具，可協助您提升內容的實用程度。",
  "onboarding-quickstart.nthuserv2.collaborate.elements.shortcut": "按下「/」即可查看元素列表。",
  "onboarding-quickstart.nthuserv2.collaborate.elements.title": "使用元素",
  "onboarding-quickstart.nthuserv2.collaborate.feedback.cta": "了解提及功能",
  "onboarding-quickstart.nthuserv2.collaborate.feedback.desc": "透過留言和回應來提出構想。",
  "onboarding-quickstart.nthuserv2.collaborate.feedback.shortcut": "@提及團隊成員，讓他知道您想聽聽他的看法。",
  "onboarding-quickstart.nthuserv2.collaborate.feedback.title": "提供意見反應",
  "onboarding-quickstart.nthuserv2.collaborate.share.cta": "深入了解分享功能",
  "onboarding-quickstart.nthuserv2.collaborate.share.desc": "透過在內容樹狀結構中拖放項目來整理您的內容，讓您的團隊可以找到他們想要的項目。",
  "onboarding-quickstart.nthuserv2.collaborate.share.shortcut": "按下「k」鍵即可產生可分享的頁面連結。",
  "onboarding-quickstart.nthuserv2.collaborate.share.shortcut.livedocs": "按「k」以產生可分享的連結。",
  "onboarding-quickstart.nthuserv2.collaborate.share.title": "整理和共用內容",
  "onboarding-quickstart.nthuserv2.collaborate.title": "以更聰明的方式分工合作",
  "onboarding-quickstart.nthuserv2.confluence101.desc": "不確定網站、空間和頁面有什麼差別嗎？以下快速概覽可協助您開始了解。",
  "onboarding-quickstart.nthuserv2.confluence101.desc.livedocs": "不確定網站、空間、即時文件和頁面有什麼差別嗎？以下快速概覽可協助您開始了解。",
  "onboarding-quickstart.nthuserv2.confluence101.title": "Confluence 基本概念",
  "onboarding-quickstart.nthuserv2.create.desc": "頁面可讓團隊建立內容、協同合作和組織工作，是 Confluence 的構成要素。",
  "onboarding-quickstart.nthuserv2.create.desc.livedocs": "頁面和即時文件可讓團隊建立內容、協同合作和組織工作，是 Confluence 的構成要素。",
  "onboarding-quickstart.nthuserv2.create.shortcut": "按下「c」鍵即可隨時建立頁面。",
  "onboarding-quickstart.nthuserv2.create.shortcut.livedocs": "需要新的「即時文件」捷徑嗎？",
  "onboarding-quickstart.nthuserv2.create.title": "建立有意義的內容",
  "onboarding-quickstart.nthuserv2.explore.templates": "探索頁面範本",
  "onboarding-quickstart.nthuserv2.explore.templates.livedocs": "探索範本",
  "onboarding-quickstart.nthuserv2.help.desc": "查看說明文件以取得逐步指南，或在 Atlassian 社群中詢問問題，以聽聽其他 Confluence 使用者所分享的秘訣。",
  "onboarding-quickstart.nthuserv2.help.title": "在您需要時提供協助",
  "onboarding-quickstart.nthuserv2.search.docs.button": "搜尋文件",
  "onboarding-quickstart.ok.button": "確定",
  "onboarding-quickstart.quickstart.button": "快速入門",
  "onboarding-quickstart.quickstart.dismiss": "關閉快速入門",
  "onboarding-quickstart.quickstart.title": "Confluence 快速入門",
  "onboarding-quickstart.sharePage.description": "您可以透過連結、經由電子郵件地址或使用者名稱分享。",
  "onboarding-quickstart.sharePage.link": "深入了解分享",
  "onboarding-quickstart.sharePage.shortcut": "按 \"k\" 可取得任何頁面的可分享連結。",
  "onboarding-quickstart.sharePage.shortcut.livedocs": "按「k」可取得任何頁面或即時文件的可分享連結。",
  "onboarding-quickstart.sharePage.title": "分享內容",
  "onboarding-quickstart.showMeHow.button": "顯示方法",
  "onboarding-quickstart.simplify.admin.site-rename-description": "您的網站名稱是用於尋找及分享網站的 URL，因此請確保您的團隊能夠辨識該 URL。您也可以依喜好新增自訂網域名稱。",
  "onboarding-quickstart.simplify.admin.site-rename-title": "自訂網站名稱",
  "onboarding-quickstart.siteTour.description": "觀看介紹影片，瞭解 Connuence 如何幫助您的團隊完成工作。",
  "onboarding-quickstart.siteTour.title": "瞭解 Confluence",
  "onboarding-quickstart.spotlight.admin.quickstart.pill.description": "透過「快速入門」略過猜測的步驟，讓您快速瞭解 Confluence。",
  "onboarding-quickstart.spotlight.admin.quickstart.pill.title": "更快入門",
  "onboarding-quickstart.takeEditorTutorial.description": "我們的教學課程和範本可讓您輕鬆即時地建立美觀、有效的內容。",
  "onboarding-quickstart.takeEditorTutorial.start.button": "開始教學課程",
  "onboarding-quickstart.takeEditorTutorial.template.button": "選取範本",
  "onboarding-quickstart.takeEditorTutorial.title": "建立您的第一個頁面",
  "onboarding-quickstart.takeEditorTutorial.title.livedocs": "建立您的第一個頁面或即時文件",
  "onboarding-quickstart.try.again.button": "再試一次",
  "onboarding-quickstart.viewAllSpaces.button": "檢視所有空間",
  "onboarding-quickstart.xflow.backup.welcome.title": "歡迎使用 Confluence！",
  "onboarding-quickstart.xflow.not.now": "現在不要",
  "onboarding-quickstart.xflow.publish.description.one": "Confluence 是團隊可以為您的專案建立、編輯和整理說明文件的地方。",
  "onboarding-quickstart.xflow.publish.description.two": "搭配 Jira 使用 Confluence，為您的團隊提供單一事實來源，並免除共用磁碟機的需求。",
  "onboarding-quickstart.xflow.publish.title": "您已發佈第一個 Confluence 頁面！{emoji}",
  "onboarding-quickstart.xflow.take.tour": "進行導覽",
  "onboarding-quickstart.xflow.welcome.description.one": "Confluence 是團隊可以為您的專案建立、編輯和組織說明文件的地方。",
  "onboarding-quickstart.xflow.welcome.description.two": "搭配 Jira 使用，為您的團隊提供單一事實來源，並免除共用磁碟機的需求。",
  "onboarding-quickstart.xflow.welcome.title": "歡迎使用 Confluence，{firstName}！",
  "onboarding-spotlight-coordinator.skip": "略過",
  "onboarding-spotlight-coordinator.spotlight.back.button": "上一步",
  "onboarding-spotlight-coordinator.spotlight.done.button": "完成",
  "onboarding-spotlight-coordinator.spotlight.next.button": "下一個",
  "onboarding.nth-user.content-types.whiteboards.default.heading": "腦力激盪 - 一般",
  "page-card.action.commented": "您已於 {timeAgo} 留言",
  "page-card.action.created": "已於 {timeAgo} 建立",
  "page-card.action.created.by.me": "您已於 {timeAgo} 建立",
  "page-card.action.liked": "您已於 {timeAgo} 按讚",
  "page-card.action.updated": "已於 {timeAgo} 更新",
  "page-card.action.you.edited": "您已於 {timeAgo} 編輯",
  "page-card.action.you.visited": "您已於 {timeAgo} 造訪",
  "page-card.blog.label": "部落格",
  "page-card.created.by": "建立者為 {creator}",
  "page-card.creator.image.label": "個人檔案相片",
  "page-card.database.label": "資料庫",
  "page-card.expandable.show-fewer": "顯示較少",
  "page-card.expandable.show-more": "顯示更多",
  "page-card.folder.label": "資料夾",
  "page-card.live.page.label": "即時文件",
  "page-card.lozenge.draft": "草稿",
  "page-card.lozenge.unpublished": "未發佈的變更",
  "page-card.owned.by": "負責人：{owner}",
  "page-card.owner.image.label": "個人檔案相片",
  "page-card.page.label": "頁面",
  "page-card.popup-view-with-ai-snippet.no-ai-footer-text": "為什麼我會看到此內容？",
  "page-card.popup-view-with-ai-snippet.see-more": "查看更多",
  "page-card.quick-actions.edit.aria-label": "編輯 {title}",
  "page-card.quick-actions.edit.page": "編輯",
  "page-card.quick-actions.share.aria-label": "分享 {title}",
  "page-card.quick-actions.share.page": "分享",
  "page-card.quick-actions.unwatch.aria-label": "取消追蹤 {title}",
  "page-card.quick-actions.unwatch.page": "取消追蹤",
  "page-card.quick-actions.watch.aria-label": "追蹤 {title}",
  "page-card.quick-actions.watch.page": "追蹤",
  "page-card.rec.strategy.behavioral": "以此閱讀",
  "page-card.rec.strategy.content-to-content": "更像這樣",
  "page-card.rec.strategy.linked-content": "這裡的連結",
  "page-card.rec.strategy.structural": "以此分組",
  "page-card.social.comments": "留言",
  "page-card.social.likes": "讚",
  "page-card.star.content.tooltip.label": "標上星號",
  "page-card.toggle.card-view": "卡片",
  "page-card.toggle.compact-list-view": "精簡清單",
  "page-card.toggle.list-view": "清單",
  "page-card.toggle.radio-group-label": "外觀",
  "page-card.unstar.content.tooltip.label": "移除星號",
  "page-card.whiteboard.label": "白板",
  "page-catchup.catchup.button.text": "摘要差異",
  "page-catchup.changes.between.versions.text": "所選版本之間的變更",
  "page-catchup.diff.empty.between.versions.text": "這些版本非常相似，因此 Atlassian Intelligence (AI) 無法產生差異摘要。",
  "page-catchup.editors.name.list.text": "{editorsCount, plural, =2 {{firstEditor} 和 {secondEditor} 已編輯此內容} =3 {{firstEditor}、{secondEditor} 和 {thirdEditor} 已編輯此內容} other {{firstEditor}、{secondEditor}、{thirdEditor} 和其他 {remainingEditorCount} 人已編輯此內容}}",
  "page-catchup.editors.name.list.text.no.verbiage": "{editorsCount, plural, =2 {{firstEditor} 與 {secondEditor}} =3 {{firstEditor}、{secondEditor} 和 {thirdEditor}} other {{firstEditor}、{secondEditor}、{thirdEditor} 和其他 {remainingEditorCount} 人}}",
  "page-catchup.first-time-visit-text": "由於這是您第一次瀏覽此內容，您會看到頁面摘要，而不是變更摘要。",
  "page-catchup.full.version.history.link.text": "在版本歷史記錄中查看變更",
  "page-catchup.general-error": "Atlassian Intelligence 目前無法提供回應。請參閱<a>我們的支援說明文件</a>。",
  "page-catchup.last-visited-on-text": "您上次於 {lastVisitedOnDate} 造訪後的變更：",
  "page-catchup.no-changes-since-last-visit-text": "您上次於 {lastVisitedOnDate} 造訪之後，沒有任何變更。我們已改為產生此摘要，以幫助您恢復記憶。",
  "page-catchup.recent.edits.header.text": "最近編輯紀錄",
  "page-cover-picture.ai-suggested-image-header.flag.suggest-next-time": "要在下次嘗試建議的標頭嗎？",
  "page-cover-picture.ai-suggested-image-header.flag.suggest-next-time.accept": "是的，保留建議",
  "page-cover-picture.ai-suggested-image-header.flag.suggest-next-time.decline": "不，關閉",
  "page-cover-picture.cancel.reposition": "取消",
  "page-cover-picture.drag.to.reposition.message": "拖曳以重新定位",
  "page-cover-picture.error.flag.description": "請重新整理，然後再試一次。",
  "page-cover-picture.error.flag.title": "我們無法上傳您的標頭影像",
  "page-cover-picture.save.reposition": "套用",
  "page-header-loom-button.crossJoinEntryPointLabel": "加入 Loom 上的團隊，以錄製影片",
  "page-header-loom-button.crossSellPopupCardDescription": "透過影片說明、示範、更新等等，節省時間並與團隊互動。",
  "page-header-loom-button.crossSellPopupCardTitle": "透過影片分享工作內容",
  "page-header-loom-button.entryPointLabel": "錄製 Loom 影片",
  "page-layout.banner": "橫幅",
  "page-layout.impersonation-flag.description": "您已暫時以另一個使用者的身分登入。完成後，請<switchAction>切換回到</switchAction>您的帳戶。",
  "page-layout.impersonation-flag.error-description": "我們無法切換回來。請稍後再試一次，如果這種情況持續發生，請嘗試連絡<atlassianSupport>支援人員</atlassianSupport>。",
  "page-layout.impersonation-flag.error-title": "錯誤",
  "page-layout.impersonation-flag.title": "作用中模擬",
  "page-layout.main": "頁面",
  "page-layout.nav4.feedback-collector.share-feedback-button.text": "提供有關新導覽的意見反應",
  "page-layout.right-panel.resize.label": "重新調整面板大小",
  "page-layout.side-navigation.drag-handle": "側邊導覽拖曳控點",
  "page-layout.side-navigation.global-invite-button-label": "邀請人員",
  "page-layout.side.nav": "側邊導覽",
  "page-layout.sidebar.collapse.label": "摺疊側邊欄",
  "page-layout.sidebar.expand.label": "展開側邊欄",
  "page-layout.sidebar.tooltip.collapse": "摺疊",
  "page-layout.sidebar.tooltip.expand": "展開",
  "page-layout.skip.links": "跳至",
  "page-layout.top.nav": "Confluence 導覽",
  "page-properties-report-renderer.error.message": "無法顯示此報告。請重新整理，然後再試一次。",
  "page-properties-report-renderer.loading.message": "正在產生頁面屬性報告...",
  "page-properties-report-renderer.loading.message.content-properties": "正在產生內容屬性報告...",
  "page-properties-report-renderer.noContent": "找不到內容",
  "page-properties-report-renderer.table.comments": "留言",
  "page-properties-report-renderer.table.labels": "標籤",
  "page-properties-report-renderer.table.modified": "已修改",
  "page-properties-report-renderer.table.owner": "負責人",
  "page-properties-report-renderer.table.reactions": "回應",
  "page-properties-report-renderer.table.title": "標題",
  "page-properties-report-renderer.table.unresolvedComments": "未解決的留言",
  "page-recommendations.eop.collapse.button": "摺疊",
  "page-recommendations.eop.expand.button": "展開",
  "page-recommendations.eop.feedback.button": "提供意見反應",
  "page-recommendations.eop.feedback.hide": "對所有人隱藏...",
  "page-recommendations.eop.feedback.info": "系統會根據一起檢視或整理在一起的內容，自動產生這些建議。建議會隨時間經過而更新，並且遵守內容限制。",
  "page-recommendations.eop.hide.modal.cancel": "取消",
  "page-recommendations.eop.hide.modal.hide.button": "對所有人隱藏",
  "page-recommendations.eop.hide.modal.info": "此內容的建議將對所有人隱藏。",
  "page-recommendations.eop.hide.modal.info.show": "您可以在進階詳細資料底下再次顯示相關內容。",
  "page-recommendations.eop.hide.modal.title": "要向<b>所有人</b>隱藏相關內容嗎？",
  "page-recommendations.eop.info": "更多資訊",
  "page-recommendations.eop.space.setting.default": "預設行為",
  "page-recommendations.eop.space.setting.default.hidden": "在每個頁面上隱藏",
  "page-recommendations.eop.space.setting.default.hidden.livedocs": "在每個頁面或即時文件上隱藏",
  "page-recommendations.eop.space.setting.default.shown": "在每個頁面上顯示",
  "page-recommendations.eop.space.setting.default.shown.livedocs": "在每個頁面或即時文件上顯示",
  "page-recommendations.eop.space.setting.hide.toggle": "相關內容",
  "page-recommendations.eop.space.setting.info": "相關內容會根據一起檢視或整理在一起的內容自動產生建議。這些建議會在某些頁面底部顯示為一系列的卡片，並且可能會隨著時間經過而更新。",
  "page-recommendations.eop.space.setting.off": "此空間的相關內容已關閉。",
  "page-recommendations.eop.space.setting.on": "此空間的相關內容已開啟，但任何擁有編輯權限的人都可以隱藏建議。",
  "page-recommendations.eop.space.setting.on.hidden": "此空間的相關內容已開啟，但除非由有編輯權限的使用者設定為顯示建議，否則系統會隱藏建議。",
  "page-recommendations.eop.title": "相關內容",
  "page-recommendations.feedback.cancel": "取消",
  "page-recommendations.feedback.confirmation": "已提交意見反應",
  "page-recommendations.feedback.confirmation.description.v2": "感謝您協助我們改善相關內容！",
  "page-recommendations.feedback.description": "您對相關內容的滿意程度如何？",
  "page-recommendations.feedback.followup": "感謝您的意見反應！您喜歡其中哪一個部分？有什麼可以改善的嗎？",
  "page-recommendations.feedback.followup.second": "您對於此特定項目的相關內容有任何意見反應嗎？",
  "page-recommendations.feedback.rating.bad": "不佳",
  "page-recommendations.feedback.rating.good": "良好",
  "page-recommendations.feedback.rating.great": "太棒了",
  "page-recommendations.feedback.rating.okay": "普通",
  "page-recommendations.feedback.rating.terrible": "很糟糕",
  "page-recommendations.feedback.submit": "提交",
  "page-recommendations.feedback.title.v2": "感謝您試用相關內容",
  "page-recommendations.related.pages.space.settings.feedback.button.text": "提供意見反應",
  "page-recommendations.related.pages.space.settings.feedback.section": "您對相關內容有什麼想法？",
  "page-selection-table.clickable-column-header.sort-label": "可排序",
  "page-selection-table.column-header.more.actions.": "更多動作",
  "page-selection-table.column-header.title.": "標題",
  "page-selection-table.data-row.branch-selected-count": "已選取 {numberOfPagesSelected} 項 (共 {totalNumberOfPages} 項)",
  "page-selection-table.empty-archived-content-list.body": "封存過期內容，讓您的工作區保持在最新狀態，維持井然有序。{learnMore}",
  "page-selection-table.empty-archived-content-list.title": "封存空白",
  "page-selection-table.empty-bulk-archive.body.content": "建立後，您可以在這裡開始大量封存檔案！{learnMore}",
  "page-selection-table.empty-bulk-archive.title.content": "尚未建立任何內容。",
  "page-selection-table.empty-page-selection-table.link.learn-more.content": "進一步了解封存的內容",
  "page-selection-table.nested-page-tree.error.title": "我們無法載入整個內容的樹狀結構",
  "page-selection-table.quick-actions.menu.aria-label": "快速動作",
  "page-selection-table.table-tree.label": "封存資料",
  "page-selector.all.pages.in.space": "此空間中的所有內容",
  "page-selector.no-parent-page-selection": "沒有父系",
  "page-selector.no.page.found": "找不到內容",
  "page-selector.pages.loading": "正在載入內容",
  "page-selector.parent.page": "父系",
  "page-selector.recent.pages": "最近",
  "page-selector.search.error": "抱歉，我們現在無法載入搜尋結果。",
  "page-selector.select.parent.page": "選取父系",
  "page-tree.children-count-plural": "{count, plural, other {包括 {count,number} 個子系 }}",
  "page-tree.dragndrop.failed.description": "請重新整理，然後再試一次。如果這種情況持續發生，請連絡您的空間管理員。",
  "page-tree.dragndrop.failed.title": "發生錯誤",
  "page-tree.dragndrop.invalid-move-draft.description": "發布草稿以將內容移至此處。",
  "page-tree.dragndrop.invalid-move-draft.title": "您無法在草稿狀態下移動內容",
  "page-tree.dragndrop.lpt.description": "500 頁以上的列表無法使用拖放功能。請重新整理並再試一次，無需展開內容樹狀結構。",
  "page-tree.dragndrop.lpt.refresh.action": "重新整理頁面",
  "page-tree.dragndrop.lpt.settings.action": "前往空間設定",
  "page-tree.dragndrop.lpt.title": "我們無法移動此內容",
  "page-tree.dragndrop.permissions.error.decription": "您沒有移動此受限制內容的權限。請聯絡您的空間管理員。",
  "page-tree.dragndrop.permissions.error.title": "您無法移動此內容",
  "page-tree.dragndrop.undo.action": "復原",
  "page-tree.dragndrop.undo.title": "已移動 \"{pageTitle}\"",
  "page-tree.dragndrop.undo.untitled": "已移動「未命名」",
  "page-tree.failed.load.content": "無法載入內容樹狀結構",
  "page-tree.failed.load.icon": "內容樹狀結構無法載入的錯誤圖示",
  "page-tree.failed.load.tooltip": "請再等一下，我們正在努力解決此問題。",
  "page-tree.folder.empty-state": "此資料夾中還沒有任何內容。",
  "page-tree.move-dialog.select-page-as-new-parent.label": "選取「{page}」作為新的父系項目",
  "page-tree.move-dialog.untitled-draft": "未命名",
  "page-tree.move-page-dialog.action.cancel": "取消",
  "page-tree.move-page-dialog.action.continue": "繼續",
  "page-tree.move-page-dialog.action.move": "移動",
  "page-tree.move-page-dialog.action.reset": "重新開始",
  "page-tree.move-page-dialog.content.state.warning.body": "<b>狀態</b>。如果移動，此內容將會因為選取空間中的設定，而失去其狀態。其他狀態選項可能會顯示，因此請務必在移動後檢查。",
  "page-tree.move-page-dialog.content.state.warning.title": "將內容移動到此空間將會變更內容屬性",
  "page-tree.move-page-dialog.draft-page.children.move-error.default.description": "此草稿具有子系，無法移至其他空間。請先移動，以重新定位此草稿，或連絡空間管理員尋求協助。",
  "page-tree.move-page-dialog.draft-page.children.move-error.default.title": "您無法移動此內容",
  "page-tree.move-page-dialog.draft-page.move-error.default.description": "只有負責人可以將草稿移到另一個空間。請連絡負責人或空間管理員尋求協助。",
  "page-tree.move-page-dialog.draft-page.move-error.default.title": "您無法移動此內容",
  "page-tree.move-page-dialog.header": "移動",
  "page-tree.move-page-dialog.learn-more-link": "深入了解如何移動內容",
  "page-tree.move-page-dialog.live-doc.move-error.single-conflicting-page-name-within-editor.description": "{destinationSpace} 中已經有名為「<strong>{conflictingPageName}</strong>」的即時文件。請為此文件提供不重複的標題以便移動。",
  "page-tree.move-page-dialog.live-page.move-error.single-conflicting-page-name-within-editor.description": "{destinationSpace} 中已經有名為 <strong>{conflictingPageName}</strong> 的頁面。為此頁面提供不重複的標題以便移動。",
  "page-tree.move-page-dialog.loading-error.description": "請重新整理，然後再試一次。",
  "page-tree.move-page-dialog.loading-error.title": "我們無法載入此資訊",
  "page-tree.move-page-dialog.published-page.move-error.currently-updated.description": "有人剛才更新了此內容。請重新整理，然後再次嘗試移動。",
  "page-tree.move-page-dialog.published-page.move-error.currently-updated.title": "我們現在無法移動此內容",
  "page-tree.move-page-dialog.published-page.move-error.default.description": "我們在移動此內容時遇到問題。請重新整理並再試一次；如果這無法解決問題，請連絡支援人員。",
  "page-tree.move-page-dialog.published-page.move-error.default.title": "我們在移動此內容時遇到問題",
  "page-tree.move-page-dialog.published-page.move-error.destination-does-not-exist.description": "此目的地最近已刪除或封存。請選取其他目的地。",
  "page-tree.move-page-dialog.published-page.move-error.destination-does-not-exist.title": "選取不同的目的地",
  "page-tree.move-page-dialog.published-page.move-error.more-than-hundred-pages.description": "請選取子系項目少於 100 個的項目，然後再試一次。",
  "page-tree.move-page-dialog.published-page.move-error.more-than-hundred-pages.title": "我們無法一次移動這麼多項目。",
  "page-tree.move-page-dialog.published-page.move-error.multiple-conflicting-page-name.description": "{destinationSpace} 空間中已存在下列內容：{listOfConflictingNames}。請先重新命名您的內容再移動。",
  "page-tree.move-page-dialog.published-page.move-error.multiple-conflicting-page-name.title": "具有這些名稱的內容已存在",
  "page-tree.move-page-dialog.published-page.move-error.no-create-permissions-error.description": "若要將內容移至其他空間，您需要具有在該空間中建立頁面的權限。",
  "page-tree.move-page-dialog.published-page.move-error.no-create-permissions-error.title": "您無法移動此內容",
  "page-tree.move-page-dialog.published-page.move-error.no-restrictions-permissions.description": "此內容受到限制，且您沒有在新空間中建立受限制內容的權限。請先移除限制再移動。",
  "page-tree.move-page-dialog.published-page.move-error.no-restrictions-permissions.title": "您無法將受限制的內容移至此空間",
  "page-tree.move-page-dialog.published-page.move-error.not-space-admin-cross-space.description": "只有空間管理員可以將內容移至其他空間。請與管理員連絡以取得協助。",
  "page-tree.move-page-dialog.published-page.move-error.not-space-admin-cross-space.title": "您無法移動此內容",
  "page-tree.move-page-dialog.published-page.move-error.parent-child-loop.description": "無法在正在移動的內容下方建立巢狀目的地。",
  "page-tree.move-page-dialog.published-page.move-error.parent-child-loop.title": "請選取不同的目的地",
  "page-tree.move-page-dialog.published-page.move-error.partially-moved.description": "部分內容無法移至目標空間。如果您在尋找內容時遇到問題，請聯繫支援人員尋求協助。",
  "page-tree.move-page-dialog.published-page.move-error.partially-moved.title": "無法徹底完成移動",
  "page-tree.move-page-dialog.published-page.move-error.permissions-error.description": "請空間管理員移動內容或授予您所需權限。",
  "page-tree.move-page-dialog.published-page.move-error.permissions-error.title": "您沒有移動此內容的權限",
  "page-tree.move-page-dialog.published-page.move-error.single-conflicting-live-page-name-within-editor.call-to-action": "重新命名此文件",
  "page-tree.move-page-dialog.published-page.move-error.single-conflicting-live-page-name-within-editor.title": "將此文件重新命名，使用不重複的名稱",
  "page-tree.move-page-dialog.published-page.move-error.single-conflicting-page-name-within-editor.call-to-action": "重新命名此頁面",
  "page-tree.move-page-dialog.published-page.move-error.single-conflicting-page-name-within-editor.description": "{destinationSpace} 空間中已有標題為 <strong>{conflictingPageName}</strong> 的頁面。若要移動此頁面，您首先需要為其提供不重複的標題並發布頁面。",
  "page-tree.move-page-dialog.published-page.move-error.single-conflicting-page-name-within-editor.title": "將此頁面重新命名，使用不重複的名稱",
  "page-tree.move-page-dialog.published-page.move-error.single-conflicting-page-name.description": "{destinationSpace} 空間中已存在 <strong>{conflictingPageName}</strong>。請先重新命名您的內容再移動。",
  "page-tree.move-page-dialog.published-page.move-error.single-conflicting-page-name.title": "具有此標題的內容已存在",
  "page-tree.move-page-dialog.published-page.move-error.source-does-not-exist.description": "此內容最近已刪除或封存，因此無法移動。",
  "page-tree.move-page-dialog.published-page.move-error.source-does-not-exist.title": "此內容無法移動",
  "page-tree.move-page-dialog.published-page.move-error.source-same-as-target.description": "糟糕！您正在嘗試將內容移至本身。請選擇您想要移至其他哪個內容。",
  "page-tree.move-page-dialog.published-page.move-error.source-same-as-target.title": "您無法將任何內容移至相關位置",
  "page-tree.move-page-dialog.published-page.move-error.too-many-pages.description": "請選取子系項目較少的項目，然後再試一次。",
  "page-tree.move-page-dialog.published-page.move-error.too-many-pages.title": "我們無法一次移動這麼多項目。",
  "page-tree.move-page-dialog.select-space-placeholder": "選取空間",
  "page-tree.move-page-dialog.space-selector.cannot-change-space": "您無法將此內容移至其他空間，因為您在此空間中沒有空間管理員權限。",
  "page-tree.move-page-dialog.subheader1": "選取或搜尋目的地空間，然後將此內容和任何巢狀項目拖放至新位置。",
  "page-tree.move-page-dialog.tabs.browse": "瀏覽",
  "page-tree.move-page-dialog.tabs.page-tree-label": "內容",
  "page-tree.move-page-dialog.tabs.search": "搜尋",
  "page-tree.move-page-dialog.too-many-pages-warning": "這可能需要一段時間。若要加快移動速度，請移動較小批次的內容。",
  "page-tree.move-page.change-warning-remove-classification": "<b>分類。</b>將內容移動到此空間將移除其資料分類層級。",
  "page-tree.move-page.change-warning-set-classification": "<b>分類。</b>如果移動，此內容將繼承新目的地空間的預設分類層級。移動之後，根據目的地空間的預設分類層級，內容將被歸類為「{classification}」。",
  "page-tree.move-page.change-warning-update-classification": "<b>分類。</b>如果移動，此內容將繼承新目的地空間的預設分類層級。將內容移動到此空間會將其資料分類層級從「{originalClassification}」更新為「{classification}」。",
  "page-tree.move-page.flag.success.title": "已移動「{title}」",
  "page-tree.move-page.flag.success.untitled": "未命名",
  "page-tree.no-content.message": "此空間中沒有內容",
  "page-tree.pages.show.more.above": "在上方顯示更多",
  "page-tree.pages.show.more.below": "在下方顯示更多",
  "page-tree.paginate-content.failed.description": "我們在載入更多內容時遇到網路錯誤。請重新整理，然後再試一次。 如果這種情況持續發生，請連絡您的空間管理員。",
  "page-tree.quick-actions.add-to-shortcuts": "加入捷徑",
  "page-tree.quick-actions.archive": "封存",
  "page-tree.quick-actions.automate": "自動化",
  "page-tree.quick-actions.content-does-not-exist.error-flag.description": "請重新整理以更新內容樹狀結構。",
  "page-tree.quick-actions.content-does-not-exist.error-flag.title": "最近有人刪除了該項目",
  "page-tree.quick-actions.copy": "複製",
  "page-tree.quick-actions.copy-link": "複製連結",
  "page-tree.quick-actions.delete": "刪除",
  "page-tree.quick-actions.edit": "編輯",
  "page-tree.quick-actions.edit-restrictions": "編輯限制",
  "page-tree.quick-actions.get-link-error-description": "請嘗試更新您的瀏覽器以解決此問題。",
  "page-tree.quick-actions.get-link-error-title": "我們無法取得連結",
  "page-tree.quick-actions.get-link-success": "連結已複製到剪貼簿",
  "page-tree.quick-actions.inline-rename.add-emoji": "新增表情符號",
  "page-tree.quick-actions.inline-rename.change-emoji": "變更表情符號",
  "page-tree.quick-actions.inline-rename.duplicate-error-description": "請使用不同的名稱來儲存。",
  "page-tree.quick-actions.inline-rename.duplicate-error-title": "該名稱已存在於空間中",
  "page-tree.quick-actions.inline-rename.generic-error-description": "請嘗試重新命名。",
  "page-tree.quick-actions.inline-rename.generic-error-title": "發生錯誤",
  "page-tree.quick-actions.inline-rename.no-title": "新增標題",
  "page-tree.quick-actions.inline-rename.remove-emoji": "移除表情符號",
  "page-tree.quick-actions.inline-rename.success": "{inlineRenameSuccessContentType, select, page {已儲存頁面標題} whiteboard {白板標題已儲存} live {已儲存即時文件標題} other {新標題已儲存}}",
  "page-tree.quick-actions.inline-rename.too-long-error-description": "使用 60 個字元以下的名稱來儲存。",
  "page-tree.quick-actions.inline-rename.too-long-error-title": "該名字太長",
  "page-tree.quick-actions.more-actions": "更多動作",
  "page-tree.quick-actions.more-actions-for-title": "更多動作，{pageTitle}",
  "page-tree.quick-actions.move": "移動",
  "page-tree.quick-actions.rename": "重新命名",
  "page-tree.quick-actions.restrictions-apply-owner-admin": "負責人或管理員已限制此內容上的動作。",
  "page-tree.quick-actions.share": "分享",
  "page-tree.restricted-content.icon": "限制內容圖示",
  "page-tree.status.draft": "草稿",
  "page-tree.untitled-draft": "未命名",
  "page-tree.word": "內容",
  "people-directory.restricted.page.manual.request.access.from.author": "如果您認為您應該擁有存取權，請嘗試向將您帶往此處的人員尋求協助。",
  "people-directory.restricted.page.view.title": "這是受限制的內容",
  "persistent-invite-button.persistent.invite.button": "邀請人員",
  "persistent-upgrade.250-gb": "250 GB 儲存空間",
  "persistent-upgrade.advanced-permissions": "進階權限",
  "persistent-upgrade.allow-listing-ip": "IP 允許清單",
  "persistent-upgrade.analytics": "分析",
  "persistent-upgrade.auto-upgrade-awareness.button.upgrade": "升級",
  "persistent-upgrade.automation": "自動化",
  "persistent-upgrade.guest-access": "公開連結和訪客存取權",
  "persistent-upgrade.high-uptime-sla": "99.9% 運作時間服務等級協議",
  "persistent-upgrade.local-business-hours": "頁面深入解析",
  "persistent-upgrade.local-business-hours.livedocs": "頁面和即時文件深入解析",
  "persistent-upgrade.lozenge-text": "最佳價值",
  "persistent-upgrade.plan-selection.modal-description": "免費試用我們的 Standard 或 Premium 方案！如果您在試用結束後沒有升級，您的團隊會回到 Free 方案。",
  "persistent-upgrade.plan-selection.modal-heading": "試用最適合團隊的方案",
  "persistent-upgrade.plan-selection.premium-features-description": "Standard 方案中的所有內容，外加：",
  "persistent-upgrade.premium-edition-name-premium": "Premium",
  "persistent-upgrade.premium-edition-summary-premium": "適合成長型組織，可取得進階管理員控制項和強大的省時功能。",
  "persistent-upgrade.premium-edition-summary-standard": "<a>檢視所有功能</a>",
  "persistent-upgrade.pricing-unit": "試用期後每位使用者一個月 {price}",
  "persistent-upgrade.section.message.persistent-upgrade.menuitem.freeplan.title": "升級",
  "persistent-upgrade.space-and-page-permissions": "空間和內容權限",
  "persistent-upgrade.standard-edition-name-standard": "Standard",
  "persistent-upgrade.standard-edition-summary": "適用於需要基本安全性管理員控制項的多個團隊或小型組織。",
  "persistent-upgrade.team-calendars": "團隊行事曆",
  "persistent-upgrade.trial-button": "開始使用",
  "persistent-upgrade.trial-length": "{numberOfDays, plural, other {免費使用 {numberOfDays,number} 天}}",
  "persistent-upgrade.trial-plan-comparison.section.message.persistent-upgrade.menuitem.freeplan.label": "試用 Standard 或 Premium 方案",
  "persistent-upgrade.trial-plan-comparison.section.message.persistent-upgrade.menuitem.freeplan.lozenge": "免費試用",
  "persistent-upgrade.unlimited-storage": "無限儲存空間",
  "persistent-upgrade.up-to-50k": "最多 50,000 名使用者",
  "powered-by-templates.byline.text": "使用範本",
  "powered-by-templates.popup.view-template-button": "檢視",
  "premium-onboarding.advanced.permissions.body.text.pto2": "檢視權限相關議題，確保您的團隊擁有合適的內容存取權。",
  "premium-onboarding.advanced.permissions.title": "進階權限",
  "premium-onboarding.analytics.body.text.pto2": "查看網站、空間和內容層級的使用者參與度與檢視次數。",
  "premium-onboarding.analytics.title": "分析",
  "premium-onboarding.automation.body.text": "建立規則以變更內容狀態、建立 Jira 任務等等，藉此節省時間。",
  "premium-onboarding.automation.title": "自動化",
  "premium-onboarding.button.dismiss": "關閉",
  "premium-onboarding.button.done": "完成",
  "premium-onboarding.button.learn.more": "深入了解",
  "premium-onboarding.button.next": "下一頁",
  "premium-onboarding.button.text": "探索功能",
  "premium-onboarding.modal-beginning-of-trial.body.text.pto2": "您使用過的功能會有打勾標記。",
  "premium-onboarding.modal-beginning-of-trial.title.pto2": "您的 Premium 功能指南",
  "premium-onboarding.modal-halfway-through-trial.body.text.sentence1.pto2": "您已使用 <b>{count}</b> 項 Premium 最受歡迎的功能。",
  "premium-onboarding.modal-halfway-through-trial.body.text.sentence2.pto2": "充分善用試用版，探索您還沒嘗試過的功能。",
  "premium-onboarding.modal-halfway-through-trial.body.text.sentence3.pto2": "您已使用 Premium 最受歡迎的<b>全部</b>功能。",
  "premium-onboarding.modal-halfway-through-trial.title.pto2": "{daysLeft, plural, other {您的 Premium 試用版剩下 {daysLeft,number} 天 🎉}}",
  "premium-onboarding.modal.body.text": "探索 Confluence 最強大的功能",
  "premium-onboarding.modal.body.text.pto.rt": "{n, plural, other {開始探索 {n,number} 個最受歡迎的功能。}}",
  "premium-onboarding.modal.body.text.pto2": "開始探索 5 個最受歡迎的功能。",
  "premium-onboarding.modal.body.text.pto2.no.automation": "開始探索 4 個最受歡迎的功能。",
  "premium-onboarding.modal.title": "歡迎開始您的 Premium 方案試用",
  "premium-onboarding.not-useful.button.pto2": "👎 沒幫助",
  "premium-onboarding.premium.ok.button": "確定",
  "premium-onboarding.premium.revisit-feature-guide.title": "回顧功能指南",
  "premium-onboarding.premium.trial-days-description": "查看試用版剩餘天數，並點選這個按鈕隨時回顧功能指南。",
  "premium-onboarding.question-halfway-through-trial.title.pto2": "到目前為止，您對 Premium 功能有什麼想法？",
  "premium-onboarding.team-calendars.body.text": "為團隊的排程和截止日期保留一個單一事實來源。",
  "premium-onboarding.team-calendars.title": "團隊行事曆",
  "premium-onboarding.text.additional.feature.advance.permissions": "進階權限",
  "premium-onboarding.text.additional.feature.atlassian.ai": "Atlassian Intelligence (AI)",
  "premium-onboarding.text.additional.feature.bulk.content.tools": "大量內容管理工具",
  "premium-onboarding.text.additional.feature.whiteboard": "無限的白板和儲存空間",
  "premium-onboarding.title.additional.features": "外加：",
  "premium-onboarding.toggle.body.text": "我們會透過標籤協助您識別 Premium 方案的功能。",
  "premium-onboarding.toggle.title.pto2": "醒目顯示 Confluence 的 Premium 功能",
  "premium-onboarding.unlimited-storage-and-whiteboards.title.pto2": "無限儲存空間和白板",
  "premium-onboarding.useful.button.pto2": "👍 有幫助",
  "premium-onboarding.user.onboarding.analytics": "分析",
  "premium-onboarding.user.onboarding.confluence.cloud.premium": "Confluence Cloud Premium",
  "premium-onboarding.user.onboarding.learn.more": "深入了解。",
  "premium-onboarding.user.onboarding.slide.whiteboards.body": "解鎖進階白板功能的存取權，例如進一步與 Jira 整合和投票功能！<learnMoreLink>深入了解</learnMoreLink>",
  "premium-onboarding.user.onboarding.slide.whiteboards.title": "白板功能",
  "premium-onboarding.user.onboarding.slide1.body": "隨著您的組織成長，輕鬆擴充。您已取得更多分析、新的權限工具和大量封存功能，可大規模管理您的內容。",
  "premium-onboarding.user.onboarding.slide1.title": "歡迎使用 Confluence Cloud Premium",
  "premium-onboarding.user.onboarding.slide2.automate.body": "在您身為管理員的任何空間中 (包括您的個人空間)，<automationLink>自動執行</automationLink>週期性的待辦事項和程序。這樣可以讓空間保持整齊，並且讓內容處於最新狀態。",
  "premium-onboarding.user.onboarding.slide2.automate.title": "自動化功能可以讓內容保持井然有序",
  "premium-onboarding.user.onboarding.slide2.body.p1": "使用頁面和空間分析來尋找您最熱門的內容，並奠定您的成功基礎。在任何頁面的頂端開啟 {analytics}。",
  "premium-onboarding.user.onboarding.slide2.body.p2": "您已利用 {confluenceCloudPremium} 取得分析。讓團隊的知識更上一層樓吧！",
  "premium-onboarding.user.onboarding.slide2.title": "利用分析建立世界級內容",
  "premium-onboarding.whiteboard.body.text": "擁有不限數量的空間，將構想轉化為實際行動。",
  "premium-trial.digest-data-mc-section.collapse-button.label": "摺疊",
  "premium-trial.digest-data-mc-section.collapsed-expand.title": "您的團隊正在免費試用，試用期直到 {trialEndDate}為止。了解他們使用 Premium 方案的情況。",
  "premium-trial.digest-data-mc-section.expand-button.label": "展開",
  "premium-trial.digest-data-mc-section.expand.high-usage.title": "您的 Premium 試用期將在 {trialEndDate} 結束",
  "premium-trial.digest-data-mc-section.expand.low-usage.title": "您的團隊正在免費試用，試用期直到 {trialEndDate}為止",
  "premium-trial.digest-data-mc-section.expand.payment-cta": "繼續使用 Premium 方案",
  "premium-trial.digest-data-mc-section.high-usage.description": "太好了 🥳。您的團隊在此試用期中比其他團隊更加充分運用 Premium 功能。<a>進一步了解 Premium 方案</a>",
  "premium-trial.digest-data-mc-section.high-usage.title": "有 <b>{featureUsagePercentage,number,percent}</b> <s>位使用者已試用 Premium 功能</s>",
  "premium-trial.digest-data-mc-section.low-usage-subtitle": "還有時間可以試用 Premium。鼓勵您的團隊，看看他們喜歡哪些功能。",
  "premium-trial.digest-data-mc-section.low-usage.title": "您的團隊尚未試用 Premium 方案",
  "premium-trial.digest-data-mc-section.premium-features.features-not-used.title": "尚未試用的功能",
  "premium-trial.digest-data-mc-section.premium-features.features-promo.title": "您的團隊試用 Premium 方案之後，您就可以看到他們覺得實用的功能。",
  "premium-trial.digest-data-mc-section.premium-features.features-used.title": "最常使用的功能",
  "premium-trial.digest-data-mc-section.premium-features.high-usage.title": "最常使用的 Premium 功能",
  "premium-trial.digest-data-mc-section.premium-features.low-usage.title": "探索最受歡迎的功能",
  "premium-trial.digest-data-mc-section.premium-icon.label": "Premium",
  "premium-trial.digest-data-mc-section.premium-users.avatar.subtitle.analytics": "分析",
  "premium-trial.digest-data-mc-section.premium-users.avatar.subtitle.automation": "自動化",
  "premium-trial.digest-data-mc-section.premium-users.avatar.subtitle.one-premium-feature-used": "已使用 <b>{feature}</b>",
  "premium-trial.digest-data-mc-section.premium-users.avatar.subtitle.permissions": "權限",
  "premium-trial.digest-data-mc-section.premium-users.avatar.subtitle.team-calendars": "行事曆",
  "premium-trial.digest-data-mc-section.premium-users.avatar.subtitle.two-premium-features-used": "已使用 <b>{feature}</b> 和 <b>{otherFeature}</b>",
  "premium-trial.digest-data-mc-section.premium-users.high-usage.description": "聯繫您的首要使用者，了解他們使用 Premium 功能的情況。",
  "premium-trial.digest-data-mc-section.premium-users.high-usage.title": "首要 Premium 使用者",
  "premium-trial.digest-data-mc-section.premium-users.low-usage.description": "觀看此影片，了解 Premium 提供的功能，或<a>比較功能。</a>",
  "premium-trial.digest-data-mc-section.premium-users.low-usage.title": "進一步了解 Premium 方案",
  "premium-trial.learn-more.video.close-modal.label": "關閉影片強制回應",
  "premium-trial.modal.add-payment-details.button": "新增付款詳細資料",
  "premium-trial.modal.analytics-feature": "已檢視分析",
  "premium-trial.modal.automation-feature": "自動化使用",
  "premium-trial.modal.close-modal.image-alt": "左側插圖",
  "premium-trial.modal.close-modal.label": "關閉強制回應",
  "premium-trial.modal.description": "了解您的團隊如何充分發揮 Premium 方案的所有優勢。若要協助您的團隊在試用期結束後繼續使用 Premium 方案，請新增付款詳細資料。",
  "premium-trial.modal.digest-high-usage-message.summary": "太好了 🥳。您的團隊在此試用期中比其他團隊更加充分運用 Premium 功能。",
  "premium-trial.modal.digest-low-usage-message.summary": "還有時間可以試用 Premium。鼓勵您的團隊，看看他們喜歡哪些功能。",
  "premium-trial.modal.header": "{daysLeft, plural, other {您的試用期將在 {daysLeft,number} 天後結束}}",
  "premium-trial.modal.maybe-later.button": "稍後再說",
  "premium-trial.modal.payment-onfile-description": "了解您的團隊如何充分發揮 Premium 方案的所有優勢。",
  "premium-trial.modal.permissions-inspected-feature": "個權限已檢查",
  "premium-trial.modal.premium-feature-usage.vote-percentage": "{votePercentage,number,percent} 投票表示實用",
  "premium-trial.modal.section.top-premium-features.header": "最常使用的 Premium 功能",
  "premium-trial.modal.section.top-premium-users.title": "首要 Premium 使用者",
  "premium-trial.modal.summary.premium-insights": "<a>查看更多 Premium 深入解析</a>",
  "premium-trial.modal.summary.title": "有 <b>{featureUsagePercentage,number,percent}</b> <s>位使用者已試用 Premium 功能</s>",
  "premium-trial.modal.team-calendar-feature": "行事曆造訪",
  "premium-trial.modal.top-premium-users.avatar.subtitle.analytics": "分析",
  "premium-trial.modal.top-premium-users.avatar.subtitle.automation": "自動化",
  "premium-trial.modal.top-premium-users.avatar.subtitle.one-premium-feature-used": "已使用 <b>{feature}</b>",
  "premium-trial.modal.top-premium-users.avatar.subtitle.permissions": "權限",
  "premium-trial.modal.top-premium-users.avatar.subtitle.team-calendars": "行事曆",
  "premium-trial.modal.top-premium-users.avatar.subtitle.two-premium-features-used": "已使用 <b>{feature}</b> 和 <b>{otherFeature}</b>",
  "premium-trial.onboarding.mt.ai.action": "探索 AI 的功能",
  "premium-trial.onboarding.mt.ai.description": "透過 AI 支援的編輯功能來建立和摘要內容，以達到事半功倍的效果。",
  "premium-trial.onboarding.mt.ai.title": "Atlassian Intelligence (AI)",
  "premium-trial.onboarding.mt.analytics.action": "檢視分析",
  "premium-trial.onboarding.mt.analytics.description": "查看網站、空間和內容層級的使用者參與度與檢視次數。",
  "premium-trial.onboarding.mt.analytics.title": "分析",
  "premium-trial.onboarding.mt.automation.action": "建立自動化規則",
  "premium-trial.onboarding.mt.automation.description": "建立規則以變更內容狀態、建立 Jira 任務等等，藉此節省時間。",
  "premium-trial.onboarding.mt.automation.title": "自動化",
  "premium-trial.onboarding.mt.company-hub.action": "自訂我的公司中心",
  "premium-trial.onboarding.mt.company-hub.description": "透過適用於重要公告和資源的集中式內部網路，協助您的團隊保持聯繫。",
  "premium-trial.onboarding.mt.company-hub.title": "公司中心",
  "premium-trial.onboarding.mt.content-manager.action": "檢視我的內容管理員",
  "premium-trial.onboarding.mt.content-manager.description": "讓內容保持井然有序，並在數百個頁面上同時大量變更。",
  "premium-trial.onboarding.mt.content-manager.description.livedocs": "讓內容保持井然有序，並在數百個頁面和即時文件上同時大量變更。",
  "premium-trial.onboarding.mt.content-manager.title": "內容管理員",
  "premium-trial.onboarding.mt.mission-control.action": "前往任務控制",
  "premium-trial.onboarding.mt.mission-control.description": "透過深入解析和資料導向改善項目的控制項，提高團隊的生產力。",
  "premium-trial.onboarding.mt.mission-control.title": "任務控制",
  "premium-trial.onboarding.mt.modal.description": "開始探索 5 個最受歡迎的功能。",
  "premium-trial.onboarding.mt.modal.title": "歡迎開始您的 Premium 方案試用",
  "premium-trial.onboarding.mt.team-calendars.action": "前往團隊行事曆",
  "premium-trial.onboarding.mt.team-calendars.description": "為團隊的排程和截止日期保留一個單一事實來源。",
  "premium-trial.onboarding.mt.team-calendars.title": "團隊行事曆",
  "premium-trial.onboarding.mt.unlimited-whiteboards.action": "建立白板",
  "premium-trial.onboarding.mt.unlimited-whiteboards.description": "腦力激盪不受限，並且從單一位置將構想轉化為 Jira 任務。",
  "premium-trial.onboarding.mt.unlimited-whiteboards.title": "不受限制的白板和 Jira",
  "premium-trial.onboarding.mt.video-button.text": "追蹤 Premium 的摘要",
  "premium-trial.premium-feature-low-usage.analytics": "分析",
  "premium-trial.premium-feature-low-usage.automation": "自動化",
  "premium-trial.premium-feature-low-usage.not-used-feature-button": "帶我前往那裡",
  "premium-trial.premium-feature-low-usage.permissions-inspected": "進階權限",
  "premium-trial.premium-feature-low-usage.team-calendars": "團隊行事曆",
  "premium-trial.premium-tip-prompt.automation.action-dismiss-message": "不再顯示此內容",
  "premium-trial.premium-tip-prompt.automation.action-open-automation": "前往自動化",
  "premium-trial.premium-tip-prompt.automation.fifth.description": "建立規則以協助您順利協作、整理內容，以及在多個工具上工作。",
  "premium-trial.premium-tip-prompt.automation.fifth.title": "簡化您的日常待辦事項清單",
  "premium-trial.premium-tip-prompt.automation.first.description": "透過自動化免去重複性的任務，例如建立標籤、提醒等等。",
  "premium-trial.premium-tip-prompt.automation.first.title": "節省時間並專注於重要的事情",
  "premium-trial.premium-tip-prompt.automation.fourth.description": "您知道嗎？自動化功能可讓您設定提醒、封存非作用中的內容˙等等。",
  "premium-trial.premium-tip-prompt.automation.fourth.title": "善用自動化功能",
  "premium-trial.premium-tip-prompt.automation.second.description": "使用 AI 建立自動化規則，進而簡化工作流程。",
  "premium-trial.premium-tip-prompt.automation.second.title": "您距離生產力高峰僅有幾步之遙",
  "premium-trial.premium-tip-prompt.automation.third.description": "建立自動化規則，協助您達成事半功倍，以便您專注於真正重要的事情。",
  "premium-trial.premium-tip-prompt.automation.third.title": "透過自動化免去手動工作的麻煩",
  "premium-trial.premium-tip-prompt.close": "關閉 Premium 提示",
  "premium-trial.premium-tip-prompt.generic.action-dismiss-message": "不再顯示此內容",
  "premium-trial.premium-tip-prompt.generic.action-pto-modal": "查看包含的項目",
  "premium-trial.premium-tip-prompt.generic.fifth.description": "Premium 功能可讓您獲得需要的工具和深入解析，以專注於您最擅長的工作。",
  "premium-trial.premium-tip-prompt.generic.fifth.title": "進一步實現生產力高峰",
  "premium-trial.premium-tip-prompt.generic.first.description": "我們的 Premium 功能可協助您完成重要工作，同時節省您的時間和精力。",
  "premium-trial.premium-tip-prompt.generic.first.title": "讓我們為您完成繁重的工作",
  "premium-trial.premium-tip-prompt.generic.fourth.description": "使用 Premium 功能盡可能減少繁忙的工作，並專注於真正重要的事情。",
  "premium-trial.premium-tip-prompt.generic.fourth.title": "讓做決策變得輕鬆簡單",
  "premium-trial.premium-tip-prompt.generic.second.description": "使用 Premium 功能最佳化工作流程，以便專注於您擅長的工作。",
  "premium-trial.premium-tip-prompt.generic.second.title": "將更多時間花在重要的事情上",
  "premium-trial.premium-tip-prompt.generic.third.description": "Premium 功能可協助您保持井然有序，並且在不同工具中維持單一事實來源。",
  "premium-trial.premium-tip-prompt.generic.third.title": "輕鬆提高效率",
  "premium-trial.premium-tip-prompt.header": "Premium 提示",
  "premium.admin.onboarding.analytics": "分析",
  "premium.admin.onboarding.inspect.user.permissions": "檢查使用者的權限",
  "premium.admin.onboarding.learn.more": "深入了解",
  "premium.admin.onboarding.slide.whiteboards.body": "進一步存取進階白板功能，例如與 Jira 和智慧部分進行更多元的整合！<learnMoreLink>深入了解</learnMoreLink>",
  "premium.admin.onboarding.slide.whiteboards.title": "使用白板進行腦力激盪",
  "premium.admin.onboarding.slide1.body": "隨著您的組織成長，輕鬆擴充。您已獲得更多觀看權限、控制權和平台支援，讓團隊知識更上一層樓。",
  "premium.admin.onboarding.slide1.title": "歡迎使用 Confluence Cloud Premium",
  "premium.admin.onboarding.slide2.automation.body": "<automationLink>自動化</automationLink>功能可讓您追蹤內容生命週期、讓空間保持整齊，並且將重要的任務和截止日期通知團隊。",
  "premium.admin.onboarding.slide2.automation.title": "將您不斷拓展的 Confluence 網站自動化",
  "premium.admin.onboarding.slide2.body": "使用網站、空間和頁面 {analyticsLink}，報告專案進度、團隊參與情形和熱門內容。",
  "premium.admin.onboarding.slide2.title": "做出更好的決定",
  "premium.admin.onboarding.slide3.body": "前往受限頁面的 {temporaryAccessLink} 及頁面上的 {inspectUserPermissionsLink}，以快速解決存取問題，讓團隊返回工作崗位。",
  "premium.admin.onboarding.slide3.title": "快速移除障礙",
  "premium.admin.onboarding.slide5.body": "您什麼都不用擔心，因為 Confluence 會全天候啟動並執行。Premium 包含 99.9% 的運作時間 SLA、全年無休的支援，以及無限量的儲存空間。{learnMore}",
  "premium.admin.onboarding.slide5.title": "隨時運作，永不停頓",
  "premium.admin.onboarding.temporary.access": "暫時存取權",
  "presentation-mode.header.cursor.spotlight.toggle": "游標焦點",
  "presentation-mode.header.darkTheme.toggle": "以深色主題呈現",
  "presentation-mode.header.exit": "結束",
  "presentation-mode.header.fullscreen.toggle": "全螢幕檢視",
  "presentation-mode.header.settings.menu.close": "關閉",
  "presentation-mode.header.tooltip.settings": "呈現方式設定",
  "presentation-mode.navigation.content-toggling.spotlight-description": "使用箭頭來強調內容區段，並引導受眾的注意力。",
  "presentation-mode.navigation.control.next": "下一步",
  "presentation-mode.navigation.control.previous": "上一步",
  "presentation-mode.navigation.menu.close": "關閉",
  "presentation-mode.navigation.menu.empty": "沒有要顯示的章節",
  "presentation-mode.navigation.menu.empty.message": "當內容包含不同的<link>章節</link>時，會顯示在此處。",
  "presentation-mode.navigation.menu.information": "深入了解章節",
  "presentation-mode.navigation.menu.title": "跳至章節",
  "presentation-mode.navigation.tooltip.next": "下一個內容部分",
  "presentation-mode.navigation.tooltip.previous": "上一個內容部分",
  "presentation-mode.portal.generic.error.message": "發生錯誤。請重新整理，然後再試一次。",
  "preview-panel-api.resize.label": "重新調整面板大小",
  "profile-macros.renderer.deactivated.user": "{userFullName} (已停用)",
  "profile-macros.renderer.email.title": "將電子郵件傳送至",
  "profile-macros.renderer.image.alt": "使用者圖示",
  "profile-macros.renderer.image.alt.anonymous": "匿名",
  "profile-macros.renderer.image.error": "我們無法顯示此個人檔案圖片。請重新整理以再試一次",
  "profile-macros.renderer.info.error": "我們無法顯示此使用者的資訊。請重新整理以再試一次",
  "profile-macros.renderer.no.access.message": "此巨集的內容只能由已登入的使用者檢視。",
  "profile.anonymous.name": "匿名",
  "profile.avatar.ariaLabel": "{name} 的更多資訊",
  "profile.avatar.image": "使用者的個人檔案圖片",
  "profile.card.feed.follow.mutation.error.description": "請再次嘗試追蹤或取消追蹤這位使用者",
  "profile.card.feed.follow.mutation.error.title": "我們在執行過程中遇到問題",
  "profile.card.follow": "追蹤",
  "profile.card.follow.tooltip": "查看摘要中的活動",
  "profile.card.unfollow": "取消追蹤",
  "profile.card.unfollow.tooltip": "停止查看摘要中的活動",
  "profile.card.viewProfile": "檢視個人檔案",
  "profile.link.name": "{fullName} 設定檔",
  "public-links.changeboarding.intro.acknowledge": "確定",
  "public-links.changeboarding.intro.benefits.additional": "<b>附註：</b>您可以依照個別空間加以控管。",
  "public-links.changeboarding.intro.benefits.four": "公開內容的訪客無法查看或使用應用程式",
  "public-links.changeboarding.intro.benefits.one": "網際網路上的任何人若具有此連結都可以檢視",
  "public-links.changeboarding.intro.benefits.three": "空間設定中具有更精細的控制項",
  "public-links.changeboarding.intro.benefits.two": "輕鬆查看和控管可以公開的內容",
  "public-links.changeboarding.intro.body": "公開連結可讓您的團隊安全地與網際網路上的任何人分享公開的個別內容 (客戶常見問答、版本資訊等等)，而不必提供 Confluence 的存取權。",
  "public-links.changeboarding.intro.learn-more": "深入了解",
  "public-links.changeboarding.intro.title": "透過公開連結，與外部分享內容",
  "public-links.changeboarding.lozenge.text": "全新",
  "public-links.checkbox.dont-show-again": "不再顯示此內容",
  "public-links.content.confirmation-smart-sections": "允許任何人編輯",
  "public-links.content.description": "網際網路上的任何人若具有此內容的公開連結，都能夠檢視內容。此空間中的任何人也將能夠複製和分享連結。",
  "public-links.content.description-revoke": "網際網路上的任何人即使具有此內容的公開連結，將無法再檢視內容。",
  "public-links.content.description-smart-sections": "如果您允許任何人編輯白板上的任何智慧區段，這些區段將會永久停用。<link>深入了解</link>",
  "public-links.content.note.description-smart-sections": "<b>注意：</b>如果公開連結設為可編輯，此白板上的任何智慧區段都將永久停用。",
  "public-links.content.restricted.description": "能檢視此限制內容的人將能夠複製公開連結，並與網際網路上的任何人分享。<learnmorelink>深入了解</learnmorelink>",
  "public-links.content.title-smart-sections": "任何人皆可編輯時，智慧區段將會中斷",
  "public-links.default-space-perms.description-main.copy-version-two": "公開連結可讓團隊與 Confluence 以外的人共用個別的 Confluence 內容，而無需授予他們 Confluence 的存取權。這可控管是否要允許在此網站上建立的任何新空間中，使用公用連結。<learnmorelink>進一步了解公開連結。</learnmorelink>",
  "public-links.default-space-perms.description-toggle.copy-version-two": "允許在所有新空間中使用公開連結",
  "public-links.default-space-perms.failure-message": "動作無法完成。請再試一次。",
  "public-links.default-space-perms.friction-cancel": "取消",
  "public-links.default-space-perms.friction-confirm": "設為預設值",
  "public-links.default-space-perms.friction-description.copy-version-two": "所有建立的新空間都允許使用者針對空間中的內容，開啟並分享公開連結。網際網路上的任何人若具有內容的公開連結，都能夠檢視內容。",
  "public-links.default-space-perms.friction-learnmorelink": "深入了解公開連結",
  "public-links.default-space-perms.friction-title.copy-version-two": "要允許在所有新空間中使用公開連結嗎？",
  "public-links.default-space-perms.success-message": "公開連結的預設值已更新",
  "public-links.default-space-perms.title": "公開連結",
  "public-links.empty-table.no-search-results.icon": "找不到相符項目的圖示",
  "public-links.export-share-as-public-link.learnMore": "深入了解",
  "public-links.export-share-as-public-link.share": "分享公開連結",
  "public-links.export-share-as-public-link.text": "公開連結可方便您變更內容並讓所有人保持一致。",
  "public-links.export-share-as-public-link.title": "以公開連結分享",
  "public-links.filter.button-label": "篩選條件",
  "public-links.filter.reset": "重設篩選條件",
  "public-links.page-table.actions.live.doc.error.title": "{count, plural, other {我們無法更新即時文件}}",
  "public-links.page-table.actions.pages.error.title": "{count, plural, other {我們無法更新頁面}}",
  "public-links.page.cancel": "取消",
  "public-links.page.confirmation": "開啟",
  "public-links.page.confirmation-revoke": "停用",
  "public-links.page.description-two": "與外部分享時請小心謹慎。<learnmorelink>深入了解</learnmorelink>",
  "public-links.page.restricted.confirmation": "啟用",
  "public-links.page.restricted.title": "要啟用限制內容的公開連結嗎？",
  "public-links.page.title": "要啟用公開連結嗎？",
  "public-links.page.title-revoke": "要停用公開連結嗎？",
  "public-links.pages-table-action.modal.cancel-button": "取消",
  "public-links.pages-table-bulk-action.modal.block-description": "這會停用公開連結，禁止其他人重新啟用。管理員將需要解除鎖定。",
  "public-links.pages-table-bulk-action.modal.block-title": "{count, plural, other {要封鎖 {count} 個公開連結嗎？}}",
  "public-links.pages-table-bulk-action.modal.block.confirmation-button": "封鎖",
  "public-links.pages-table-bulk-action.modal.turn-off.confirmation-button": "停用",
  "public-links.pages-table-bulk-action.modal.turn-off.description": "這將停用公開連結。具有內容存取權的任何人都可以重新啟用。",
  "public-links.pages-table-bulk-action.modal.turn-off.title": "{count, plural, other {要停用 {count} 個公開連結嗎？}}",
  "public-links.pages-table-bulk-action.modal.unblock.confirmation-button": "解除封鎖",
  "public-links.pages-table-bulk-action.modal.unblock.description": "這會讓公開連結保持停用，並允許具有內容存取權的任何人將其啟用。",
  "public-links.pages-table-bulk-action.modal.unblock.title": "{count, plural, other {要解除封鎖 {count} 個公開連結嗎？}}",
  "public-links.pages-table.actions.block-pages.success.title": "{count, plural, other {已封鎖 {count,number} 個公開連結}}",
  "public-links.pages-table.actions.turn-off-pages.success.title": "{count, plural, other {有 {count,number} 個公開連結現已封鎖}}",
  "public-links.pages-table.bulk-actions.no-changes-made.info.description": "這些空間已經處於您想要的狀態。",
  "public-links.pages-table.bulk-actions.no-changes-made.info.title": "無需變更",
  "public-links.pages-table.content.page-title-column": "內容標題",
  "public-links.pages-table.cta-header.turn-off": "停用",
  "public-links.pages-table.date-enabled-column.copy-version-two": "開啟日期",
  "public-links.pages-table.empty-description": "{isCompanyHub, select, true {此中心沒有作用中的公開連結} other {此空間中沒有作用中的公開連結}}",
  "public-links.pages-table.enabled-by-column.copy-version-two": "開啟者",
  "public-links.pages-table.error.message": "我們無法在此空間中載入公開連結",
  "public-links.pages-table.filters.search-textbox.content.placeholder": "搜尋內容",
  "public-links.pages-table.modal.block.confirmation-button": "封鎖",
  "public-links.pages-table.modal.block.description": "這會停用公開連結，並禁止其他人重新啟用。管理員將需要先解除封鎖。",
  "public-links.pages-table.modal.block.title": "要封鎖公開連結嗎？",
  "public-links.pages-table.modal.learn-more-link": "深入了解公開連結",
  "public-links.pages-table.modal.turn-off.confirmation-button": "停用",
  "public-links.pages-table.modal.turn-off.description": "網際網路上的任何人即使具有公開連結，也無法再檢視其內容。",
  "public-links.pages-table.modal.turn-off.title": "要停用公開連結嗎？",
  "public-links.pages-table.modal.unblock.confirmation-button": "解除封鎖",
  "public-links.pages-table.modal.unblock.description": "這會讓公開連結保持停用，並允許具有內容存取權的任何人將其啟用。",
  "public-links.pages-table.modal.unblock.title": "要解除封鎖公開連結嗎？",
  "public-links.pages-table.no-search-results.message": "我們找不到任何結果",
  "public-links.pages-table.quick-actions.disabled-unblock-message": "您在此內容上的動作受到管理員限制。",
  "public-links.pages-table.quick-actions.partial-unblock-pages.info.description": "您沒有解除封鎖一或多個選取項目的權限，因為產品管理員已封鎖權限。",
  "public-links.pages-table.quick-actions.partial-unblock-pages.info.title": "您無法解除封鎖一個或多個項目",
  "public-links.pages-table.quick-actions.turn-off-and-block": "封鎖",
  "public-links.pages-table.quick-actions.turn-off-and-block.description": "防止其他人重新啟用",
  "public-links.pages-table.quick-actions.turn-off-page.description": "其他人可以重新啟用",
  "public-links.pages-table.quick-actions.turn-off.label": "停用",
  "public-links.pages-table.quick-actions.unblock-pages.success.title": "{count, plural, other {已解除封鎖 {count,number} 個公開連結}}",
  "public-links.pages-table.quick-actions.unblock.description": "您在此內容上的動作受到管理員限制。",
  "public-links.pages-table.quick-actions.unblock.label": "解除封鎖",
  "public-links.pages-table.quick-actions.view-public-link": "檢視公開連結",
  "public-links.pages-table.status.lozenge.blocked.text": "已封鎖",
  "public-links.pages-table.status.lozenge.on.text": "開啟",
  "public-links.restrictions.local.disable-pl.body": "只要處於作用中狀態，網際網路上具有連結的任何人皆能檢視內容。<learnmorelink>深入了解</learnmorelink>",
  "public-links.restrictions.local.disable-pl.heading": "要停用公開連結嗎？",
  "public-links.restrictions.local.disable-pl.no-button": "保持啟用",
  "public-links.restrictions.local.disable-pl.yes-button": "停用",
  "public-links.search-textbox-reset-button-caption": "重設文字篩選條件",
  "public-links.search-textbox-search-button-caption": "搜尋",
  "public-links.settings.flag.disabled.success.title": "此網站上不再允許使用公開連結。",
  "public-links.settings.flag.enabled.success.title": "此網站現在允許使用公開連結",
  "public-links.settings.flag.error.title": "我們無法更新此網站",
  "public-links.settings.spotlight.content.body": "除了空間層級的次要控管之外，您也可以微調有哪些內容可以透過公開連結與外部分享。",
  "public-links.settings.spotlight.heading": "允許他人在您的網站上使用公開連結",
  "public-links.settings.spotlight.nextButtonLabel": "下一個",
  "public-links.settings.toggle": "允許在此網站上使用公開連結",
  "public-links.settings.tooltip": "公開連結僅適用於付費方案",
  "public-links.site-settings.back-to-spaces-link": "所有空間",
  "public-links.site-settings.back-to-spaces-link-label": "返回所有空間",
  "public-links.site-settings.content.description-main": "您可以透過公開連結，讓 Confluence 使用者與網際網路讓的任何人分享內容。這些連結可讓無法存取 Confluence 的人檢視公開連結中的內容 (例如客戶常見問答、版本資訊或股東信函)。",
  "public-links.site-settings.description-details.for-GA": "您可以決定哪些空間要允許使用公開連結。在 Premium 方案中，您可以藉由封鎖空間，讓空間管理員無法在其空間中允許使用公開連結。",
  "public-links.site-settings.learn-more": "進一步了解公開連結",
  "public-links.site-settings.modal.disable-description": "這個網站上沒有人能夠再啟用任何公開連結。所有作用中的公開連結都會停用，必須手動才能重新啟用。",
  "public-links.site-settings.modal.disable-title": "要停止允許在此網站中使用公開連結嗎？",
  "public-links.site-settings.modal.disable-yes-button-text": "停止允許",
  "public-links.site-settings.modal.learn-more-link": "深入了解公開連結",
  "public-links.site-settings.modal.no-button-text": "取消",
  "public-links.site-settings.modal.premium.content.enable-description": "<p><b>這會允許 Confluence 使用者在尚未封鎖的空間中，啟用任何內容的公開連結。</b>網際網路上的任何人若具有內容項目的公開連結，都能夠檢視內容。</p>",
  "public-links.site-settings.modal.premium.enable-description-two": "這不會將任何項目設為公開。",
  "public-links.site-settings.modal.premium.enable-title": "是否要允許在此網站上使用公開連結？",
  "public-links.site-settings.modal.premium.enable-yes-button-text": "允許",
  "public-links.site-settings.modal.standard.content.enable-description": "<p><b>這會允許 Confluence 使用者在任何空間中，啟用任何內容的公開連結。</b>網際網路上的任何人若具有內容的公開連結，都能夠檢視內容。</p>",
  "public-links.site-settings.modal.standard.enable-description-two": "這不會將任何項目設為公開。",
  "public-links.site-settings.modal.standard.enable-title": "是否要允許在此網站上使用公開連結？",
  "public-links.site-settings.modal.standard.enable-yes-button-text": "允許",
  "public-links.site-settings.org-policy-blocked.link.non-org-admin": "進一步了解已封鎖的公開連結",
  "public-links.site-settings.org-policy-blocked.link.org-admin": "在「Atlassian 管理」中允許",
  "public-links.site-settings.org-policy-blocked.message": "您的組織已透過資料安全政策，封鎖現有和未來的公開連結。",
  "public-links.site-settings.standard-upsell.learn-more-link": "深入了解",
  "public-links.site-settings.standard-upsell.message-body": "使用大量動作，大規模管理公開連結。您可以透過批次變更提高效率，不用逐一變更。您也可以讓空間管理員無法允許使用公開連結，以便提升控管程度。<i></i>",
  "public-links.site-settings.standard-upsell.message-title": "用於管理公開連結更強大的工具",
  "public-links.site-settings.standard-upsell.try-free": "免費試用",
  "public-links.site-settings.standard-upsell.try-premium": "試用 Premium 方案",
  "public-links.space-settings.blocked-state.learn-more-about-policy-link": "<learnmorelink>進一步了解已封鎖的公開連結</learnmorelink>",
  "public-links.space-settings.blocked-state.learn-more-link": "<learnmorelink>深入了解公開連結</learnmorelink>",
  "public-links.space-settings.blocked-state.org-policy-blocked.lin.org-admin": "<link>在「Atlassian 管理」中允許</link>",
  "public-links.space-settings.blocked-state.panel-text-default": "您的組織禁止在此空間中使用公開連結。",
  "public-links.space-settings.blocked-state.panel-text-product-admin": "您的組織目前禁止在此空間中使用公開連結。",
  "public-links.space-settings.blocked-state.settings-link": "<link>在設定中允許</link>",
  "public-links.space-settings.classifications-message.disabled": "如果內容含有<dataClassificationLink>安全性政策</dataClassificationLink>封鎖的公開連結，則無法由管理員控管，且不會顯示在下表。",
  "public-links.space-settings.content.description-details": "網際網路上的任何人若具有公開連結，都能夠檢視該內容。<learnmorelink>深入了解公開連結</learnmorelink>",
  "public-links.space-settings.description-main": "{isCompanyHub, select, true {您可以透過公開連結，讓其他人與網際網路上的任何人分享內容。這些連結可讓無法存取 Confluence 的人檢視特定內容 (例如客戶常見問答、版本資訊或股東信函)。} other {您可以透過公開連結，讓空間中的其他人與網際網路上的任何人分享內容。這些連結可讓無法存取 Confluence 的人檢視特定內容 (例如客戶常見問答、版本資訊或股東信函)。}}",
  "public-links.space-settings.disabled-by-classifications.title": "含有公開連結的某些內容不會顯示在此處",
  "public-links.space-settings.flag.description.error": "發生錯誤。請再試一次。",
  "public-links.space-settings.flag.description.off": "此空間中不再允許使用公開連結。",
  "public-links.space-settings.flag.description.on": "此空間已允許使用公開連結",
  "public-links.space-settings.flag.title.error": "我們無法更新空間",
  "public-links.space-settings.modal.cancel": "取消",
  "public-links.space-settings.modal.confirmation": "允許",
  "public-links.space-settings.modal.content-impacted": "受影響的公開連結",
  "public-links.space-settings.modal.content.description": "這不會將任何項目設為公開，只會允許這個空間中的人使用公開連結。 網際網路上的任何人若具有內容的公開連結，都能夠檢視內容。",
  "public-links.space-settings.modal.content.revoke-description": "外部人員的所有作用中公開連結都會停止運作。此空間中的任何人都無法啟用內容的公開連結。",
  "public-links.space-settings.modal.learn-more-link": "深入了解公開連結",
  "public-links.space-settings.modal.revoke-confirmation": "停止允許",
  "public-links.space-settings.modal.revoke-title": "要停止允許在此空間中使用公開連結嗎？",
  "public-links.space-settings.modal.title": "要允許在此空間中使用公開連結嗎？",
  "public-links.space-settings.restricted.message": "只有部分人員能檢視此項目。如果您認為您應該有存取權，請嘗試向將您帶往此處的人員尋求協助。",
  "public-links.space-settings.restricted.title": "您碰巧遇到了受限制的內容",
  "public-links.space-settings.tooltip.non-current-space": "此空間已封存。請復原以允許公開連結。",
  "public-links.space.edition-message.body.admin": "您的團隊可以使用公開連結，與網際網路上的任何人分享內容，這只適用於 Confluence 的付費方案。",
  "public-links.space.edition-message.body.non-admin": "您的團隊可以使用公開連結，與網際網路上的任何人分享內容，這只適用於 Confluence 的付費方案。<learnmorelink>深入了解</learnmorelink>",
  "public-links.space.edition-message.title": "在網際網路上公開分享內容",
  "public-links.space.settings.toggle": "{isCompanyHub, select, true {允許此中心的公開連結} other {允許在此空間中使用公開連結}}",
  "public-links.space.spotlight.content.body": "控管空間中的人員是否可以使用公開連結。直到有人啟用公開連結並加以分享之前，沒有任何內容會設為公開。",
  "public-links.spaces-table.actions.block-spaces.success.title": "{count, plural, other {有 {count} 個空間現已禁止使用公開連結}}",
  "public-links.spaces-table.actions.space.error.title": "{count, plural, other {我們無法更新空間}}",
  "public-links.spaces-table.actions.turn-off-spaces.success.title": "{count, plural, other {有 {count} 個空間已不再允許使用公開連結}}",
  "public-links.spaces-table.actions.turn-on-spaces.success.title": "{count, plural, other {有 {count} 個空間現已允許使用公開連結}}",
  "public-links.spaces-table.actions.unblock-spaces.success.title": "{count, plural, other {有 {count} 個空間已不再封鎖公開連結}}",
  "public-links.spaces-table.content.public-pages-column": "公開連結",
  "public-links.spaces-table.cta-header.turn-off": "停止允許",
  "public-links.spaces-table.cta-header.turn-on": "允許",
  "public-links.spaces-table.error.message": "我們無法載入此網站的空間",
  "public-links.spaces-table.filters.search-textbox.placeholder": "搜尋空間",
  "public-links.spaces-table.modal.premium.block-description": "這會讓空間管理員無法在這些空間中允許使用公開連結。所有目前作用中的公開連結都會停用，必須手動才能重新啟用。",
  "public-links.spaces-table.modal.premium.block-learn-more-link": "深入了解公開連結",
  "public-links.spaces-table.modal.premium.block-no-button-text": "取消",
  "public-links.spaces-table.modal.premium.block-yes-button-text": "封鎖",
  "public-links.spaces-table.modal.premium.content.preemptive-unblock-description": "{count, plural, other {如果本網站允許使用公開連結，即可在這些空間中使用公開連結。網際網路上的任何人若具有內容的公開連結，都能夠檢視內容。}}",
  "public-links.spaces-table.modal.premium.content.turn-on-description": "這些空間中的人員將能夠啟用並分享公開連結。網際網路上的任何人若具有內容的公開連結，都能夠檢視內容。",
  "public-links.spaces-table.modal.premium.content.unblock-description": "這不會將任何項目設為公開，只會允許這些空間中的人使用公開連結。網際網路上的任何人若具有內容的公開連結，都能夠檢視內容。",
  "public-links.spaces-table.modal.premium.preemptive-block-description.copy-version-two": "{count, plural, other {如果此網站上已允許使用公開連結，這會禁止空間管理員允許在這些空間中使用公開連結。}}",
  "public-links.spaces-table.modal.premium.preemptive-block-no-button-text": "取消",
  "public-links.spaces-table.modal.premium.preemptive-block-title": "{count, plural, other {要讓公開連結無法在 {count} 個空間中允許使用嗎？}}",
  "public-links.spaces-table.modal.premium.preemptive-block-yes-button-text": "封鎖",
  "public-links.spaces-table.modal.premium.preemptive-unblock-learn-more-link": "深入了解公開連結",
  "public-links.spaces-table.modal.premium.preemptive-unblock-no-button-text": "取消",
  "public-links.spaces-table.modal.premium.preemptive-unblock-title": "{count, plural, other {要解除封鎖 {count} 個空間中的公開連結嗎？}}",
  "public-links.spaces-table.modal.premium.preemptive-unblock-yes-button-text": "解除封鎖",
  "public-links.spaces-table.modal.premium.turn-off-description": "這會停用所有作用中的公開連結，必須手動才能重新啟用。",
  "public-links.spaces-table.modal.premium.turn-off-description-two": "空間管理員可以隨時重新允許。",
  "public-links.spaces-table.modal.premium.turn-off-learn-more-link": "深入了解公開連結",
  "public-links.spaces-table.modal.premium.turn-off-no-button-text": "取消",
  "public-links.spaces-table.modal.premium.turn-off-yes-button-text": "停止允許",
  "public-links.spaces-table.modal.premium.turn-on-learn-more-link": "深入了解公開連結",
  "public-links.spaces-table.modal.premium.turn-on-no-button-text": "取消",
  "public-links.spaces-table.modal.premium.turn-on-yes-button-text": "允許",
  "public-links.spaces-table.modal.premium.unblock-learn-more-link": "深入了解公開連結",
  "public-links.spaces-table.modal.premium.unblock-no-button-text": "取消",
  "public-links.spaces-table.modal.premium.unblock-yes-button-text": "解除封鎖",
  "public-links.spaces-table.modal.standard.block-description": "這會讓空間管理員無法在此空間中允許使用公開連結。所有目前作用中的公開連結都會停用，必須手動才能重新啟用。",
  "public-links.spaces-table.modal.standard.block-learn-more-link": "深入了解公開連結",
  "public-links.spaces-table.modal.standard.block-no-button-text": "取消",
  "public-links.spaces-table.modal.standard.block-title": "要禁止在此空間中使用公開連結嗎？",
  "public-links.spaces-table.modal.standard.block-yes-button-text": "封鎖",
  "public-links.spaces-table.modal.standard.content.block-description-three": "<p>受影響的公開連結：{count} 個</p>",
  "public-links.spaces-table.modal.standard.content.turn-off-description-three": "<p>受影響的公開連結：{count} 個</p>",
  "public-links.spaces-table.modal.standard.content.turn-on-description": "這不會將任何項目設為公開，只會允許這個空間中的人使用公開連結。網際網路上的任何人若具有內容的公開連結，都能夠檢視內容。",
  "public-links.spaces-table.modal.standard.content.unblock-description": "這不會將任何項目設為公開，只會允許這個空間中的人使用公開連結。網際網路上的任何人若具有內容的公開連結，都能夠檢視內容。",
  "public-links.spaces-table.modal.standard.turn-off-description": "這會停用所有作用中的公開連結，必須手動才能重新啟用。",
  "public-links.spaces-table.modal.standard.turn-off-description-two": "空間管理員可以隨時重新允許。",
  "public-links.spaces-table.modal.standard.turn-off-learn-more-link": "深入了解公開連結",
  "public-links.spaces-table.modal.standard.turn-off-no-button-text": "取消",
  "public-links.spaces-table.modal.standard.turn-off-title": "要停止允許在此空間中使用公開連結嗎？",
  "public-links.spaces-table.modal.standard.turn-off-yes-button-text": "停止允許",
  "public-links.spaces-table.modal.standard.turn-on-learn-more-link": "深入了解公開連結",
  "public-links.spaces-table.modal.standard.turn-on-no-button-text": "取消",
  "public-links.spaces-table.modal.standard.turn-on-title": "要允許在此空間中使用公開連結嗎？",
  "public-links.spaces-table.modal.standard.turn-on-yes-button-text": "允許",
  "public-links.spaces-table.modal.standard.unblock-learn-more-link": "深入了解公開連結",
  "public-links.spaces-table.modal.standard.unblock-no-button-text": "取消",
  "public-links.spaces-table.modal.standard.unblock-title": "要解除封鎖並允許在此空間中使用公開連結嗎？",
  "public-links.spaces-table.modal.standard.unblock-yes-button-text": "解除封鎖",
  "public-links.spaces-table.no-search-results.message": "我們找不到任何結果",
  "public-links.spaces-table.quick-actions.block-space.description": "讓空間管理員無法重新允許",
  "public-links.spaces-table.quick-actions.block-space.label": "封鎖",
  "public-links.spaces-table.quick-actions.link.learn-more": "深入了解",
  "public-links.spaces-table.quick-actions.link.try-it-now": "<a>立即試用</a>",
  "public-links.spaces-table.quick-actions.manage-space.label": "管理作用中的公開連結",
  "public-links.spaces-table.quick-actions.menu.aria-label": "更多動作",
  "public-links.spaces-table.quick-actions.menu.spotlight.heading": "保護機密空間",
  "public-links.spaces-table.quick-actions.menu.spotlight.message": "某些空間中的內容不應公開分享。因此，您可以禁止空間管理員在其中允許使用公開連結，以確保資訊受到保護。",
  "public-links.spaces-table.quick-actions.site-off.block-space.description": "讓空間管理員無法允許",
  "public-links.spaces-table.quick-actions.turn-off-space.description": "空間管理員可以重新允許",
  "public-links.spaces-table.quick-actions.turn-off.label": "停止允許",
  "public-links.spaces-table.quick-actions.turn-on-space.label": "允許",
  "public-links.spaces-table.quick-actions.unblock-space.description": "允許此空間中的人員使用公開連結",
  "public-links.spaces-table.quick-actions.unblock-space.label": "解除封鎖並允許",
  "public-links.spaces-table.quick-actions.upsell": "讓空間無法允許使用公開連結",
  "public-links.spaces-table.quick-actions.view-pages.label": "檢視公開連結詳細資料",
  "public-links.spaces-table.search.placeholder": "搜尋空間",
  "public-links.spaces-table.space-name-column": "空間名稱",
  "public-links.spaces-table.status-column": "狀態",
  "public-links.spaces-table.status.lozenge.blocked.text": "禁止允許",
  "public-links.spaces-table.status.lozenge.off.text": "不允許",
  "public-links.spaces-table.status.lozenge.on.text": "已允許",
  "public-links.spotlight-message.acknowledge": "確定",
  "public-links.stats-summary.total-disabled": "已停用總計",
  "public-links.stats-summary.total-enabled": "已啟用頁面總計",
  "public-links.stats-summary.total-enabled.livedocs": "已啟用的頁面和即時文件總數",
  "public-links.stats-summary.total-views": "檢視次數總計",
  "public-links.table-filter.apply-search-hint": "按 Enter 鍵或按一下搜尋圖示進行搜尋",
  "public-links.table.cta-header.block": "封鎖",
  "public-links.table.cta-header.unblock": "解除封鎖",
  "public-links.table.quick-actions.menu.aria-label": "公開連結更多動作",
  "public-links.table.quick-actions.unblock.label": "解除封鎖",
  "public-links.tables-common.public-links-views-column.heading": "公開連結檢視 (30 天)",
  "public-links.upsell.toggle-disabled-tooltip-free-trial": "您在免費試用期間無法使用公開連結。",
  "public-links.useAddPublicLinkPermissionsMutation.error.body": "開啟「分享和限制」對話方塊以檢查目前的狀態，或更新權限。",
  "public-links.useAddPublicLinkPermissionsMutation.error.title": "我們無法變更公開連結權限。",
  "public-links.usePublicLinkDataProvider.sharePathError.message": "publicLinkStatus 狀態為開啟，但並未提供 publicLinkUrlPath",
  "public-links.usePublicLinkDisablePageMutation.error.body": "開啟「分享」對話方塊以檢查目前的狀態，或停用公開連結。",
  "public-links.usePublicLinkDisablePageMutation.error.title": "我們無法關閉公開連結。",
  "public-links.usePublicLinkDisablePageMutation.success.title": "此內容的公開連結現已停用。",
  "public-links.usePublicLinkEnablePageMutation.error.body": "開啟「分享和限制」對話方塊以檢查目前的狀態，或啟用公開連結。",
  "public-links.usePublicLinkEnablePageMutation.error.title": "我們無法啟用公開連結。",
  "public-links.usePublicLinkEnablePageMutation.success.title": "此內容的公開連結現已啟用。",
  "public-links.useRemovePublicLinkPermissionsMutation.error.body": "開啟「分享和限制」對話方塊以檢查目前的狀態，或更新權限。",
  "public-links.useRemovePublicLinkPermissionsMutation.error.title": "我們無法變更公開連結權限。",
  "public-links.validation.body": "如果子系項目具有作用中的公開連結，那麼在網際網路上具有公開連結的任何人仍然可以檢視這些項目。<learnmorelink>深入了解</learnmorelink>",
  "public-links.validation.confirm-button": "確定",
  "public-links.validation.heading": "限制不適用於公開連結",
  "publish-modal.add-version-comments-label": "版本註解",
  "publish-modal.add-version-comments-placeholder-text": "描述這個版本",
  "publish-modal.blog": "部落格",
  "publish-modal.blog-title": "發布部落格",
  "publish-modal.breadcrumbs-path.blog-word": "部落格",
  "publish-modal.breadcrumbs-path.pages-word": "內容",
  "publish-modal.cancel-schedule-publish-failure-message": "您的發布內容仍處於已排程的狀態。請重新整理並再次嘗試取消。",
  "publish-modal.cancel-schedule-publish-failure-title": "取消錯誤",
  "publish-modal.cancel-schedule-publish-success-message": "您的「{pageTitle}」排程發布已取消。",
  "publish-modal.cancel-schedule-publish-title": "發布已取消",
  "publish-modal.cancel-schedule-publish-update-message": "您的「{pageTitle}」排程更新已取消。",
  "publish-modal.cancel-schedule-update-title": "更新已取消",
  "publish-modal.cancel-scheduled-button": "排程",
  "publish-modal.cancel-scheduled-publish": "取消已排程的發布",
  "publish-modal.cancel-scheduled-update": "取消已排成的更新",
  "publish-modal.cancel-sp-modal.": "是，取消",
  "publish-modal.cancel-sp-modal.body-for-publish": "如果您取消此排程發布，則不會儲存您目前的任何選取項目。",
  "publish-modal.cancel-sp-modal.body-for-update": "如果您取消此排程更新，則不會儲存您目前的任何選取項目。",
  "publish-modal.cancel-sp-modal.go-back-button": "返回",
  "publish-modal.cancel-sp-modal.title-for-publish": "是否要取消此排程發布？",
  "publish-modal.cancel-sp-modal.title-for-update": "是否要取消此排程更新？",
  "publish-modal.clear-schedule-ok": "確定",
  "publish-modal.clear-schedule-reset": "重設",
  "publish-modal.close-button": "關閉",
  "publish-modal.convert-to-page-button": "轉換為頁面",
  "publish-modal.convert-to-page-info-message.text": "新增版本留言或調整位置和存取權，再轉換和發布。<helpLink>已發布的頁面</helpLink>可以隨時轉換為即時文件。",
  "publish-modal.convert.page-title": "要將此即時文件轉換為已發布的頁面嗎？",
  "publish-modal.default-publish-button": "發佈中...",
  "publish-modal.default-publish-button-tooltip": "選取並確認發布設定",
  "publish-modal.discard-modal.body": "您剛才選取的項目不會儲存。確定要捨棄這些項目並結束嗎？",
  "publish-modal.discard-modal.discard-button": "捨棄並結束",
  "publish-modal.discard-modal.go-back-button": "取消",
  "publish-modal.discard-modal.title": "要捨棄您的選擇嗎？",
  "publish-modal.edit-page-location-icon": "編輯項目位置",
  "publish-modal.flag.accept": "接受",
  "publish-modal.immediately-label": "立即",
  "publish-modal.move-page-label": "位置",
  "publish-modal.notify-others-label": "透過電子郵件通知追蹤者",
  "publish-modal.page": "頁面",
  "publish-modal.page-title": "發布頁面",
  "publish-modal.preview-button": "預覽",
  "publish-modal.public-icon-submit-button-label": "更新公開內容",
  "publish-modal.public-schedule-publish-icon": "已安排在未來發布公開內容",
  "publish-modal.publish-as-blog-label": "發布為",
  "publish-modal.publish-as-blog-select-toggle-icon": "切換為以部落格形式發布",
  "publish-modal.publish-as-blog-tooltip": "以部落格發布會將您的內容移至所選空間的部落格區段",
  "publish-modal.publish-button-disabled-tooltip-company-hub": "目前只有管理員可以發布 - 您的變更已儲存。",
  "publish-modal.publish-button-for-system-space": "發布",
  "publish-modal.publish-button-tooltip-for-system-space": "發布登陸頁面",
  "publish-modal.publish-modal-schedule-publish-button-tooltip": "調整發布排程及其他項目",
  "publish-modal.publish-modal-schedule-update-button-tooltip": "調整更新排程及其他項目",
  "publish-modal.publish-submit-button": "發佈",
  "publish-modal.schedule-close": "關閉",
  "publish-modal.schedule-publish-dialog-toggle-icon": "切換排程發布對話方塊",
  "publish-modal.schedule-publish-icon": "發布排定在未來的時間",
  "publish-modal.schedule-publish-label": "排定發布時間",
  "publish-modal.schedule-publish-time-error": "時間必須是 5 分鐘之後",
  "publish-modal.schedule-publish-tooltip": "將您的發布排程到未來的日期。{lineBreak}通知將在頁面發布時傳送",
  "publish-modal.schedule-update-dialog-toggle-icon": "切換排程更新對話方塊",
  "publish-modal.schedule-update-label": "排程更新",
  "publish-modal.schedule-update-tooltip": "將您的更新排程到未來的日期。{lineBreak}通知將在頁面更新時傳送",
  "publish-modal.schedule.publish.message": "{pageTitle} 將會於 {date} 的 {time} 發布",
  "publish-modal.schedule.publish.title": "發布已列入排程",
  "publish-modal.schedule.update.message": "{pageTitle} 將會於 {date} 的 {time} 更新",
  "publish-modal.schedule.update.title": "更新已列入排程",
  "publish-modal.scheduled-publish-button": "已排程",
  "publish-modal.see-fewer-button": "更少選項",
  "publish-modal.see-more-actions-tooltip-text": "更多動作",
  "publish-modal.see-more-button": "更多選項",
  "publish-modal.select-audience-disabled-text-restrictions-fetch-error": "您現在無法編輯限制。請重新載入，然後再試一次。",
  "publish-modal.select-audience-general-access-label": "一般存取權",
  "publish-modal.select-audience-label": "存取",
  "publish-modal.select-audience-loading-text": "正在載入...",
  "publish-modal.select-audience-option-anyone": "此空間中的任何人",
  "publish-modal.select-audience-option-anyone-can-view": "任何人都可以檢視，但只有某些人可以編輯",
  "publish-modal.select-audience-option-anyone-can-view-and-edit": "任何人都可以檢視和編輯",
  "publish-modal.select-audience-option-anyone-can-view-and-edit-improved": "此空間中的任何人都可以檢視和編輯",
  "publish-modal.select-audience-option-anyone-can-view-and-edit-inherited": "父系頁面上的任何人都可以檢視和編輯",
  "publish-modal.select-audience-option-anyone-can-view-and-edit.external-share": "Confluence 上的任何人都可以檢視和編輯",
  "publish-modal.select-audience-option-anyone-can-view-improved": "此空間中的任何人都可以檢視，但只有某些人可以編輯",
  "publish-modal.select-audience-option-anyone-can-view-inherited": "父系頁面上的任何人都可以檢視，但只有某些人可以編輯",
  "publish-modal.select-audience-option-anyone-can-view.external-share": "Confluence 上的任何人都可以檢視，但某些人可以編輯",
  "publish-modal.select-audience-option-anyone-with-page-access": "父系頁面上任何人",
  "publish-modal.select-audience-option-custom": "自訂存取...",
  "publish-modal.select-audience-option-only-you": "只限您",
  "publish-modal.select-audience-option-specific-can-view-or-edit": "只有特定人員可以檢視或編輯",
  "publish-modal.select-audience-pencil-button-a11y-label": "編輯存取權",
  "publish-modal.select-audience-unknown-error-message": "發生未知的錯誤。",
  "publish-modal.split-button-tooltip": "調整更新設定",
  "publish-modal.split-button-tooltip.object-header": "更新設定",
  "publish-modal.update-as-blog-label": "更新為",
  "publish-modal.update-as-blog-select-toggle-icon": "切換更新為部落格的選擇",
  "publish-modal.update-as-blog-tooltip": "更新為部落格會將您的內容移至所選空間的部落格區段",
  "publish-modal.update-blog-title": "更新部落格",
  "publish-modal.update-button": "更新",
  "publish-modal.update-button-tooltip": "以目前的設定更新",
  "publish-modal.update-button-tooltip-for-system-space": "更新登陸頁面",
  "publish-modal.update-dropdown.adjust-settings": "調整更新設定",
  "publish-modal.update-dropdown.update-without-notify": "在不通知追蹤者的情況下更新",
  "publish-modal.update-page-title": "更新頁面",
  "publish-modal.update-public-content-label": "更新公開內容",
  "publish-modal.update-submit-button": "更新",
  "publish-page-as-blog.dialog.cancel-text": "取消",
  "publish-page-as-blog.dialog.edit-page-description": "將此內容發布為部落格貼文，而非頁面。刪除您不想顯示的任何留言；回應將不會轉換過去。",
  "publish-page-as-blog.dialog.edit-page-header": "發佈為部落格貼文",
  "publish-page-as-blog.dialog.edit-page-submit-text": "發佈為部落格貼文",
  "publish-page-as-blog.dialog.view-page-description": "將此頁面上的內容和留言轉換為新的部落格貼文。回應不會轉換過去。",
  "publish-page-as-blog.dialog.view-page-header": "轉換為部落格貼文",
  "publish-page-as-blog.dialog.view-page-submit-text": "轉換為部落格貼文",
  "publish-page-as-blog.dialog.warning.changed-classification-message": "<b>分類。</b>如果複製，此內容將繼承新目的地空間的預設分類層級。複製之後，根據目的地空間的預設分類層級，內容將被歸類為「{classification}」。",
  "publish-page-as-blog.flags.alternative-error-message-title": "我們無法轉換這個頁面",
  "publish-page-as-blog.flags.archived-page-error-message-description": "當您在使用此頁面時，有其他人封存了此頁面。",
  "publish-page-as-blog.flags.error-message-description": "請重新整理頁面，然後再試一次。",
  "publish-page-as-blog.flags.error-message-title": "我們在發佈部落格時遇到問題",
  "publish-page-as-blog.flags.page-deleted-error-message-description": "當您在使用此內容時，有其他人將其刪除。",
  "publish-page-as-blog.flags.page-permissions-error-message-description": "最近已將防止轉換的限制套用至此項目。",
  "publish-page-as-blog.flags.space-permissions-error-message-description": "您在目的地空間中需要額外的權限，才能轉換頁面。",
  "publish-page-as-blog.flags.space-restrictions-error-message-description": "目的地空間中的限制會讓此項目無法轉換。",
  "publish-page-as-blog.publishedDraft.menu.item": "發佈為部落格...",
  "publish-page-as-blog.unpublishedDraft.menu.item": "發佈為部落格",
  "qr-code-generator.qr.code.label": "QR 代碼",
  "qr-code-generator.qr.component.message": "掃描以在 Confluence 應用程式中檢視此簡報中的內容。",
  "qr-code-generator.scan.to.save.page": "透過 QR 分享",
  "questions.answer-question.button": "回答問題",
  "questions.answer-view.create-comment-error-description": "我們無法儲存留言。請重新整理頁面，然後再試一次。",
  "questions.answer-view.create-comment-error-title": "留言無法儲存",
  "questions.answer-view.delete-answer-error-description": "刪除回答時發生錯誤。請再試一次。",
  "questions.answer-view.delete-answer-error-title": "刪除回答時發生錯誤",
  "questions.answer-view.delete-answer-modal-body": "您確定要刪除此回答嗎？",
  "questions.answer-view.delete-answer-modal-title": "刪除回答",
  "questions.answer-view.empty-answer-error-description": "請在提交前輸入您的回答。",
  "questions.answer-view.empty-answer-error-title": "空白回答",
  "questions.answer-view.update-answer-error-description": "更新回答時發生錯誤。請再試一次。",
  "questions.answer-view.update-answer-error-title": "更新回答時發生錯誤",
  "questions.attachment-confirmation-dialog.cancel-button": "取消",
  "questions.attachment-confirmation-dialog.confirm-button": "移動",
  "questions.comment-view.delete-comment-error-description": "刪除留言時發生錯誤。請再試一次。",
  "questions.comment-view.delete-comment-error-title": "刪除留言時發生錯誤",
  "questions.comment-view.delete-comment-modal-body": "您確定要刪除此留言嗎？此動作無法復原。",
  "questions.comment-view.delete-comment-modal-title": "刪除留言",
  "questions.comment-view.update-comment-error-description": "更新留言時發生錯誤。請再試一次。",
  "questions.comment-view.update-comment-error-title": "更新留言時發生錯誤",
  "questions.content-details.comment": "留言",
  "questions.content-details.delete": "刪除",
  "questions.content-details.edit": "編輯",
  "questions.content-details.vote-count": "{count, plural, other {票}}",
  "questions.content-details.vote-down-label": "投票反對",
  "questions.content-details.vote-up-label": "投票贊成",
  "questions.create-answer.ask-question-button": "提出問題",
  "questions.create-answer.editor-placeholder": "新增您的回答...",
  "questions.create-answer.title": "你的回答",
  "questions.create-topic.cancel-button": "取消",
  "questions.create-topic.form-title": "建立主題",
  "questions.create-topic.submit-button": "建立",
  "questions.delete-confirm-modal.cancel-button": "取消",
  "questions.delete-confirm-modal.confirm-button": "刪除",
  "questions.delete-confirm-modal.modal-close": "關閉強制回應",
  "questions.delete-confirm-modal.modal-title": "刪除問題",
  "questions.delete-confirm-modal.prompt": "您確定要刪除此問題嗎？此動作無法復原。",
  "questions.edit-question-modal.fetch-question-error-description": "我們無法擷取問題。請稍後再試一次。",
  "questions.edit-question-modal.fetch-question-error-title": "無法擷取問題",
  "questions.edit-topic.cancel-button": "取消",
  "questions.edit-topic.form-title": "編輯主題",
  "questions.edit-topic.submit-button": "儲存",
  "questions.editor-field.validation.empty.error": "請先將文字新增至訊息再更新。",
  "questions.empty-list.ask-question-button": "提出問題",
  "questions.empty-list.global.description": "提出問題並結合團隊的知識，然後靜靜等待答案浮現。",
  "questions.empty-list.global.header": "您想要先提出什麼問題？",
  "questions.empty-list.space.description": "發揮團隊或組織中潛藏的知識效應。提出第一個問題，然後與他人分享。",
  "questions.empty-list.space.header": "您已更接近答案",
  "questions.generic-error.description": "該要求傳回錯誤。",
  "questions.generic-error.title": "發生錯誤",
  "questions.question-comment.cancel-button": "取消",
  "questions.question-comment.comment": "留言",
  "questions.question-comment.delete-comment": "刪除",
  "questions.question-comment.edit-comment": "編輯",
  "questions.question-comment.placeholder-comment": "新增留言...",
  "questions.question-comment.submit-button": "儲存",
  "questions.question-item.answer-count": "{count, plural, other {{count} 個回答}}",
  "questions.question-item.vote-count": "{count, plural, other {票}}",
  "questions.question-modal.cancel-button": "取消",
  "questions.question-modal.content-label": "描述",
  "questions.question-modal.content-placeholder": "輸入您的問題...",
  "questions.question-modal.modal-title": "提出問題",
  "questions.question-modal.question-label": "問題",
  "questions.question-modal.question-placeholder": "您想知道什麼？",
  "questions.question-modal.save-button": "儲存",
  "questions.question-modal.save-question-error-description": "我們無法儲存您的問題。請重新整理頁面，然後再試一次。",
  "questions.question-modal.save-question-error-title": "無法儲存問題",
  "questions.question-modal.space-label": "問題空間",
  "questions.question-modal.space-placeholder": "在空間中提問",
  "questions.question-view.answer-count": "{count, plural, other {{count} 個回答}}",
  "questions.question-view.create-answer-error-description": "我們無法儲存回答。請重新整理頁面，然後再試一次。",
  "questions.question-view.create-answer-error-title": "回答無法儲存",
  "questions.question-view.create-comment-error-description": "我們無法儲存留言。請重新整理頁面，然後再試一次。",
  "questions.question-view.create-comment-error-title": "留言無法儲存",
  "questions.question-view.delete-error-description": "我們無法刪除問題。請重新整理頁面，然後再試一次。",
  "questions.question-view.delete-error-title": "問題無法刪除",
  "questions.questions-list.popular-filter-button": "熱門",
  "questions.questions-list.recent-filter-button": "最近",
  "questions.questions-list.search-placeholder": "您想知道什麼？",
  "questions.questions-list.show-more-button": "顯示更多",
  "questions.questions-list.title": "問題",
  "questions.questions-list.unasnwered-filter-button": "未回答",
  "questions.search.error.description": "我們無法完成您的搜尋。請再試一次。",
  "questions.search.error.title": "搜尋錯誤",
  "questions.share-question.button": "分享",
  "questions.title.create.new.question.info": "建立新問題",
  "questions.title.placeholder.label": "搜尋問題",
  "questions.topic-form.description-label": "描述",
  "questions.topic-form.error-message-invalid-chars": "{topic} 包含空格或無效字元 {chars}",
  "questions.topic-form.error-message-missing-title": "主題必須有名稱",
  "questions.topic-form.is-featured-checkbox-label": "設為精選主題",
  "questions.topic-form.is-featured-field-label": "精選",
  "questions.topic-form.logo-label": "選擇圖示",
  "questions.topic-form.name-label": "主題",
  "questions.topic-logo-upload.browse-files": "選擇檔案",
  "questions.topic-logo-upload.error.upload.description": "請重新整理頁面，然後再試一次。",
  "questions.topic-logo-upload.error.upload.title": "無法上傳圖片",
  "questions.topic-logo-upload.file-not-chosen": "未選擇檔案",
  "questions.topic-logo-upload.remove-button": "移除",
  "questions.unwatch-All.button": "取消追蹤全部",
  "questions.unwatch-question.button": "取消追蹤",
  "questions.unwatch-space.button": "取消追蹤空間",
  "questions.watch-all.button": "追蹤全部",
  "questions.watch-question.button": "追蹤",
  "questions.watch-space.button": "追蹤空間",
  "quick-reload.at-least-three-people-commented": "{commentType, select, comment {{numOthers, plural, other {{somebody} 和其他 {numOthers,number} 人 {timeAgo}已留言}}} other {{numOthers, plural, other {{somebody} 和其他 {numOthers,number} 人 {timeAgo}已回覆}}}}",
  "quick-reload.at-least-three-people-commented-on-different-version": "{commentType, select, comment {{numOthers, plural, other {{somebody} 和其他 {numOthers,number} 人 {timeAgo}已在不同版本上留言}}} other {{numOthers, plural, other {{somebody} 和其他 {numOthers,number} 人 {timeAgo}已在不同版本上回覆}}}}",
  "quick-reload.at-least-three-people-published": "{numOthers, plural, other {{somebody} 和其他 {numOthers,number} 個人發佈了此頁面的新版本}}",
  "quick-reload.at-least-three-people-published-blog": "{numOthers, plural, other {{somebody} 和其他 {numOthers,number} 人發佈了此部落格貼文的新版本}}",
  "quick-reload.new-comment": "新留言",
  "quick-reload.new-comments": "{numComments} 則新留言",
  "quick-reload.new-comments-loading": "正在載入留言...",
  "quick-reload.new-comments-loading-blog": "正在載入此部落格貼文的留言...",
  "quick-reload.new-content-loading": "正在載入此內容的新版本...",
  "quick-reload.new-content-loading-blog": "正在載入此部落格貼文的新版本...",
  "quick-reload.new-version-published": "已發佈新版本",
  "quick-reload.reload": "重新載入",
  "quick-reload.somebody-commented": "{commentType, select, comment {{somebody} {timeAgo}已留言} other {{somebody} {timeAgo}已回覆}}",
  "quick-reload.somebody-commented-on-different-version": "{commentType, select, comment {{somebody} 在 {timeAgo}已在不同版本上留言} other {{somebody} 在 {timeAgo}已在不同版本上回覆}}",
  "quick-reload.somebody-published": "{somebody} 發佈了此頁面的新版本",
  "quick-reload.somebody-published-blog": "{somebody} 發佈了此部落格貼文的新版本",
  "quick-reload.two-people-commented": "{somebody} 和 {somebodyElse} 已留言",
  "quick-reload.two-people-commented-on-different-version": "{somebody} 和 {somebodyElse} 已在不同版本上留言",
  "quick-reload.two-people-published": "{somebody} 和 {somebodyElse} 發佈了此頁面的新版本",
  "quick-reload.two-people-published-blog": "{somebody} 和 {somebodyElse} 發佈了此部落格貼文的新版本",
  "quick-reload.view-comment": "查看留言",
  "quick-reload.view-first-comment": "{numComments, plural, other {查看其留言}}",
  "quick-summary.admin.opt-in.dialog.body.text": "<a>透過 Atlassian Intelligence</a> 閱讀 AL 產生的摘要，而非整個頁面，藉此為團隊節省時間。<br></br><br></br>為 Atlassian 管理的使用者啟動 Atlassian Intelligence 功能。",
  "quick-summary.admin.opt-in.dialog.body.text.livedocs": "<a>透過 Atlassian Intelligence</a> 閱讀 AL 生成的摘要，而非整個頁面或即時文件，藉此為團隊節省時間。<br></br><br></br>為「Atlassian 管理」的使用者啟動 Atlassian Intelligence 功能。",
  "quick-summary.content.audio-header": "摘要",
  "quick-summary.create-page-button.button-text": "建立頁面",
  "quick-summary.create-page-button.error-flag-body": "建立摘要頁面時發生錯誤。 請重新載入，然後再試一次。",
  "quick-summary.create-page-button.error-flag-title": "我們無法建立頁面",
  "quick-summary.create-page-button.title-suffix": "「{contentTitle}」的摘要",
  "quick-summary.create-page-modal.generated-from-footer": "來源：",
  "quick-summary.dislike.tooltip": "回應不良",
  "quick-summary.error.aup-violation": "您的內容可能不符合我們的《可接受使用政策》。如有需要，請查看並參閱我們的<a>《可接受使用政策》</a>。",
  "quick-summary.error.aup-violation-comments": "我們目前無法提供留言摘要，因為某些留言可能不符合 Atlassian 的<a>可接受使用政策</a>。",
  "quick-summary.error.aup-violation-page-catchup": "Atlassian Intelligence (AI) 無法提供此內容上的變更摘要，因為某些變更可能不符合我們的<a>《可接受使用政策》</a>。",
  "quick-summary.error.general-error": "Atlassian Intelligence 目前無法提供回應。請參閱<a>我們的支援說明文件</a>。",
  "quick-summary.error.not-enough-content": "這裡沒有足夠的內容可以提供摘要。請新增更多內容並再試一次。",
  "quick-summary.error.rate-limit": "我們發現 Atlassian Intelligence 使用過量。請稍後再試一次。請參閱<a>我們的支援說明文件</a>。",
  "quick-summary.error.too-much-content": "Atlassian Intelligence 目前無法為您產生摘要，因為需要摘要的內容太多。",
  "quick-summary.error.too-much-content-comments": "有太多需要 Atlassian Intelligence 摘要。請在留言較少的內容上再試一次。",
  "quick-summary.error.too-much-content-page-catchup": "有過多變更需要 Atlassian Intelligence (AI) 摘要。請在變更較少的內容上再試一次。",
  "quick-summary.feature-spotlight-one.text": "內容可能比較長。節省時間，閱讀 Atlassian Intelligence 的簡短摘要。",
  "quick-summary.feedback.can-contact.label": "Atlassian 可以連絡我來了解此意見反應。請參閱我們的{privacyPolicyLink}。",
  "quick-summary.feedback.flag.description": "感謝您撥空傳送此意見反應。",
  "quick-summary.feedback.flag.title": "謝謝！",
  "quick-summary.feedback.improve-atlassian": "我想要加入 {researchGroupLink}，協助改善 Atlassian 產品。",
  "quick-summary.feedback.privacy-policy.link": "隱私政策",
  "quick-summary.feedback.research-group.link": "Atlassian 研究團隊",
  "quick-summary.feedback.summary.placeholder": "Atlassian Intelligence 有哪些方面表現良好？有什麼可以改善的嗎？",
  "quick-summary.feedback.summary.title": "告訴我們您的體驗",
  "quick-summary.feedback.title": "協助我們改善 Atlassian Intelligence",
  "quick-summary.follow-up.initial-human-prompt": "摘要此 {link}",
  "quick-summary.label.text": "快速摘要",
  "quick-summary.like.tooltip": "回應良好",
  "quick-summary.opt-in.dialog.body.text": "<a>透過 Atlassian Intelligence</a> 閱讀 AL 產生的摘要，而非整個頁面或部落格，藉此節省時間。<br></br><br></br>想嘗試 Atlassian Intelligence 嗎？您的管理員可以從 Atlassian 管理啟動 AI 功能。",
  "quick-summary.opt-in.dialog.body.text.livedocs": "<a>透過 Atlassian Intelligence</a> 閱讀 AL 生成的摘要，而非整個頁面、即時文件或部落格，藉此節省時間。<br></br><br></br>想嘗試 Atlassian Intelligence 嗎？您的管理員可以從「Atlassian 管理」啟動 AI 功能。",
  "quick-summary.opt-in.dialog.header.text": "事半功倍",
  "quick-summary.quick-summary-footer.footer-title": "由 Atlassian Intelligence 總結",
  "quick-summary.quick-summary-footer.footer-title-error": "Atlassian Intelligence",
  "quick-summary.quick-summary-footer.learn-more-link": "深入了解",
  "quick-summary.quick-summary-footer.logo-alt-text": "Atlassian Intelligence 標誌",
  "quick-summary.quick-summary-footer.more-info": "更多資訊",
  "quick-summary.quick-summary-footer.quality-descriptor": "Atlassian Intelligence 所產生的資訊品質、準確性、可靠性可能會變動。",
  "quick-summary.quick-summary-footer.what-can-ai-do-link": "Atlassian Intelligence 還有哪些功能？",
  "quick-summary.quick-summary-header.copied-tooltip": "已複製！",
  "quick-summary.quick-summary-header.copy-tooltip": "複製摘要",
  "quick-summary.smarts-summary-header.refresh-tooltip": "產生新摘要",
  "quick-summary.spotlight.close.button.text": "關閉",
  "quick-summary.spotlight.summarize.button.text": "摘要",
  "quick-summary.summary-footer.beta-lozenge": "測試版",
  "quick-summary.tooltip.text": "摘要",
  "quick-summary.upsell.body.text.admin": "升級至 Premium 方案時，使用 Atlassian Intelligence 功能，每週省下超過 45 分鐘。",
  "quick-summary.upsell.body.text.admin.livedocs": "使用 Atlassian Intelligence 節省時間並為頁面、即時文件或部落格產生摘要。請升級至 Premium 試用看看。",
  "quick-summary.upsell.body.text.user": "使用 Premium 方案後，您可以透過 Atlassian Intelligence 功能，每週省下超過 45 分鐘。",
  "quick-summary.upsell.body.text.user.livedocs": "您可以透過 Premium 方案，使用 Atlassian Intelligence 建立頁面、即時文件和部落格的摘要，藉此節省時間。",
  "quick-summary.upsell.header.text": "讓您的組織事半功倍",
  "quick-summary.upsell.learn-more.link.text.admin": "深入了解 Atlassian Intelligence",
  "quick-summary.upsell.learn-more.link.text.user": "進一步了解 Atlassian Intelligence",
  "reactions.error.message.generic": "如果問題持續發生，請連絡{atlassianSupportLink}或您的空間管理員，讓他們對此問題進行疑難排解。",
  "reactions.error.title.generic": "我們無法更新該表情符號",
  "reactions.mutation.add.error": "無法新增回應",
  "reactions.mutation.delete.error": "無法刪除回應",
  "reactions.mutation.error.action": "再試一次",
  "reactions.no.page.reactions": "成為第一個新增表情符號的人",
  "reactions.view-page.byline.reactions.add.new": "新增",
  "reactions.view-page.byline.reactions.add.reaction": "新增回應",
  "reactions.view.error": "無法載入回應",
  "reactions.view.error.tooltip": "請重新整理以再試一次",
  "read-time.by-line.abbreviated-estimated-read-time": "{readTime} 分鐘",
  "read-time.by-line.estimated-read-time": "{readTime} 分鐘閱讀時間",
  "read-time.by-line.icon-label": "閱讀時間",
  "read-time.read-time-popup": "閱讀時間細分",
  "read-time.read-time-popup-expand-tooltip-description": "Loom 影片和展開內容不包含在讀取時間估計中",
  "read-time.read-time-popup-expands": "展開",
  "read-time.read-time-popup-loom-videos": "Looms",
  "read-time.read-time-popup-page-content": "頁面內容",
  "read-time.read-time-popup-read-time-disclaimer": "不包含在閱讀時間中",
  "read-time.tooltip-description": "預估的讀取時間",
  "read-time.word-count": "{wordCount, plural, other {{wordCount} 個字}}",
  "recent-pages.actions.edit.draft.button.label": "編輯此草稿",
  "recent-pages.actions.edit.page.button.label": "編輯「{pageTitle}」",
  "recent-pages.actions.star.button.page.label": "為此內容標上星號",
  "recent-pages.content.bucket.last.month": "在上個月",
  "recent-pages.content.bucket.last.week": "過去一週內",
  "recent-pages.content.bucket.more.month": "一個多月前",
  "recent-pages.content.bucket.today": "今天",
  "recent-pages.content.bucket.yesterday": "昨天",
  "recent-pages.error.state.message": "我們目前無法顯示您最近使用的項目。請重新整理或稍後再試一次。",
  "recent-pages.error.state.title": "無法載入您最近的項目",
  "recent-pages.filter.all": "全部",
  "recent-pages.filter.created.by.me": "由我建立",
  "recent-pages.filter.drafts": "草稿",
  "recent-pages.filter.owned.by.me": "由我所負責",
  "recent-pages.filter.starred": "已標上星號",
  "recent-pages.filter.visited": "已造訪",
  "recent-pages.filter.worked.on": "已處理",
  "recent-pages.null.state.actions": "這將在您建立、編輯和探索時填滿。",
  "recent-pages.null.state.create": "建立頁面",
  "recent-pages.null.state.create.live.page": "建立即時文件",
  "recent-pages.null.state.no.content": "沒有最近使用的頁面或部落格",
  "recent-pages.null.state.no.content.livedocs": "沒有最近的頁面、即時文件或部落格",
  "recent-pages.screenReader.textFilter.resultsUpdated": "結果已於下方更新",
  "recent-pages.search.clear": "清除搜尋欄位",
  "recent-pages.textFilter.label": "依標題篩選",
  "recent-pages.textFilter.noResults.created.by.me": "我們無法從您已建立的內容中找到相符項目。",
  "recent-pages.textFilter.noResultsDrafts": "我們找不到任何相符的草稿。",
  "recent-pages.textFilter.noResultsRecent": "我們無法在您造訪的前 {count} 個項目中找到相符項目。",
  "recent-pages.textFilter.noResultsStarred": "我們無法從已標上星號的項目中找到相符項目。",
  "recent-pages.textFilter.noResultsWorkedOn": "我們無法從您已使用的內容中找到相符項目。",
  "recent-pages.textFilter.recentSearchPrompt": "<a>搜尋所有內容</a>",
  "recent-pages.textFilter.screenReaderDescription": "當您輸入時，內容將在下方篩選。",
  "recent-pages.untitled-page": "未命名",
  "recent-pages.view.all": "檢視全部",
  "recent-pages.view.all.drafts.label": "檢視所有草稿",
  "recent-pages.view.all.recent.content.label": "檢視所有造訪過的內容",
  "recent-pages.view.all.starred.content.label": "檢視所有已標上星號的內容",
  "recent-pages.view.all.worked.on.label": "檢視您已處理的所有內容",
  "recent-pages.view.created.by.me.content.label": "檢視您建立的所有內容",
  "redactions.redaction-dialog.body-header": "已找到敏感資料，並從此內容中移除。",
  "redactions.redaction-dialog.body-header-link-text": "編輯的運作方式",
  "redactions.redaction-dialog.date-time": "日期/時間已編輯",
  "redactions.redaction-dialog.empty-table-text": "沒有可顯示的資料",
  "redactions.redaction-dialog.icon-button-label": "更多動作",
  "redactions.redaction-dialog.icon-copy-menu-item": "複製編輯 ID",
  "redactions.redaction-dialog.icon-copy-text": "複製",
  "redactions.redaction-dialog.reason-header": "原因",
  "redactions.redaction-dialog.redaction-creator": "編輯者",
  "redactions.redactions-dialog.close-button": "關閉",
  "redactions.redactions-dialog.title": "編輯",
  "redactions.redactions-tour.dismiss": "關閉",
  "redactions.redactions-tour.go-to-redactions": "前往此選單中的「編輯」，以詳細了解此頁面上的編輯。",
  "redactions.redactions-tour.next": "下一步",
  "redactions.redactions-tour.ok": "確定",
  "redactions.redactions-tour.read-more": "深入了解",
  "redactions.redactions-tour.solid-bar-indicates": "實心列表示您的組織已偵測和刪除敏感資料。",
  "redactions.redactions-tour.steps": "{step}/{steps}",
  "resolved-inline-comments-dialog.a11y.comment.wrapper": "留言者為 {username}",
  "resolved-inline-comments-dialog.close": "關閉",
  "resolved-inline-comments-dialog.error": "發生錯誤。請稍後再試一次。",
  "resolved-inline-comments-dialog.inline.message": "只有具有編輯權限的人員能看見編輯時解決的內嵌留言",
  "resolved-inline-comments-dialog.no-comments-for-content": "沒有已解決的留言。",
  "resolved-inline-comments-dialog.reattach.redesign": "復原留言",
  "resolved-inline-comments-dialog.reopen": "重新開啟留言",
  "resolved-inline-comments-dialog.reply": "{repliesCount, plural, other {{repliesCount,number} 個回覆}}",
  "resolved-inline-comments-dialog.resolved": "已解決",
  "resolved-inline-comments-dialog.resolved-menu-newest": "最新",
  "resolved-inline-comments-dialog.resolved-menu-oldest": "最舊",
  "resolved-inline-comments-dialog.resolved.by": "解決者為 {resolvedUser}",
  "resolved-inline-comments-dialog.resolved.by.dangling.redesign": "已解決，因為 {resolvedUser} 已刪除醒目顯示的文字",
  "resolved-inline-comments-dialog.sortByLabel": "排序依據",
  "resolved-inline-comments-dialog.title": "已解決的留言",
  "restrictions.add-users-and-groups": "新增",
  "restrictions.button.edit-restrictions-apply.tooltip": "編輯動作已受限制",
  "restrictions.button.experiment-restrictions.tooltip": "升級以限制內容存取權",
  "restrictions.button.no-restrictions.tooltip": "無限制",
  "restrictions.button.restrictions-apply.tooltip": "有限制條件",
  "restrictions.button.smart-link-embed-restrictions.tooltip": "無法為智慧連結設定其他限制",
  "restrictions.confirm-discard-dialog.body": "您有未儲存的變更，如果您未選取「{apply}」就關閉「限制」視窗，這些變更將會遺失。您要捨棄這些變更嗎？",
  "restrictions.confirm-discard-dialog.body.apply": "套用",
  "restrictions.confirm-discard-dialog.button.discard": "捨棄",
  "restrictions.confirm-discard-dialog.button.keep-editing": "繼續編輯",
  "restrictions.confirm-discard-dialog.title": "未儲存的變更",
  "restrictions.dialog-header.learn-more-link-2": "深入了解限制",
  "restrictions.dialog.apply-action-fail-save.text": "提交限制時發生錯誤。請稍後再試一次。",
  "restrictions.dialog.apply-action-fail-save.title": "錯誤",
  "restrictions.dialog.atleast-one-editor-needed-if-view-and-editing-restricted": "若要限制查看和編輯權限，則您必須將編輯權限至少授予一個人或群組",
  "restrictions.dialog.blogpost.share-succeeded-flag.description": "您新增的人員已收到有關此部落格貼文的通知。",
  "restrictions.dialog.blogpost.share-succeeded-flag.title": "已分享部落格貼文",
  "restrictions.dialog.description.no-restrictions-current": "任何人都可以檢視和編輯",
  "restrictions.dialog.description.no-restrictions-inherited": "父系上的任何人都可以檢視和編輯",
  "restrictions.dialog.description.no-restrictions.verbose-text": "此空間中的任何人都可以編輯",
  "restrictions.dialog.description.restrict-edit-current": "任何人都可以檢視，但只有某些人可以編輯",
  "restrictions.dialog.description.restrict-edit-inherited": "父系上的任何人都可以檢視，但只有某些人可以編輯",
  "restrictions.dialog.description.restrict-edit.verbose": "此空間中的任何人都可以檢視，但只有某些人可以編輯",
  "restrictions.dialog.description.restrict-view-inherited": "只有特定人員可以檢視或編輯",
  "restrictions.dialog.description.restrict-view.verbose": "只有特定人員可以檢視或編輯",
  "restrictions.dialog.dropdown.restrict-editing.inherited": "父系上的任何人都可以檢視，但只有某些人可以編輯",
  "restrictions.dialog.dropdown.restrict-editing.verbose": "此空間中的任何人都可以檢視，但只有某些人可以編輯",
  "restrictions.dialog.embed.no-restrictions-support-message.body": "任何可在 Confluence 中存取此項目的人都可以檢視，但連結上的權限可能會影響誰可以與內容互動。<SACLink>內容樹狀結構中的智慧連結權限如何運作？</SACLink>",
  "restrictions.dialog.embed.no-restrictions-support-message.title": "無法為智慧連結設定其他限制",
  "restrictions.dialog.failed.label": "失敗",
  "restrictions.dialog.footer.apply-action": "套用",
  "restrictions.dialog.footer.cancel-action": "取消",
  "restrictions.dialog.footer.continue-action": "繼續",
  "restrictions.dialog.footer.done-action": "完成",
  "restrictions.dialog.footer.give-feedback": "不符合您的預期嗎？<feedbackButton>傳送意見反應</feedbackButton>",
  "restrictions.dialog.group.everyone": "此空間中的其他人",
  "restrictions.dialog.group.inherited": "父系上的其他人",
  "restrictions.dialog.group.inherited.restrictions": "父系上的其他人",
  "restrictions.dialog.header.inspect.permissions.title": "檢查權限",
  "restrictions.dialog.header.inspect.permissions.tooltip": "了解系統是在什麼地方拒絕授予使用者對此內容的權限。",
  "restrictions.dialog.header.inspect.permissions.upsell.body": "了解系統是在父系項目還是在空間拒絕使用者對此內容的存取。如需診斷及修正權限議題的工具，請升級至 Premium 方案。",
  "restrictions.dialog.header.inspect.permissions.upsell.title": "升級以檢查權限",
  "restrictions.dialog.header.restrictions.folders": "此資料夾的檢視限制會套用至其內容。",
  "restrictions.dialog.header.restrictions.more": "更多動作",
  "restrictions.dialog.header.restrictions.title": "限制",
  "restrictions.dialog.inherited-view-restrictions-trigger-part1": "具有 {inherritedViewRestrictions}。",
  "restrictions.dialog.inherited-view-restrictions-trigger-part2": "繼承的檢視限制",
  "restrictions.dialog.inherited-view-restrictions.description": "只有可以檢視的人才能看到您的內容。以下是可以檢視每個層級的人員列表。",
  "restrictions.dialog.link.share-succeeded-flag.description": "您新增的人員已收到有關此連結的通知。",
  "restrictions.dialog.link.share-succeeded-flag.title": "已分享連結",
  "restrictions.dialog.link.text": "限制",
  "restrictions.dialog.loading.fail.text": "我們無法載入部分或全部的限制資料，這表示可能無法正確反映內容的存取權。請嘗試立即重新整理。",
  "restrictions.dialog.loading.fail.title": "限制無法載入",
  "restrictions.dialog.need-atleast-one-user-or-group-in-restrictions": "您必須將存取權賦予至少一個人。如果您嘗試將存取權賦予每個人，請從頂端選單中選擇 {noRestrictions}。",
  "restrictions.dialog.no-permission-to-change": "您無法變更這些限制。這可能是因為內容的編輯限制，或是此空間的權限設定所導致。",
  "restrictions.dialog.no-restrictions": "無限制",
  "restrictions.dialog.page.share-succeeded-flag.description": "已通知新加入的人。",
  "restrictions.dialog.page.share-succeeded-flag.title": "已分享內容",
  "restrictions.dialog.parent-page-trigger": "<parentLink>此父系</parentLink>限制為特定人員。",
  "restrictions.dialog.permission-select.edit": "可以編輯",
  "restrictions.dialog.permission-select.view-only": "僅限檢視",
  "restrictions.dialog.public-link.unavailable.lozenge": "無法取得",
  "restrictions.dialog.public-link.unavailable.lozenge.tooltip": "若要限制可以檢視此內容的人員，請停用公開連結。",
  "restrictions.dialog.remove-item": "移除",
  "restrictions.dialog.restriction-select-aria-label": "選取內容限制",
  "restrictions.dialog.select-permission.no-access-text": "無存取權",
  "restrictions.dialog.share-error-flag.title": "我們無法分享此連結",
  "restrictions.dialog.success.label": "成功",
  "restrictions.dialog.table-announcer.several-user-added": "{amount, plural, other {已將 {amount,number} 位使用者新增至表格}}",
  "restrictions.dialog.table-announcer.several-user-removed": "{amount, plural, other {已將 {amount,number} 使用者從表格中移除}}",
  "restrictions.dialog.table-announcer.user-added": "{name} 已新增至表格",
  "restrictions.dialog.table-announcer.user-removed": "{name} 已從表格中移除",
  "restrictions.dialog.table.header.actions": "動作",
  "restrictions.dialog.table.header.permission": "權限",
  "restrictions.dialog.table.header.users": "使用者/群組",
  "restrictions.dialog.whiteboard.share-succeeded-flag.description": "您新增的人員已收到有關此白板的通知。",
  "restrictions.dialog.whiteboard.share-succeeded-flag.title": "已分享白板",
  "restrictions.dialog.word.you": "您",
  "restrictions.drilldown-button.content-access": "檢視父系內容上的人員",
  "restrictions.drilldown-button.space-access": "檢視這個空間中的人員",
  "restrictions.external-footer.external-people.popup-closed": "外部人員可以存取。<popupLink>檢視詳細資料</popupLink>",
  "restrictions.external-footer.external-people.popup-open": "外部人員可以存取。<popupLink>隱藏詳細資料</popupLink>",
  "restrictions.external-footer.public-link": "公開連結已啟用。<turnOffButtonLink>停用</turnOffButtonLink>",
  "restrictions.external-footer.public-link.no-cta": "公開連結已啟用。",
  "restrictions.external-footer.public-link.with-restrictions": "公開連結已啟用並且會覆寫限制。<turnOffButtonLink>停用</turnOffButtonLink>",
  "restrictions.external-footer.public-link.with-restrictions.no-cta": "公開連結已啟用並且會覆寫限制。",
  "restrictions.no-restrictions-card.public-link-content-type.live-doc": "這個即時文件",
  "restrictions.no-restrictions-card.public-link-content-type.page": "此頁面",
  "restrictions.no-restrictions-card.public-link-description": "使用 {link} 按鈕與網際網路上的任何人分享此 {contentType} 的安全唯讀版本。",
  "restrictions.no-restrictions-card.public-link-description.whiteboard": "使用 {link} 按鈕，與網際網路上的任何人分享此白板僅供檢視的安全版本。",
  "restrictions.no-restrictions-card.public-link-learn-more": "深入了解",
  "restrictions.no-restrictions-card.public-link-share-link": "分享",
  "restrictions.no-restrictions-card.public-link-title": "公開分享此內容",
  "restrictions.no-restrictions-card.public-link-title.whiteboard": "公開分享此白板",
  "restrictions.no.ancestor.view.permission.warning.message": "必須先擁有<button>父系</button>頁面的存取權。",
  "restrictions.no.space.edit.permission.warning.message": "沒有空間的編輯權限。請連絡 {spaceAdmin}。",
  "restrictions.no.space.view.permission.warning.message": "必須先擁有空間的存取權。請連絡 {spaceAdmin}.",
  "restrictions.placeholder.text.person.or.group": "輸入人員或群組",
  "restrictions.public-links.learn.more.link.label": "深入了解",
  "restrictions.public-links.warning.label": "這將中斷子系頁面的任何作用中公開連結。{learnMoreLink}",
  "restrictions.space.admin.button": "空間管理員",
  "return-to-mobile.nav.switch.to.mobile.action": "切換至 Confluence Mobile",
  "return-to-mobile.nav.switch.to.mobile.text": "您正使用行動支援裝置檢視桌面版 Confluence。",
  "rovo-video-modal.confluence-modal.title": "開始使用 Rovo！",
  "save-indicator.all.changes.saved": "已儲存",
  "save-indicator.all.changes.saved.tooltip": "每個變更都會儲存，最後一次變更時間為 {time}",
  "save-indicator.error.tooltip": "我們無法儲存最新的變更。最後一次的儲存時間是 {time}",
  "save-indicator.save-indicator-live-pages.saved": "已儲存",
  "save-indicator.save-indicator-live-pages.saving": "正在儲存",
  "save-indicator.saving": "正在儲存",
  "save-indicator.tooltip.time.aMomentAgo": "剛剛",
  "save-indicator.tooltip.time.lessThanAMinuteAgo": "一分鐘內",
  "save-indicator.tooltip.time.oneHourAgo": "大約一小時前",
  "save-indicator.tooltip.time.oneMinuteAgo": "一分鐘前",
  "save-indicator.tooltip.time.xHoursAgo": "大約 {time} 小時前",
  "save-indicator.tooltip.time.xMinutesAgo": "{time} 分鐘前",
  "save-indicator.tooltip.time.yesterday": "昨天 {time}",
  "selection-table.bulk-actions-header.selection-count-total": "總共有 {count} 個",
  "selection-table.clickable-column-header.asc": "遞增排序",
  "selection-table.clickable-column-header.desc": "遞減排序",
  "selection-table.clickable-column-header.sortable": "可排序",
  "selection-table.data-error.title": "我們無法載入某些表格",
  "selection-table.error-messages.empty-table-error-icon": "錯誤圖示",
  "selection-table.pagination.next.button.label": "下一步",
  "selection-table.pagination.page-number.button.label": "頁碼",
  "selection-table.pagination.page-results-count.label": "結果 {pageStartingItem}-{pageEndingItem}",
  "selection-table.pagination.page-size-selector.label": "每頁的結果：",
  "selection-table.pagination.previous.button.label": "上一頁",
  "selection-table.quick-actions-menu.aria-label": "快速動作",
  "settings-settings.pdf-export.critical-failure.description": "我們無法擷取資料。請重新整理 Confluence。",
  "share-and-restrict-dialog.button.restriction.invite.action.text": "邀請",
  "share-and-restrict-dialog.button.restriction.message.invite.text": "{userCount, plural, =0 {要邀請 <b>{userEmail}</b> 加入 Confluence 嗎？如果不要，我們只會在您選取「分享」時傳送通知。} other {要邀請 <b>{userEmail} 和其他 {userCount,number} 人</b>加入 Confluence 嗎？如果不要，我們只會在您選取「分享」時傳送通知。}}",
  "share-and-restrict-dialog.close-confirmation.body": "您有未儲存的變更，如果您關閉「共用」視窗，這些變更將會遺失。您要捨棄這些變更嗎？",
  "share-and-restrict-dialog.close-confirmation.cancel": "取消",
  "share-and-restrict-dialog.close-confirmation.discard": "捨棄",
  "share-and-restrict-dialog.close-confirmation.heading": "未儲存的變更",
  "share-and-restrict-dialog.controlled-share-button.share": "分享",
  "share-and-restrict-dialog.controlled-share-button.tooltip.draft": "開放 - 空間中有連結的任何人都可以存取",
  "share-and-restrict-dialog.controlled-share-button.tooltip.error": "存取層次無法載入",
  "share-and-restrict-dialog.controlled-share-button.tooltip.inherited": "受到父系限制 - 父系項目上的任何人皆可存取",
  "share-and-restrict-dialog.controlled-share-button.tooltip.open": "開放 - 此空間中的任何人皆可存取",
  "share-and-restrict-dialog.controlled-share-button.tooltip.openEdit": "開放 - 空間中的任何人都可以編輯",
  "share-and-restrict-dialog.controlled-share-button.tooltip.openView": "開放 - 空間中的任何人都可以檢視",
  "share-and-restrict-dialog.controlled-share-button.tooltip.public": "公開 - 擁有連結的任何人皆可存取",
  "share-and-restrict-dialog.controlled-share-button.tooltip.restricted": "受限制 - 只有特定人員可以存取",
  "share-and-restrict-dialog.cta-notify-message-footer.add-message": "新增訊息",
  "share-and-restrict-dialog.cta-notify-message-footer.cancel-cta": "取消",
  "share-and-restrict-dialog.cta-notify-message-footer.char-limit-error-message": "訊息必須少於 500 個字元",
  "share-and-restrict-dialog.cta-notify-message-footer.done-label": "完成",
  "share-and-restrict-dialog.cta-notify-message-footer.learn-more-label": "深入了解",
  "share-and-restrict-dialog.cta-notify-message-footer.notification-spot-light-description": "選擇是要通知使用者他們已有存取權，還是直接授予權限，不另行通知。",
  "share-and-restrict-dialog.cta-notify-message-footer.notification-spot-light-heading": "控管通知",
  "share-and-restrict-dialog.cta-notify-message-footer.notify-newly-added-user-label": "通知新增加的人員",
  "share-and-restrict-dialog.cta-notify-message-footer.notify-recipients-label": "通知收件者",
  "share-and-restrict-dialog.cta-notify-message-footer.notify-selected-users-label": "通知所選使用者",
  "share-and-restrict-dialog.cta-notify-message-footer.optional-message": "選填訊息",
  "share-and-restrict-dialog.cta-notify-message-footer.save-cta": "儲存",
  "share-and-restrict-dialog.cta-notify-message-footer.share-cta": "分享",
  "share-and-restrict-dialog.default.title": "未命名",
  "share-and-restrict-dialog.edit-public-link-permissions-spotlight-okay": "確定",
  "share-and-restrict-dialog.edit-public-link-permissions-spotlight-text": "將編輯權限授予在白板中沒有 Confluence 帳戶的使用者。",
  "share-and-restrict-dialog.edit-public-whiteboard-spotlight-okay": "確定",
  "share-and-restrict-dialog.edit-public-whiteboard-spotlight-text": "允許沒有 Confluence 帳戶的團隊成員檢視或編輯您的白板。",
  "share-and-restrict-dialog.facepileRow.collapse": "摺疊特定存取權詳細資料",
  "share-and-restrict-dialog.facepileRow.expand": "檢視特定存取權詳細資料",
  "share-and-restrict-dialog.facepileRow.group-name": "{count, plural, other {{count} 個群組}}",
  "share-and-restrict-dialog.facepileRow.icon.collapse": "摺疊",
  "share-and-restrict-dialog.facepileRow.icon.expand": "檢視特定存取權",
  "share-and-restrict-dialog.facepileRow.open-can-view.multiple-users": "{count, plural, other {<b>{name1}、{name2}</b> 和其他 <b>{count} 人</b>可以編輯}}",
  "share-and-restrict-dialog.facepileRow.open-can-view.two-users": "<b>{name1}</b> 和 <b>{name2}</b> 可以編輯",
  "share-and-restrict-dialog.facepileRow.open-can-view.you-and-multiple-others": "{count, plural, other {<b>您、{name}</b> 和其他 <b>{count} 人</b>可以編輯}}",
  "share-and-restrict-dialog.facepileRow.open-can-view.you-and-one-other": "<b>您</b>和 <b>{name}</b> 可以編輯",
  "share-and-restrict-dialog.facepileRow.restricted.deleted-groups": "此群組已被刪除",
  "share-and-restrict-dialog.facepileRow.restricted.multiple-users": "{count, plural, other {<b>{name1}、{name2}</b> 和其他 <b>{count} 人</b>}}",
  "share-and-restrict-dialog.facepileRow.restricted.two-users": "<b>{name1}</b> 和 <b>{name2}</b>",
  "share-and-restrict-dialog.facepileRow.restricted.you-and-multiple-others": "{count, plural, other {<b>您、{name}</b> 和其他 <b>{count} 人</b>}}",
  "share-and-restrict-dialog.facepileRow.restricted.you-and-one-other": "<b>您</b> 和 <b>{name}</b>",
  "share-and-restrict-dialog.feedback-collector.title": "提供意見反應",
  "share-and-restrict-dialog.feedback-collector.title-details": "整體而言，您對於存取權的提供和管理功能是否感到滿意？",
  "share-and-restrict-dialog.flag.action": "向我顯示",
  "share-and-restrict-dialog.flag.heading": "鎖定圖示已移動",
  "share-and-restrict-dialog.flag.message": "鎖定圖示 (您管理內容存取權的位置) 現在位於「分享」按鈕中。",
  "share-and-restrict-dialog.flags.title.access-updated": "存取權已更新",
  "share-and-restrict-dialog.flags.title.already-has-access": "新增的使用者已經有存取權",
  "share-and-restrict-dialog.flags.title.content-shared": "已分享內容",
  "share-and-restrict-dialog.flags.title.notification-sent": "已傳送通知",
  "share-and-restrict-dialog.footer.copy-link": "複製連結",
  "share-and-restrict-dialog.footer.eap-lozenge": "搶先體驗",
  "share-and-restrict-dialog.footer.info-popup-text": "新的「分享」服務目前提供搶先體驗。您的意見反應十分重要。歡迎提供您的想法！",
  "share-and-restrict-dialog.footer.public-link": "公開連結",
  "share-and-restrict-dialog.footer.public-link-is-on": "公開連結已開啟",
  "share-and-restrict-dialog.footer.slack": "Slack",
  "share-and-restrict-dialog.general-access.anyone-in-this-space": "<a>此空間</a>中的任何人",
  "share-and-restrict-dialog.general-access.anyone-in-this-space-can-view-and-edit": "此<a>空間</a>中的任何人都可以檢視和編輯",
  "share-and-restrict-dialog.general-access.anyone-in-this-space-can-view-not-edit": "此<a>空間</a>中的任何人都可以檢視，但只有某些人可以編輯",
  "share-and-restrict-dialog.general-access.anyone-on-parent": "<parentLink>父系</parentLink>上的任何人",
  "share-and-restrict-dialog.general-access.anyone-on-parent-can-view-and-edit": "<parentLink>父系</parentLink>上的任何人都可以檢視和編輯",
  "share-and-restrict-dialog.general-access.anyone-on-parent-can-view-not-edit": "<parentLink>父系</parentLink>上的任何人都可以檢視，但只有某些人可以編輯",
  "share-and-restrict-dialog.general-access.draft.anyone-in-this-space": "<a>此空間</a>中 (具有連結) 的任何人",
  "share-and-restrict-dialog.general-access.draft.anyone-in-this-space-can-view-and-edit": "<a>此空間</a>中 (具有連結) 的任何人都可以檢視和編輯",
  "share-and-restrict-dialog.general-access.draft.anyone-in-this-space-can-view-not-edit": "此<a>空間</a>中 (具有連結) 的任何人都可以檢視，但只有某些人可以編輯",
  "share-and-restrict-dialog.general-access.draft.anyone-on-parent": "在<parentLink>父系</parentLink>上 (具有連結) 的任何人",
  "share-and-restrict-dialog.general-access.draft.anyone-on-parent-can-view-and-edit": "<parentLink>父系</parentLink>上 (具有連結) 的任何人都可以檢視和編輯",
  "share-and-restrict-dialog.general-access.draft.anyone-on-parent-can-view-not-edit": "<parentLink>父系</parentLink>上 (具有連結) 的任何人都可以檢視，但只有某些人可以編輯",
  "share-and-restrict-dialog.general-access.draft.only-specific-people": "只有 (具有連結) 的特定人員可以檢視或編輯",
  "share-and-restrict-dialog.general-access.dropdown-icon.label": "變更一般存取等級",
  "share-and-restrict-dialog.general-access.flags.title.failed-to-load-body": "我們無法載入一些資料，因此存取資訊可能不正確。請嘗試立即重新整理。",
  "share-and-restrict-dialog.general-access.flags.title.failed-to-load-title": "無法載入存取資訊",
  "share-and-restrict-dialog.general-access.flags.title.mutation-error-body": "我們在完成分享動作時遇到問題。請稍候片刻，然後再試一次。",
  "share-and-restrict-dialog.general-access.flags.title.mutation-error-title": "存取變更失敗",
  "share-and-restrict-dialog.general-access.flags.title.notification-error-body": "我們在通知您分享的使用者時遇到了問題。請嘗試複製連結。",
  "share-and-restrict-dialog.general-access.flags.title.notification-error-title": "無法傳送通知",
  "share-and-restrict-dialog.general-access.level.open": "開放",
  "share-and-restrict-dialog.general-access.level.restricted": "受限制",
  "share-and-restrict-dialog.general-access.level.restricted-by-parent": "受父系限制",
  "share-and-restrict-dialog.general-access.level.restricted-by-parent-tooltip": "存取權限受父系項目限制，無法開啟空間。",
  "share-and-restrict-dialog.general-access.level.restricted-by-parent-tooltip-icon-label": "「開放」已停用 - 更多資訊",
  "share-and-restrict-dialog.general-access.lock-icon.label": "受限制",
  "share-and-restrict-dialog.general-access.only-specific-people": "只有特定人員可以檢視或編輯",
  "share-and-restrict-dialog.general-access.permission.can-edit": "可以編輯",
  "share-and-restrict-dialog.general-access.permission.can-view": "可以檢視",
  "share-and-restrict-dialog.general-access.title": "一般存取權",
  "share-and-restrict-dialog.general-access.unlock-icon.label": "開啟",
  "share-and-restrict-dialog.give-feedback-icon": "提供意見反應",
  "share-and-restrict-dialog.group-notify-warning.body": "群組通常包含很多人。通知所有人可能會稍微有點干擾他人。您確定要通知這些群組中的每個人嗎？",
  "share-and-restrict-dialog.group-notify-warning.do-not-notify": "分享但不通知",
  "share-and-restrict-dialog.group-notify-warning.do-notify": "通知群組",
  "share-and-restrict-dialog.group-notify-warning.heading": "要通知群組中的每個人嗎？",
  "share-and-restrict-dialog.header.back": "返回",
  "share-and-restrict-dialog.header.close": "關閉",
  "share-and-restrict-dialog.header.done-label": "完成",
  "share-and-restrict-dialog.header.general-access-description": "選擇哪些一般受眾可以存取此內容：這個空間中的任何人或僅限特定人員。",
  "share-and-restrict-dialog.header.general-access-heading": "控制一般存取權",
  "share-and-restrict-dialog.header.general-access-permission-dropdown-description": "選擇一般受眾是否可以檢視或編輯。",
  "share-and-restrict-dialog.header.general-access-permission-dropdown-heading": "控制一般權限",
  "share-and-restrict-dialog.header.learn-more-label": "深入了解",
  "share-and-restrict-dialog.header.next-label": "下一步",
  "share-and-restrict-dialog.header.specific-description": "只有存取權限比一般存取設定更高的特定人員才會顯示在此處。",
  "share-and-restrict-dialog.header.specific-heading": "檢視特定存取權",
  "share-and-restrict-dialog.header.title.public-link": "公開連結",
  "share-and-restrict-dialog.header.title.share": "分享",
  "share-and-restrict-dialog.header.title.slack": "分享到 Slack",
  "share-and-restrict-dialog.info-message.draft.after-label": "更多資訊工具提示",
  "share-and-restrict-dialog.info-message.draft.before-label": "草稿資訊訊息",
  "share-and-restrict-dialog.info-message.draft.message": "只有具有連結的人才能檢視和編輯草稿。",
  "share-and-restrict-dialog.info-message.draft.tooltip-message": "草稿建立者分享草稿連結之前，只有該建立者能夠存取草稿。",
  "share-and-restrict-dialog.info-message.public-link-free-upsell.icon-label": "公開連結",
  "share-and-restrict-dialog.info-message.smart-links-warning.action": "內容樹狀結構中的智慧連結權限如何運作",
  "share-and-restrict-dialog.info-message.smart-links-warning.message": "任何可在 Confluence 中存取此項目的人都可以檢視，但連結上的權限可能會影響誰可以與內容互動。",
  "share-and-restrict-dialog.info-message.smart-links-warning.title": "無法為智慧連結設定其他限制",
  "share-and-restrict-dialog.info-message.uneditable-restrictions.message": "您沒有權限變更此內容的存取權。",
  "share-and-restrict-dialog.makeBodyProps.avatarGroupData.deletedGroup": "此群組已被刪除",
  "share-and-restrict-dialog.makeBodyProps.avatarGroupData.you": "{name} (您)",
  "share-and-restrict-dialog.openAccessWarningDialog.body": "<b>此動作無法在 Free 方案上復原。</b>這會將內容的存取層級復原至下列預設層級：",
  "share-and-restrict-dialog.openAccessWarningDialog.cancelButton": "取消",
  "share-and-restrict-dialog.openAccessWarningDialog.openAccessButton": "開放存取權",
  "share-and-restrict-dialog.openAccessWarningDialog.title": "向所有人開放存取權",
  "share-and-restrict-dialog.overflow-menu.inspect-permissions": "檢查權限",
  "share-and-restrict-dialog.overflow-menu.learn-more": "深入了解限制",
  "share-and-restrict-dialog.overflow-menu.manage-space": "管理空間存取權",
  "share-and-restrict-dialog.overflow-menu.more": "更多動作",
  "share-and-restrict-dialog.permissions-select.capacity-exceeded": "已超過 400 位使用者和 400 個群組的容量上限。",
  "share-and-restrict-dialog.permissions-select.group-limit-exceeded": "{groupOverflow, plural, other {請移除 {groupOverflow,number} 個群組以繼續。}}",
  "share-and-restrict-dialog.permissions-select.user-and-group-limit-exceeded-prefix": "{userOverflow, plural, other {請移除 {userOverflow,number} 位使用者}}",
  "share-and-restrict-dialog.permissions-select.user-and-group-limit-exceeded-suffix": "{groupOverflow, plural, other {以及 {groupOverflow,number} 個群組以繼續。}}",
  "share-and-restrict-dialog.permissions-select.user-limit-exceeded": "{userOverflow, plural, other {請移除 {userOverflow,number} 位使用者以繼續。}}",
  "share-and-restrict-dialog.principal-access.can-edit-access": "可以編輯",
  "share-and-restrict-dialog.principal-access.can-view-access": "可以檢視",
  "share-and-restrict-dialog.principal-access.inherited-restrictions": "父系上的每個人都已經可以檢視",
  "share-and-restrict-dialog.principal-access.no-access": "無存取權",
  "share-and-restrict-dialog.principal-access.no-inherited-restrictions": "此空間中的每個人都已經可以檢視",
  "share-and-restrict-dialog.principal-access.remove-access": "移除",
  "share-and-restrict-dialog.principal-details-warning.draft-access-warning": "需要「可以編輯」才能檢視此草稿",
  "share-and-restrict-dialog.principal-details-warning.no-space-admin": "此空間目前沒有指派的空間管理員。",
  "share-and-restrict-dialog.principal-details-warning.no-space-edit-permission": "必須先擁有空間的編輯權限。請連絡<spaceAdmin>空間管理員</spaceAdmin>。",
  "share-and-restrict-dialog.principal-details-warning.no-space-permission": "必須先擁有空間的存取權。請連絡<spaceAdmin>空間管理員</spaceAdmin>。",
  "share-and-restrict-dialog.principal-details-warning.principal-details-warning.no-ancestor-permission": "必須先擁有<parentLink>父系</parentLink>頁面的存取權。",
  "share-and-restrict-dialog.principal-details.group-text": "群組",
  "share-and-restrict-dialog.principal-details.you-text": "(您)",
  "share-and-restrict-dialog.principals-stager.add-button": "新增",
  "share-and-restrict-dialog.principals-stager.can-edit": "可以編輯",
  "share-and-restrict-dialog.principals-stager.can-view": "可以檢視",
  "share-and-restrict-dialog.principals-stager.error": "若要繼續，請選取「新增」或移除這些人員。",
  "share-and-restrict-dialog.principals-stager.placeholder": "新增名稱、群組或電子郵件",
  "share-and-restrict-dialog.public-links.anyone-with-link": "具有連結的任何人",
  "share-and-restrict-dialog.public-links.body-empowered": "如果允許，可以檢視此內容的人可以與網際網路上的任何人分享，無須提供 Confluence 存取權。",
  "share-and-restrict-dialog.public-links.body-unempowered": "如果允許，您可以與網際網路上的任何人分享此內容，而無需授予他們 Confluence 的存取權。",
  "share-and-restrict-dialog.public-links.can-edit": "可以編輯",
  "share-and-restrict-dialog.public-links.can-view": "可以檢視",
  "share-and-restrict-dialog.public-links.copy-button-text": "複製公開連結",
  "share-and-restrict-dialog.public-links.learn-more": "深入了解",
  "share-and-restrict-dialog.public-links.learn-more-link": "深入了解公開連結",
  "share-and-restrict-dialog.public-links.link-allow-in-atlassian-administration": "在「Atlassian 管理」中允許",
  "share-and-restrict-dialog.public-links.link-allow-in-settings": "在設定中允許",
  "share-and-restrict-dialog.public-links.link-allow-in-space-settings": "在空間設定中允許",
  "share-and-restrict-dialog.public-links.no-sign-in-required": "無需登入。<link>深入了解</link>",
  "share-and-restrict-dialog.public-links.off": "公開連結已關閉",
  "share-and-restrict-dialog.public-links.on": "公開連結已開啟",
  "share-and-restrict-dialog.public-links.permissions-dropdown-label": "公開連結的權限",
  "share-and-restrict-dialog.public-links.smart-sections-message": "<b>智慧型區段不適用於公開可編輯的白板。</b>如果公開連結已設為可編輯，任何智慧型區段都將永久停用。<link>深入了解</link>",
  "share-and-restrict-dialog.public-links.title-empowered": "不允許使用此公開連結",
  "share-and-restrict-dialog.public-links.title-unempowered": "您的組織禁止使用此公開連結",
  "share-and-restrict-dialog.public-links.view": "檢視",
  "share-and-restrict-dialog.public-links.view-label": "檢視",
  "share-and-restrict-dialog.public-links.view-tooltip": "在新分頁中開啟公開連結",
  "share-and-restrict-dialog.publish-modal-warning.publish-blog": "選擇發布此部落格時要套用的存取設定。",
  "share-and-restrict-dialog.publish-modal-warning.publish-page": "選擇發布此頁面時要套用的存取設定。",
  "share-and-restrict-dialog.publish-modal-warning.update-blog": "選擇更新此部落格時要套用的存取設定。",
  "share-and-restrict-dialog.publish-modal-warning.update-page": "選擇更新此頁面時要套用的存取設定。",
  "share-and-restrict-dialog.remove-all.button": "全部移除",
  "share-and-restrict-dialog.resolve-restricted-access.heading.multi-user": "有些人需要額外的存取權",
  "share-and-restrict-dialog.resolve-restricted-access.heading.single-user": "有人需要額外的存取權",
  "share-and-restrict-dialog.resolve-restriction-dialog.error-flag.body": "有一位以上的訪客無法新增至空間，因為已能存取其他空間。訪客一次只能存取一個空間。",
  "share-and-restrict-dialog.resolve-restriction-dialog.error-flag.title": "無法新增訪客",
  "share-and-restrict-dialog.resolve-restriction.add-to-all-button": "新增至全部",
  "share-and-restrict-dialog.resolve-restriction.multi-user.parent.view-and-edit.body": "{usersCount, plural, =2 {<bold>{firstUser} 和 {secondUser}</bold> 必須先擁有其他地方的特定存取權，才能成功存取「<bold>{pageTitle}</bold>」。系統會將他們新增至父系項目，具有唯讀權限。<learnMoreLink>深入了解</learnMoreLink>} =3 {<bold>{firstUser}、{secondUser} 和 {thirdUser}</bold> 必須先擁有其他地方的特定存取權，才能成功存取「<bold>{pageTitle}</bold>」。系統會將他們新增至父系項目，具有唯讀權限。<learnMoreLink>深入了解</learnMoreLink>} =4 {<bold>{firstUser}、{secondUser}、{thirdUser} 和 {fourthUser}</bold> 必須先擁有其他地方的特定存取權，才能成功存取「<bold>{pageTitle}</bold>」。系統會將他們新增至父系項目，具有唯讀權限。<learnMoreLink>深入了解</learnMoreLink>} other {<bold>{firstUser}、{secondUser}、{thirdUser} 和其他 {remainingUserCount}人</bold>必須先擁有其他地方的特定存取權，才能成功存取「<bold>{pageTitle}</bold>」。系統會將他們新增至父系項目，具有唯讀權限。<learnMoreLink>深入了解</learnMoreLink>}}",
  "share-and-restrict-dialog.resolve-restriction.multi-user.single-restriction.body": "{usersCount, plural, =2 {{firstUser} 與 {secondUser}} =3 {{firstUser}、{secondUser} 和 {thirdUser}} =4 {{firstUser}、{secondUser}、{thirdUser} 和 {fourthUser}} other {{firstUser}、{secondUser}、{thirdUser} 和其他 {remainingUserCount} 人}}",
  "share-and-restrict-dialog.resolve-restriction.multi-user.space.view-and-edit.body": "{usersCount, plural, =2 {<bold>{firstUser} 和 {secondUser}</bold> 必須先擁有其他地方的特定存取權，才能成功存取「<bold>{pageTitle}</bold>」。系統會將他們新增為僅具有空間層級的編輯權限。系統會將他們新增至父系項目，具有唯讀權限。<learnMoreLink>深入了解</learnMoreLink>} =3 {<bold>{firstUser}、{secondUser} 和 {thirdUser}</bold> 必須先擁有其他地方的特定存取權，才能成功存取「<bold>{pageTitle}</bold>」。系統會將他們新增為僅具有空間層級的編輯權限。系統會將他們新增至父系項目，具有唯讀權限。<learnMoreLink>深入了解</learnMoreLink>} =4 {<bold>{firstUser}、{secondUser}、{thirdUser} 和 {fourthUser}</bold> 必須先擁有其他地方的特定存取權，才能成功存取「<bold>{pageTitle}</bold>」。系統會將他們新增為僅具有空間層級的編輯權限。系統會將他們新增至父系項目，具有唯讀權限。<learnMoreLink>深入了解</learnMoreLink>} other {<bold>{firstUser}、{secondUser}、{thirdUser} 和其他 {remainingUserCount} 人</bold>必須先擁有其他地方的特定存取權，才能成功存取「<bold>{pageTitle}</bold>」。系統會將他們新增為僅具有空間層級的編輯權限。系統會將他們新增至父系項目，具有唯讀權限。<learnMoreLink>深入了解</learnMoreLink>}}",
  "share-and-restrict-dialog.resolve-restriction.multi-user.view.body": "{usersCount, plural, =2 {<bold>{firstUser} 和 {secondUser}</bold> 必須先被授予其他地方的檢視權限，才能成功檢視「<bold>{pageTitle}</bold>」。<learnMoreLink>深入了解</learnMoreLink>} =3 {<bold>{firstUser}、{secondUser} 和 {thirdUser}</bold> 必須先被授予其他地方的檢視權限，才能成功檢視「<bold>{pageTitle}</bold>」。<learnMoreLink>深入了解</learnMoreLink>} =4 {<bold>{firstUser}、{secondUser}、{thirdUser} 和 {fourthUser}</bold> 必須先被授予其他地方的檢視權限，才能成功檢視「<bold>{pageTitle}</bold>」。<learnMoreLink>深入了解</learnMoreLink>} other {<bold>{firstUser}、{secondUser}、{thirdUser} 和其他 {remainingUserCount}人</bold>必須先被授予其他地方的檢視權限，才能成功檢視「<bold>{pageTitle}</bold>」。<learnMoreLink>深入了解</learnMoreLink>}}",
  "share-and-restrict-dialog.resolve-restriction.parent-access.add-to-parent-button": "新增至父系",
  "share-and-restrict-dialog.resolve-restriction.parent-access.body": "該使用者必須先擁有父系「<resourceLink>{resourceTitle}</resourceLink>」的存取權，才能成功存取「<bold>{pageTitle}</bold>」。系統會將該使用者新增為具有唯讀權限。<learnMoreLink>深入了解</learnMoreLink>",
  "share-and-restrict-dialog.resolve-restriction.space-access.add-to-space-button": "新增至空間",
  "share-and-restrict-dialog.resolve-restriction.space-access.body": "該使用者必須先擁有空間<resourceLink>{resourceTitle}</resourceLink>的存取權，才能存取 <bold>{pageTitle}</bold>。",
  "share-and-restrict-dialog.resolve-restriction.space-access.heading": "有人需要額外的存取權",
  "share-and-restrict-dialog.resolve-restriction.space-access.skip-button": "暫時跳過",
  "share-and-restrict-dialog.resolve-restriction.space-access.view-and-edit.body": "該使用者必須先擁有空間「<resourceLink>{resourceTitle}</resourceLink>」的存取權，才能成功存取「<bold>{pageTitle}</bold>」。系統會將該使用者新增為僅具有檢視和編輯權限。<learnMoreLink>深入了解</learnMoreLink>",
  "share-and-restrict-dialog.resolve-restriction.space-access.view.body": "該使用者必須先擁有空間「<resourceLink>{resourceTitle}</resourceLink>」的存取權，才能成功檢視「<bold>{pageTitle}</bold>」。系統會將該使用者新增為具有唯讀權限。<learnMoreLink>深入了解</learnMoreLink>",
  "share-and-restrict-dialog.restricted-access-warning.body": "他們需要先取得其他地方的存取權，才能獲得「<b>{page}</b>」的指定存取權。請連絡空間管理員，或<learnMoreLink>參閱我們的疑難排解指南</learnMoreLink>。",
  "share-and-restrict-dialog.restricted-access-warning.contact-admin": "請連絡空間管理員尋求協助。",
  "share-and-restrict-dialog.restricted-access-warning.continue": "不修正就繼續",
  "share-and-restrict-dialog.restricted-access-warning.go-back": "返回並修正",
  "share-and-restrict-dialog.restricted-access-warning.heading": "有些人需要額外的存取權",
  "share-and-restrict-dialog.restricted-access-warning.heading.multi-user": "有些人需要額外的存取權",
  "share-and-restrict-dialog.restricted-access-warning.heading.single-user": "有人需要額外的存取權",
  "share-and-restrict-dialog.restricted-access-warning.skip": "確定",
  "share-and-restrict-dialog.restricted-access-warning.users": "{usersCount, plural, =2 {{firstUser} 與 {secondUser}} =3 {{firstUser}、{secondUser} 和 {thirdUser}} =4 {{firstUser}、{secondUser}、{thirdUser} 和 {fourthUser}} other {{firstUser}、{secondUser}、{thirdUser} 和其他 {remainingUserCount} 人}}",
  "share-and-restrict-dialog.restricted-user-resources-details.needs-access": "需要 {resourcesCount} 個地方的存取權：",
  "share-and-restrict-dialog.restricted-user-resources-details.parent-items": "父系項目",
  "share-and-restrict-dialog.restricted-user-resources-details.space": "空間",
  "share-and-restrict-dialog.specific-access.heading": "特定存取權",
  "share-and-restrict-dialog.spotlight.heading": "限制已移動",
  "share-and-restrict-dialog.spotlight.learn-more": "深入了解",
  "share-and-restrict-dialog.spotlight.ok": "確定",
  "share-and-restrict-dialog.spotlight.text": "現在您可以在單一位置分享和限制內容的存取權。",
  "share.blogpost": "部落格貼文",
  "share.button.restriction.invite.action.text": "邀請人員",
  "share.button.restriction.message.invite.text": "{userCount, plural, =0 {<b>{userEmail}</b> 無法存取任何空間中的內容。邀請該使用者加入 Confluence 以開始協作。} other {<b>{userEmail} 和其他 {userCount,number}</b> 人無法存取任何空間中的內容。邀請他們加入 Confluence 以開始協作。}}",
  "share.button.text": "分享",
  "share.button.user-picker.no-options.existingUserOnly": "找不到「{inputValue}」的任何結果。",
  "share.button.user-picker.no-options.generic": "找不到「{inputValue}」的任何結果。請使用電子郵件地址邀請使用者。",
  "share.copylink.copied.tooltip": "已複製！",
  "share.copylink.error.tooltip": "發生錯誤。",
  "share.copylink.icon.label": "複製連結",
  "share.default.title": "未命名",
  "share.dialog.shareInSlack.new.lozenge": "全新",
  "share.external-share-toggle.copy-public-link.button": "複製公開連結",
  "share.external.edition-message.body.admin": "如果您使用付費方案，您的團隊可以使用公開連結，與網際網路上的任何人分享內容。",
  "share.external.edition-message.body.non-admin": "如果您使用付費方案，您的團隊可以使用公開連結，與網際網路上的任何人分享內容。<learnmorelink>深入了解</learnmorelink>",
  "share.external.edition-message.title": "公開分享此內容",
  "share.external.learn.more.text": "深入了解",
  "share.external.public.link.copied": "公開連結已複製到剪貼簿。",
  "share.external.restriction.change": "變更",
  "share.external.restriction.message": "由於對內容的限制，有些人可能無法檢視此內容",
  "share.external.toggle.confirm.accept": "確認",
  "share.external.toggle.confirm.cancel": "取消",
  "share.external.toggle.confirm.label": "您確定嗎？此內容上的作用中公開連結將變成無效。",
  "share.external.toggle.disabled.info.link.allowInAtlassianAdministration": "在「Atlassian 管理」中允許",
  "share.external.toggle.disabled.info.link.allowInSettings": "在設定中允許",
  "share.external.toggle.disabled.info.link.allowInSpaceSettings": "在空間設定中允許",
  "share.external.toggle.disabled.info.link.learnmore.admin": "深入了解",
  "share.external.toggle.disabled.info.link.learnmore.unempowered": "深入了解公開連結",
  "share.external.toggle.disabled.info.text.admin": "如果允許，使用者可以與網際網路上的任何人分享此內容，而無需授予他們 Confluence 的存取權。",
  "share.external.toggle.disabled.info.text.unempowered": "如果允許，使用者可以與網際網路上的任何人分享此內容，而無需授予他們 Confluence 的存取權。",
  "share.external.toggle.disabled.info.text.whiteboard.unempowered": "如果允許，您可以與網際網路上的任何人分享此白板，而無需授予他們 Confluence 的存取權。",
  "share.external.toggle.disabled.info.title.admin": "不允許使用此公開連結",
  "share.external.toggle.disabled.info.title.unempowered": "您的組織禁止使用此公開連結",
  "share.external.toggle.free-disabled.tooltip": "已停用免費 Confluence 網站的公開連結",
  "share.external.toggle.improper.permission.toggle.off": "公開連結已停用。若要啟用，您需要編輯此內容的權限，或在此空間中編輯限制的權限。",
  "share.external.toggle.improper.permission.toggle.on": "公開連結已啟用。若要停用，您需要編輯此內容的權限，或在此空間中編輯限制的權限。",
  "share.external.toggle.label": "公開連結",
  "share.external.toggle.legacy.content.tooltip": "請編輯此頁面並將其轉換為新編輯器以使用公開連結",
  "share.external.toggle.permission": "允許任何人編輯",
  "share.external.toggle.subheading": "網際網路上有此連結的任何人都可以檢視。",
  "share.external.toggle.subheading.unavailable": "發生錯誤。請嘗試重新整理頁面。",
  "share.external.whiteboard.toggle.disabled.info.text.admin": "如果允許，使用者可以與網際網路上的任何人分享此白板，而無需授予他們 Confluence 的存取權。",
  "share.form.title": "分享 {type}",
  "share.livedoc": "即時文件",
  "share.page": "頁面",
  "share.space": "空間",
  "shortcuts.deprecated-shortcut-flag.button.dont-tell-me-again": "不再顯示通知",
  "shortcuts.deprecated-shortcut-flag.button.remind-me-later": "稍後再提醒我",
  "shortcuts.deprecated-shortcut-flag.description": "快速鍵正在切換為<supportLink>通用格式</supportLink>。<inline>{oldShortcut} 現在將會是 {newShortcut}</inline>",
  "shortcuts.deprecated-shortcut-flag.title": "這個快速鍵即將變更",
  "side-navigation.admin-navigation.back-button.title.site-settings": "Confluence 管理",
  "side-navigation.admin.admin.center": "任務控制",
  "side-navigation.admin.apps-section.title": "應用程式",
  "side-navigation.admin.changeboarding.data-management.description": "此外，管理設定現在稱為「資料管理」。{br}{br}除了稽核記錄之外，其他都原封不動。",
  "side-navigation.admin.changeboarding.go-back-button": "返回",
  "side-navigation.admin.changeboarding.header": "管理更新",
  "side-navigation.admin.changeboarding.learn-more-button": "深入了解",
  "side-navigation.admin.changeboarding.modal.description": "Confluence 管理現在會登陸在任務控制中心，您可以主動監控 Confluence 活動、存取權和警示，並採取具體的行動。{br}{br}側邊導覽中還有新的階層：{br}{br}<strong>監控</strong>功能 (例如 Confluence 任務控管和稽核記錄等等) 是頂端的優先項目。{br}{br}<strong>管理工具</strong> (例如自動化和公告橫幅) 更容易尋找和使用。{br}{br}<strong>設定</strong>可搜尋，並可摺疊成更容易管理、可擴充的貯體。",
  "side-navigation.admin.changeboarding.modal.heading": "任務控管：您的下一次重要登陸",
  "side-navigation.admin.changeboarding.monitoring.description": "我們已從設定中提取稽核記錄等監控功能，方便您尋找。",
  "side-navigation.admin.changeboarding.next-button": "下一步",
  "side-navigation.admin.changeboarding.ok-button": "確定",
  "side-navigation.admin.changeboarding.search.description": "設定現在可搜尋並摺疊成更容易管理、可擴充的貯體。",
  "side-navigation.admin.configuration.analytics-permissions": "分析權限",
  "side-navigation.admin.configuration.beta-features": "測試版功能",
  "side-navigation.admin.configuration.live-edit": "即時編輯",
  "side-navigation.admin.configuration.new-features": "新功能",
  "side-navigation.admin.configuration.notifications": "通知",
  "side-navigation.admin.container-nav.heading": "設定",
  "side-navigation.admin.container-nav.heading-admin-tools": "管理工具",
  "side-navigation.admin.container-nav.heading-monitoring": "監視",
  "side-navigation.admin.globaladminbilling.label": "帳單",
  "side-navigation.admin.setting-search.clear-search": "清除搜尋",
  "side-navigation.admin.setting-search.label": "設定搜尋",
  "side-navigation.admin.setting-search.no-results": "我們找不到具有該標題的任何設定",
  "side-navigation.admin.setting-search.placeholder": "跳到設定...",
  "side-navigation.admin.title.announcement-banners": "公告",
  "side-navigation.admin.title.atlassian-administration": "Atlassian 管理",
  "side-navigation.admin.title.automation": "自動化",
  "side-navigation.admin.title.company-hub-permissions": "中心權限",
  "side-navigation.admin.title.configuration": "組態",
  "side-navigation.admin.title.data-management": "資料管理",
  "side-navigation.admin.title.global.permissions": "全域權限",
  "side-navigation.admin.title.manage.groups": "群組",
  "side-navigation.admin.title.security": "安全性",
  "side-navigation.admin.title.space-manager": "空間",
  "side-navigation.admin.title.space.reports": "空間報告",
  "side-navigation.admin.title.user-access": "使用者存取權",
  "side-navigation.admin.title.users": "使用者",
  "side-navigation.admin.use-marketplace-web-items.explore-apps": "探索應用程式",
  "side-navigation.admin.usermanagement.label": "使用者管理",
  "side-navigation.apps-configuration.cancel": "取消",
  "side-navigation.apps-configuration.description": "在側邊欄中顯示和排序應用程式。",
  "side-navigation.apps-configuration.emptyView": "此空間沒有任何應用程式",
  "side-navigation.apps-configuration.errorGenericTitle": "發生錯誤。",
  "side-navigation.apps-configuration.save": "儲存",
  "side-navigation.apps-configuration.title": "編輯空間應用程式",
  "side-navigation.container.all-content": "所有內容",
  "side-navigation.container.analytics": "分析",
  "side-navigation.container.automation": "自動化",
  "side-navigation.container.calendars": "行事曆",
  "side-navigation.content-menu.error-message.subtitle": "請重新整理，然後再試一次。",
  "side-navigation.content-menu.no-results-message.subtitle": "我們找不到您正在尋找的項目。",
  "side-navigation.content-menu.text-filter.clear-filter": "清除篩選條件",
  "side-navigation.content-menu.untitled": "未命名",
  "side-navigation.custom.home.link": "自訂首頁",
  "side-navigation.customize-sidebar.item-actions.move-down": "向下移動",
  "side-navigation.customize-sidebar.item-actions.move-to-bottom": "移至底部",
  "side-navigation.customize-sidebar.item-actions.move-to-top": "移至頂端",
  "side-navigation.customize-sidebar.item-actions.move-up": "向上移動",
  "side-navigation.databases.alpha-label": "Alpha 版",
  "side-navigation.databases.tooltip": "檢視此空間中的所有資料庫",
  "side-navigation.databases.word": "資料庫",
  "side-navigation.global-banner-reminder.content-with-link": "<a>新版導覽</a>將在 5 月 19 日當週自動開啟。如果您還沒有新版導覽，現在就為您自己或團隊開啟。",
  "side-navigation.global-banner.close.label": "關閉",
  "side-navigation.global-banner.content-with-link": "<a>新版導覽</a>已可供使用，將在未來幾週內自動開啟。立即為您的團隊開啟此功能，或僅開啟您自己的。",
  "side-navigation.global-banner.cta": "前往設定",
  "side-navigation.global-navigation.customization-modal.actions-icon-button-label": "「{itemName}」項目的動作",
  "side-navigation.global-navigation.customization-modal.app-items-description": "下列 Atlassian 應用程式可供您的組織使用。",
  "side-navigation.global-navigation.customization-modal.app-items-label": "應用程式捷徑",
  "side-navigation.global-navigation.customization-modal.app-items-title": "應用程式捷徑",
  "side-navigation.global-navigation.customization-modal.close-button": "取消",
  "side-navigation.global-navigation.customization-modal.close-button-label": "取消對側邊欄的變更",
  "side-navigation.global-navigation.customization-modal.close-icon-button": "關閉並取消對側邊欄的變更",
  "side-navigation.global-navigation.customization-modal.description": "所選項目將隨時顯示在側邊欄中。您仍然可以從側邊欄的<b>更多</b>選單，存取未選取的項目。",
  "side-navigation.global-navigation.customization-modal.heading": "自訂您的側邊欄",
  "side-navigation.global-navigation.customization-modal.heading-body": "所選項目將隨時顯示在側邊欄中。您仍然可以從側邊欄的「更多」選單，存取未選取的項目。",
  "side-navigation.global-navigation.customization-modal.hide-item-action-label": "從側邊欄隱藏「{itemName}」",
  "side-navigation.global-navigation.customization-modal.hide-item-action-text": "從側邊欄隱藏項目",
  "side-navigation.global-navigation.customization-modal.hide-item-checkbox-label": "隱藏側邊欄中的「{itemName}」區段",
  "side-navigation.global-navigation.customization-modal.info": "您在此處所做的變更只會影響您，不會影響網站上的其他人。",
  "side-navigation.global-navigation.customization-modal.move-item-actions-label": "移動「{itemName}」",
  "side-navigation.global-navigation.customization-modal.move-item-actions-text": "在側邊欄中移動項目",
  "side-navigation.global-navigation.customization-modal.move-item-bottom-label": "將「{itemName}」移至底部",
  "side-navigation.global-navigation.customization-modal.move-item-bottom-text": "將「{itemName}」移至底部",
  "side-navigation.global-navigation.customization-modal.move-item-down-label": "將「{itemName}」向下移動",
  "side-navigation.global-navigation.customization-modal.move-item-down-text": "向下移動",
  "side-navigation.global-navigation.customization-modal.move-item-top-label": "將「{itemName}」移至頂部",
  "side-navigation.global-navigation.customization-modal.move-item-top-text": "將「{itemName}」移至頂部",
  "side-navigation.global-navigation.customization-modal.move-item-up-label": "將「{itemName}」向上移動",
  "side-navigation.global-navigation.customization-modal.move-item-up-text": "向上移動",
  "side-navigation.global-navigation.customization-modal.product-items-description": "下列導覽項目可在 Confluence 中使用。",
  "side-navigation.global-navigation.customization-modal.product-items-label": "自訂 Confluence 導覽",
  "side-navigation.global-navigation.customization-modal.product-items-title": "Confluence 導覽",
  "side-navigation.global-navigation.customization-modal.save-button": "儲存變更",
  "side-navigation.global-navigation.customization-modal.save-button-label": "為側邊欄儲存自訂項目",
  "side-navigation.global-navigation.customization-modal.show-item-action-label": "在側邊欄中顯示「{itemName}」",
  "side-navigation.global-navigation.customization-modal.show-item-action-text": "在側邊欄中顯示項目",
  "side-navigation.global-navigation.customization-modal.show-item-checkbox-label": "在側邊欄中顯示「{itemName}」區段",
  "side-navigation.global-navigation.customize-sidebar-dialog.cancel": "取消",
  "side-navigation.global-navigation.customize-sidebar-dialog.error-description": "我們目前無法儲存您的自訂內容。請重新整理頁面或再試一次。",
  "side-navigation.global-navigation.customize-sidebar-dialog.error-title": "我們無法儲存您的自訂內容",
  "side-navigation.global-navigation.customize-sidebar-dialog.save": "儲存",
  "side-navigation.global-navigation.customize-sidebar-dialog.subtitle": "在左側邊欄中顯示、隱藏和重新排序導覽項目。只有您會看到這些變更。",
  "side-navigation.global-navigation.customize-sidebar-dialog.title": "自訂側邊欄",
  "side-navigation.global.apps": "應用程式",
  "side-navigation.global.apps.app-audit-log": "應用程式稽核記錄",
  "side-navigation.global.apps.error-description": "請重新整理，然後再試一次。",
  "side-navigation.global.apps.error-title": "我們無法載入應用程式",
  "side-navigation.global.apps.explore-apps": "探索應用程式",
  "side-navigation.global.apps.explore-more-apps": "探索更多應用程式",
  "side-navigation.global.apps.manage-apps": "管理應用程式",
  "side-navigation.global.apps.more-actions": "更多動作",
  "side-navigation.global.apps.popular-apps": "熱門應用程式",
  "side-navigation.global.apps.view-app-requests": "檢視應用程式要求",
  "side-navigation.global.apps.your-apps": "您的應用程式",
  "side-navigation.global.company.hub": "公司中心",
  "side-navigation.global.customize.separator": "從側邊欄隱藏",
  "side-navigation.global.customize.sidebar": "自訂側邊欄",
  "side-navigation.global.customize.templates": "範本",
  "side-navigation.global.customize.workflows": "工作流程",
  "side-navigation.global.drafts": "草稿",
  "side-navigation.global.for.you": "與您相關的內容",
  "side-navigation.global.goals": "目標",
  "side-navigation.global.home": "首頁",
  "side-navigation.global.more": "更多",
  "side-navigation.global.recent": "最近",
  "side-navigation.global.scroll-to-top.button.label": "返回最上方",
  "side-navigation.global.spaces": "空間",
  "side-navigation.global.starred": "已標上星號",
  "side-navigation.global.tasks": "任務",
  "side-navigation.global.teams": "團隊",
  "side-navigation.global.topics": "主題",
  "side-navigation.global.your.work": "與您相關的內容",
  "side-navigation.hub-settings.navigation-item.analytics": "分析",
  "side-navigation.hub-settings.navigation-item.general": "一般",
  "side-navigation.hub-settings.navigation-item.users": "使用者",
  "side-navigation.hub-settings.navigation-title": "公司中心設定",
  "side-navigation.monitoring.title.analytics": "分析",
  "side-navigation.page-tree-dialog.errorGenericBody": "請稍後再試一次。",
  "side-navigation.recent-content-menu.advanced-search-link": "<a>改為搜尋所有內容</a>",
  "side-navigation.recent-content-menu.all-results-announcement": "顯示所有最近的頁面",
  "side-navigation.recent-content-menu.empty-state.message": "您瀏覽或編輯的頁面、白板和資料庫將顯示在此處。",
  "side-navigation.recent-content-menu.empty-state.title": "這裡沒有任何資訊可以顯示！",
  "side-navigation.recent-content-menu.error-message.title": "我們無法載入您最近的項目",
  "side-navigation.recent-content-menu.filter-label": "篩選",
  "side-navigation.recent-content-menu.filter-placeholder": "篩選最近的項目",
  "side-navigation.recent-content-menu.filter.all": "全部",
  "side-navigation.recent-content-menu.filter.owned-by-me": "由我所負責",
  "side-navigation.recent-content-menu.filter.remove": "移除",
  "side-navigation.recent-content-menu.filter.worked-on": "已處理",
  "side-navigation.recent-content-menu.filtered-results-announcement": "{count, plural, other {找到 {count,number} 個結果}}",
  "side-navigation.recent-content-menu.load-more": "載入更多",
  "side-navigation.recent-content-menu.no-results-state.message": "{selectedFilter, select, WORKED_ON {我們找不到您在過去 90 天內處理的任何相符內容。} CREATED_BY_ME {我們找不到您在過去 90 天內建立的任何相符內容。} other {我們無法從最近 90 天造訪的內容中找到相符項目。}}",
  "side-navigation.recent-content-menu.section.last-month": "在上個月",
  "side-navigation.recent-content-menu.section.last-week": "過去一週內",
  "side-navigation.recent-content-menu.section.more-than-month": "一個多月前",
  "side-navigation.recent-content-menu.section.today": "今天",
  "side-navigation.recent-content-menu.section.yesterday": "昨天",
  "side-navigation.recent-content-menu.selected-filter.label": "已選取",
  "side-navigation.recent-content-menu.title": "最近",
  "side-navigation.recent-content-menu.view-all": "檢視所有最近的項目",
  "side-navigation.space-apps.edit.label": "編輯應用程式",
  "side-navigation.space-apps.edit.tooltip": "重新排列、顯示和隱藏應用程式",
  "side-navigation.space-apps.header": "空間應用程式",
  "side-navigation.space-apps.no-space-apps.message": "側邊欄中沒有顯示應用程式",
  "side-navigation.space-apps.tooltip": "存取此空間中的應用程式",
  "side-navigation.space-navigation.add-users": "新增使用者",
  "side-navigation.space-navigation.all-content.tooltip": "檢視此空間中的所有內容",
  "side-navigation.space-navigation.analytics": "分析",
  "side-navigation.space-navigation.analytics.tooltip": "檢視此空間的分析",
  "side-navigation.space-navigation.archive-space": "封存空間",
  "side-navigation.space-navigation.automation": "自動化",
  "side-navigation.space-navigation.automation.tooltip": "檢視此空間的自動化",
  "side-navigation.space-navigation.bulk-tools.label": "內容管理員",
  "side-navigation.space-navigation.bulk-tools.tooltip": "管理此空間的內容",
  "side-navigation.space-navigation.calendars": "行事曆",
  "side-navigation.space-navigation.calendars.tooltip": "檢視行事曆",
  "side-navigation.space-navigation.content-manager": "內容管理員",
  "side-navigation.space-navigation.error.generic": "我們在載入此空間時遇到問題。請嘗試立即重新整理。",
  "side-navigation.space-navigation.error.not-found": "我們找不到您正在尋找的空間。",
  "side-navigation.space-navigation.error.restricted": "您沒有在此空間中查看內容的權限。",
  "side-navigation.space-navigation.header.edit-space-details": "編輯空間詳細資料",
  "side-navigation.space-navigation.header.external-collaborators-space-changeboarding-dismiss": "確定",
  "side-navigation.space-navigation.header.external-collaborators-space-changeboarding-text": "您可以隨時按一下「<b>訪客</b>」來查看空間中的訪客清單。",
  "side-navigation.space-navigation.header.space-avatar-edit-header-tooltip": "編輯空間詳細資料",
  "side-navigation.space-navigation.header.space-avatar-error": "發生錯誤。請再試一次。",
  "side-navigation.space-navigation.more-actions": "更多動作",
  "side-navigation.space-navigation.nav.region.aria.label": "空間",
  "side-navigation.space-navigation.premium-lozenge": "Premium",
  "side-navigation.space-navigation.questions": "問題",
  "side-navigation.space-navigation.questions.label": "問題",
  "side-navigation.space-navigation.questions.tooltip": "詢問並回答此空間的問題",
  "side-navigation.space-navigation.restore-space": "復原空間",
  "side-navigation.space-navigation.space-settings": "空間設定",
  "side-navigation.space-navigation.space-settings-link.title": "空間設定",
  "side-navigation.space-navigation.space-settings-link.tooltip": "檢視此空間的設定",
  "side-navigation.space-navigation.space-tools": "空間工具",
  "side-navigation.space-navigation.trash-space": "刪除空間",
  "side-navigation.space-overview-shortcut.tooltip": "檢視空間概覽",
  "side-navigation.star-content-menu.all-results-announcement": "顯示所有已標上星號的頁面",
  "side-navigation.star-content-menu.filtered-results-announcement": "{count, plural, other {找到 {count,number} 個結果}}",
  "side-navigation.starred-content-menu.empty-state-message": "使用星號標記重要項目，以便快速存取。您會在這裡看到這些項目。",
  "side-navigation.starred-content-menu.empty-state-title": "您尚未將任何項目標上星號",
  "side-navigation.starred-content-menu.error-message.title": "我們無法載入您已標上星號的項目",
  "side-navigation.starred-content-menu.filter-placeholder": "篩選已標上星號的項目",
  "side-navigation.starred-content-menu.load-more": "載入更多",
  "side-navigation.starred-content-menu.title": "已標上星號",
  "side-navigation.starred-content-menu.view-all": "檢視所有已標上星號的項目",
  "side-navigation.starred-spaces-list.empty-message": "您標上星號的空間會顯示在這裡",
  "side-navigation.starred-spaces-list.error-flag-description": "我們目前無法顯示您的空間。重新整理頁面或再試一次。",
  "side-navigation.starred-spaces-list.error-flag-title": "我們無法載入已標上星號的空間",
  "side-navigation.starred-spaces-list.title": "已標上星號的空間",
  "side-navigation.starred-spaces-list.view-all": "檢視所有空間",
  "site-permissions.app-search-textbox-Placeholder": "輸入應用程式名稱",
  "site-permissions.bulk-edit.bulk-action.assign.space": "指派空間",
  "site-permissions.bulk-edit.bulk-action.remove.space": "移除空間",
  "site-permissions.bulk-edit.selected.aria-label": "選取此頁面上的所有訪客",
  "site-permissions.bulk-edit.selected.count": "已選取 {count} 個",
  "site-permissions.confirm-body": "如果您現在離開，系統將不會儲存您對權限所做的變更。",
  "site-permissions.default-space-assignment.assigned-desc": "未來所有訪客使用者將會自動新增至此空間。{button}",
  "site-permissions.default-space-assignment.card-title": "預設空間：{status}",
  "site-permissions.default-space-assignment.change-space": "管理預設空間",
  "site-permissions.default-space-assignment.dismiss": "關閉",
  "site-permissions.default-space-assignment.fetch-error": "預設空間的資訊無法顯示。請稍後再試一次。",
  "site-permissions.default-space-assignment.fetch-error-title": "發生錯誤",
  "site-permissions.default-space-assignment.flag-success-action": "知道了",
  "site-permissions.default-space-assignment.none": "無",
  "site-permissions.default-space-assignment.set-space": "指派預設空間",
  "site-permissions.default-space-assignment.try-again": "再試一次",
  "site-permissions.default-space-assignment.update-error": "未儲存預設空間的變更。請稍後再試一次。",
  "site-permissions.default-space-assignment.update-error-title": "預設空間未更新",
  "site-permissions.default-space-assignment.update-success": "已成功儲存您的預設空間設定",
  "site-permissions.default-space-assignment.update-success-title": "預設空間已更新",
  "site-permissions.default-space-dialog.body": "未來所有訪客使用者將會自動新增至此空間。{learnMoreLink}",
  "site-permissions.default-space-dialog.cancel": "取消",
  "site-permissions.default-space-dialog.header": "預設空間設定",
  "site-permissions.default-space-dialog.save": "儲存",
  "site-permissions.default-space-dialog.space-select-label": "預設空間",
  "site-permissions.default-space-dialog.space-select-placeholder": "無",
  "site-permissions.error-flag-description": "請稍後再試一次。",
  "site-permissions.external-tab-feedback-option.btn.description": "讓我們知道您對訪客功能的看法",
  "site-permissions.external-tab-feedback-option.btn.label": "提供意見反應",
  "site-permissions.external-tab.guest-permissions-info.assign-space": "<b>附註：</b>如果沒有指派的空間，訪客完全無法存取 Confluence。",
  "site-permissions.external-tab.guest-permissions-info.learn-more": "進一步了解訪客",
  "site-permissions.external-tab.guest-permissions-info.message": "訪客是組織外部的承包商、顧問和其他協作者。因為是訪客，所以僅限於存取一個空間、會清楚標示為訪客，且對於使用者資訊的存取權會受到限制。 {learnMoreLink}",
  "site-permissions.external.bulk-space-access-dialog-space-selector.new-single-space-label": "空間",
  "site-permissions.external.bulk-space-access-dialog-space-selector.placeholder-text": "選取空間",
  "site-permissions.external.bulk-space-access-dialog-space-selector.single-space-helper-message": "訪客一次只能被新增至一個空間",
  "site-permissions.external.bulk-space-access-dialog-user-selector.error-loading-users-message": "無法新增某些使用者。請嘗試搜尋這些使用者，或重新整理頁面。",
  "site-permissions.external.bulk-space-access-dialog-user-selector.new-user-group-helper-message": "最多可新增 {count} 位訪客",
  "site-permissions.external.bulk-space-access-dialog-user-selector.new-user-label": "訪客",
  "site-permissions.external.bulk-space-access-dialog.bulk-assign.header": "{selectedUserCount, plural, other {將 {selectedUserCount,number} 位訪客指派至空間}}",
  "site-permissions.external.bulk-space-access-dialog.cta-assign-space": "指派",
  "site-permissions.external.bulk-space-access-dialog.cta-cancel": "取消",
  "site-permissions.external.bulk-space-access-dialog.cta-remove-space-access": "移除存取權",
  "site-permissions.external.bulk-space-access-dialog.cta-try-again": "再試一次",
  "site-permissions.external.bulk-space-access-dialog.default-space-checkbox-label": "設定為訪客的預設空間",
  "site-permissions.external.bulk-space-access-dialog.default-space-mutation-description": "您也成功更新了訪客的預設空間。",
  "site-permissions.external.bulk-space-access-dialog.header": "新增空間存取權",
  "site-permissions.external.bulk-space-access-dialog.mutation.new-failed-message": "將其中 {userCount} 個所選訪客指派至指示空間時發生問題。您可以嘗試再次指派。",
  "site-permissions.external.bulk-space-access-dialog.mutation.new-failed-title": "{userCount, plural, other {{userCount,number} 個訪客無法指派至空間}}",
  "site-permissions.external.bulk-space-access-dialog.mutation.new-success-title": "{userCount, plural, other {{userCount,number} 位訪客已指派至空間}}",
  "site-permissions.external.bulk-space-access-dialog.single-space-description": "將空間的存取權賦予人員，以便他們在該空間中開始協作。",
  "site-permissions.external.bulk-space-access-dialog.space-reassignment.warning-label": "空間指派警告",
  "site-permissions.external.bulk-space-access-dialog.space-reassignment.warning-message": "已指派空間的訪客將被移除，並重新指派到這個空間。{learnMoreLink}",
  "site-permissions.external.bulk-space-access-removal-dialog.admin-link-text": "Atlassian 管理",
  "site-permissions.external.bulk-space-access-removal-dialog.bulk-unassign.description": "{selectedUsersCount, plural, other {如果沒有空間存取權，這些訪客將無法再檢視此 Confluence 網站上的內容，也無法在這些內容上協作。}}",
  "site-permissions.external.bulk-space-access-removal-dialog.bulk-unassign.header": "{selectedUsersCount, plural, other {要移除 {selectedUsersCount,number} 位訪客的空間嗎？}}",
  "site-permissions.external.bulk-space-access-removal-dialog.cta-cancel": "取消",
  "site-permissions.external.bulk-space-access-removal-dialog.cta-try-again": "再試一次",
  "site-permissions.external.bulk-space-access-removal-dialog.message-for-org-admin": "如果您要停用這些訪客或將其停權，請前往 {adminHubLink}。",
  "site-permissions.external.bulk-space-access-removal-dialog.message-for-product-admin": "若要從產品中完全移除訪客，請連絡您的組織管理員。",
  "site-permissions.external.bulk-space-access-removal-dialog.mutation.failed-message": "{count, plural, other {移除 {count,number} 個訪客的空間存取權時發生錯誤。}}",
  "site-permissions.external.bulk-space-access-removal-dialog.mutation.failed-title": "{count, plural, other {我們無法移除 {count,number} 個訪客的空間存取權}}",
  "site-permissions.external.bulk-space-access-removal-dialog.mutation.success-title": "{count, plural, other {已移除 {count,number} 位訪客的空間存取權}}",
  "site-permissions.external.failed-to-load.title": "無法載入訪客列表",
  "site-permissions.external.guest-features-footer-note": "<b>附註：</b>您可以進一步限制訪客可以執行的操作。",
  "site-permissions.external.invite-guests": "新增訪客",
  "site-permissions.external.invite-guests-button.text": "邀請訪客",
  "site-permissions.external.learn-more-link": "進一步了解訪客",
  "site-permissions.external.no-guests": "尚未新增訪客",
  "site-permissions.external.no-guests-without-access.title": "您最親切友善！所有訪客都可以存取空間",
  "site-permissions.external.product-admin-note": "請連絡組織管理員以新增訪客。",
  "site-permissions.external.quick-actions.aria-label": "快速動作",
  "site-permissions.external.quick-actions.manage-space-access": "管理空間存取權",
  "site-permissions.external.refresh-list": "重新整理列表",
  "site-permissions.external.single-space-selector.error-mutation-failed.description": "請再試一次。如果這種情況持續發生，請試著連絡{supportLink}或空間管理員。",
  "site-permissions.external.single-space-selector.error-mutation-failed.title": "無法變更空間存取權",
  "site-permissions.external.single-space-selector.has-multiple-spaces": "多個空間",
  "site-permissions.external.single-space-selector.mutation-succeeded.title": "已變更空間存取權",
  "site-permissions.external.single-space-selector.quick-actions.error-mutation-failed.description": "請再試一次。如果這種情況持續發生，請試著連絡{supportLink}或空間管理員。",
  "site-permissions.external.single-space-selector.quick-actions.error-mutation-failed.title": "無法移除空間存取權",
  "site-permissions.external.what-guests-can-do": "訪客可以執行什麼操作：",
  "site-permissions.filter.caption": "篩選",
  "site-permissions.filter.reset": "重設篩選條件",
  "site-permissions.group-count.one-person": "{count, plural, other {{count} 個人}}",
  "site-permissions.group-search-textbox-placeholder": "輸入群組名稱",
  "site-permissions.group.members.load.more.button": "載入更多",
  "site-permissions.guest-access-warning-tooltip.text": "訪客以個人或訪客群組成員的身分取得一個空間的存取權之前，完全無法使用 Confluence。",
  "site-permissions.guest-filter.group-selector.label": "群組中的訪客",
  "site-permissions.guest-filter.group-selector.placeholder": "選取群組",
  "site-permissions.guest-filter.space-selector.label": "此空間的訪客",
  "site-permissions.guest-filter.space-selector.no-search-text": "選取空間",
  "site-permissions.learnMore": "深入了解",
  "site-permissions.manageGroups": "管理群組",
  "site-permissions.name-search-textbox-placeholder": "輸入名稱或電子郵件",
  "site-permissions.permission-table.permission-icon.denied": "權限已遭拒絕",
  "site-permissions.permission-table.permission-icon.granted": "已授予權限",
  "site-permissions.permissions-filter.apply-search-hint": "按 Enter 鍵或按一下搜尋圖示進行搜尋",
  "site-permissions.permissions-filter.confluence-admin": "Confluence 管理員",
  "site-permissions.permissions-filter.create-space": "建立空間",
  "site-permissions.permissions-filter.personal-space": "個人空間",
  "site-permissions.permissions-filter.view-user-profile": "檢視使用者個人檔案",
  "site-permissions.personal-space-dialog.body": "關閉此設定表示該群組未來不會有成員取得個人空間。此選擇不會影響此群組中已擁有個人空間的使用者。",
  "site-permissions.personal-space-dialog.cancel": "取消",
  "site-permissions.personal-space-dialog.header": "是否要停止為新加入此群組的使用者建立個人空間？",
  "site-permissions.personal-space-dialog.save": "儲存",
  "site-permissions.remove-space-access.mutation.failed-message": "請再試一次。如果這種情況持續發生，請試著連絡 {supportLink} 或空間管理員。",
  "site-permissions.remove-space-access.mutation.failed-title": "無法移除空間存取權",
  "site-permissions.remove-space-access.mutation.success-title": "已移除空間存取權",
  "site-permissions.restricted.page.manual.request.access.from.author": "如果您認為您應該有存取權，請嘗試向將您帶往此處的人員尋求協助。",
  "site-permissions.restricted.page.view.title": "這是受限制的頁面",
  "site-permissions.save-error-flag-title": "儲存權限時發生錯誤",
  "site-permissions.save-success-flag-title": "已更新權限",
  "site-permissions.search-textbox-reset-button-caption": "重設文字篩選條件",
  "site-permissions.search-textbox-search-button-caption": "搜尋",
  "site-permissions.space-access.group-selector.no-options-text": "沒有符合搜尋條件的群組",
  "site-permissions.space-access.group-selector.no-search-text": "開始輸入以尋找群組",
  "site-permissions.space-access.learn-more-link-text": "深入了解",
  "site-permissions.space-access.recent-spaces": "建議的空間",
  "site-permissions.space-access.space-selector.change-space-aria-label": "目前的空間 {space}。若要變更，請選取不同的空間",
  "site-permissions.space-access.space-selector.default-placeholder-text": "輸入空間名稱",
  "site-permissions.space-access.space-selector.no-options-text": "沒有符合搜尋條件的空間",
  "site-permissions.space-access.space-selector.no-search-text": "開始輸入以尋找空間",
  "site-permissions.tab-anonymous": "匿名存取",
  "site-permissions.tab-apps": "應用程式",
  "site-permissions.tab-external-guests": "訪客",
  "site-permissions.tab-internal": "使用者群組",
  "site-permissions.tab-jsm": "JSM 存取權",
  "site-permissions.tab-public-links": "公開連結",
  "site-permissions.tab.anonymous.banner.info": "您的組織會避免他人匿名存取此網站。",
  "site-permissions.tab.anonymous.info": "藉由啟用此網站的匿名存取，您或任何空間管理員將可讓匿名使用者 (網際網路上的任何人) 存取此網站上的任何空間。必須在空間設定中完成匿名存取的個別空間啟用。匿名存取不會影響您的授權計數。",
  "site-permissions.tab.anonymous.subtext": "網際網路上的任何人",
  "site-permissions.tab.anonymous.users": "匿名使用者",
  "site-permissions.tab.jsm.info1": "您可以選擇是否允許 Jira Service Management (JSM) 使用者檢視此網站上的內容，即使他們沒有授權也是如此。",
  "site-permissions.tab.jsm.info2": "如果您停用此權限，則只能透過 JSM 再次啟用。",
  "site-permissions.tab.jsm.learnMore": "深入了解",
  "site-permissions.tab.jsm.users": "JSM 使用者",
  "site-permissions.table.checkbox.aria-label": "選取 {name}",
  "site-permissions.table.clear-all-filters.btn.label": "清除所有篩選條件",
  "site-permissions.table.header.apps": "{totalCount, plural, =0 {應用程式} other {應用程式 ({totalCount,number})}}",
  "site-permissions.table.header.assigned-spaces": "指派的空間",
  "site-permissions.table.header.confluence-access.tooltip": "如果沒有指派的空間，訪客完全無法存取 Confluence。",
  "site-permissions.table.header.confluenceAdmin": "Confluence 管理員",
  "site-permissions.table.header.createSpace": "建立空間",
  "site-permissions.table.header.groups": "{totalCount, plural, =0 {群組} other {群組 ({totalCount,number})}}",
  "site-permissions.table.header.guests": "{totalCount, plural, =0 {訪客} other {訪客 ({totalCount,number})}}",
  "site-permissions.table.header.guests-pagination": "{totalCount, plural, =0 {訪客} other {訪客 (第 {first}-{last} 位，總共 {totalCount,number} 位)}}",
  "site-permissions.table.header.guests-pagination-filter": "{totalCount, plural, =0 {訪客} other {訪客 (第 {first}-{last} 位)}}",
  "site-permissions.table.header.personalSpace": "個人空間",
  "site-permissions.table.header.space-access.info.label": "Confluence 存取資訊",
  "site-permissions.table.header.spaceAccess": "Confluence 存取權",
  "site-permissions.table.header.useConfluence": "使用 Confluence",
  "site-permissions.table.header.users": "使用者",
  "site-permissions.table.header.viewUserProfile": "檢視使用者個人檔案",
  "site-permissions.table.manage-guest-users.btn.label": "管理訪客",
  "site-permissions.table.more-filters.btn.label": "更多篩選條件",
  "site-permissions.table.no-space-access.btn.label": "沒有存取權的訪客",
  "site-permissions.table.warning.sys-admin-uneditable": "只有系統管理員可以編輯這些權限",
  "site-permissions.tabs.empty-filter-results-message": "沒有符合搜尋條件的使用者群組",
  "site-permissions.tabs.empty-filter-results-suggestion-app": "如果找不到應用程式，表示該應用程式可能尚未新增至網站",
  "site-permissions.tabs.empty-filter-results-suggestion-group": "如果找不到群組，表示該群組可能尚未新增至網站",
  "site-permissions.tabs.empty-filter.add-app-button-text": "管理應用程式",
  "site-permissions.tabs.empty-filter.add-group-button-text": "新增群組",
  "site-permissions.tabs.external.empty-filter-results-guest-image": "空白篩選條件圖片",
  "site-permissions.tabs.external.empty-filter-results-guest-message": "沒有訪客符合您的搜尋或篩選條件",
  "site-permissions.tabs.external.empty-filter-results-suggestion-guest": "找不到訪客嗎？訪客可能尚未新增到網站。",
  "site-permissions.tabs.no-apps-using-global-permissions-message-header": "這裡看不到任何資料",
  "site-permissions.tabs.no-apps-using-global-permissions-message-text": "您的網站上未安裝任何使用全域權限的應用程式。",
  "site-permissions.title": "全域權限",
  "site-permissions.title.info": "管理不同群組的使用者 (和應用程式) 可以在您的 Confluence 網站上執行的動作。",
  "site-permissions.user-details-view.account-details": "帳號詳細資料",
  "site-permissions.user-details-view.email-address": "電子郵件地址",
  "site-permissions.user-details-view.full-name": "全名",
  "site-permissions.user-details-view.manage-user": "管理使用者",
  "site-permissions.user-details-view.public-name": "公開名稱",
  "site-permissions.usergroup-details-view.back-button.tooltip": "返回「訪客」",
  "site-permissions.usergroup-details-view.breadcrumbs-site-permissions": "網站權限",
  "site-permissions.usergroup-details-view.empty-space-access-list": "{isUser, select, true {此使用者沒有空間存取權} false {這個群組沒有空間存取權} other {其他}}",
  "site-permissions.usergroup-details-view.guest-access": "訪客存取權",
  "site-permissions.usergroup-details-view.space-access": "空間存取權",
  "site-settings.add.application-navigator.error.flag.title": "我們在新增「{name}」時遇到問題，請再試一次",
  "site-settings.add.application-navigator.success.flag.title": "「{name}」已成功新增",
  "site-settings.admin-settings.error": "我們在更新您的設定時遇到問題，請再試一次",
  "site-settings.admin-settings.error.permission": "很抱歉，由於使用者權限不足，無法儲存您的變更",
  "site-settings.admin-settings.error.required": "很抱歉，我們無法儲存您的變更，因為某些必填欄位未填寫完成",
  "site-settings.admin-settings.refresh": "重新整理頁面",
  "site-settings.admin-settings.updated": "設定已更新",
  "site-settings.application-navigator.actions.column.name": "動作",
  "site-settings.application-navigator.add-button.label": "新增",
  "site-settings.application-navigator.add-new-app.label": "新增應用程式",
  "site-settings.application-navigator.cancel-button.label": "取消",
  "site-settings.application-navigator.common.words.displayName": "名稱",
  "site-settings.application-navigator.common.words.hide": "隱藏",
  "site-settings.application-navigator.common.words.url": "URL",
  "site-settings.application-navigator.custom-apps.manage.validation.errors.url": "您必須提供有效的絕對 URL，例如 ‘http://www.atlassian.com’",
  "site-settings.application-navigator.custom-apps.page.description": "應用程式導覽器會出現在標題的左上角，讓使用者可以快速存取其他應用程式。連結的應用程式會在應用程式導覽器中自動設定，您無法刪除這些應用程式。在下方提供目的地的名稱和 URL，即可為使用者新增您自己的連結。",
  "site-settings.application-navigator.custom-apps.select2.formatNoMatches": "找不到相符的群組",
  "site-settings.application-navigator.delete-button.aria-label": "刪除按鈕",
  "site-settings.application-navigator.delete-button.label": "刪除",
  "site-settings.application-navigator.delete.error.flag.title": "我們在刪除 {name} 時遇到問題，請再試一次",
  "site-settings.application-navigator.delete.success.flag.title": "「{name}」已成功刪除",
  "site-settings.application-navigator.drag-icon.label": "拖曳",
  "site-settings.application-navigator.error.bad-request.message": "很抱歉，由於輸入無效，無法啟動應用程式導覽工具的動作。",
  "site-settings.application-navigator.error.flag.title": "我們在更新您的設定時遇到問題，請再試一次",
  "site-settings.application-navigator.error.no-perms.message": "很抱歉，由於使用者權限不足，無法啟動應用程式導覽工具的動作。",
  "site-settings.application-navigator.filter.user.empty": "開始輸入以搜尋群組",
  "site-settings.application-navigator.group-selector.error-flag.description": "請從提供的選項中選取，或重新整理頁面。",
  "site-settings.application-navigator.group-selector.error-flag.title": "抱歉，擷取 Confluence 群組時發生錯誤",
  "site-settings.application-navigator.hide.tooltip": "不要在「更多」區段中顯示。",
  "site-settings.application-navigator.modal.delete.title": "您確定要移除「{name}」嗎？",
  "site-settings.application-navigator.must.not.be.empty.not-final": "不可空白",
  "site-settings.application-navigator.reset-button.label": "重設",
  "site-settings.application-navigator.restricted-to-groups.column.name": "已限制為群組",
  "site-settings.application-navigator.selector.placeholder": "搜尋群組名稱...",
  "site-settings.application-navigator.send-to-trash.header": "傳送到垃圾桶嗎？",
  "site-settings.application-navigator.title": "應用程式導覽器",
  "site-settings.application-navigator.update-button.label": "更新",
  "site-settings.attachment-settings.attachment-max-upload": "每次上傳的附件上限",
  "site-settings.attachment-settings.attachment-maximum-size-byte-unit": "位元組",
  "site-settings.attachment-settings.attachment-maximum-size-label": "附件大小上限",
  "site-settings.attachment-settings.attachment-maximum-size-mebibyte-unit": "MiB",
  "site-settings.attachment-settings.attachment-maximum-size-range-error": "附件的大小必須介於 {min} 和 {max} 之間",
  "site-settings.attachment-settings.attachment-validation-empty": "此欄位為必填欄位",
  "site-settings.attachment-settings.default-message-displayed": "正在顯示預設訊息。",
  "site-settings.attachment-settings.default-size-description": "預設值：10 mb",
  "site-settings.attachment-settings.description": "您可以在<a>附件儲存頁面</a>上設定附件的儲存位置。",
  "site-settings.attachment-settings.error-maximum-num-attachments": "附件數目上限為 {maxAttachments}",
  "site-settings.attachment-settings.error-minimum-num-attachments": "附件數目下限為 {minAttachments}",
  "site-settings.attachment-settings.header": "附件設定",
  "site-settings.attachment-settings.learn-more-link": "<a>深入了解</a>",
  "site-settings.attachment-settings.maximum-size-description": "可讓您為每個上傳至 Confluence 的附件設定大小上限。",
  "site-settings.configuration-site-homepage.company-hub-app-notice": "「公司中心」不再是登陸頁面的選項。我們已將您的登陸頁面設回 Confluence 首頁。",
  "site-settings.configuration-site-homepage.error.cannot-find-space": "很抱歉，我們在伺服器上找不到目前選取的空間。該空間可能已移除或修改。請在此處選取其他空間，或預設為「Confluence 首頁」。",
  "site-settings.configuration-site-homepage.error.generic": "很抱歉，由於一些錯誤，我們無法顯示目前選取的空間。請在此處選取其他空間，或預設為「Confluence 首頁」",
  "site-settings.configuration-site-homepage.error.invalid-data.message": "您的提交發生問題。請檢閱已醒目提示的欄位，並修正任何錯誤，然後再次提交。",
  "site-settings.configuration-site-homepage.error.no-perms.message": "很抱歉，由於使用者權限不足，我們無法擷取所有空間資料。",
  "site-settings.configuration-site-homepage.helpertext": "設定使用者的預設起始位置。",
  "site-settings.configuration-site-homepage.label": "Confluence 登陸頁面",
  "site-settings.configuration-site-homepage.notfound-error": "所選空間無法設定為網站首頁，因為已不存在",
  "site-settings.configuration-site-homepage.permission-error": "{spaceName} 空間必須可供 {groupName} 群組存取 (或必須授予匿名檢視權限)，才能設定為「網站首頁」",
  "site-settings.configuration.admin-editor-full-width-description": "啟用全寬做為新頁面的預設值。",
  "site-settings.configuration.admin-editor-full-width-description-v2": "啟用全寬作為新頁面和即時文件的預設值。",
  "site-settings.configuration.admin-editor-full-width-description.livedocs": "啟用全寬作為新頁面和即時文件的預設值。",
  "site-settings.configuration.admin-editor-full-width-toggle": "編輯器全寬",
  "site-settings.configuration.convertPages-description": "自動轉換所有頁面以完全轉換至新編輯器。<a>進一步了解</a>如何轉換頁面。",
  "site-settings.configuration.critical-failure.description": "請重新整理 Confluence。",
  "site-settings.configuration.critical-failure.title": "發生錯誤",
  "site-settings.configuration.editor-autoconversion-toggle": "自動轉換頁面",
  "site-settings.configuration.email-notification-description": "如果在 Confluence 層級關閉通知，系統就不會針對任何活動傳送電子郵件。使用者將無法開啟通知。",
  "site-settings.configuration.email-notification-header": "電子郵件通知",
  "site-settings.configuration.email-notification-toggle": "電子郵件通知",
  "site-settings.configuration.likes-description": "啟用此功能可讓使用者對頁面、部落格、留言和其他內容按讚/回應。",
  "site-settings.configuration.likes-description-v2": "啟用此功能可讓使用者對頁面、即時文件、部落格、留言和其他內容按讚/回應。",
  "site-settings.configuration.likes-description.livedocs": "啟用此功能可讓使用者對頁面、即時文件、留言和其他內容按讚/回應。",
  "site-settings.configuration.likes-toggle": "按讚/回應",
  "site-settings.configuration.push-notification-description": "如果在 Confluence 層級關閉通知，Confluence 行動應用程式中就不會顯示任何活動的推播通知。使用者將無法開啟通知。",
  "site-settings.configuration.push-notification-header": "推播通知",
  "site-settings.configuration.push-notification-toggle": "推播通知",
  "site-settings.configuration.space-selector-all-spaces-label": "所有空間",
  "site-settings.configuration.space-selector-default-label": "預設",
  "site-settings.configuration.space-selector-default-option-name": "Confluence 首頁",
  "site-settings.configuration.space-selector-generic-error": "擷取空間時發生錯誤。請再試一次。",
  "site-settings.configuration.space-selector-placeholder": "搜尋空間...",
  "site-settings.configuration.space-selector-recent-spaces-label": "最近造訪的空間",
  "site-settings.configuration.space-selector-star-spaces-label": "已標上星號的空間",
  "site-settings.configuration.submit-name": "儲存組態變更",
  "site-settings.configuration.team-presence-description": "開啟之後，查閱者即可查看還有誰在檢視已發布的頁面和部落格貼文。<a>進一步了解頭像可見性</a>",
  "site-settings.configuration.team-presence-toggle": "已發布內容上的頭像",
  "site-settings.configure-code-macro.default-language": "預設語言",
  "site-settings.configure-code-macro.default-theme": "預設主題",
  "site-settings.configure-code-macro.error": "我們在更新您的設定時遇到問題，請再試一次",
  "site-settings.configure-code-macro.help": "此畫面可讓您設定程式碼區塊巨集的預設外觀。",
  "site-settings.configure-code-macro.languages.actionScript": "ActionScript",
  "site-settings.configure-code-macro.languages.appleScript": "AppleScript",
  "site-settings.configure-code-macro.languages.bash": "Bash",
  "site-settings.configure-code-macro.languages.cSharp": "C#",
  "site-settings.configure-code-macro.languages.coldFusion": "ColdFusion",
  "site-settings.configure-code-macro.languages.cpp": "C++",
  "site-settings.configure-code-macro.languages.css": "CSS",
  "site-settings.configure-code-macro.languages.delphi": "Delphi",
  "site-settings.configure-code-macro.languages.diff": "Diff",
  "site-settings.configure-code-macro.languages.erland": "Erlang",
  "site-settings.configure-code-macro.languages.groovy": "Groovy",
  "site-settings.configure-code-macro.languages.jScript": "JavaScript",
  "site-settings.configure-code-macro.languages.java": "Java",
  "site-settings.configure-code-macro.languages.javaFX": "Java FX",
  "site-settings.configure-code-macro.languages.perl": "Perl",
  "site-settings.configure-code-macro.languages.php": "PHP",
  "site-settings.configure-code-macro.languages.plainText": "純文字",
  "site-settings.configure-code-macro.languages.powerShell": "PowerShell",
  "site-settings.configure-code-macro.languages.python": "Python",
  "site-settings.configure-code-macro.languages.ruby": "Ruby",
  "site-settings.configure-code-macro.languages.sass": "Sass",
  "site-settings.configure-code-macro.languages.scala": "Scala",
  "site-settings.configure-code-macro.languages.sql": "SQL",
  "site-settings.configure-code-macro.languages.vb": "Visual Basic",
  "site-settings.configure-code-macro.languages.xml": "HTML 和 XML",
  "site-settings.configure-code-macro.save": "儲存",
  "site-settings.configure-code-macro.successfully-saved": "已成功儲存組態",
  "site-settings.configure-code-macro.themes.confluence": "Confluence",
  "site-settings.configure-code-macro.themes.default": "預設",
  "site-settings.configure-code-macro.themes.django": "Django",
  "site-settings.configure-code-macro.themes.eclipse": "Eclipse",
  "site-settings.configure-code-macro.themes.emacs": "Emacs",
  "site-settings.configure-code-macro.themes.fadeToGrey": "FadeToGrey",
  "site-settings.configure-code-macro.themes.midnight": "Midnight",
  "site-settings.configure-code-macro.themes.rDark": "RDark",
  "site-settings.configure-code-macro.title": "程式碼巨集管理",
  "site-settings.connection-timeouts.header": "連線逾時",
  "site-settings.connection-timeouts.label": "連線逾時 (毫秒)",
  "site-settings.connection-timeouts.socket-timeout-label": "通訊端逾時 (毫秒)",
  "site-settings.connection-timeouts.timeouts-enabled": "已啟用外部連線",
  "site-settings.date-time-format.invalid-pattern": "請輸入有效的時間格式。<a>深入了解</a>",
  "site-settings.default-space-logo.attach-file-message": "選取檔案",
  "site-settings.default-space-logo.button.submit": "設定新標誌",
  "site-settings.default-space-logo.description": "您可以將預設空間標誌取代為您選擇的標誌。為獲得最佳效果，請使用寬度和高度相同的圖片。",
  "site-settings.default-space-logo.disable.success-flag.-title": "已停用自訂預設空間標誌",
  "site-settings.default-space-logo.enable.success-flag.title": "已啟用自訂預設空間標誌",
  "site-settings.default-space-logo.error.logo-not-found.message": "找不到自訂預設空間標誌",
  "site-settings.default-space-logo.error.no-perms.message": "很抱歉，您無法儲存更新的預設空間標誌設定，因為使用者權限不足",
  "site-settings.default-space-logo.error.not-enabled-message": "很抱歉，自訂預設空間標誌功能已停用，也許是由另一位使用者停用。請重新整理此頁面，然後再試一次。",
  "site-settings.default-space-logo.file-input-placeholder": "選取檔案",
  "site-settings.default-space-logo.file-input.upload-done.description": "按一下「設定新標誌」按鈕，以使用自訂預設空間標誌。",
  "site-settings.default-space-logo.file-input.upload-done.title": "{fileName} 上傳成功",
  "site-settings.default-space-logo.file-input.upload-fail.title": "我們在上傳您的自訂標誌檔案時遇到問題，請再試一次",
  "site-settings.default-space-logo.file-view.alt-text": "自訂預設空間標誌",
  "site-settings.default-space-logo.form.required-field": "此欄位為必填欄位",
  "site-settings.default-space-logo.logo-toggle-label": "標誌：",
  "site-settings.default-space-logo.main-query-load.error-flag.title": "我們在載入預設空間標誌設定時遇到問題，請再試一次",
  "site-settings.default-space-logo.media-image-display.error-flag.title": "我們無法顯示您的圖片，請重新整理 Confluence",
  "site-settings.default-space-logo.media-service-load.error-flag.title": "我們在載入影像媒體服務時遇到問題，請再試一次",
  "site-settings.default-space-logo.no-default-space-logo-defined": "目前沒有設定自訂的預設空間標誌。使用預設值。",
  "site-settings.default-space-logo.page-title": "預設空間標誌",
  "site-settings.default-space-logo.reset-default-logo.error-flag.title": "我們在重設預設空間標誌時遇到問題，請再試一次",
  "site-settings.default-space-logo.reset-default-logo.success-flag.title": "已重設預設空間標誌",
  "site-settings.default-space-logo.reset-logo-to-default": "將標誌重設為預設值",
  "site-settings.default-space-logo.set-default-logo.error-flag.title": "我們在設定新自訂的預設空間標誌時遇到問題，請再試一次",
  "site-settings.default-space-logo.set-default-logo.no-file-specified.error-flag.title": "未選取任何自訂標誌檔案。請選取檔案，然後再試一次",
  "site-settings.default-space-logo.set-default-logo.success-flag.title": "已設定新自訂的預設空間標誌",
  "site-settings.default-space-logo.update-enable.error-flag.title": "我們在儲存更新的自訂預設空間標誌設定時遇到問題，請再試一次",
  "site-settings.delete.application-link.error.not-found.message": "找不到應用程式連結。",
  "site-settings.favicon-field.customize-navigation.customization-highlight-message": "從<a>外觀和風格 > 自訂導覽</a>，來自訂導覽標誌和顏色配置。",
  "site-settings.favicon-field.favicon-title": "最愛圖示",
  "site-settings.favicon-field.favicon-title-description": "選擇至少 48 x 48 像素且最高 2MB 的 PNG、JPEG 或 ICO。上傳和儲存後，可能需要重新整理頁面才能顯示瀏覽器圖示。",
  "site-settings.favicon-upload.favicon-alt-text-label": "最愛圖示",
  "site-settings.favicon-upload.remove-custom-favicon-message": "移除自訂的最愛圖示",
  "site-settings.favicon-upload.upload-description-cta": "<p><button>選取要上傳的檔案</button>或拖放到此處</p>",
  "site-settings.favicon-upload.upload-error": "圖片無法上傳 - 請再試一次...",
  "site-settings.favicon-upload.upload-success": "已上傳最愛圖示",
  "site-settings.favicon-upload.uploading-message": "正在上傳...",
  "site-settings.favicon.error-flag.description": "請再試一次",
  "site-settings.favicon.error-flag.title": "錯誤",
  "site-settings.favicon.error.permissions": "遭到禁止",
  "site-settings.favicon.error.server-error": "內部伺服器錯誤",
  "site-settings.formatting-and-international-settings.formatting-description": "這些選項與 Confluence 上的時間和日期格式有關。除非您確實了解您將執行的動作，否則我們建議您讓這些內容維持不變。",
  "site-settings.formatting-and-international-settings.header": "格式設定和國際設定",
  "site-settings.general-config.confluence-title.description": "可讓您指定要顯示在瀏覽器標題列上的 Confluence 標題。",
  "site-settings.general-config.confluence-title.label": "Confluence 標題",
  "site-settings.general-config.confluence-title.toggle": "在導覽列上顯示此標題",
  "site-settings.general-config.confluence-title.warning.title-too-long-message": "網站標題必須少於 40 個字元",
  "site-settings.general-config.contact-admin.default-prompt": "請輸入要提供給網站管理員的要求相關資訊。如果您要回報錯誤，請務必包含問題發生時您正在執行的作業和時間資訊。",
  "site-settings.general-config.contact-admin.form": "連絡管理員表單",
  "site-settings.general-config.contact-admin.form-checkbox-label": "連絡管理員表單",
  "site-settings.general-config.contact-admin.form-description": "嘗試連絡 Confluence 管理員時，顯示連絡表單。僅在有自訂連絡人管理員訊息時，才能關閉此表單。",
  "site-settings.general-config.contact-admin.form-error": "如果關閉「連絡管理員表單」，則必須設定「自訂連絡管理員訊息」。",
  "site-settings.general-config.contact-admin.message": "連絡管理員訊息",
  "site-settings.general-config.contact-admin.message-description": "可讓您設定使用者嘗試連絡 Confluence 管理員時顯示的訊息。此內容應使用 Wiki 標記輸入。{br}若未定義訊息，則會顯示預設訊息。",
  "site-settings.general-config.contact-admin.message-format-hint": "提示：您可使用 wiki 標記將此欄位格式化。",
  "site-settings.general-config.site-title-default": "預設：Confluence",
  "site-settings.general-config.subtitle": "Confluence 設定",
  "site-settings.general-config.title": "一般組態",
  "site-settings.global-language.default": "全域預設語言",
  "site-settings.global-language.desc": "只有在使用者的瀏覽器未將語言傳送至 Confluence，或者在將 confluence.browser.language.enabled 屬性設為 False 來關閉語言偵測功能時，才會影響使用者。",
  "site-settings.global-language.in-development-desc": "此功能目前處於開發階段。<a>深入了解</a>",
  "site-settings.global-language.submit": "儲存全域預設語言的變更",
  "site-settings.global-language.subtitle": "設定此 Confluence 執行個體的預設語言。",
  "site-settings.global-language.title": "國際化",
  "site-settings.header-and-footer.button.reset": "捨棄變更",
  "site-settings.header-and-footer.button.submit": "儲存",
  "site-settings.header-and-footer.custom-page-content-description": "自訂 Confluence 中所有頁面的外觀。使用 <a>Wiki 標記</a>來新增文字、連結、巨集和影像 (從 Web 或附加至空間中的頁面)。",
  "site-settings.header-and-footer.custom-page-content-description-v2": "自訂 Confluence 中所有頁面和即時文件的外觀。使用 <a>Wiki 標記</a>來新增文字、連結、巨集和圖片 (從 Web 或附加至空間中的頁面或即時文件)。",
  "site-settings.header-and-footer.custom-page-content-description.livedocs": "自訂 Confluence 中所有頁面和即時文件的外觀。使用 <a>Wiki 標記</a>來新增文字、連結、巨集和圖片 (從 Web 或附加至空間中的內容)。",
  "site-settings.header-and-footer.error.flag.title": "我們在儲存更新的標頭和頁尾時遇到一些問題，請再試一次",
  "site-settings.header-and-footer.error.no-perms.message": "很抱歉，由於使用者權限不足，無法儲存更新的標頭和頁尾。",
  "site-settings.header-and-footer.flag-success-title": "頁首和頁尾已更新",
  "site-settings.header-and-footer.footer.label": "頁尾",
  "site-settings.header-and-footer.header.label": "頁首",
  "site-settings.header-and-footer.page-title": "頁首和頁尾",
  "site-settings.import-spaces.critical-failure.description": "請重新整理 Confluence。",
  "site-settings.import-spaces.critical-failure.title": "發生錯誤",
  "site-settings.import-spaces.file-input-desc": "只能匯入空間匯出檔案。",
  "site-settings.import-spaces.file-input-label": "空間匯出檔案",
  "site-settings.import-spaces.import-failure-title": "匯入期間發生錯誤。參閱下方以取得詳細資訊。",
  "site-settings.import-spaces.import-form-in-progress-title": "正在匯入中...",
  "site-settings.import-spaces.import-form.failure.generic": "匯入期間發生錯誤。",
  "site-settings.import-spaces.import-form.failure.media-id-missing": "媒體檔案 ID 不能空白。",
  "site-settings.import-spaces.import-form.failure.permissions": "很抱歉，由於使用者權限不足，無法上傳。",
  "site-settings.import-spaces.import-form.failure.server-error": "我們這端發生錯誤，請再試一次。",
  "site-settings.import-spaces.import-form.file-input.placeholder": "選取檔案",
  "site-settings.import-spaces.import-form.file-input.upload-done-desc": "按一下「匯入」按鈕以繼續進行空間匯入。",
  "site-settings.import-spaces.import-form.file-input.upload-done-title": "{fileName} 上傳成功",
  "site-settings.import-spaces.import-form.file-input.upload-fail-title": "我們在上傳您的空間匯出檔案時遇到問題，請再試一次",
  "site-settings.import-spaces.import-form.required-field": "此欄位為必填欄位",
  "site-settings.import-spaces.import-form.success.actions.jiramacrorepair": "前往 Jira 巨集修復",
  "site-settings.import-spaces.import-form.success.description": "您可以匯入另一個空間，或是在匯入所有空間後，檢查是否有損壞的 Jira 巨集。",
  "site-settings.import-spaces.import-form.success.title": "已成功匯入",
  "site-settings.import-spaces.import-form.title": "匯入空間匯出檔案",
  "site-settings.import-spaces.import-tip.cloud.desc1": "如果您要從另一個 Confluence Cloud 網站移動空間，請使用此頁面中包含的<a>空間匯入</a>。",
  "site-settings.import-spaces.import-tip.cloud.title": "從 Confluence Cloud 匯入",
  "site-settings.import-spaces.import-tip.notes.title": "開始匯入前，請注意：",
  "site-settings.import-spaces.import-tip.server.desc1": "如果您要從 Confluence Server 移轉到 Confluence Cloud，請使用 <a>Cloud Migration Assistant for Confluence</a>。此應用程式將協助您從伺服器執行個體，將資料輕鬆移轉到 Confluence Cloud。",
  "site-settings.import-spaces.import-tip.server.desc2": "若要匯入空間，請確定您使用的是 Confluence Server 或 Data Center 6.15 以上版本。然後，請在<b>匯入空間匯出檔案</b>下方選取<a>匯出的空間檔案</a>，然後選取<b>匯入</b>。",
  "site-settings.import-spaces.import-tip.server.desc3": "如果您使用的是 Server 或 Data Center 6.14 以下版本，請升級至 Confluence Server 或 Data Center 6.15，或聯繫 Atlassian 支援，了解如何將您的空間移到雲端。不過，若要獲得更穩定可靠的移轉體驗，請使用 Confluence Cloud Migration Assistant 來移轉您的空間。",
  "site-settings.import-spaces.import-tip.server.title": "從 Confluence Server 匯入",
  "site-settings.import-spaces.notes.note1": "為了讓您可以搜尋資料，匯入 Confluence 空間會觸發網站索引重製。這可能需要一些時間，在此過程中，使用者可能會感受到效能比平常更慢。",
  "site-settings.import-spaces.notes.note2": "我們無法匯入白板。在此空間中匯入的白板不會保留其內容、版面配置或功能。",
  "site-settings.import-spaces.page-title": "匯入 Confluence 空間",
  "site-settings.import-spaces.project-input-desc": "選擇您要連結此空間的目的地雲端專案 (如果有的話)。",
  "site-settings.import-spaces.project-input-label": "連結至雲端專案",
  "site-settings.import-spaces.project-input-none": "無",
  "site-settings.import-spaces.submit-button-title": "匯入",
  "site-settings.indexing-language.confirmation.cancel": "取消",
  "site-settings.indexing-language.confirmation.description": "Confluence 中的所有內容都會重新建立索引，這可能需要幾分鐘至幾小時的時間。此動作無法復原。",
  "site-settings.indexing-language.confirmation.submit": "變更語言",
  "site-settings.indexing-language.confirmation.title": "要變更索引語言嗎？",
  "site-settings.indexing-language.description": "如果您 Confluence 的大部分內容都使用英文以外的某種語言，您可以透過變更索引語言來改善索引支援。Confluence 除了英文 (預設) 之外，還提供德文、俄文、中文、CJK (中日韓統一表意文字)、法文、巴西文、捷克文和希臘文的內容索引支援。",
  "site-settings.indexing-language.error.conflict": "已在建立索引",
  "site-settings.indexing-language.error.emptyLanguage": "語言不能空白",
  "site-settings.indexing-language.error.noperms": "很抱歉，由於使用者權限不足，無法啟動索引",
  "site-settings.indexing-language.in-progress.bar-label": "已完成 {percentage}%",
  "site-settings.indexing-language.in-progress.description1": "視您的內容而定，這可能需要幾分鐘至幾小時的時間。",
  "site-settings.indexing-language.in-progress.description2": "在完成之前，您無法再次變更索引語言，但仍然可以配置此頁面上的其他設定。",
  "site-settings.indexing-language.in-progress.error": "變更索引語言時發生錯誤。請再試一次，或連絡 <a>Atlassian 支援人員</a>尋求協助。",
  "site-settings.indexing-language.in-progress.title": "將索引語言變更為 {lang} 的動作已完成 {percentage}%",
  "site-settings.indexing-language.label": "索引編製語言",
  "site-settings.indexing-language.language.CJK": "CJK",
  "site-settings.indexing-language.language.brazilian": "巴西語",
  "site-settings.indexing-language.language.chinese": "中文",
  "site-settings.indexing-language.language.custom-japanese": "自訂日文",
  "site-settings.indexing-language.language.czech": "捷克文",
  "site-settings.indexing-language.language.english": "英文",
  "site-settings.indexing-language.language.french": "法文",
  "site-settings.indexing-language.language.german": "德文",
  "site-settings.indexing-language.language.greek": "希臘文",
  "site-settings.indexing-language.language.other": "其他",
  "site-settings.indexing-language.language.russian": "俄文",
  "site-settings.indexing-language.notstarted": "無法開始索引",
  "site-settings.indexing-language.started": "索引語言已啟動",
  "site-settings.indexing-language.submit": "儲存索引語言的變更",
  "site-settings.jira-macro-repair.action.description": "「JIRA 巨集修復」會在您的執行個體上找到並修正任何損壞的 JIRA 巨集。如果有損壞的連結，我們會通知您、確認您的 JIRA 執行個體，並修正這些連結。<br/></br>如果您不打算修正巨集，您可以選擇<strong>略過巨集修復</strong>。如果您改變主意，可以隨時回到此畫面並執行 JIRA 巨集修復。",
  "site-settings.jira-macro-repair.appLink.selection-error": "請選取正確的應用程式連結或略過對應。",
  "site-settings.jira-macro-repair.done.description": "已成功修正您執行個體上的所有損壞 Jira 議題巨集。",
  "site-settings.jira-macro-repair.done.title": "皆已完成",
  "site-settings.jira-macro-repair.error-description": "請重新整理頁面，然後再試一次。",
  "site-settings.jira-macro-repair.error-status.title": "錯誤",
  "site-settings.jira-macro-repair.error-title": "發生錯誤",
  "site-settings.jira-macro-repair.failure.permissions": "很抱歉，由於使用者權限不足，無法啟動 Jira 巨集修復。",
  "site-settings.jira-macro-repair.failure.server-error": "我們這端發生錯誤，請再試一次。",
  "site-settings.jira-macro-repair.fix-dialog.cancel-button-label": "取消",
  "site-settings.jira-macro-repair.fix-dialog.col1-header-title": "現有的 Jira 執行個體連結",
  "site-settings.jira-macro-repair.fix-dialog.col2-header-title": "新的 Jira 執行個體連結",
  "site-settings.jira-macro-repair.fix-dialog.default-option-label": "選取應用程式連結",
  "site-settings.jira-macro-repair.fix-dialog.desc": "請讓我們知道與您舊執行個體對應的新執行個體有哪些，以便我們更新 Jira 連結。",
  "site-settings.jira-macro-repair.fix-dialog.note": "<strong>請注意：</strong>在您完成此步驟之前，損壞的巨集將無法正常運作。",
  "site-settings.jira-macro-repair.fix-dialog.submit-button-title": "完成",
  "site-settings.jira-macro-repair.fix-dialog.title": "選擇 Jira 執行個體連結",
  "site-settings.jira-macro-repair.fix.btn.title": "按一下此處以修正",
  "site-settings.jira-macro-repair.intermediate-progress-bar.label": "Jira 巨集修復進度條中間狀態",
  "site-settings.jira-macro-repair.no-app-links.btn.title": "連結 Jira 執行個體",
  "site-settings.jira-macro-repair.no-app-links.description": "您的 Confluence 執行個體中有 Jira 巨集，但並未連結到 Jira 執行個體。請連結執行個體，讓這些巨集可以運作。",
  "site-settings.jira-macro-repair.no-app-links.dismiss.btn.title": "關閉",
  "site-settings.jira-macro-repair.page-title": "JIRA 巨集修復",
  "site-settings.jira-macro-repair.reset.btn.title": "重設",
  "site-settings.jira-macro-repair.skip.btn.title": "略過巨集修復",
  "site-settings.jira-macro-repair.start.btn.title": "開始",
  "site-settings.jira-macro-repair.success-progress-bar.label": "Jira 巨集修復進度條成功狀態",
  "site-settings.jira-macro-repair.wait-for-config.description": "我們在您的執行個體上發現了一些損壞的 Jira 議題巨集。",
  "site-settings.jira-macro-repair.wait-for-config.title": "正在等待設定",
  "site-settings.macro-usage.query-error.description": "請重新整理 Confluence。",
  "site-settings.macro-usage.query-error.title": "擷取巨集時發生錯誤",
  "site-settings.macro-usage.title": "巨集使用情形",
  "site-settings.macro-usage.unused-macros.found-message": "下列巨集是由使用者安裝的應用程式提供，並未在任何內容上使用 (不包括封存空間中的項目)。如果您即將停用或移除應用程式，並且需要確定未使用該應用程式，這項資訊會很有幫助。",
  "site-settings.macro-usage.unused-macros.no-items": "好消息！使用者安裝的應用程式提供的所有巨集至少在一個內容上使用。您可以在下方列表中檢查每個巨集的使用頻率。",
  "site-settings.macro-usage.unused-macros.table-header": "應用程式名稱",
  "site-settings.macro-usage.unused-macros.title": "未使用的巨集",
  "site-settings.macro-usage.used-macros.description": "此列表顯示每個巨集在您網站中的使用頻率。我們按照提供巨集的應用程式整理列表，並包含使用者安裝的應用程式和 Confluence 隨附的應用程式。",
  "site-settings.macro-usage.used-macros.no-items": "您的網站上未使用任何巨集。在團隊開始建立內容並新增巨集後，您就能夠在此查看每個巨集的使用頻率。",
  "site-settings.macro-usage.used-macros.table-header-app-name": "應用程式名稱",
  "site-settings.macro-usage.used-macros.table-header-page-count": "內容項目的數量",
  "site-settings.macro-usage.used-macros.title": "所有巨集",
  "site-settings.media-service.failure.description": "請重新整理 Confluence",
  "site-settings.media-service.failure.title": "發生錯誤",
  "site-settings.pdf-export.button.reset": "捨棄變更",
  "site-settings.pdf-export.button.submit": "儲存",
  "site-settings.pdf-export.critical-failure.description": "我們無法擷取頁面資料。請重新整理 Confluence。",
  "site-settings.pdf-export.critical-failure.title": "發生錯誤",
  "site-settings.pdf-export.error.bad-request.message": "部分欄位可能包含錯誤資料，很可能是輸入了錯誤的 URL。",
  "site-settings.pdf-export.error.no-perms.message": "很抱歉，由於使用者權限不足，無法啟動該動作。",
  "site-settings.pdf-export.flag-error-title": "我們在更新您的設定時遇到問題，請再試一次",
  "site-settings.pdf-export.flag-success-title": "已更新全域 PDF 匯出欄位。",
  "site-settings.pdf-export.footer.placeholder": "按一下即可開始套用頁尾。",
  "site-settings.pdf-export.header.placeholder": "按一下即可開始套用標頭。",
  "site-settings.pdf-export.info-message": "我們最新版本的匯出功能改善了匯出的呈現方式，但不支援 PDF 樣式表中的 @頁面標記 (搭配@右上、@右下等屬性)，或是空間或網站設定頁首/頁尾/標題中的 HTML。如果您的內容具有這些自訂項目，或者您的管理員已啟用 IP 允許列表，Confluence 將使用舊版本的功能匯出。請觀看我們的<a>匯出功能進度，以查看未來更新</a>。",
  "site-settings.pdf-export.page-title": "全域 PDF 匯出",
  "site-settings.pdf-export.pdf-config.footer-label": "頁尾",
  "site-settings.pdf-export.pdf-config.header-label": "頁首",
  "site-settings.pdf-export.pdf-config.stylesheet-label": "PDF 樣式表",
  "site-settings.pdf-export.pdf-config.title-label": "標題",
  "site-settings.pdf-export.stylesheet.helper.text": "<a>了解可套用至 PDF 樣式表的預設 CSS 規則和覆寫內容。</a>",
  "site-settings.pdf-export.stylesheet.placeholder": "按一下即可開始變更外觀和風格。",
  "site-settings.pdf-export.title.placeholder": "按一下即可開始套用標題頁面。",
  "site-settings.pdf-export.warning-message": "由於有瀏覽器呈現標準的增強功能，某些 @page 屬性可能會以不同方式顯示。這可能需要調整現有的 CSS，以確保與新型瀏覽器相容。<a>請檢閱我們的支援指南，</a>以獲得最佳結果。",
  "site-settings.security-config.attachment-security-level": "附件下載安全性政策",
  "site-settings.security-config.attachment-security-level.option-insecure": "不安全：顯示所有內嵌附件。",
  "site-settings.security-config.attachment-security-level.option-secure": "安全：提示使用者下載所有附件類型和所有瀏覽器的附件。",
  "site-settings.security-config.attachment-security-level.option-smart": "預設：根據附件類型和瀏覽器設定，自動顯示內嵌附件或提示下載。這在大多數環境中都是安全的。",
  "site-settings.security-config.auth-basic-config-button-enable": "啟用",
  "site-settings.security-config.elevatedsecurity.label": "已加強安全性檢查",
  "site-settings.security-config.elevatedsecurity.use.captcha": "在登入時啟用驗證碼",
  "site-settings.security-config.error": "我們在更新您的安全性設定時遇到問題，請再試一次",
  "site-settings.security-config.error.login-elevatedsecurity-loginAttemptsThreshold-outofrange": "登入嘗試次數必須等於或大於 1。",
  "site-settings.security-config.hide-external-links-description": "此設定可防止搜尋引擎追蹤網站，進而阻止垃圾郵件發送者張貼惡意連結。",
  "site-settings.security-config.hide-links-from-search-engines": "向搜尋引擎隱藏外部連結",
  "site-settings.security-config.login-elevatedsecurity-loginAttemptsThreshold-form": "允許的驗證嘗試上限",
  "site-settings.security-config.max-loginAttemptsThreshold.invalid": "登入嘗試次數必須小於或等於 2,147,483,647。",
  "site-settings.security-config.more-about-external-links": "<a>深入了解外部連結</a>",
  "site-settings.security-config.page-render-max-time": "頁面逾時",
  "site-settings.security-config.page-render-max-time-description": "轉譯每個 Wiki 頁面內容的允許時間 (以秒為單位)。轉譯時間較長的頁面會向使用者顯示逾時錯誤。預設值為 120 秒。",
  "site-settings.security-config.page-render-max-time-invalid": "頁面逾時必須是大於 0 的整數秒數。",
  "site-settings.security-config.page-render-max-time.overflow.invalid": "頁面逾時必須是小於或等於 2,147,483,647 的整數秒數。",
  "site-settings.security-config.remote-api-anonymous-access": "匿名存取遠端 API",
  "site-settings.security-config.remote-api-anonymous-access-description": "啟用此功能將允許以「匿名」方式，從遠端存取 Confluence。",
  "site-settings.security-config.rss-max-items": "RSS 項目上限",
  "site-settings.security-config.rss-max-items.description": "限制 RSS 摘要可要求的項目數量上限。",
  "site-settings.security-config.rss-max-items.max.invalid": "RSS 項目的數目上限必須少於或等於 2,147,483,647 個項目。",
  "site-settings.security-config.rss-max-items.min.invalid": "RSS 項目的數目上限必須大於 0 個項目。",
  "site-settings.security-config.rss-max-time": "RSS 逾時",
  "site-settings.security-config.rss-max-time.description": "建立每個 RSS 摘要的時間上限 (以秒為單位)。在逾時內呈現的任何項目仍會傳回。",
  "site-settings.security-config.rss-max-time.invalid": "RSS 逾時必須是大於 0 的整數秒數。",
  "site-settings.security-config.rss-max-time.overflow.invalid": "RSS 逾時必須是小於或等於 2,147,483,647 的整數秒數。",
  "site-settings.security-config.seconds": "秒",
  "site-settings.security-config.security-and-privacy-subtitle": "安全性與隱私",
  "site-settings.security-config.submit.name": "儲存",
  "site-settings.security-config.title": "安全性組態",
  "site-settings.security-config.title.description": "網站安全性和使用者隱私的設定。",
  "site-settings.security-config.updated": "安全性設定已更新",
  "site-settings.security-config.users-addwildcards": "將萬用字元附加至使用者和群組搜尋內容",
  "site-settings.security-config.xsrf.addComments": "新增留言",
  "site-settings.security-config.xsrf.addComments.description": "這會在新增留言時移除自動 xsrf 檢查。 只有在您要使用不支援此功能的舊版主題時，才關閉此選項。",
  "site-settings.security-config.xsrf.description": "某些協力廠商或已淘汰的 Confluence 主題將無法與新的 Confluence XSRF 防護搭配使用。您可以停用 XSRF 防護以支援舊版主題，但會降低安全性。如果您關閉任何設定，Confluence 網站將遭受 XSRF 攻擊。這表示攻擊者只要按一下連結，即可欺騙任何 Confluence 使用者提交資料。",
  "site-settings.security-config.xsrf.subtitle": "XSRF 防護",
  "site-settings.space.reports.actions.column": "動作",
  "site-settings.space.reports.anonymous": "匿名",
  "site-settings.space.reports.create.report": "建立報告",
  "site-settings.space.reports.created.by.column": "建立者",
  "site-settings.space.reports.created.column": "已建立",
  "site-settings.space.reports.download.action": "下載",
  "site-settings.space.reports.empty.table.heading": "此期間沒有建立任何報告",
  "site-settings.space.reports.error.flag.description": "請再試一次。",
  "site-settings.space.reports.error.flag.title": "我們無法建立您的報告",
  "site-settings.space.reports.in.progress": "正在建立報告...",
  "site-settings.space.reports.in.progress.flag.description": "請稍候幾分鐘，等待報告完成。",
  "site-settings.space.reports.in.progress.flag.title": "我們已在建立報告",
  "site-settings.space.reports.page.description": "空間報告包含 Confluence 中每個空間的相關資訊，例如上次處於作用中的時間，以及使用了多少儲存空間。建立報告以透過 CSV 試算表查看這項資料。",
  "site-settings.space.reports.page.heading": "空間報告",
  "site-settings.space.reports.page.sub.heading": "過去 7 天的報告",
  "site-settings.space.reports.page.sub.heading.description": "只能顯示 25 份報告",
  "site-settings.space.reports.success.flag.description": "這可能需要幾分鐘的時間。",
  "site-settings.space.reports.success.flag.title": "我們正在建立您的報告",
  "site-settings.templates-and-blueprints.1-on-1-meeting.blueprint.title": "一對一會議",
  "site-settings.templates-and-blueprints.4-ls-retrospective.blueprint.title": "4 L 回顧",
  "site-settings.templates-and-blueprints.5-whys-analysis.blueprint.title": "5 個原因分析",
  "site-settings.templates-and-blueprints.90-day-plan.blueprint.title": "90 天計畫",
  "site-settings.templates-and-blueprints.account-planning-for-sales.blueprint.title": "銷售客戶規劃",
  "site-settings.templates-and-blueprints.action-add-label": "新增全域範本",
  "site-settings.templates-and-blueprints.add-description-button-label": "新增描述",
  "site-settings.templates-and-blueprints.add-template-description-title": "新增範本描述",
  "site-settings.templates-and-blueprints.all-hands-meeting.blueprint.title": "全員會議",
  "site-settings.templates-and-blueprints.annual-plan-one-pager.blueprint.description": "在整個組織中共用貴公司的年度計畫和優先要務。",
  "site-settings.templates-and-blueprints.annual-plan-one-pager.blueprint.title": "年度計畫單頁說明",
  "site-settings.templates-and-blueprints.aws-architecture-diagram.blueprint.title": "AWS 架構圖",
  "site-settings.templates-and-blueprints.brainstorming-with-remote-teams.blueprint.title": "腦力激盪",
  "site-settings.templates-and-blueprints.business-plan-one-pager.blueprint.title": "商業計畫單頁資料",
  "site-settings.templates-and-blueprints.business-status-update.blueprint.title": "業務狀態更新",
  "site-settings.templates-and-blueprints.business-strategy.blueprint.title": "策略性計畫",
  "site-settings.templates-and-blueprints.calendar3.spacecalendars.blueprint.key": "Team Calendars 藍圖",
  "site-settings.templates-and-blueprints.cancel-button-label": "取消",
  "site-settings.templates-and-blueprints.capacity.planning.blueprint.description": "請確認您的團隊擁有足夠時間完成最重要的工作。",
  "site-settings.templates-and-blueprints.capacity.planning.blueprint.title": "產能規劃藍圖",
  "site-settings.templates-and-blueprints.career-development-plan.blueprint.title": "生涯發展計畫",
  "site-settings.templates-and-blueprints.change-management-plan.blueprint.title": "變更管理計畫",
  "site-settings.templates-and-blueprints.column-label.actions": "動作",
  "site-settings.templates-and-blueprints.column-label.description": "描述",
  "site-settings.templates-and-blueprints.column-label.last-updated-by": "上次更新者",
  "site-settings.templates-and-blueprints.column-label.title": "標題",
  "site-settings.templates-and-blueprints.column-label.updated": "更新時間",
  "site-settings.templates-and-blueprints.competitive.analysis.blueprint.name": "競爭分析藍圖",
  "site-settings.templates-and-blueprints.content-design-glossary.blueprint.title": "內容設計詞彙",
  "site-settings.templates-and-blueprints.content-strategy.blueprint.title": "內容策略",
  "site-settings.templates-and-blueprints.corporate-bylaws.blueprint.title": "公司章程",
  "site-settings.templates-and-blueprints.create.content.plugin.plugin.global.templates": "全域藍圖",
  "site-settings.templates-and-blueprints.create.content.plugin.plugin.templates.blueprints-more-info": "什麼是藍圖？",
  "site-settings.templates-and-blueprints.creative-brief.blueprint.title": "創意簡報",
  "site-settings.templates-and-blueprints.customer-impact-assessment.blueprint.title": "客戶影響評估",
  "site-settings.templates-and-blueprints.customer-journey-mapping.blueprint.title": "客戶旅程對應",
  "site-settings.templates-and-blueprints.customer.interview.report.blueprint.name": "客戶拜訪報告藍圖",
  "site-settings.templates-and-blueprints.daily-stand-up.blueprint.description": "讓您的團隊瞭解每個人每天在做的事情。",
  "site-settings.templates-and-blueprints.daily-stand-up.blueprint.title": "每日站立會議範本",
  "site-settings.templates-and-blueprints.decisions.blueprint.name": "DACI：決策說明文件",
  "site-settings.templates-and-blueprints.default.space.content.configuration": "預設空間內容",
  "site-settings.templates-and-blueprints.delete-button-label": "刪除",
  "site-settings.templates-and-blueprints.delete-global-template.error.empty.message": "全域頁面範本不能空白。",
  "site-settings.templates-and-blueprints.delete-global-template.error.no-perms.message": "很抱歉，由於使用者權限不足，無法啟動全域範本動作。",
  "site-settings.templates-and-blueprints.delete-global-template.error.not-found.message": "找不到全域範本。",
  "site-settings.templates-and-blueprints.delete-space-template.error.empty.message": "空間預設範本不能空白。",
  "site-settings.templates-and-blueprints.delete-space-template.error.no-perms.message": "很抱歉，由於使用者權限不足，無法啟動空間範本動作。",
  "site-settings.templates-and-blueprints.delete-template-success-flag-title": "「{templateTitle}」已成功刪除",
  "site-settings.templates-and-blueprints.delete-template.error.flag.title": "我們在刪除 {templateTitle} 時遇到問題，請再試一次",
  "site-settings.templates-and-blueprints.dependency-mapping.blueprint.title": "相依性對應",
  "site-settings.templates-and-blueprints.design-component.blueprint.title": "設計元件",
  "site-settings.templates-and-blueprints.design-decision.blueprint.title": "設計決策",
  "site-settings.templates-and-blueprints.design-review.blueprint.title": "設計檢討",
  "site-settings.templates-and-blueprints.design-sprint.blueprint.description": "透過設計和測試，建立用於回答重要業務問題的架構。",
  "site-settings.templates-and-blueprints.design-sprint.blueprint.title": "設計衝刺",
  "site-settings.templates-and-blueprints.design-systems.blueprint.title": "設計系統",
  "site-settings.templates-and-blueprints.devops-change-management.blueprint.title": "DevOps 變更管理",
  "site-settings.templates-and-blueprints.devops-runbook.blueprint.title": "DevOps 標準執行程序",
  "site-settings.templates-and-blueprints.disable-blueprint.error.flag.title": "我們在停用 {blueprintTitle} 時遇到問題，請再試一次。",
  "site-settings.templates-and-blueprints.disable-template.success.flag.title": "{blueprintTitle} 已成功停用",
  "site-settings.templates-and-blueprints.disrupt-brainstorming.blueprint.title": "顛覆性腦力激盪",
  "site-settings.templates-and-blueprints.edit-button-label": "編輯",
  "site-settings.templates-and-blueprints.edit-description-button-label": "編輯描述",
  "site-settings.templates-and-blueprints.edit-description-dialog-placeholder": "輸入範本的描述 (最多 100 個字元)",
  "site-settings.templates-and-blueprints.edit-template-description-dialog-title": "編輯範本描述",
  "site-settings.templates-and-blueprints.edit-template-description.error.message": "您已超過字元數上限。",
  "site-settings.templates-and-blueprints.edit-template-description.textarea.title": "附註 (選擇性)",
  "site-settings.templates-and-blueprints.elevator-pitch.blueprint.title": "電梯簡報",
  "site-settings.templates-and-blueprints.email-drip.blueprint.description": "讓電子郵件涓滴行銷活動的詳細資料保持井然有序，並且讓您的團隊清楚了解結果。",
  "site-settings.templates-and-blueprints.email-drip.blueprint.title": "電子郵件涓滴行銷活動",
  "site-settings.templates-and-blueprints.employee-handbook.blueprint.description": "建立指南，讓員工可以找到公司政策、福利資訊等。",
  "site-settings.templates-and-blueprints.employee-handbook.blueprint.title": "員工手冊",
  "site-settings.templates-and-blueprints.employee-promotion-letter.blueprint.description": "建立正式的晉升信函，祝賀您的員工。",
  "site-settings.templates-and-blueprints.employee-promotion-letter.blueprint.title": "員工晉升信函",
  "site-settings.templates-and-blueprints.enable-blueprint.error.flag.title": "我們在啟用 {blueprintTitle} 時遇到問題，請再試一次。",
  "site-settings.templates-and-blueprints.enable-blueprint.success.flag.title": "{blueprintTitle} 已成功啟用",
  "site-settings.templates-and-blueprints.eow-status-report.blueprint.title": "週末狀態報告",
  "site-settings.templates-and-blueprints.executive-business-review.blueprint.description": "擷取高階業務績效並向主要利害關係人呈現。",
  "site-settings.templates-and-blueprints.executive-business-review.blueprint.title": "管理階層業務檢討",
  "site-settings.templates-and-blueprints.experiment-planning-and-results.blueprint.title": "實驗規劃",
  "site-settings.templates-and-blueprints.file.list.blueprint.description": "上傳和預覽檔案，以及與團隊共用檔案。",
  "site-settings.templates-and-blueprints.file.list.blueprint.title": "檔案清單藍圖",
  "site-settings.templates-and-blueprints.fundraising-database.blueprint.title": "募資資料庫",
  "site-settings.templates-and-blueprints.generic.template.text": "未命名藍圖",
  "site-settings.templates-and-blueprints.global-header": "全域範本和藍圖",
  "site-settings.templates-and-blueprints.gsm.blueprint.title": "GSM 藍圖",
  "site-settings.templates-and-blueprints.header": "全域範本",
  "site-settings.templates-and-blueprints.help-tips": "說明提示",
  "site-settings.templates-and-blueprints.help-tips-summary": "範本是預先定義的頁面，可在網站中作為原型使用。此畫面會顯示目前為網站定義的範本。您可以新增範本或編輯現有範本。",
  "site-settings.templates-and-blueprints.help-tips-summary-v2": "範本是預先定義的頁面和即時文件，可在網站中作為原型使用。此畫面會顯示目前為網站定義的範本。您可以新增範本或編輯現有範本。",
  "site-settings.templates-and-blueprints.help-tips-summary.livedocs": "範本是預先定義的頁面和即時文件，可在網站中作為原型使用。此畫面會顯示目前為網站定義的範本。您可以新增範本或編輯現有範本。",
  "site-settings.templates-and-blueprints.hiring-process.blueprint.description": "開發重複性的招聘流程，使招聘變得更輕鬆。",
  "site-settings.templates-and-blueprints.hiring-process.blueprint.title": "招聘流程",
  "site-settings.templates-and-blueprints.how-to-blueprint.name": "操作說明藍圖",
  "site-settings.templates-and-blueprints.hr-knowledge-base-management.blueprint.title": "人力資源知識庫管理",
  "site-settings.templates-and-blueprints.ideal-workweek.blueprint.title": "設計理想的工作週",
  "site-settings.templates-and-blueprints.ideas.blueprint.title": "構想",
  "site-settings.templates-and-blueprints.incident-communication.blueprint.title": "事件通訊",
  "site-settings.templates-and-blueprints.interview-feedback.blueprint.title": "面試意見反應",
  "site-settings.templates-and-blueprints.introductory-blog.blueprint.title": "簡介部落格",
  "site-settings.templates-and-blueprints.invoice.blueprint.title": "發票",
  "site-settings.templates-and-blueprints.it.project.poster.blueprint.name": "IT 專案海報",
  "site-settings.templates-and-blueprints.itsm-change-management.blueprint.title": "ITSM 變更管理",
  "site-settings.templates-and-blueprints.itsm-known-errors.blueprint.title": "ITSM 已知錯誤",
  "site-settings.templates-and-blueprints.itsm-pir.blueprint.description": "使用我們的範本來探索根本原因並整理事件時間軸，以便回顧檢討事件。",
  "site-settings.templates-and-blueprints.itsm-pir.blueprint.title": "ITSM 事件回顧檢討",
  "site-settings.templates-and-blueprints.itsm-runbook.blueprint.title": "ITSM Runbook",
  "site-settings.templates-and-blueprints.itsm-weekly-major-incident-report.blueprint.title": "ITSM 每週重大事件報告",
  "site-settings.templates-and-blueprints.jirareports.blueprint.title": "JIRA 報告藍圖",
  "site-settings.templates-and-blueprints.job-description.blueprint.title": "工作說明",
  "site-settings.templates-and-blueprints.job-offer-letter.blueprint.title": "錄取通知",
  "site-settings.templates-and-blueprints.leadership-team-health-monitor.blueprint.title": "領導團隊 Health Monitor",
  "site-settings.templates-and-blueprints.marketing-united.blueprint.title": "聯合行銷",
  "site-settings.templates-and-blueprints.marketing.blog.post.blueprint.name": "行銷部落格貼文藍圖",
  "site-settings.templates-and-blueprints.marketing.blueprint.title": "行銷計畫藍圖",
  "site-settings.templates-and-blueprints.marketing.campaign.blueprint.name": "行銷活動藍圖",
  "site-settings.templates-and-blueprints.master-project-document.blueprint.title": "主要專案說明文件",
  "site-settings.templates-and-blueprints.meeting.notes.blueprint.title": "會議筆記藍圖",
  "site-settings.templates-and-blueprints.message.house.blueprint.name": "訊息屋藍圖",
  "site-settings.templates-and-blueprints.more-about-link-label": "進一步了解全域範本",
  "site-settings.templates-and-blueprints.mutual-action-plan.blueprint.title": "共同行動計劃",
  "site-settings.templates-and-blueprints.mvp-ideation.blueprint.title": "「最低可行產品」構想",
  "site-settings.templates-and-blueprints.my.user.manual.blueprint.name": "我的使用者手冊藍圖",
  "site-settings.templates-and-blueprints.no-blueprints-message": "目前沒有藍圖。",
  "site-settings.templates-and-blueprints.no-global-templates": "目前沒有全域範本。",
  "site-settings.templates-and-blueprints.no-system-templates-message": "目前沒有系統範本。",
  "site-settings.templates-and-blueprints.non-disclosure-agreement.blueprint.title": "保密協議",
  "site-settings.templates-and-blueprints.okr.blueprint.title": "目標與關鍵成果 (OKR) 藍圖",
  "site-settings.templates-and-blueprints.ooo-team-notification.blueprint.title": "OOO 團隊通知",
  "site-settings.templates-and-blueprints.out-of-office-plan.blueprint.title": "休假計畫",
  "site-settings.templates-and-blueprints.performance-improvement-plan.blueprint.title": "績效改善計畫",
  "site-settings.templates-and-blueprints.persona.blueprint.title": "角色計畫藍圖",
  "site-settings.templates-and-blueprints.pp.blueprint.description": "使用此範本來定義問題、提出解決方案並準備好執行。",
  "site-settings.templates-and-blueprints.pp.blueprint.name": "專案海報",
  "site-settings.templates-and-blueprints.pre-mortem.blueprint.title": "事前剖析 (Premortem)",
  "site-settings.templates-and-blueprints.presenter-mode.blueprint.title": "簡報者模式",
  "site-settings.templates-and-blueprints.prioritization-matrix.blueprint.title": "優先順序對照表",
  "site-settings.templates-and-blueprints.problem-framing.blueprint.title": "建構問題框架",
  "site-settings.templates-and-blueprints.product-roadmap.blueprint.description": "擷取您團隊的高階產品藍圖。",
  "site-settings.templates-and-blueprints.product-roadmap.blueprint.title": "產品藍圖",
  "site-settings.templates-and-blueprints.productlaunch.blueprint.title": "產品推出藍圖",
  "site-settings.templates-and-blueprints.project-kickoff.blueprint.title": "專案啟動",
  "site-settings.templates-and-blueprints.project-status.blueprint.title": "專案狀態",
  "site-settings.templates-and-blueprints.project-team-health-monitor.blueprint.title": "專案團隊運作狀態監控",
  "site-settings.templates-and-blueprints.project.task.report.blueprint.title": "專案任務報告藍圖",
  "site-settings.templates-and-blueprints.projectplan.blueprint.name": "專案計畫藍圖",
  "site-settings.templates-and-blueprints.qtc-acquisition.blueprint.title": "「報價到現金」收購",
  "site-settings.templates-and-blueprints.quarterly-check-in.blueprint.title": "季度檢查",
  "site-settings.templates-and-blueprints.recurring-meeting-minutes.blueprint.title": "每週會議記錄",
  "site-settings.templates-and-blueprints.remote-team-meeting.blueprint.title": "遠端團隊會議",
  "site-settings.templates-and-blueprints.remove-template-confirm": "移除",
  "site-settings.templates-and-blueprints.remove-template-message": "您確定要移除範本「{title}」嗎？",
  "site-settings.templates-and-blueprints.remove-template-modal-title": "傳送到垃圾桶嗎？",
  "site-settings.templates-and-blueprints.requirements.blueprint.title": "產品需求藍圖",
  "site-settings.templates-and-blueprints.reset-template-error-flag-title": "我們在重設 {templateTitle} 時遇到問題，請再試一次",
  "site-settings.templates-and-blueprints.reset-template-success-flag-title": "{templateTitle} 已成功重設",
  "site-settings.templates-and-blueprints.reset-to-default-message": "重設為預設值",
  "site-settings.templates-and-blueprints.retrospectives.blueprint.title": "回顧藍圖",
  "site-settings.templates-and-blueprints.risk-assessment.blueprint.title": "風險評估對照表",
  "site-settings.templates-and-blueprints.ritual-reset.blueprint.title": "重設儀式",
  "site-settings.templates-and-blueprints.roles-responsibilities.blueprint.title": "角色和責任案例",
  "site-settings.templates-and-blueprints.safe-business-case.blueprint.description": "根據 SAFe 敏捷作法，為您的項目組合大型工作建立精實商務案例。",
  "site-settings.templates-and-blueprints.safe-business-case.blueprint.title": "SAFe 精實商務案例",
  "site-settings.templates-and-blueprints.sales-portal-template.blueprint.title": "銷售入口網站",
  "site-settings.templates-and-blueprints.save-button-label": "儲存",
  "site-settings.templates-and-blueprints.service-team-health-monitor.blueprint.title": "服務團隊運作狀態監控",
  "site-settings.templates-and-blueprints.sharelinks.blueprint.title": "分享連結藍圖",
  "site-settings.templates-and-blueprints.smart-goals.blueprint.title": "SMART 目標",
  "site-settings.templates-and-blueprints.software-architecture-review.blueprint.description": "收集資訊、提供資訊給利害關係人，並開始您的軟體架構檢討。",
  "site-settings.templates-and-blueprints.software-architecture-review.blueprint.title": "軟體架構檢討",
  "site-settings.templates-and-blueprints.spacecontent.plugin.content.personal.name": "預設個人空間內容",
  "site-settings.templates-and-blueprints.sparring.blueprint.title": "唇槍舌戰",
  "site-settings.templates-and-blueprints.sprint-planning-meeting.blueprint.title": "衝刺規劃會議",
  "site-settings.templates-and-blueprints.stakeholder.communications.blueprint.title": "相關人員溝通藍圖",
  "site-settings.templates-and-blueprints.startup-pitch-deck.blueprint.title": "新創公司簡報",
  "site-settings.templates-and-blueprints.swot-analysis.blueprint.title": "SWOT 分析",
  "site-settings.templates-and-blueprints.system-templates.header": "系統範本",
  "site-settings.templates-and-blueprints.systemtemplate.welcome.message": "預設歡迎訊息",
  "site-settings.templates-and-blueprints.task.report.blueprint.title": "任務報告藍圖",
  "site-settings.templates-and-blueprints.team-homepage.blueprint.title": "團隊首頁",
  "site-settings.templates-and-blueprints.team-poster.blueprint.title": "團隊海報",
  "site-settings.templates-and-blueprints.team.task.report.blueprint.title": "團隊任務報告藍圖",
  "site-settings.templates-and-blueprints.template.button.label": "轉換",
  "site-settings.templates-and-blueprints.template.edited.label": "(已編輯)",
  "site-settings.templates-and-blueprints.template.sample-pages.title": "範例頁面",
  "site-settings.templates-and-blueprints.templates.incident-postmortem.incident-postmortem": "事件事後分析",
  "site-settings.templates-and-blueprints.to-do-list.blueprint.name": "待辦事項清單",
  "site-settings.templates-and-blueprints.toggle.tooltip": "啟用/停用藍圖",
  "site-settings.templates-and-blueprints.transition-plan.blueprint.title": "轉換計畫",
  "site-settings.templates-and-blueprints.troubleshooting-blueprint.name": "疑難排解藍圖",
  "site-settings.templates-and-blueprints.update-template-description.error.flag.title": "我們在更新 {templateTitle} 的描述時遇到問題，請再試一次。",
  "site-settings.templates-and-blueprints.update-template-description.placeholder": "為您的範本提供描述",
  "site-settings.templates-and-blueprints.update-template-description.success.flag.title": "{templateTitle} 的描述已成功更新",
  "site-settings.templates-and-blueprints.using-the-editor.blueprint.title": "使用編輯器",
  "site-settings.templates-and-blueprints.vendor-agreement.blueprint.title": "供應商合約",
  "site-settings.templates-and-blueprints.virtual-event.blueprint.title": "虛擬事件",
  "site-settings.templates-and-blueprints.virtual-lunch.blueprint.title": "虛擬團隊午餐",
  "site-settings.templates-and-blueprints.vision-to-values.blueprint.title": "從願景到創造價值",
  "site-settings.templates-and-blueprints.voting-table.blueprint.title": "投票表格",
  "site-settings.templates-and-blueprints.work-life-impact.blueprint.description": "掌握「工作生活影響」劇目中的輸出、動作和機會。",
  "site-settings.templates-and-blueprints.work-life-impact.blueprint.title": "工作生活影響",
  "site-settings.templates-and-blueprints.work-trip-planner.blueprint.description": "持續追蹤您所有的出差計畫及活動",
  "site-settings.templates-and-blueprints.work-trip-planner.blueprint.title": "出差規畫工具",
  "site-settings.templates-and-blueprints.working-agreements.blueprint.title": "工作協議",
  "site-settings.templates-and-blueprints.workshop-planner.blueprint.description": "與您的團隊一起籌劃並開辦即時協作研討會。",
  "site-settings.templates-and-blueprints.workshop-planner.blueprint.title": "實作課程規劃人員",
  "site-settings.templates-and-blueprints.writing-guideline.blueprint.description": "建立撰寫指南，讓團隊和產品之間的訊息傳遞保持一致。",
  "site-settings.templates-and-blueprints.writing-guideline.blueprint.title": "撰寫指南",
  "site-settings.templates-and-blueprints.year-in-review.blueprint.title": "年度回顧",
  "site-settings.themes.critical-failure.description": "請重新整理 Confluence。",
  "site-settings.themes.critical-failure.title": "發生錯誤",
  "site-settings.themes.current-theme-desc": "目前主題可控制此空間的版面配置和顏色。",
  "site-settings.themes.current-theme-title": "目前主題",
  "site-settings.themes.default-theme-title": "預設主題",
  "site-settings.themes.description": "主題是可自訂網站外觀的 Confluence 外掛程式模組。",
  "site-settings.themes.description.text.1": "如果您選取主題，則在該主題中定義的任何色彩或頁面配置都會套用到整個 Confluence 網站。",
  "site-settings.themes.flag-error-title": "我們在更新您的設定時遇到問題，請再試一次",
  "site-settings.themes.flag-success-title": "設定已更新",
  "site-settings.themes.global-theme-default-desc": "這是 Confluence 原本的外觀和風格。內容會延展到整個螢幕寬度。",
  "site-settings.themes.help-tip-3": "如果您沒有選取主題，系統會套用預設的外觀和風格，或是您可以透過色彩配置和版面配置自訂功能，手動自訂網站的外觀。",
  "site-settings.themes.help-tip-5": "進一步了解主題",
  "site-settings.themes.new-theme-title": "選擇新主題",
  "site-settings.themes.no-theme-desc": "如果您已安裝主題外掛程式，請確定其已正確放置在應用程式伺服器的 Classpath 中，而且其主題模組已在外掛程式組態中啟用。",
  "site-settings.themes.no-theme-title": "找不到任何主題。",
  "site-settings.themes.page-title": "網站主題",
  "site-settings.themes.space-admins-can-select-different-theme": "空間管理員可以為其空間選取不同的主題。",
  "site-settings.themes.submit": "變更主題",
  "site-settings.themes.table-header-details": "詳細資料",
  "site-settings.themes.table-header-empty-state": "沒有可用的主題。",
  "site-settings.themes.table-header-icon": "圖示",
  "site-settings.themes.theme-select-desc": "若要變更此 Confluence 網站的預設主題，請選取下列其中一個選項：",
  "site-settings.time-format.date-format-description": "日期格式。",
  "site-settings.time-format.date-label": "日期格式",
  "site-settings.time-format.date-time-format-description": "日期和時間的格式。",
  "site-settings.time-format.date-time-label": "日期時間格式",
  "site-settings.time-format.decimal-number-format-description": "小數數字的格式。",
  "site-settings.time-format.decimal-number-format-label": "長小數格式",
  "site-settings.time-format.long-number-format-description": "長數字的格式。",
  "site-settings.time-format.long-number-format-label": "長數字格式",
  "site-settings.time-format.time-format-description": "時間格式。",
  "site-settings.time-format.time-label": "時間格式",
  "site-settings.trashed-spaces.confirmation-cancel": "取消",
  "site-settings.trashed-spaces.confirmation-ok": "確定",
  "site-settings.trashed-spaces.description": "從下表中的「動作」欄中刪除或復原空間。在垃圾桶中超過 60 天的空間將自動刪除。",
  "site-settings.trashed-spaces.empty": "目前垃圾桶中沒有空間。",
  "site-settings.trashed-spaces.error-description": "請重新整理頁面，然後再試一次。",
  "site-settings.trashed-spaces.error-description.polling": "刪除流程可能仍在進行中，但我們目前無法接收其狀態。請重新整理頁面以確認是否已成功完成。",
  "site-settings.trashed-spaces.error-title": "發生錯誤",
  "site-settings.trashed-spaces.hard-delete.confirmation-message": "從垃圾桶刪除此空間後永遠無法復原。{br}{br}視您的空間大小而定，這可能需要數小時的時間。",
  "site-settings.trashed-spaces.hard-delete.confirmation-submit": "刪除此空間",
  "site-settings.trashed-spaces.hard-delete.confirmation-title": "您確定嗎？",
  "site-settings.trashed-spaces.hard-delete.progress": "刪除中…",
  "site-settings.trashed-spaces.hard-delete.progress.title": "正在刪除 {spaceName}",
  "site-settings.trashed-spaces.hard-delete.success-title": "{spaceName} 已成功刪除",
  "site-settings.trashed-spaces.moved-to-trash-date": "{timeAgo}，編輯者：{displayName}",
  "site-settings.trashed-spaces.restore.confirmation-message": "<b>{spaceName} 空間</b>及其所有內容將復原至 Confluence。",
  "site-settings.trashed-spaces.restore.success-title": "{spaceName} 已成功復原",
  "site-settings.trashed-spaces.restore.title": "要復原這個空間嗎？",
  "site-settings.trashed-spaces.table.action-permanently-delete": "永久刪除",
  "site-settings.trashed-spaces.table.action-restore": "復原空間",
  "site-settings.trashed-spaces.table.header.action": "動作",
  "site-settings.trashed-spaces.table.header.moved-to-trash-date": "移至垃圾桶的時間",
  "site-settings.trashed-spaces.table.header.permanent-delete-date": "永久刪除",
  "site-settings.trashed-spaces.table.header.space-name": "空間名稱",
  "site-settings.trashed-spaces.table.header.system-space-key": "系統空間索引鍵",
  "site-settings.trashed-spaces.table.not-applicable": "不適用",
  "site-settings.trashed-spaces.table.permanent-delete-date": "{daysLeft} 天後",
  "site-settings.trashed-spaces.table.permanent-delete-date.one-day-left": "明天",
  "site-settings.trashed-spaces.table.permanent-delete-date.today": "今天",
  "site-settings.trashed-spaces.title": "已丟棄的空間",
  "site-settings.update-order.application-navigator.success.flag.title": "自訂應用程式順序已成功更新",
  "site-settings.update.application-navigator.error.flag.title": "我們在更新 {name} 時遇到問題，請再試一次",
  "site-settings.update.application-navigator.success.flag.title": "已成功更新 {name}",
  "site-settings.user-access.avatar.description": "選擇使用者或群組",
  "site-settings.user-access.content-item.label": "內容項目",
  "site-settings.user-access.content-item.selector.placeholder": "選擇內容項目",
  "site-settings.user-access.content.selector.generic.error": "擷取內容項目時發生錯誤。請再試一次。",
  "site-settings.user-access.description": "針對群組或使用者可以在 Confluence 中存取的項目，取得概觀檢視。",
  "site-settings.user-access.dialog.show-full-page-tree.toggle": "顯示所有層級",
  "site-settings.user-access.error-flag.description": "請重新整理頁面，然後再試一次",
  "site-settings.user-access.error-flag.title": "發生錯誤",
  "site-settings.user-access.error.cannot-find-content": "很抱歉，我們在伺服器上找不到目前選取的內容項目。該內容項目可能已被移除或修改。",
  "site-settings.user-access.error.no-perms.message": "很抱歉，由於使用者權限不足，我們無法擷取所有權限資料。",
  "site-settings.user-access.footer.feedback.button": "提供意見反應",
  "site-settings.user-access.footer.feedback.text": "請讓我們知道您對於在 Confluence 中管理使用者存取的看法。",
  "site-settings.user-access.group.label": "群組",
  "site-settings.user-access.help.link.label": "說明",
  "site-settings.user-access.no-groups.message": "請選取特定使用者，以檢查特定內容項目的權限。",
  "site-settings.user-access.no-groups.title": "檢查權限不適用於群組",
  "site-settings.user-access.permission.label": "權限",
  "site-settings.user-access.permissions-report.error.no-perms.message": "抱歉，由於使用者權限不足，無法產生權限報告。",
  "site-settings.user-access.permissions-report.error.timeout.message": "抱歉，產生權限報告的要求已逾時。請再試一次。",
  "site-settings.user-access.permissions-report.server-error.message": "我們這端發生錯誤，請再試一次。",
  "site-settings.user-access.report.button": "下載空間權限報告 (.CSV)",
  "site-settings.user-access.report.comment": "這可能需要一段時間。請保持此分頁開啟，直到下載作業完成。",
  "site-settings.user-access.report.description": "檢視他們具檢視和管理權限的空間列表",
  "site-settings.user-access.report.header": "所有空間存取權",
  "site-settings.user-access.satisfaction-survey.cancel": "取消",
  "site-settings.user-access.satisfaction-survey.checkbox.can-contact": "是的，Atlassian 團隊可以與我聯繫，詢問我的使用體驗，以便改善 Atlassian 產品和服務。我同意 <a>Atlassian 隱私政策</a>。",
  "site-settings.user-access.satisfaction-survey.confirmation.description": "感謝您協助我們改善 Confluence！",
  "site-settings.user-access.satisfaction-survey.confirmation.title": "已提交意見反應",
  "site-settings.user-access.satisfaction-survey.description": "在 Confluence 中管理使用者存取是否有任何可以改進的地方？",
  "site-settings.user-access.satisfaction-survey.question": "在 Confluence 中管理使用者存取是否有任何可以改進的地方？",
  "site-settings.user-access.satisfaction-survey.submit": "提交",
  "site-settings.user-access.satisfaction-survey.title": "告訴我們您的想法",
  "site-settings.user-access.specific-content.description": "檢查特定內容項目的權限",
  "site-settings.user-access.specific-content.header": "特定內容",
  "site-settings.user-access.title": "使用者存取權",
  "site-settings.user-access.user-or-group.label": "使用者或群組",
  "site-settings.user-access.user-or-group.selector.no-matches": "找不到相符的使用者或群組",
  "site-settings.user-access.user-or-group.selector.placeholder": "搜尋使用者或群組",
  "site-settings.user-access.user.label": "使用者",
  "site-settings.user-access.view-and-comment-option": "可以檢視和發表留言",
  "site-settings.user-access.view-and-edit-option": "可以檢視和編輯",
  "site-settings.user-access.view-option": "可以檢視",
  "space-404.text.go.back.previous.page": "前往上一頁",
  "space-access-details.access-details-dialog.clear-filter": "清除選取內容",
  "space-access-details.access-details-dialog.count-of-groups": "{countOfGroups, plural, other {搜尋 {countOfGroups,number} 個群組}}",
  "space-access-details.access-details-dialog.count-of-groups-and-individuals-suffix": "{countOfIndividuals, plural, other {和 {countOfIndividuals,number} 位個人}}",
  "space-access-details.access-details-dialog.count-of-individuals": "{countOfIndividuals, plural, other {搜尋 {countOfIndividuals,number} 位個人}}",
  "space-access-details.access-details-dialog.restricting-page-header": "誰可以存取父系項目",
  "space-access-details.access-details-dialog.restricting-space-header": "誰可以存取這個空間",
  "space-access-details.access-details-table.header.principal": "{count, plural, other {{count,number} 個人}}",
  "space-directory.all-spaces": "所有空間",
  "space-directory.delete-dialog.body": "刪除此空間後永遠無法復原。",
  "space-directory.delete-dialog.cancel": "取消",
  "space-directory.delete-dialog.confirm": "刪除此空間",
  "space-directory.delete-dialog.header": "您確定嗎？",
  "space-directory.error.message": "我們在載入空間時遇到問題。請嘗試立即重新整理。",
  "space-directory.filters.all": "全部",
  "space-directory.filters.archived": "已封存",
  "space-directory.filters.communal": "公共",
  "space-directory.filters.labels.all-categories": "所有類別",
  "space-directory.filters.labels.aria-labelledby.text": "按類別篩選",
  "space-directory.filters.personal.v2": "個人",
  "space-directory.filters.search.aria-describedby.text": "當您輸入時，空間將在下方進行篩選",
  "space-directory.filters.search.icon": "搜尋",
  "space-directory.filters.search.label": "依標題篩選",
  "space-directory.filters.starred": "已標上星號",
  "space-directory.filters.trashed": "已丟棄",
  "space-directory.filters.watching": "追蹤",
  "space-directory.not.found.alt.text": "破裂的放大鏡",
  "space-directory.not.found.subtext": "沒有與您的篩選條件相符的空間。請使用較少的篩選條件再試一次。",
  "space-directory.not.found.title": "我們找不到任何空間",
  "space-directory.recent-spaces-section.empty": "建立或檢視空間之後，空間會出現在此處。",
  "space-directory.recent-spaces-section.empty.no.create": "您檢視過的空間會出現在這裡。",
  "space-directory.recent-spaces-section.empty.unlicensed": "前 10 個公開空間會出現在此處。",
  "space-directory.recent-spaces-section.error": "擷取空間時發生錯誤",
  "space-directory.recent-spaces-section.error.message": "我們目前無法顯示任何空間。請重新整理或稍後再試一次。",
  "space-directory.recent-spaces-section.error.title": "無法載入空間",
  "space-directory.recent-spaces-section.header": "您的空間",
  "space-directory.recent-spaces-section.show.less": "顯示較少",
  "space-directory.recent-spaces-section.show.more": "顯示更多",
  "space-directory.space.delete.may-take-a-long-time": "根據您的空間大小，這可能需要數小時的時間。",
  "space-directory.space.delete.progress": "刪除中…",
  "space-directory.space.delete.progress.title": "正在刪除空間",
  "space-directory.space.delete.success-title": "空間已成功刪除",
  "space-directory.space.menu": "更多動作",
  "space-directory.space.restore.error-description": "請重新整理，然後再試一次。",
  "space-directory.space.restore.error-title": "發生錯誤",
  "space-directory.space.settings.link": "空間設定",
  "space-directory.title": "空間",
  "space-directory.trash.go-to-settings": "前往設定",
  "space-directory.trash.message": "您可以從 Confluence 設定中永久刪除或復原丟棄的空間。",
  "space-guest-list.external-collaborator-message.error": "擷取訪客時發生錯誤。",
  "space-guest-list.external-collaborator-message.guest-context": "訪客是組織外部的人。",
  "space-guest-list.external-collaborator-message.guest-count": "{guestCount, plural, =0 {沒有訪客} other {有 {guestCount,number} 位訪客}}",
  "space-guest-list.external-collaborator-message.navigation.guests-access-to-space": "{guestCallToAction}在這個空間中",
  "space-guest-list.external-collaborator-message.page.guests-access-to-page": "{guestCallToAction} 可以存取。",
  "space-guest-list.external-collaborator-message.page.guests-access-to-page-cta": "{guests} 可以存取。{callToAction}",
  "space-guest-list.external-collaborator-message.space.guests-access-to-space": "{guestCount, plural, other {{guestCallToAction} 可存取這個空間。}}",
  "space-guest-list.external-collaborator-message.view-guest-action": "{guestCount, plural, other {檢視訪客}}",
  "space-guest-list.external-collaborators-dialog.confirm-button": "確定",
  "space-guest-list.external-collaborators-dialog.current-space.description": "此空間會與訪客共用，這些訪客只能存取選取的空間，而且使用者資訊的存取方式有所限制。",
  "space-guest-list.external-collaborators-dialog.header": "{count, plural, other {此空間中的 {count,number} 位訪客}}",
  "space-guest-list.external-collaborators-dialog.learn-more-button": "深入了解",
  "space-guest-list.external-collaborators-dialog.review-permissions-button": "檢閱權限",
  "space-guest-list.external-collaborators-single-space-dialog.current-space.description": "此空間會與訪客共用，這些訪客只能存取單一空間，而且只能存取部分的使用者資訊。",
  "space-guest-list.external-collaborators-single-space-dialog.description": "{count, plural, other {「{spaceName}」空間已與 {count,number} 位訪客共用，這些訪客只能在單一空間中協作，而且對於使用者資訊的存取權會受到限制。}}",
  "space-guest-list.space-external-list-scrollable.failed-load": "無法載入。請重新整理。",
  "space-guest-list.space-external-list-scrollable.load-more-button": "載入更多",
  "space-guest-list.view-external-collaborators-list.link": "檢視清單",
  "space-manager.empty-table.active-space.body": "空間建立後會顯示在這裡",
  "space-manager.empty-table.active-space.title": "沒有作用中的空間",
  "space-manager.empty-table.archived-spaces.body": "空間封存後會顯示在這裡",
  "space-manager.empty-table.archived-spaces.title": "沒有已封存的空間",
  "space-manager.empty-table.general.body": "移除所有篩選條件，或以較籠統的內容搜尋",
  "space-manager.empty-table.general.title": "沒有任何項目符合您的搜尋條件",
  "space-manager.empty-table.trashed-spaces.body": "空間會在垃圾桶中保留 60 天，然後就會永久刪除",
  "space-manager.empty-table.trashed-spaces.title": "沒有已丟棄的空間",
  "space-manager.filters.dropdown.options.community-spaces": "團隊和專案空間",
  "space-manager.filters.dropdown.options.personal-spaces": "個人空間",
  "space-manager.filters.dropdown.options.reset": "重設篩選條件",
  "space-manager.filters.dropdown.title": "篩選條件",
  "space-manager.filters.pill-buttons.active": "作用中",
  "space-manager.filters.pill-buttons.archived": "已封存",
  "space-manager.filters.pill-buttons.trashed": "已丟棄",
  "space-manager.heading": "空間",
  "space-manager.modal.close-button-text": "關閉",
  "space-manager.modal.cta-text": "檢視所有群組",
  "space-manager.modal.disabled-state-base-card.enabled-icon-label": "已停用的圖示",
  "space-manager.modal.enabled-state-base-card.enabled-icon-label": "已啟用的圖示",
  "space-manager.modal.error.description": "請重新整理頁面。如果持續發生問題，請<a>連絡支援人員</a>。",
  "space-manager.modal.error.title": "載入錯誤",
  "space-manager.modal.error.title.icon-label": "錯誤圖示",
  "space-manager.modal.manage-group-text": "管理群組",
  "space-manager.modal.pagination.next-page": "下一頁",
  "space-manager.modal.pagination.page-range": "第 {start}-{end} 項結果",
  "space-manager.modal.pagination.page-range-limited": "所有結果的第 {start}-{end} 項 (最多 {limit} 項)",
  "space-manager.modal.pagination.previous-page": "上一頁",
  "space-manager.quick-actions.button.archive": "封存空間",
  "space-manager.quick-actions.button.change-owner": "變更負責人",
  "space-manager.quick-actions.button.copy-permissions": "從另一個空間複製權限",
  "space-manager.quick-actions.button.delete": "將空間傳送至垃圾桶",
  "space-manager.quick-actions.button.delete-space": "永久刪除空間",
  "space-manager.quick-actions.button.edit-space-key": "編輯空間索引鍵",
  "space-manager.quick-actions.button.restore-space": "還原空間",
  "space-manager.quick-actions.link.space-settings": "空間設定",
  "space-manager.quick-actions.menu-item.restrictions": "您不能對此空間採取特定動作。",
  "space-manager.quick-actions.menu.aria-label": "快速動作",
  "space-manager.quick-actions.modal.archive.body": "封存空間會將其從基本網站導覽中隱藏，進而降低畫面的雜亂感，讓使用者能更輕鬆找到最新和相關的內容。如果之後有需要，您隨時都能夠尋找已封存的空間，而且可以隨時還原該空間。",
  "space-manager.quick-actions.modal.archive.save-button": "封存",
  "space-manager.quick-actions.modal.archive.title": "封存空間",
  "space-manager.quick-actions.modal.cancel-button": "取消",
  "space-manager.quick-actions.modal.change-owner.body": "負責人",
  "space-manager.quick-actions.modal.change-owner.button": "變更負責人",
  "space-manager.quick-actions.modal.change-owner.description": "負責人也會被設定為這個空間的管理員 (如果還沒設定的話)。",
  "space-manager.quick-actions.modal.change-owner.no-owner-selected": "空間負責人不能空白",
  "space-manager.quick-actions.modal.change-owner.placeholder": "輸入使用者或群組名稱",
  "space-manager.quick-actions.modal.change-owner.selector": "找不到相符的使用者或群組",
  "space-manager.quick-actions.modal.change-owner.title": "變更負責人",
  "space-manager.quick-actions.modal.copy-permissions.body": "您即將從另一個空間複製權限。此空間的權限將覆寫空間上的所有權限。此動作無法復原。",
  "space-manager.quick-actions.modal.copy-permissions.save-button": "複製權限",
  "space-manager.quick-actions.modal.copy-permissions.source-space.placeholder": "選擇空間",
  "space-manager.quick-actions.modal.copy-permissions.title": "從另一個空間複製權限",
  "space-manager.quick-actions.modal.delete.body": "如果將此空間丟到垃圾桶，空間裡的所有內容也會一起送到垃圾桶。放在垃圾桶超過 60 天的空間將被永久刪除。",
  "space-manager.quick-actions.modal.delete.save-button": "丟到垃圾桶",
  "space-manager.quick-actions.modal.delete.title": "將空間傳送至垃圾桶",
  "space-manager.quick-actions.modal.edit-space-key.body": "空間索引鍵不能重複。{br}{br}如果原始空間已刪除並從垃圾桶中清除，只有不同的空間可以重新使用其空間索引鍵。",
  "space-manager.quick-actions.modal.edit-space-key.button": "提交",
  "space-manager.quick-actions.modal.edit-space-key.label": "空間索引鍵",
  "space-manager.quick-actions.modal.edit-space-key.title": "編輯空間索引鍵",
  "space-manager.quick-actions.modal.edit-space-key.validation.blank": "空間索引鍵不能空白",
  "space-manager.quick-actions.modal.edit-space-key.validation.length": "空間索引鍵必須在 255 個字元以內",
  "space-manager.quick-actions.modal.edit-space-key.validation.symbols": "空間索引鍵只能是數字和字母",
  "space-manager.quick-actions.modal.hard-delete.body": "從垃圾桶刪除此空間後永遠無法復原。{br}{br}視您的空間大小而定，這可能需要數小時的時間。",
  "space-manager.quick-actions.modal.hard-delete.save-button": "刪除此空間",
  "space-manager.quick-actions.modal.hard-delete.title": "您確定嗎？",
  "space-manager.quick-actions.modal.restore-archived.body": "此空間已封存。您目前無法在基本網站導覽和搜尋中看到此空間與其內容。<link>深入了解</link>{br}{br}復原此空間以回到作用中狀態。",
  "space-manager.quick-actions.modal.restore-archived.save-button": "復原",
  "space-manager.quick-actions.modal.restore-archived.title": "復原此空間",
  "space-manager.quick-actions.modal.restore-deleted.body": "此空間及其所有內容將復原至 Confluence。",
  "space-manager.quick-actions.modal.restore-deleted.save-button": "復原",
  "space-manager.quick-actions.modal.restore-deleted.title": "還原空間",
  "space-manager.search.label": "搜尋",
  "space-manager.sort.tooltip.description.ascending": "從 A 到 Z 排序",
  "space-manager.sort.tooltip.description.descending": "從 Z 到 A 排序",
  "space-manager.space-mutation.archive.flag.success.link": "在封存中檢視",
  "space-manager.space-mutation.archive.flag.success.title": "已傳送至封存",
  "space-manager.space-mutation.change-owner.flag.success.description": "所有權已轉移給 {displayName}",
  "space-manager.space-mutation.change-owner.flag.success.title": "空間負責人已更新",
  "space-manager.space-mutation.copy-space-perms.flag.success.message": "您的空間現在正使用 {spaceName} 空間的權限",
  "space-manager.space-mutation.copy-space-perms.flag.success.title": "已複製空間權限",
  "space-manager.space-mutation.edit-space-key.flag.success.title": "已編輯空間索引鍵",
  "space-manager.space-mutation.flag.error.description": "請重新整理頁面，然後再試一次。",
  "space-manager.space-mutation.flag.error.description.alias-fails.uniqueness": "為此空間選擇唯一的索引鍵。",
  "space-manager.space-mutation.flag.error.title": "發生錯誤",
  "space-manager.space-mutation.flag.error.title.alias-fails.uniqueness": "空間索引鍵已經在使用中",
  "space-manager.space-mutation.hard-delete.flag.progress.bar": "刪除中…",
  "space-manager.space-mutation.hard-delete.flag.progress.title": "正在刪除空間",
  "space-manager.space-mutation.hard-delete.flag.success.title": "空間已成功刪除",
  "space-manager.space-mutation.restore.flag.success.title": "{spaceName} 已成功復原",
  "space-manager.space-mutation.soft-delete.flag.success.link": "在垃圾桶中檢視",
  "space-manager.space-mutation.soft-delete.flag.success.title": "已傳送到垃圾桶",
  "space-manager.table.cell.last-viewed.just-now": "剛才",
  "space-manager.table.cell.last-viewed.tooltip": "{days, plural, =0 {{date} (今天)} other {{date} ({days,number} 天前)}}",
  "space-manager.table.cell.not-applicable.text": "不適用",
  "space-manager.table.column.header.created-by": "建立者",
  "space-manager.table.column.header.last-viewed": "上次檢視",
  "space-manager.table.column.header.moved-to-trash": "移至垃圾桶的時間",
  "space-manager.table.column.header.owned-by": "負責人",
  "space-manager.table.column.header.permanently-deleting": "永久刪除",
  "space-manager.table.column.header.space-key": "索引鍵",
  "space-manager.table.column.header.space-name": "標題",
  "space-manager.table.row.info-button.aria-label": "更多資訊按鈕",
  "space-manager.table.row.info-button.popup-message": "此資料僅適用於過去一年內檢視的空間。",
  "space-pages.options.pill-filters.all": "全部",
  "space-pages.options.pill-filters.starred": "已標上星號",
  "space-pages.options.pill-filters.worked-on": "已處理",
  "space-pages.options.sort-by-select.newest": "最新",
  "space-pages.options.sort-by-select.oldest": "最舊",
  "space-pages.options.sort-by-select.relevant-2": "相關",
  "space-pages.options.sort-by-select.relevant-tooltip": "根據您的最新活動進行個人化排序",
  "space-pages.options.sort-by-select.sort-by": "排序依據",
  "space-pages.options.sort-by-select.title-alpha": "標題 - A 到 Z",
  "space-pages.options.sort-by-select.title-reverse-alpha": "標題 - Z 到 A",
  "space-pages.options.text-filter.label": "依標題搜尋",
  "space-pages.search.results.empty.state.body.content": "內容建立後，此畫面會填滿許多卡片，供您輕鬆瀏覽詳細資訊，找出您接下來想要前往的位置。",
  "space-pages.search.results.empty.state.body.pages": "建立內容後，此畫面會填滿許多頁面卡片，方便您瀏覽其詳細資料，並協助找出您接下來想要前往的位置。",
  "space-pages.search.results.empty.state.header": "讓這個空間栩栩如生",
  "space-pages.search.results.error.action": "請重新整理，然後再試一次。",
  "space-pages.search.results.error.combined": "我們無法取得您的結果。請重新整理，然後再試一次。",
  "space-pages.search.results.error.header": "我們無法取得您的結果",
  "space-pages.search.results.found.count": "{count, plural, other {找到 {count,number} 個頁面}}",
  "space-pages.search.results.found.count.livedocs": "套用至「頁面和即時文件」",
  "space-pages.search.results.no.results.body": "移除所有篩選條件，或以較籠統的內容搜尋。",
  "space-pages.search.results.no.results.header": "沒有任何項目符合您的搜尋條件",
  "space-pages.search.results.no.results.reset.filter": "重設",
  "space-pages.title.all-content": "所有內容",
  "space-pages.untitled-draft": "未命名",
  "space-permissions.access-request.access-granted-prompt": "{username} 的這個存取權要求已授予。",
  "space-permissions.access-request.access-granted-prompt-acknowledge": "確定",
  "space-permissions.access-request.access-granted-prompt-review": "檢閱他們的權限",
  "space-permissions.access-request.modal-cancel-action": "拒絕",
  "space-permissions.access-request.modal-close-icon-label": "關閉強制回應",
  "space-permissions.access-request.modal-intro-paragraph": "{requesterinfo} 已要求存取 {spaceinfo} 空間。",
  "space-permissions.access-request.modal-primary-action": "選取權限",
  "space-permissions.access-request.modal-title": "空間存取權要求",
  "space-permissions.anonymous-access-friction-modal.cancel-button.non-final": "取消",
  "space-permissions.anonymous-tab.banner": "您的組織會避免他人匿名存取此空間。",
  "space-permissions.anonymous-tab.description": "如果您的 Confluence 網站是公開的，您可以將權限授予並未登入的人員。匿名使用者可以被授予大部分的權限，但我們建議您將權限限制為檢視和留言。",
  "space-permissions.anonymous-tab.general-error-flag": "發生錯誤。",
  "space-permissions.anonymous-tab.non-global-warning.admin": "<b>匿名使用者無法檢視此空間</b>，因為目前已關閉全域適用的匿名「使用 Confluence」權限。請移至<link>全域權限</link>，以將 Confluence 的使用權限授予匿名使用者。",
  "space-permissions.anonymous-tab.table-row-header": "匿名使用者",
  "space-permissions.back-to-space-settings.space-settings-link": "空間設定",
  "space-permissions.back-to-space-settings.space-settings-link-label": "空間設定連結",
  "space-permissions.flag-message.error-removing-all-admin-perms": "您無權移除此空間的所有管理權限。",
  "space-permissions.flag-message.fetch-perms-failure": "我們無法載入表格。",
  "space-permissions.flag-message.guest-already-has-access": "無法儲存訪客權限：訪客已經存取其他空間。",
  "space-permissions.flag-message.guest-group-not-allowed": "訪客群組無法新增為內部群組。",
  "space-permissions.flag-message.update-perms-failure": "我們在儲存變更時遇到問題。",
  "space-permissions.flag-message.user-not-authorized": "使用者並未獲得授權，因此無法修改權限",
  "space-permissions.groups-tab.description": "{isCompanyHub, select, true {將此中心的權限授予群組的所有成員。} other {將此空間的權限授予群組的所有成員。}}",
  "space-permissions.groups-tab.group-count": "{count, plural, other {{count,number} 個人}}",
  "space-permissions.groups-tab.table-empty-view": "{isCompanyHub, select, true {目前沒有任何群組擁有此中心的存取權。} other {目前沒有群組擁有此空間的存取權。}}",
  "space-permissions.groups-tab.table-empty-view-paginated": "在此頁面上沒有其他群組可查看",
  "space-permissions.guests-tab.description": "{isCompanyHub, select, true {將完整或部分的公司中心權限授予個別使用者。} other {將權限授予個別使用者 (無論他們是哪個群組的成員)。}}",
  "space-permissions.guests-tab.table-empty-view": "{isCompanyHub, select, true {目前沒有任何使用者擁有此中心的個別存取權限。} other {目前沒有使用者擁有此空間的個別存取權限。}}",
  "space-permissions.guests-tab.table-empty-view-paginated": "在此頁面上沒有其他使用者可以查看",
  "space-permissions.hub-permissions.default-hub.title": "公司中心",
  "space-permissions.hub-permissions.title": "中心權限",
  "space-permissions.jsm-prompt.info-box-button": "停用此權限",
  "space-permissions.jsm-prompt.info-box-description": "任何作用中的使用者都可以檢視此空間中的內容，包括沒有 Confluence 授權的使用者。這會透過 Jira Service Management 來啟用，因此使用者可以在提出協助要求時檢視知識庫文章。",
  "space-permissions.jsm-prompt.info-box-title": "任何作用中使用者都可以檢視此空間",
  "space-permissions.jsm-prompt.modal-action-paragraph": "如果您停用此權限，則只能透過 Jira Service Management 再次啟用。",
  "space-permissions.jsm-prompt.modal-cancel-action": "取消",
  "space-permissions.jsm-prompt.modal-intro-paragraph": "這個空間已連結至 Jira Service Management 中的專案，所以使用者可以在提出要求時檢視知識庫文章。",
  "space-permissions.jsm-prompt.modal-primary-action": "停用",
  "space-permissions.jsm-prompt.modal-title": "停用所有使用中使用者的這項權限",
  "space-permissions.next-page.aria-label": "下一頁",
  "space-permissions.pagination.page-size-selection": "每頁的結果：",
  "space-permissions.previous-page.aria-label": "上一頁",
  "space-permissions.table.header.allViewTooltipContent": "檢視權限可決定誰可以存取該空間。",
  "space-permissions.table.header.allViewTooltipIconLabel": "進一步了解檢視權限",
  "space-permissions.table.header.column.Add": "新增",
  "space-permissions.table.header.column.add-delete": "新增/刪除",
  "space-permissions.table.header.column.admin": "管理員",
  "space-permissions.table.header.column.archive": "封存",
  "space-permissions.table.header.column.delete": "刪除",
  "space-permissions.table.header.column.delete-own": "刪除自己的",
  "space-permissions.table.header.column.export": "匯出",
  "space-permissions.table.header.column.view": "檢視",
  "space-permissions.table.header.deleteOwnTooltipContent": "可讓使用者刪除自己的頁面、部落格和附件。(對於留言，「新增」權限包含「刪除自己的」)",
  "space-permissions.table.header.deleteOwnTooltipIconLabel": "進一步了解如何刪除自己的",
  "space-permissions.table.header.group.all": "全部",
  "space-permissions.table.header.group.attachments": "附件",
  "space-permissions.table.header.group.blogs": "部落格",
  "space-permissions.table.header.group.comments": "留言",
  "space-permissions.table.header.group.mail": "郵件",
  "space-permissions.table.header.group.pages": "頁面",
  "space-permissions.table.header.group.pages-databases": "頁面和資料庫",
  "space-permissions.table.header.group.pages-databases-embeds": "頁面、資料庫和智慧連結",
  "space-permissions.table.header.group.pages-databases-embeds.livedocs": "頁面、即時文件、資料庫和智慧連結",
  "space-permissions.table.header.group.pages-databases.livedocs": "頁面、即時文件和資料庫",
  "space-permissions.table.header.group.pages-embeds": "頁面和智慧連結",
  "space-permissions.table.header.group.pages-embeds.livedocs": "頁面、即時文件和智慧連結",
  "space-permissions.table.header.group.pages-whiteboards": "頁面和白板",
  "space-permissions.table.header.group.pages-whiteboards-databases-embeds": "頁面、白板、資料庫和智慧連結",
  "space-permissions.table.header.group.pages-whiteboards-databases-embeds.livedocs": "頁面、即時文件、白板、資料庫和智慧連結",
  "space-permissions.table.header.group.pages-whiteboards-databases-old": "頁面、白板和資料庫",
  "space-permissions.table.header.group.pages-whiteboards-databases.livedocs": "頁面、即時文件、白板和資料庫",
  "space-permissions.table.header.group.pages-whiteboards-embeds": "頁面、白板和智慧連結",
  "space-permissions.table.header.group.pages-whiteboards-embeds.livedocs": "頁面、即時文件、白板和智慧連結",
  "space-permissions.table.header.group.pages-whiteboards.livedocs": "頁面、即時文件和白板",
  "space-permissions.table.header.group.pages.livedocs": "頁面和即時文件",
  "space-permissions.table.header.group.restrictions": "限制",
  "space-permissions.table.header.group.select-all": "全選",
  "space-permissions.table.header.group.space": "空間",
  "space-permissions.table.header.principals.group": "群組",
  "space-permissions.table.header.principals.guest": "訪客",
  "space-permissions.table.header.principals.user": "使用者",
  "space-permissions.table.header.restrictionsTooltipContent": "允許使用者直接新增和移除內容的限制。這不會影響繼承的限制。",
  "space-permissions.table.header.restrictionsTooltipIconLabel": "限制新增/刪除工具提示",
  "space-permissions.user-and-groups-picker.add-button-text": "新增",
  "space-permissions.user-and-groups-picker.group-add-more-text": "新增更多群組...",
  "space-permissions.user-and-groups-picker.group-label-text": "搜尋內部群組",
  "space-permissions.user-and-groups-picker.guests-add-more-text": "新增更多訪客...",
  "space-permissions.user-and-groups-picker.guests-label-text": "搜尋訪客使用者",
  "space-permissions.user-and-groups-picker.user-add-more-text": "新增更多使用者...",
  "space-permissions.user-and-groups-picker.user-label-text": "搜尋內部使用者",
  "space-permissions.users-tab.description": "{isCompanyHub, select, true {將完整或部分的公司中心權限授予個別使用者。} other {將權限授予個別使用者 (無論他們是哪個群組的成員)。}}",
  "space-permissions.users-tab.pending-user-lozenge": "待處理的要求",
  "space-permissions.users-tab.table-empty-view": "{isCompanyHub, select, true {目前沒有任何使用者擁有此中心的個別存取權限。} other {目前沒有使用者擁有此空間的個別存取權限。}}",
  "space-permissions.users-tab.table-empty-view-paginated": "在此頁面上沒有其他使用者可以查看",
  "space-roles.access-class.anonymous-users": "匿名使用者",
  "space-roles.access-class.licensed-users": "所有 Confluence 使用者",
  "space-roles.access-class.product-admins": "所有 Confluence 管理員",
  "space-roles.add-principal-modal.friction-modal.cancel-button": "繼續編輯",
  "space-roles.add-principal-modal.friction-modal.confirm-button": "捨棄",
  "space-roles.add-principal-modal.warning-message": "無法指派此角色給訪客。",
  "space-roles.add-principal-modal.warning-message-existing-space": "此訪客已被指派至空間。",
  "space-roles.copy-roles-modal.placeholder": "選擇空間",
  "space-roles.copy-roles-modal.title": "從另一個空間複製權限",
  "space-roles.default-permissions-modal.body": "這會將空間的權限設定復原為管理員設定的預設值，並覆寫您目前的權限設定。<b>此動作無法復原。</b>",
  "space-roles.default-permissions-modal.cancel-button": "取消",
  "space-roles.default-permissions-modal.confirm-button": "還原預設值",
  "space-roles.default-permissions-modal.success": "存取權已更新。權限已成功重設為管理員設定的預設值。",
  "space-roles.default-permissions-modal.title": "是否復原預設權限？",
  "space-roles.dialog-add-principal.add-button": "新增",
  "space-roles.dialog-add-principal.cancel-button": "取消",
  "space-roles.dialog-add-principal.groups-title": "新增預設群組",
  "space-roles.dialog-add-principal.guest-lozenge": "訪客",
  "space-roles.dialog-add-principal.incompatible-guest-role-assignment-warning": "無法指派此角色給訪客。",
  "space-roles.dialog-add-principal.remove-button": "移除",
  "space-roles.dialog-add-principal.role-select-placeholder": "選取角色",
  "space-roles.dialog-add-principal.save-button": "儲存",
  "space-roles.dialog-add-principal.save-success": "已新增至空間",
  "space-roles.dialog-add-principal.title": "新增人員",
  "space-roles.feedback-collector.button-text": "提供意見反應",
  "space-roles.feedback-collector.flag-title": "意見反應已提交，感謝您！",
  "space-roles.feedback-collector.title": "提供意見反應",
  "space-roles.feedback-collector.title-details": "整體來說，您對於在 Confluence 中使用角色管理存取權的體驗是否滿意？",
  "space-roles.friction-modal.body": "您有未儲存的變更，如果您在未選取<b>儲存</b>的情況下關閉，這些變更將會遺失。",
  "space-roles.friction-modal.body-additional": "您要捨棄這些變更嗎？",
  "space-roles.friction-modal.title": "未儲存的變更",
  "space-roles.jsm-banner.info-box-button": "停用此權限",
  "space-roles.jsm-banner.info-box-description": "任何作用中的使用者都可以檢視此空間中的內容，包括沒有 Confluence 授權的使用者。 這會透過 Jira Service Management 來啟用，因此使用者可以在提出協助要求時檢視知識庫文章。",
  "space-roles.jsm-banner.info-box-title": "任何作用中使用者都可以檢視此空間",
  "space-roles.jsm-banner.modal-action-paragraph": "如果您停用此權限，則只能透過 Jira Service Management 再次啟用。",
  "space-roles.jsm-banner.modal-cancel-action": "取消",
  "space-roles.jsm-banner.modal-intro-paragraph": "這個空間已連結至 Jira Service Management 中的專案，所以使用者可以在提出要求時檢視知識庫文章。",
  "space-roles.jsm-banner.modal-primary-action": "停用",
  "space-roles.jsm-banner.modal-title": "停用所有使用中使用者的這項權限",
  "space-roles.page.add-people-button-text": "新增人員",
  "space-roles.page.learn-more-link": "深入了解",
  "space-roles.page.page-actions-menu.copy-permissions": "從另一個空間複製權限",
  "space-roles.page.page-actions-menu.disabled-message": "您不能對此空間採取特定動作。",
  "space-roles.page.page-actions-menu.manage-default-permissions": "管理預設權限",
  "space-roles.page.page-actions-menu.manage-space-roles": "管理角色",
  "space-roles.page.page-actions-menu.restore-default-permissions": "復原預設權限",
  "space-roles.page.user-management-page-description": "管理不同人員可以在您的空間中執行的動作。{learnMoreLink}",
  "space-roles.page.user-management-page-title": "使用者",
  "space-roles.page.view-role-permissions": "檢視角色權限",
  "space-roles.permissions-summary.custom-access-default-description": "他們具備不對應至角色的預設權限。",
  "space-roles.permissions-summary.custom-access-description": "他們在此空間中具有無法對應至角色的權限。",
  "space-roles.permissions-summary.custom-access-heading": "自訂存取權",
  "space-roles.permissions-summary.no-access-default-description": "除非獲得一般存取權，否則使用者無法存取依預設建立的所有新空間。",
  "space-roles.permissions-summary.no-access-description": "除非獲得一般存取權或群組成員資格，否則使用者無法存取此空間。",
  "space-roles.permissions-summary.no-access-heading": "無存取權",
  "space-roles.permissions-summary.no-general-access-default-description": "選取角色，讓這個使用者類別存取所有新建立的空間，不論群組成員資格為何。",
  "space-roles.permissions-summary.no-general-access-description": "選取角色，讓這個使用者類別中的所有使用者存取此空間，不論群組成員資格為何。",
  "space-roles.permissions-summary.no-general-access-heading": "沒有一般存取權",
  "space-roles.popup.custom-access-label": "管理存取權",
  "space-roles.popup.custom-access-learn-more": "深入了解",
  "space-roles.popup.view-role-permissions-label": "檢視角色權限",
  "space-roles.removal-friction-modal.body": "他們將無法再檢視此空間中的內容。",
  "space-roles.removal-friction-modal.cancel-button": "取消",
  "space-roles.removal-friction-modal.confirm-button": "移除",
  "space-roles.removal-friction-modal.defaults-body": "他們將不再具有空間的預設存取權限。",
  "space-roles.removal-friction-modal.title": "是否從空間移除？",
  "space-roles.remove-principal-modal.cancel.non-final": "取消",
  "space-roles.remove-principal-modal.custom-access": "自訂存取權",
  "space-roles.remove-principal-modal.general-access-title": "要停止允許一般存取權嗎？",
  "space-roles.remove-principal-modal.group-body": "將移除該群組作為成員存取權來源的身分。<b>注意：</b>成員仍然可以透過其他來源存取 (其他群組、使用者類別或以個人身分存取)。",
  "space-roles.remove-principal-modal.group-table-cell": "群組",
  "space-roles.remove-principal-modal.group-table-cell.non-final": "群組",
  "space-roles.remove-principal-modal.group-title": "是否移除群組？",
  "space-roles.remove-principal-modal.guest-body": "他們將無法再與此空間互動。",
  "space-roles.remove-principal-modal.guest-title": "是否移除訪客？",
  "space-roles.remove-principal-modal.last-admin-error": "無法從組態中移除最後一位管理員。",
  "space-roles.remove-principal-modal.remove": "移除",
  "space-roles.remove-principal-modal.remove-access-class-success": "已更新一般存取權",
  "space-roles.remove-principal-modal.remove-success": "已移除",
  "space-roles.remove-principal-modal.remove-user-class": "停止允許",
  "space-roles.remove-principal-modal.role-table-cell": "角色",
  "space-roles.remove-principal-modal.role-table-cell.non-final": "角色",
  "space-roles.remove-principal-modal.team-title": "是否移除團隊？",
  "space-roles.remove-principal-modal.user-class-body": "這將限制此使用者類別的一般存取權。表格中特別列出的任何使用者和群組都將保留存取權。",
  "space-roles.remove-principal-modal.user-group-member-body": "這麼做會從空間中移除他們的個人身份，但他們仍然可以透過這些群組的成員資格存取此空間：",
  "space-roles.remove-principal-modal.user-title": "是否移除使用者？",
  "space-roles.table-filters.user-picked-info": "他們的存取權是所有來源權限的組合。<learnmorelink>深入了解</learnmorelink>",
  "space-roles.table.add-people-button-text": "新增人員",
  "space-roles.table.custom-access-role-filter": "自訂存取權",
  "space-roles.table.empty-table-body": "請嘗試變更搜尋條件，或是加入人員。",
  "space-roles.table.empty-table-title": "我們找不到任何相符項目。",
  "space-roles.table.error-view-title": "我們無法載入這個空間中的人員。",
  "space-roles.table.filter-clear-button": "全部清除",
  "space-roles.table.filter-role": "角色",
  "space-roles.table.filter-type": "類型",
  "space-roles.table.filtered-result": "{resultsCount, plural, other {正在顯示 {resultsCount,number} 筆結果}}",
  "space-roles.table.filtered-result-paginated": "正在顯示 100+ 個結果",
  "space-roles.table.group-count": "{count, plural, other {{count,number} 個人}}",
  "space-roles.table.guest-lozenge-text": "訪客",
  "space-roles.table.last-admin-error": "組態中的最後一位管理員必須保留其目前角色。",
  "space-roles.table.licensed-user-display-name": "Confluence 使用者",
  "space-roles.table.load-more-button.non-final": "載入更多",
  "space-roles.table.people-column-header": "此空間的人員",
  "space-roles.table.placeholder-text": "自訂存取權",
  "space-roles.table.principal-type-class": "使用者類別",
  "space-roles.table.principal-type-group": "群組",
  "space-roles.table.principal-type-guest": "訪客",
  "space-roles.table.principal-type-user": "使用者",
  "space-roles.table.product-admin-display-name": "Confluence 管理員",
  "space-roles.table.role-column-header": "角色",
  "space-roles.table.role-update-success": "存取權已更新",
  "space-roles.table.searched-result": "{resultsCount, plural, other {使用者有 {resultsCount,number} 個存取權來源}}",
  "space-roles.table.searched-result-paginated": "使用者有 100 個以上的存取權來源",
  "space-roles.table.table-actions-menu.learn-more-about-roles": "進一步了解角色",
  "space-roles.table.table-actions-menu.manage-permissions": "管理存取權",
  "space-roles.table.table-actions-menu.remove-access-class-from-space": "移除存取權",
  "space-roles.table.table-actions-menu.remove-from-space": "移除",
  "space-roles.table.type-column-header": "類型",
  "space-roles.update-modal.duplicate-role-selection.body.non-final": "您選取的權限組合符合系統中的兩個角色。您需要選取一個才能繼續操作。",
  "space-roles.update-modal.duplicate-role-selection.cancel-button": "取消",
  "space-roles.update-modal.duplicate-role-selection.save-button": "確認",
  "space-roles.update-modal.duplicate-role-selection.title.non-final": "權限符合多個角色",
  "space-roles.update-principal-modal.cancel": "取消",
  "space-roles.update-principal-modal.done": "完成",
  "space-roles.update-principal-modal.duplicate-permissions-info": "這些權限符合多個角色",
  "space-roles.update-principal-modal.friction-modal.cancel-button": "繼續編輯",
  "space-roles.update-principal-modal.friction-modal.confirm-button": "捨棄",
  "space-roles.update-principal-modal.invalid-permissions-update": "這些權限不適用於此列",
  "space-roles.update-principal-modal.last-admin-permissions-error": "組態中的最後一位管理員必須保留其管理員權限。",
  "space-roles.update-principal-modal.last-admin-role-error": "組態中的最後一位管理員必須保留其目前角色。",
  "space-roles.update-principal-modal.remove": "移除",
  "space-roles.update-principal-modal.role-deselection-friction.cancel": "取消",
  "space-roles.update-principal-modal.role-deselection-friction.confirm": "繼續",
  "space-roles.update-principal-modal.role-deselection-friction.description": "您選取的權限組合不屬於角色，並且會產生自訂存取權，這可能會使權限更難管理。<learnmorelink>深入了解</learnmorelink>",
  "space-roles.update-principal-modal.role-deselection-friction.title": "是否退出角色？",
  "space-roles.update-principal-modal.save": "儲存",
  "space-roles.update-principal-modal.save-access-class-success": "已更新一般存取權",
  "space-roles.update-principal-modal.save-success": "存取權已更新",
  "space-roles.update-principal-modal.title": "管理存取權",
  "space-roles.users-table-spotlight.done-button-label": "完成",
  "space-roles.users-table-spotlight.next-button-label": "下一步",
  "space-roles.users-table-spotlight.role-selector-spotlight-heading": "檢視角色權限",
  "space-roles.view-role-permissions-modal.custom-role-list-title": "自訂角色",
  "space-roles.view-role-permissions-modal.done-button-text": "完成",
  "space-roles.view-role-permissions-modal.edit-button-label": "編輯角色權限",
  "space-roles.view-role-permissions-modal.permission-disabled": "已停用",
  "space-roles.view-role-permissions-modal.permission-enabled": "已啟用",
  "space-roles.view-role-permissions-modal.predefined-role-list-title": "Confluence 角色",
  "space-roles.view-role-permissions-modal.title": "角色權限",
  "space-selector.create.drawer.header": "選取空間",
  "space-selector.create.drawer.no.space.found": "找不到空間",
  "space-selector.create.drawer.select.a.space": "選取空間",
  "space-selector.create.drawer.spaces.loading": "正在載入空間",
  "space-selector.move-page-dialog.space-info-error": "無法擷取空間資訊。請再試一次。",
  "space-selector.no.permission.to.create": "您在此空間中沒有建立權限",
  "space-selector.non-admin.icon": "您不是此空間的管理員",
  "space-selector.only.admins.copy.permissions": "您必須是此空間的管理員才能複製權限",
  "space-selector.restricted-space.icon": "此空間受到限制",
  "space-settings.Category-labels.error.validation.tilde": "類別不能以「 ~ 」字元開頭",
  "space-settings.actions.column.label": "動作",
  "space-settings.add-description.button.label": "新增描述",
  "space-settings.add-description.title": "新增範本描述",
  "space-settings.automation.card-title.non-final": "自動化",
  "space-settings.back-button.title.space-settings": "空間設定",
  "space-settings.cancel.button.label": "取消",
  "space-settings.content-manager.card-title.non-final": "內容管理員",
  "space-settings.convert-template.button.label": "轉換",
  "space-settings.create-new-template.button.label": "建立新範本",
  "space-settings.delete-template.error.flag.title": "我們在刪除 {templateTitle} 時遇到問題，請再試一次",
  "space-settings.delete-template.success.flag.title": "「{templateTitle}」已成功刪除",
  "space-settings.design-decision.blueprint.title": "設計決策",
  "space-settings.disable-blueprint.error.flag.title": "我們在停用 {blueprintTitle} 時遇到問題，請再試一次。",
  "space-settings.disable-template.success.flag.title": "{blueprintTitle} 已成功停用",
  "space-settings.edit-description.button.label": "編輯描述",
  "space-settings.edit-template-description.error.message": "您已超過字元數上限。",
  "space-settings.edit-template-description.textarea.title": "附註 (選擇性)",
  "space-settings.enable-blueprint.error.flag.title": "我們在啟用 {blueprintTitle} 時遇到問題，請再試一次。",
  "space-settings.enable-blueprint.success.flag.title": "{blueprintTitle} 已成功啟用",
  "space-settings.export-space.all-content.description": "您有權檢視的所有內容",
  "space-settings.export-space.all-content.title": "所有可顯示的內容",
  "space-settings.export-space.component-header": "內容",
  "space-settings.export-space.csv.description": "匯出至 Confluence Cloud",
  "space-settings.export-space.csv.title": "CSV",
  "space-settings.export-space.export.button": "匯出空間",
  "space-settings.export-space.file-type": "檔案格式",
  "space-settings.export-space.html.description": "匯出以將您的網站作為靜態網站",
  "space-settings.export-space.html.title": "HTML",
  "space-settings.export-space.info-text": "由於有瀏覽器呈現標準的增強功能，某些 @page 屬性可能會以不同方式顯示。這可能需要調整現有的 CSS，以確保與新型瀏覽器相容。請參閱我們的支援指南，以獲取最佳結果",
  "space-settings.export-space.link-text": "前往支援文件",
  "space-settings.export-space.next.button": "下一步",
  "space-settings.export-space.pdf.description": "下載空間內容",
  "space-settings.export-space.pdf.title": "PDF",
  "space-settings.export-space.selected-content.description": "選擇要包含的特定內容",
  "space-settings.export-space.selected-content.title": "選取的內容",
  "space-settings.export-space.tooltip.content": "只有 Confluence 頁面會包含在 PDF 匯出內容中。其他內容類型 (例如白板) 不會包含在內。",
  "space-settings.export-space.xml.description": "匯出至 Confluence Server 或 Data Center",
  "space-settings.export-space.xml.title": "XML",
  "space-settings.feedback-banner.button-text": "提供意見反應",
  "space-settings.feedback-banner.message": "我們變更了空間設定的整理方式。讓我們知道您的想法！",
  "space-settings.forge-app.error-loading-apps.title": "我們無法載入 Forge 應用程式",
  "space-settings.forge-app.error-selected-app.description": "請連絡您的網站管理員以安裝應用程式。",
  "space-settings.forge-app.error-selected-app.title": "無法使用應用程式",
  "space-settings.forge-apps-tabs.error-loading": "某些應用程式可能無法載入",
  "space-settings.generic.template.text": "未命名藍圖",
  "space-settings.global-custom-templates.header": "全域範本",
  "space-settings.global-templates.header": "藍圖範本",
  "space-settings.gsm.blueprint.title": "GSM 藍圖",
  "space-settings.invoice.blueprint.title": "發票",
  "space-settings.labels-select.input-placeholder": "搜尋或建立標籤",
  "space-settings.landing-page.admin-center-changeboarding.body": "來自任務控管的深入解析和動作可讓您輕鬆管理團隊的知識。",
  "space-settings.landing-page.admin-center-changeboarding.button.maybe-later": "稍後再說",
  "space-settings.landing-page.admin-center-changeboarding.button.try-now": "立即試用",
  "space-settings.landing-page.admin-center-changeboarding.title": "使用任務控管簡化工作",
  "space-settings.landing-page.live-pages-admin-info-banner.body": "您可以隨時透過<strong>功能</strong>將其開啟，將在此空間中建立的新頁面設定為即時編輯頁面。",
  "space-settings.landing-page.live-pages-admin-info-banner.body.livedocs": "您可以隨時透過<strong>功能</strong>開啟，以在此空間中啟用即時文件。",
  "space-settings.landing-page.live-pages-admin-info-banner.button-features": "管理功能",
  "space-settings.landing-page.live-pages-admin-info-banner.button-info": "深入了解",
  "space-settings.landing-page.live-pages-admin-info-banner.heading": "此空間現已適用即時編輯頁面",
  "space-settings.landing-page.live-pages-admin-info-banner.heading.livedocs": "此空間現已適用即時文件",
  "space-settings.landing-page.loading-error": "抱歉，我們目前無法載入空間工具。",
  "space-settings.landing-page.title": "空間設定",
  "space-settings.last-updated-by.column.label": "上次更新者",
  "space-settings.live-pages.expanded-eap-changeboarding-button-dismiss": "關閉",
  "space-settings.live-pages.expanded-eap-changeboarding-button-findOutMore": "深入了解",
  "space-settings.live-pages.expanded-eap-changeboarding-button-gotIt": "知道了",
  "space-settings.live-pages.expanded-eap-changeboarding-button-next": "下一步",
  "space-settings.live-pages.expanded-eap-changeboarding-settings-off-landing-body": "我們已針對此空間中的新頁面，新增即時編輯設定。",
  "space-settings.live-pages.expanded-eap-changeboarding-settings-off-landing-header": "已新增頁面設定",
  "space-settings.live-pages.expanded-eap-changeboarding-settings-on-landing-body": "我們已針對此空間中的新頁面，新增即時編輯的預設設定。",
  "space-settings.live-pages.expanded-eap-changeboarding-settings-on-landing-header": "已啟用即時編輯頁面",
  "space-settings.manage-content-tree.setting-title": "內容管理員",
  "space-settings.manage-global-templates.button.label": "管理全域範本",
  "space-settings.mission-control.card-title.non-final": "任務控制",
  "space-settings.more-about-global-templates.link.label": "進一步了解全域範本",
  "space-settings.navigation.filter-bar.empty-options": "我們找不到任何符合您搜尋內容的項目。",
  "space-settings.navigation.filter-bar.error-loading": "部分連結無法載入",
  "space-settings.navigation.filter-bar.placeholder-text": "跳到設定...",
  "space-settings.navigation.tabs.overflow-button": "更多",
  "space-settings.new-lozenge.text.non-final": "全新",
  "space-settings.no-blueprints.message": "目前沒有藍圖。",
  "space-settings.no-custom-templates.message": "範本是協助您將文件標準化並且讓團隊快速開始撰寫內容的絕佳方法。您還沒有此空間專用的範本，建立第一個範本即可開始使用。",
  "space-settings.onboarding-modal.close-button": "關閉",
  "space-settings.onboarding-modal.manage-users-button": "管理使用者",
  "space-settings.open-template-browser.button.label": "開啟範本瀏覽器",
  "space-settings.page-layout.button.reset": "捨棄變更",
  "space-settings.page-layout.button.submit": "儲存",
  "space-settings.page-layout.error.flag.title": "我們在儲存更新的版面配置時遇到一些問題，請再試一次",
  "space-settings.page-layout.error.no-perms.message": "抱歉，由於使用者權限不足，無法儲存更新的版面配置",
  "space-settings.page-layout.flag-success-title": "版面配置已更新",
  "space-settings.page-layout.footer.label": "頁尾",
  "space-settings.page-layout.header.label": "頁首",
  "space-settings.page-tree-state.error.body": "請稍後再試一次",
  "space-settings.page-tree-state.error.title": "發生錯誤",
  "space-settings.page-tree.nested-node-count": "載入選取的頁數時發生錯誤。",
  "space-settings.pdf-export.button.reset": "捨棄變更",
  "space-settings.pdf-export.button.submit": "儲存",
  "space-settings.pdf-export.critical-failure.description": "我們無法擷取資料。請重新整理 Confluence。",
  "space-settings.pdf-export.critical-failure.title": "發生錯誤",
  "space-settings.pdf-export.empty-table-body": "內容可以使用後，將顯示在這裡。",
  "space-settings.pdf-export.empty-table-header": "沒有要顯示的內容",
  "space-settings.pdf-export.error.bad-request.message": "部分欄位可能包含錯誤資料，很可能是輸入了錯誤的 URL。",
  "space-settings.pdf-export.error.no-perms.message": "很抱歉，由於使用者權限不足，無法啟動該動作。",
  "space-settings.pdf-export.export-download-button": "下載",
  "space-settings.pdf-export.export-download-error-body": "我們在匯出您的空間時遇到問題。請再試一次。",
  "space-settings.pdf-export.export-download-error-header": "發生錯誤",
  "space-settings.pdf-export.export-download-header": "您的 PDF 已準備就緒！",
  "space-settings.pdf-export.export-download-retry-button": "返回",
  "space-settings.pdf-export.export-status-completion-percentage-header": "完成進度",
  "space-settings.pdf-export.export-status-completion-seconds": "秒",
  "space-settings.pdf-export.export-status-header": "正在匯出 PDF 檔案",
  "space-settings.pdf-export.export-status-sub-header": "匯出期間，請不要離開此頁面",
  "space-settings.pdf-export.export-status-time-header": "剩餘時間",
  "space-settings.pdf-export.flag-error-title": "我們在更新您的設定時遇到問題，請再試一次",
  "space-settings.pdf-export.flag-success-title": "已更新全域 PDF 匯出欄位。",
  "space-settings.pdf-export.footer.placeholder": "按一下即可開始套用頁尾。",
  "space-settings.pdf-export.header.placeholder": "按一下即可開始套用標頭。",
  "space-settings.pdf-export.main-description": "您可以編輯下面的 HTML，自訂此空間已匯出 PDF 的標題頁面、頁首和頁尾。<a>將空間匯出為 PDF</a>",
  "space-settings.pdf-export.not-enough-pages-selected-body": "請選取至少一個要匯出的內容項目。",
  "space-settings.pdf-export.not-enough-pages-selected-header": "未選取任何內容",
  "space-settings.pdf-export.options-header": "選項",
  "space-settings.pdf-export.options-zip-tile": "匯出為 zip",
  "space-settings.pdf-export.stylesheet.helper.text": "<a>了解可套用至 PDF 樣式表的預設 CSS 規則和覆寫內容。</a>",
  "space-settings.pdf-export.stylesheet.placeholder": "按一下即可開始變更外觀和風格。",
  "space-settings.pdf-export.title.placeholder": "按一下即可開始套用標題頁面。",
  "space-settings.pdf-export.too-many-pages-selected": "已達到內容上限",
  "space-settings.pdf-export.too-many-pages-selected-body": "您選取了超過 2,000 頁。請將您的選取範圍減少到少於 2,000 頁。",
  "space-settings.pdf-export.warning-message": "由於有瀏覽器呈現標準的增強功能，某些 @page 屬性可能會以不同方式顯示。這可能需要調整現有的 CSS，以確保與新型瀏覽器相容。<a>請檢閱我們的支援指南，</a>以獲得最佳結果。",
  "space-settings.project-status.blueprint.title": "專案狀態",
  "space-settings.promote-template.button.label": "推廣",
  "space-settings.promote-template.error.flag.title": "我們在推廣 {templateTitle} 時遇到問題，請再試一次",
  "space-settings.promote-template.success.flag.title": "{templateTitle} 已成功推廣",
  "space-settings.promote-template.tooltip.description": "您推廣的藍圖會顯示在範本瀏覽器的「精選」和「已推廣」類別中。",
  "space-settings.reset-template.error.flag.title": "我們在重設 {templateTitle} 時遇到問題，請再試一次",
  "space-settings.reset-template.success.flag.title": "{templateTitle} 已成功重設",
  "space-settings.reset-to-default.message": "重設為預設值",
  "space-settings.satisfaction-survey.button.cancel": "取消",
  "space-settings.satisfaction-survey.button.submit": "提交",
  "space-settings.satisfaction-survey.checkbox.can-contact": "Atlassian 可以連絡我來了解此意見反應",
  "space-settings.satisfaction-survey.description": "您目前對於新空間設定導覽的看法為何？",
  "space-settings.satisfaction-survey.final.description": "感謝您協助我們改善 Confluence！",
  "space-settings.satisfaction-survey.final.title": "已提交意見反應",
  "space-settings.satisfaction-survey.question.bad": "我們很遺憾得知這個消息。您不滿意的項目為何？有任何讓您感到滿意的地方嗎？(選擇性)",
  "space-settings.satisfaction-survey.question.good": "太棒了！您喜歡其中哪一個部分？有什麼可以改進的嗎？(選擇性)",
  "space-settings.satisfaction-survey.question.okay": "您是否能再提供多一點資訊？您喜歡其中哪一個部分？有什麼可以改進的嗎？(選擇性)",
  "space-settings.satisfaction-survey.reaction.amazing": "棒極了",
  "space-settings.satisfaction-survey.reaction.bad": "不佳",
  "space-settings.satisfaction-survey.reaction.great": "很好",
  "space-settings.satisfaction-survey.reaction.okay": "還好",
  "space-settings.satisfaction-survey.reaction.terrible": "很糟糕",
  "space-settings.satisfaction-survey.title": "告訴我們您的想法",
  "space-settings.save.button.label": "儲存",
  "space-settings.send-to-trash.header": "傳送到垃圾桶嗎？",
  "space-settings.side-navigation.error.title": "載入錯誤",
  "space-settings.side-navigation.forge-error.title": "載入錯誤",
  "space-settings.side-navigation.no-search-results": "我們找不到具有該標題的任何設定",
  "space-settings.side-navigation.primary-item.analytics": "分析",
  "space-settings.side-navigation.primary-item.automation": "自動化",
  "space-settings.side-navigation.primary-item.content-manager": "內容管理員",
  "space-settings.side-navigation.primary-item.mission-control": "任務控制",
  "space-settings.side-navigation.primary-item.space-details": "空間詳細資料",
  "space-settings.side-navigation.primary-item.users": "使用者",
  "space-settings.sidebar-links.space-settings.link": "空間設定",
  "space-settings.sidebar-links.space-settings.tooltip": "檢視此空間的設定",
  "space-settings.space-blueprint.header": "空間藍圖",
  "space-settings.space-blueprint.knowledge-base": "知識庫",
  "space-settings.space-details.administrators.label": "管理員",
  "space-settings.space-details.admins.label": "管理員",
  "space-settings.space-details.admins.view-all.label": "全部檢視",
  "space-settings.space-details.categories-field.invalid.error.message": "類別只能是字母和數字",
  "space-settings.space-details.categories-field.message.exceeds-labels": "空間最多可以有 20 個類別",
  "space-settings.space-details.categories.label": "類別",
  "space-settings.space-details.categories.placeholder": "新增類別",
  "space-settings.space-details.change-owner.placeholder": "輸入使用者或群組名稱",
  "space-settings.space-details.change-owner.selector": "找不到相符的使用者或群組",
  "space-settings.space-details.collapse-details.label": "摺疊詳細資料",
  "space-settings.space-details.content.selector.generic.error": "擷取內容項目時發生錯誤，請再試一次。",
  "space-settings.space-details.created-by.label": "建立者",
  "space-settings.space-details.description.label": "描述",
  "space-settings.space-details.duplicate-error.flag.message": "為此空間選擇不重複的索引鍵",
  "space-settings.space-details.duplicate-error.flag.title": "空間索引鍵已經在使用中",
  "space-settings.space-details.error.flag.title": "我們在儲存更新的空間詳細資料時遇到一些問題，請再試一次",
  "space-settings.space-details.expand-details.label": "更多詳細資料",
  "space-settings.space-details.flag-success-title": "已更新空間詳細資料",
  "space-settings.space-details.home-page-id.cannot-resolve.error.message": "無法識別指定的首頁",
  "space-settings.space-details.home-page.helper-message": "使用者瀏覽至此空間時所顯示的內容。",
  "space-settings.space-details.home-page.label": "首頁內容",
  "space-settings.space-details.key.label": "系統索引鍵",
  "space-settings.space-details.name.label": "名稱",
  "space-settings.space-details.reset-changes.button.label": "重設變更",
  "space-settings.space-details.save.button.label": "儲存",
  "space-settings.space-details.space-alias.field-message.empty": "空間索引鍵不能空白",
  "space-settings.space-details.space-alias.field-message.exceeds-char": "空間索引鍵必須在 255 個字元以內",
  "space-settings.space-details.space-alias.field-message.symbols": "空間索引鍵只能是字母和數字",
  "space-settings.space-details.space-alias.missing-personal-space-identifier.error.message": "缺少個人空間識別碼",
  "space-settings.space-details.space-alias.unsupported-edition.error.message": "升級您的方案以變更空間索引鍵",
  "space-settings.space-details.space-icon.edit.label": "編輯圖示",
  "space-settings.space-details.space-icon.label": "空間圖示",
  "space-settings.space-details.space-icon.tooltip.label": "編輯空間圖示",
  "space-settings.space-details.space-key.info-section.description": "如果原始空間已刪除並從垃圾桶中清除，只有不同的空間可以重新使用其空間索引鍵。",
  "space-settings.space-details.space-key.info-section.title": "空間索引鍵不能重複。",
  "space-settings.space-details.space-key.label": "空間索引鍵",
  "space-settings.space-details.space-key.limitation-reached.error.message": "空間不能更新超過 10 次",
  "space-settings.space-details.space-owner.field-message.empty": "空間負責人不能空白",
  "space-settings.space-details.space-owner.label": "負責人",
  "space-settings.space-details.system-key.restriction.error.message": "系統索引鍵無法更新",
  "space-settings.space-details.title": "空間詳細資料",
  "space-settings.space-details.unknown-user.label": "未知使用者",
  "space-settings.space-details.update-disabled-error.flag.title": "此租戶中未啟用更新空間詳細資料的功能",
  "space-settings.space-labels-select.create-new-label-already-added": "「{inputValue}」類別已新增至空間",
  "space-settings.space-labels-select.get-categories-error": "類別未載入。請重新整理以再試一次。",
  "space-settings.space-labels-select.input-placeholder": "搜尋或建立類別",
  "space-settings.space-labels-select.labels-search-error": "建議並未載入。請嘗試再次寫入或重新整理頁面。",
  "space-settings.space-labels-selector.create-new-category": "建立新類別",
  "space-settings.space-labels-selector.placeholder": "新增類別",
  "space-settings.space-labels.error.validation.invalid-character": "類別不能包含「{invalidChar}」字元",
  "space-settings.space-labels.error.validation.length": "類別必須在 255 個字元以內。",
  "space-settings.space-roles-link-button": "管理使用者",
  "space-settings.space-settings-navigation.space-details-page.title": "空間詳細資料",
  "space-settings.sparring.blueprint.title": "唇槍舌戰",
  "space-settings.system-templates.header": "系統範本",
  "space-settings.template.edited.label": "(已編輯)",
  "space-settings.template.error.empty.message": "範本不能空白。",
  "space-settings.template.error.no-perms.message": "很抱歉，由於使用者權限不足，無法啟動範本動作。",
  "space-settings.template.error.not-found.message": "找不到範本。",
  "space-settings.template.sample-pages.title": "範例頁面",
  "space-settings.themes.critical-failure.description": "請重新整理 Confluence。",
  "space-settings.themes.critical-failure.title": "發生錯誤",
  "space-settings.themes.current-theme-title": "目前主題",
  "space-settings.themes.flag-error-title": "我們在更新您的設定時遇到問題，請再試一次",
  "space-settings.themes.flag-success-title": "設定已更新",
  "space-settings.themes.new-theme-title": "選擇新主題",
  "space-settings.themes.no-theme-desc": "如果您已安裝主題外掛程式，請確定其已正確放置在應用程式伺服器的 Classpath 中，而且其主題模組已在外掛程式組態中啟用。",
  "space-settings.themes.no-theme-title": "找不到任何主題。",
  "space-settings.themes.submit": "變更主題",
  "space-settings.themes.table-header-details": "詳細資料",
  "space-settings.themes.table-header-empty-state": "沒有可用的主題。",
  "space-settings.themes.table-header-icon": "圖示",
  "space-settings.title.column.label": "標題",
  "space-settings.to-do-list.blueprint.name": "待辦事項清單",
  "space-settings.toggle.tooltip": "啟用/停用藍圖",
  "space-settings.unpromote-template.button.label": "未推廣",
  "space-settings.unpromote-template.error.flag.title": "{templateTitle} 已成功取消推廣",
  "space-settings.unpromote-template.success.flag.title": "我們在取消推廣 {templateTitle} 時遇到問題，請再試一次",
  "space-settings.unpromote-template.tooltip.description": "您取消推廣的藍圖不會顯示在範本瀏覽器的「精選」和「已推廣」類別中。",
  "space-settings.update-template-description.error.flag.title": "我們在更新 {templateTitle} 的描述時遇到問題，請再試一次。",
  "space-settings.update-template-description.placeholder": "為您的範本提供描述",
  "space-settings.update-template-description.success.flag.title": "{templateTitle} 的描述已成功更新",
  "space-settings.user-created-templates.header": "使用者建立的範本",
  "space-settings.user-management.card-title": "使用者",
  "space-settings.user-management.card-title.non-final": "使用者",
  "space-settings.using-the-editor.blueprint.title": "使用編輯器",
  "space-settings.web-item-section.hub-permissions.web-item.title": "中心權限",
  "space-settings.web-item-section.look-and-feel.web-item.page-layout": "版面配置",
  "space-settings.web-item-section.space-permissions.web-item.anonymous-access": "匿名存取",
  "space-settings.web-item-section.space-permissions.web-item.groups": "群組",
  "space-settings.web-item-section.space-permissions.web-item.guests": "訪客",
  "space-settings.web-item-section.space-permissions.web-item.public-links": "公開連結",
  "space-settings.web-item-section.space-permissions.web-item.users": "使用者",
  "space-shortcuts.draggable-item.label": "{title} 可拖曳的項目",
  "space-shortcuts.no-shortcuts.message": "此空間中沒有快速鍵",
  "space-shortcuts.shortcuts.add.tooltip": "新增捷徑",
  "space-shortcuts.shortcuts.header": "捷徑",
  "space-shortcuts.shortcuts.quick-actions.remove": "移除",
  "space-shortcuts.side-nav-collapsible-header.tooltip": "Confluence 或網路內容的快速連結",
  "space-shortcuts.space-space-shortcuts.add-error-flag.description": "建立捷徑時發生錯誤。請重新整理，然後再試一次。",
  "space-shortcuts.space-space-shortcuts.add-error-flag.title": "無法新增捷徑",
  "space-shortcuts.space-space-shortcuts.add-success-flag.title": "已新增捷徑",
  "space-shortcuts.space-space-shortcuts.edit-error-flag.description": "更新捷徑時發生錯誤。請重新整理，然後再試一次。",
  "space-shortcuts.space-space-shortcuts.edit-error-flag.title": "無法編輯捷徑",
  "space-shortcuts.space-space-shortcuts.edit-success-flag.title": "捷徑已編輯",
  "space-shortcuts.space-space-shortcuts.remove-error-flag.description": "移除捷徑時發生錯誤。請重新整理，然後再試一次。",
  "space-shortcuts.space-space-shortcuts.remove-error-flag.title": "無法移除捷徑",
  "space-shortcuts.space-space-shortcuts.remove-success-flag.title": "捷徑已移除",
  "space-shortcuts.space-space-shortcuts.reorder-error-flag.description": "移動捷徑時發生錯誤。請重新整理，然後再試一次。",
  "space-shortcuts.space-space-shortcuts.reorder-error-flag.title": "捷徑無法重新排序",
  "space-shortcuts.space-space-shortcuts.reorder-success-flag.title": "捷徑已重新排序",
  "space-shortcuts.space-space-shortcuts.undo-action": "復原",
  "space-trash.page-banner.message": "這些項目中目前有任何項目值得儲存嗎？",
  "space-trash.page-banner.upsell-link-message": "嘗試封存",
  "space-views.a-z.desc": "標題 - A 到 Z",
  "space-views.checkmark.title": "已選取",
  "space-views.collapsible-section.title": "內容",
  "space-views.collapsible-section.title.tooltip": "在此空間中整理內容",
  "space-views.content-tree-search.clear-search": "清除搜尋",
  "space-views.content-tree-search.empty-message": "我們找不到具有該標題的任何內容",
  "space-views.content-tree-search.error-message": "發生錯誤。請再試一次。",
  "space-views.content-tree-search.input-description": "結果將在您輸入時更新。",
  "space-views.content-tree-search.placeholder": "依標題搜尋",
  "space-views.content-tree-search.results-count": "{count, plural, other {找到 {count} 個結果}}",
  "space-views.current-view.remove-label": "清除檢視",
  "space-views.current-view.text": "檢視：{currentView}",
  "space-views.current-view.unknown-label": "未知",
  "space-views.default": "預設值",
  "space-views.error.generic": "發生錯誤",
  "space-views.error.no-results": "沒有任何項目符合您的搜尋條件",
  "space-views.recently.modified.nonfinal": "上次更新",
  "space-views.recently.viewed": "我的造訪",
  "space-views.space.menu.title": "檢視",
  "space-views.space.menu.tooltip.content": "變更檢視畫面",
  "space-views.tree": "樹狀結構",
  "space-views.view.more": "檢視更多",
  "spaces-dropdown.advanced-search-link": "改為試用進階搜尋",
  "spaces-dropdown.current": "目前",
  "spaces-dropdown.empty": "檢視空間或建立空間後，這些空間就會出現在此處。",
  "spaces-dropdown.error": "我們目前無法顯示您的空間。請重新整理或稍後再試一次。",
  "spaces-dropdown.filter-placeholder": "篩選空間",
  "spaces-dropdown.no-results": "我們找不到您正在尋找的項目。",
  "spaces-dropdown.recent": "最近檢視過的項目",
  "spaces-dropdown.spaces-title": "空間",
  "spaces-dropdown.starred": "已標上星號",
  "spaces-dropdown.text-filter.clear.filter": "清除篩選條件",
  "spaces-dropdown.view-all": "檢視所有空間",
  "ssr-render-failure-notification.flag": "此頁面沒有 SSR 呈現！",
  "ssr-render-failure-notification.flag.branch.deploy.message": "偵測到可能過時的分支部署。您的 PR 變更可能無法準確地針對 SSR 進行測試。",
  "ssr-render-failure-notification.flag.generic.message": "原因：{reason}。",
  "ssr-render-failure-notification.hydration.flag": "此頁面尚未 Hydrate！",
  "ssr-render-failure-notification.hydration.flag.message": "若要檢視 hydration 不符的地方，請參閱瀏覽器主控台中的 window.__HYDRATION_ERRORS__。",
  "ssr-render-failure-notification.hydration.runbook.link": "若要了解如何針對不相符的地方進行除錯，請參閱<runbookLink>此頁面</runbookLink>。",
  "ssr-render-failure-notification.runbook.link": "若要了解如何針對此錯誤除錯，請參閱<runbookLink>此頁面</runbookLink>。",
  "storage-enforcement.banner.admin.hard.enforced.message": "需要採取行動。除非您升級以獲得更多儲存空間或刪除 <b>{number} GB</b> 的檔案，否則您無法在 Confluence 中編輯或建立新內容。<a>升級至 Standard 方案</a>",
  "storage-enforcement.banner.admin.hard.message.v2": "需要採取行動。您很快就會無法在 Confluence 中建立內容，除非升級以獲得更多儲存空間，或刪除 <b>{number} GB</b> 的檔案 ({date} 以前)。<a>升級至 Standard 方案</a>",
  "storage-enforcement.banner.button.dismiss": "關閉",
  "storage-enforcement.banner.button.upgrade-for-more-storage": "升級以獲得更多儲存空間",
  "storage-enforcement.banner.learn-more": "深入了解",
  "storage-enforcement.banner.nth-user.hard.enforced.message": "需要採取行動。在刪除檔案之前，您無法在 Confluence 中編輯或建立新內容。<a>深入了解</a>",
  "storage-enforcement.banner.nth-user.hard.message": "需要採取行動。除非您在 {date} 之前刪除檔案，否則很快就會無法在 Confluence 中建立內容。<a>深入了解</a>",
  "storage-enforcement.banner.soft.message.over": "你已超過 Free 方案的 2GB 儲存空間限制。",
  "storage-enforcement.banner.soft.message.under.v2": "在 Free 方案的 2 GB 儲存空間限制中，您已使用了 <b>{number}%</b>。",
  "storage-enforcement.block-create-modal.additional-features": "Standard 方案的其他功能包括：",
  "storage-enforcement.block-create-modal.description": "您已達到 Confluence Free 方案的 2 GB 儲存空間上限。在獲得更多儲存空間之前，您將無法編輯或建立任何新內容。升級到 Standard 方案並獲得 250 GB 的儲存空間，或刪除 <b>{currentUsage}GB</b> 的現有檔案。",
  "storage-enforcement.block-create-modal.features.collaboration": "訪客協作",
  "storage-enforcement.block-create-modal.features.permissions": "空間和內容權限",
  "storage-enforcement.block-create-modal.features.userLimits": "高達 50,000 名使用者",
  "storage-enforcement.block-create-modal.heading": "需要採取行動：您無法新增內容",
  "storage-enforcement.flags.buttons.learn-more": "深入了解",
  "storage-enforcement.flags.buttons.try-standard": "免費試用 Standard 方案",
  "storage-enforcement.flags.buttons.upgrade-for-more-storage": "升級以獲得更多儲存空間",
  "storage-enforcement.flags.description": "為避免空間不足，請升級至 Confluence Standard 以取得 250 GB 的儲存空間。",
  "storage-enforcement.flags.title": "您已使用 {percentage}% 的儲存空間",
  "storage-enforcement.icons.close": "「關閉」圖示",
  "storage-enforcement.icons.more": "更多圖示",
  "storage-enforcement.policy-changes-modal.admin.description.body": "您很快就會無法編輯或建立新內容。您不會遺失檔案，但需要升級至 Standard 方案並取得 250 GB 的儲存空間，或刪除檔案以清除儲存空間。",
  "storage-enforcement.policy-changes-modal.button.learn-more": "了解如何清除儲存空間",
  "storage-enforcement.policy-changes-modal.button.upgrade": "免費試用 Standard 方案",
  "storage-enforcement.policy-changes-modal.description.header.V2": "您超過 Confluence Free 方案的儲存空間上限 <b>{number} GB ({percentage}%)</b>。",
  "storage-enforcement.policy-changes-modal.heading": "需採取動作：您需要更多儲存空間",
  "storage-enforcement.policy-changes-modal.nth-user.description.body": "您很快就會無法編輯或建立新內容。您不會遺失檔案，但請要求管理員升級至 Standard 方案並取得 250 GB 的儲存空間，或刪除檔案以清除部分儲存空間。",
  "suggested-comment-prompts.ai-feedback-collector.can-contact.label": "Atlassian 可以連絡我來了解此意見反應。請參閱我們的<a>隱私政策</a>。",
  "suggested-comment-prompts.ai-feedback-collector.flag-description": "您的意見反應很珍貴，能幫助我們持續改善產品。",
  "suggested-comment-prompts.ai-feedback-collector.flag-title": "謝謝！",
  "suggested-comment-prompts.ai-feedback-collector.improve-atlassian": "我希望加入 <a>Atlassian 研究團隊</a>，以協助改善 Atlassian 產品。",
  "suggested-comment-prompts.ai-feedback-collector.summary-placeholder": "讓我們知道您嘗試執行的動作，以及該功能如何改善",
  "suggested-comment-prompts.ai-feedback-collector.title": "協助我們讓 Atlassian Intelligence 更臻完美",
  "suggested-comment-prompts.ai-feedback-collector.user-consent-checkbox-label": "在意見反應中包含我的最後一個提示和回應。",
  "super-admin.banner.exit": "停止使用管理員金鑰",
  "super-admin.banner.message": "您使用的是管理員金鑰，可讓您暫時存取受限制的內容。",
  "super-admin.disable.super.admin.error.description-with-link": "如果這個問題持續發生，請透過 {atlassianSupportLink} 通知我們",
  "super-admin.disable.super.admin.error.title": "發生錯誤",
  "super-admin.enable.super.admin.error.description": "請重新整理，然後再試一次。",
  "super-admin.enable.super.admin.error.title": "發生錯誤",
  "super-admin.entry.point.message": "身為 Premium 的 {canBeSuperAdmin}，您可以使用管理員金鑰來檢視受限制的內容。我們會記錄您檢視的任何受限內容，並通知負責人。",
  "super-admin.entry.point.message.can-be-super-admin": "網站管理員",
  "super-admin.entry.point.title": "使用管理員金鑰立即檢視",
  "super-admin.learn.more": "深入了解",
  "super-admin.satisfaction.survey.button.close": "關閉",
  "super-admin.satisfaction.survey.button.submit": "提交",
  "super-admin.satisfaction.survey.final.description": "您的意見反應已提交",
  "super-admin.satisfaction.survey.final.title": "謝謝",
  "super-admin.satisfaction.survey.question.bad": "我們很遺憾得知這個消息。出了什麼問題？(選擇性)",
  "super-admin.satisfaction.survey.question.good": "謝謝您！您喜歡其中哪一個部分？有什麼可以改進的嗎？(選擇性)",
  "super-admin.satisfaction.survey.reaction.amazing": "了不起",
  "super-admin.satisfaction.survey.reaction.bad": "不佳",
  "super-admin.satisfaction.survey.reaction.great": "太棒了",
  "super-admin.satisfaction.survey.reaction.okay": "確定",
  "super-admin.satisfaction.survey.reaction.terrible": "糟糕",
  "super-admin.satisfaction.survey.title": "您的管理員金鑰體驗如何？",
  "super-admin.session.expiration.description": "您已經有一段時間沒有使用了。為了保護資訊安全，我們已終止您對受限內容的存取權。",
  "super-admin.session.expiration.title": "受限制內容的存取權已終止",
  "super-admin.start.session": "立即檢視",
  "super-admin.timeout.super.admin.description": "由於非使用狀態，您將在 {counter} 中被登出。",
  "super-admin.timeout.super.admin.description.counter": "{count, plural, =0 {0 秒} other {{count,number} 秒}}",
  "super-admin.timeout.super.admin.title": "還在嗎？",
  "super-admin.timer.flag.action": "繼續使用管理員金鑰",
  "super-admin.upsell.message": "Premium 方案的 {canBeSuperAdmins} 可以使用管理員金鑰來暫時存取受限的內容，以便快速針對問題進行疑難排解與修正。",
  "super-admin.upsell.message.can-be-super-admins": "網站管理員",
  "super-admin.upsell.title": "升級以取得管理員金鑰",
  "table-of-contents.empty-toc": "將標題新增到此頁面，標題會立即顯示在此處。",
  "table-of-contents.live-page-empty-toc": "將標題新增到此文件，標題會立即顯示在此處。",
  "team-calendar.CalendarToolbar.addEvent": "新增事件",
  "team-calendar.CalendarToolbar.today": "今天",
  "team-calendar.add": "新增",
  "team-calendar.admin.delete-subscriptions.button.name": "刪除所有行事曆訂閱",
  "team-calendar.auth-warning.buttonText": "登入",
  "team-calendar.auth-warning.popup": "登入並核准存取權，以顯示 {server} 的資料",
  "team-calendar.auth-warning.title": "核准存取權，以顯示 {server} 的資料",
  "team-calendar.calendar-toolbar.next-button-label": "查看後續日期",
  "team-calendar.calendar-toolbar.prev-button-label": "查看先前的日期",
  "team-calendar.calendar-toolbar.share-title": "團隊行事曆",
  "team-calendar.calendar-view.list": "清單",
  "team-calendar.calendar-view.month": "月份",
  "team-calendar.calendar-view.timeline": "時間軸",
  "team-calendar.calendar-view.week": "週",
  "team-calendar.calendar.actions.addEventLowercase": "新增事件",
  "team-calendar.calendar.actions.addExistingCalendar": "新增現有行事曆",
  "team-calendar.calendar.actions.addNewCalendar": "新增行事曆",
  "team-calendar.calendar.actions.apply": "套用",
  "team-calendar.calendar.actions.delete": "刪除",
  "team-calendar.calendar.actions.edit": "編輯",
  "team-calendar.calendar.actions.embed": "嵌入",
  "team-calendar.calendar.actions.errorFlagFailedToDeleteEventDescription": "無法刪除事件",
  "team-calendar.calendar.actions.errorFlagFailedToResetSubscribeLinkDescription": "無法重設行事曆訂閱連結",
  "team-calendar.calendar.actions.errorFlagFailedToUpdateHiddenCalStateDescription": "無法更新行事曆的顯示/隱藏喜好設定",
  "team-calendar.calendar.actions.errorFlagFailedToUpdateWatchCalStateDescription": "無法更新行事曆的追蹤喜好設定",
  "team-calendar.calendar.actions.eventTypesLowercase": "事件類型",
  "team-calendar.calendar.actions.export": "匯出至 iCalendar",
  "team-calendar.calendar.actions.exportCalendar": "匯出至 iCalendar",
  "team-calendar.calendar.actions.exportCalendarTitle": "以 iCalendar 格式匯出行事曆",
  "team-calendar.calendar.actions.generalSettings": "一般設定",
  "team-calendar.calendar.actions.genericErrorFlagTitle": "錯誤",
  "team-calendar.calendar.actions.hideEvents": "隱藏事件",
  "team-calendar.calendar.actions.importCalendar": "匯入行事曆",
  "team-calendar.calendar.actions.loadingWatchingStatus": "載入追蹤狀態",
  "team-calendar.calendar.actions.refresh": "重新整理",
  "team-calendar.calendar.actions.remove": "移除",
  "team-calendar.calendar.actions.restrictions": "限制",
  "team-calendar.calendar.actions.showEvents": "顯示事件",
  "team-calendar.calendar.actions.subscribe": "訂閱",
  "team-calendar.calendar.actions.subscribeByURL": "依 URL 訂閱",
  "team-calendar.calendar.actions.unwatch": "停止追蹤",
  "team-calendar.calendar.actions.watch": "追蹤",
  "team-calendar.calendar.actions.watchedviacontent": "正在透過內容追蹤",
  "team-calendar.calendar.apr": "四月",
  "team-calendar.calendar.april": "四月",
  "team-calendar.calendar.aug": "八月",
  "team-calendar.calendar.august": "八月",
  "team-calendar.calendar.day": "天",
  "team-calendar.calendar.dec": "十二月",
  "team-calendar.calendar.december": "十二月",
  "team-calendar.calendar.empty.no-calendar": "您尚未建立或新增任何現有的行事曆。",
  "team-calendar.calendar.error.genericErrorMessage": "糟糕！發生錯誤！請傳送錯誤報告，協助我們改善您的體驗。",
  "team-calendar.calendar.event-type-placeholder": "選取事件",
  "team-calendar.calendar.feb": "二月",
  "team-calendar.calendar.february": "二月",
  "team-calendar.calendar.filter.user.empty": "開始輸入以搜尋使用者",
  "team-calendar.calendar.fri": "週五",
  "team-calendar.calendar.friday": "星期五",
  "team-calendar.calendar.jan": "一月",
  "team-calendar.calendar.january": "一月",
  "team-calendar.calendar.jul": "七月",
  "team-calendar.calendar.july": "七月",
  "team-calendar.calendar.jun": "六月",
  "team-calendar.calendar.june": "六月",
  "team-calendar.calendar.learnMore": "深入瞭解",
  "team-calendar.calendar.mar": "三月",
  "team-calendar.calendar.march": "三月",
  "team-calendar.calendar.may": "五月",
  "team-calendar.calendar.mon": "週一",
  "team-calendar.calendar.monday": "星期一",
  "team-calendar.calendar.no-event-types-option": "此行事曆沒有可用的事件類型。",
  "team-calendar.calendar.no-option": "您尚未建立任何行事曆。",
  "team-calendar.calendar.nov": "十一月",
  "team-calendar.calendar.november": "十一月",
  "team-calendar.calendar.oct": "十月",
  "team-calendar.calendar.october": "十月",
  "team-calendar.calendar.sat": "週六",
  "team-calendar.calendar.saturday": "星期六",
  "team-calendar.calendar.sep": "九月",
  "team-calendar.calendar.september": "九月",
  "team-calendar.calendar.sun": "週日",
  "team-calendar.calendar.sunday": "星期日",
  "team-calendar.calendar.thu": "週四",
  "team-calendar.calendar.thursday": "星期四",
  "team-calendar.calendar.tooltip-text.how-to-unwatch": "若要停止追蹤此行事曆，您必須停止追蹤嵌入此行事曆的空間或頁面。",
  "team-calendar.calendar.tooltip-text.how-to-unwatch.livedocs": "若要停止追蹤此行事曆，您必須停止追蹤嵌入此行事曆的空間、頁面或即時文件。",
  "team-calendar.calendar.tue": "週二",
  "team-calendar.calendar.tuesday": "星期二",
  "team-calendar.calendar.wed": "週三",
  "team-calendar.calendar.wednesday": "星期三",
  "team-calendar.cancel": "取消",
  "team-calendar.color.picker.label.blue": "藍色",
  "team-calendar.color.picker.label.bold.blue": "個性藍",
  "team-calendar.color.picker.label.bold.gray": "個性灰",
  "team-calendar.color.picker.label.bold.green": "個性綠",
  "team-calendar.color.picker.label.bold.orange": "個性橘",
  "team-calendar.color.picker.label.bold.purple": "個性紫",
  "team-calendar.color.picker.label.bold.red": "個性紅",
  "team-calendar.color.picker.label.bold.teal": "個性藍綠",
  "team-calendar.color.picker.label.gray": "灰色",
  "team-calendar.color.picker.label.green": "綠色",
  "team-calendar.color.picker.label.orange": "橘色",
  "team-calendar.color.picker.label.purple": "紫色",
  "team-calendar.color.picker.label.red": "紅色",
  "team-calendar.color.picker.label.subtle.blue": "內斂藍",
  "team-calendar.color.picker.label.subtle.gray": "內斂灰",
  "team-calendar.color.picker.label.subtle.green": "內斂綠",
  "team-calendar.color.picker.label.subtle.orange": "內斂橘",
  "team-calendar.color.picker.label.subtle.purple": "內斂紫",
  "team-calendar.color.picker.label.subtle.red": "內斂紅",
  "team-calendar.color.picker.label.subtle.teal": "內斂藍綠",
  "team-calendar.color.picker.label.teal": "藍綠色",
  "team-calendar.components.events-creation.expander-text": "進階",
  "team-calendar.components.shared.calendarError": "無法載入其中事件：",
  "team-calendar.components.shared.errorGenericBody": "請稍後再試一次。",
  "team-calendar.components.shared.errorGenericTitle": "發生錯誤。",
  "team-calendar.components.sidebar.action-modal-windows.add-existing-calendar.add-description": "從 Confluence 空間中尋找行事曆，並將其新增至所有行事曆檢視。您也可以瀏覽 {popularCalendarWording}。",
  "team-calendar.components.sidebar.action-modal-windows.add-existing-calendar.add-title": "新增現有行事曆",
  "team-calendar.components.sidebar.action-modal-windows.add-existing-calendar.calendar": "行事曆",
  "team-calendar.components.sidebar.action-modal-windows.add-existing-calendar.description": "描述",
  "team-calendar.components.sidebar.action-modal-windows.add-existing-calendar.no-results": "我們找不到任何符合您搜尋的項目。",
  "team-calendar.components.sidebar.action-modal-windows.add-existing-calendar.no-results-try-again": "請使用其他名稱再試一次。",
  "team-calendar.components.sidebar.action-modal-windows.add-existing-calendar.popular-calendars": "熱門行事曆",
  "team-calendar.components.sidebar.action-modal-windows.add-existing-calendar.popular-calendars-description": "以下是您可能有興趣的熱門團隊行事曆清單。您也可以 {searchForOtherCalendarsWording} 或 {createCalendarWording}。",
  "team-calendar.components.sidebar.action-modal-windows.add-existing-calendar.popular-calendars-description-create": "建立您自己的行事曆",
  "team-calendar.components.sidebar.action-modal-windows.add-existing-calendar.popular-calendars-description-search": "搜尋行事曆",
  "team-calendar.components.sidebar.action-modal-windows.add-existing-calendar.popular-calendars-no-result": "我們找不到任何熱門行事曆。",
  "team-calendar.components.sidebar.action-modal-windows.add-existing-calendar.popular-calendars-search-all": "您也可以{searchForCalendarsWording}。",
  "team-calendar.components.sidebar.action-modal-windows.add-existing-calendar.popular-calendars-search-for-calendars": "搜尋行事曆",
  "team-calendar.components.sidebar.action-modal-windows.add-existing-calendar.popular-calendars-watch-selected-calendars": "追蹤所選行事曆",
  "team-calendar.components.sidebar.action-modal-windows.add-existing-calendar.relatedSpace": "相關空間",
  "team-calendar.components.sidebar.action-modal-windows.add-existing-calendar.subscribers": "訂閱者",
  "team-calendar.components.sidebar.action-modal-windows.add-existing-calendar.suggested-calendars": "建議行事曆",
  "team-calendar.components.sidebar.action-modal-windows.create-modal.invalidInterval": "無效的間隔數目",
  "team-calendar.components.sidebar.action-modal-windows.create-modal.sameDate": "請為每個期間選取不同的欄位。",
  "team-calendar.components.sidebar.action-modal-windows.delete-calendar.cancel": "取消",
  "team-calendar.components.sidebar.action-modal-windows.delete-calendar.confirm": "確定要刪除 \"{calendarName}\" 嗎？",
  "team-calendar.components.sidebar.action-modal-windows.delete-calendar.title": "刪除行事曆",
  "team-calendar.components.sidebar.action-modal-windows.delete-calendar.warning": "從您的行事曆中移除這些事件並不會在 Jira 中將其刪除。如果您改變主意，可以稍後將其加回此行事曆。",
  "team-calendar.components.sidebar.action-modal-windows.edit-modal.create-title": "建立行事曆",
  "team-calendar.components.sidebar.action-modal-windows.edit-modal.edit-title": "編輯行事曆",
  "team-calendar.components.sidebar.action-modal-windows.edit-modal.emptyField": "欄位不可空白",
  "team-calendar.components.sidebar.action-modal-windows.edit-modal.timezone": "時區",
  "team-calendar.components.sidebar.action-modal-windows.edit-modal.timezone-loading": "正在載入時區...",
  "team-calendar.components.sidebar.action-modal-windows.edit-modal.timezone-not-found": "找不到時區",
  "team-calendar.components.sidebar.action-modal-windows.import-calendar.calendar-name": "行事曆名稱",
  "team-calendar.components.sidebar.action-modal-windows.import-calendar.calendar-name-helper-message": "若要使用 ICS 檔案中的行事曆名稱，請將此保留空白。",
  "team-calendar.components.sidebar.action-modal-windows.import-calendar.description": "描述",
  "team-calendar.components.sidebar.action-modal-windows.import-calendar.import-ical": "上傳 iCal",
  "team-calendar.components.sidebar.action-modal-windows.import-calendar.name-to-long": "{numberCharacters, plural, other {行事曆名稱長度大於 {numberCharacters,number} 個字元}}",
  "team-calendar.components.sidebar.action-modal-windows.import-calendar.no-timezone-description": "無法判斷此行事曆的時區。請在下面設定時區。",
  "team-calendar.components.sidebar.action-modal-windows.import-calendar.no-timezone-title": "無法判斷行事曆時區",
  "team-calendar.components.sidebar.action-modal-windows.import-calendar.select-a-file": "從您的電腦中選取檔案",
  "team-calendar.components.sidebar.action-modal-windows.import-calendar.space": "空間",
  "team-calendar.components.sidebar.action-modal-windows.import-calendar.space-description": "將此行事曆連結至空間",
  "team-calendar.components.sidebar.action-modal-windows.import-calendar.title": "匯入行事曆",
  "team-calendar.components.sidebar.action-modal-windows.import-calendar.upload-choose-file": "選擇檔案",
  "team-calendar.components.sidebar.action-modal-windows.remove": "移除",
  "team-calendar.components.sidebar.action-modal-windows.remove-calendar.title": "移除 Jira 事件？",
  "team-calendar.components.sidebar.action-modal-windows.subscribe-url-modal.edit-subscribe-title": "編輯訂閱",
  "team-calendar.components.sidebar.action-modal-windows.subscribe-url-modal.help": "說明",
  "team-calendar.components.sidebar.action-modal-windows.subscribe-url-modal.password": "密碼",
  "team-calendar.components.sidebar.action-modal-windows.subscribe-url-modal.subscribe-title": "訂閱",
  "team-calendar.components.sidebar.action-modal-windows.subscribe-url-modal.url": "iCal URL",
  "team-calendar.components.sidebar.action-modal-windows.subscribe-url-modal.username": "使用者名稱",
  "team-calendar.components.sidebar.action-modal-windows.subscribe.support-link": "深入了解團隊行事曆",
  "team-calendar.components.sidebar.calendar-creation-success-flag.action": "新增事件",
  "team-calendar.components.sidebar.calendar-creation-success-flag.icon-label": "成功",
  "team-calendar.components.sidebar.calendar-creation-success-flag.title": "已成功建立行事曆",
  "team-calendar.components.timelineview.timelineview": "無法更新事件",
  "team-calendar.create": "建立",
  "team-calendar.date-time-selection.edit-this-instance-only.warning": "編輯後，無法改回重複發生的事件。",
  "team-calendar.delete-calendar.cancel": "取消",
  "team-calendar.delete-calendar.delete": "刪除",
  "team-calendar.delete-calendar.header": "刪除行事曆",
  "team-calendar.delete-calendar.messageSubscriberCount": "{number, plural, =0 {\n      您確定要刪除 {calendarName} 行事曆嗎？所有訂閱者都會收到 iCalendar 匯出項目。} other {已有 {number} 個人訂閱 {calendarName}。\n您確定要刪除 {calendarName} 行事曆嗎？所有訂閱者都將會收到 iCalendar 匯出項目。}}",
  "team-calendar.delete-calendar.warningRemoveFromMyCal": "從您所有的行事曆檢視中移除 {calendarName} 行事曆。",
  "team-calendar.delete-calendar.warningRemoveFromSpace": "從此空間移除 {calendarName} 行事曆。",
  "team-calendar.delete-event.all-future": "所有未來的執行個體",
  "team-calendar.delete-event.all-future-message": "將會移除這個執行個體和未來的所有執行個體。",
  "team-calendar.delete-event.all-instances": "系列中的所有執行個體",
  "team-calendar.delete-event.all-instances-message": "將會移除整個系列。",
  "team-calendar.delete-event.cancel": "取消",
  "team-calendar.delete-event.confirm": "是，刪除",
  "team-calendar.delete-event.confirmation-message": "您確定嗎？此動作無法復原。",
  "team-calendar.delete-event.delete": "刪除",
  "team-calendar.delete-event.header": "刪除事件",
  "team-calendar.delete-event.recurring-header": "刪除週期性事件",
  "team-calendar.delete-event.this-instance": "僅限此執行個體",
  "team-calendar.delete-event.this-instance-message": "此系列中的所有其他事件將維持不變。",
  "team-calendar.delete-subscriptions.error": "我們在刪除您的行事曆訂閱時遇到問題，請再試一次。",
  "team-calendar.delete-subscriptions.success": "已刪除行事曆訂閱",
  "team-calendar.delete-subscriptions.title": "刪除訂閱",
  "team-calendar.developer.internal-empty-message": "_",
  "team-calendar.disable-private-urls.label": "停用私密 URL",
  "team-calendar.done": "完成",
  "team-calendar.event-creation.date.allDayEvent": "全天事件",
  "team-calendar.event-creation.date.dateRangeValidationMessage": "指定的日期範圍無效。",
  "team-calendar.event-creation.date.dateTimeRangeValidationMessage": "事件必須在開始後結束",
  "team-calendar.event-creation.date.dateValidationMessage": "指定的日期無效。",
  "team-calendar.event-creation.date.endDate": "結束日期",
  "team-calendar.event-creation.date.endTime": "結束時間",
  "team-calendar.event-creation.date.errorEndDateNotEqualStartDate": "事件開始日期和結束日期必須相符",
  "team-calendar.event-creation.date.startDate": "開始日期",
  "team-calendar.event-creation.date.startTime": "開始時間",
  "team-calendar.event-creation.date.timeRangeValidationMessage": "指定的時間範圍無效。",
  "team-calendar.event-creation.date.timeValidationMessage": "指定的時間無效。",
  "team-calendar.event-creation.dayOfWeekValidationMessage": "此欄位為必填欄位",
  "team-calendar.event-creation.descriptionLabel": "描述",
  "team-calendar.event-creation.descriptionValidationMessage": "請輸入此事件的說明",
  "team-calendar.event-creation.editThisInstanceOnly": "僅限編輯此執行個體",
  "team-calendar.event-creation.jira.eventName": "名稱",
  "team-calendar.event-creation.jira.project": "專案",
  "team-calendar.event-creation.jira.server": "伺服器",
  "team-calendar.event-creation.jiraDateFieldValidationMessage": "請至少選取一個日期或日期範圍",
  "team-calendar.event-creation.jiraDateRange": "日期範圍",
  "team-calendar.event-creation.jiraDateSingle": "單一日期",
  "team-calendar.event-creation.jiraDisplayValidationMessage": "請選取顯示選項",
  "team-calendar.event-creation.jiraEventDisplay": "顯示",
  "team-calendar.event-creation.jiraEventDisplayJQL": "JQL",
  "team-calendar.event-creation.jiraEventDisplayProject": "專案",
  "team-calendar.event-creation.jiraEventDisplaySavedFilter": "已儲存的篩選條件",
  "team-calendar.event-creation.jiraEventNameValidationMessage": "請輸入名稱",
  "team-calendar.event-creation.jiraProjectDateDurationCreatingCustomDates": "建立自訂日期",
  "team-calendar.event-creation.jiraProjectDateDurationHelp": "在 Calendar 中，您可以將兩個議題日期之間的持續時間視覺化。深入了解 {creatingCustomDatesWording}。",
  "team-calendar.event-creation.jiraProjectDateFields": "顯示",
  "team-calendar.event-creation.jiraProjectDateRangeEndField": "結束日期",
  "team-calendar.event-creation.jiraProjectDateRangeRemove": "移除開始與結束日期",
  "team-calendar.event-creation.jiraProjectDateRangeStartField": "開始日期",
  "team-calendar.event-creation.jiraProjectValidationMessage": "請選取 Jira 專案",
  "team-calendar.event-creation.jiraProjectsLoading": "正在載入 Jira 專案清單",
  "team-calendar.event-creation.jiraProjectsNotFound": "找不到 Jira 專案",
  "team-calendar.event-creation.jiraServerValidationMessage": "請選取 Jira 伺服器",
  "team-calendar.event-creation.jiraServersLoading": "正在載入 Jira 伺服器清單",
  "team-calendar.event-creation.jiraServersNotFound": "找不到 Jira Server",
  "team-calendar.event-creation.jql.invalidJql": "無效的 JQL",
  "team-calendar.event-creation.jql.validJql": "有效的 JQL",
  "team-calendar.event-creation.jql.validatingJql": "正在驗證 JQL...",
  "team-calendar.event-creation.jqlField": "JQL",
  "team-calendar.event-creation.relatedPage.invalidPageOrUrlValidationMessage": "無效的 Confluence 項目或 URL。",
  "team-calendar.event-creation.relatedPageLabel": "相關內容",
  "team-calendar.event-creation.singleDate": "需要勾選一個日期",
  "team-calendar.event-creation.titleLabel": "標題",
  "team-calendar.event-creation.titleValidationMessage": "請輸入此事件的標題",
  "team-calendar.event-creation.whereLabel": "位置",
  "team-calendar.event-creation.whereValidationMessage": "請輸入此事件的位置",
  "team-calendar.event-creation.wholabel": "誰",
  "team-calendar.event-frequency.daily": "每日",
  "team-calendar.event-frequency.doesntRepeat": "不重複",
  "team-calendar.event-frequency.label.after": "晚於",
  "team-calendar.event-frequency.label.never": "永不",
  "team-calendar.event-frequency.label.onDate": "日期",
  "team-calendar.event-frequency.label.sameDate": "相同日期",
  "team-calendar.event-frequency.label.sameDayEachMonth": "每月同一天",
  "team-calendar.event-frequency.label.times": "次數",
  "team-calendar.event-frequency.monthly": "每月",
  "team-calendar.event-frequency.repeat.every-n-day": "天",
  "team-calendar.event-frequency.repeat.every-n-month": "月",
  "team-calendar.event-frequency.repeat.every-n-week": "週",
  "team-calendar.event-frequency.repeat.every-n-yearly": "年",
  "team-calendar.event-frequency.repeat.every-other-day": "其他天",
  "team-calendar.event-frequency.repeat.every-other-weekdays": "重複間隔為每個工作日",
  "team-calendar.event-frequency.repeat.every-x-day": "{number} 天",
  "team-calendar.event-frequency.repeat.every-x-weeks-on-weekdays": "{number, plural, other {在每隔 {number,number} 週的工作日重複}}",
  "team-calendar.event-frequency.repeat.friday": "星期五",
  "team-calendar.event-frequency.repeat.monday": "星期一",
  "team-calendar.event-frequency.repeat.saturday": "星期六",
  "team-calendar.event-frequency.repeat.sunday": "星期日",
  "team-calendar.event-frequency.repeat.thursday": "星期四",
  "team-calendar.event-frequency.repeat.tuesday": "星期二",
  "team-calendar.event-frequency.repeat.wednesday": "星期三",
  "team-calendar.event-frequency.repeat.weekdays": "在工作日重複",
  "team-calendar.event-frequency.title.endRepeat": "結束重複",
  "team-calendar.event-frequency.title.repeat.every.other.month.by.day": "每兩個月的重複時間：",
  "team-calendar.event-frequency.title.repeat.every.xmonths.by.day": "每 {interval} 個月的重複時間：",
  "team-calendar.event-frequency.title.repeat.monthly.by.day": "每月重複時間：",
  "team-calendar.event-frequency.title.repeatDaily": "每天重複",
  "team-calendar.event-frequency.title.repeatEvent": "重複事件",
  "team-calendar.event-frequency.title.repeatEvery": "重複間隔",
  "team-calendar.event-frequency.title.repeatEveryOther": "重複間隔為每個",
  "team-calendar.event-frequency.title.repeatEveryOtherDay": "每隔一天重複",
  "team-calendar.event-frequency.title.repeatEveryOtherMonth": "在每隔一個月的第 {number} 天重複",
  "team-calendar.event-frequency.title.repeatEveryOtherYear": "每隔一年重複",
  "team-calendar.event-frequency.title.repeatEveryXDay": "{number, plural, other {每隔 {number,number} 天重複}}",
  "team-calendar.event-frequency.title.repeatEveryXMonths": "在每隔 {interval} 個月的第 {number} 天重複",
  "team-calendar.event-frequency.title.repeatEveryXWeeks": "{number, plural, other {重複間隔為每 {number,number} 週的}}",
  "team-calendar.event-frequency.title.repeatEveryXWeeksDaily": "{number, plural, other {每 {number,number} 週的每一天重複}}",
  "team-calendar.event-frequency.title.repeatEveryXYear": "{number, plural, other {每隔 {number,number} 年重複}}",
  "team-calendar.event-frequency.title.repeatEveryYear": "每年重複",
  "team-calendar.event-frequency.title.repeatMonthly": "在每個月的第 {number} 天重複",
  "team-calendar.event-frequency.title.repeatOn": "重複頻率",
  "team-calendar.event-frequency.weekly": "每週",
  "team-calendar.event-frequency.yearly": "每年",
  "team-calendar.event-popup.all-day": "全天",
  "team-calendar.event-popup.assignee": "受託人",
  "team-calendar.event-popup.issue-date": "議題截止日期",
  "team-calendar.event-popup.more-actions": "更多動作",
  "team-calendar.event-popup.release-notes": "版本資訊",
  "team-calendar.event-popup.repeats-message": "重複間隔",
  "team-calendar.event-popup.show-all-guest": "顯示所有訪客",
  "team-calendar.event-popup.show-less-guest": "顯示較少訪客",
  "team-calendar.event-popup.status": "狀態",
  "team-calendar.event-popup.summary": "摘要",
  "team-calendar.event-popup.unassigned": "未指派",
  "team-calendar.event-popup.view-issue": "檢視議題",
  "team-calendar.event-popup.view-issues": "檢視議題",
  "team-calendar.event-reminder-notification-status-switch-modal.cancel": "取消",
  "team-calendar.event-reminder-notification-status-switch-modal.confirm": "是",
  "team-calendar.event-reminder-notification-status-switch-modal.confirmation-message-off": "您將停止在「{calendarName}」中接收有關此事件的電子郵件提醒。",
  "team-calendar.event-reminder-notification-status-switch-modal.confirmation-message-on": "您將在「{calendarName}」中接收有關此事件的電子郵件提醒。",
  "team-calendar.event-reminder-notification-status-switch-modal.title-off": "要關閉「{childSubcalendarName}」的電子郵件通知嗎？",
  "team-calendar.event-reminder-notification-status-switch-modal.title-on": "要開啟「{childSubcalendarName}」的電子郵件通知嗎？",
  "team-calendar.event-types.allThings": "所有項目",
  "team-calendar.event-types.birthdays": "生日",
  "team-calendar.event-types.events": "事件",
  "team-calendar.event-types.jiraAgileSprints": "Jira Agile 衝刺",
  "team-calendar.event-types.jiraIssueDates": "Jira 議題日期",
  "team-calendar.event-types.jiraProjectReleases": "Jira 專案版本",
  "team-calendar.event-types.leaves": "休假",
  "team-calendar.event-types.travels": "旅遊",
  "team-calendar.events-creation.add-new-event-type-label": "新增事件類型",
  "team-calendar.events-creation.calendar-label": "行事曆",
  "team-calendar.events-creation.cancel-event": "取消",
  "team-calendar.events-creation.create-event": "建立事件",
  "team-calendar.events-creation.event-type-label": "事件類型",
  "team-calendar.events-creation.save-event": "儲存",
  "team-calendar.evt-types.actions": "動作",
  "team-calendar.evt-types.add.custom.event.type": "新增自訂事件類型",
  "team-calendar.evt-types.custom": "自訂事件類型",
  "team-calendar.evt-types.delete.custom.event.type.confirmation": "這會刪除所有事件，並從行事曆中移除此類型的事件。這無法復原。您確定嗎？",
  "team-calendar.evt-types.delete.custom.event.type.confirmed": "是，請刪除",
  "team-calendar.evt-types.delete.custom.event.type.header": "刪除事件類型",
  "team-calendar.evt-types.edit-email-reminder.label": "編輯 {eventType} 的電子郵件提醒",
  "team-calendar.evt-types.event-types": "事件類型",
  "team-calendar.evt-types.event-types.manage": "管理事件類型",
  "team-calendar.evt-types.modal.header": "新增、編輯或移除 {subCalName} 行事曆的事件類型。",
  "team-calendar.evt-types.placeholder": "事件類型名稱",
  "team-calendar.evt-types.reminder": "電子郵件提醒",
  "team-calendar.evt-types.show-hide": "顯示/隱藏",
  "team-calendar.evt-types.textfield.label": "事件類型：{eventTypeName}",
  "team-calendar.evt-types.toggle.off.label": "隱藏 {eventTypeName}",
  "team-calendar.evt-types.toggle.on.label": "顯示 {eventTypeName}",
  "team-calendar.evt-types.update.error": "無法儲存事件類型屬性",
  "team-calendar.evt-types.validation.empty.name": "名稱為必填",
  "team-calendar.focus-icon-text": "已聚焦於「{name}」選項。使用向上和向下鍵以選擇選項，按 Enter 鍵可選取目前聚焦的選項，按 Escape 鍵可離開選單。",
  "team-calendar.global-setting.error": "我們在更新您的設定時遇到問題，請再試一次。",
  "team-calendar.global-settings.header": "全域設定",
  "team-calendar.homepage-card.add-existing-calendar": "新增現有行事曆",
  "team-calendar.homepage-card.create-calendar": "{createNewCalendar} 或 {addExistingCalendar}",
  "team-calendar.homepage-card.create-new-calendar": "建立新行事曆",
  "team-calendar.homepage-card.more-events": "{number, plural, other {還有 {number} 個事件}}",
  "team-calendar.homepage-card.no-calendars": "您的清單中沒有行事曆。",
  "team-calendar.homepage-card.no-incoming-events": "{number, plural, other {接下來 {number} 天沒有即將到來的事件}}",
  "team-calendar.homepage-card.view-calendars": "檢視行事曆",
  "team-calendar.icon.warning": "警告圖示",
  "team-calendar.import": "匯入",
  "team-calendar.more": "等等",
  "team-calendar.open-menu-instructions": "按 Enter 鍵可開啟選單",
  "team-calendar.ordinals.first": "第一個",
  "team-calendar.ordinals.first.lower.case": "第一天",
  "team-calendar.ordinals.fourth": "4 日",
  "team-calendar.ordinals.fourth.lower.case": "第四天",
  "team-calendar.ordinals.last": "最後一個",
  "team-calendar.ordinals.last.lower.case": "最後一天",
  "team-calendar.ordinals.second": "第二",
  "team-calendar.ordinals.second.lower.case": "秒",
  "team-calendar.ordinals.third": "3 日",
  "team-calendar.ordinals.third.lower.case": "第三天",
  "team-calendar.reminder.add-reminder": "新增提醒",
  "team-calendar.reminder.edit-event-type": "編輯事件類型",
  "team-calendar.reminder.label": "提醒",
  "team-calendar.reminder.no-reminder": "無",
  "team-calendar.reminder.period.day.1": "1 天前",
  "team-calendar.reminder.period.days.2": "2 天前",
  "team-calendar.reminder.period.days.3": "3 天前",
  "team-calendar.reminder.period.hour.1": "1 小時前",
  "team-calendar.reminder.period.hours.2": "2 小時前",
  "team-calendar.reminder.period.hours.4": "4 小時前",
  "team-calendar.reminder.period.hours.8": "8 小時前",
  "team-calendar.reminder.period.mins.10": "10 分鐘前",
  "team-calendar.reminder.period.mins.20": "20 分鐘前",
  "team-calendar.reminder.period.mins.30": "30 分鐘前",
  "team-calendar.reminder.period.mins.5": "5 分鐘前",
  "team-calendar.reminder.period.none": "無",
  "team-calendar.reminder.period.week.1": "1 週前",
  "team-calendar.reminder.period.weeks.2": "2 星期前",
  "team-calendar.reminder.period.weeks.3": "3 週前",
  "team-calendar.reminder.period.weeks.4": "4 週前",
  "team-calendar.reminder.tooltip": "提醒功能會繼承自事件類型",
  "team-calendar.reminder.tooltip.text": "變更會影響使用此行事曆的所有人。",
  "team-calendar.remove-calendar.removeCalendar": "移除行事曆",
  "team-calendar.repeat-event-component.frequency-selector.warning": "您只能更新不屬於重複序列的重複頻率。",
  "team-calendar.restricted.message": "如果您認為您應該有存取權，請連絡系統管理員。",
  "team-calendar.restricted.title": "此內容受到限制",
  "team-calendar.restrictions.can-edit": "可以編輯",
  "team-calendar.restrictions.can-edit-only-warning": "需要先擁有檢視的存取權。",
  "team-calendar.restrictions.can-view": "可以檢視",
  "team-calendar.restrictions.error.no-calendar.description": "找不到行事曆。請重新整理頁面。",
  "team-calendar.restrictions.error.no-perm.description": "您沒有足夠的權限來更新限制。",
  "team-calendar.restrictions.has-restriction-edit": "任何人都可以檢視，只有某些人可以編輯",
  "team-calendar.restrictions.has-restriction-edit-and-view": "只有特定人員可以檢視或編輯",
  "team-calendar.restrictions.header": "行事曆限制",
  "team-calendar.restrictions.no-restriction": "任何人都可以檢視和編輯",
  "team-calendar.restrictions.placeholder-message": "輸入使用者名稱或群組",
  "team-calendar.restrictions.restriction-message": "新增、編輯或移除 {calendar} 行事曆的限制。",
  "team-calendar.save": "儲存",
  "team-calendar.search": "搜尋",
  "team-calendar.select-icon-text": "選取的圖示標籤為「{name}」",
  "team-calendar.sidebar.addReminder": "新增電子郵件提醒",
  "team-calendar.sidebar.deleteCalendar": "刪除行事曆",
  "team-calendar.sidebar.editCalendar": "編輯",
  "team-calendar.sidebar.refresh": "重新整理",
  "team-calendar.sidebar.remove": "移除",
  "team-calendar.sidebar.removeCalendar": "移除",
  "team-calendar.sidebar.removeFromMyCalendarView": "從我的行事曆中移除",
  "team-calendar.sidebar.removeFromSpaceView": "從空間行事曆中移除",
  "team-calendar.sidebar.turnOffReminders": "關閉電子郵件提醒",
  "team-calendar.sidebar.turnOnReminders": "開啟電子郵件提醒",
  "team-calendar.subcalendar.all-space-calendars": "所有空間行事曆",
  "team-calendar.subcalendar.name": "{calendarName} 行事曆的更多動作",
  "team-calendar.subcalendar.toggle-email-reminder-error": "我們無法更新電子郵件提醒設定。",
  "team-calendar.subcalendar.toggle-email-reminder-invalid-url": "已為電子郵件提醒輸入了無效的 URL。",
  "team-calendar.subcalendar.toggle-email-reminder-not-set": "「{eventTypeName}」事件尚未有建立的提醒。",
  "team-calendar.subcalendar.turn-off-email-reminder-success": "您已關閉「{eventTypeName}」的電子郵件提醒。",
  "team-calendar.subcalendar.turn-on-email-reminder-success": "您已開啟「{eventTypeName}」的電子郵件提醒。",
  "team-calendar.subcalendar.type.all-day-text": "全天",
  "team-calendar.subcalendar.type.birthdays": "生日",
  "team-calendar.subcalendar.type.generic-people": "人員",
  "team-calendar.subcalendar.type.jira": "Jira 行事曆",
  "team-calendar.subcalendar.type.jira-agile-sprint": "Jira Agile 衝刺",
  "team-calendar.subcalendar.type.jira-issue-dates": "Jira 議題日期",
  "team-calendar.subcalendar.type.jira-project-releases": "Jira 專案版本",
  "team-calendar.subcalendar.type.leaves": "請假",
  "team-calendar.subcalendar.type.local": "事件行事曆",
  "team-calendar.subcalendar.type.no-events-message": "沒有即將到來的事件",
  "team-calendar.subcalendar.type.no-events-message-list-view": "沒有可顯示的事件",
  "team-calendar.subcalendar.type.other": "事件",
  "team-calendar.subcalendar.type.parent": "行事曆",
  "team-calendar.subcalendar.type.people": "人員行事曆",
  "team-calendar.subcalendar.type.spaceCalendarsHeader": "空間行事曆",
  "team-calendar.subcalendar.type.subscription": "訂閱",
  "team-calendar.subcalendar.type.travel": "旅遊",
  "team-calendar.subcalendar.type.unknown": "未知類型",
  "team-calendar.subscribe": "訂閱",
  "team-calendar.subscribe-link-reset.confirm-reset": "重設連結",
  "team-calendar.subscribe-link-reset.reset-message": "這會從所有行事曆檢視中移除 {calendarName}。",
  "team-calendar.subscribe-link-reset.reset.header": "重設行事曆的連結？",
  "team-calendar.subscribe.add": "新增",
  "team-calendar.subscribe.add-calendar": "將 {calendar} 新增至您的行事曆",
  "team-calendar.subscribe.app": "應用程式",
  "team-calendar.subscribe.app-not-listed": "我的應用程式未列出",
  "team-calendar.subscribe.app-not-listed-message": "您的行事曆應用程式很有可能可支援 iCal 或 CalDAV。",
  "team-calendar.subscribe.app-not-listed-second-message": "查看行事曆應用程式的說明文件以了解其支援項目，然後從上方的「行事曆應用程式」欄位中選擇 iCal 或 CalDAV。",
  "team-calendar.subscribe.apple-calendar-ios": "Apple Calendar (iOS)",
  "team-calendar.subscribe.apple-calendar-macos": "Apple Calendar (MacOS)",
  "team-calendar.subscribe.caldav-subscribe": "在您最愛的行事曆應用程式中檢視 {calendar} 行事曆並編輯活動。",
  "team-calendar.subscribe.calendar": "行事曆",
  "team-calendar.subscribe.calendar-added": "已將 {calendar} 新增至您的行事曆。",
  "team-calendar.subscribe.calendar-app": "行事曆應用程式",
  "team-calendar.subscribe.choose-app-message": "選擇您的應用程式",
  "team-calendar.subscribe.copied-to-clipboard": "已複製到剪貼簿",
  "team-calendar.subscribe.copy": "複製",
  "team-calendar.subscribe.copy-the-url": "複製 URL",
  "team-calendar.subscribe.copy-the-values": "將您的帳號類型設定為<b>進階</b>，並複製這些值",
  "team-calendar.subscribe.google-calendar-android": "Google Calendar (Android)",
  "team-calendar.subscribe.google-calendar-browser": "Google Calendar (瀏覽器)",
  "team-calendar.subscribe.guide": "逐步指南",
  "team-calendar.subscribe.learnMore": "深入了解",
  "team-calendar.subscribe.message-guide": "前往行事曆應用程式來設定行事曆。需要協助嗎？請參閱我們的{guide}。",
  "team-calendar.subscribe.microsoft-outlook-browser": "Microsoft Outlook (瀏覽器)",
  "team-calendar.subscribe.microsoft-outlook-desktop": "Microsoft Outlook (Windows 桌面)",
  "team-calendar.subscribe.other": "其他",
  "team-calendar.subscribe.port": "連接埠",
  "team-calendar.subscribe.reset-link": "重設行事曆連結",
  "team-calendar.subscribe.reset-message": "若要移除行事曆的存取權，{reset}。",
  "team-calendar.subscribe.server-address": "伺服器位址",
  "team-calendar.subscribe.server-path": "伺服器路徑",
  "team-calendar.subscribe.setup-caldav": "前往行事曆應用程式來設定行事曆。請參閱行事曆應用程式的說明文件，了解如何新增 CalDAV 行事曆。",
  "team-calendar.subscribe.setup-ical": "前往行事曆應用程式來設定行事曆。請參閱行事曆應用程式的說明文件，了解如何新增 iCal 行事曆。",
  "team-calendar.subscribe.subscribe-to-calendar": "訂閱行事曆",
  "team-calendar.subscribe.thunderbird": "Thunderbird",
  "team-calendar.subscribe.undo": "復原",
  "team-calendar.subscribe.url-error.title": "我們無法載入 URL",
  "team-calendar.timezone-error.could-not-load-events": "我們無法在「行事曆」頁面上載入事件",
  "team-calendar.timezone-error.go-to-setting": "前往「設定」",
  "team-calendar.timezone-error.incorrect-timezone": "我們無法辨識時區。請更新您的時區設定並重新載入。",
  "team-calendar.week-and-month-content.invitee": "{numOfInvitee, plural, other {{inviteeName} 與其他 {numOfInvitee} 人}}",
  "team-presence.avatar-group.anonymous-user": "匿名者",
  "team-presence.avatar-group.blogpost-landmark": "部落格貼文上作用中的人",
  "team-presence.avatar-group.overflow-label": "溢位選單",
  "team-presence.avatar-group.page-landmark": "頁面上作用中的人員",
  "team-presence.avatar-group.spotlight.description-admin": "{contentType, select, page {您的團隊現在可以即時查看誰正在檢視此頁面。} blogpost {您的團隊現在可以即時查看誰正在檢視此部落格貼文。} other {您的團隊現在可以即時查看誰正在檢視此內容。}}",
  "team-presence.avatar-group.spotlight.description-user": "{contentType, select, page {您現在可以即時查看誰正在檢視此頁面。} blogpost {您現在可以即時查看誰正在檢視此部落格貼文。} other {您現在可以即時查看誰正在檢視此內容。}}",
  "team-presence.avatar-group.spotlight.label": "即時顯示頭像群組的入門內容",
  "team-presence.avatar-group.spotlight.primary-action": "確定",
  "team-presence.avatar-group.spotlight.secondary-action-admin": "深入了解設定",
  "team-presence.avatar-group.spotlight.secondary-action-user": "深入了解可見性",
  "team-presence.avatar-group.spotlight.title": "{contentType, select, page {查看您頁面上的人員} blogpost {查看您部落格貼文上的人} other {查看您內容上的人}}",
  "team-presence.menu.active.title": "{count, plural, =0 {目前作用中 ({count})} other {目前作用中 ({count})}}",
  "team-presence.menu.commenting": "正在留言",
  "team-presence.menu.current-user.marker": "您",
  "team-presence.menu.editing": "正在編輯",
  "team-presence.menu.editing.title": "{count, plural, =0 {正在編輯 ({count})} other {正在編輯 ({count})}}",
  "team-presence.menu.empty-state.blogpost.editing": "您是唯一編輯此部落格貼文的人。",
  "team-presence.menu.empty-state.blogpost.share-button": "分享部落格貼文",
  "team-presence.menu.empty-state.blogpost.share-button.clicked": "已分享部落格貼文",
  "team-presence.menu.empty-state.blogpost.viewing": "您是唯一檢視此部落格貼文的人。",
  "team-presence.menu.empty-state.copy-button": "複製連結",
  "team-presence.menu.empty-state.page.editing": "您是唯一編輯此頁面的人。",
  "team-presence.menu.empty-state.page.share-button": "分享頁面",
  "team-presence.menu.empty-state.page.share-button.clicked": "已分享頁面",
  "team-presence.menu.empty-state.page.viewing": "您是唯一檢視此頁面的人。",
  "team-presence.menu.empty-state.publish-to-share-it-with-others": "發布頁面，以便與其他可能感興趣的人分享。",
  "team-presence.menu.empty-state.share-it-with-others": "您可以與其他感興趣的人分享。",
  "team-presence.menu.viewing": "檢視",
  "team-presence.menu.viewing.title": "{count, plural, =0 {正在檢視 ({count})} other {正在檢視 ({count})}}",
  "team-presence.menu.you": "您",
  "team-presence.satisfaction-survey.button.cancel": "取消",
  "team-presence.satisfaction-survey.button.submit": "提交",
  "team-presence.satisfaction-survey.checkbox.can-contact": "Atlassian 可以連絡我來了解此意見反應",
  "team-presence.satisfaction-survey.description": "對於能夠在 Confluence 內容上看到其他查閱者/編輯者，您有什麼看法？",
  "team-presence.satisfaction-survey.final.description": "感謝您協助我們改善 Confluence！",
  "team-presence.satisfaction-survey.final.title": "已提交意見反應",
  "team-presence.satisfaction-survey.question.bad": "我們很遺憾得知這個消息。您不滿意的地方是什麼？有任何讓您喜歡的地方嗎？(選擇性)",
  "team-presence.satisfaction-survey.question.good": "太棒了！ 您喜歡其中哪一個部分？ 有什麼可以改進的嗎？ (選擇性)",
  "team-presence.satisfaction-survey.question.okay": "您是否能再提供多一點資訊？ 您喜歡其中哪一個部分？ 有哪裡可以改善的嗎？ (選擇性)",
  "team-presence.satisfaction-survey.reaction.amazing": "了不起",
  "team-presence.satisfaction-survey.reaction.bad": "不佳",
  "team-presence.satisfaction-survey.reaction.great": "很好",
  "team-presence.satisfaction-survey.reaction.okay": "確定",
  "team-presence.satisfaction-survey.reaction.terrible": "很糟糕",
  "team-presence.satisfaction-survey.title": "告訴我們您的想法",
  "template-breadcrumbs.administration.name": "管理",
  "template-breadcrumbs.content.appearance.toggle.fixed.width": "將範本設為固定寬度",
  "template-breadcrumbs.content.appearance.toggle.full.width": "將範本設為全寬",
  "template-breadcrumbs.templates.name": "範本",
  "template-card.author-label": "由 {author} 製作",
  "template-card.filled-star.label": "移除 {templateName} 的星號",
  "template-card.filled-star.tooltip": "移除此範本的星號",
  "template-card.icon.label": "預設範本圖示",
  "template-card.interaction-button-label": "{name}，使用 enter 鍵即可載入範本",
  "template-card.onboarding.tutorial": "教學課程",
  "template-card.powered-by-template-card.author-label": "由 {author} 製作",
  "template-card.powered-by-template-card.permission-error-description": "您無法使用此範本。",
  "template-card.powered-by-template-card.permission-error-heading": "嗯，這有點奇怪...",
  "template-card.powered-by-template-card.template-deleted-description": "該範本已刪除",
  "template-card.powered-by-template-card.template-deleted-heading": "嗯，這有點奇怪...",
  "template-card.powered-by-template-card.unknown-error-description": "請嘗試重新整理頁面",
  "template-card.powered-by-template-card.unknown-error-heading": "無法載入範本",
  "template-card.powered-by-template-card.view-button": "檢視",
  "template-card.star.label": "為 {templateName} 標上星號",
  "template-card.star.tooltip": "為此範本標上星號",
  "template-card.use-button": "使用",
  "template-editor.cancel.button": "取消",
  "template-editor.content.placeholder": "您知道嗎？您可以在此新增目錄、日期或藍圖等各式各樣的酷炫項目。輸入 / 即可開啟列表。",
  "template-editor.ellipsis.dropdown.findReplace": "尋找與取代",
  "template-editor.ellipsis.dropdown.label.more.word.capitalised": "更多",
  "template-editor.ellipsis.dropdown.preview": "預覽",
  "template-editor.ellipsis.dropdown.redo": "重做",
  "template-editor.ellipsis.dropdown.undo": "復原",
  "template-editor.go.back": "返回",
  "template-editor.inline-extension.variable-description": "加入新欄位，以便範本使用者填寫。",
  "template-editor.inline-extension.variable-title": "新變數",
  "template-editor.save.button": "儲存",
  "template-editor.save.button.disable.by.closing.tooltip": "仍在處理中...",
  "template-editor.save.button.disable.by.empty.title.tooltip": "您的範本需要標題才能發布。",
  "template-editor.save.button.disable.by.saving.tooltip": "我們仍在儲存您的範本。",
  "template-gallery.author-label": "由 {author} 製作",
  "template-gallery.categories.featured.category.name": "精選",
  "template-gallery.categories.my-templates.category.name": "我的範本",
  "template-gallery.close-label": "關閉",
  "template-gallery.detail-panel.error-boundary.close-label": "關閉",
  "template-gallery.detail-panel.error-boundary.description": "我們目前無法載入範本詳細資料。請重新整理頁面，並再試一次。",
  "template-gallery.detail-panel.error-boundary.header": "我們無法載入您的範本",
  "template-gallery.ellipsis.dropdown.actions": "更多動作",
  "template-gallery.errors.spaceKey.description": "只有具有建立內容權限的人才能使用範本。您可以向空間管理員要求特定空間的權限 (列在「空間設定」中)。",
  "template-gallery.errors.spaceKey.header": "要求使用範本的權限",
  "template-gallery.errors.templates.empty.description": "您選取的空間沒有範本，但其他空間可能有範本。嘗試不同的空間繼續探索。",
  "template-gallery.errors.templates.empty.header": "我們目前沒有可用的範本",
  "template-gallery.errors.templates.emptySearch.description": "沒有範本符合您的搜尋條件。{lineBreak}請使用不同的關鍵字再試一次。",
  "template-gallery.errors.templates.emptySearch.header": "我們找不到任何範本",
  "template-gallery.errors.templates.queryError.description": "我們目前無法載入範本。{lineBreak}請重新整理頁面，並再試一次。",
  "template-gallery.errors.templates.queryError.header": "我們無法載入您的範本",
  "template-gallery.errors.templates.tooManyRequestsError.description": "請稍候幾分鐘，然後再試一次。{lineBreak}如果這種情況持續發生，請連絡 {supportLink}",
  "template-gallery.errors.templates.tooManyRequestsError.header": "我們目前無法載入範本",
  "template-gallery.filters.search.expand.label": "開啟搜尋列",
  "template-gallery.filters.search.expanded.description.label": "在搜尋列中輸入內容，即可篩選選項。",
  "template-gallery.filters.search.hintText": "搜尋範本",
  "template-gallery.filters.search.label": "範本",
  "template-gallery.filters.search.template.data.hintText": "搜尋作者、種類、主題",
  "template-gallery.header.text": "範本",
  "template-gallery.learn-more-link": "深入瞭解",
  "template-gallery.learn-more-link-label": "深入了解「{name}」",
  "template-gallery.manage-templates.button.title": "管理範本",
  "template-gallery.next-label": "下一個範本",
  "template-gallery.previous-label": "上一個範本",
  "template-gallery.space-error.templates.queryError.description": "此空間可能已不存在、已封存，或您沒有查看權限。{lineBreak}請檢查封存，或聯繫空間管理員以恢復存取權限。",
  "template-gallery.space-error.templates.queryError.header": "無法載入範本",
  "template-gallery.star.label": "為 {templateName} 標上星號",
  "template-gallery.star.tooltip": "為此範本標上星號",
  "template-gallery.template-actions.copiedLink": "已複製！",
  "template-gallery.template-actions.edit": "編輯",
  "template-gallery.template-actions.share": "分享連結",
  "template-gallery.template.count.all": "{totalTemplatesCount, plural, other {正在顯示全部 {totalTemplatesCount} 個範本。}}",
  "template-gallery.template.count.filtered": "{totalTemplatesCount, plural, other {正在顯示 {filteredTemplatesCount} 個範本，總共 {totalTemplatesCount} 個。}}",
  "template-gallery.templates.empty.description": "在空間設定中推廣範本，或根據團隊的特定需求製作專屬範本，快速追蹤團隊成功完成的項目。",
  "template-gallery.templates.empty.header": "沒有精選範本",
  "template-gallery.templates.empty.link": "設定範本",
  "template-gallery.templates.empty.my-templates.description": "您建立或標上星號的範本將會顯示在這裡。",
  "template-gallery.templates.empty.my-templates.header": "您沒有任何自訂範本或已儲存的範本",
  "template-gallery.templates.empty.my-templates.link": "如何建立範本",
  "template-gallery.unstar.label": "移除 {templateName} 的星號",
  "template-gallery.unstar.tooltip": "移除此範本的星號",
  "template-gallery.use-template-button": "使用範本",
  "template-gallery.use-template.error.bad.edited.first.party.blueprint.action": "連絡支援人員",
  "template-gallery.use-template.error.bad.edited.first.party.blueprint.description": "範本中包含 Confluence 編輯器中不再支援的元素。",
  "template-gallery.use-template.error.bad.edited.first.party.blueprint.title": "此範本已毀損",
  "template-gallery.use-template.error.brokentemplate.description": "由於該範本為第三方所擁有，因此必須由他們修復。請連絡您的網站管理員，讓他們疑難排解此議題。",
  "template-gallery.use-template.error.brokentemplate.title": "此範本已經損壞",
  "template-gallery.use-template.error.description": "請重新整理頁面，然後再試一次。如果這種情況持續發生，請連絡支援人員。",
  "template-gallery.use-template.error.invalid.spacekey.description": "此空間最近已被刪除。請嘗試切換到不同的空間來建立內容。",
  "template-gallery.use-template.error.invalid.spacekey.title": "我們在使用此範本時遇到問題",
  "template-gallery.use-template.error.title": "我們無法為您建立新內容",
  "template-gallery.use-template.error.unauthorized.description": "您不再擁有在此空間中建立內容的權限。請連絡空間管理員，讓他們對此問題進行疑難排解。",
  "template-gallery.use-template.error.unauthorized.title": "我們在使用此範本時遇到問題",
  "template-gallery.user-template.error.not-found-graphql-error": "請重新整理頁面，並再試一次。",
  "template-gallery.user-template.error.not-found-graphql-error.title": "我們無法為您建立新內容",
  "template-list.categories.all.category.name": "全部",
  "template-list.categories.featured.category.name": "精選",
  "template-list.categories.my-templates.category.name": "我的範本",
  "template-list.empty-search-results.description": "沒有範本符合您的搜尋條件。{lineBreak}請使用不同的關鍵字再試一次。",
  "template-list.empty-search-results.headline": "我們找不到任何範本",
  "template-list.empty.description": "此空間中沒有任何範本，但是還有很多可打造您頁面的方式。",
  "template-list.empty.headline": "我們目前沒有可用的範本",
  "template-list.error.description": "我們目前無法載入範本。{lineBreak}請重新整理頁面，並再試一次。",
  "template-list.error.headline": "我們無法載入您的範本",
  "template-list.space-error.description": "此空間可能已不存在、已封存，或您沒有查看權限。{lineBreak}請檢查封存，或聯繫空間管理員以恢復存取權限。",
  "template-list.space-error.header": "無法載入範本",
  "template-list.template.count.all": "{totalTemplatesCount, plural, other {正在顯示全部 {totalTemplatesCount} 個範本。}}",
  "template-list.template.count.filtered": "{totalTemplatesCount, plural, other {正在顯示 {filteredTemplatesCount} 個範本，總共 {totalTemplatesCount} 個。}}",
  "template-list.templates.empty.description": "在空間設定中推廣範本，或根據團隊的特定需求製作專屬範本，快速追蹤團隊成功完成的項目。",
  "template-list.templates.empty.header": "沒有精選範本",
  "template-list.templates.empty.link": "設定範本",
  "template-list.templates.empty.my-templates.description": "您建立或標上星號的範本將會顯示在這裡。",
  "template-list.templates.empty.my-templates.description.ep": "在新的瀏覽器分頁中開啟 Confluence 以存取自訂範本",
  "template-list.templates.empty.my-templates.header": "您沒有任何自訂範本或已儲存的範本",
  "template-list.templates.empty.my-templates.header.ep": "內嵌內容尚未支援自訂和已儲存的範本",
  "template-list.templates.empty.my-templates.link": "如何建立範本",
  "template-management-flags.fabric-template-migration.error.message.description": "發生問題，我們無法轉換此範本。請再試一次。",
  "template-management-flags.fabric-template-migration.error.message.title": "我們無法轉換範本",
  "template-management-flags.fabric-template-migration.success.message.description": "已成功轉換範本。",
  "template-management-flags.fabric-template-migration.success.message.title": "已轉換範本",
  "template-migration-preview.breadcrumbs-item.administration": "管理",
  "template-migration-preview.breadcrumbs-item.templates": "範本",
  "template-migration-preview.errors.api-error.action-text": "重新整理",
  "template-migration-preview.errors.api-error.description": "請重新整理頁面，並再試一次。",
  "template-migration-preview.errors.api-error.header": "我們無法載入預覽",
  "template-migration-preview.errors.ineligible-template.header": "我們無法顯示範本",
  "template-migration-preview.errors.ineligible-template.template-gallery-enabled.action-text": "前往範本庫",
  "template-migration-preview.errors.ineligible-template.template-gallery-enabled.description": "無法使用您嘗試開啟的範本。如果您是按一下連結來到達此處，此連結可能會指向舊版的範本。您可以檢視範本庫中所有可用的範本。",
  "template-migration-preview.errors.invalid-template.action-text": "前往首頁",
  "template-migration-preview.errors.invalid-template.description": "無法顯示您嘗試開啟的範本。您點擊的連結可能有錯誤，或者您可能需要其他權限才能檢視。",
  "template-migration-preview.errors.invalid-template.header": "我們無法顯示範本",
  "template-migration-preview.footer.cancel": "取消",
  "template-migration-preview.footer.convert-template": "轉換",
  "template-migration-preview.header.message": "您正在預覽全新的編輯體驗",
  "template-panel.always-discard-modal.body": "您到目前為止所建立的內容將會遺失。若要在不遺失內容的條件下使用範本，請先建立新頁面並選取範本，再加入內容。",
  "template-panel.always-discard-modal.body.livedocs": "您到目前為止所建立的內容將會遺失。若要在不遺失工作的條件下使用範本，請先建立新頁面或即時文件並選取範本，再加入內容。",
  "template-panel.always-discard-modal.button.cancel": "取消",
  "template-panel.always-discard-modal.button.create": "取代內容",
  "template-panel.always-discard-modal.title": "要以範本取代現有內容嗎？",
  "template-panel.always-discard-modal.title.warning": "警告",
  "template-panel.label": "範本",
  "template-panel.overwrite-warning-modal.body": "現有內容將被移除，並以所選範本取代。",
  "template-panel.overwrite-warning-modal.button.cancel": "取消",
  "template-panel.overwrite-warning-modal.button.confirm": "確認",
  "template-panel.overwrite-warning-modal.checkbox.description": "或者，保留此頁面並建立新頁面",
  "template-panel.overwrite-warning-modal.checkbox.description.livedocs": "或者保留此內容並建立新頁面或文件",
  "template-panel.overwrite-warning-modal.title": "要選取此範本嗎？",
  "template-panel.search.hintText": "搜尋作者、種類、主題",
  "template-panel.space-selector.label": "從此空間選取範本",
  "template-preview.custom-blueprint-variable-handler.document-owner": "文件負責人",
  "template-preview.custom.blog-post.icon.description": "部落格貼文",
  "template-preview.custom.blog-post.message": "您可以控制部落格貼文的內容，{lineBreak}讓您的想像力不受限。",
  "template-preview.custom.blog-post.title": "讓您的部落格栩栩如生",
  "template-preview.errors.display.icon.description": "無法顯示預覽",
  "template-preview.errors.display.message": "此範本沒有可用的預覽，{lineBreak}因為系統已針對您提供的詳細資料量身訂製該範本。",
  "template-preview.errors.display.title": "在您新增之前沒有可查看的內容",
  "template-preview.errors.loading.icon.description": "無法顯示預覽",
  "template-preview.errors.loading.message": "我們目前無法載入預覽。{lineBreak} 請重新整理頁面，並再試一次。",
  "template-preview.errors.loading.title": "我們無法載入預覽",
  "template-preview.inline-extension.create-from-template": "透過範本建立",
  "template-suggestions.byline.popular-templates": "熱門範本：{template1}、{template2}",
  "template-suggestions.multiple-suggested-templates": "建議的範本：{template1}、{template2}",
  "template-suggestions.single-suggested-template": "建議的範本：{template1}",
  "template-utils.errors.authorization.template.select.description": "請嘗試重新整理頁面。",
  "template-utils.errors.authorization.template.select.title": "我們無法載入範本",
  "template-utils.errors.content.template.select.description": "請嘗試建立新頁面，然後再次選取範本。",
  "template-utils.errors.content.template.select.description.livedocs": "請嘗試建立新的即時文件，然後再次選取範本。",
  "template-utils.errors.content.template.select.title": "我們無法在此套用範本",
  "template-utils.errors.edited.first.party.blueprint.template.select.action": "連絡支援人員",
  "template-utils.errors.edited.first.party.blueprint.template.select.description": "此範本中包含 Confluence 編輯器中不再支援的元素。",
  "template-utils.errors.edited.first.party.blueprint.template.select.title": "此範本已毀損",
  "template-utils.errors.graphql.not.found.description": "請重新整理頁面，並再試一次。",
  "template-utils.errors.graphql.not.found.description.title": "我們無法在這裡建立新內容",
  "template-utils.errors.third.party.blueprint.template.select.description": "由於該範本為第三方所擁有，因此必須由他們修復。請連絡您的網站管理員，讓他們針對此問題進行疑難排解。",
  "template-utils.errors.third.party.blueprint.template.select.title": "此範本已毀損",
  "template-utils.errors.validation.template.select.description": "請嘗試不同的範本，或建立新頁面，然後再次選取範本。",
  "template-utils.errors.validation.template.select.description.livedocs": "請嘗試不同的範本，或建立新頁面或即時文件，然後再次選取範本。",
  "template-utils.errors.validation.template.select.title": "我們無法載入範本",
  "template-utils.featured.category.name": "精選",
  "template-utils.my-templates.category.name": "我的範本",
  "template-utils.promoted.category.name": "已推廣",
  "template-utils.sort-by-dropdown.sortBy.label": "排序依據",
  "template-utils.sort-by-dropdown.sortBy.option.alphabetical.label": "按字母順序",
  "template-utils.sort-by-dropdown.sortBy.option.recommended.label": "建議",
  "template-utils.sort-by-dropdown.sortBy.recommended.tooltip.content": "建議的範本會依使用頻率排序",
  "template-utils.starred.category.name": "已標上星號",
  "template-variable.description.invalid.variable.name": "此範本包含使用無效字元的變數 (. , [ , ], /)。若要使用，請要求範本負責人從變數中移除這些字元。",
  "template-variable.property.panel.variable.display.list": "清單",
  "template-variable.property.panel.variable.display.list.tooltip": "下拉式清單。",
  "template-variable.property.panel.variable.display.string": "文字",
  "template-variable.property.panel.variable.display.string.tooltip": "單行文字輸入欄位。",
  "template-variable.property.panel.variable.display.textarea": "多行文字",
  "template-variable.property.panel.variable.display.textarea.tooltip": "多行文字輸入欄位。",
  "template-variable.property.panel.variable.list.values.tooltip": "輸入清單中的每個項目，並以逗號分隔每個項目。",
  "template-variable.property.panel.variable.textarea.columns.tooltip": "要為此欄位顯示的欄數。",
  "template-variable.property.panel.variable.textarea.rows.tooltip": "要為此欄位顯示的列數。",
  "template-variable.template.editor.changing.variable.dialog.title": "編輯範本變數",
  "template-variable.template.editor.variable.list.field.placeholder": "選項一、選項二、選項三",
  "template-variable.template.editor.variable.name.field": "變數名稱",
  "template-variable.template.editor.variable.save.button.label": "儲存",
  "theme.default.desc": "全域設定的外觀和風格。全域設定的外觀和風格。您可以手動自訂色彩配置和版面配置。",
  "theme.notheme.title": "全域外觀和風格",
  "theming.menu.item.dark": "深色",
  "theming.menu.item.light": "淺色",
  "theming.menu.item.system": "符合瀏覽器",
  "third-party-nudge.notifications-nudge.both": "兩者",
  "third-party-nudge.notifications-nudge.common-nudge-component-title": "在 Microsoft Teams 或 Slack 中取得即時 Confluence 更新",
  "third-party-nudge.notifications-nudge.connect-slack-button": "連結到 Slack",
  "third-party-nudge.notifications-nudge.connect-teams-button": "連結到 Teams",
  "third-party-nudge.notifications-nudge.dismiss-flag.content": "我們會限制您看到這些建議的頻率。",
  "third-party-nudge.notifications-nudge.dismiss-flag.success-label": "成功",
  "third-party-nudge.notifications-nudge.dismiss-flag.title": "謝謝您告訴我們",
  "third-party-nudge.notifications-nudge.dropdown.dismiss-dropdown-content": "不感興趣",
  "third-party-nudge.notifications-nudge.dropdown.info-dropdown-content": "為什麼我會看到此內容？",
  "third-party-nudge.notifications-nudge.dropdown.more-label": "在 Teams 中取得個人通知",
  "third-party-nudge.notifications-nudge.dropdown.snooze-dropdown-content": "請在 7 天後提醒我",
  "third-party-nudge.notifications-nudge.info-modal.confirmation-button": "確定",
  "third-party-nudge.notifications-nudge.info-modal.content": "我們認為 {product} 將提高您團隊的生產力。這項建議的依據是：",
  "third-party-nudge.notifications-nudge.info-modal.first-list-item": "您團隊使用應用程式整合的情況",
  "third-party-nudge.notifications-nudge.info-modal.learn-more-link": "進一步了解您所適用的 Atlassian 資料隱私權",
  "third-party-nudge.notifications-nudge.info-modal.second-list-item": "您現有的 Atlassian 產品",
  "third-party-nudge.notifications-nudge.info-modal.title": "為什麼我會看到此內容？",
  "third-party-nudge.notifications-nudge.slack": "slack",
  "third-party-nudge.notifications-nudge.slack-nudge-component-content": "開啟通知，以即時追蹤並回應 Confluence 內容上的活動更新。",
  "third-party-nudge.notifications-nudge.slack-nudge-component-title": "在 Slack 中取得即時 Confluence 更新",
  "third-party-nudge.notifications-nudge.teams": "teams",
  "third-party-nudge.notifications-nudge.teams-nudge-component-title": "在 Microsoft Teams 中取得即時 Confluence 更新",
  "third-party-nudge.nudge-spotlight.alt-image-text-both": "Microsoft Teams 和 Slack 的 Confluence 通知，顯示「小明在留言中提及您」",
  "third-party-nudge.nudge-spotlight.alt-image-text-slack": "「Slack 中的 Confluence 通知，顯示『小明已指派頁面給您』",
  "third-party-nudge.nudge-spotlight.alt-image-text-teams": "Microsoft Teams 中的 Confluence Cloud 通知，顯示「小明正在追蹤頁面」",
  "third-party-nudge.nudge-spotlight.chat-spotlight-card-title": "在聊天中獲取即時更新",
  "third-party-nudge.nudge-spotlight.common-spotlight-card-content": "在團隊聊天中開啟通知，以掌握工作狀況並即時回應更新。",
  "third-party-nudge.nudge-spotlight.slack-spotlight-card-content": "在 Slack 中開啟通知，以掌握工作狀況並即時回應更新。",
  "third-party-nudge.nudge-spotlight.slack-spotlight-card-title": "在 Slack 中獲取即時更新",
  "third-party-nudge.nudge-spotlight.spotlight-card-connect-slack-btn": "連接 Slack",
  "third-party-nudge.nudge-spotlight.spotlight-card-connect-teams-btn": "連接 Microsoft Teams",
  "third-party-nudge.nudge-spotlight.spotlight-card-slack-btn": "Slack",
  "third-party-nudge.nudge-spotlight.spotlight-card-teams-btn": "Microsoft Teams",
  "third-party-nudge.nudge-spotlight.spotlight-card-title": "獲取即時更新",
  "third-party-nudge.nudge-spotlight.teams-spotlight-card-content": "在 Microsoft Teams 中開啟通知，以掌握工作狀況並即時回應更新。",
  "third-party-nudge.nudge-spotlight.teams-spotlight-card-title": "在 Teams 中獲取即時更新",
  "time-ago.prepositions.on": "於 {datetime}",
  "time-ago.time.lessThanAMinute": "一分鐘內",
  "time-ago.time.now": "現在",
  "title-area-content-components.toolbar-above-title.center-alignment-icon.label": "置中對齊",
  "title-area-content-components.toolbar-above-title.dropdown-menu-alignment-icon.label": "選取對齊選項",
  "title-area-content-components.toolbar-above-title.dropdown-menu-center-aligned-icon.label": "已置中對齊",
  "title-area-content-components.toolbar-above-title.dropdown-menu-left-aligned-icon.label": "已靠左對齊",
  "title-area-content-components.toolbar-above-title.left-alignment-icon.label": "靠左對齊",
  "title-area-content-components.toolbar-above-title.suggest-title-button.empty-document.tooltip": "頁面不能空白",
  "title-area-content-components.toolbar-above-title.suggest-title-button.empty-live-document.tooltip": "文件不能空白",
  "title-area-content-components.toolbar-above-title.suggest-title-button.label": "建議標題",
  "topics.content.overview-tab-heading": "概觀",
  "topics.document.last-edited-pretext": "已於 {timeAgo}前編輯",
  "topics.documents.heading": "相關文件",
  "topics.feedback.checkbox-set-legend": "選取所有適用的選項：",
  "topics.feedback.dislike-tooltip": "回應不良",
  "topics.feedback.experts-not-relevant-checkbox-label": "專家與主題無關",
  "topics.feedback.flag-description": "感謝您撥空傳送此意見反應。",
  "topics.feedback.flag-title": "謝謝！",
  "topics.feedback.general-checkbox-label": "主題太籠統",
  "topics.feedback.like-tooltip": "回應良好",
  "topics.feedback.projects-not-relevant-checkbox-label": "專案與主題無關",
  "topics.feedback.sense-checkbox-label": "主題名稱或描述不正確",
  "topics.feedback.specific-checkbox-label": "主題過於特定",
  "topics.feedback.subtitle": "此主題是由 Rovo 所生成。請與我們分享您的體驗心得！",
  "topics.feedback.title": "不符合您的預期嗎？",
  "topics.footer.disclaimer-text": "內容取決於您的權限，其品質可能會有所不同",
  "topics.header.ai-tagline": "由 Atlassian Intelligence 提供技術支援",
  "topics.header.content-vary-text": "內容可能會有所不同",
  "topics.header.last-updated-pretext": "上次更新時間：{timeAgo}前",
  "topics.header.rovo-product": "Rovo",
  "topics.header.rovo-text": "由 Rovo 提供",
  "topics.projects.heading": "相關專案",
  "topics.sidebar.heading": "相關主題",
  "topics.users.heading": "相關人員",
  "tree.draggable-item.label": "{title}可拖曳的項目",
  "trial-components.action.menu.downgrade.message.v2": "試用之後，我們會將您降級為 Free 方案。",
  "trial-components.action.menu.label.credit-card": "信用卡圖示",
  "trial-components.action.menu.label.premium": "Premium 圖示",
  "trial-components.action.menu.payment-details": "新增付款詳細資料",
  "trial-components.action.menu.pill": "{count, plural, =0 {剩餘天數} other {剩餘 {count,number} 天}}",
  "trial-components.add.payment.premium.button": "新增付款詳細資料以持續使用 Premium 方案",
  "trial-components.auto-upgrade-awareness.modal.carouselGuestAccess": "訪客存取權",
  "trial-components.auto-upgrade-awareness.modal.carouselPageInsights": "內容深入解析",
  "trial-components.auto-upgrade-awareness.modal.carouselPageRestrictions": "內容限制",
  "trial-components.auto-upgrade-awareness.modal.carouselUnlimitedUserLimit": "不限數量的使用者",
  "trial-components.auto-upgrade-awareness.modal.closeModalCTA": "稍後再說",
  "trial-components.auto-upgrade-awareness.modal.freeHeader10Users": "您已用完免費的使用者額度",
  "trial-components.auto-upgrade-awareness.modal.freeHeader1to2Users": "讓所有人都能使用相同的工具",
  "trial-components.auto-upgrade-awareness.modal.freeHeader3to9Users": "升級以新增您的團隊",
  "trial-components.auto-upgrade-awareness.modal.freeModalCTA": "開始免費試用",
  "trial-components.auto-upgrade-awareness.modal.freeStorageUsageSubHeader": "升級以獲得 250 GB 的儲存空間",
  "trial-components.auto-upgrade-awareness.modal.freeSubHeader10Users": "開始 Standard 方案的 14 天免費試用，以取得不限數量的使用者上限。 此外，還可以存取進階功能。",
  "trial-components.auto-upgrade-awareness.modal.freeSubHeader1to2Users": "開始 Standard 方案的 14 天免費試用，以新增更多使用者，並且與您的團隊和相關人員保持同步。",
  "trial-components.auto-upgrade-awareness.modal.freeSubHeader3to9Users": "開始 Standard 方案的 14 天免費試用，以新增更多使用者，並取得免費的訪客存取權和存取控管。",
  "trial-components.auto-upgrade-awareness.modal.freeUserAvatarHeader1to2Users": "已邀請 {userCount} 位，總共 10 位",
  "trial-components.auto-upgrade-awareness.modal.freeUserAvatarHeader3to10Users": "已邀請 {userCount} 位，總共 10 位",
  "trial-components.auto-upgrade-awareness.modal.freeUserAvatarSubHeader1to2Users": "升級以取得不限數量的使用者上限。",
  "trial-components.auto-upgrade-awareness.modal.freeUserAvatarSubHeader3to10Users": "如果邀請超過 10 位使用者，將開始 Standard 方案的 14 天免費試用",
  "trial-components.auto-upgrade-awareness.modal.standardHeader10Users": "在試用中採取行動",
  "trial-components.auto-upgrade-awareness.modal.standardHeader1to9Users": "在試用中採取行動",
  "trial-components.auto-upgrade-awareness.modal.standardStorageUsageHeader": "已使用 {dataUsageinGB}，總共 250 GB",
  "trial-components.auto-upgrade-awareness.modal.standardStorageUsageSubHeader": "您已超過 Free 方案的上限 {dataUsageOverFreeLimitInGB} GB",
  "trial-components.auto-upgrade-awareness.modal.standardSubHeader10Users": "{daysRemaining, plural, other {新增付款詳細資料，以在試用結束後保留 Standard 方案的功能。您的試用期將在 {daysRemaining} 天後結束。}}",
  "trial-components.auto-upgrade-awareness.modal.standardSubHeader1to9Users": "{daysRemaining, plural, other {新增付款詳細資料，以在試用結束後保留 Standard 方案的功能。您的試用期將在 {daysRemaining} 天後結束。}}",
  "trial-components.auto-upgrade-awareness.modal.standardUserAvatarHeader10orLessUsers": "充分運用使用者無上限的優勢",
  "trial-components.auto-upgrade-awareness.modal.standardUserAvatarHeader11PlusUsers": "您正在發揮使用者無上限的優勢",
  "trial-components.auto-upgrade-awareness.modal.standardUserAvatarSubHeader10orLessUsers": "邀請您的團隊成員和相關人員協作",
  "trial-components.auto-upgrade-awareness.modal.standardUserAvatarSubHeader11PlusUsers": "{userLimitOverFreeLimit, plural, other {您的團隊有 {userLimitOverFreeLimit} 位使用者超過 Free 方案的上限}}",
  "trial-components.banner.add-billing.link.v2": "新增付款詳細資料",
  "trial-components.banner.icons.dismiss": "帶有十字圖示的關閉按鈕",
  "trial-components.banner.learn-more.link": "深入了解",
  "trial-components.banner.trial.ended.link-to-payment-details": "新增付款詳細資料以持續使用 {edition} 方案。",
  "trial-components.banner.warning.deactivation": "{numberOfUsersToDelete, plural, other {您的試用已結束，且您已超過使用者上限。除非您新增帳單資訊進行升級或移除 {numberOfUsersToDelete,number} 位使用者，否則本網站將於 {deactivationDateLong} 停用。}}",
  "trial-components.end.trial.button": "結束試用並變更方案",
  "trial-components.explore.premium.button": "探索 Premium 方案功能",
  "trial-components.flag.add-payment-details": "新增付款詳細資料",
  "trial-components.flag.info.description": "新增付款詳細資料以繼續使用 {edition} 方案，並保留您喜愛的功能。否則，您的網站將降級為 Confluence Free 方案。",
  "trial-components.flag.remove-users.link-text": "移除使用者",
  "trial-components.flag.title.premium": "{trialDaysLeft, plural, other {您的 Premium 試用期將在 {trialDaysLeft,number} 天內結束}}",
  "trial-components.flag.title.standard": "{trialDaysLeft, plural, other {您的 Standard 試用期將在 {trialDaysLeft,number} 天內結束}}",
  "trial-components.flag.warning.description": "新增付款詳細資料以繼續使用 {edition} 方案並保留超過 10 位使用者，或移除使用者並切換至 Confluence Free 方案。<strong>如果不採取行動，您的網站將在 {deactivationDateLong} 停用。</strong>",
  "trial-components.icons.info": "「資訊」圖示",
  "trial-components.premium.charge-message": "當您的試用期在 {trialEndDate} 結束時，會需要支付 Premium 每月費用。",
  "trial-components.premium.feature-highlight-description.toggle": "我們會透過標籤協助您識別 Premium 功能。",
  "trial-components.premium.feature-highlight-title.toggle": "醒目顯示 Premium 功能",
  "trial-components.premium.review-feature-guide.button": "回顧功能指南",
  "trial-components.premium.review-premium-insights.button": "檢閱 Premium 深入解析",
  "trial-components.premium.review-premium-insights.high-usage.description": "有 {featureUsagePercentage,number,percent} 位使用者已試用 Premium 功能",
  "trial-components.premium.review-premium-insights.low-usage.description": "查看有多少人試用過 Premium 功能",
  "trial-components.premium.trial.title": "Premium 方案試用",
  "trial-components.see.billing.button": "查看帳單詳細資料",
  "trial-components.trial.ended.last.day.warning": "今天是保留所有 {edition} 功能的最後一天。",
  "trial-components.trial.ended.remaining.days.warning": "{numberOfDaysLeft, plural, other {我們提供您額外 {numberOfDaysLeft,number} 天可保有所有的 {edition} 功能。}}",
  "trial-components.trial.ended.warning": "您的試用已結束。",
  "trial-components.upgrade-awareness.modal.standardModalCTA": "新增付款詳細資料",
  "trial-components.vvauto-upgrade-awareness.modal.freeStorageUsageHeader": "已使用 {dataUsageinGB}，總共 2GB",
  "unread-comments.unread-count-max-tooltip": "您有 100 多個未讀留言",
  "unread-comments.unread-count-one-tooltip": "您有 1 個未讀留言",
  "unread-comments.unread-count-tooltip": "您有 {unreadCommentCount} 個未讀留言",
  "unsupported-browser-banner.banner-link": "不受支援",
  "unsupported-browser-banner.banner-message": "您的瀏覽器<link>不受支援</link>。請切換或升級以維持最佳效能。",
  "user-and-group-search.permission.error": "我們找不到任何結果，因為您沒有搜尋使用者目錄的權限。",
  "user-and-group-search.placeholder.text.users": "輸入使用者名稱",
  "user-and-group-search.placeholder.text.users.and.email": "新增人員、電子郵件",
  "user-and-group-search.placeholder.text.users.and.groups": "輸入使用者名稱或群組",
  "user-and-group-search.placeholder.text.users.groups.and.email": "按姓名、電子郵件或群組新增人員",
  "user-and-group-search.search.error": "抱歉，我們現在無法載入搜尋結果。",
  "version-history.author.last-edited-by-anonymous-user.label": "上次是匿名編輯",
  "version-history.author.last-edited-by-deactivated-user.label": "上次編輯者：{author} (已停用)",
  "version-history.author.last-edited-by.label": "上次編輯者：{author}",
  "version-history.auto-saved.version.title": "自動儲存的版本",
  "version-history.close.button.icon.label": "關閉按鈕",
  "version-history.close.icon.button.label": "「關閉」圖示",
  "version-history.copy.icon.label": "「複製」圖示",
  "version-history.copy.icon.tooltip": "複製所有內容",
  "version-history.copy.icon.tooltip-copied": "已複製！",
  "version-history.current.version.description": "最近儲存",
  "version-history.current.version.title": "目前版本",
  "version-history.database-title": "資料庫標題",
  "version-history.database.history.availability.info": "可以顯示過去 30 天的資料庫歷程記錄。",
  "version-history.database.info.box.text": "復原資料庫時，權限和分享設定會維持不變。",
  "version-history.error-state.header.title": "無法載入",
  "version-history.error-state.new.retry.or.refresh.text": "我們無法載入歷程記錄。請再試一次，或檢查您的網路連線。",
  "version-history.error-state.retry.button.text": "重試",
  "version-history.error-state.retry.or.refresh.text": "我們無法載入看板歷程記錄。請再試一次，或檢查您的網路連線。",
  "version-history.header-title": "版本歷程記錄",
  "version-history.history.availability.info": "可以顯示過去 30 天的白板歷程記錄。",
  "version-history.icon.label": "時鐘圖示",
  "version-history.info.box.text": "復原看板時，權限和分享設定會維持不變。",
  "version-history.placeholder.database.title": "[已復原] 無標題資料庫 {date}",
  "version-history.placeholder.whiteboard.title": "[已復原] 無標題看板 {date}",
  "version-history.restore-modal.conflicting-title-error-body": "若要復原看板，請建立不重複的標題，或嘗試將其新增至其他空間。",
  "version-history.restore-modal.conflicting-title-error-title": "此空間中的標題重複",
  "version-history.restore-modal.generic-error-body": "嘗試重新整理頁面，或檢查您的網路連線。",
  "version-history.restore-modal.generic-error-title": "我們無法完成要求",
  "version-history.restore-modal.new-conflicting-title-error-body": "若要繼續復原，請建立不重複的標題，或嘗試將其新增至其他空間。",
  "version-history.restore-modal.new-space-permission-error-body": "若要復原此內容，您需要具有在此空間中<b>建立內容</b>的權限。",
  "version-history.restore-modal.space-permission-error-body": "若要復原此看板，您需要在此空間中<b>建立內容</b>的權限。",
  "version-history.restore-modal.space-permission-error-title": "您沒有空間存取權",
  "version-history.restore.button": "復原",
  "version-history.restore.content.title": "復原",
  "version-history.restore.database.button.text": "復原為新資料庫",
  "version-history.restore.database.label": "復原為新資料庫",
  "version-history.restore.whiteboard.button.text": "復原為新的白板",
  "version-history.restore.whiteboard.label": "復原為新的白板",
  "version-history.save-work-without-creating.text": "如果要儲存工作但不建立新工作，您可以嘗試將白板中的內容複製到可編輯的白板中。",
  "version-history.space-selector.label": "選取空間",
  "version-history.title": "歷程記錄",
  "version-history.title.length.error": "{maxLength, plural, other {標題不能超過 {maxLength} 個字元數}}",
  "version-history.whiteboard-title": "白板標題",
  "view-changes-dialog.close.dialog": "關閉",
  "view-changes-dialog.editor.quit-dialog.title.diff": "未發佈的變更",
  "watch-dialog.blog": "追蹤部落格貼文",
  "watch-dialog.blogs": "追蹤此空間中的新部落格貼文",
  "watch-dialog.choose.watch.type.label": "選擇追蹤類型",
  "watch-dialog.description.not.watching.database.description": "開始追蹤以針對資料庫留言中的提及和回覆，接收電子郵件更新。",
  "watch-dialog.description.not.watching.whiteboard.description": "開始追蹤以針對白板留言中的提及和回覆，接收電子郵件更新。",
  "watch-dialog.description.watching.database.description": "針對資料庫留言中的提及和回覆，接收電子郵件更新。",
  "watch-dialog.description.watching.whiteboard.description": "針對白板留言中的提及和回覆，接收電子郵件更新。",
  "watch-dialog.disabled.blog.tooltip": "因為您是此空間的追蹤者，所以會收到此部落格貼文的更新",
  "watch-dialog.disabled.database.tooltip": "因為您是此空間的追蹤者，所以會收到此資料庫的更新",
  "watch-dialog.disabledblogs.tooltip": "您是此空間的追蹤者，因此會訂閱所有部落格貼文",
  "watch-dialog.disableddatabase.ancestor.watching.children.tooltip": "此資料庫從其父系之一繼承了「已追蹤」狀態",
  "watch-dialog.disableddatabase.watching.children.tooltip": "若要只追蹤此資料庫，請先停止追蹤其子系項目",
  "watch-dialog.disabledpage.ancestor.watching.children.tooltip": "此內容從其父系之一繼承了「已追蹤」狀態",
  "watch-dialog.disabledpage.tooltip": "因為您是此空間的追蹤者，所以會收到關於此內容的更新",
  "watch-dialog.disabledpage.watching.children.tooltip": "若要只追蹤此內容，請先停止追蹤其子系項目",
  "watch-dialog.disabledwhiteboard.ancestor.watching.children.tooltip": "此白板從其父系之一繼承了「已追蹤」狀態",
  "watch-dialog.disabledwhiteboard.tooltip": "因為您是此空間的追蹤者，所以會收到此白板的更新",
  "watch-dialog.disabledwhiteboard.watching.children.tooltip": "若要只追蹤此白板，請先停止追蹤其子系項目",
  "watch-dialog.follow.blog": "追蹤這篇部落格貼文",
  "watch-dialog.follow.blogs": "追蹤此空間中的新部落格貼文",
  "watch-dialog.follow.disabledblogs.tooltip": "您是此空間的追蹤者，因此已訂閱所有部落格貼文",
  "watch-dialog.follow.disabledpage.tooltip": "因為您是此空間的追蹤者，所以會收到關於此內容的更新",
  "watch-dialog.follow.page": "追蹤此內容",
  "watch-dialog.follow.space": "追蹤此空間中的所有內容",
  "watch-dialog.manage": "管理追蹤者",
  "watch-dialog.notification.start.watching.blog": "您已開始追蹤此部落格。",
  "watch-dialog.notification.start.watching.database": "您已開始追蹤此資料庫。",
  "watch-dialog.notification.start.watching.page": "您已開始追蹤此內容。",
  "watch-dialog.notification.start.watching.whiteboard": "您已開始追蹤此白板。",
  "watch-dialog.notification.stop.watching.blog": "您已停止追蹤此部落格。",
  "watch-dialog.notification.stop.watching.database": "您已停止追蹤此資料庫。",
  "watch-dialog.notification.stop.watching.page": "您已停止追蹤此內容。",
  "watch-dialog.notification.stop.watching.whiteboard": "您已停止追蹤此白板。",
  "watch-dialog.overflow-menu.ancestor-watch-status": "您已追蹤此內容父系底下的所有項目。您可以隨時調整其設定。",
  "watch-dialog.overflow-menu.manage-watchers": "管理追蹤者",
  "watch-dialog.overflow-menu.not-watching-icon-label": "未追蹤內容",
  "watch-dialog.overflow-menu.stopped-watching-blogs-flag-description": "您不會再收到與此空間中的新部落格貼文相關的電子郵件更新。",
  "watch-dialog.overflow-menu.stopped-watching-blogs-flag-title": "您已停止追蹤新的部落格貼文",
  "watch-dialog.overflow-menu.stopped-watching-children-flag-description": "您不會再就此內容子系項目的變更，收到相關的電子郵件更新。",
  "watch-dialog.overflow-menu.stopped-watching-children-flag-title": "您已停止追蹤子系項目",
  "watch-dialog.overflow-menu.stopped-watching-content-flag-description": "您不會再收到與其內容變更有關的電子郵件更新。",
  "watch-dialog.overflow-menu.stopped-watching-content-flag-title": "您已停止追蹤此內容。",
  "watch-dialog.overflow-menu.stopped-watching-database-flag-description": "您不會再收到有關提及與留言回覆的電子郵件更新。",
  "watch-dialog.overflow-menu.stopped-watching-database-flag-title": "您已停止追蹤此資料庫",
  "watch-dialog.overflow-menu.stopped-watching-space-flag-description": "您不會再就此空間中的內容變更，收到相關的電子郵件更新。",
  "watch-dialog.overflow-menu.stopped-watching-space-flag-title": "您已停止追蹤此空間中的內容",
  "watch-dialog.overflow-menu.stopped-watching-whiteboard-flag-description": "您不會再收到有關提及與留言回覆的電子郵件更新。",
  "watch-dialog.overflow-menu.stopped-watching-whiteboard-flag-title": "您已停止追蹤此白板",
  "watch-dialog.overflow-menu.watch-all-content": "追蹤此空間中的所有內容",
  "watch-dialog.overflow-menu.watch-child-items": "追蹤子系項目",
  "watch-dialog.overflow-menu.watch-new-blog-posts": "追蹤新的部落格貼文",
  "watch-dialog.overflow-menu.watch-settings": "追蹤設定",
  "watch-dialog.overflow-menu.watch-this-content": "追蹤此內容",
  "watch-dialog.overflow-menu.watching-blogs-flag-description": "您將收到與此空間中的新部落格貼文相關的電子郵件更新。",
  "watch-dialog.overflow-menu.watching-blogs-flag-title": "您正在追蹤新的部落格貼文",
  "watch-dialog.overflow-menu.watching-children-flag-description": "您會就此內容子系項目的變更，收到相關的電子郵件更新。",
  "watch-dialog.overflow-menu.watching-children-flag-title": "您正在追蹤子系項目",
  "watch-dialog.overflow-menu.watching-content-flag-description": "您將收到與其內容變更有關的電子郵件更新。",
  "watch-dialog.overflow-menu.watching-content-flag-title": "您正在追蹤此內容",
  "watch-dialog.overflow-menu.watching-database-flag-description": "您將收到有關提及與留言回覆的電子郵件更新。",
  "watch-dialog.overflow-menu.watching-database-flag-title": "您正在追蹤此資料庫",
  "watch-dialog.overflow-menu.watching-icon-label": "追蹤內容",
  "watch-dialog.overflow-menu.watching-space-flag-description": "您會就此空間中的內容變更，收到相關的電子郵件更新。",
  "watch-dialog.overflow-menu.watching-space-flag-title": "您正在追蹤此空間中的內容",
  "watch-dialog.overflow-menu.watching-whiteboard-flag-description": "您將收到有關提及與留言回覆的電子郵件更新。",
  "watch-dialog.overflow-menu.watching-whiteboard-flag-title": "您正在追蹤此白板",
  "watch-dialog.page": "追蹤此內容",
  "watch-dialog.popup.label": "「追蹤內容」對話方塊",
  "watch-dialog.space": "追蹤此空間中的所有內容",
  "watch-dialog.start.button.tooltip": "追蹤",
  "watch-dialog.stop.button.tooltip": "停止追蹤",
  "watch-dialog.title.follow": "追蹤以收到任何更新的通知",
  "watch-dialog.title.follow.description": "每當有人更新您追蹤的內容時，Confluence 就會向您傳送通知電子郵件。",
  "watch-dialog.title.not.watching.database.title": "您並未追蹤此資料庫",
  "watch-dialog.title.not.watching.whiteboard.title": "您並未追蹤此白板",
  "watch-dialog.title.nothing.watching.page.description": "開始追蹤以就此內容的變更，收到相關的電子郵件更新。",
  "watch-dialog.title.watching.blog": "您正在追蹤此部落格貼文",
  "watch-dialog.title.watching.blog.and.blogs": "您正在追蹤此部落格貼文",
  "watch-dialog.title.watching.blog.and.blogs.description": "接收電子郵件更新，以了解對此部落格貼文所做的變更，以及此空間中所有新的部落格貼文。",
  "watch-dialog.title.watching.blog.description": "當此部落格貼有變更時接收電子郵件更新。",
  "watch-dialog.title.watching.blogs": "您正在追蹤新的部落格貼文",
  "watch-dialog.title.watching.blogs.description": "在此空間中接收新部落格貼文的電子郵件更新。",
  "watch-dialog.title.watching.children.database.description": "您將會在此資料庫及其下方任何巢狀項目有所變更時收到電子郵件更新。",
  "watch-dialog.title.watching.children.database.title": "您正在追蹤此資料庫和其子系項目",
  "watch-dialog.title.watching.children.page.description": "您將會在此內容及其下方任何巢狀項目發生變更時，收到相關的電子郵件更新。",
  "watch-dialog.title.watching.children.page.title": "您正在追蹤此內容及其下方的巢狀項目",
  "watch-dialog.title.watching.children.whiteboard.description": "您將會在此白板及其下方任何巢狀項目發生變更時收到電子郵件更新。",
  "watch-dialog.title.watching.children.whiteboard.title": "您正在追蹤此白板和其子系項目",
  "watch-dialog.title.watching.database.title": "您正在追蹤此資料庫",
  "watch-dialog.title.watching.nothing.blog": "您並未追蹤此部落格",
  "watch-dialog.title.watching.nothing.blogs.description": "開始追蹤以接收與此部落格變更相關的電子郵件更新。",
  "watch-dialog.title.watching.nothing.page": "您未追蹤此內容",
  "watch-dialog.title.watching.page": "您正在追蹤此內容",
  "watch-dialog.title.watching.page.description": "您將會就此內容的變更，收到相關的電子郵件更新。",
  "watch-dialog.title.watching.space": "您正在追蹤此空間",
  "watch-dialog.title.watching.space.description": "接收有關此空間中所有內容的電子郵件更新。",
  "watch-dialog.title.watching.whiteboard.title": "您正在追蹤此白板",
  "watch-dialog.watch-button.start.watching.label": "開始追蹤",
  "watch-dialog.watch-button.stop.watching.label": "停止追蹤",
  "watch-dialog.watch.database": "追蹤資料庫",
  "watch-dialog.watch.database.children": "追蹤此資料庫和所有子系項目",
  "watch-dialog.watch.nudge.content": "當您正在追蹤的內容更新時，您將收到通知。",
  "watch-dialog.watch.nudge.dismiss.action": "關閉",
  "watch-dialog.watch.nudge.title": "追蹤更新",
  "watch-dialog.watch.nudge.watch.action": "追蹤",
  "watch-dialog.watch.page.children": "追蹤此內容和所有子系項目",
  "watch-dialog.watch.whiteboard": "追蹤白板",
  "watch-dialog.watch.whiteboard.children": "追蹤此白板和所有子系項目",
  "whiteboard-common.deactivated-whiteboard-flag.private-whiteboard-title": "已將較舊的白板設為唯讀模式",
  "whiteboard-common.mobile-web-view-description": "在 Web 的 Confluence Cloud 上檢視。",
  "whiteboard-common.mobile-web-view-details": "當靈感來臨時，使用白板呈現腦力激盪和協作。",
  "whiteboard-common.mobile-web-view-title": "行動裝置上還無法使用白板",
  "whiteboard-common.navigation-lockout.default-lockout-message": "尚未在白板上完成動作，如果離開此分頁，將會停止動作",
  "whiteboard-common.onboarding-modal.closeButtonLabel": "關閉強制回應",
  "whiteboard-common.onboarding-modal.nextButtonLabel": "下一頁",
  "whiteboard-common.onboarding-modal.prevButtonLabel": "上一頁",
  "whiteboard-common.unset-paywall-dialog.continue-to-view-only": "繼續使用唯讀",
  "whiteboard-common.unset-paywall-dialog.flag.continue-to-view-only.primary-text": "為了使用此白板，較舊的白板已設為唯讀模式。",
  "whiteboard-common.unset-paywall-dialog.flag.continue-to-view-only.title": "我們已將「{title}」設定為唯讀",
  "whiteboard-common.unset-paywall-dialog.flag.error.primary-text": "發生錯誤，請再試一次。",
  "whiteboard-common.unset-paywall-dialog.flag.error.title": "我們無法將此白板設為作用中",
  "whiteboard-common.unset-paywall-dialog.flag.got-it.title": "確定",
  "whiteboard-common.unset-paywall-dialog.flag.view-deactivated-board.title": "檢視 {title}",
  "whiteboard-common.unset-paywall-dialog.learn-more-link": "了解方案",
  "whiteboard-common.unset-paywall-dialog.make-this-whiteboard-active": "將此白板設為作用中",
  "whiteboard-common.unset-paywall-dialog.private-whiteboard-to-be-disabled": "較舊的白板",
  "whiteboard-common.unset-paywall-dialog.view-only-whiteboard.paywall-title": "此白板為唯讀",
  "whiteboard-common.unset-paywall-dialog.whiteboard-active-paywall-view-primary-text": "設有三個可編輯白板的上限。如果您要編輯此白板，{title} 將變成唯讀。{makeActiveLink}",
  "whiteboard-common.unset-paywall-dialog.whiteboard-active-paywall-view-secondary-text": "若要使用無限數量的白板，請升級至 Premium。",
  "whiteboard-common.use-whiteboard-ai-agent-service.ai-panel-header-name": "白板 Atlassian Intelligence 面板",
  "whiteboard-common.use-whiteboard-ai-agent-service.ai-panel.generate-card-button": "生成卡片",
  "whiteboard-common.use-whiteboard-ai-agent-service.ai-panel.generate-diagram-button": "生成圖表",
  "whiteboard-common.use-whiteboard-ai-agent-service.ai-panel.summarize-button": "摘要白板",
  "whiteboard-extension.create-brainstorming.description": "使用腦力寫作範本來建立白板",
  "whiteboard-extension.create-brainstorming.title": "建立腦力激盪",
  "whiteboard-extension.create-diagram.description": "使用流程圖範本建立白板",
  "whiteboard-extension.create-diagram.title": "建立圖表",
  "whiteboard-extension.create-flowchart.description": "使用流程圖範本建立白板",
  "whiteboard-extension.create-flowchart.title": "建立流程圖",
  "whiteboard-extension.create-retrospective.description": "使用簡單的回顧範本建立白板",
  "whiteboard-extension.create-retrospective.title": "建立回顧",
  "whiteboard-extension.create-roadmap.description": "使用產品藍圖範本建立白板",
  "whiteboard-extension.create-roadmap.title": "建立藍圖",
  "whiteboard-extension.create-whiteboard.description": "建立空白的白板",
  "whiteboard-extension.create-whiteboard.icon-alt-text": "建立白板圖示",
  "whiteboard-extension.create-whiteboard.title": "建立白板",
  "whiteboard-extension.description": "建立空的白板",
  "whiteboard-extension.error-flag.description": "請重新整理或等待幾分鐘，然後再試一次。如果這種情況持續發生，請連絡支援人員。",
  "whiteboard-extension.error-flag.title": "我們目前無法建立",
  "whiteboard-extension.error.invalid-parent-error-description": "此頁面已刪除或封存。您可以在不同的頁面上建立白板。",
  "whiteboard-extension.error.invalid-parent-error-description.livedocs": "此項目已被刪除或封存。您可以在不同的頁面上建立白板。",
  "whiteboard-extension.error.invalid-parent-error-title": "我們無法建立白板",
  "whiteboard-extension.error.parent-page-moved-error-description": "請重新整理以在新位置建立內容。",
  "whiteboard-extension.error.parent-page-moved-error-title": "父系已移動",
  "whiteboard-extension.error.permission-removed-error-description": "您沒有在此建立的權限，或該空間已在最近遭到刪除。",
  "whiteboard-extension.error.permission-removed-error-title": "我們無法建立此內容",
  "whiteboard-extension.success-flag.action": "前往白板",
  "whiteboard-extension.success-flag.description": "來源白板已在樹狀結構中建立。請前往白板以移動其位置或變更其權限。",
  "whiteboard-extension.success-flag.title": "白板已新增至內容樹狀結構",
  "whiteboard-extension.title": "白板擴充功能",
  "whiteboards-onboarding.ga-modal.body1": "開始建立白板來規劃和呈現您的工作。",
  "whiteboards-onboarding.ga-modal.body2": "讓我們看看一些可用的工具，以便您開始和團隊一起合作！🚀",
  "whiteboards-onboarding.ga-modal.closeButton": "關閉強制回應",
  "whiteboards-onboarding.ga-modal.gifAltText": "使用便利貼在白板上協作的使用者",
  "whiteboards-onboarding.ga-modal.header": "白板可供所有人使用",
  "whiteboards-onboarding.ga-modal.learnMore": "深入了解",
  "whiteboards-onboarding.ga-modal.tryNow": "立即試用",
  "whiteboards-onboarding.version-history-modal.body": "檢視和復原舊版的白板。查看更新時間軸以了解最新變更。",
  "whiteboards-onboarding.version-history-modal.closeButton": "關閉強制回應",
  "whiteboards-onboarding.version-history-modal.dismiss": "關閉",
  "whiteboards-onboarding.version-history-modal.header": "版本歷史記錄在這裡",
  "whiteboards-onboarding.version-history-modal.imageAltText": "顯示版本歷史記錄面板的圖片",
  "whiteboards-onboarding.version-history-modal.ok": "確定"
}